// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  type ClientMeta,
  formDataBodySerializer,
  type Options as Options2,
  type RequestResult,
  type TDataShape,
} from './client';
import { client } from './client.gen';
import type {
  AbandonReplacementClaimBillingBillingCycleBillingCycleIdReplacementAbandonPostData,
  AbandonReplacementClaimBillingBillingCycleBillingCycleIdReplacementAbandonPostErrors,
  AbandonReplacementClaimBillingBillingCycleBillingCycleIdReplacementAbandonPostResponses,
  AcceptImportedGoalGoalsVisitVisitIdPatientGoalIdAcceptImportPostData,
  AcceptImportedGoalGoalsVisitVisitIdPatientGoalIdAcceptImportPostErrors,
  AcceptImportedGoalGoalsVisitVisitIdPatientGoalIdAcceptImportPostResponses,
  AcknowledgeAllPatientImportReviewItemsPatientsPatientIdChartImportsReviewItemsAcknowledgeAllPostData,
  AcknowledgeAllPatientImportReviewItemsPatientsPatientIdChartImportsReviewItemsAcknowledgeAllPostErrors,
  AcknowledgeAllPatientImportReviewItemsPatientsPatientIdChartImportsReviewItemsAcknowledgeAllPostResponses,
  AcknowledgePatientImportReviewItemPatientsPatientIdChartImportsReviewItemsItemIdAcknowledgePostData,
  AcknowledgePatientImportReviewItemPatientsPatientIdChartImportsReviewItemsItemIdAcknowledgePostErrors,
  AcknowledgePatientImportReviewItemPatientsPatientIdChartImportsReviewItemsItemIdAcknowledgePostResponses,
  AddGoalToVisitByExternalIdInternalGoalsVisitVisitIdPostData,
  AddGoalToVisitByExternalIdInternalGoalsVisitVisitIdPostErrors,
  AddGoalToVisitByExternalIdInternalGoalsVisitVisitIdPostResponses,
  AddGoalToVisitGoalsVisitVisitIdPostData,
  AddGoalToVisitGoalsVisitVisitIdPostErrors,
  AddGoalToVisitGoalsVisitVisitIdPostResponses,
  AddInterventionToVisitByExternalIdInternalGoalsVisitVisitIdInterventionPostData,
  AddInterventionToVisitByExternalIdInternalGoalsVisitVisitIdInterventionPostErrors,
  AddInterventionToVisitByExternalIdInternalGoalsVisitVisitIdInterventionPostResponses,
  AddInterventionToVisitGoalsVisitVisitIdInterventionPostData,
  AddInterventionToVisitGoalsVisitVisitIdInterventionPostErrors,
  AddInterventionToVisitGoalsVisitVisitIdInterventionPostResponses,
  AddKinnserGoalToEpisodeGoalsEpisodeEpisodeIdPostData,
  AddKinnserGoalToEpisodeGoalsEpisodeEpisodeIdPostErrors,
  AddKinnserGoalToEpisodeGoalsEpisodeEpisodeIdPostResponses,
  AddPermissionToRoleRbacRolePermissionsRoleIdPermissionsPostData,
  AddPermissionToRoleRbacRolePermissionsRoleIdPermissionsPostErrors,
  AddPermissionToRoleRbacRolePermissionsRoleIdPermissionsPostResponses,
  AddTelnyxNumberInternalToolsTelnyxFaxLinesAgencyIdNumbersPostData,
  AddTelnyxNumberInternalToolsTelnyxFaxLinesAgencyIdNumbersPostErrors,
  AddTelnyxNumberInternalToolsTelnyxFaxLinesAgencyIdNumbersPostResponses,
  ApproveTaskEndpointTasksTaskIdApprovePostData,
  ApproveTaskEndpointTasksTaskIdApprovePostErrors,
  ApproveTaskEndpointTasksTaskIdApprovePostResponses,
  ApproveTaskForSignatureEndpointTasksTaskIdApproveForSignaturePostData,
  ApproveTaskForSignatureEndpointTasksTaskIdApproveForSignaturePostErrors,
  ApproveTaskForSignatureEndpointTasksTaskIdApproveForSignaturePostResponses,
  ArchiveChannelChatChannelsChannelIdArchivePostData,
  ArchiveChannelChatChannelsChannelIdArchivePostErrors,
  ArchiveChannelChatChannelsChannelIdArchivePostResponses,
  ArchiveFaxItemFaxRoutingKindItemIdArchivePostData,
  ArchiveFaxItemFaxRoutingKindItemIdArchivePostErrors,
  ArchiveFaxItemFaxRoutingKindItemIdArchivePostResponses,
  ArchivePatientTagDefinitionPatientTagsDefinitionsDefinitionIdArchivePostData,
  ArchivePatientTagDefinitionPatientTagsDefinitionsDefinitionIdArchivePostErrors,
  ArchivePatientTagDefinitionPatientTagsDefinitionsDefinitionIdArchivePostResponses,
  ArchiveTaskTypeAliasTaskTypesAliasesAliasIdArchivePostData,
  ArchiveTaskTypeAliasTaskTypesAliasesAliasIdArchivePostErrors,
  ArchiveTaskTypeAliasTaskTypesAliasesAliasIdArchivePostResponses,
  AssembleFaxDocumentFaxDocumentsPostData,
  AssembleFaxDocumentFaxDocumentsPostErrors,
  AssembleFaxDocumentFaxDocumentsPostResponses,
  AssignRogerdocAccountLinkRogerdocAccountLinksAccountIdPutData,
  AssignRogerdocAccountLinkRogerdocAccountLinksAccountIdPutErrors,
  AssignRogerdocAccountLinkRogerdocAccountLinksAccountIdPutResponses,
  AssignTelnyxNumbersInternalToolsTelnyxFaxLinesAgencyIdNumbersAssignPostData,
  AssignTelnyxNumbersInternalToolsTelnyxFaxLinesAgencyIdNumbersAssignPostErrors,
  AssignTelnyxNumbersInternalToolsTelnyxFaxLinesAgencyIdNumbersAssignPostResponses,
  AssignUnassignedFaxInternalToolsUnassignedFaxesFaxIdPatchData,
  AssignUnassignedFaxInternalToolsUnassignedFaxesFaxIdPatchErrors,
  AssignUnassignedFaxInternalToolsUnassignedFaxesFaxIdPatchResponses,
  AssignUserToAllClinicsUsersUserIdAssignAllClinicsPostData,
  AssignUserToAllClinicsUsersUserIdAssignAllClinicsPostErrors,
  AssignUserToAllClinicsUsersUserIdAssignAllClinicsPostResponses,
  AuthCallbackAuthCallbackGetData,
  AuthCallbackAuthCallbackGetErrors,
  AuthCallbackAuthCallbackGetResponses,
  AutoAddAdmissionAndEpisodeKinnserPatientAddAdmissionAndEpisodeAutoClinicIdPostData,
  AutoAddAdmissionAndEpisodeKinnserPatientAddAdmissionAndEpisodeAutoClinicIdPostErrors,
  AutoAddAdmissionAndEpisodeKinnserPatientAddAdmissionAndEpisodeAutoClinicIdPostResponses,
  AutoAddEpisodeKinnserPatientAddEpisodeAutoClinicIdPostData,
  AutoAddEpisodeKinnserPatientAddEpisodeAutoClinicIdPostErrors,
  AutoAddEpisodeKinnserPatientAddEpisodeAutoClinicIdPostResponses,
  AutoAddInKinnserIntakeIntakeIdAutoAddInKinnserPostData,
  AutoAddInKinnserIntakeIntakeIdAutoAddInKinnserPostErrors,
  AutoAddInKinnserIntakeIntakeIdAutoAddInKinnserPostResponses,
  BackfillKinnserMappedLinesInternalKinnserImportMappedLinesBackfillPostData,
  BackfillKinnserMappedLinesInternalKinnserImportMappedLinesBackfillPostErrors,
  BackfillKinnserMappedLinesInternalKinnserImportMappedLinesBackfillPostResponses,
  BackfillKinnserPrintRetriesInternalKinnserImportPrintRetriesBackfillPostData,
  BackfillKinnserPrintRetriesInternalKinnserImportPrintRetriesBackfillPostErrors,
  BackfillKinnserPrintRetriesInternalKinnserImportPrintRetriesBackfillPostResponses,
  BatchPrintEpisodeTasksEpisodesEpisodeIdTasksBatchPrintPostData,
  BatchPrintEpisodeTasksEpisodesEpisodeIdTasksBatchPrintPostErrors,
  BatchPrintEpisodeTasksEpisodesEpisodeIdTasksBatchPrintPostResponses,
  BillingGetArRollForwardData,
  BillingGetArRollForwardLinesData,
  BillingGetArRollForwardLinesErrors,
  BillingGetArRollForwardLinesResponses,
  BillingGetArRollForwardResponses,
  BillingListWriteOffsData,
  BillingListWriteOffsErrors,
  BillingListWriteOffsResponses,
  BillingPostWriteOffData,
  BillingPostWriteOffErrors,
  BillingPostWriteOffResponses,
  BillingReverseWriteOffData,
  BillingReverseWriteOffErrors,
  BillingReverseWriteOffResponses,
  BreakSignaturesEndpointTasksTaskIdEditPostData,
  BreakSignaturesEndpointTasksTaskIdEditPostErrors,
  BreakSignaturesEndpointTasksTaskIdEditPostResponses,
  BulkAppendTaskNotesTasksNotesBulkPostData,
  BulkAppendTaskNotesTasksNotesBulkPostErrors,
  BulkAppendTaskNotesTasksNotesBulkPostResponses,
  BulkAssignAgencyRolesToUserRbacRoleAssignmentsUserUserIdAgencyRolesPutData,
  BulkAssignAgencyRolesToUserRbacRoleAssignmentsUserUserIdAgencyRolesPutErrors,
  BulkAssignAgencyRolesToUserRbacRoleAssignmentsUserUserIdAgencyRolesPutResponses,
  BulkAssignClinicRolesToUserRbacRoleAssignmentsUserUserIdClinicRolesPutData,
  BulkAssignClinicRolesToUserRbacRoleAssignmentsUserUserIdClinicRolesPutErrors,
  BulkAssignClinicRolesToUserRbacRoleAssignmentsUserUserIdClinicRolesPutResponses,
  BulkCreatePatientVisitsPatientsPatientIdVisitsBulkPostData,
  BulkCreatePatientVisitsPatientsPatientIdVisitsBulkPostErrors,
  BulkCreatePatientVisitsPatientsPatientIdVisitsBulkPostResponses,
  BulkSendNoasBulkSendPostData,
  BulkSendNoasBulkSendPostErrors,
  BulkSendNoasBulkSendPostResponses,
  BulkUpsertAssignmentsRbacRoleAssignmentsBulkPutData,
  BulkUpsertAssignmentsRbacRoleAssignmentsBulkPutErrors,
  BulkUpsertAssignmentsRbacRoleAssignmentsBulkPutResponses,
  BulkUpsertToRogerdocsGoalsDashboardBulkUpsertToRogerdocsPostData,
  BulkUpsertToRogerdocsGoalsDashboardBulkUpsertToRogerdocsPostErrors,
  BulkUpsertToRogerdocsGoalsDashboardBulkUpsertToRogerdocsPostResponses,
  BypassTaskSignatureEndpointTasksTaskIdBypassSignaturePostData,
  BypassTaskSignatureEndpointTasksTaskIdBypassSignaturePostErrors,
  BypassTaskSignatureEndpointTasksTaskIdBypassSignaturePostResponses,
  CancelKinnserImportQueueItemInternalKinnserImportQueueItemIdDeleteData,
  CancelKinnserImportQueueItemInternalKinnserImportQueueItemIdDeleteErrors,
  CancelKinnserImportQueueItemInternalKinnserImportQueueItemIdDeleteResponses,
  CancelPatientExternalEmrImportRoutePatientsPatientIdExternalEmrImportDeleteData,
  CancelPatientExternalEmrImportRoutePatientsPatientIdExternalEmrImportDeleteErrors,
  CancelPatientExternalEmrImportRoutePatientsPatientIdExternalEmrImportDeleteResponses,
  CaptureVisitEvvClockInVisitsVisitIdEvvClockInPostData,
  CaptureVisitEvvClockInVisitsVisitIdEvvClockInPostErrors,
  CaptureVisitEvvClockInVisitsVisitIdEvvClockInPostResponses,
  CaptureVisitEvvClockOutVisitsVisitIdEvvClockOutPostData,
  CaptureVisitEvvClockOutVisitsVisitIdEvvClockOutPostErrors,
  CaptureVisitEvvClockOutVisitsVisitIdEvvClockOutPostResponses,
  CaptureVisitEvvSignatureVisitsVisitIdEvvSignaturePostData,
  CaptureVisitEvvSignatureVisitsVisitIdEvvSignaturePostErrors,
  CaptureVisitEvvSignatureVisitsVisitIdEvvSignaturePostResponses,
  CarryForwardImportedNoKnownAllergiesData,
  CarryForwardImportedNoKnownAllergiesErrors,
  CarryForwardImportedNoKnownAllergiesResponses,
  ChangeEsignatureCredentialSigningCredentialChangePostData,
  ChangeEsignatureCredentialSigningCredentialChangePostErrors,
  ChangeEsignatureCredentialSigningCredentialChangePostResponses,
  ChangeVisitTypeVisitsVisitIdTypePatchData,
  ChangeVisitTypeVisitsVisitIdTypePatchErrors,
  ChangeVisitTypeVisitsVisitIdTypePatchResponses,
  CheckClaimAcknowledgmentWaystarClaimsClaimIdAckGetData,
  CheckClaimAcknowledgmentWaystarClaimsClaimIdAckGetErrors,
  CheckClaimAcknowledgmentWaystarClaimsClaimIdAckGetResponses,
  CheckClinicOasisExportErrorsAgencyClinicsOasisExportErrorsPostData,
  CheckClinicOasisExportErrorsAgencyClinicsOasisExportErrorsPostErrors,
  CheckClinicOasisExportErrorsAgencyClinicsOasisExportErrorsPostResponses,
  CheckCoordinationOfBenefitsStediCoordinationOfBenefitsPostData,
  CheckCoordinationOfBenefitsStediCoordinationOfBenefitsPostErrors,
  CheckCoordinationOfBenefitsStediCoordinationOfBenefitsPostResponses,
  CheckEligibilityDirectWaystarEligibilityDirectPostData,
  CheckEligibilityDirectWaystarEligibilityDirectPostErrors,
  CheckEligibilityDirectWaystarEligibilityDirectPostResponses,
  CheckEligibilityStediEligibilityPostData,
  CheckEligibilityStediEligibilityPostErrors,
  CheckEligibilityStediEligibilityPostResponses,
  CheckEligibilityWithX12270X12270EligibilityCheckPostData,
  CheckEligibilityWithX12270X12270EligibilityCheckPostErrors,
  CheckEligibilityWithX12270X12270EligibilityCheckPostResponses,
  CheckEligibilityX12WaystarEligibilityPostData,
  CheckEligibilityX12WaystarEligibilityPostErrors,
  CheckEligibilityX12WaystarEligibilityPostResponses,
  CheckinOrderOrdersOrderIdCheckinPostData,
  CheckinOrderOrdersOrderIdCheckinPostErrors,
  CheckinOrderOrdersOrderIdCheckinPostResponses,
  CheckNoaPhysicianSyncEpisodesEpisodeIdSyncNoaPhysicianCheckGetData,
  CheckNoaPhysicianSyncEpisodesEpisodeIdSyncNoaPhysicianCheckGetErrors,
  CheckNoaPhysicianSyncEpisodesEpisodeIdSyncNoaPhysicianCheckGetResponses,
  CheckOasisMrnSyncPatientsPatientIdOasisMrnSyncCheckGetData,
  CheckOasisMrnSyncPatientsPatientIdOasisMrnSyncCheckGetErrors,
  CheckOasisMrnSyncPatientsPatientIdOasisMrnSyncCheckGetResponses,
  CheckoutOrderOrdersOrderIdCheckoutPostData,
  CheckoutOrderOrdersOrderIdCheckoutPostErrors,
  CheckoutOrderOrdersOrderIdCheckoutPostResponses,
  CheckPatientOasisExportErrorsPatientsPatientIdOasisExportErrorsPostData,
  CheckPatientOasisExportErrorsPatientsPatientIdOasisExportErrorsPostErrors,
  CheckPatientOasisExportErrorsPatientsPatientIdOasisExportErrorsPostResponses,
  CheckPlannedVisitsData,
  CheckPlannedVisitsErrors,
  CheckPlannedVisitsResponses,
  CheckPortabilityFaxNumberPortsPortabilityCheckPostData,
  CheckPortabilityFaxNumberPortsPortabilityCheckPostErrors,
  CheckPortabilityFaxNumberPortsPortabilityCheckPostResponses,
  CheckPriorAuthorizationWaystarPriorAuthPostData,
  CheckPriorAuthorizationWaystarPriorAuthPostErrors,
  CheckPriorAuthorizationWaystarPriorAuthPostResponses,
  CheckRogerdocHealthRogerdocHealthGetData,
  CheckRogerdocHealthRogerdocHealthGetResponses,
  ClearRogerdocAccountLinkRogerdocAccountLinksAccountIdDeleteData,
  ClearRogerdocAccountLinkRogerdocAccountLinksAccountIdDeleteErrors,
  ClearRogerdocAccountLinkRogerdocAccountLinksAccountIdDeleteResponses,
  ClearTestDataDevTestDataClearDeleteData,
  ClearTestDataDevTestDataClearDeleteErrors,
  ClearTestDataDevTestDataClearDeleteResponses,
  ClosePatientSyncReviewPatientsPatientIdChartImportsSyncReviewClosePostData,
  ClosePatientSyncReviewPatientsPatientIdChartImportsSyncReviewClosePostErrors,
  ClosePatientSyncReviewPatientsPatientIdChartImportsSyncReviewClosePostResponses,
  CompleteAgencyEnrollmentTaskClinicsEnrollmentsRecordIdTasksTaskIdCompletePostData,
  CompleteAgencyEnrollmentTaskClinicsEnrollmentsRecordIdTasksTaskIdCompletePostErrors,
  CompleteAgencyEnrollmentTaskClinicsEnrollmentsRecordIdTasksTaskIdCompletePostResponses,
  CompleteEpisodeData,
  CompleteEpisodeErrors,
  CompleteEpisodeResponses,
  CompleteEsignatureCredentialResetSigningCredentialResetPostData,
  CompleteEsignatureCredentialResetSigningCredentialResetPostErrors,
  CompleteEsignatureCredentialResetSigningCredentialResetPostResponses,
  CompleteInterventionForVisitGoalsVisitProgressVisitIdProgressPatientInterventionIdCompletePostData,
  CompleteInterventionForVisitGoalsVisitProgressVisitIdProgressPatientInterventionIdCompletePostErrors,
  CompleteInterventionForVisitGoalsVisitProgressVisitIdProgressPatientInterventionIdCompletePostResponses,
  CompleteInterventionForVisitInternalInternalGoalsVisitProgressVisitIdProgressPatientInterventionIdCompletePostData,
  CompleteInterventionForVisitInternalInternalGoalsVisitProgressVisitIdProgressPatientInterventionIdCompletePostErrors,
  CompleteInterventionForVisitInternalInternalGoalsVisitProgressVisitIdProgressPatientInterventionIdCompletePostResponses,
  CompleteRemittanceRemittancesRemittanceIdCompletePostData,
  CompleteRemittanceRemittancesRemittanceIdCompletePostErrors,
  CompleteRemittanceRemittancesRemittanceIdCompletePostResponses,
  CompleteTaskOutsideRecordEndpointTasksTaskIdCompleteOutsideRecordPostData,
  CompleteTaskOutsideRecordEndpointTasksTaskIdCompleteOutsideRecordPostErrors,
  CompleteTaskOutsideRecordEndpointTasksTaskIdCompleteOutsideRecordPostResponses,
  ConfirmPortDetailsFaxNumberPortsPortOrderIdDetailsConfirmationPutData,
  ConfirmPortDetailsFaxNumberPortsPortOrderIdDetailsConfirmationPutErrors,
  ConfirmPortDetailsFaxNumberPortsPortOrderIdDetailsConfirmationPutResponses,
  ConfirmTabStatusEndpointIntakeIntakeIdTabTabKeyConfirmPutData,
  ConfirmTabStatusEndpointIntakeIntakeIdTabTabKeyConfirmPutErrors,
  ConfirmTabStatusEndpointIntakeIntakeIdTabTabKeyConfirmPutResponses,
  ContextFormQuestionsFormsManagerContextFormQuestionsGetData,
  ContextFormQuestionsFormsManagerContextFormQuestionsGetErrors,
  ContextFormQuestionsFormsManagerContextFormQuestionsGetResponses,
  ContextSectionLayoutFormsManagerContextSectionLayoutGetData,
  ContextSectionLayoutFormsManagerContextSectionLayoutGetErrors,
  ContextSectionLayoutFormsManagerContextSectionLayoutGetResponses,
  ContextSectionLayoutsFormsManagerContextSectionLayoutsGetData,
  ContextSectionLayoutsFormsManagerContextSectionLayoutsGetErrors,
  ContextSectionLayoutsFormsManagerContextSectionLayoutsGetResponses,
  ContinueGoalsFromPreviousEpisodeGoalsEpisodeEpisodeIdCarryForwardPostData,
  ContinueGoalsFromPreviousEpisodeGoalsEpisodeEpisodeIdCarryForwardPostErrors,
  ContinueGoalsFromPreviousEpisodeGoalsEpisodeEpisodeIdCarryForwardPostResponses,
  CopyGoalsBetweenClinicsGoalsDashboardCopyGoalsBetweenClinicsPostData,
  CopyGoalsBetweenClinicsGoalsDashboardCopyGoalsBetweenClinicsPostErrors,
  CopyGoalsBetweenClinicsGoalsDashboardCopyGoalsBetweenClinicsPostResponses,
  CountUserLicensesUserLicensesCountsGetData,
  CountUserLicensesUserLicensesCountsGetResponses,
  CreateAgencyAssignmentRbacRoleAssignmentsAgencyPostData,
  CreateAgencyAssignmentRbacRoleAssignmentsAgencyPostErrors,
  CreateAgencyAssignmentRbacRoleAssignmentsAgencyPostResponses,
  CreateAgencyClinicAgencyClinicsPostData,
  CreateAgencyClinicAgencyClinicsPostErrors,
  CreateAgencyClinicAgencyClinicsPostResponses,
  CreateAgencyInsuranceClinicsInsurancePostData,
  CreateAgencyInsuranceClinicsInsurancePostErrors,
  CreateAgencyInsuranceClinicsInsurancePostResponses,
  CreateAgencyInternalInternalAgenciesPostData,
  CreateAgencyInternalInternalAgenciesPostErrors,
  CreateAgencyInternalInternalAgenciesPostResponses,
  CreateAgencyInternalToolsAgenciesPostData,
  CreateAgencyInternalToolsAgenciesPostErrors,
  CreateAgencyInternalToolsAgenciesPostResponses,
  CreateAllergyAllergiesPostData,
  CreateAllergyAllergiesPostErrors,
  CreateAllergyAllergiesPostResponses,
  CreateBillingCycleNoteBillingBillingCycleBillingCycleIdNotesPostData,
  CreateBillingCycleNoteBillingBillingCycleBillingCycleIdNotesPostErrors,
  CreateBillingCycleNoteBillingBillingCycleBillingCycleIdNotesPostResponses,
  CreateClinicAssignmentRbacRoleAssignmentsClinicPostData,
  CreateClinicAssignmentRbacRoleAssignmentsClinicPostErrors,
  CreateClinicAssignmentRbacRoleAssignmentsClinicPostResponses,
  CreateClinicPhysicianAdminClinicPhysiciansPostData,
  CreateClinicPhysicianAdminClinicPhysiciansPostErrors,
  CreateClinicPhysicianAdminClinicPhysiciansPostResponses,
  CreateDashboardTabReportingDashboardTabsPostData,
  CreateDashboardTabReportingDashboardTabsPostErrors,
  CreateDashboardTabReportingDashboardTabsPostResponses,
  CreateEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsPostData,
  CreateEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsPostErrors,
  CreateEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsPostResponses,
  CreateEpisodeData,
  CreateEpisodeErrors,
  CreateEpisodeFrequencyEpisodesEpisodeIdFrequenciesPostData,
  CreateEpisodeFrequencyEpisodesEpisodeIdFrequenciesPostErrors,
  CreateEpisodeFrequencyEpisodesEpisodeIdFrequenciesPostResponses,
  CreateEpisodeNoteEpisodesEpisodeIdNotesPostData,
  CreateEpisodeNoteEpisodesEpisodeIdNotesPostErrors,
  CreateEpisodeNoteEpisodesEpisodeIdNotesPostResponses,
  CreateEpisodeResponses,
  CreateFallLogEndpointPatientsPatientIdFallLogsPostData,
  CreateFallLogEndpointPatientsPatientIdFallLogsPostErrors,
  CreateFallLogEndpointPatientsPatientIdFallLogsPostResponses,
  CreateFaxNumberMappingInternalToolsFaxNumberMappingsPostData,
  CreateFaxNumberMappingInternalToolsFaxNumberMappingsPostErrors,
  CreateFaxNumberMappingInternalToolsFaxNumberMappingsPostResponses,
  CreateFaxTagFaxClassificationTagsPostData,
  CreateFaxTagFaxClassificationTagsPostErrors,
  CreateFaxTagFaxClassificationTagsPostResponses,
  CreateFaxTypeInternalToolsFaxTypesPostData,
  CreateFaxTypeInternalToolsFaxTypesPostErrors,
  CreateFaxTypeInternalToolsFaxTypesPostResponses,
  CreateFormTemplateAdminFormTemplatesPostData,
  CreateFormTemplateAdminFormTemplatesPostErrors,
  CreateFormTemplateAdminFormTemplatesPostResponses,
  CreateGroupAssignmentRbacRoleAssignmentsGroupPostData,
  CreateGroupAssignmentRbacRoleAssignmentsGroupPostErrors,
  CreateGroupAssignmentRbacRoleAssignmentsGroupPostResponses,
  CreateGroupChatGroupsPostData,
  CreateGroupChatGroupsPostErrors,
  CreateGroupChatGroupsPostResponses,
  CreateInfectionLogEndpointPatientsPatientIdInfectionLogsPostData,
  CreateInfectionLogEndpointPatientsPatientIdInfectionLogsPostErrors,
  CreateInfectionLogEndpointPatientsPatientIdInfectionLogsPostResponses,
  CreateIntakeDraftIntakeDraftsPostData,
  CreateIntakeDraftIntakeDraftsPostErrors,
  CreateIntakeDraftIntakeDraftsPostResponses,
  CreateIntakeFromFaxDocumentsIntakeFromFaxDocumentsPostData,
  CreateIntakeFromFaxDocumentsIntakeFromFaxDocumentsPostErrors,
  CreateIntakeFromFaxDocumentsIntakeFromFaxDocumentsPostResponses,
  CreateInternalReferralSourceAdminInternalReferralSourcesPostData,
  CreateInternalReferralSourceAdminInternalReferralSourcesPostErrors,
  CreateInternalReferralSourceAdminInternalReferralSourcesPostResponses,
  CreateManualIntakeIntakeManualPostData,
  CreateManualIntakeIntakeManualPostResponses,
  CreateMarMedicationPatientsPatientIdVisitsVisitIdMarPostData,
  CreateMarMedicationPatientsPatientIdVisitsVisitIdMarPostErrors,
  CreateMarMedicationPatientsPatientIdVisitsVisitIdMarPostResponses,
  CreateMedicationOrderData,
  CreateMedicationOrderErrors,
  CreateMedicationOrderResponses,
  CreateMiscTaskPatientsPatientIdMiscTasksPostData,
  CreateMiscTaskPatientsPatientIdMiscTasksPostErrors,
  CreateMiscTaskPatientsPatientIdMiscTasksPostResponses,
  CreateNoaForAdmissionNoasAdmissionsAdmissionIdNoaPostData,
  CreateNoaForAdmissionNoasAdmissionsAdmissionIdNoaPostErrors,
  CreateNoaForAdmissionNoasAdmissionsAdmissionIdNoaPostResponses,
  CreateOrderOrdersPostData,
  CreateOrderOrdersPostErrors,
  CreateOrderOrdersPostResponses,
  CreatePatientAllergyPatientsPatientIdAllergyPostData,
  CreatePatientAllergyPatientsPatientIdAllergyPostErrors,
  CreatePatientAllergyPatientsPatientIdAllergyPostResponses,
  CreatePatientCommunicationPatientsPatientIdCommunicationsPostData,
  CreatePatientCommunicationPatientsPatientIdCommunicationsPostErrors,
  CreatePatientCommunicationPatientsPatientIdCommunicationsPostResponses,
  CreatePatientInKinnserKinnserPatientsPostData,
  CreatePatientInKinnserKinnserPatientsPostErrors,
  CreatePatientInKinnserKinnserPatientsPostResponses,
  CreatePatientInsurancePatientsPatientIdInsurancePostData,
  CreatePatientInsurancePatientsPatientIdInsurancePostErrors,
  CreatePatientInsurancePatientsPatientIdInsurancePostResponses,
  CreatePatientMedicationInternalInternalPatientsPatientIdMedicationsPostData,
  CreatePatientMedicationInternalInternalPatientsPatientIdMedicationsPostErrors,
  CreatePatientMedicationInternalInternalPatientsPatientIdMedicationsPostResponses,
  CreatePatientMedicationPatientsPatientIdMedicationsPostData,
  CreatePatientMedicationPatientsPatientIdMedicationsPostErrors,
  CreatePatientMedicationPatientsPatientIdMedicationsPostResponses,
  CreatePatientPatientsPostData,
  CreatePatientPatientsPostErrors,
  CreatePatientPatientsPostResponses,
  CreatePatientTagDefinitionPatientTagsDefinitionsPostData,
  CreatePatientTagDefinitionPatientTagsDefinitionsPostErrors,
  CreatePatientTagDefinitionPatientTagsDefinitionsPostResponses,
  CreatePatientVisitPatientsPatientIdVisitsPostData,
  CreatePatientVisitPatientsPatientIdVisitsPostErrors,
  CreatePatientVisitPatientsPatientIdVisitsPostResponses,
  CreatePatientWoundPatientsPatientIdWoundsPostData,
  CreatePatientWoundPatientsPatientIdWoundsPostErrors,
  CreatePatientWoundPatientsPatientIdWoundsPostResponses,
  CreatePayorEndpointPayorsPostData,
  CreatePayorEndpointPayorsPostErrors,
  CreatePayorEndpointPayorsPostResponses,
  CreatePayrollEntryPayrollEntriesPostData,
  CreatePayrollEntryPayrollEntriesPostErrors,
  CreatePayrollEntryPayrollEntriesPostResponses,
  CreatePermissionRbacPermissionsPostData,
  CreatePermissionRbacPermissionsPostErrors,
  CreatePermissionRbacPermissionsPostResponses,
  CreatePortOrdersFaxNumberPortsPostData,
  CreatePortOrdersFaxNumberPortsPostErrors,
  CreatePortOrdersFaxNumberPortsPostResponses,
  CreateRemittanceRemittancesPostData,
  CreateRemittanceRemittancesPostErrors,
  CreateRemittanceRemittancesPostResponses,
  CreateReplacementClaimBillingBillingCycleBillingCycleIdReplacementPostData,
  CreateReplacementClaimBillingBillingCycleBillingCycleIdReplacementPostErrors,
  CreateReplacementClaimBillingBillingCycleBillingCycleIdReplacementPostResponses,
  CreateReportDefinitionReportingReportDefinitionsPostData,
  CreateReportDefinitionReportingReportDefinitionsPostErrors,
  CreateReportDefinitionReportingReportDefinitionsPostResponses,
  CreateReportWidgetReportingWidgetsPostData,
  CreateReportWidgetReportingWidgetsPostErrors,
  CreateReportWidgetReportingWidgetsPostResponses,
  CreateRogerdocAccountLinkRogerdocAccountLinksPostData,
  CreateRogerdocAccountLinkRogerdocAccountLinksPostErrors,
  CreateRogerdocAccountLinkRogerdocAccountLinksPostResponses,
  CreateRoleRbacRolesPostData,
  CreateRoleRbacRolesPostErrors,
  CreateRoleRbacRolesPostResponses,
  CreateStedi837ClaimJsonApiBillingBillingCycleBillingCycleIdCreateStedi837ClaimJsonPostData,
  CreateStedi837ClaimJsonApiBillingBillingCycleBillingCycleIdCreateStedi837ClaimJsonPostErrors,
  CreateStedi837ClaimJsonApiBillingBillingCycleBillingCycleIdCreateStedi837ClaimJsonPostResponses,
  CreateTaskForEpisodeKinnserClinicClinicIdEpisodeEpisodeKeyTaskPostData,
  CreateTaskForEpisodeKinnserClinicClinicIdEpisodeEpisodeKeyTaskPostErrors,
  CreateTaskForEpisodeKinnserClinicClinicIdEpisodeEpisodeKeyTaskPostResponses,
  CreateTaskTypeAliasTaskTypesAliasesPostData,
  CreateTaskTypeAliasTaskTypesAliasesPostErrors,
  CreateTaskTypeAliasTaskTypesAliasesPostResponses,
  CreateUserDefinedPatientAllergyPatientsPatientIdAllergyUserDefinedPostData,
  CreateUserDefinedPatientAllergyPatientsPatientIdAllergyUserDefinedPostErrors,
  CreateUserDefinedPatientAllergyPatientsPatientIdAllergyUserDefinedPostResponses,
  CreateUserLicenseTypeAdminUserLicenseTypesPostData,
  CreateUserLicenseTypeAdminUserLicenseTypesPostErrors,
  CreateUserLicenseTypeAdminUserLicenseTypesPostResponses,
  CreateUserLicenseUserLicensesPostData,
  CreateUserLicenseUserLicensesPostErrors,
  CreateUserLicenseUserLicensesPostResponses,
  CreateUserUsersPostData,
  CreateUserUsersPostErrors,
  CreateUserUsersPostResponses,
  CreateVisitDiagnosisInternalInternalVisitsVisitIdDiagnosesPostData,
  CreateVisitDiagnosisInternalInternalVisitsVisitIdDiagnosesPostErrors,
  CreateVisitDiagnosisInternalInternalVisitsVisitIdDiagnosesPostResponses,
  CreateVisitDiagnosisVisitsVisitIdDiagnosesPostData,
  CreateVisitDiagnosisVisitsVisitIdDiagnosesPostErrors,
  CreateVisitDiagnosisVisitsVisitIdDiagnosesPostResponses,
  CreateVisitInternalInternalVisitsPostData,
  CreateVisitInternalInternalVisitsPostErrors,
  CreateVisitInternalInternalVisitsPostResponses,
  CreateVisitVisitsPostData,
  CreateVisitVisitsPostErrors,
  CreateVisitVisitsPostResponses,
  CreateWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsPostData,
  CreateWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsPostErrors,
  CreateWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsPostResponses,
  DatabaseHealthCheckHealthDbGetData,
  DatabaseHealthCheckHealthDbGetResponses,
  DeactivateUserUsersUserIdDeactivatePostData,
  DeactivateUserUsersUserIdDeactivatePostErrors,
  DeactivateUserUsersUserIdDeactivatePostResponses,
  DecideOrderFaxSignatureOrdersOrderIdFaxSignaturePostData,
  DecideOrderFaxSignatureOrdersOrderIdFaxSignaturePostErrors,
  DecideOrderFaxSignatureOrdersOrderIdFaxSignaturePostResponses,
  DeclineImportedAllergyLineData,
  DeclineImportedAllergyLineErrors,
  DeclineImportedAllergyLineResponses,
  DeclineImportedMedicationLineData,
  DeclineImportedMedicationLineErrors,
  DeclineImportedMedicationLineResponses,
  DecodePayloadsTemporalCodecDecodePostData,
  DecodePayloadsTemporalCodecDecodePostErrors,
  DecodePayloadsTemporalCodecDecodePostResponses,
  DeleteAgencyClinicAgencyClinicsAgencyClinicIdDeleteData,
  DeleteAgencyClinicAgencyClinicsAgencyClinicIdDeleteErrors,
  DeleteAgencyClinicAgencyClinicsAgencyClinicIdDeleteResponses,
  DeleteAgencyInsuranceClinicsInsuranceInsuranceIdDeleteData,
  DeleteAgencyInsuranceClinicsInsuranceInsuranceIdDeleteErrors,
  DeleteAgencyInsuranceClinicsInsuranceInsuranceIdDeleteResponses,
  DeleteAllergyAllergiesAllergyIdDeleteData,
  DeleteAllergyAllergiesAllergyIdDeleteErrors,
  DeleteAllergyAllergiesAllergyIdDeleteResponses,
  DeleteAssignmentRbacRoleAssignmentsAssignmentIdDeleteData,
  DeleteAssignmentRbacRoleAssignmentsAssignmentIdDeleteErrors,
  DeleteAssignmentRbacRoleAssignmentsAssignmentIdDeleteResponses,
  DeleteBillingCycleNoteBillingBillingCycleNotesNoteIdDeleteData,
  DeleteBillingCycleNoteBillingBillingCycleNotesNoteIdDeleteErrors,
  DeleteBillingCycleNoteBillingBillingCycleNotesNoteIdDeleteResponses,
  DeleteClinicPhysicianAdminClinicPhysiciansClinicPhysicianIdDeleteData,
  DeleteClinicPhysicianAdminClinicPhysiciansClinicPhysicianIdDeleteErrors,
  DeleteClinicPhysicianAdminClinicPhysiciansClinicPhysicianIdDeleteResponses,
  DeleteCurrentAgencyAgenciesDeleteData,
  DeleteCurrentAgencyAgenciesDeleteResponses,
  DeleteDashboardTabReportingDashboardTabsTabIdDeleteData,
  DeleteDashboardTabReportingDashboardTabsTabIdDeleteErrors,
  DeleteDashboardTabReportingDashboardTabsTabIdDeleteResponses,
  DeleteEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdDeleteData,
  DeleteEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdDeleteErrors,
  DeleteEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdDeleteResponses,
  DeleteEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdDeleteData,
  DeleteEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdDeleteErrors,
  DeleteEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdDeleteResponses,
  DeleteEpisodeNoteEpisodesEpisodeIdNotesNoteIdDeleteData,
  DeleteEpisodeNoteEpisodesEpisodeIdNotesNoteIdDeleteErrors,
  DeleteEpisodeNoteEpisodesEpisodeIdNotesNoteIdDeleteResponses,
  DeleteEvvCorrectionInternalToolsEvvCorrectionsDeletePostData,
  DeleteEvvCorrectionInternalToolsEvvCorrectionsDeletePostErrors,
  DeleteEvvCorrectionInternalToolsEvvCorrectionsDeletePostResponses,
  DeleteFallLogEndpointPatientsPatientIdFallLogsFallLogIdDeleteData,
  DeleteFallLogEndpointPatientsPatientIdFallLogsFallLogIdDeleteErrors,
  DeleteFallLogEndpointPatientsPatientIdFallLogsFallLogIdDeleteResponses,
  DeleteFaxTagFaxClassificationTagsTagIdDeleteData,
  DeleteFaxTagFaxClassificationTagsTagIdDeleteErrors,
  DeleteFaxTagFaxClassificationTagsTagIdDeleteResponses,
  DeleteFormTemplateAdminFormTemplatesTemplateIdDeleteData,
  DeleteFormTemplateAdminFormTemplatesTemplateIdDeleteErrors,
  DeleteFormTemplateAdminFormTemplatesTemplateIdDeleteResponses,
  DeleteGoalFromVisitGoalsVisitVisitIdPatientGoalIdDeleteData,
  DeleteGoalFromVisitGoalsVisitVisitIdPatientGoalIdDeleteErrors,
  DeleteGoalFromVisitGoalsVisitVisitIdPatientGoalIdDeleteResponses,
  DeleteInfectionLogEndpointPatientsPatientIdInfectionLogsInfectionLogIdDeleteData,
  DeleteInfectionLogEndpointPatientsPatientIdInfectionLogsInfectionLogIdDeleteErrors,
  DeleteInfectionLogEndpointPatientsPatientIdInfectionLogsInfectionLogIdDeleteResponses,
  DeleteIntakeDocumentIntakeDocumentsDocumentIdDeleteData,
  DeleteIntakeDocumentIntakeDocumentsDocumentIdDeleteErrors,
  DeleteIntakeDocumentIntakeDocumentsDocumentIdDeleteResponses,
  DeleteIntakeEndpointIntakeIntakeIdDeleteData,
  DeleteIntakeEndpointIntakeIntakeIdDeleteErrors,
  DeleteIntakeEndpointIntakeIntakeIdDeleteResponses,
  DeleteInternalReferralSourceAdminInternalReferralSourcesSourceIdDeleteData,
  DeleteInternalReferralSourceAdminInternalReferralSourcesSourceIdDeleteErrors,
  DeleteInternalReferralSourceAdminInternalReferralSourcesSourceIdDeleteResponses,
  DeleteInterventionFromVisitGoalsVisitVisitIdInterventionPatientInterventionIdDeleteData,
  DeleteInterventionFromVisitGoalsVisitVisitIdInterventionPatientInterventionIdDeleteErrors,
  DeleteInterventionFromVisitGoalsVisitVisitIdInterventionPatientInterventionIdDeleteResponses,
  DeleteMarMedicationPatientsPatientIdVisitsVisitIdMarMarIdDeleteData,
  DeleteMarMedicationPatientsPatientIdVisitsVisitIdMarMarIdDeleteErrors,
  DeleteMarMedicationPatientsPatientIdVisitsVisitIdMarMarIdDeleteResponses,
  DeleteMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsAttachmentIdDeleteData,
  DeleteMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsAttachmentIdDeleteErrors,
  DeleteMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsAttachmentIdDeleteResponses,
  DeleteMessageChatChannelsChannelIdMessagesMessageIdDeleteData,
  DeleteMessageChatChannelsChannelIdMessagesMessageIdDeleteErrors,
  DeleteMessageChatChannelsChannelIdMessagesMessageIdDeleteResponses,
  DeleteMiscTaskMiscTasksMiscTaskIdDeleteData,
  DeleteMiscTaskMiscTasksMiscTaskIdDeleteErrors,
  DeleteMiscTaskMiscTasksMiscTaskIdDeleteResponses,
  DeleteOrderOrdersOrderIdDeleteData,
  DeleteOrderOrdersOrderIdDeleteErrors,
  DeleteOrderOrdersOrderIdDeleteResponses,
  DeletePatientAllergyPatientsAllergyPatientAllergyIdDeleteData,
  DeletePatientAllergyPatientsAllergyPatientAllergyIdDeleteErrors,
  DeletePatientAllergyPatientsAllergyPatientAllergyIdDeleteResponses,
  DeletePatientCommunicationPatientCommunicationsCommunicationIdDeleteData,
  DeletePatientCommunicationPatientCommunicationsCommunicationIdDeleteErrors,
  DeletePatientCommunicationPatientCommunicationsCommunicationIdDeleteResponses,
  DeletePatientDocumentPatientsPatientIdDocumentsDocumentIdDeleteData,
  DeletePatientDocumentPatientsPatientIdDocumentsDocumentIdDeleteErrors,
  DeletePatientDocumentPatientsPatientIdDocumentsDocumentIdDeleteResponses,
  DeletePatientHardDevTestDataPatientPatientIdDeleteData,
  DeletePatientHardDevTestDataPatientPatientIdDeleteErrors,
  DeletePatientHardDevTestDataPatientPatientIdDeleteResponses,
  DeletePatientInsurancePatientsPatientIdInsurancePatientInsuranceIdDeleteData,
  DeletePatientInsurancePatientsPatientIdInsurancePatientInsuranceIdDeleteErrors,
  DeletePatientInsurancePatientsPatientIdInsurancePatientInsuranceIdDeleteResponses,
  DeletePatientIntakeDocumentPatientsPatientIdIntakeDocumentsDocumentIdDeleteData,
  DeletePatientIntakeDocumentPatientsPatientIdIntakeDocumentsDocumentIdDeleteErrors,
  DeletePatientIntakeDocumentPatientsPatientIdIntakeDocumentsDocumentIdDeleteResponses,
  DeletePatientMedicationInternalPatientsPatientIdMedicationsMedicationIdDeleteData,
  DeletePatientMedicationInternalPatientsPatientIdMedicationsMedicationIdDeleteErrors,
  DeletePatientMedicationInternalPatientsPatientIdMedicationsMedicationIdDeleteResponses,
  DeletePatientMedicationPatientsPatientIdMedicationsMedicationIdDeleteData,
  DeletePatientMedicationPatientsPatientIdMedicationsMedicationIdDeleteErrors,
  DeletePatientMedicationPatientsPatientIdMedicationsMedicationIdDeleteResponses,
  DeletePatientPatientsPatientIdDeleteData,
  DeletePatientPatientsPatientIdDeleteErrors,
  DeletePatientPatientsPatientIdDeleteResponses,
  DeletePatientWoundPatientsPatientIdWoundsWoundIdDeleteData,
  DeletePatientWoundPatientsPatientIdWoundsWoundIdDeleteErrors,
  DeletePatientWoundPatientsPatientIdWoundsWoundIdDeleteResponses,
  DeletePayorEndpointPayorsPayorIdDeleteData,
  DeletePayorEndpointPayorsPayorIdDeleteErrors,
  DeletePayorEndpointPayorsPayorIdDeleteResponses,
  DeletePayrollEntryPayrollEntriesPayrollEntryIdDeleteData,
  DeletePayrollEntryPayrollEntriesPayrollEntryIdDeleteErrors,
  DeletePayrollEntryPayrollEntriesPayrollEntryIdDeleteResponses,
  DeletePortOrderFaxNumberPortsPortOrderIdDeleteData,
  DeletePortOrderFaxNumberPortsPortOrderIdDeleteErrors,
  DeletePortOrderFaxNumberPortsPortOrderIdDeleteResponses,
  DeleteProductUpdateEntryInternalToolsProductUpdatesManagementProductUpdateIdDeleteData,
  DeleteProductUpdateEntryInternalToolsProductUpdatesManagementProductUpdateIdDeleteErrors,
  DeleteProductUpdateEntryInternalToolsProductUpdatesManagementProductUpdateIdDeleteResponses,
  DeleteProductUpdateImageInternalToolsProductUpdatesManagementImagesImageIdDeleteData,
  DeleteProductUpdateImageInternalToolsProductUpdatesManagementImagesImageIdDeleteErrors,
  DeleteProductUpdateImageInternalToolsProductUpdatesManagementImagesImageIdDeleteResponses,
  DeleteRemittanceRemittancesRemittanceIdDeleteData,
  DeleteRemittanceRemittancesRemittanceIdDeleteErrors,
  DeleteRemittanceRemittancesRemittanceIdDeleteResponses,
  DeleteReportDefinitionReportingReportDefinitionsDefinitionIdDeleteData,
  DeleteReportDefinitionReportingReportDefinitionsDefinitionIdDeleteErrors,
  DeleteReportDefinitionReportingReportDefinitionsDefinitionIdDeleteResponses,
  DeleteReportWidgetReportingWidgetsWidgetIdDeleteData,
  DeleteReportWidgetReportingWidgetsWidgetIdDeleteErrors,
  DeleteReportWidgetReportingWidgetsWidgetIdDeleteResponses,
  DeleteRoleRbacRolesRoleIdDeleteData,
  DeleteRoleRbacRolesRoleIdDeleteErrors,
  DeleteRoleRbacRolesRoleIdDeleteResponses,
  DeleteTaskDetailsDocumentTasksTaskIdDetailsDocumentsDocumentIdDeleteData,
  DeleteTaskDetailsDocumentTasksTaskIdDetailsDocumentsDocumentIdDeleteErrors,
  DeleteTaskDetailsDocumentTasksTaskIdDetailsDocumentsDocumentIdDeleteResponses,
  DeleteTaskDocumentTasksTaskIdDocumentsDocumentIdDeleteData,
  DeleteTaskDocumentTasksTaskIdDocumentsDocumentIdDeleteErrors,
  DeleteTaskDocumentTasksTaskIdDocumentsDocumentIdDeleteResponses,
  DeleteTaskOutsideRecordDocumentEndpointTasksTaskIdOutsideRecordDocumentsDocumentIdDeleteData,
  DeleteTaskOutsideRecordDocumentEndpointTasksTaskIdOutsideRecordDocumentsDocumentIdDeleteErrors,
  DeleteTaskOutsideRecordDocumentEndpointTasksTaskIdOutsideRecordDocumentsDocumentIdDeleteResponses,
  DeleteTestPatientsAdminTestPatientsDeletePostData,
  DeleteTestPatientsAdminTestPatientsDeletePostErrors,
  DeleteTestPatientsAdminTestPatientsDeletePostResponses,
  DeleteUserLicenseDocumentUserLicensesLicenseIdDocumentsDocumentIdDeleteData,
  DeleteUserLicenseDocumentUserLicensesLicenseIdDocumentsDocumentIdDeleteErrors,
  DeleteUserLicenseDocumentUserLicensesLicenseIdDocumentsDocumentIdDeleteResponses,
  DeleteUserLicenseTypeAdminUserLicenseTypesTypeIdDeleteData,
  DeleteUserLicenseTypeAdminUserLicenseTypesTypeIdDeleteErrors,
  DeleteUserLicenseTypeAdminUserLicenseTypesTypeIdDeleteResponses,
  DeleteUserLicenseUserLicensesLicenseIdDeleteData,
  DeleteUserLicenseUserLicensesLicenseIdDeleteErrors,
  DeleteUserLicenseUserLicensesLicenseIdDeleteResponses,
  DeleteVisitDiagnosisInternalInternalVisitsDiagnosesDiagnosisIdDeleteData,
  DeleteVisitDiagnosisInternalInternalVisitsDiagnosesDiagnosisIdDeleteErrors,
  DeleteVisitDiagnosisInternalInternalVisitsDiagnosesDiagnosisIdDeleteResponses,
  DeleteVisitDiagnosisVisitsDiagnosesDiagnosisIdDeleteData,
  DeleteVisitDiagnosisVisitsDiagnosesDiagnosisIdDeleteErrors,
  DeleteVisitDiagnosisVisitsDiagnosesDiagnosisIdDeleteResponses,
  DeleteVisitInternalInternalVisitsVisitIdDeleteData,
  DeleteVisitInternalInternalVisitsVisitIdDeleteErrors,
  DeleteVisitInternalInternalVisitsVisitIdDeleteResponses,
  DeleteVisitVisitsVisitIdDeleteData,
  DeleteVisitVisitsVisitIdDeleteErrors,
  DeleteVisitVisitsVisitIdDeleteResponses,
  DeleteWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsAssessmentIdDeleteData,
  DeleteWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsAssessmentIdDeleteErrors,
  DeleteWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsAssessmentIdDeleteResponses,
  DeleteWoundAttachmentPatientsPatientIdWoundsWoundIdAttachmentsAttachmentIdDeleteData,
  DeleteWoundAttachmentPatientsPatientIdWoundsWoundIdAttachmentsAttachmentIdDeleteErrors,
  DeleteWoundAttachmentPatientsPatientIdWoundsWoundIdAttachmentsAttachmentIdDeleteResponses,
  DeliverDirectFaxInternalToolsDirectFaxesPostData,
  DeliverDirectFaxInternalToolsDirectFaxesPostErrors,
  DeliverDirectFaxInternalToolsDirectFaxesPostResponses,
  DiagnosisCodeFitnessRouteDiagnosisCodesFitnessPostData,
  DiagnosisCodeFitnessRouteDiagnosisCodesFitnessPostErrors,
  DiagnosisCodeFitnessRouteDiagnosisCodesFitnessPostResponses,
  DisconnectAgencyClinicFromKinnserAgencyClinicsAgencyClinicIdKinnserDisconnectPostData,
  DisconnectAgencyClinicFromKinnserAgencyClinicsAgencyClinicIdKinnserDisconnectPostErrors,
  DisconnectAgencyClinicFromKinnserAgencyClinicsAgencyClinicIdKinnserDisconnectPostResponses,
  DismissQaScrubberItemVisitsVisitIdQaScrubberRuleIdDismissPostData,
  DismissQaScrubberItemVisitsVisitIdQaScrubberRuleIdDismissPostErrors,
  DismissQaScrubberItemVisitsVisitIdQaScrubberRuleIdDismissPostResponses,
  DownloadAttachmentChatAttachmentsAttachmentIdDownloadGetData,
  DownloadAttachmentChatAttachmentsAttachmentIdDownloadGetErrors,
  DownloadAttachmentChatAttachmentsAttachmentIdDownloadGetResponses,
  DownloadBillingCycle837EdiBillingBillingCycleBillingCycleIdDownload837EdiGetData,
  DownloadBillingCycle837EdiBillingBillingCycleBillingCycleIdDownload837EdiGetErrors,
  DownloadBillingCycle837EdiBillingBillingCycleBillingCycleIdDownload837EdiGetResponses,
  DownloadBillingCycleUb04PdfBillingBillingCycleBillingCycleIdDownloadUb04PdfGetData,
  DownloadBillingCycleUb04PdfBillingBillingCycleBillingCycleIdDownloadUb04PdfGetErrors,
  DownloadBillingCycleUb04PdfBillingBillingCycleBillingCycleIdDownloadUb04PdfGetResponses,
  DownloadCahpsExportCahpsExportsExportIdDownloadGetData,
  DownloadCahpsExportCahpsExportsExportIdDownloadGetErrors,
  DownloadCahpsExportCahpsExportsExportIdDownloadGetResponses,
  DownloadFaxDocumentFaxDocumentsDocumentIdDownloadGetData,
  DownloadFaxDocumentFaxDocumentsDocumentIdDownloadGetErrors,
  DownloadFaxDocumentFaxDocumentsDocumentIdDownloadGetResponses,
  DownloadHistoricalClaimPrintData,
  DownloadHistoricalClaimPrintErrors,
  DownloadHistoricalClaimPrintResponses,
  DownloadImporterRosterStatusImporterRosterStatusPostData,
  DownloadImporterRosterStatusImporterRosterStatusPostErrors,
  DownloadImporterRosterStatusImporterRosterStatusPostResponses,
  DownloadPortDocumentFaxNumberPortsPortOrderIdDocumentsDocumentKindGetData,
  DownloadPortDocumentFaxNumberPortsPortOrderIdDocumentsDocumentKindGetErrors,
  DownloadPortDocumentFaxNumberPortsPortOrderIdDocumentsDocumentKindGetResponses,
  DownloadReceivedFaxDocumentReceivedFaxesFaxIdDocumentsDocumentIdDownloadGetData,
  DownloadReceivedFaxDocumentReceivedFaxesFaxIdDocumentsDocumentIdDownloadGetErrors,
  DownloadReceivedFaxDocumentReceivedFaxesFaxIdDocumentsDocumentIdDownloadGetResponses,
  DownloadRemittanceRemittancesRemittanceIdDownloadGetData,
  DownloadRemittanceRemittancesRemittanceIdDownloadGetErrors,
  DownloadRemittanceRemittancesRemittanceIdDownloadGetResponses,
  DownloadShpSentXmlVisitsOasisManagerVisitIdShpSentXmlGetData,
  DownloadShpSentXmlVisitsOasisManagerVisitIdShpSentXmlGetErrors,
  DownloadShpSentXmlVisitsOasisManagerVisitIdShpSentXmlGetResponses,
  DownloadUnassignedFaxDocumentInternalToolsUnassignedFaxesFaxIdDocumentsDocumentIdDownloadGetData,
  DownloadUnassignedFaxDocumentInternalToolsUnassignedFaxesFaxIdDocumentsDocumentIdDownloadGetErrors,
  DownloadUnassignedFaxDocumentInternalToolsUnassignedFaxesFaxIdDocumentsDocumentIdDownloadGetResponses,
  DuplicateClinicInsurancesClinicsInsuranceDuplicatePostData,
  DuplicateClinicInsurancesClinicsInsuranceDuplicatePostErrors,
  DuplicateClinicInsurancesClinicsInsuranceDuplicatePostResponses,
  DuplicateClinicPhysiciansAdminClinicPhysiciansDuplicatePostData,
  DuplicateClinicPhysiciansAdminClinicPhysiciansDuplicatePostErrors,
  DuplicateClinicPhysiciansAdminClinicPhysiciansDuplicatePostResponses,
  EditFaxDocumentPagesFaxDocumentsDocumentIdPagesPatchData,
  EditFaxDocumentPagesFaxDocumentsDocumentIdPagesPatchErrors,
  EditFaxDocumentPagesFaxDocumentsDocumentIdPagesPatchResponses,
  EditMessageChatChannelsChannelIdMessagesMessageIdPatchData,
  EditMessageChatChannelsChannelIdMessagesMessageIdPatchErrors,
  EditMessageChatChannelsChannelIdMessagesMessageIdPatchResponses,
  EncodePayloadsTemporalCodecEncodePostData,
  EncodePayloadsTemporalCodecEncodePostErrors,
  EncodePayloadsTemporalCodecEncodePostResponses,
  EnqueueBillingCycleBillingDevEnqueueBillingCycleCreationPostData,
  EnqueueBillingCycleBillingDevEnqueueBillingCycleCreationPostErrors,
  EnqueueBillingCycleBillingDevEnqueueBillingCycleCreationPostResponses,
  EnqueueKinnserImportQueueInternalKinnserImportQueuePostData,
  EnqueueKinnserImportQueueInternalKinnserImportQueuePostErrors,
  EnqueueKinnserImportQueueInternalKinnserImportQueuePostResponses,
  EnsureCurrentEpisodeInternalInternalEpisodesEnsureCurrentPatientIdPostData,
  EnsureCurrentEpisodeInternalInternalEpisodesEnsureCurrentPatientIdPostErrors,
  EnsureCurrentEpisodeInternalInternalEpisodesEnsureCurrentPatientIdPostResponses,
  EnsureTestPatientInternalInternalPatientsEnsureTestPatientPostData,
  EnsureTestPatientInternalInternalPatientsEnsureTestPatientPostErrors,
  EnsureTestPatientInternalInternalPatientsEnsureTestPatientPostResponses,
  ExportActiveUsersReportReportsActiveUsersExportGetData,
  ExportActiveUsersReportReportsActiveUsersExportGetErrors,
  ExportActiveUsersReportReportsActiveUsersExportGetResponses,
  ExportAllPayrollEntriesPayrollEntriesExportGetData,
  ExportAllPayrollEntriesPayrollEntriesExportGetErrors,
  ExportAllPayrollEntriesPayrollEntriesExportGetResponses,
  ExportBillingCyclesBillingBillingCyclesExportGetData,
  ExportBillingCyclesBillingBillingCyclesExportGetErrors,
  ExportBillingCyclesBillingBillingCyclesExportGetResponses,
  ExportCensusReportReportsCensusExportGetData,
  ExportCensusReportReportsCensusExportGetErrors,
  ExportCensusReportReportsCensusExportGetResponses,
  ExportClinicianDirectoryInternalToolsClinicianDirectoryExportCsvGetData,
  ExportClinicianDirectoryInternalToolsClinicianDirectoryExportCsvGetErrors,
  ExportClinicianDirectoryInternalToolsClinicianDirectoryExportCsvGetResponses,
  ExportInsuranceEligibilityReportReportsInsuranceEligibilityExportGetData,
  ExportInsuranceEligibilityReportReportsInsuranceEligibilityExportGetErrors,
  ExportInsuranceEligibilityReportReportsInsuranceEligibilityExportGetResponses,
  ExportIntakesEndpointIntakeExportGetData,
  ExportIntakesEndpointIntakeExportGetErrors,
  ExportIntakesEndpointIntakeExportGetResponses,
  ExportLateStartsReportReportsLateStartsExportGetData,
  ExportLateStartsReportReportsLateStartsExportGetErrors,
  ExportLateStartsReportReportsLateStartsExportGetResponses,
  ExportLupaRiskReportReportsLupaRiskExportGetData,
  ExportLupaRiskReportReportsLupaRiskExportGetErrors,
  ExportLupaRiskReportReportsLupaRiskExportGetResponses,
  ExportMarketingReportReportsMarketingExportGetData,
  ExportMarketingReportReportsMarketingExportGetErrors,
  ExportMarketingReportReportsMarketingExportGetResponses,
  ExportNoasNoasExportGetData,
  ExportNoasNoasExportGetErrors,
  ExportNoasNoasExportGetResponses,
  ExportOasisBatchVisitsExportOasisBatchPostData,
  ExportOasisBatchVisitsExportOasisBatchPostErrors,
  ExportOasisBatchVisitsExportOasisBatchPostResponses,
  ExportOpenOasisReportReportsOpenOasisExportGetData,
  ExportOpenOasisReportReportsOpenOasisExportGetErrors,
  ExportOpenOasisReportReportsOpenOasisExportGetResponses,
  ExportOrgMembersUsersOrgMembersExportGetData,
  ExportOrgMembersUsersOrgMembersExportGetResponses,
  ExportPastDueVisitsReportReportsPastDueVisitsExportGetData,
  ExportPastDueVisitsReportReportsPastDueVisitsExportGetErrors,
  ExportPastDueVisitsReportReportsPastDueVisitsExportGetResponses,
  ExportPatientDiagnosesReportReportsPatientDiagnosesExportGetData,
  ExportPatientDiagnosesReportReportsPatientDiagnosesExportGetErrors,
  ExportPatientDiagnosesReportReportsPatientDiagnosesExportGetResponses,
  ExportPatientRosterReportReportsPatientRosterExportGetData,
  ExportPatientRosterReportReportsPatientRosterExportGetErrors,
  ExportPatientRosterReportReportsPatientRosterExportGetResponses,
  ExportPatientsPatientsExportGetData,
  ExportPatientsPatientsExportGetErrors,
  ExportPatientsPatientsExportGetResponses,
  ExportPayrollEntryVisitsPayrollEntriesPayrollEntryIdExportGetData,
  ExportPayrollEntryVisitsPayrollEntriesPayrollEntryIdExportGetErrors,
  ExportPayrollEntryVisitsPayrollEntriesPayrollEntryIdExportGetResponses,
  ExportPayrollVisitsPayrollVisitsExportGetData,
  ExportPayrollVisitsPayrollVisitsExportGetErrors,
  ExportPayrollVisitsPayrollVisitsExportGetResponses,
  ExportPcrReportReportsPcrExportGetData,
  ExportPcrReportReportsPcrExportGetErrors,
  ExportPcrReportReportsPcrExportGetResponses,
  ExportQaAllTasksTasksMyTasksExportGetData,
  ExportQaAllTasksTasksMyTasksExportGetErrors,
  ExportQaAllTasksTasksMyTasksExportGetResponses,
  ExportRecertificationTimingReportReportsRecertificationTimingExportGetData,
  ExportRecertificationTimingReportReportsRecertificationTimingExportGetErrors,
  ExportRecertificationTimingReportReportsRecertificationTimingExportGetResponses,
  ExportRehospitalizationReportReportsRehospitalizationExportGetData,
  ExportRehospitalizationReportReportsRehospitalizationExportGetErrors,
  ExportRehospitalizationReportReportsRehospitalizationExportGetResponses,
  ExportRemittancesRemittancesExportGetData,
  ExportRemittancesRemittancesExportGetErrors,
  ExportRemittancesRemittancesExportGetResponses,
  ExportScheduleDeviationReportReportsScheduleDeviationExportGetData,
  ExportScheduleDeviationReportReportsScheduleDeviationExportGetErrors,
  ExportScheduleDeviationReportReportsScheduleDeviationExportGetResponses,
  ExportScheduleReportReportsScheduleExportGetData,
  ExportScheduleReportReportsScheduleExportGetErrors,
  ExportScheduleReportReportsScheduleExportGetResponses,
  ExportUserOnboardingReportReportsUserOnboardingExportGetData,
  ExportUserOnboardingReportReportsUserOnboardingExportGetErrors,
  ExportUserOnboardingReportReportsUserOnboardingExportGetResponses,
  ExportWorklogReportReportsWorklogExportGetData,
  ExportWorklogReportReportsWorklogExportGetErrors,
  ExportWorklogReportReportsWorklogExportGetResponses,
  ExportWoundStatusReportReportsWoundStatusExportGetData,
  ExportWoundStatusReportReportsWoundStatusExportGetErrors,
  ExportWoundStatusReportReportsWoundStatusExportGetResponses,
  ExtendGoalToNextEpisodeGoalsVisitProgressVisitIdGoalPatientGoalIdExtendPostData,
  ExtendGoalToNextEpisodeGoalsVisitProgressVisitIdGoalPatientGoalIdExtendPostErrors,
  ExtendGoalToNextEpisodeGoalsVisitProgressVisitIdGoalPatientGoalIdExtendPostResponses,
  ForgetTelnyxFaxApplicationInternalToolsTelnyxFaxLinesAgencyIdForgetApplicationPostData,
  ForgetTelnyxFaxApplicationInternalToolsTelnyxFaxLinesAgencyIdForgetApplicationPostErrors,
  ForgetTelnyxFaxApplicationInternalToolsTelnyxFaxLinesAgencyIdForgetApplicationPostResponses,
  GenerateCahpsExportCahpsExportsGeneratePostData,
  GenerateCahpsExportCahpsExportsGeneratePostErrors,
  GenerateCahpsExportCahpsExportsGeneratePostResponses,
  GenerateTestDataDevTestDataGeneratePostData,
  GenerateTestDataDevTestDataGeneratePostErrors,
  GenerateTestDataDevTestDataGeneratePostResponses,
  GenerateX12270X12270GeneratePostData,
  GenerateX12270X12270GeneratePostErrors,
  GenerateX12270X12270GeneratePostResponses,
  GenerateX12271X12271GeneratePostData,
  GenerateX12271X12271GeneratePostErrors,
  GenerateX12271X12271GeneratePostResponses,
  GenerateX12837iX12837iGeneratePostData,
  GenerateX12837iX12837iGeneratePostErrors,
  GenerateX12837iX12837iGeneratePostResponses,
  GetActiveAttestationsSigningAttestationsActiveGetData,
  GetActiveAttestationsSigningAttestationsActiveGetResponses,
  GetActiveBillingCyclesApiBillingBillingCyclesActiveCyclesPostData,
  GetActiveBillingCyclesApiBillingBillingCyclesActiveCyclesPostErrors,
  GetActiveBillingCyclesApiBillingBillingCyclesActiveCyclesPostResponses,
  GetActiveUsersReportReportsActiveUsersGetData,
  GetActiveUsersReportReportsActiveUsersGetErrors,
  GetActiveUsersReportReportsActiveUsersGetResponses,
  GetAdmissionAdmissionsAdmissionIdGetData,
  GetAdmissionAdmissionsAdmissionIdGetErrors,
  GetAdmissionAdmissionsAdmissionIdGetResponses,
  GetAdmissionWorkLogAdmissionsAdmissionIdWorkLogGetData,
  GetAdmissionWorkLogAdmissionsAdmissionIdWorkLogGetErrors,
  GetAdmissionWorkLogAdmissionsAdmissionIdWorkLogGetResponses,
  GetAgenciesInternalToolsAgenciesGetData,
  GetAgenciesInternalToolsAgenciesGetErrors,
  GetAgenciesInternalToolsAgenciesGetResponses,
  GetAgencyClinicAgencyClinicsAgencyClinicIdGetData,
  GetAgencyClinicAgencyClinicsAgencyClinicIdGetErrors,
  GetAgencyClinicAgencyClinicsAgencyClinicIdGetResponses,
  GetAgencyClinicHhrgCostsAgencyClinicsAgencyClinicIdHhrgCostsGetData,
  GetAgencyClinicHhrgCostsAgencyClinicsAgencyClinicIdHhrgCostsGetErrors,
  GetAgencyClinicHhrgCostsAgencyClinicsAgencyClinicIdHhrgCostsGetResponses,
  GetAgencyClinicsAgencyClinicsGetData,
  GetAgencyClinicsAgencyClinicsGetErrors,
  GetAgencyClinicsAgencyClinicsGetResponses,
  GetAgencyClinicScopeAgencyClinicsScopeGetData,
  GetAgencyClinicScopeAgencyClinicsScopeGetResponses,
  GetAgencyConfigAgencyConfigGetData,
  GetAgencyConfigAgencyConfigGetResponses,
  GetAgencyEnrollmentCountClinicsEnrollmentsCountGetData,
  GetAgencyEnrollmentCountClinicsEnrollmentsCountGetResponses,
  GetAgencyEnrollmentsClinicsEnrollmentsGetData,
  GetAgencyEnrollmentsClinicsEnrollmentsGetResponses,
  GetAgencyInsurancesClinicsInsuranceGetData,
  GetAgencyInsurancesClinicsInsuranceGetErrors,
  GetAgencyInsurancesClinicsInsuranceGetResponses,
  GetAgencyMembersUsersAgencyMembersGetData,
  GetAgencyMembersUsersAgencyMembersGetErrors,
  GetAgencyMembersUsersAgencyMembersGetResponses,
  GetAgencyPayerEnrollmentsClinicsEnrollmentsPayersGetData,
  GetAgencyPayerEnrollmentsClinicsEnrollmentsPayersGetResponses,
  GetAgencySchedulingPointsSchedulingPointsAgencyGetData,
  GetAgencySchedulingPointsSchedulingPointsAgencyGetResponses,
  GetAllergyAllergiesAllergyIdGetData,
  GetAllergyAllergiesAllergyIdGetErrors,
  GetAllergyAllergiesAllergyIdGetResponses,
  GetAllProductUpdatesInternalToolsProductUpdatesAllGetData,
  GetAllProductUpdatesInternalToolsProductUpdatesAllGetErrors,
  GetAllProductUpdatesInternalToolsProductUpdatesAllGetResponses,
  GetAssignmentRbacRoleAssignmentsAssignmentIdGetData,
  GetAssignmentRbacRoleAssignmentsAssignmentIdGetErrors,
  GetAssignmentRbacRoleAssignmentsAssignmentIdGetResponses,
  GetAuthorizationErrorsEpisodesEpisodeIdAuthorizationsErrorsGetData,
  GetAuthorizationErrorsEpisodesEpisodeIdAuthorizationsErrorsGetErrors,
  GetAuthorizationErrorsEpisodesEpisodeIdAuthorizationsErrorsGetResponses,
  GetAuthorizationEvaluationEpisodesEpisodeIdAuthorizationsEvaluationGetData,
  GetAuthorizationEvaluationEpisodesEpisodeIdAuthorizationsEvaluationGetErrors,
  GetAuthorizationEvaluationEpisodesEpisodeIdAuthorizationsEvaluationGetResponses,
  GetAuthQueueEndpointIntakeAuthQueueGetData,
  GetAuthQueueEndpointIntakeAuthQueueGetErrors,
  GetAuthQueueEndpointIntakeAuthQueueGetResponses,
  GetAvailableCliniciansUserClinicsAvailableGetData,
  GetAvailableCliniciansUserClinicsAvailableGetErrors,
  GetAvailableCliniciansUserClinicsAvailableGetResponses,
  GetBillingClaimWorksheetBillingClaimsClaimIdWorksheetGetData,
  GetBillingClaimWorksheetBillingClaimsClaimIdWorksheetGetErrors,
  GetBillingClaimWorksheetBillingClaimsClaimIdWorksheetGetResponses,
  GetBillingCycleClaimTimelineBillingBillingCycleBillingCycleIdClaimTimelineGetData,
  GetBillingCycleClaimTimelineBillingBillingCycleBillingCycleIdClaimTimelineGetErrors,
  GetBillingCycleClaimTimelineBillingBillingCycleBillingCycleIdClaimTimelineGetResponses,
  GetBillingCycleCountForPatientApiBillingBillingCyclesCountGetData,
  GetBillingCycleCountForPatientApiBillingBillingCyclesCountGetErrors,
  GetBillingCycleCountForPatientApiBillingBillingCyclesCountGetResponses,
  GetBillingCycleEoePreviewApiBillingBillingCycleBillingCycleIdEoePreviewGetData,
  GetBillingCycleEoePreviewApiBillingBillingCycleBillingCycleIdEoePreviewGetErrors,
  GetBillingCycleEoePreviewApiBillingBillingCycleBillingCycleIdEoePreviewGetResponses,
  GetBillingCycleHippsPreviewApiBillingBillingCycleBillingCycleIdHippsPreviewGetData,
  GetBillingCycleHippsPreviewApiBillingBillingCycleBillingCycleIdHippsPreviewGetErrors,
  GetBillingCycleHippsPreviewApiBillingBillingCycleBillingCycleIdHippsPreviewGetResponses,
  GetBillingCycleNoteBillingBillingCycleNotesNoteIdGetData,
  GetBillingCycleNoteBillingBillingCycleNotesNoteIdGetErrors,
  GetBillingCycleNoteBillingBillingCycleNotesNoteIdGetResponses,
  GetBillingCyclePayerResponseBillingBillingCycleBillingCycleIdPayerResponseGetData,
  GetBillingCyclePayerResponseBillingBillingCycleBillingCycleIdPayerResponseGetErrors,
  GetBillingCyclePayerResponseBillingBillingCycleBillingCycleIdPayerResponseGetResponses,
  GetBillingCycleReadinessApiBillingBillingCycleBillingCycleIdReadinessGetData,
  GetBillingCycleReadinessApiBillingBillingCycleBillingCycleIdReadinessGetErrors,
  GetBillingCycleReadinessApiBillingBillingCycleBillingCycleIdReadinessGetResponses,
  GetBillingCycleReadinessDetailsData,
  GetBillingCycleReadinessDetailsErrors,
  GetBillingCycleReadinessDetailsResponses,
  GetBillingCycleRevenueEstimateApiBillingBillingCycleBillingCycleIdRevenueEstimateGetData,
  GetBillingCycleRevenueEstimateApiBillingBillingCycleBillingCycleIdRevenueEstimateGetErrors,
  GetBillingCycleRevenueEstimateApiBillingBillingCycleBillingCycleIdRevenueEstimateGetResponses,
  GetBillingCyclesMetaApiBillingBillingCyclesMetaGetData,
  GetBillingCyclesMetaApiBillingBillingCyclesMetaGetErrors,
  GetBillingCyclesMetaApiBillingBillingCyclesMetaGetResponses,
  GetBillingCycleVisitsAndSuppliesApiBillingBillingCycleBillingCycleIdVisitsAndSuppliesGetData,
  GetBillingCycleVisitsAndSuppliesApiBillingBillingCycleBillingCycleIdVisitsAndSuppliesGetErrors,
  GetBillingCycleVisitsAndSuppliesApiBillingBillingCycleBillingCycleIdVisitsAndSuppliesGetResponses,
  GetBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetGetData,
  GetBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetGetErrors,
  GetBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetGetResponses,
  GetBucketStatusS3BucketStatusGetData,
  GetBucketStatusS3BucketStatusGetResponses,
  GetBulkEnrollReviewClinicsEnrollmentsBulkGetData,
  GetBulkEnrollReviewClinicsEnrollmentsBulkGetErrors,
  GetBulkEnrollReviewClinicsEnrollmentsBulkGetResponses,
  GetCapturedPortfolioInternalKinnserHistoricalCapturesCaptureIdAdmissionsOrdinalPortfolioGetData,
  GetCapturedPortfolioInternalKinnserHistoricalCapturesCaptureIdAdmissionsOrdinalPortfolioGetErrors,
  GetCapturedPortfolioInternalKinnserHistoricalCapturesCaptureIdAdmissionsOrdinalPortfolioGetResponses,
  GetCaptureInternalKinnserHistoricalCapturesCaptureIdGetData,
  GetCaptureInternalKinnserHistoricalCapturesCaptureIdGetErrors,
  GetCaptureInternalKinnserHistoricalCapturesCaptureIdGetResponses,
  GetCarryoverPreviewVisitsVisitIdCarryoverPreviewGetData,
  GetCarryoverPreviewVisitsVisitIdCarryoverPreviewGetErrors,
  GetCarryoverPreviewVisitsVisitIdCarryoverPreviewGetResponses,
  GetCarryoverSourcesVisitsVisitIdCarryoverSourcesGetData,
  GetCarryoverSourcesVisitsVisitIdCarryoverSourcesGetErrors,
  GetCarryoverSourcesVisitsVisitIdCarryoverSourcesGetResponses,
  GetCensusReportClinicOptionsReportsCensusClinicOptionsGetData,
  GetCensusReportClinicOptionsReportsCensusClinicOptionsGetErrors,
  GetCensusReportClinicOptionsReportsCensusClinicOptionsGetResponses,
  GetCensusReportReportsCensusGetData,
  GetCensusReportReportsCensusGetErrors,
  GetCensusReportReportsCensusGetResponses,
  GetChannelByEpisodeChatChannelsByEpisodeEpisodeIdGetData,
  GetChannelByEpisodeChatChannelsByEpisodeEpisodeIdGetErrors,
  GetChannelByEpisodeChatChannelsByEpisodeEpisodeIdGetResponses,
  GetChannelChatChannelsChannelIdGetData,
  GetChannelChatChannelsChannelIdGetErrors,
  GetChannelChatChannelsChannelIdGetResponses,
  GetClinicSchedulingPointsSchedulingPointsClinicsClinicIdGetData,
  GetClinicSchedulingPointsSchedulingPointsClinicsClinicIdGetErrors,
  GetClinicSchedulingPointsSchedulingPointsClinicsClinicIdGetResponses,
  GetCms485PrefillPatientsPatientIdCms485PrefillGetData,
  GetCms485PrefillPatientsPatientIdCms485PrefillGetErrors,
  GetCms485PrefillPatientsPatientIdCms485PrefillGetResponses,
  GetCodingUploadUrlsRogerdocCodingUploadUrlsPostData,
  GetCodingUploadUrlsRogerdocCodingUploadUrlsPostErrors,
  GetCodingUploadUrlsRogerdocCodingUploadUrlsPostResponses,
  GetCurrentCtxInfoAuthMeGetData,
  GetCurrentCtxInfoAuthMeGetErrors,
  GetCurrentCtxInfoAuthMeGetResponses,
  GetCurrentEpisodePatientsPatientIdCurrentEpisodeGetData,
  GetCurrentEpisodePatientsPatientIdCurrentEpisodeGetErrors,
  GetCurrentEpisodePatientsPatientIdCurrentEpisodeGetResponses,
  GetCurrentFormSchemaVersionsRogerdocFormSchemasCurrentGetData,
  GetCurrentFormSchemaVersionsRogerdocFormSchemasCurrentGetErrors,
  GetCurrentFormSchemaVersionsRogerdocFormSchemasCurrentGetResponses,
  GetDashboardOnboardingData,
  GetDashboardOnboardingErrors,
  GetDashboardOnboardingResponses,
  GetDeletedPatientTasksPatientsPatientIdDeletedTasksGetData,
  GetDeletedPatientTasksPatientsPatientIdDeletedTasksGetErrors,
  GetDeletedPatientTasksPatientsPatientIdDeletedTasksGetResponses,
  GetDemoTeamDefaultDemoAgencySetupTeamDefaultGetData,
  GetDemoTeamDefaultDemoAgencySetupTeamDefaultGetResponses,
  GetDirectoryChatDirectoryGetData,
  GetDirectoryChatDirectoryGetErrors,
  GetDirectoryChatDirectoryGetResponses,
  GetDraftBillingCyclesApiBillingBillingCyclesDraftsPostData,
  GetDraftBillingCyclesApiBillingBillingCyclesDraftsPostErrors,
  GetDraftBillingCyclesApiBillingBillingCyclesDraftsPostResponses,
  GetEligibilityChecksEndpointEligibilityGetData,
  GetEligibilityChecksEndpointEligibilityGetErrors,
  GetEligibilityChecksEndpointEligibilityGetResponses,
  GetEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdGetData,
  GetEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdGetErrors,
  GetEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdGetResponses,
  GetEpisodeDetailsEndpointIntakeIntakeIdEpisodeDetailsGetData,
  GetEpisodeDetailsEndpointIntakeIntakeIdEpisodeDetailsGetErrors,
  GetEpisodeDetailsEndpointIntakeIntakeIdEpisodeDetailsGetResponses,
  GetEpisodeEpisodesEpisodeIdGetData,
  GetEpisodeEpisodesEpisodeIdGetErrors,
  GetEpisodeEpisodesEpisodeIdGetResponses,
  GetEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdGetData,
  GetEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdGetErrors,
  GetEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdGetResponses,
  GetEpisodeHhrgCostsBillingWorksheetEpisodeEpisodeIdHhrgCostsGetData,
  GetEpisodeHhrgCostsBillingWorksheetEpisodeEpisodeIdHhrgCostsGetErrors,
  GetEpisodeHhrgCostsBillingWorksheetEpisodeEpisodeIdHhrgCostsGetResponses,
  GetEpisodeHhrgPeriodsApiBillingWorksheetEpisodeEpisodeIdPeriodsGetData,
  GetEpisodeHhrgPeriodsApiBillingWorksheetEpisodeEpisodeIdPeriodsGetErrors,
  GetEpisodeHhrgPeriodsApiBillingWorksheetEpisodeEpisodeIdPeriodsGetResponses,
  GetEpisodeLupaData,
  GetEpisodeLupaErrors,
  GetEpisodeLupaResponses,
  GetEpisodeRevenueEstimateApiBillingWorksheetEpisodeEpisodeIdRevenueEstimateGetData,
  GetEpisodeRevenueEstimateApiBillingWorksheetEpisodeEpisodeIdRevenueEstimateGetErrors,
  GetEpisodeRevenueEstimateApiBillingWorksheetEpisodeEpisodeIdRevenueEstimateGetResponses,
  GetEpisodeTakeOverPlanData,
  GetEpisodeTakeOverPlanErrors,
  GetEpisodeTakeOverPlanResponses,
  GetEpisodeTakeOverUndoCheckData,
  GetEpisodeTakeOverUndoCheckErrors,
  GetEpisodeTakeOverUndoCheckResponses,
  GetEpisodeVitalsSummaryPatientsPatientIdEpisodesEpisodeIdVitalsSummaryGetData,
  GetEpisodeVitalsSummaryPatientsPatientIdEpisodesEpisodeIdVitalsSummaryGetErrors,
  GetEpisodeVitalsSummaryPatientsPatientIdEpisodesEpisodeIdVitalsSummaryGetResponses,
  GetEpisodeWorksheetEpisodesEpisodeIdWorksheetGetData,
  GetEpisodeWorksheetEpisodesEpisodeIdWorksheetGetErrors,
  GetEpisodeWorksheetEpisodesEpisodeIdWorksheetGetResponses,
  GetEsignatureCredentialStatusSigningCredentialGetData,
  GetEsignatureCredentialStatusSigningCredentialGetErrors,
  GetEsignatureCredentialStatusSigningCredentialGetResponses,
  GetExternalEmrCustodyFilterPatientsExternalEmrCustodyFilterGetData,
  GetExternalEmrCustodyFilterPatientsExternalEmrCustodyFilterGetResponses,
  GetExternalEmrImportReadinessPatientsExternalEmrImportReadinessGetData,
  GetExternalEmrImportReadinessPatientsExternalEmrImportReadinessGetResponses,
  GetExternalEmrSummaryPatientsExternalEmrSummaryGetData,
  GetExternalEmrSummaryPatientsExternalEmrSummaryGetErrors,
  GetExternalEmrSummaryPatientsExternalEmrSummaryGetResponses,
  GetFallLogPdfPatientsPatientIdFallLogsFallLogIdPdfGetData,
  GetFallLogPdfPatientsPatientIdFallLogsFallLogIdPdfGetErrors,
  GetFallLogPdfPatientsPatientIdFallLogsFallLogIdPdfGetResponses,
  GetFaxDocumentFaxDocumentsDocumentIdGetData,
  GetFaxDocumentFaxDocumentsDocumentIdGetErrors,
  GetFaxDocumentFaxDocumentsDocumentIdGetResponses,
  GetGoalOptionsForEpisodeGoalsEpisodeEpisodeIdOptionsGetData,
  GetGoalOptionsForEpisodeGoalsEpisodeEpisodeIdOptionsGetErrors,
  GetGoalOptionsForEpisodeGoalsEpisodeEpisodeIdOptionsGetResponses,
  GetGoalOptionsForVisitGoalsVisitVisitIdOptionsGetData,
  GetGoalOptionsForVisitGoalsVisitVisitIdOptionsGetErrors,
  GetGoalOptionsForVisitGoalsVisitVisitIdOptionsGetResponses,
  GetGoalsProgressValidationConfigData,
  GetGoalsProgressValidationConfigResponses,
  GetGoalsToContinueGoalsEpisodeEpisodeIdCarryForwardGetData,
  GetGoalsToContinueGoalsEpisodeEpisodeIdCarryForwardGetErrors,
  GetGoalsToContinueGoalsEpisodeEpisodeIdCarryForwardGetResponses,
  GetGoalTemplateByExternalIdInternalGoalsVisitVisitIdTemplateGoalExternalIdGetData,
  GetGoalTemplateByExternalIdInternalGoalsVisitVisitIdTemplateGoalExternalIdGetErrors,
  GetGoalTemplateByExternalIdInternalGoalsVisitVisitIdTemplateGoalExternalIdGetResponses,
  GetGoalTemplateGoalsVisitVisitIdTemplateGoalTemplateIdGetData,
  GetGoalTemplateGoalsVisitVisitIdTemplateGoalTemplateIdGetErrors,
  GetGoalTemplateGoalsVisitVisitIdTemplateGoalTemplateIdGetResponses,
  GetGoalTemplatesByExternalIdsInternalGoalsVisitVisitIdTemplateBatchPostData,
  GetGoalTemplatesByExternalIdsInternalGoalsVisitVisitIdTemplateBatchPostErrors,
  GetGoalTemplatesByExternalIdsInternalGoalsVisitVisitIdTemplateBatchPostResponses,
  GetGoalTemplatesForEpisodeGoalsEpisodeEpisodeIdTemplateBatchPostData,
  GetGoalTemplatesForEpisodeGoalsEpisodeEpisodeIdTemplateBatchPostErrors,
  GetGoalTemplatesForEpisodeGoalsEpisodeEpisodeIdTemplateBatchPostResponses,
  GetGoalTemplatesGoalsVisitVisitIdTemplateBatchPostData,
  GetGoalTemplatesGoalsVisitVisitIdTemplateBatchPostErrors,
  GetGoalTemplatesGoalsVisitVisitIdTemplateBatchPostResponses,
  GetGroupChatGroupsGroupIdGetData,
  GetGroupChatGroupsGroupIdGetErrors,
  GetGroupChatGroupsGroupIdGetResponses,
  GetHistoricalClaimCaptureData,
  GetHistoricalClaimCaptureErrors,
  GetHistoricalClaimCaptureResponses,
  GetImportedAllergyProfilePatientsPatientIdAllergyImportedGetData,
  GetImportedAllergyProfilePatientsPatientIdAllergyImportedGetErrors,
  GetImportedAllergyProfilePatientsPatientIdAllergyImportedGetResponses,
  GetImportedAllergySuggestionData,
  GetImportedAllergySuggestionErrors,
  GetImportedAllergySuggestionResponses,
  GetImportedMedicationLinesPatientsPatientIdMedicationsImportedGetData,
  GetImportedMedicationLinesPatientsPatientIdMedicationsImportedGetErrors,
  GetImportedMedicationLinesPatientsPatientIdMedicationsImportedGetResponses,
  GetImportedMedicationSuggestionData,
  GetImportedMedicationSuggestionErrors,
  GetImportedMedicationSuggestionResponses,
  GetImporterQueueImporterQueueGetData,
  GetImporterQueueImporterQueueGetErrors,
  GetImporterQueueImporterQueueGetResponses,
  GetImporterSettingsImporterSettingsGetData,
  GetImporterSettingsImporterSettingsGetResponses,
  GetImportTargetOptionsInternalInternalAgenciesAgencyIdImportTargetOptionsGetData,
  GetImportTargetOptionsInternalInternalAgenciesAgencyIdImportTargetOptionsGetErrors,
  GetImportTargetOptionsInternalInternalAgenciesAgencyIdImportTargetOptionsGetResponses,
  GetInboxChatInboxGetData,
  GetInboxChatInboxGetErrors,
  GetInboxChatInboxGetResponses,
  GetInfectionLogDetailPatientsPatientIdInfectionLogsInfectionLogIdGetData,
  GetInfectionLogDetailPatientsPatientIdInfectionLogsInfectionLogIdGetErrors,
  GetInfectionLogDetailPatientsPatientIdInfectionLogsInfectionLogIdGetResponses,
  GetInfectionLogPdfPatientsPatientIdInfectionLogsInfectionLogIdPdfGetData,
  GetInfectionLogPdfPatientsPatientIdInfectionLogsInfectionLogIdPdfGetErrors,
  GetInfectionLogPdfPatientsPatientIdInfectionLogsInfectionLogIdPdfGetResponses,
  GetInsuranceEligibilityOptionsReportsInsuranceEligibilityOptionsGetData,
  GetInsuranceEligibilityOptionsReportsInsuranceEligibilityOptionsGetResponses,
  GetInsuranceEligibilityReportReportsInsuranceEligibilityGetData,
  GetInsuranceEligibilityReportReportsInsuranceEligibilityGetErrors,
  GetInsuranceEligibilityReportReportsInsuranceEligibilityGetResponses,
  GetInsuranceVisitRateDefaultsClinicsInsuranceInsuranceIdRatesDefaultsGetData,
  GetInsuranceVisitRateDefaultsClinicsInsuranceInsuranceIdRatesDefaultsGetErrors,
  GetInsuranceVisitRateDefaultsClinicsInsuranceInsuranceIdRatesDefaultsGetResponses,
  GetInsuranceVisitRatesClinicsInsuranceInsuranceIdRatesGetData,
  GetInsuranceVisitRatesClinicsInsuranceInsuranceIdRatesGetErrors,
  GetInsuranceVisitRatesClinicsInsuranceInsuranceIdRatesGetResponses,
  GetIntakeDocumentsNameDictIntakeIntakeIdDocumentsNameDictGetData,
  GetIntakeDocumentsNameDictIntakeIntakeIdDocumentsNameDictGetErrors,
  GetIntakeDocumentsNameDictIntakeIntakeIdDocumentsNameDictGetResponses,
  GetIntakeDraftIntakeDraftsDraftIdGetData,
  GetIntakeDraftIntakeDraftsDraftIdGetErrors,
  GetIntakeDraftIntakeDraftsDraftIdGetResponses,
  GetIntakeEndpointIntakeIntakeIdGetData,
  GetIntakeEndpointIntakeIntakeIdGetErrors,
  GetIntakeEndpointIntakeIntakeIdGetResponses,
  GetIntakeExtractionPromptIntakeExtractionPromptGetData,
  GetIntakeExtractionPromptIntakeExtractionPromptGetResponses,
  GetIntakeFormSchemaIntakeFormSchemaGetData,
  GetIntakeFormSchemaIntakeFormSchemaGetResponses,
  GetIntakePatientTagsPatientTagsIntakesIntakeIdGetData,
  GetIntakePatientTagsPatientTagsIntakesIntakeIdGetErrors,
  GetIntakePatientTagsPatientTagsIntakesIntakeIdGetResponses,
  GetIntakeProcessingStatusIntakeIntakeIdProcessingStatusGetData,
  GetIntakeProcessingStatusIntakeIntakeIdProcessingStatusGetErrors,
  GetIntakeProcessingStatusIntakeIntakeIdProcessingStatusGetResponses,
  GetIntakesEndpointIntakeGetData,
  GetIntakesEndpointIntakeGetErrors,
  GetIntakesEndpointIntakeGetResponses,
  GetIntakesForAuthManagementAuthorizationGetData,
  GetIntakesForAuthManagementAuthorizationGetErrors,
  GetIntakesForAuthManagementAuthorizationGetResponses,
  GetInterventionOptionsForVisitGoalsVisitVisitIdInterventionOptionsGetData,
  GetInterventionOptionsForVisitGoalsVisitVisitIdInterventionOptionsGetErrors,
  GetInterventionOptionsForVisitGoalsVisitVisitIdInterventionOptionsGetResponses,
  GetInterventionsForPatientGoalGoalsVisitVisitIdInterventionPatientGoalIdGetData,
  GetInterventionsForPatientGoalGoalsVisitVisitIdInterventionPatientGoalIdGetErrors,
  GetInterventionsForPatientGoalGoalsVisitVisitIdInterventionPatientGoalIdGetResponses,
  GetInterventionTemplateByExternalIdInternalGoalsVisitInterventionInterventionExternalIdGetData,
  GetInterventionTemplateByExternalIdInternalGoalsVisitInterventionInterventionExternalIdGetErrors,
  GetInterventionTemplateByExternalIdInternalGoalsVisitInterventionInterventionExternalIdGetResponses,
  GetInterventionTemplateGoalsVisitInterventionInterventionTemplateIdGetData,
  GetInterventionTemplateGoalsVisitInterventionInterventionTemplateIdGetErrors,
  GetInterventionTemplateGoalsVisitInterventionInterventionTemplateIdGetResponses,
  GetKinnserClinicDataKinnserClinicsClinicIdGetData,
  GetKinnserClinicDataKinnserClinicsClinicIdGetErrors,
  GetKinnserClinicDataKinnserClinicsClinicIdGetResponses,
  GetKinnserClinicsKinnserClinicsGetData,
  GetKinnserClinicsKinnserClinicsGetResponses,
  GetKinnserFieldRulesInternalToolsKinnserAgencySyncFieldRulesGetData,
  GetKinnserFieldRulesInternalToolsKinnserAgencySyncFieldRulesGetErrors,
  GetKinnserFieldRulesInternalToolsKinnserAgencySyncFieldRulesGetResponses,
  GetKinnserImportAttemptsInternalKinnserImportWorkflowWorkflowIdAttemptsGetData,
  GetKinnserImportAttemptsInternalKinnserImportWorkflowWorkflowIdAttemptsGetErrors,
  GetKinnserImportAttemptsInternalKinnserImportWorkflowWorkflowIdAttemptsGetResponses,
  GetKinnserImportWorkflowStatusInternalKinnserImportWorkflowWorkflowIdGetData,
  GetKinnserImportWorkflowStatusInternalKinnserImportWorkflowWorkflowIdGetErrors,
  GetKinnserImportWorkflowStatusInternalKinnserImportWorkflowWorkflowIdGetResponses,
  GetKinnserRescrapeStatusForDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdRescrapeKinnserGetData,
  GetKinnserRescrapeStatusForDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdRescrapeKinnserGetErrors,
  GetKinnserRescrapeStatusForDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdRescrapeKinnserGetResponses,
  GetKinnserSyncStatusInternalToolsKinnserAgencySyncAgenciesAgencyIdGetData,
  GetKinnserSyncStatusInternalToolsKinnserAgencySyncAgenciesAgencyIdGetErrors,
  GetKinnserSyncStatusInternalToolsKinnserAgencySyncAgenciesAgencyIdGetResponses,
  GetKinnserUploadStatusIntakeIntakeIdKinnserUploadStatusGetData,
  GetKinnserUploadStatusIntakeIntakeIdKinnserUploadStatusGetErrors,
  GetKinnserUploadStatusIntakeIntakeIdKinnserUploadStatusGetResponses,
  GetLateStartsOptionsReportsLateStartsOptionsGetData,
  GetLateStartsOptionsReportsLateStartsOptionsGetResponses,
  GetLateStartsReportReportsLateStartsGetData,
  GetLateStartsReportReportsLateStartsGetErrors,
  GetLateStartsReportReportsLateStartsGetResponses,
  GetLoaSigningFaxNumberPortsPortOrderIdLoaSigningGetData,
  GetLoaSigningFaxNumberPortsPortOrderIdLoaSigningGetErrors,
  GetLoaSigningFaxNumberPortsPortOrderIdLoaSigningGetResponses,
  GetLoaTemplateFaxNumberPortsPortOrderIdLoaTemplateGetData,
  GetLoaTemplateFaxNumberPortsPortOrderIdLoaTemplateGetErrors,
  GetLoaTemplateFaxNumberPortsPortOrderIdLoaTemplateGetResponses,
  GetLupaRiskOptionsReportsLupaRiskClinicOptionsGetData,
  GetLupaRiskOptionsReportsLupaRiskClinicOptionsGetErrors,
  GetLupaRiskOptionsReportsLupaRiskClinicOptionsGetResponses,
  GetLupaRiskReportReportsLupaRiskGetData,
  GetLupaRiskReportReportsLupaRiskGetErrors,
  GetLupaRiskReportReportsLupaRiskGetResponses,
  GetMarketingReportOptionsReportsMarketingOptionsGetData,
  GetMarketingReportOptionsReportsMarketingOptionsGetErrors,
  GetMarketingReportOptionsReportsMarketingOptionsGetResponses,
  GetMarketingReportReportsMarketingGetData,
  GetMarketingReportReportsMarketingGetErrors,
  GetMarketingReportReportsMarketingGetResponses,
  GetMedicationAttachmentUrlPatientsPatientIdMedicationsAttachmentsAttachmentIdUrlGetData,
  GetMedicationAttachmentUrlPatientsPatientIdMedicationsAttachmentsAttachmentIdUrlGetErrors,
  GetMedicationAttachmentUrlPatientsPatientIdMedicationsAttachmentsAttachmentIdUrlGetResponses,
  GetMedicationCatalogVersionInternalMedicationsCatalogVersionGetData,
  GetMedicationCatalogVersionInternalMedicationsCatalogVersionGetErrors,
  GetMedicationCatalogVersionInternalMedicationsCatalogVersionGetResponses,
  GetMedicationEndpointMedicationsMedicationIdGetData,
  GetMedicationEndpointMedicationsMedicationIdGetErrors,
  GetMedicationEndpointMedicationsMedicationIdGetResponses,
  GetMedicationOrderLaunchValidationData,
  GetMedicationOrderLaunchValidationErrors,
  GetMedicationOrderLaunchValidationResponses,
  GetMedicationPdfInternalPatientsPatientIdMedicationsPdfPostData,
  GetMedicationPdfInternalPatientsPatientIdMedicationsPdfPostErrors,
  GetMedicationPdfInternalPatientsPatientIdMedicationsPdfPostResponses,
  GetMedicationPdfPatientsPatientIdMedicationsPdfPostData,
  GetMedicationPdfPatientsPatientIdMedicationsPdfPostErrors,
  GetMedicationPdfPatientsPatientIdMedicationsPdfPostResponses,
  GetMedicationProfileAttachmentsPatientsPatientIdMedicationsAttachmentsGetData,
  GetMedicationProfileAttachmentsPatientsPatientIdMedicationsAttachmentsGetErrors,
  GetMedicationProfileAttachmentsPatientsPatientIdMedicationsAttachmentsGetResponses,
  GetMessagesChatChannelsChannelIdMessagesGetData,
  GetMessagesChatChannelsChannelIdMessagesGetErrors,
  GetMessagesChatChannelsChannelIdMessagesGetResponses,
  GetMiscTaskMiscTasksMiscTaskIdGetData,
  GetMiscTaskMiscTasksMiscTaskIdGetErrors,
  GetMiscTaskMiscTasksMiscTaskIdGetResponses,
  GetMiscTaskWorkLogMiscTasksMiscTaskIdWorkLogGetData,
  GetMiscTaskWorkLogMiscTasksMiscTaskIdWorkLogGetErrors,
  GetMiscTaskWorkLogMiscTasksMiscTaskIdWorkLogGetResponses,
  GetMissedVisitOptionsInternalInternalVisitsVisitIdMissedVisitOptionsGetData,
  GetMissedVisitOptionsInternalInternalVisitsVisitIdMissedVisitOptionsGetErrors,
  GetMissedVisitOptionsInternalInternalVisitsVisitIdMissedVisitOptionsGetResponses,
  GetMissedVisitOptionsVisitsMissedVisitOptionsGetData,
  GetMissedVisitOptionsVisitsMissedVisitOptionsGetResponses,
  GetMyTasksPdxOptionsTasksMyTasksPdxOptionsGetData,
  GetMyTasksPdxOptionsTasksMyTasksPdxOptionsGetErrors,
  GetMyTasksPdxOptionsTasksMyTasksPdxOptionsGetResponses,
  GetMyTasksTasksMyTasksGetData,
  GetMyTasksTasksMyTasksGetErrors,
  GetMyTasksTasksMyTasksGetResponses,
  GetMyTasksTypeOptionsTasksMyTasksTypeOptionsGetData,
  GetMyTasksTypeOptionsTasksMyTasksTypeOptionsGetErrors,
  GetMyTasksTypeOptionsTasksMyTasksTypeOptionsGetResponses,
  GetMyTasksVisitsMyTasksGetData,
  GetMyTasksVisitsMyTasksGetErrors,
  GetMyTasksVisitsMyTasksGetResponses,
  GetNextActiveEpisodeEpisodesEpisodeIdNextActiveGetData,
  GetNextActiveEpisodeEpisodesEpisodeIdNextActiveGetErrors,
  GetNextActiveEpisodeEpisodesEpisodeIdNextActiveGetResponses,
  GetNoa837iNoasNoaId837iGetData,
  GetNoa837iNoasNoaId837iGetErrors,
  GetNoa837iNoasNoaId837iGetResponses,
  GetNoaNoasNoaIdGetData,
  GetNoaNoasNoaIdGetErrors,
  GetNoaNoasNoaIdGetResponses,
  GetNoaPayerResponseNoasNoaIdPayerResponseGetData,
  GetNoaPayerResponseNoasNoaIdPayerResponseGetErrors,
  GetNoaPayerResponseNoasNoaIdPayerResponseGetResponses,
  GetNoaStatusCountsNoasStatusCountsGetData,
  GetNoaStatusCountsNoasStatusCountsGetErrors,
  GetNoaStatusCountsNoasStatusCountsGetResponses,
  GetNoaUb04PdfNoasNoaIdUb04GetData,
  GetNoaUb04PdfNoasNoaIdUb04GetErrors,
  GetNoaUb04PdfNoasNoaIdUb04GetResponses,
  GetNoaWorkLogNoasNoaIdWorkLogGetData,
  GetNoaWorkLogNoasNoaIdWorkLogGetErrors,
  GetNoaWorkLogNoasNoaIdWorkLogGetResponses,
  GetOasisExportReadinessVisitsOasisManagerExportReadinessPostData,
  GetOasisExportReadinessVisitsOasisManagerExportReadinessPostErrors,
  GetOasisExportReadinessVisitsOasisManagerExportReadinessPostResponses,
  GetOasisShpLastCheckVisitsOasisManagerVisitIdShpCheckGetData,
  GetOasisShpLastCheckVisitsOasisManagerVisitIdShpCheckGetErrors,
  GetOasisShpLastCheckVisitsOasisManagerVisitIdShpCheckGetResponses,
  GetOnboardingTeamConfigInternalToolsOnboardingTeamConfigGetData,
  GetOnboardingTeamConfigInternalToolsOnboardingTeamConfigGetErrors,
  GetOnboardingTeamConfigInternalToolsOnboardingTeamConfigGetResponses,
  GetOnboardPatientStatusKinnserPatientOnboardStatusIntakeIdGetData,
  GetOnboardPatientStatusKinnserPatientOnboardStatusIntakeIdGetErrors,
  GetOnboardPatientStatusKinnserPatientOnboardStatusIntakeIdGetResponses,
  GetOpenOasisReportOptionsReportsOpenOasisOptionsGetData,
  GetOpenOasisReportOptionsReportsOpenOasisOptionsGetErrors,
  GetOpenOasisReportOptionsReportsOpenOasisOptionsGetResponses,
  GetOpenOasisReportReportsOpenOasisGetData,
  GetOpenOasisReportReportsOpenOasisGetErrors,
  GetOpenOasisReportReportsOpenOasisGetResponses,
  GetOrderCms485FormOrdersOrderIdCms485FormGetData,
  GetOrderCms485FormOrdersOrderIdCms485FormGetErrors,
  GetOrderCms485FormOrdersOrderIdCms485FormGetResponses,
  GetOrderCms485PrefillOrdersOrderIdCms485PrefillGetData,
  GetOrderCms485PrefillOrdersOrderIdCms485PrefillGetErrors,
  GetOrderCms485PrefillOrdersOrderIdCms485PrefillGetResponses,
  GetOrderManagerCountsOrdersManagerCountsGetData,
  GetOrderManagerCountsOrdersManagerCountsGetErrors,
  GetOrderManagerCountsOrdersManagerCountsGetResponses,
  GetOrderManagerFilterOptionsOrdersManagerOptionsGetData,
  GetOrderManagerFilterOptionsOrdersManagerOptionsGetErrors,
  GetOrderManagerFilterOptionsOrdersManagerOptionsGetResponses,
  GetOrderManagerItemsOrdersManagerGetData,
  GetOrderManagerItemsOrdersManagerGetErrors,
  GetOrderManagerItemsOrdersManagerGetResponses,
  GetOrderOrdersOrderIdGetData,
  GetOrderOrdersOrderIdGetErrors,
  GetOrderOrdersOrderIdGetResponses,
  GetOrderPdfOrdersOrderIdPdfGetData,
  GetOrderPdfOrdersOrderIdPdfGetErrors,
  GetOrderPdfOrdersOrderIdPdfGetResponses,
  GetOrderPdfRevisionOrdersOrderIdPdfRevisionGetData,
  GetOrderPdfRevisionOrdersOrderIdPdfRevisionGetErrors,
  GetOrderPdfRevisionOrdersOrderIdPdfRevisionGetResponses,
  GetOrderPhoPrefillOrdersOrderIdPhoPrefillGetData,
  GetOrderPhoPrefillOrdersOrderIdPhoPrefillGetErrors,
  GetOrderPhoPrefillOrdersOrderIdPhoPrefillGetResponses,
  GetOrderTypeOptionsOrdersTypeOptionsGetData,
  GetOrderTypeOptionsOrdersTypeOptionsGetResponses,
  GetOrderWorkLogOrdersOrderIdWorkLogGetData,
  GetOrderWorkLogOrdersOrderIdWorkLogGetErrors,
  GetOrderWorkLogOrdersOrderIdWorkLogGetResponses,
  GetPastDueVisitsReportOptionsReportsPastDueVisitsOptionsGetData,
  GetPastDueVisitsReportOptionsReportsPastDueVisitsOptionsGetErrors,
  GetPastDueVisitsReportOptionsReportsPastDueVisitsOptionsGetResponses,
  GetPastDueVisitsReportReportsPastDueVisitsGetData,
  GetPastDueVisitsReportReportsPastDueVisitsGetErrors,
  GetPastDueVisitsReportReportsPastDueVisitsGetResponses,
  GetPatientAllergiesPatientsPatientIdAllergyGetData,
  GetPatientAllergiesPatientsPatientIdAllergyGetErrors,
  GetPatientAllergiesPatientsPatientIdAllergyGetResponses,
  GetPatientChartImportReportPatientsPatientIdChartImportsRunIdReportGetData,
  GetPatientChartImportReportPatientsPatientIdChartImportsRunIdReportGetErrors,
  GetPatientChartImportReportPatientsPatientIdChartImportsRunIdReportGetResponses,
  GetPatientCommunicationPatientCommunicationsCommunicationIdGetData,
  GetPatientCommunicationPatientCommunicationsCommunicationIdGetErrors,
  GetPatientCommunicationPatientCommunicationsCommunicationIdGetResponses,
  GetPatientCommunicationPdfPatientCommunicationsCommunicationIdPdfGetData,
  GetPatientCommunicationPdfPatientCommunicationsCommunicationIdPdfGetErrors,
  GetPatientCommunicationPdfPatientCommunicationsCommunicationIdPdfGetResponses,
  GetPatientCommunicationPdfRevisionPatientCommunicationsCommunicationIdPdfRevisionGetData,
  GetPatientCommunicationPdfRevisionPatientCommunicationsCommunicationIdPdfRevisionGetErrors,
  GetPatientCommunicationPdfRevisionPatientCommunicationsCommunicationIdPdfRevisionGetResponses,
  GetPatientCommunicationWorkLogPatientCommunicationsCommunicationIdWorkLogGetData,
  GetPatientCommunicationWorkLogPatientCommunicationsCommunicationIdWorkLogGetErrors,
  GetPatientCommunicationWorkLogPatientCommunicationsCommunicationIdWorkLogGetResponses,
  GetPatientCountPatientsCountGetData,
  GetPatientCountPatientsCountGetErrors,
  GetPatientCountPatientsCountGetResponses,
  GetPatientDiagnosesReportClinicOptionsReportsPatientDiagnosesClinicOptionsGetData,
  GetPatientDiagnosesReportClinicOptionsReportsPatientDiagnosesClinicOptionsGetErrors,
  GetPatientDiagnosesReportClinicOptionsReportsPatientDiagnosesClinicOptionsGetResponses,
  GetPatientDiagnosesReportReportsPatientDiagnosesGetData,
  GetPatientDiagnosesReportReportsPatientDiagnosesGetErrors,
  GetPatientDiagnosesReportReportsPatientDiagnosesGetResponses,
  GetPatientDocumentsInternalInternalPatientsPatientIdDocumentsGetData,
  GetPatientDocumentsInternalInternalPatientsPatientIdDocumentsGetErrors,
  GetPatientDocumentsInternalInternalPatientsPatientIdDocumentsGetResponses,
  GetPatientDocumentsPatientsPatientIdDocumentsGetData,
  GetPatientDocumentsPatientsPatientIdDocumentsGetErrors,
  GetPatientDocumentsPatientsPatientIdDocumentsGetResponses,
  GetPatientDocumentUrlInternalInternalPatientsPatientIdDocumentsDocumentIdUrlGetData,
  GetPatientDocumentUrlInternalInternalPatientsPatientIdDocumentsDocumentIdUrlGetErrors,
  GetPatientDocumentUrlInternalInternalPatientsPatientIdDocumentsDocumentIdUrlGetResponses,
  GetPatientDocumentUrlPatientsPatientIdDocumentsDocumentIdUrlGetData,
  GetPatientDocumentUrlPatientsPatientIdDocumentsDocumentIdUrlGetErrors,
  GetPatientDocumentUrlPatientsPatientIdDocumentsDocumentIdUrlGetResponses,
  GetPatientEligibilityProblemsEligibilityPatientPatientIdProblemsGetData,
  GetPatientEligibilityProblemsEligibilityPatientPatientIdProblemsGetErrors,
  GetPatientEligibilityProblemsEligibilityPatientPatientIdProblemsGetResponses,
  GetPatientExternalEmrImportPatientsPatientIdExternalEmrImportGetData,
  GetPatientExternalEmrImportPatientsPatientIdExternalEmrImportGetErrors,
  GetPatientExternalEmrImportPatientsPatientIdExternalEmrImportGetResponses,
  GetPatientExternalOrderRendersPatientsPatientIdExternalOrderRendersGetData,
  GetPatientExternalOrderRendersPatientsPatientIdExternalOrderRendersGetErrors,
  GetPatientExternalOrderRendersPatientsPatientIdExternalOrderRendersGetResponses,
  GetPatientGeographicValueCodesApiBillingPatientPatientIdGeographicValueCodesGetData,
  GetPatientGeographicValueCodesApiBillingPatientPatientIdGeographicValueCodesGetErrors,
  GetPatientGeographicValueCodesApiBillingPatientPatientIdGeographicValueCodesGetResponses,
  GetPatientGoalForVisitGoalsVisitVisitIdGoalPatientGoalIdGetData,
  GetPatientGoalForVisitGoalsVisitVisitIdGoalPatientGoalIdGetErrors,
  GetPatientGoalForVisitGoalsVisitVisitIdGoalPatientGoalIdGetResponses,
  GetPatientGoalsForVisitGoalsVisitVisitIdGetData,
  GetPatientGoalsForVisitGoalsVisitVisitIdGetErrors,
  GetPatientGoalsForVisitGoalsVisitVisitIdGetResponses,
  GetPatientGoalsForVisitInternalGoalsVisitVisitIdGetData,
  GetPatientGoalsForVisitInternalGoalsVisitVisitIdGetErrors,
  GetPatientGoalsForVisitInternalGoalsVisitVisitIdGetResponses,
  GetPatientInsurancePatientsPatientIdInsurancePatientInsuranceIdGetData,
  GetPatientInsurancePatientsPatientIdInsurancePatientInsuranceIdGetErrors,
  GetPatientInsurancePatientsPatientIdInsurancePatientInsuranceIdGetResponses,
  GetPatientMedicationInternalPatientsPatientIdMedicationsMedicationIdGetData,
  GetPatientMedicationInternalPatientsPatientIdMedicationsMedicationIdGetErrors,
  GetPatientMedicationInternalPatientsPatientIdMedicationsMedicationIdGetResponses,
  GetPatientMedicationPatientsPatientIdMedicationsMedicationIdGetData,
  GetPatientMedicationPatientsPatientIdMedicationsMedicationIdGetErrors,
  GetPatientMedicationPatientsPatientIdMedicationsMedicationIdGetResponses,
  GetPatientMedicationsInternalPatientsPatientIdMedicationsGetData,
  GetPatientMedicationsInternalPatientsPatientIdMedicationsGetErrors,
  GetPatientMedicationsInternalPatientsPatientIdMedicationsGetResponses,
  GetPatientMedicationsPatientsPatientIdMedicationsGetData,
  GetPatientMedicationsPatientsPatientIdMedicationsGetErrors,
  GetPatientMedicationsPatientsPatientIdMedicationsGetResponses,
  GetPatientPatientsPatientIdGetData,
  GetPatientPatientsPatientIdGetErrors,
  GetPatientPatientsPatientIdGetResponses,
  GetPatientPharmacyPatientsPatientIdPharmacyGetData,
  GetPatientPharmacyPatientsPatientIdPharmacyGetErrors,
  GetPatientPharmacyPatientsPatientIdPharmacyGetResponses,
  GetPatientRosterClinicOptionsReportsPatientRosterClinicOptionsGetData,
  GetPatientRosterClinicOptionsReportsPatientRosterClinicOptionsGetResponses,
  GetPatientRosterReportReportsPatientRosterGetData,
  GetPatientRosterReportReportsPatientRosterGetErrors,
  GetPatientRosterReportReportsPatientRosterGetResponses,
  GetPatientsPatientsGetData,
  GetPatientsPatientsGetErrors,
  GetPatientsPatientsGetResponses,
  GetPatientSyncReviewPatientsPatientIdChartImportsSyncReviewGetData,
  GetPatientSyncReviewPatientsPatientIdChartImportsSyncReviewGetErrors,
  GetPatientSyncReviewPatientsPatientIdChartImportsSyncReviewGetResponses,
  GetPatientTagsPatientTagsPatientsPatientIdGetData,
  GetPatientTagsPatientTagsPatientsPatientIdGetErrors,
  GetPatientTagsPatientTagsPatientsPatientIdGetResponses,
  GetPatientTasksPatientsPatientIdTasksGetData,
  GetPatientTasksPatientsPatientIdTasksGetErrors,
  GetPatientTasksPatientsPatientIdTasksGetResponses,
  GetPatientVisitsPatientsPatientIdVisitsGetData,
  GetPatientVisitsPatientsPatientIdVisitsGetErrors,
  GetPatientVisitsPatientsPatientIdVisitsGetResponses,
  GetPatientWoundsPatientsPatientIdWoundsGetData,
  GetPatientWoundsPatientsPatientIdWoundsGetErrors,
  GetPatientWoundsPatientsPatientIdWoundsGetResponses,
  GetPatientWoundVisitActivityPatientsPatientIdWoundsVisitActivityGetData,
  GetPatientWoundVisitActivityPatientsPatientIdWoundsVisitActivityGetErrors,
  GetPatientWoundVisitActivityPatientsPatientIdWoundsVisitActivityGetResponses,
  GetPayorByClearinghouseIdEndpointPayorsByClearinghouseIdClearinghousePayorIdGetData,
  GetPayorByClearinghouseIdEndpointPayorsByClearinghouseIdClearinghousePayorIdGetErrors,
  GetPayorByClearinghouseIdEndpointPayorsByClearinghouseIdClearinghousePayorIdGetResponses,
  GetPayorByElectronicIdEndpointPayorsByElectronicIdElectronicPayorIdGetData,
  GetPayorByElectronicIdEndpointPayorsByElectronicIdElectronicPayorIdGetErrors,
  GetPayorByElectronicIdEndpointPayorsByElectronicIdElectronicPayorIdGetResponses,
  GetPayorByNameEndpointPayorsByNamePayorNameGetData,
  GetPayorByNameEndpointPayorsByNamePayorNameGetErrors,
  GetPayorByNameEndpointPayorsByNamePayorNameGetResponses,
  GetPayorEndpointPayorsPayorIdGetData,
  GetPayorEndpointPayorsPayorIdGetErrors,
  GetPayorEndpointPayorsPayorIdGetResponses,
  GetPayorNoaSettingsHistoryInternalToolsPayorsPayorIdNoaSettingsHistoryGetData,
  GetPayorNoaSettingsHistoryInternalToolsPayorsPayorIdNoaSettingsHistoryGetErrors,
  GetPayorNoaSettingsHistoryInternalToolsPayorsPayorIdNoaSettingsHistoryGetResponses,
  GetPayorsEndpointPayorsGetData,
  GetPayorsEndpointPayorsGetResponses,
  GetPayrollSettingsPayrollSettingsGetData,
  GetPayrollSettingsPayrollSettingsGetResponses,
  GetPcrReportReportsPcrGetData,
  GetPcrReportReportsPcrGetErrors,
  GetPcrReportReportsPcrGetResponses,
  GetPermissionRbacPermissionsPermissionIdGetData,
  GetPermissionRbacPermissionsPermissionIdGetErrors,
  GetPermissionRbacPermissionsPermissionIdGetResponses,
  GetPortOrderFaxNumberPortsPortOrderIdGetData,
  GetPortOrderFaxNumberPortsPortOrderIdGetErrors,
  GetPortOrderFaxNumberPortsPortOrderIdGetResponses,
  GetPrintViewForGoalsGoalsVisitPrintViewVisitIdPrintViewGetData,
  GetPrintViewForGoalsGoalsVisitPrintViewVisitIdPrintViewGetErrors,
  GetPrintViewForGoalsGoalsVisitPrintViewVisitIdPrintViewGetResponses,
  GetProductUpdatesForUserProductUpdatesGetData,
  GetProductUpdatesForUserProductUpdatesGetResponses,
  GetQuestionCustomizationsData,
  GetQuestionCustomizationsResponses,
  GetQuestionSchemaRogerdocQuestionSchemaGetData,
  GetQuestionSchemaRogerdocQuestionSchemaGetErrors,
  GetQuestionSchemaRogerdocQuestionSchemaGetResponses,
  GetReceivedFaxReceivedFaxesFaxIdGetData,
  GetReceivedFaxReceivedFaxesFaxIdGetErrors,
  GetReceivedFaxReceivedFaxesFaxIdGetResponses,
  GetRecertificationTimingOptionsReportsRecertificationTimingOptionsGetData,
  GetRecertificationTimingOptionsReportsRecertificationTimingOptionsGetResponses,
  GetRecertificationTimingReportReportsRecertificationTimingGetData,
  GetRecertificationTimingReportReportsRecertificationTimingGetErrors,
  GetRecertificationTimingReportReportsRecertificationTimingGetResponses,
  GetReferralDocPresignedUrlIntakeIntakeIdReferralDocGetData,
  GetReferralDocPresignedUrlIntakeIntakeIdReferralDocGetErrors,
  GetReferralDocPresignedUrlIntakeIntakeIdReferralDocGetResponses,
  GetReferralDocsPresignedUrlsIntakeIntakeIdReferralDocsGetData,
  GetReferralDocsPresignedUrlsIntakeIntakeIdReferralDocsGetErrors,
  GetReferralDocsPresignedUrlsIntakeIntakeIdReferralDocsGetResponses,
  GetRefreshBillingCyclesStatusBillingRefreshBillingCyclesWorkflowIdStatusGetData,
  GetRefreshBillingCyclesStatusBillingRefreshBillingCyclesWorkflowIdStatusGetErrors,
  GetRefreshBillingCyclesStatusBillingRefreshBillingCyclesWorkflowIdStatusGetResponses,
  GetRehospitalizationClinicOptionsReportsRehospitalizationClinicOptionsGetData,
  GetRehospitalizationClinicOptionsReportsRehospitalizationClinicOptionsGetResponses,
  GetRehospitalizationReportReportsRehospitalizationGetData,
  GetRehospitalizationReportReportsRehospitalizationGetErrors,
  GetRehospitalizationReportReportsRehospitalizationGetResponses,
  GetRemittanceDetailRemittancesRemittanceIdGetData,
  GetRemittanceDetailRemittancesRemittanceIdGetErrors,
  GetRemittanceDetailRemittancesRemittanceIdGetResponses,
  GetRemittanceStatusCountsRemittancesStatusCountsGetData,
  GetRemittanceStatusCountsRemittancesStatusCountsGetErrors,
  GetRemittanceStatusCountsRemittancesStatusCountsGetResponses,
  GetReportingExtractReportingExtractsDatasetKeyGetData,
  GetReportingExtractReportingExtractsDatasetKeyGetErrors,
  GetReportingExtractReportingExtractsDatasetKeyGetResponses,
  GetReportingManifestReportingManifestGetData,
  GetReportingManifestReportingManifestGetResponses,
  GetReturnedFaxOrdersOrderIdReturnedFaxGetData,
  GetReturnedFaxOrdersOrderIdReturnedFaxGetErrors,
  GetReturnedFaxOrdersOrderIdReturnedFaxGetResponses,
  GetReturnedFaxPageOrdersOrderIdReturnedFaxPagesIndexGetData,
  GetReturnedFaxPageOrdersOrderIdReturnedFaxPagesIndexGetErrors,
  GetReturnedFaxPageOrdersOrderIdReturnedFaxPagesIndexGetResponses,
  GetRogerDocFormTypeCatalogRogerdocFormTypeCatalogGetData,
  GetRogerDocFormTypeCatalogRogerdocFormTypeCatalogGetResponses,
  GetRoleRbacRolesRoleIdGetData,
  GetRoleRbacRolesRoleIdGetErrors,
  GetRoleRbacRolesRoleIdGetResponses,
  GetScheduleDeviationReportOptionsReportsScheduleDeviationOptionsGetData,
  GetScheduleDeviationReportOptionsReportsScheduleDeviationOptionsGetErrors,
  GetScheduleDeviationReportOptionsReportsScheduleDeviationOptionsGetResponses,
  GetScheduleDeviationReportReportsScheduleDeviationGetData,
  GetScheduleDeviationReportReportsScheduleDeviationGetErrors,
  GetScheduleDeviationReportReportsScheduleDeviationGetResponses,
  GetScheduleReportOptionsReportsScheduleOptionsGetData,
  GetScheduleReportOptionsReportsScheduleOptionsGetErrors,
  GetScheduleReportOptionsReportsScheduleOptionsGetResponses,
  GetScheduleReportReportsScheduleGetData,
  GetScheduleReportReportsScheduleGetErrors,
  GetScheduleReportReportsScheduleGetResponses,
  GetSchedulingPointLoadSchedulingPointsLoadGetData,
  GetSchedulingPointLoadSchedulingPointsLoadGetErrors,
  GetSchedulingPointLoadSchedulingPointsLoadGetResponses,
  GetShpOasisBatchStageDevTestDataShpOasisBatchGetData,
  GetShpOasisBatchStageDevTestDataShpOasisBatchGetResponses,
  GetSignatureBypassOptionsTasksSignatureBypassOptionsGetData,
  GetSignatureBypassOptionsTasksSignatureBypassOptionsGetResponses,
  GetSimulatedOrderFaxPdfInternalToolsSimulatedOrderFaxesStoredIdPdfGetData,
  GetSimulatedOrderFaxPdfInternalToolsSimulatedOrderFaxesStoredIdPdfGetErrors,
  GetSimulatedOrderFaxPdfInternalToolsSimulatedOrderFaxesStoredIdPdfGetResponses,
  GetStediClaimUb04PdfStediClaimsClaimIdUb04GetData,
  GetStediClaimUb04PdfStediClaimsClaimIdUb04GetErrors,
  GetStediClaimUb04PdfStediClaimsClaimIdUb04GetResponses,
  GetSyncGoalsForAgencyWorkflowStatusGoalsDashboardSyncGoalsForAgencyStatusGetData,
  GetSyncGoalsForAgencyWorkflowStatusGoalsDashboardSyncGoalsForAgencyStatusGetErrors,
  GetSyncGoalsForAgencyWorkflowStatusGoalsDashboardSyncGoalsForAgencyStatusGetResponses,
  GetTaskDetailsTasksTaskIdDetailsGetData,
  GetTaskDetailsTasksTaskIdDetailsGetErrors,
  GetTaskDetailsTasksTaskIdDetailsGetResponses,
  GetTaskDocumentsTasksTaskIdDocumentsGetData,
  GetTaskDocumentsTasksTaskIdDocumentsGetErrors,
  GetTaskDocumentsTasksTaskIdDocumentsGetResponses,
  GetTaskDocumentUrlTasksTaskIdDocumentsDocumentIdUrlGetData,
  GetTaskDocumentUrlTasksTaskIdDocumentsDocumentIdUrlGetErrors,
  GetTaskDocumentUrlTasksTaskIdDocumentsDocumentIdUrlGetResponses,
  GetTaskOutsideRecordEndpointTasksTaskIdOutsideRecordGetData,
  GetTaskOutsideRecordEndpointTasksTaskIdOutsideRecordGetErrors,
  GetTaskOutsideRecordEndpointTasksTaskIdOutsideRecordGetResponses,
  GetTaskSignaturesTasksTaskIdSignaturesGetData,
  GetTaskSignaturesTasksTaskIdSignaturesGetErrors,
  GetTaskSignaturesTasksTaskIdSignaturesGetResponses,
  GetTaskTypesTaskTypesGetData,
  GetTaskTypesTaskTypesGetResponses,
  GetTelnyxFaxLineInternalToolsTelnyxFaxLinesAgencyIdGetData,
  GetTelnyxFaxLineInternalToolsTelnyxFaxLinesAgencyIdGetErrors,
  GetTelnyxFaxLineInternalToolsTelnyxFaxLinesAgencyIdGetResponses,
  GetTemporalScalingOverridesInternalToolsTemporalScalingOverridesGetData,
  GetTemporalScalingOverridesInternalToolsTemporalScalingOverridesGetErrors,
  GetTemporalScalingOverridesInternalToolsTemporalScalingOverridesGetResponses,
  GetThirtyDaySummaryPdfPatientCommunicationsCommunicationIdThirtyDaySummaryPdfGetData,
  GetThirtyDaySummaryPdfPatientCommunicationsCommunicationIdThirtyDaySummaryPdfGetErrors,
  GetThirtyDaySummaryPdfPatientCommunicationsCommunicationIdThirtyDaySummaryPdfGetResponses,
  GetThirtyDaySummaryPrefillPatientCommunicationsCommunicationIdThirtyDaySummaryPrefillGetData,
  GetThirtyDaySummaryPrefillPatientCommunicationsCommunicationIdThirtyDaySummaryPrefillGetErrors,
  GetThirtyDaySummaryPrefillPatientCommunicationsCommunicationIdThirtyDaySummaryPrefillGetResponses,
  GetUnassignedFaxInternalToolsUnassignedFaxesFaxIdGetData,
  GetUnassignedFaxInternalToolsUnassignedFaxesFaxIdGetErrors,
  GetUnassignedFaxInternalToolsUnassignedFaxesFaxIdGetResponses,
  GetUserDefinedAllergiesAllergiesUserDefinedGetData,
  GetUserDefinedAllergiesAllergiesUserDefinedGetResponses,
  GetUserLicenseDocumentUrlUserLicensesLicenseIdDocumentsDocumentIdUrlGetData,
  GetUserLicenseDocumentUrlUserLicensesLicenseIdDocumentsDocumentIdUrlGetErrors,
  GetUserLicenseDocumentUrlUserLicensesLicenseIdDocumentsDocumentIdUrlGetResponses,
  GetUserOnboardingReportReportsUserOnboardingGetData,
  GetUserOnboardingReportReportsUserOnboardingGetErrors,
  GetUserOnboardingReportReportsUserOnboardingGetResponses,
  GetUserOrganizationsAuthOrganizationsGetData,
  GetUserOrganizationsAuthOrganizationsGetResponses,
  GetUsersByPermissionUsersByPermissionGetData,
  GetUsersByPermissionUsersByPermissionGetErrors,
  GetUsersByPermissionUsersByPermissionGetResponses,
  GetUsersByRoleRbacRoleAssignmentsUsersByRoleRoleIdGetData,
  GetUsersByRoleRbacRoleAssignmentsUsersByRoleRoleIdGetErrors,
  GetUsersByRoleRbacRoleAssignmentsUsersByRoleRoleIdGetResponses,
  GetUsersUsersGetData,
  GetUsersUsersGetErrors,
  GetUsersUsersGetResponses,
  GetUserUsersUserIdGetData,
  GetUserUsersUserIdGetErrors,
  GetUserUsersUserIdGetResponses,
  GetVersionedQuestionSchemaRogerdocV2QuestionSchemaPostData,
  GetVersionedQuestionSchemaRogerdocV2QuestionSchemaPostErrors,
  GetVersionedQuestionSchemaRogerdocV2QuestionSchemaPostResponses,
  GetVisitDataInternalInternalVisitsVisitIdDataGetData,
  GetVisitDataInternalInternalVisitsVisitIdDataGetErrors,
  GetVisitDataInternalInternalVisitsVisitIdDataGetResponses,
  GetVisitDataVisitsVisitIdDataGetData,
  GetVisitDataVisitsVisitIdDataGetErrors,
  GetVisitDataVisitsVisitIdDataGetResponses,
  GetVisitEvvCaptureContextVisitsVisitIdEvvCaptureContextGetData,
  GetVisitEvvCaptureContextVisitsVisitIdEvvCaptureContextGetErrors,
  GetVisitEvvCaptureContextVisitsVisitIdEvvCaptureContextGetResponses,
  GetVisitEvvCaptureReadingsVisitsVisitIdEvvCaptureViewGetData,
  GetVisitEvvCaptureReadingsVisitsVisitIdEvvCaptureViewGetErrors,
  GetVisitEvvCaptureReadingsVisitsVisitIdEvvCaptureViewGetResponses,
  GetVisitEvvReadingsVisitsVisitIdEvvGetData,
  GetVisitEvvReadingsVisitsVisitIdEvvGetErrors,
  GetVisitEvvReadingsVisitsVisitIdEvvGetResponses,
  GetVisitExternalAnswersVisitsVisitIdExternalAnswersGetData,
  GetVisitExternalAnswersVisitsVisitIdExternalAnswersGetErrors,
  GetVisitExternalAnswersVisitsVisitIdExternalAnswersGetResponses,
  GetVisitInternalInternalVisitsVisitIdGetData,
  GetVisitInternalInternalVisitsVisitIdGetErrors,
  GetVisitInternalInternalVisitsVisitIdGetResponses,
  GetVisitPdfRevisionVisitsVisitIdPdfRevisionGetData,
  GetVisitPdfRevisionVisitsVisitIdPdfRevisionGetErrors,
  GetVisitPdfRevisionVisitsVisitIdPdfRevisionGetResponses,
  GetVisitPdfVisitsVisitIdPdfGetData,
  GetVisitPdfVisitsVisitIdPdfGetErrors,
  GetVisitPdfVisitsVisitIdPdfGetResponses,
  GetVisitsByClinicianVisitsByClinicianClinicianIdGetData,
  GetVisitsByClinicianVisitsByClinicianClinicianIdGetErrors,
  GetVisitsByClinicianVisitsByClinicianClinicianIdGetResponses,
  GetVisitSchemaRogerdocV2VisitsVisitIdSchemaGetData,
  GetVisitSchemaRogerdocV2VisitsVisitIdSchemaGetErrors,
  GetVisitSchemaRogerdocV2VisitsVisitIdSchemaGetResponses,
  GetVisitsListInternalInternalVisitsGetData,
  GetVisitsListInternalInternalVisitsGetErrors,
  GetVisitsListInternalInternalVisitsGetResponses,
  GetVisitTypeChangeOptionsVisitsVisitIdTypeOptionsGetData,
  GetVisitTypeChangeOptionsVisitsVisitIdTypeOptionsGetErrors,
  GetVisitTypeChangeOptionsVisitsVisitIdTypeOptionsGetResponses,
  GetVisitTypeOptionsVisitsTypeOptionsGetData,
  GetVisitTypeOptionsVisitsTypeOptionsGetResponses,
  GetVisitVisitsVisitIdGetData,
  GetVisitVisitsVisitIdGetErrors,
  GetVisitVisitsVisitIdGetResponses,
  GetVisitWorkLogVisitsVisitIdWorkLogGetData,
  GetVisitWorkLogVisitsVisitIdWorkLogGetErrors,
  GetVisitWorkLogVisitsVisitIdWorkLogGetResponses,
  GetWidgetTokenAuthWidgetTokenGetData,
  GetWidgetTokenAuthWidgetTokenGetResponses,
  GetWorklogReportOptionsReportsWorklogOptionsGetData,
  GetWorklogReportOptionsReportsWorklogOptionsGetErrors,
  GetWorklogReportOptionsReportsWorklogOptionsGetResponses,
  GetWorklogReportReportsWorklogGetData,
  GetWorklogReportReportsWorklogGetErrors,
  GetWorklogReportReportsWorklogGetResponses,
  GetWoundAssessmentsPatientsPatientIdWoundsWoundIdAssessmentsGetData,
  GetWoundAssessmentsPatientsPatientIdWoundsWoundIdAssessmentsGetErrors,
  GetWoundAssessmentsPatientsPatientIdWoundsWoundIdAssessmentsGetResponses,
  GetWoundAttachmentsPatientsPatientIdWoundsWoundIdAttachmentsGetData,
  GetWoundAttachmentsPatientsPatientIdWoundsWoundIdAttachmentsGetErrors,
  GetWoundAttachmentsPatientsPatientIdWoundsWoundIdAttachmentsGetResponses,
  GetWoundAttachmentUrlPatientsPatientIdWoundsWoundIdAttachmentsAttachmentIdUrlGetData,
  GetWoundAttachmentUrlPatientsPatientIdWoundsWoundIdAttachmentsAttachmentIdUrlGetErrors,
  GetWoundAttachmentUrlPatientsPatientIdWoundsWoundIdAttachmentsAttachmentIdUrlGetResponses,
  GetWoundCareWorksheetPdfPatientsPatientIdWoundsPdfPostData,
  GetWoundCareWorksheetPdfPatientsPatientIdWoundsPdfPostErrors,
  GetWoundCareWorksheetPdfPatientsPatientIdWoundsPdfPostResponses,
  GetWoundStatusReportOptionsReportsWoundStatusOptionsGetData,
  GetWoundStatusReportOptionsReportsWoundStatusOptionsGetErrors,
  GetWoundStatusReportOptionsReportsWoundStatusOptionsGetResponses,
  GetWoundStatusReportReportsWoundStatusGetData,
  GetWoundStatusReportReportsWoundStatusGetErrors,
  GetWoundStatusReportReportsWoundStatusGetResponses,
  HealthCheckHealthGetData,
  HealthCheckHealthGetResponses,
  HealthCheckTemporalHealthGetData,
  HealthCheckTemporalHealthGetResponses,
  ImportAllergiesFromFileAllergiesImportPostData,
  ImportAllergiesFromFileAllergiesImportPostResponses,
  ImportBespokeTemplatesBundleBespokeTemplatesImportBundlePostData,
  ImportBespokeTemplatesBundleBespokeTemplatesImportBundlePostErrors,
  ImportBespokeTemplatesBundleBespokeTemplatesImportBundlePostResponses,
  ImportGoalsFromRogerdocsGoalsDashboardImportFromRogerdocsPostData,
  ImportGoalsFromRogerdocsGoalsDashboardImportFromRogerdocsPostErrors,
  ImportGoalsFromRogerdocsGoalsDashboardImportFromRogerdocsPostResponses,
  ImportKinnserPatientPortfolioDevTestDataKinnserImportPostData,
  ImportKinnserPatientPortfolioDevTestDataKinnserImportPostErrors,
  ImportKinnserPatientPortfolioDevTestDataKinnserImportPostResponses,
  ImportKinnserPatientPortfolioInternalInternalKinnserImportPostData,
  ImportKinnserPatientPortfolioInternalInternalKinnserImportPostErrors,
  ImportKinnserPatientPortfolioInternalInternalKinnserImportPostResponses,
  ImportStediCsvEndpointPayorsImportStediCsvPostData,
  ImportStediCsvEndpointPayorsImportStediCsvPostResponses,
  ImportWaystarCsvEndpointPayorsImportWaystarCsvPostData,
  ImportWaystarCsvEndpointPayorsImportWaystarCsvPostResponses,
  IngestWoundAttachmentsFromS3PatientsPatientIdWoundsWoundIdAttachmentsFromS3PostData,
  IngestWoundAttachmentsFromS3PatientsPatientIdWoundsWoundIdAttachmentsFromS3PostErrors,
  IngestWoundAttachmentsFromS3PatientsPatientIdWoundsWoundIdAttachmentsFromS3PostResponses,
  IngestWoundAttachmentsFromUrlPatientsPatientIdWoundsWoundIdAttachmentsFromUrlPostData,
  IngestWoundAttachmentsFromUrlPatientsPatientIdWoundsWoundIdAttachmentsFromUrlPostErrors,
  IngestWoundAttachmentsFromUrlPatientsPatientIdWoundsWoundIdAttachmentsFromUrlPostResponses,
  InitializeEmrSelectionEndpointIntakeIntakeIdInitializeEmrSelectionPostData,
  InitializeEmrSelectionEndpointIntakeIntakeIdInitializeEmrSelectionPostErrors,
  InitializeEmrSelectionEndpointIntakeIntakeIdInitializeEmrSelectionPostResponses,
  InternalHealthCheckInternalHealthGetData,
  InternalHealthCheckInternalHealthGetErrors,
  InternalHealthCheckInternalHealthGetResponses,
  InviteUserUsersInvitePostData,
  InviteUserUsersInvitePostErrors,
  InviteUserUsersInvitePostResponses,
  IssueAttachmentUrlsChatAttachmentsUrlsPostData,
  IssueAttachmentUrlsChatAttachmentsUrlsPostErrors,
  IssueAttachmentUrlsChatAttachmentsUrlsPostResponses,
  ListAgenciesInternalInternalAgenciesGetData,
  ListAgenciesInternalInternalAgenciesGetErrors,
  ListAgenciesInternalInternalAgenciesGetResponses,
  ListAgenciesWithAssignedRolesInternalToolsAgenciesWithAssignedRolesGetData,
  ListAgenciesWithAssignedRolesInternalToolsAgenciesWithAssignedRolesGetErrors,
  ListAgenciesWithAssignedRolesInternalToolsAgenciesWithAssignedRolesGetResponses,
  ListAgencyClinicPhysiciansAgencyClinicsAgencyClinicIdPhysiciansGetData,
  ListAgencyClinicPhysiciansAgencyClinicsAgencyClinicIdPhysiciansGetErrors,
  ListAgencyClinicPhysiciansAgencyClinicsAgencyClinicIdPhysiciansGetResponses,
  ListAgencyClinicsInternalToolsAgenciesAgencyIdClinicsGetData,
  ListAgencyClinicsInternalToolsAgenciesAgencyIdClinicsGetErrors,
  ListAgencyClinicsInternalToolsAgenciesAgencyIdClinicsGetResponses,
  ListAgencyFaxNumbersInternalToolsFaxNumbersGetData,
  ListAgencyFaxNumbersInternalToolsFaxNumbersGetErrors,
  ListAgencyFaxNumbersInternalToolsFaxNumbersGetResponses,
  ListAllowedFormTemplateQuestionsAdminFormTemplatesAllowedQuestionsGetData,
  ListAllowedFormTemplateQuestionsAdminFormTemplatesAllowedQuestionsGetResponses,
  ListBespokeTemplateRevisionsBespokeTemplatesRevisionsGetData,
  ListBespokeTemplateRevisionsBespokeTemplatesRevisionsGetErrors,
  ListBespokeTemplateRevisionsBespokeTemplatesRevisionsGetResponses,
  ListBespokeTemplatesBespokeTemplatesGetData,
  ListBespokeTemplatesBespokeTemplatesGetErrors,
  ListBespokeTemplatesBespokeTemplatesGetResponses,
  ListBespokeTemplatesExportAllBespokeTemplatesExportAllGetData,
  ListBespokeTemplatesExportAllBespokeTemplatesExportAllGetResponses,
  ListBillingCycleNotesBillingBillingCycleBillingCycleIdNotesGetData,
  ListBillingCycleNotesBillingBillingCycleBillingCycleIdNotesGetErrors,
  ListBillingCycleNotesBillingBillingCycleBillingCycleIdNotesGetResponses,
  ListCahpsExportsCahpsExportsGetData,
  ListCahpsExportsCahpsExportsGetResponses,
  ListClinicianDirectoryInternalToolsClinicianDirectoryGetData,
  ListClinicianDirectoryInternalToolsClinicianDirectoryGetErrors,
  ListClinicianDirectoryInternalToolsClinicianDirectoryGetResponses,
  ListClinicPhysiciansAdminClinicPhysiciansGetData,
  ListClinicPhysiciansAdminClinicPhysiciansGetErrors,
  ListClinicPhysiciansAdminClinicPhysiciansGetResponses,
  ListCms485OasisVisitsPatientsPatientIdCms485OasisVisitsGetData,
  ListCms485OasisVisitsPatientsPatientIdCms485OasisVisitsGetErrors,
  ListCms485OasisVisitsPatientsPatientIdCms485OasisVisitsGetResponses,
  ListDashboardClinicsData,
  ListDashboardClinicsErrors,
  ListDashboardClinicsResponses,
  ListDashboardTabsReportingDashboardTabsGetData,
  ListDashboardTabsReportingDashboardTabsGetResponses,
  ListDashboardTabWidgetsReportingDashboardTabsTabIdWidgetsGetData,
  ListDashboardTabWidgetsReportingDashboardTabsTabIdWidgetsGetErrors,
  ListDashboardTabWidgetsReportingDashboardTabsTabIdWidgetsGetResponses,
  ListDemoEnvironmentRunsDemoAgencySetupEnvironmentsAgencyIdRunsGetData,
  ListDemoEnvironmentRunsDemoAgencySetupEnvironmentsAgencyIdRunsGetErrors,
  ListDemoEnvironmentRunsDemoAgencySetupEnvironmentsAgencyIdRunsGetResponses,
  ListDemoEnvironmentsDemoAgencySetupEnvironmentsGetData,
  ListDemoEnvironmentsDemoAgencySetupEnvironmentsGetResponses,
  ListDiagnosisReviewVisitsVisitIdDiagnosisReviewGetData,
  ListDiagnosisReviewVisitsVisitIdDiagnosisReviewGetErrors,
  ListDiagnosisReviewVisitsVisitIdDiagnosisReviewGetResponses,
  ListDirectoryAgenciesInternalToolsClinicianDirectoryAgenciesGetData,
  ListDirectoryAgenciesInternalToolsClinicianDirectoryAgenciesGetErrors,
  ListDirectoryAgenciesInternalToolsClinicianDirectoryAgenciesGetResponses,
  ListDistinctRolesAssignedAtAgencyRbacRoleAssignmentsAgenciesAgencyIdAssignedRolesGetData,
  ListDistinctRolesAssignedAtAgencyRbacRoleAssignmentsAgenciesAgencyIdAssignedRolesGetErrors,
  ListDistinctRolesAssignedAtAgencyRbacRoleAssignmentsAgenciesAgencyIdAssignedRolesGetResponses,
  ListEnabledSectionsBespokeTemplatesEnabledGetData,
  ListEnabledSectionsBespokeTemplatesEnabledGetErrors,
  ListEnabledSectionsBespokeTemplatesEnabledGetResponses,
  ListEpisodeAuthorizationsEpisodesEpisodeIdAuthorizationsGetData,
  ListEpisodeAuthorizationsEpisodesEpisodeIdAuthorizationsGetErrors,
  ListEpisodeAuthorizationsEpisodesEpisodeIdAuthorizationsGetResponses,
  ListEpisodeFrequenciesEpisodesEpisodeIdFrequenciesGetData,
  ListEpisodeFrequenciesEpisodesEpisodeIdFrequenciesGetErrors,
  ListEpisodeFrequenciesEpisodesEpisodeIdFrequenciesGetResponses,
  ListEpisodeNotesEpisodesEpisodeIdNotesGetData,
  ListEpisodeNotesEpisodesEpisodeIdNotesGetErrors,
  ListEpisodeNotesEpisodesEpisodeIdNotesGetResponses,
  ListEpisodesForPatientData,
  ListEpisodesForPatientErrors,
  ListEpisodesForPatientResponses,
  ListEpisodeUnsentBillingCyclesEpisodesEpisodeIdUnsentBillingCyclesGetData,
  ListEpisodeUnsentBillingCyclesEpisodesEpisodeIdUnsentBillingCyclesGetErrors,
  ListEpisodeUnsentBillingCyclesEpisodesEpisodeIdUnsentBillingCyclesGetResponses,
  ListFallLogsPatientsPatientIdFallLogsGetData,
  ListFallLogsPatientsPatientIdFallLogsGetErrors,
  ListFallLogsPatientsPatientIdFallLogsGetResponses,
  ListFaxDocumentsFaxDocumentsGetData,
  ListFaxDocumentsFaxDocumentsGetErrors,
  ListFaxDocumentsFaxDocumentsGetResponses,
  ListFaxItemsFaxItemsGetData,
  ListFaxItemsFaxItemsGetErrors,
  ListFaxItemsFaxItemsGetResponses,
  ListFaxNumberMappingsInternalToolsFaxNumberMappingsGetData,
  ListFaxNumberMappingsInternalToolsFaxNumberMappingsGetErrors,
  ListFaxNumberMappingsInternalToolsFaxNumberMappingsGetResponses,
  ListFaxRouteSettingsFaxRouteSettingsGetData,
  ListFaxRouteSettingsFaxRouteSettingsGetResponses,
  ListFaxTagsFaxClassificationTagsGetData,
  ListFaxTagsFaxClassificationTagsGetErrors,
  ListFaxTagsFaxClassificationTagsGetResponses,
  ListFaxTypesFaxClassificationTypesGetData,
  ListFaxTypesFaxClassificationTypesGetErrors,
  ListFaxTypesFaxClassificationTypesGetResponses,
  ListFaxTypesInternalToolsFaxTypesGetData,
  ListFaxTypesInternalToolsFaxTypesGetErrors,
  ListFaxTypesInternalToolsFaxTypesGetResponses,
  ListFormTemplatesAdminFormTemplatesGetData,
  ListFormTemplatesAdminFormTemplatesGetErrors,
  ListFormTemplatesAdminFormTemplatesGetResponses,
  ListFormTemplatesForVisitFormTemplatesGetData,
  ListFormTemplatesForVisitFormTemplatesGetErrors,
  ListFormTemplatesForVisitFormTemplatesGetResponses,
  ListGroupAssignmentsRbacRoleAssignmentsGroupGroupIdGetData,
  ListGroupAssignmentsRbacRoleAssignmentsGroupGroupIdGetErrors,
  ListGroupAssignmentsRbacRoleAssignmentsGroupGroupIdGetResponses,
  ListGroupsChatGroupsGetData,
  ListGroupsChatGroupsGetErrors,
  ListGroupsChatGroupsGetResponses,
  ListHistoricalClaimCapturesData,
  ListHistoricalClaimCapturesErrors,
  ListHistoricalClaimCapturesResponses,
  ListInfectionLogsPatientsPatientIdInfectionLogsGetData,
  ListInfectionLogsPatientsPatientIdInfectionLogsGetErrors,
  ListInfectionLogsPatientsPatientIdInfectionLogsGetResponses,
  ListIntakeDraftsIntakeDraftsGetData,
  ListIntakeDraftsIntakeDraftsGetErrors,
  ListIntakeDraftsIntakeDraftsGetResponses,
  ListInternalReferralSourcesAdminInternalReferralSourcesGetData,
  ListInternalReferralSourcesAdminInternalReferralSourcesGetErrors,
  ListInternalReferralSourcesAdminInternalReferralSourcesGetResponses,
  ListInternalReferralSourcesForIntakeInternalReferralSourcesGetData,
  ListInternalReferralSourcesForIntakeInternalReferralSourcesGetErrors,
  ListInternalReferralSourcesForIntakeInternalReferralSourcesGetResponses,
  ListKinnserAgencyClinicsInternalToolsKinnserAgencySyncAgenciesAgencyIdClinicsGetData,
  ListKinnserAgencyClinicsInternalToolsKinnserAgencySyncAgenciesAgencyIdClinicsGetErrors,
  ListKinnserAgencyClinicsInternalToolsKinnserAgencySyncAgenciesAgencyIdClinicsGetResponses,
  ListKinnserImportQueueInternalKinnserImportQueueGetData,
  ListKinnserImportQueueInternalKinnserImportQueueGetErrors,
  ListKinnserImportQueueInternalKinnserImportQueueGetResponses,
  ListKinnserSyncAgenciesInternalToolsKinnserAgencySyncAgenciesGetData,
  ListKinnserSyncAgenciesInternalToolsKinnserAgencySyncAgenciesGetErrors,
  ListKinnserSyncAgenciesInternalToolsKinnserAgencySyncAgenciesGetResponses,
  ListMarMedicationsPatientsPatientIdVisitsVisitIdMarGetData,
  ListMarMedicationsPatientsPatientIdVisitsVisitIdMarGetErrors,
  ListMarMedicationsPatientsPatientIdVisitsVisitIdMarGetResponses,
  ListMergeCandidatesInternalToolsAgenciesAgencyIdUsersMergeCandidatesGetData,
  ListMergeCandidatesInternalToolsAgenciesAgencyIdUsersMergeCandidatesGetErrors,
  ListMergeCandidatesInternalToolsAgenciesAgencyIdUsersMergeCandidatesGetResponses,
  ListMergesInternalToolsAgenciesAgencyIdUsersMergesGetData,
  ListMergesInternalToolsAgenciesAgencyIdUsersMergesGetErrors,
  ListMergesInternalToolsAgenciesAgencyIdUsersMergesGetResponses,
  ListNoaPayersNoasPayersGetData,
  ListNoaPayersNoasPayersGetErrors,
  ListNoaPayersNoasPayersGetResponses,
  ListNoasNoasGetData,
  ListNoasNoasGetErrors,
  ListNoasNoasGetResponses,
  ListOasisManagerVisitsVisitsOasisManagerGetData,
  ListOasisManagerVisitsVisitsOasisManagerGetErrors,
  ListOasisManagerVisitsVisitsOasisManagerGetResponses,
  ListOrgMembersUsersOrgMembersGetData,
  ListOrgMembersUsersOrgMembersGetResponses,
  ListPatientAdmissionsFaxClassificationPatientsPatientIdAdmissionsGetData,
  ListPatientAdmissionsFaxClassificationPatientsPatientIdAdmissionsGetErrors,
  ListPatientAdmissionsFaxClassificationPatientsPatientIdAdmissionsGetResponses,
  ListPatientChartImportsPatientsPatientIdChartImportsGetData,
  ListPatientChartImportsPatientsPatientIdChartImportsGetErrors,
  ListPatientChartImportsPatientsPatientIdChartImportsGetResponses,
  ListPatientCommunicationsPatientsPatientIdCommunicationsGetData,
  ListPatientCommunicationsPatientsPatientIdCommunicationsGetErrors,
  ListPatientCommunicationsPatientsPatientIdCommunicationsGetResponses,
  ListPatientDuplicateImportsImporterPatientsPatientIdDuplicateImportsGetData,
  ListPatientDuplicateImportsImporterPatientsPatientIdDuplicateImportsGetErrors,
  ListPatientDuplicateImportsImporterPatientsPatientIdDuplicateImportsGetResponses,
  ListPatientImportReviewItemsPatientsPatientIdChartImportsReviewItemsGetData,
  ListPatientImportReviewItemsPatientsPatientIdChartImportsReviewItemsGetErrors,
  ListPatientImportReviewItemsPatientsPatientIdChartImportsReviewItemsGetResponses,
  ListPatientInsurancesPatientsPatientIdInsuranceGetData,
  ListPatientInsurancesPatientsPatientIdInsuranceGetErrors,
  ListPatientInsurancesPatientsPatientIdInsuranceGetResponses,
  ListPatientTagDefinitionsPatientTagsDefinitionsGetData,
  ListPatientTagDefinitionsPatientTagsDefinitionsGetErrors,
  ListPatientTagDefinitionsPatientTagsDefinitionsGetResponses,
  ListPayorsInternalToolsPayorsGetData,
  ListPayorsInternalToolsPayorsGetErrors,
  ListPayorsInternalToolsPayorsGetResponses,
  ListPayrollEntriesPayrollEntriesGetData,
  ListPayrollEntriesPayrollEntriesGetErrors,
  ListPayrollEntriesPayrollEntriesGetResponses,
  ListPayrollEntryVisitsPayrollEntriesPayrollEntryIdVisitsGetData,
  ListPayrollEntryVisitsPayrollEntriesPayrollEntryIdVisitsGetErrors,
  ListPayrollEntryVisitsPayrollEntriesPayrollEntryIdVisitsGetResponses,
  ListPayrollVisitsPayrollVisitsGetData,
  ListPayrollVisitsPayrollVisitsGetErrors,
  ListPayrollVisitsPayrollVisitsGetResponses,
  ListPermissionsRbacPermissionsGetData,
  ListPermissionsRbacPermissionsGetErrors,
  ListPermissionsRbacPermissionsGetResponses,
  ListPhoRocVisitsPatientsPatientIdPhoRocVisitsGetData,
  ListPhoRocVisitsPatientsPatientIdPhoRocVisitsGetErrors,
  ListPhoRocVisitsPatientsPatientIdPhoRocVisitsGetResponses,
  ListPickableRolesChatGroupsRolesGetData,
  ListPickableRolesChatGroupsRolesGetResponses,
  ListPickableSourcesChatGroupsSourcesGetData,
  ListPickableSourcesChatGroupsSourcesGetResponses,
  ListPortOrdersFaxNumberPortsGetData,
  ListPortOrdersFaxNumberPortsGetResponses,
  ListPulledPayersDemoAgencySetupEnvironmentsAgencyIdPulledPayersGetData,
  ListPulledPayersDemoAgencySetupEnvironmentsAgencyIdPulledPayersGetErrors,
  ListPulledPayersDemoAgencySetupEnvironmentsAgencyIdPulledPayersGetResponses,
  ListReceivedFaxesReceivedFaxesGetData,
  ListReceivedFaxesReceivedFaxesGetErrors,
  ListReceivedFaxesReceivedFaxesGetResponses,
  ListRemittancePayorsRemittancesPayorsGetData,
  ListRemittancePayorsRemittancesPayorsGetResponses,
  ListRemittancesRemittancesGetData,
  ListRemittancesRemittancesGetErrors,
  ListRemittancesRemittancesGetResponses,
  ListReportDefinitionsReportingReportDefinitionsGetData,
  ListReportDefinitionsReportingReportDefinitionsGetResponses,
  ListReportWidgetsReportingWidgetsGetData,
  ListReportWidgetsReportingWidgetsGetResponses,
  ListRingcentralInventoryInternalToolsFaxNumbersRingcentralGetData,
  ListRingcentralInventoryInternalToolsFaxNumbersRingcentralGetErrors,
  ListRingcentralInventoryInternalToolsFaxNumbersRingcentralGetResponses,
  ListRogerdocAccountLinksRogerdocAccountLinksGetData,
  ListRogerdocAccountLinksRogerdocAccountLinksGetResponses,
  ListRolePermissionsRbacRolePermissionsRoleIdPermissionsGetData,
  ListRolePermissionsRbacRolePermissionsRoleIdPermissionsGetErrors,
  ListRolePermissionsRbacRolePermissionsRoleIdPermissionsGetResponses,
  ListRolesRbacRolesGetData,
  ListRolesRbacRolesGetErrors,
  ListRolesRbacRolesGetResponses,
  ListRouteEpisodesFaxRoutingPatientsPatientIdEpisodesGetData,
  ListRouteEpisodesFaxRoutingPatientsPatientIdEpisodesGetErrors,
  ListRouteEpisodesFaxRoutingPatientsPatientIdEpisodesGetResponses,
  ListRouteTasksFaxRoutingEpisodesEpisodeIdTasksGetData,
  ListRouteTasksFaxRoutingEpisodesEpisodeIdTasksGetErrors,
  ListRouteTasksFaxRoutingEpisodesEpisodeIdTasksGetResponses,
  ListSimulatedOrderFaxesInternalToolsSimulatedOrderFaxesGetData,
  ListSimulatedOrderFaxesInternalToolsSimulatedOrderFaxesGetErrors,
  ListSimulatedOrderFaxesInternalToolsSimulatedOrderFaxesGetResponses,
  ListTaskSignatureBypassesTasksTaskIdSignatureBypassesGetData,
  ListTaskSignatureBypassesTasksTaskIdSignatureBypassesGetErrors,
  ListTaskSignatureBypassesTasksTaskIdSignatureBypassesGetResponses,
  ListTelnyxFaxLinesInternalToolsTelnyxFaxLinesGetData,
  ListTelnyxFaxLinesInternalToolsTelnyxFaxLinesGetErrors,
  ListTelnyxFaxLinesInternalToolsTelnyxFaxLinesGetResponses,
  ListUnassignedFaxesInternalToolsUnassignedFaxesGetData,
  ListUnassignedFaxesInternalToolsUnassignedFaxesGetErrors,
  ListUnassignedFaxesInternalToolsUnassignedFaxesGetResponses,
  ListUserAssignmentsRbacRoleAssignmentsUserUserIdGetData,
  ListUserAssignmentsRbacRoleAssignmentsUserUserIdGetErrors,
  ListUserAssignmentsRbacRoleAssignmentsUserUserIdGetResponses,
  ListUserLicenseDocumentsUserLicensesLicenseIdDocumentsGetData,
  ListUserLicenseDocumentsUserLicensesLicenseIdDocumentsGetErrors,
  ListUserLicenseDocumentsUserLicensesLicenseIdDocumentsGetResponses,
  ListUserLicensesUserLicensesGetData,
  ListUserLicensesUserLicensesGetErrors,
  ListUserLicensesUserLicensesGetResponses,
  ListUserLicenseTypesAdminUserLicenseTypesGetData,
  ListUserLicenseTypesAdminUserLicenseTypesGetErrors,
  ListUserLicenseTypesAdminUserLicenseTypesGetResponses,
  ListUserLicenseTypesForPickerUserLicenseTypesGetData,
  ListUserLicenseTypesForPickerUserLicenseTypesGetResponses,
  ListUserMergeCandidatesUsersMergeCandidatesGetData,
  ListUserMergeCandidatesUsersMergeCandidatesGetResponses,
  ListUserRoleAssignmentsData,
  ListUserRoleAssignmentsErrors,
  ListUserRoleAssignmentsResponses,
  ListValueCodesRouteValueCodesGetData,
  ListValueCodesRouteValueCodesGetResponses,
  ListVisitDiagnosesInternalInternalVisitsVisitIdDiagnosesGetData,
  ListVisitDiagnosesInternalInternalVisitsVisitIdDiagnosesGetErrors,
  ListVisitDiagnosesInternalInternalVisitsVisitIdDiagnosesGetResponses,
  ListVisitDiagnosesVisitsVisitIdDiagnosesGetData,
  ListVisitDiagnosesVisitsVisitIdDiagnosesGetErrors,
  ListVisitDiagnosesVisitsVisitIdDiagnosesGetResponses,
  ListWorkosFeatureFlagsRbacFeatureFlagsGetData,
  ListWorkosFeatureFlagsRbacFeatureFlagsGetResponses,
  LogErrorSentryDebugLogErrorGetData,
  LogErrorSentryDebugLogErrorGetResponses,
  LoginAuthLoginGetData,
  LoginAuthLoginGetResponses,
  LogoutAuthLogoutGetData,
  LogoutAuthLogoutGetResponses,
  MarkNotApplicableNoasNoaIdMarkNotApplicablePostData,
  MarkNotApplicableNoasNoaIdMarkNotApplicablePostErrors,
  MarkNotApplicableNoasNoaIdMarkNotApplicablePostResponses,
  MarkPaidNoasNoaIdMarkPaidPostData,
  MarkPaidNoasNoaIdMarkPaidPostErrors,
  MarkPaidNoasNoaIdMarkPaidPostResponses,
  MarkPatientChartImportReviewedPatientsPatientIdChartImportsRunIdReviewPostData,
  MarkPatientChartImportReviewedPatientsPatientIdChartImportsRunIdReviewPostErrors,
  MarkPatientChartImportReviewedPatientsPatientIdChartImportsRunIdReviewPostResponses,
  MarkPatientGoalMetGoalsVisitProgressVisitIdProgressPatientGoalIdMarkMetPostData,
  MarkPatientGoalMetGoalsVisitProgressVisitIdProgressPatientGoalIdMarkMetPostErrors,
  MarkPatientGoalMetGoalsVisitProgressVisitIdProgressPatientGoalIdMarkMetPostResponses,
  MarkPatientGoalMetInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdMarkMetPostData,
  MarkPatientGoalMetInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdMarkMetPostErrors,
  MarkPatientGoalMetInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdMarkMetPostResponses,
  MarkPatientGoalUnattainableGoalsVisitProgressVisitIdProgressPatientGoalIdMarkUnattainablePostData,
  MarkPatientGoalUnattainableGoalsVisitProgressVisitIdProgressPatientGoalIdMarkUnattainablePostErrors,
  MarkPatientGoalUnattainableGoalsVisitProgressVisitIdProgressPatientGoalIdMarkUnattainablePostResponses,
  MarkPatientGoalUnattainableInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdMarkUnattainablePostData,
  MarkPatientGoalUnattainableInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdMarkUnattainablePostErrors,
  MarkPatientGoalUnattainableInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdMarkUnattainablePostResponses,
  MarkReadChatChannelsChannelIdReadPostData,
  MarkReadChatChannelsChannelIdReadPostErrors,
  MarkReadChatChannelsChannelIdReadPostResponses,
  MarkRejectedNoasNoaIdMarkRejectedPostData,
  MarkRejectedNoasNoaIdMarkRejectedPostErrors,
  MarkRejectedNoasNoaIdMarkRejectedPostResponses,
  MarkSentNoasNoaIdMarkSentPostData,
  MarkSentNoasNoaIdMarkSentPostErrors,
  MarkSentNoasNoaIdMarkSentPostResponses,
  MarkVisitAsMissedVisitsVisitIdMarkMissedPostData,
  MarkVisitAsMissedVisitsVisitIdMarkMissedPostErrors,
  MarkVisitAsMissedVisitsVisitIdMarkMissedPostResponses,
  MarkVisitMissedInternalInternalVisitsVisitIdMarkMissedPostData,
  MarkVisitMissedInternalInternalVisitsVisitIdMarkMissedPostErrors,
  MarkVisitMissedInternalInternalVisitsVisitIdMarkMissedPostResponses,
  MarkVisitsExportedVisitsMarkExportedPostData,
  MarkVisitsExportedVisitsMarkExportedPostErrors,
  MarkVisitsExportedVisitsMarkExportedPostResponses,
  MatchPatientsPatientsMatchPostData,
  MatchPatientsPatientsMatchPostErrors,
  MatchPatientsPatientsMatchPostResponses,
  MergeAccountsInternalToolsAgenciesAgencyIdUsersMergePostData,
  MergeAccountsInternalToolsAgenciesAgencyIdUsersMergePostErrors,
  MergeAccountsInternalToolsAgenciesAgencyIdUsersMergePostResponses,
  MergeFaxItemsFaxDocumentsMergePostData,
  MergeFaxItemsFaxDocumentsMergePostErrors,
  MergeFaxItemsFaxDocumentsMergePostResponses,
  MergeUsersUsersMergePostData,
  MergeUsersUsersMergePostErrors,
  MergeUsersUsersMergePostResponses,
  OnboardPatientRogerIntakeIntakeIdOnboardPatientRogerPostData,
  OnboardPatientRogerIntakeIntakeIdOnboardPatientRogerPostErrors,
  OnboardPatientRogerIntakeIntakeIdOnboardPatientRogerPostResponses,
  OnboardUsersEndpointUsersOnboardPostData,
  OnboardUsersEndpointUsersOnboardPostErrors,
  OnboardUsersEndpointUsersOnboardPostResponses,
  OpenChannelByEpisodeChatChannelsByEpisodeEpisodeIdPostData,
  OpenChannelByEpisodeChatChannelsByEpisodeEpisodeIdPostErrors,
  OpenChannelByEpisodeChatChannelsByEpisodeEpisodeIdPostResponses,
  OverridePaymentOasisHoldBillingBillingCycleBillingCycleIdPaymentOasisHoldOverridePostData,
  OverridePaymentOasisHoldBillingBillingCycleBillingCycleIdPaymentOasisHoldOverridePostErrors,
  OverridePaymentOasisHoldBillingBillingCycleBillingCycleIdPaymentOasisHoldOverridePostResponses,
  ParseX12271X12271ParsePostData,
  ParseX12271X12271ParsePostErrors,
  ParseX12271X12271ParsePostResponses,
  PauseImporterLaneImporterLanesLaneKeyPausePostData,
  PauseImporterLaneImporterLanesLaneKeyPausePostErrors,
  PauseImporterLaneImporterLanesLaneKeyPausePostResponses,
  PerformInterventionForVisitGoalsVisitProgressVisitIdProgressPatientInterventionIdPerformPostData,
  PerformInterventionForVisitGoalsVisitProgressVisitIdProgressPatientInterventionIdPerformPostErrors,
  PerformInterventionForVisitGoalsVisitProgressVisitIdProgressPatientInterventionIdPerformPostResponses,
  PerformInterventionForVisitInternalInternalGoalsVisitProgressVisitIdProgressPatientInterventionIdPerformPostData,
  PerformInterventionForVisitInternalInternalGoalsVisitProgressVisitIdProgressPatientInterventionIdPerformPostErrors,
  PerformInterventionForVisitInternalInternalGoalsVisitProgressVisitIdProgressPatientInterventionIdPerformPostResponses,
  PerformPatientEligibilityCheckEligibilityPatientPatientIdCheckPostData,
  PerformPatientEligibilityCheckEligibilityPatientPatientIdCheckPostErrors,
  PerformPatientEligibilityCheckEligibilityPatientPatientIdCheckPostResponses,
  PerformRealEligibilityCheckEligibilityIntakeIntakeIdCheckPostData,
  PerformRealEligibilityCheckEligibilityIntakeIntakeIdCheckPostErrors,
  PerformRealEligibilityCheckEligibilityIntakeIntakeIdCheckPostResponses,
  PollEventsEventsGetData,
  PollEventsEventsGetErrors,
  PollEventsEventsGetResponses,
  PostLinkTitlesChatLinkTitlesPostData,
  PostLinkTitlesChatLinkTitlesPostErrors,
  PostLinkTitlesChatLinkTitlesPostResponses,
  PrecheckOasisBatchVisitsExportOasisPrecheckPostData,
  PrecheckOasisBatchVisitsExportOasisPrecheckPostErrors,
  PrecheckOasisBatchVisitsExportOasisPrecheckPostResponses,
  PreflightStediReplayInternalToolsStediReplayPreflightPostData,
  PreflightStediReplayInternalToolsStediReplayPreflightPostErrors,
  PreflightStediReplayInternalToolsStediReplayPreflightPostResponses,
  PreviewAgencyBlastRadiusSchedulingPointsAgencyBlastRadiusPostData,
  PreviewAgencyBlastRadiusSchedulingPointsAgencyBlastRadiusPostErrors,
  PreviewAgencyBlastRadiusSchedulingPointsAgencyBlastRadiusPostResponses,
  PreviewBespokeTemplatePdfBespokeTemplatesPreviewPdfPostData,
  PreviewBespokeTemplatePdfBespokeTemplatesPreviewPdfPostErrors,
  PreviewBespokeTemplatePdfBespokeTemplatesPreviewPdfPostResponses,
  PreviewCahpsExportCahpsExportsPreviewGetData,
  PreviewCahpsExportCahpsExportsPreviewGetErrors,
  PreviewCahpsExportCahpsExportsPreviewGetResponses,
  PreviewEvvCorrectionInternalToolsEvvCorrectionsPreviewGetData,
  PreviewEvvCorrectionInternalToolsEvvCorrectionsPreviewGetErrors,
  PreviewEvvCorrectionInternalToolsEvvCorrectionsPreviewGetResponses,
  PreviewMergeInternalToolsAgenciesAgencyIdUsersMergePreviewGetData,
  PreviewMergeInternalToolsAgenciesAgencyIdUsersMergePreviewGetErrors,
  PreviewMergeInternalToolsAgenciesAgencyIdUsersMergePreviewGetResponses,
  PreviewShpBatchVisitsOasisManagerShpBatchPreviewGetData,
  PreviewShpBatchVisitsOasisManagerShpBatchPreviewGetResponses,
  PreviewTestPatientCleanupAdminTestPatientsPreviewPostData,
  PreviewTestPatientCleanupAdminTestPatientsPreviewPostErrors,
  PreviewTestPatientCleanupAdminTestPatientsPreviewPostResponses,
  PreviewUserMergeUsersMergePreviewGetData,
  PreviewUserMergeUsersMergePreviewGetErrors,
  PreviewUserMergeUsersMergePreviewGetResponses,
  PrintCensusReportReportsCensusPrintGetData,
  PrintCensusReportReportsCensusPrintGetErrors,
  PrintCensusReportReportsCensusPrintGetResponses,
  PrintPatientMedicationsInternalPatientsPatientIdMedicationsPrintGetData,
  PrintPatientMedicationsInternalPatientsPatientIdMedicationsPrintGetErrors,
  PrintPatientMedicationsInternalPatientsPatientIdMedicationsPrintGetResponses,
  PrintPatientMedicationsPatientsPatientIdMedicationsPrintGetData,
  PrintPatientMedicationsPatientsPatientIdMedicationsPrintGetErrors,
  PrintPatientMedicationsPatientsPatientIdMedicationsPrintGetResponses,
  PrintPayrollEntryVisitsPayrollEntriesPayrollEntryIdPrintGetData,
  PrintPayrollEntryVisitsPayrollEntriesPayrollEntryIdPrintGetErrors,
  PrintPayrollEntryVisitsPayrollEntriesPayrollEntryIdPrintGetResponses,
  PrintPayrollVisitsPayrollVisitsPrintGetData,
  PrintPayrollVisitsPayrollVisitsPrintGetErrors,
  PrintPayrollVisitsPayrollVisitsPrintGetResponses,
  ProvisionFaxNumberInternalToolsFaxNumbersProvisionPostData,
  ProvisionFaxNumberInternalToolsFaxNumbersProvisionPostErrors,
  ProvisionFaxNumberInternalToolsFaxNumbersProvisionPostResponses,
  ProvisionTelnyxFaxLineInternalToolsTelnyxFaxLinesAgencyIdProvisionPostData,
  ProvisionTelnyxFaxLineInternalToolsTelnyxFaxLinesAgencyIdProvisionPostErrors,
  ProvisionTelnyxFaxLineInternalToolsTelnyxFaxLinesAgencyIdProvisionPostResponses,
  PullKinnserDataInternalToolsKinnserAgencySyncAgenciesAgencyIdPullPostData,
  PullKinnserDataInternalToolsKinnserAgencySyncAgenciesAgencyIdPullPostErrors,
  PullKinnserDataInternalToolsKinnserAgencySyncAgenciesAgencyIdPullPostResponses,
  PullKinnserForDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdPullKinnserPostData,
  PullKinnserForDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdPullKinnserPostErrors,
  PullKinnserForDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdPullKinnserPostResponses,
  PushLayoutFormsManagerPushLayoutPostData,
  PushLayoutFormsManagerPushLayoutPostErrors,
  PushLayoutFormsManagerPushLayoutPostResponses,
  PushVisitEvvInternalInternalVisitsVisitIdEvvPutData,
  PushVisitEvvInternalInternalVisitsVisitIdEvvPutErrors,
  PushVisitEvvInternalInternalVisitsVisitIdEvvPutResponses,
  PutExternalEmrPlannedChartsFromPatientsPatientIdExternalEmrPlannedChartsFromPutData,
  PutExternalEmrPlannedChartsFromPatientsPatientIdExternalEmrPlannedChartsFromPutErrors,
  PutExternalEmrPlannedChartsFromPatientsPatientIdExternalEmrPlannedChartsFromPutResponses,
  QueryDashboardData,
  QueryDashboardErrors,
  QueryDashboardResponses,
  ReactivateAgencyMemberUsersUserIdReactivatePostData,
  ReactivateAgencyMemberUsersUserIdReactivatePostErrors,
  ReactivateAgencyMemberUsersUserIdReactivatePostResponses,
  ReactivatePatientTagDefinitionPatientTagsDefinitionsDefinitionIdReactivatePostData,
  ReactivatePatientTagDefinitionPatientTagsDefinitionsDefinitionIdReactivatePostErrors,
  ReactivatePatientTagDefinitionPatientTagsDefinitionsDefinitionIdReactivatePostResponses,
  ReadInvoiceFaxNumberPortsInvoiceReadingPostData,
  ReadInvoiceFaxNumberPortsInvoiceReadingPostErrors,
  ReadInvoiceFaxNumberPortsInvoiceReadingPostResponses,
  ReceiveFaxWebhookFaxInboxWebhooksReceivePostData,
  ReceiveFaxWebhookFaxInboxWebhooksReceivePostResponses,
  ReceiveStediWebhookStediWebhooksReceivePostData,
  ReceiveStediWebhookStediWebhooksReceivePostErrors,
  ReceiveStediWebhookStediWebhooksReceivePostResponses,
  ReconcileImportedAllergyLineData,
  ReconcileImportedAllergyLineErrors,
  ReconcileImportedAllergyLineResponses,
  ReconcileImportedMedicationLineData,
  ReconcileImportedMedicationLineErrors,
  ReconcileImportedMedicationLineResponses,
  ReconciliationAttach277CaClaimStatusData,
  ReconciliationAttach277CaClaimStatusErrors,
  ReconciliationAttach277CaClaimStatusResponses,
  ReconciliationAttach835RemittancePaymentData,
  ReconciliationAttach835RemittancePaymentErrors,
  ReconciliationAttach835RemittancePaymentResponses,
  ReconciliationListUnmatched277CaClaimStatusesData,
  ReconciliationListUnmatched277CaClaimStatusesResponses,
  ReconciliationResolveClaimTransmissionData,
  ReconciliationResolveClaimTransmissionErrors,
  ReconciliationResolveClaimTransmissionResponses,
  ReconnectAgencyClinicToKinnserAgencyClinicsAgencyClinicIdKinnserReconnectPostData,
  ReconnectAgencyClinicToKinnserAgencyClinicsAgencyClinicIdKinnserReconnectPostErrors,
  ReconnectAgencyClinicToKinnserAgencyClinicsAgencyClinicIdKinnserReconnectPostResponses,
  RecordGoalProgressGoalsVisitProgressVisitIdProgressPatientGoalIdRecordProgressPostData,
  RecordGoalProgressGoalsVisitProgressVisitIdProgressPatientGoalIdRecordProgressPostErrors,
  RecordGoalProgressGoalsVisitProgressVisitIdProgressPatientGoalIdRecordProgressPostResponses,
  RecordGoalProgressInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdRecordProgressPostData,
  RecordGoalProgressInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdRecordProgressPostErrors,
  RecordGoalProgressInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdRecordProgressPostResponses,
  RefreshAgencyEnrollmentsClinicsEnrollmentsRefreshPostData,
  RefreshAgencyEnrollmentsClinicsEnrollmentsRefreshPostResponses,
  RefreshBillingCyclesBillingRefreshBillingCyclesPostData,
  RefreshBillingCyclesBillingRefreshBillingCyclesPostResponses,
  RefreshBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetRefreshPostData,
  RefreshBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetRefreshPostErrors,
  RefreshBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetRefreshPostResponses,
  RefreshPatientExternalEmrImportPatientsPatientIdExternalEmrImportRefreshPostData,
  RefreshPatientExternalEmrImportPatientsPatientIdExternalEmrImportRefreshPostErrors,
  RefreshPatientExternalEmrImportPatientsPatientIdExternalEmrImportRefreshPostResponses,
  RejectIntakeEndpointIntakeIntakeIdRejectPutData,
  RejectIntakeEndpointIntakeIntakeIdRejectPutErrors,
  RejectIntakeEndpointIntakeIntakeIdRejectPutResponses,
  ReloadCmsGeographyCmsGeographyReloadPostData,
  ReloadCmsGeographyCmsGeographyReloadPostResponses,
  ReloadHippsReferenceHippsReferenceReloadPostData,
  ReloadHippsReferenceHippsReferenceReloadPostResponses,
  ReloadValueCodesValueCodesReloadPostData,
  ReloadValueCodesValueCodesReloadPostResponses,
  RemoveFaxFaxClassificationKindItemIdDeleteData,
  RemoveFaxFaxClassificationKindItemIdDeleteErrors,
  RemoveFaxFaxClassificationKindItemIdDeleteResponses,
  RemoveIntakeDraftIntakeDraftsDraftIdDeleteData,
  RemoveIntakeDraftIntakeDraftsDraftIdDeleteErrors,
  RemoveIntakeDraftIntakeDraftsDraftIdDeleteResponses,
  RemoveManyFaxesFaxClassificationRemovePostData,
  RemoveManyFaxesFaxClassificationRemovePostErrors,
  RemoveManyFaxesFaxClassificationRemovePostResponses,
  RemovePayrollEntryVisitPayrollEntriesPayrollEntryIdVisitsVisitIdDeleteData,
  RemovePayrollEntryVisitPayrollEntriesPayrollEntryIdVisitsVisitIdDeleteErrors,
  RemovePayrollEntryVisitPayrollEntriesPayrollEntryIdVisitsVisitIdDeleteResponses,
  RemovePermissionFromRoleRbacRolePermissionsRoleIdPermissionsPermissionIdDeleteData,
  RemovePermissionFromRoleRbacRolePermissionsRoleIdPermissionsPermissionIdDeleteErrors,
  RemovePermissionFromRoleRbacRolePermissionsRoleIdPermissionsPermissionIdDeleteResponses,
  RemovePortDocumentFaxNumberPortsPortOrderIdDocumentsDocumentKindDeleteData,
  RemovePortDocumentFaxNumberPortsPortOrderIdDocumentsDocumentKindDeleteErrors,
  RemovePortDocumentFaxNumberPortsPortOrderIdDocumentsDocumentKindDeleteResponses,
  RemoveUserFromAgencyInternalToolsAgenciesAgencyIdUsersUserIdDeleteData,
  RemoveUserFromAgencyInternalToolsAgenciesAgencyIdUsersUserIdDeleteErrors,
  RemoveUserFromAgencyInternalToolsAgenciesAgencyIdUsersUserIdDeleteResponses,
  RemoveVisitEvvVisitsVisitIdEvvDeleteData,
  RemoveVisitEvvVisitsVisitIdEvvDeleteErrors,
  RemoveVisitEvvVisitsVisitIdEvvDeleteResponses,
  RenameArrivalFaxItemsArrivalItemIdPatchData,
  RenameArrivalFaxItemsArrivalItemIdPatchErrors,
  RenameArrivalFaxItemsArrivalItemIdPatchResponses,
  RenameDocumentFaxItemsDocumentItemIdPatchData,
  RenameDocumentFaxItemsDocumentItemIdPatchErrors,
  RenameDocumentFaxItemsDocumentItemIdPatchResponses,
  RenameFaxDocumentFaxDocumentsDocumentIdPatchData,
  RenameFaxDocumentFaxDocumentsDocumentIdPatchErrors,
  RenameFaxDocumentFaxDocumentsDocumentIdPatchResponses,
  RenameIntakeDraftIntakeDraftsDraftIdPutData,
  RenameIntakeDraftIntakeDraftsDraftIdPutErrors,
  RenameIntakeDraftIntakeDraftsDraftIdPutResponses,
  RenamePatientTagDefinitionPatientTagsDefinitionsDefinitionIdPatchData,
  RenamePatientTagDefinitionPatientTagsDefinitionsDefinitionIdPatchErrors,
  RenamePatientTagDefinitionPatientTagsDefinitionsDefinitionIdPatchResponses,
  RenameTaskTypeAliasTaskTypesAliasesAliasIdPatchData,
  RenameTaskTypeAliasTaskTypesAliasesAliasIdPatchErrors,
  RenameTaskTypeAliasTaskTypesAliasesAliasIdPatchResponses,
  ReopenBillingCycleBillingBillingCycleBillingCycleIdSetStatusReopenPostData,
  ReopenBillingCycleBillingBillingCycleBillingCycleIdSetStatusReopenPostErrors,
  ReopenBillingCycleBillingBillingCycleBillingCycleIdSetStatusReopenPostResponses,
  ReopenEpisodeData,
  ReopenEpisodeErrors,
  ReopenEpisodeResponses,
  ReopenRemittanceRemittancesRemittanceIdReopenPostData,
  ReopenRemittanceRemittancesRemittanceIdReopenPostErrors,
  ReopenRemittanceRemittancesRemittanceIdReopenPostResponses,
  ReplaceBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetFullPutData,
  ReplaceBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetFullPutErrors,
  ReplaceBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetFullPutResponses,
  ReplaceDashboardTabWidgetsReportingDashboardTabsTabIdWidgetsPutData,
  ReplaceDashboardTabWidgetsReportingDashboardTabsTabIdWidgetsPutErrors,
  ReplaceDashboardTabWidgetsReportingDashboardTabsTabIdWidgetsPutResponses,
  ReplaceInsuranceVisitRatesClinicsInsuranceInsuranceIdRatesPutData,
  ReplaceInsuranceVisitRatesClinicsInsuranceInsuranceIdRatesPutErrors,
  ReplaceInsuranceVisitRatesClinicsInsuranceInsuranceIdRatesPutResponses,
  ReplaceIntakePatientTagsPatientTagsIntakesIntakeIdPutData,
  ReplaceIntakePatientTagsPatientTagsIntakesIntakeIdPutErrors,
  ReplaceIntakePatientTagsPatientTagsIntakesIntakeIdPutResponses,
  ReplacePatientTagsPatientTagsPatientsPatientIdPutData,
  ReplacePatientTagsPatientTagsPatientsPatientIdPutErrors,
  ReplacePatientTagsPatientTagsPatientsPatientIdPutResponses,
  ReplaceQuestionCustomizationsData,
  ReplaceQuestionCustomizationsErrors,
  ReplaceQuestionCustomizationsResponses,
  ReplayStediWebhooksInternalToolsStediReplayPostData,
  ReplayStediWebhooksInternalToolsStediReplayPostErrors,
  ReplayStediWebhooksInternalToolsStediReplayPostResponses,
  ReprocessIntakeEndpointIntakeIntakeIdReprocessPostData,
  ReprocessIntakeEndpointIntakeIntakeIdReprocessPostErrors,
  ReprocessIntakeEndpointIntakeIntakeIdReprocessPostResponses,
  RequestAttachmentUploadChatChannelsChannelIdAttachmentsPostData,
  RequestAttachmentUploadChatChannelsChannelIdAttachmentsPostErrors,
  RequestAttachmentUploadChatChannelsChannelIdAttachmentsPostResponses,
  RequestEsignatureCredentialResetSigningCredentialResetRequestPostData,
  RequestEsignatureCredentialResetSigningCredentialResetRequestPostResponses,
  RescheduleTaskTasksTaskIdReschedulePatchData,
  RescheduleTaskTasksTaskIdReschedulePatchErrors,
  RescheduleTaskTasksTaskIdReschedulePatchResponses,
  RescindInviteUsersRescindInvitePostData,
  RescindInviteUsersRescindInvitePostErrors,
  RescindInviteUsersRescindInvitePostResponses,
  RescrapeKinnserForDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdRescrapeKinnserPostData,
  RescrapeKinnserForDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdRescrapeKinnserPostErrors,
  RescrapeKinnserForDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdRescrapeKinnserPostResponses,
  ReScreenCovidPatientsPatientIdInfectionLogsInfectionLogIdReScreenPostData,
  ReScreenCovidPatientsPatientIdInfectionLogsInfectionLogIdReScreenPostErrors,
  ReScreenCovidPatientsPatientIdInfectionLogsInfectionLogIdReScreenPostResponses,
  ResendInviteUsersResendInvitePostData,
  ResendInviteUsersResendInvitePostErrors,
  ResendInviteUsersResendInvitePostResponses,
  ResetFaxRouteOverrideFaxRouteSettingsFaxTypeIdDeleteData,
  ResetFaxRouteOverrideFaxRouteSettingsFaxTypeIdDeleteErrors,
  ResetFaxRouteOverrideFaxRouteSettingsFaxTypeIdDeleteResponses,
  ResetImporterAgencyImporterResetPostData,
  ResetImporterAgencyImporterResetPostErrors,
  ResetImporterAgencyImporterResetPostResponses,
  ResetImporterLaneBreakerImporterLanesLaneKeyResetBreakerPostData,
  ResetImporterLaneBreakerImporterLanesLaneKeyResetBreakerPostErrors,
  ResetImporterLaneBreakerImporterLanesLaneKeyResetBreakerPostResponses,
  ResolveCodeSchemaReleaseInternalCodeSchemaReleasesResolveGetData,
  ResolveCodeSchemaReleaseInternalCodeSchemaReleasesResolveGetErrors,
  ResolveCodeSchemaReleaseInternalCodeSchemaReleasesResolveGetResponses,
  RestoreQaScrubberItemVisitsVisitIdQaScrubberRuleIdDismissDeleteData,
  RestoreQaScrubberItemVisitsVisitIdQaScrubberRuleIdDismissDeleteErrors,
  RestoreQaScrubberItemVisitsVisitIdQaScrubberRuleIdDismissDeleteResponses,
  RestoreTaskEndpointTasksTaskIdRestorePostData,
  RestoreTaskEndpointTasksTaskIdRestorePostErrors,
  RestoreTaskEndpointTasksTaskIdRestorePostResponses,
  ResumeCaptureInternalKinnserHistoricalCapturesCaptureIdResumePostData,
  ResumeCaptureInternalKinnserHistoricalCapturesCaptureIdResumePostErrors,
  ResumeCaptureInternalKinnserHistoricalCapturesCaptureIdResumePostResponses,
  ResumeImporterLaneImporterLanesLaneKeyResumePostData,
  ResumeImporterLaneImporterLanesLaneKeyResumePostErrors,
  ResumeImporterLaneImporterLanesLaneKeyResumePostResponses,
  RetryDeactivateUserUsersUserIdDeactivateRetryPostData,
  RetryDeactivateUserUsersUserIdDeactivateRetryPostErrors,
  RetryDeactivateUserUsersUserIdDeactivateRetryPostResponses,
  RetryEvvCorrectionInternalToolsEvvCorrectionsRetryRequestIdPostData,
  RetryEvvCorrectionInternalToolsEvvCorrectionsRetryRequestIdPostErrors,
  RetryEvvCorrectionInternalToolsEvvCorrectionsRetryRequestIdPostResponses,
  RetryImporterLaneFailuresImporterQueueRetryFailedPostData,
  RetryImporterLaneFailuresImporterQueueRetryFailedPostErrors,
  RetryImporterLaneFailuresImporterQueueRetryFailedPostResponses,
  RetryImporterQueueItemImporterQueueItemIdRetryPostData,
  RetryImporterQueueItemImporterQueueItemIdRetryPostErrors,
  RetryImporterQueueItemImporterQueueItemIdRetryPostResponses,
  RetryMergeStepsInternalToolsAgenciesAgencyIdUsersMergesMergeIdRetryPostData,
  RetryMergeStepsInternalToolsAgenciesAgencyIdUsersMergesMergeIdRetryPostErrors,
  RetryMergeStepsInternalToolsAgenciesAgencyIdUsersMergesMergeIdRetryPostResponses,
  RetryUserMergeStepsUsersMergesMergeIdRetryPostData,
  RetryUserMergeStepsUsersMergesMergeIdRetryPostErrors,
  RetryUserMergeStepsUsersMergesMergeIdRetryPostResponses,
  ReturnTaskToClinicianEndpointTasksTaskIdReturnToClinicianPostData,
  ReturnTaskToClinicianEndpointTasksTaskIdReturnToClinicianPostErrors,
  ReturnTaskToClinicianEndpointTasksTaskIdReturnToClinicianPostResponses,
  ReverseMergeInternalToolsAgenciesAgencyIdUsersMergesMergeIdReversePostData,
  ReverseMergeInternalToolsAgenciesAgencyIdUsersMergesMergeIdReversePostErrors,
  ReverseMergeInternalToolsAgenciesAgencyIdUsersMergesMergeIdReversePostResponses,
  RevertCheckinOrderOrdersOrderIdRevertCheckinPostData,
  RevertCheckinOrderOrdersOrderIdRevertCheckinPostErrors,
  RevertCheckinOrderOrdersOrderIdRevertCheckinPostResponses,
  RevertCheckoutOrderOrdersOrderIdRevertCheckoutPostData,
  RevertCheckoutOrderOrdersOrderIdRevertCheckoutPostErrors,
  RevertCheckoutOrderOrdersOrderIdRevertCheckoutPostResponses,
  RevertImportedAllergyLineData,
  RevertImportedAllergyLineErrors,
  RevertImportedAllergyLineResponses,
  RevertImportedMedicationLineData,
  RevertImportedMedicationLineErrors,
  RevertImportedMedicationLineResponses,
  RevertToNotReadyNoasNoaIdRevertToNotReadyPostData,
  RevertToNotReadyNoasNoaIdRevertToNotReadyPostErrors,
  RevertToNotReadyNoasNoaIdRevertToNotReadyPostResponses,
  RevertToReadyNoasNoaIdRevertToReadyPostData,
  RevertToReadyNoasNoaIdRevertToReadyPostErrors,
  RevertToReadyNoasNoaIdRevertToReadyPostResponses,
  RogerdocClinicianCreatePassthroughPostData,
  RogerdocClinicianCreatePassthroughPostResponses,
  RogerdocClinicianDeactivatePassthroughPostData,
  RogerdocClinicianDeactivatePassthroughPostErrors,
  RogerdocClinicianDeactivatePassthroughPostResponses,
  RogerdocClinicianResetPassthroughPostData,
  RogerdocClinicianResetPassthroughPostErrors,
  RogerdocClinicianResetPassthroughPostResponses,
  RogerdocCodingPassthroughDeleteData,
  RogerdocCodingPassthroughDeleteErrors,
  RogerdocCodingPassthroughDeleteResponses,
  RogerdocCodingPassthroughGetData,
  RogerdocCodingPassthroughGetErrors,
  RogerdocCodingPassthroughGetResponses,
  RogerdocCodingPassthroughPatchData,
  RogerdocCodingPassthroughPatchErrors,
  RogerdocCodingPassthroughPatchResponses,
  RogerdocCodingPassthroughPostData,
  RogerdocCodingPassthroughPostErrors,
  RogerdocCodingPassthroughPostResponses,
  RogerdocCodingPassthroughPutData,
  RogerdocCodingPassthroughPutErrors,
  RogerdocCodingPassthroughPutResponses,
  RogerdocFetchGoalsTemplatesPassthroughPostData,
  RogerdocFetchGoalsTemplatesPassthroughPostResponses,
  RogerdocGetFeatureFlagsData,
  RogerdocGetFeatureFlagsResponses,
  RogerdocPassthroughDeleteData,
  RogerdocPassthroughDeleteErrors,
  RogerdocPassthroughDeleteResponses,
  RogerdocPassthroughGetData,
  RogerdocPassthroughGetErrors,
  RogerdocPassthroughGetResponses,
  RogerdocPassthroughPatchData,
  RogerdocPassthroughPatchErrors,
  RogerdocPassthroughPatchResponses,
  RogerdocPassthroughPostData,
  RogerdocPassthroughPostErrors,
  RogerdocPassthroughPostResponses,
  RogerdocPassthroughPutData,
  RogerdocPassthroughPutErrors,
  RogerdocPassthroughPutResponses,
  RogerdocPatientSelectorCodingPassthroughDeleteData,
  RogerdocPatientSelectorCodingPassthroughDeleteErrors,
  RogerdocPatientSelectorCodingPassthroughDeleteResponses,
  RogerdocPatientSelectorCodingPassthroughGetData,
  RogerdocPatientSelectorCodingPassthroughGetErrors,
  RogerdocPatientSelectorCodingPassthroughGetResponses,
  RogerdocPatientSelectorCodingPassthroughPatchData,
  RogerdocPatientSelectorCodingPassthroughPatchErrors,
  RogerdocPatientSelectorCodingPassthroughPatchResponses,
  RogerdocPatientSelectorCodingPassthroughPostData,
  RogerdocPatientSelectorCodingPassthroughPostErrors,
  RogerdocPatientSelectorCodingPassthroughPostResponses,
  RogerdocPatientSelectorCodingPassthroughPutData,
  RogerdocPatientSelectorCodingPassthroughPutErrors,
  RogerdocPatientSelectorCodingPassthroughPutResponses,
  RogerdocVisitCodingPassthroughDeleteData,
  RogerdocVisitCodingPassthroughDeleteErrors,
  RogerdocVisitCodingPassthroughDeleteResponses,
  RogerdocVisitCodingPassthroughGetData,
  RogerdocVisitCodingPassthroughGetErrors,
  RogerdocVisitCodingPassthroughGetResponses,
  RogerdocVisitCodingPassthroughPatchData,
  RogerdocVisitCodingPassthroughPatchErrors,
  RogerdocVisitCodingPassthroughPatchResponses,
  RogerdocVisitCodingPassthroughPostData,
  RogerdocVisitCodingPassthroughPostErrors,
  RogerdocVisitCodingPassthroughPostResponses,
  RogerdocVisitCodingPassthroughPutData,
  RogerdocVisitCodingPassthroughPutErrors,
  RogerdocVisitCodingPassthroughPutResponses,
  RogerdocVspUpdateData,
  RogerdocVspUpdateResponses,
  RogerdocWorksheetGoalsPassthroughPostData,
  RogerdocWorksheetGoalsPassthroughPostErrors,
  RogerdocWorksheetGoalsPassthroughPostResponses,
  RootGetData,
  RootGetResponses,
  RouteFaxItemFaxRoutingKindItemIdRoutePostData,
  RouteFaxItemFaxRoutingKindItemIdRoutePostErrors,
  RouteFaxItemFaxRoutingKindItemIdRoutePostResponses,
  RunDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdRunPostData,
  RunDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdRunPostErrors,
  RunDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdRunPostResponses,
  RunOasisShpCheckVisitsOasisManagerVisitIdShpCheckPostData,
  RunOasisShpCheckVisitsOasisManagerVisitIdShpCheckPostErrors,
  RunOasisShpCheckVisitsOasisManagerVisitIdShpCheckPostResponses,
  RunShpOasisBatchNowDevTestDataShpOasisBatchRunPostData,
  RunShpOasisBatchNowDevTestDataShpOasisBatchRunPostErrors,
  RunShpOasisBatchNowDevTestDataShpOasisBatchRunPostResponses,
  SaveFaxRouteOverrideFaxRouteSettingsFaxTypeIdPutData,
  SaveFaxRouteOverrideFaxRouteSettingsFaxTypeIdPutErrors,
  SaveFaxRouteOverrideFaxRouteSettingsFaxTypeIdPutResponses,
  SaveFollowUpPatientsPatientIdInfectionLogsInfectionLogIdFollowUpsPostData,
  SaveFollowUpPatientsPatientIdInfectionLogsInfectionLogIdFollowUpsPostErrors,
  SaveFollowUpPatientsPatientIdInfectionLogsInfectionLogIdFollowUpsPostResponses,
  ScheduleInKinnserIntakeIntakeIdScheduleInKinnserPostData,
  ScheduleInKinnserIntakeIntakeIdScheduleInKinnserPostErrors,
  ScheduleInKinnserIntakeIntakeIdScheduleInKinnserPostResponses,
  ScheduleRogerExistingPatientIntakeIntakeIdScheduleRogerExistingPatientPostData,
  ScheduleRogerExistingPatientIntakeIntakeIdScheduleRogerExistingPatientPostErrors,
  ScheduleRogerExistingPatientIntakeIntakeIdScheduleRogerExistingPatientPostResponses,
  ScreenCandidateMedicationData,
  ScreenCandidateMedicationErrors,
  ScreenCandidateMedicationResponses,
  ScreenMedicationInteractionsData,
  ScreenMedicationInteractionsErrors,
  ScreenMedicationInteractionsResponses,
  SearchAllergiesAllergiesGetData,
  SearchAllergiesAllergiesGetErrors,
  SearchAllergiesAllergiesGetResponses,
  SearchChannelMembersChatChannelsChannelIdMembersGetData,
  SearchChannelMembersChatChannelsChannelIdMembersGetErrors,
  SearchChannelMembersChatChannelsChannelIdMembersGetResponses,
  SearchDiagnosisCodesRouteDiagnosisCodesSearchGetData,
  SearchDiagnosisCodesRouteDiagnosisCodesSearchGetErrors,
  SearchDiagnosisCodesRouteDiagnosisCodesSearchGetResponses,
  SearchEvvCorrectionVisitsInternalToolsEvvCorrectionsVisitsGetData,
  SearchEvvCorrectionVisitsInternalToolsEvvCorrectionsVisitsGetErrors,
  SearchEvvCorrectionVisitsInternalToolsEvvCorrectionsVisitsGetResponses,
  SearchMedicationsEndpointMedicationsGetData,
  SearchMedicationsEndpointMedicationsGetErrors,
  SearchMedicationsEndpointMedicationsGetResponses,
  SearchPayorsEndpointPayorsSearchGetData,
  SearchPayorsEndpointPayorsSearchGetErrors,
  SearchPayorsEndpointPayorsSearchGetResponses,
  SearchRemittanceClaimsRemittancesClaimsSearchGetData,
  SearchRemittanceClaimsRemittancesClaimsSearchGetErrors,
  SearchRemittanceClaimsRemittancesClaimsSearchGetResponses,
  SeedVerifyFixturesDevTestDataVerifyFixturesPostData,
  SeedVerifyFixturesDevTestDataVerifyFixturesPostErrors,
  SeedVerifyFixturesDevTestDataVerifyFixturesPostResponses,
  SendBillingCycleAgainBillingBillingCycleBillingCycleIdSendAgainPostData,
  SendBillingCycleAgainBillingBillingCycleBillingCycleIdSendAgainPostErrors,
  SendBillingCycleAgainBillingBillingCycleBillingCycleIdSendAgainPostResponses,
  SendBillingCycleToClearinghouseBillingBillingCycleBillingCycleIdSendToClearinghousePostData,
  SendBillingCycleToClearinghouseBillingBillingCycleBillingCycleIdSendToClearinghousePostErrors,
  SendBillingCycleToClearinghouseBillingBillingCycleBillingCycleIdSendToClearinghousePostResponses,
  SendFaxInternalToolsOutboundFaxesPostData,
  SendFaxInternalToolsOutboundFaxesPostErrors,
  SendFaxInternalToolsOutboundFaxesPostResponses,
  SendMessageChatChannelsChannelIdMessagesPostData,
  SendMessageChatChannelsChannelIdMessagesPostErrors,
  SendMessageChatChannelsChannelIdMessagesPostResponses,
  SendNoaNoasNoaIdSendPostData,
  SendNoaNoasNoaIdSendPostErrors,
  SendNoaNoasNoaIdSendPostResponses,
  SendOrderFaxOrdersOrderIdFaxPostData,
  SendOrderFaxOrdersOrderIdFaxPostErrors,
  SendOrderFaxOrdersOrderIdFaxPostResponses,
  SendSupportEmailApiSupportContactPostData,
  SendSupportEmailApiSupportContactPostErrors,
  SendSupportEmailApiSupportContactPostResponses,
  SetBillingCyclesStatusVoidBillingBillingCyclesSetStatusVoidPostData,
  SetBillingCyclesStatusVoidBillingBillingCyclesSetStatusVoidPostErrors,
  SetBillingCyclesStatusVoidBillingBillingCyclesSetStatusVoidPostResponses,
  SetBillingCycleStatusPaidBillingBillingCycleBillingCycleIdSetStatusPaidPostData,
  SetBillingCycleStatusPaidBillingBillingCycleBillingCycleIdSetStatusPaidPostErrors,
  SetBillingCycleStatusPaidBillingBillingCycleBillingCycleIdSetStatusPaidPostResponses,
  SetBillingCycleStatusPendingApprovalBillingBillingCycleBillingCycleIdSetStatusPendingApprovalPostData,
  SetBillingCycleStatusPendingApprovalBillingBillingCycleBillingCycleIdSetStatusPendingApprovalPostErrors,
  SetBillingCycleStatusPendingApprovalBillingBillingCycleBillingCycleIdSetStatusPendingApprovalPostResponses,
  SetBillingCycleStatusPendingPaymentBillingBillingCycleBillingCycleIdSetStatusPendingPaymentPostData,
  SetBillingCycleStatusPendingPaymentBillingBillingCycleBillingCycleIdSetStatusPendingPaymentPostErrors,
  SetBillingCycleStatusPendingPaymentBillingBillingCycleBillingCycleIdSetStatusPendingPaymentPostResponses,
  SetBillingCycleStatusReadyToSendBillingBillingCycleBillingCycleIdSetStatusReadyToSendPostData,
  SetBillingCycleStatusReadyToSendBillingBillingCycleBillingCycleIdSetStatusReadyToSendPostErrors,
  SetBillingCycleStatusReadyToSendBillingBillingCycleBillingCycleIdSetStatusReadyToSendPostResponses,
  SetBillingCycleStatusRejectedBillingBillingCycleBillingCycleIdSetStatusRejectedPostData,
  SetBillingCycleStatusRejectedBillingBillingCycleBillingCycleIdSetStatusRejectedPostErrors,
  SetBillingCycleStatusRejectedBillingBillingCycleBillingCycleIdSetStatusRejectedPostResponses,
  SetClassificationFaxClassificationKindItemIdPutData,
  SetClassificationFaxClassificationKindItemIdPutErrors,
  SetClassificationFaxClassificationKindItemIdPutResponses,
  SetDemoTeamDefaultDemoAgencySetupTeamDefaultPutData,
  SetDemoTeamDefaultDemoAgencySetupTeamDefaultPutErrors,
  SetDemoTeamDefaultDemoAgencySetupTeamDefaultPutResponses,
  SetEpisodeRogerChartsFromData,
  SetEpisodeRogerChartsFromErrors,
  SetEpisodeRogerChartsFromResponses,
  SetEsignatureCredentialSigningCredentialPutData,
  SetEsignatureCredentialSigningCredentialPutErrors,
  SetEsignatureCredentialSigningCredentialPutResponses,
  SetGoalsProgressValidationConfigData,
  SetGoalsProgressValidationConfigErrors,
  SetGoalsProgressValidationConfigResponses,
  SetIntakeTestStatusIntakeIntakeIdTestStatusPatchData,
  SetIntakeTestStatusIntakeIntakeIdTestStatusPatchErrors,
  SetIntakeTestStatusIntakeIntakeIdTestStatusPatchResponses,
  SetKinnserClinicLeftOutInternalToolsKinnserAgencySyncAgenciesAgencyIdClinicsClinicKeyLeftOutPutData,
  SetKinnserClinicLeftOutInternalToolsKinnserAgencySyncAgenciesAgencyIdClinicsClinicKeyLeftOutPutErrors,
  SetKinnserClinicLeftOutInternalToolsKinnserAgencySyncAgenciesAgencyIdClinicsClinicKeyLeftOutPutResponses,
  SetMessageReactionChatChannelsChannelIdMessagesMessageIdReactionsPutData,
  SetMessageReactionChatChannelsChannelIdMessagesMessageIdReactionsPutErrors,
  SetMessageReactionChatChannelsChannelIdMessagesMessageIdReactionsPutResponses,
  SetPatientImportBadgePatientsPatientIdImportBadgePatchData,
  SetPatientImportBadgePatientsPatientIdImportBadgePatchErrors,
  SetPatientImportBadgePatientsPatientIdImportBadgePatchResponses,
  SetPatientTestStatusPatientsPatientIdTestStatusPatchData,
  SetPatientTestStatusPatientsPatientIdTestStatusPatchErrors,
  SetPatientTestStatusPatientsPatientIdTestStatusPatchResponses,
  SetPortTypeFaxNumberPortsPortOrderIdPortTypePutData,
  SetPortTypeFaxNumberPortsPortOrderIdPortTypePutErrors,
  SetPortTypeFaxNumberPortsPortOrderIdPortTypePutResponses,
  SetTelnyxOutboundNumberInternalToolsTelnyxFaxLinesAgencyIdOutboundNumberPutData,
  SetTelnyxOutboundNumberInternalToolsTelnyxFaxLinesAgencyIdOutboundNumberPutErrors,
  SetTelnyxOutboundNumberInternalToolsTelnyxFaxLinesAgencyIdOutboundNumberPutResponses,
  SettleInvoiceDifferenceFaxNumberPortsPortOrderIdInvoiceDifferencesFieldPostData,
  SettleInvoiceDifferenceFaxNumberPortsPortOrderIdInvoiceDifferencesFieldPostErrors,
  SettleInvoiceDifferenceFaxNumberPortsPortOrderIdInvoiceDifferencesFieldPostResponses,
  SetVisitAuthorizationVisitsVisitIdAuthorizationPatchData,
  SetVisitAuthorizationVisitsVisitIdAuthorizationPatchErrors,
  SetVisitAuthorizationVisitsVisitIdAuthorizationPatchResponses,
  SetVisitOrderNotRequiredVisitsVisitIdOrderNotRequiredPatchData,
  SetVisitOrderNotRequiredVisitsVisitIdOrderNotRequiredPatchErrors,
  SetVisitOrderNotRequiredVisitsVisitIdOrderNotRequiredPatchResponses,
  SignAndReturnInternalToolsSimulatedOrderFaxesStoredIdSignAndReturnPostData,
  SignAndReturnInternalToolsSimulatedOrderFaxesStoredIdSignAndReturnPostErrors,
  SignAndReturnInternalToolsSimulatedOrderFaxesStoredIdSignAndReturnPostResponses,
  SignLoaFaxNumberPortsPortOrderIdLoaSignaturePostData,
  SignLoaFaxNumberPortsPortOrderIdLoaSignaturePostErrors,
  SignLoaFaxNumberPortsPortOrderIdLoaSignaturePostResponses,
  SignTaskEndpointTasksTaskIdSignPostData,
  SignTaskEndpointTasksTaskIdSignPostErrors,
  SignTaskEndpointTasksTaskIdSignPostResponses,
  SplitFaxDocumentFaxDocumentsDocumentIdSplitPostData,
  SplitFaxDocumentFaxDocumentsDocumentIdSplitPostErrors,
  SplitFaxDocumentFaxDocumentsDocumentIdSplitPostResponses,
  StampIntakeDocumentIntakeDocumentsDocumentIdStampPostData,
  StampIntakeDocumentIntakeDocumentsDocumentIdStampPostErrors,
  StampIntakeDocumentIntakeDocumentsDocumentIdStampPostResponses,
  StartCaptureInternalKinnserHistoricalCapturesPostData,
  StartCaptureInternalKinnserHistoricalCapturesPostErrors,
  StartCaptureInternalKinnserHistoricalCapturesPostResponses,
  StartConversationChatConversationsPostData,
  StartConversationChatConversationsPostErrors,
  StartConversationChatConversationsPostResponses,
  StartKinnserImportWorkflowInternalKinnserImportWorkflowPostData,
  StartKinnserImportWorkflowInternalKinnserImportWorkflowPostErrors,
  StartKinnserImportWorkflowInternalKinnserImportWorkflowPostResponses,
  StartOnboardPatientKinnserPatientOnboardAsyncClinicIdBranchIdPostData,
  StartOnboardPatientKinnserPatientOnboardAsyncClinicIdBranchIdPostErrors,
  StartOnboardPatientKinnserPatientOnboardAsyncClinicIdBranchIdPostResponses,
  StartPatientExternalEmrImportPatientsExternalEmrImportStartPostData,
  StartPatientExternalEmrImportPatientsExternalEmrImportStartPostErrors,
  StartPatientExternalEmrImportPatientsExternalEmrImportStartPostResponses,
  StartReferralFromDraftIntakeDraftsDraftIdReferralPostData,
  StartReferralFromDraftIntakeDraftsDraftIdReferralPostErrors,
  StartReferralFromDraftIntakeDraftsDraftIdReferralPostResponses,
  StartSyncGoalsForAgencyWorkflowGoalsDashboardSyncGoalsForAgencyAsyncPostData,
  StartSyncGoalsForAgencyWorkflowGoalsDashboardSyncGoalsForAgencyAsyncPostErrors,
  StartSyncGoalsForAgencyWorkflowGoalsDashboardSyncGoalsForAgencyAsyncPostResponses,
  StreamEventsEventsStreamGetData,
  StreamEventsEventsStreamGetErrors,
  StreamEventsEventsStreamGetResponses,
  SubmitBulkEnrollClinicsEnrollmentsBulkPostData,
  SubmitBulkEnrollClinicsEnrollmentsBulkPostErrors,
  SubmitBulkEnrollClinicsEnrollmentsBulkPostResponses,
  SubmitClaim837iStediClaim837iPostData,
  SubmitClaim837iStediClaim837iPostErrors,
  SubmitClaim837iStediClaim837iPostResponses,
  SubmitClaimWaystarClaimsSubmit837iPostData,
  SubmitClaimWaystarClaimsSubmit837iPostErrors,
  SubmitClaimWaystarClaimsSubmit837iPostResponses,
  SubmitNoa837iNoasNoaIdSubmitPostData,
  SubmitNoa837iNoasNoaIdSubmitPostErrors,
  SubmitNoa837iNoasNoaIdSubmitPostResponses,
  SubmitPortOrderFaxNumberPortsPortOrderIdSubmitPostData,
  SubmitPortOrderFaxNumberPortsPortOrderIdSubmitPostErrors,
  SubmitPortOrderFaxNumberPortsPortOrderIdSubmitPostResponses,
  SubmitTaskWithoutSignatureEndpointTasksTaskIdSubmitWithoutSignaturePostData,
  SubmitTaskWithoutSignatureEndpointTasksTaskIdSubmitWithoutSignaturePostErrors,
  SubmitTaskWithoutSignatureEndpointTasksTaskIdSubmitWithoutSignaturePostResponses,
  SwitchOrganizationAuthSwitchOrganizationPostData,
  SwitchOrganizationAuthSwitchOrganizationPostErrors,
  SwitchOrganizationAuthSwitchOrganizationPostResponses,
  SyncAgencyProductsInternalInternalAgenciesSyncProductsPostData,
  SyncAgencyProductsInternalInternalAgenciesSyncProductsPostErrors,
  SyncAgencyProductsInternalInternalAgenciesSyncProductsPostResponses,
  SyncClinicAssignmentsUsersUserIdClinicAssignmentsPutData,
  SyncClinicAssignmentsUsersUserIdClinicAssignmentsPutErrors,
  SyncClinicAssignmentsUsersUserIdClinicAssignmentsPutResponses,
  SyncClinicsFromClinicInfoAgencyClinicsSyncFromClinicInfoPostData,
  SyncClinicsFromClinicInfoAgencyClinicsSyncFromClinicInfoPostResponses,
  SyncClinicsFromClinicInfoInternalInternalAgencyClinicsSyncFromClinicInfoPostData,
  SyncClinicsFromClinicInfoInternalInternalAgencyClinicsSyncFromClinicInfoPostErrors,
  SyncClinicsFromClinicInfoInternalInternalAgencyClinicsSyncFromClinicInfoPostResponses,
  SyncEpisodeDateToVisitData,
  SyncEpisodeDateToVisitErrors,
  SyncEpisodeDateToVisitResponses,
  SyncExternalEmrCensusPatientsExternalEmrCensusPostData,
  SyncExternalEmrCensusPatientsExternalEmrCensusPostResponses,
  SyncGoalsForAgencyGoalsDashboardSyncGoalsForAgencyPostData,
  SyncGoalsForAgencyGoalsDashboardSyncGoalsForAgencyPostErrors,
  SyncGoalsForAgencyGoalsDashboardSyncGoalsForAgencyPostResponses,
  SyncNoaPhysicianEpisodesEpisodeIdSyncNoaPhysicianPostData,
  SyncNoaPhysicianEpisodesEpisodeIdSyncNoaPhysicianPostErrors,
  SyncNoaPhysicianEpisodesEpisodeIdSyncNoaPhysicianPostResponses,
  SyncOasisMrnPatientsPatientIdOasisMrnSyncPostData,
  SyncOasisMrnPatientsPatientIdOasisMrnSyncPostErrors,
  SyncOasisMrnPatientsPatientIdOasisMrnSyncPostResponses,
  SyncOnboardingTeamInternalToolsOnboardingTeamConfigSyncPostData,
  SyncOnboardingTeamInternalToolsOnboardingTeamConfigSyncPostErrors,
  SyncOnboardingTeamInternalToolsOnboardingTeamConfigSyncPostResponses,
  TakeOverDatesInternalInternalPatientsTakeOverDatesGetData,
  TakeOverDatesInternalInternalPatientsTakeOverDatesGetErrors,
  TakeOverDatesInternalInternalPatientsTakeOverDatesGetResponses,
  TakeOverEpisodeBasicData,
  TakeOverEpisodeBasicErrors,
  TakeOverEpisodeBasicResponses,
  TakeOverEpisodeData,
  TakeOverEpisodeErrors,
  TakeOverEpisodeResponses,
  TaskUploadForEpisodeKinnserTaskUploadForEpisodeEpisodeKeyClinicIdTabNamePatientTaskKeyPostData,
  TaskUploadForEpisodeKinnserTaskUploadForEpisodeEpisodeKeyClinicIdTabNamePatientTaskKeyPostErrors,
  TaskUploadForEpisodeKinnserTaskUploadForEpisodeEpisodeKeyClinicIdTabNamePatientTaskKeyPostResponses,
  TriggerErrorSentryDebugExceptionGetData,
  TriggerErrorSentryDebugExceptionGetResponses,
  UnarchiveFaxItemFaxRoutingKindItemIdArchiveDeleteData,
  UnarchiveFaxItemFaxRoutingKindItemIdArchiveDeleteErrors,
  UnarchiveFaxItemFaxRoutingKindItemIdArchiveDeleteResponses,
  UndoBillingCycleMarkedPaidBillingBillingCycleBillingCycleIdSetStatusUndoPaidPostData,
  UndoBillingCycleMarkedPaidBillingBillingCycleBillingCycleIdSetStatusUndoPaidPostErrors,
  UndoBillingCycleMarkedPaidBillingBillingCycleBillingCycleIdSetStatusUndoPaidPostResponses,
  UndoBillingCycleMarkedSentBillingBillingCycleBillingCycleIdSetStatusUndoSentPostData,
  UndoBillingCycleMarkedSentBillingBillingCycleBillingCycleIdSetStatusUndoSentPostErrors,
  UndoBillingCycleMarkedSentBillingBillingCycleBillingCycleIdSetStatusUndoSentPostResponses,
  UndoEpisodeTakeOverData,
  UndoEpisodeTakeOverErrors,
  UndoEpisodeTakeOverResponses,
  UnmarkVisitAsMissedVisitsVisitIdMarkMissedDeleteData,
  UnmarkVisitAsMissedVisitsVisitIdMarkMissedDeleteErrors,
  UnmarkVisitAsMissedVisitsVisitIdMarkMissedDeleteResponses,
  UnmarkVisitsExportedVisitsUnmarkExportedPostData,
  UnmarkVisitsExportedVisitsUnmarkExportedPostErrors,
  UnmarkVisitsExportedVisitsUnmarkExportedPostResponses,
  UnsetEpisodeBilledExternallyData,
  UnsetEpisodeBilledExternallyErrors,
  UnsetEpisodeBilledExternallyResponses,
  UpdateActiveDiagnosesDataInternalInternalVisitsVisitIdActiveDiagnosesDataPutData,
  UpdateActiveDiagnosesDataInternalInternalVisitsVisitIdActiveDiagnosesDataPutErrors,
  UpdateActiveDiagnosesDataInternalInternalVisitsVisitIdActiveDiagnosesDataPutResponses,
  UpdateActiveDiagnosesDataVisitsVisitIdActiveDiagnosesDataPutData,
  UpdateActiveDiagnosesDataVisitsVisitIdActiveDiagnosesDataPutErrors,
  UpdateActiveDiagnosesDataVisitsVisitIdActiveDiagnosesDataPutResponses,
  UpdateAdmissionAdmissionsAdmissionIdPatchData,
  UpdateAdmissionAdmissionsAdmissionIdPatchErrors,
  UpdateAdmissionAdmissionsAdmissionIdPatchResponses,
  UpdateAgencyClinicAgencyClinicsAgencyClinicIdPutData,
  UpdateAgencyClinicAgencyClinicsAgencyClinicIdPutErrors,
  UpdateAgencyClinicAgencyClinicsAgencyClinicIdPutResponses,
  UpdateAgencyClinicHhrgCostsAgencyClinicsAgencyClinicIdHhrgCostsPutData,
  UpdateAgencyClinicHhrgCostsAgencyClinicsAgencyClinicIdHhrgCostsPutErrors,
  UpdateAgencyClinicHhrgCostsAgencyClinicsAgencyClinicIdHhrgCostsPutResponses,
  UpdateAgencyConfigAgencyConfigPutData,
  UpdateAgencyConfigAgencyConfigPutErrors,
  UpdateAgencyConfigAgencyConfigPutResponses,
  UpdateAgencyInsuranceClinicsInsuranceInsuranceIdPutData,
  UpdateAgencyInsuranceClinicsInsuranceInsuranceIdPutErrors,
  UpdateAgencyInsuranceClinicsInsuranceInsuranceIdPutResponses,
  UpdateAgencySchedulingPointsSchedulingPointsAgencyPutData,
  UpdateAgencySchedulingPointsSchedulingPointsAgencyPutErrors,
  UpdateAgencySchedulingPointsSchedulingPointsAgencyPutResponses,
  UpdateAgencyTimezoneInternalToolsAgenciesAgencyIdPatchData,
  UpdateAgencyTimezoneInternalToolsAgenciesAgencyIdPatchErrors,
  UpdateAgencyTimezoneInternalToolsAgenciesAgencyIdPatchResponses,
  UpdateBillingCycleNoteBillingBillingCycleNotesNoteIdPatchData,
  UpdateBillingCycleNoteBillingBillingCycleNotesNoteIdPatchErrors,
  UpdateBillingCycleNoteBillingBillingCycleNotesNoteIdPatchResponses,
  UpdateBillingWorksheetApiBillingBillingCycleUpdateWorksheetPostData,
  UpdateBillingWorksheetApiBillingBillingCycleUpdateWorksheetPostErrors,
  UpdateBillingWorksheetApiBillingBillingCycleUpdateWorksheetPostResponses,
  UpdateClinicAccessUsersUserIdClinicAccessPutData,
  UpdateClinicAccessUsersUserIdClinicAccessPutErrors,
  UpdateClinicAccessUsersUserIdClinicAccessPutResponses,
  UpdateClinicDisciplinesUsersUserIdClinicDisciplinesPutData,
  UpdateClinicDisciplinesUsersUserIdClinicDisciplinesPutErrors,
  UpdateClinicDisciplinesUsersUserIdClinicDisciplinesPutResponses,
  UpdateClinicPhysicianAdminClinicPhysiciansClinicPhysicianIdPutData,
  UpdateClinicPhysicianAdminClinicPhysiciansClinicPhysicianIdPutErrors,
  UpdateClinicPhysicianAdminClinicPhysiciansClinicPhysicianIdPutResponses,
  UpdateClinicSchedulingPointsSchedulingPointsClinicsClinicIdPutData,
  UpdateClinicSchedulingPointsSchedulingPointsClinicsClinicIdPutErrors,
  UpdateClinicSchedulingPointsSchedulingPointsClinicsClinicIdPutResponses,
  UpdateClinicSetupUsersUserIdClinicSetupPutData,
  UpdateClinicSetupUsersUserIdClinicSetupPutErrors,
  UpdateClinicSetupUsersUserIdClinicSetupPutResponses,
  UpdateCurrentAgencyAgenciesPutData,
  UpdateCurrentAgencyAgenciesPutErrors,
  UpdateCurrentAgencyAgenciesPutResponses,
  UpdateCurrentAgencyWrittenNameAgenciesWrittenNamePutData,
  UpdateCurrentAgencyWrittenNameAgenciesWrittenNamePutErrors,
  UpdateCurrentAgencyWrittenNameAgenciesWrittenNamePutResponses,
  UpdateCurrentEpisodeCaseManagerPatientsPatientIdCurrentEpisodeCaseManagerPatchData,
  UpdateCurrentEpisodeCaseManagerPatientsPatientIdCurrentEpisodeCaseManagerPatchErrors,
  UpdateCurrentEpisodeCaseManagerPatientsPatientIdCurrentEpisodeCaseManagerPatchResponses,
  UpdateCurrentEpisodeClinicalManagerPatientsPatientIdCurrentEpisodeClinicalManagerPatchData,
  UpdateCurrentEpisodeClinicalManagerPatientsPatientIdCurrentEpisodeClinicalManagerPatchErrors,
  UpdateCurrentEpisodeClinicalManagerPatientsPatientIdCurrentEpisodeClinicalManagerPatchResponses,
  UpdateCurrentEpisodeDisasterTriageCodesPatientsPatientIdCurrentEpisodeDisasterTriageCodesPatchData,
  UpdateCurrentEpisodeDisasterTriageCodesPatientsPatientIdCurrentEpisodeDisasterTriageCodesPatchErrors,
  UpdateCurrentEpisodeDisasterTriageCodesPatientsPatientIdCurrentEpisodeDisasterTriageCodesPatchResponses,
  UpdateDashboardOnboardingTaskData,
  UpdateDashboardOnboardingTaskErrors,
  UpdateDashboardOnboardingTaskResponses,
  UpdateDashboardTabReportingDashboardTabsTabIdPatchData,
  UpdateDashboardTabReportingDashboardTabsTabIdPatchErrors,
  UpdateDashboardTabReportingDashboardTabsTabIdPatchResponses,
  UpdateDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdPutData,
  UpdateDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdPutErrors,
  UpdateDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdPutResponses,
  UpdateDiagnosisPositionsInternalInternalVisitsVisitIdDiagnosesPositionsPutData,
  UpdateDiagnosisPositionsInternalInternalVisitsVisitIdDiagnosesPositionsPutErrors,
  UpdateDiagnosisPositionsInternalInternalVisitsVisitIdDiagnosesPositionsPutResponses,
  UpdateDiagnosisPositionsVisitsVisitIdDiagnosesPositionsPutData,
  UpdateDiagnosisPositionsVisitsVisitIdDiagnosesPositionsPutErrors,
  UpdateDiagnosisPositionsVisitsVisitIdDiagnosesPositionsPutResponses,
  UpdateEmployeeTypesUsersUserIdEmployeeTypePutData,
  UpdateEmployeeTypesUsersUserIdEmployeeTypePutErrors,
  UpdateEmployeeTypesUsersUserIdEmployeeTypePutResponses,
  UpdateEpisodeAssignmentsEpisodesEpisodeIdAssignmentsPatchData,
  UpdateEpisodeAssignmentsEpisodesEpisodeIdAssignmentsPatchErrors,
  UpdateEpisodeAssignmentsEpisodesEpisodeIdAssignmentsPatchResponses,
  UpdateEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdPutData,
  UpdateEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdPutErrors,
  UpdateEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdPutResponses,
  UpdateEpisodeEpisodesEpisodeIdPatchData,
  UpdateEpisodeEpisodesEpisodeIdPatchErrors,
  UpdateEpisodeEpisodesEpisodeIdPatchResponses,
  UpdateEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdPutData,
  UpdateEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdPutErrors,
  UpdateEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdPutResponses,
  UpdateEpisodeNoteEpisodesEpisodeIdNotesNoteIdPatchData,
  UpdateEpisodeNoteEpisodesEpisodeIdNotesNoteIdPatchErrors,
  UpdateEpisodeNoteEpisodesEpisodeIdNotesNoteIdPatchResponses,
  UpdateEpisodeWorksheetEpisodesEpisodeIdWorksheetPutData,
  UpdateEpisodeWorksheetEpisodesEpisodeIdWorksheetPutErrors,
  UpdateEpisodeWorksheetEpisodesEpisodeIdWorksheetPutResponses,
  UpdateFallLogEndpointPatientsPatientIdFallLogsFallLogIdPutData,
  UpdateFallLogEndpointPatientsPatientIdFallLogsFallLogIdPutErrors,
  UpdateFallLogEndpointPatientsPatientIdFallLogsFallLogIdPutResponses,
  UpdateFaxNumberMappingInternalToolsFaxNumberMappingsMappingIdPatchData,
  UpdateFaxNumberMappingInternalToolsFaxNumberMappingsMappingIdPatchErrors,
  UpdateFaxNumberMappingInternalToolsFaxNumberMappingsMappingIdPatchResponses,
  UpdateFaxTypeInternalToolsFaxTypesFaxTypeIdPatchData,
  UpdateFaxTypeInternalToolsFaxTypesFaxTypeIdPatchErrors,
  UpdateFaxTypeInternalToolsFaxTypesFaxTypeIdPatchResponses,
  UpdateFormTemplateAdminFormTemplatesTemplateIdPutData,
  UpdateFormTemplateAdminFormTemplatesTemplateIdPutErrors,
  UpdateFormTemplateAdminFormTemplatesTemplateIdPutResponses,
  UpdateGoalForVisitGoalsVisitVisitIdPatientGoalIdPutData,
  UpdateGoalForVisitGoalsVisitVisitIdPatientGoalIdPutErrors,
  UpdateGoalForVisitGoalsVisitVisitIdPatientGoalIdPutResponses,
  UpdateGroupChatGroupsGroupIdPutData,
  UpdateGroupChatGroupsGroupIdPutErrors,
  UpdateGroupChatGroupsGroupIdPutResponses,
  UpdateImporterSettingsImporterSettingsPutData,
  UpdateImporterSettingsImporterSettingsPutErrors,
  UpdateImporterSettingsImporterSettingsPutResponses,
  UpdateInfectionLogEndpointPatientsPatientIdInfectionLogsInfectionLogIdPutData,
  UpdateInfectionLogEndpointPatientsPatientIdInfectionLogsInfectionLogIdPutErrors,
  UpdateInfectionLogEndpointPatientsPatientIdInfectionLogsInfectionLogIdPutResponses,
  UpdateIntakeDocumentIntakeDocumentsDocumentIdPatchData,
  UpdateIntakeDocumentIntakeDocumentsDocumentIdPatchErrors,
  UpdateIntakeDocumentIntakeDocumentsDocumentIdPatchResponses,
  UpdateIntakeEndpointIntakeIntakeIdPutData,
  UpdateIntakeEndpointIntakeIntakeIdPutErrors,
  UpdateIntakeEndpointIntakeIntakeIdPutResponses,
  UpdateIntakeFieldsEndpointIntakeIntakeIdFieldsPatchData,
  UpdateIntakeFieldsEndpointIntakeIntakeIdFieldsPatchErrors,
  UpdateIntakeFieldsEndpointIntakeIntakeIdFieldsPatchResponses,
  UpdateIntakeStatusEndpointIntakeIntakeIdStatusPutData,
  UpdateIntakeStatusEndpointIntakeIntakeIdStatusPutErrors,
  UpdateIntakeStatusEndpointIntakeIntakeIdStatusPutResponses,
  UpdateInternalReferralSourceAdminInternalReferralSourcesSourceIdPutData,
  UpdateInternalReferralSourceAdminInternalReferralSourcesSourceIdPutErrors,
  UpdateInternalReferralSourceAdminInternalReferralSourcesSourceIdPutResponses,
  UpdateMarMedicationPatientsPatientIdVisitsVisitIdMarMarIdPutData,
  UpdateMarMedicationPatientsPatientIdVisitsVisitIdMarMarIdPutErrors,
  UpdateMarMedicationPatientsPatientIdVisitsVisitIdMarMarIdPutResponses,
  UpdateMiscTaskMiscTasksMiscTaskIdPatchData,
  UpdateMiscTaskMiscTasksMiscTaskIdPatchErrors,
  UpdateMiscTaskMiscTasksMiscTaskIdPatchResponses,
  UpdateMissedVisitDataVisitsVisitIdMissedDataPatchData,
  UpdateMissedVisitDataVisitsVisitIdMissedDataPatchErrors,
  UpdateMissedVisitDataVisitsVisitIdMissedDataPatchResponses,
  UpdateNoaNoasNoaIdPatchData,
  UpdateNoaNoasNoaIdPatchErrors,
  UpdateNoaNoasNoaIdPatchResponses,
  UpdateOnboardingTeamConfigInternalToolsOnboardingTeamConfigPutData,
  UpdateOnboardingTeamConfigInternalToolsOnboardingTeamConfigPutErrors,
  UpdateOnboardingTeamConfigInternalToolsOnboardingTeamConfigPutResponses,
  UpdateOrderOrdersOrderIdPatchData,
  UpdateOrderOrdersOrderIdPatchErrors,
  UpdateOrderOrdersOrderIdPatchResponses,
  UpdatePatientCommunicationPatientCommunicationsCommunicationIdPutData,
  UpdatePatientCommunicationPatientCommunicationsCommunicationIdPutErrors,
  UpdatePatientCommunicationPatientCommunicationsCommunicationIdPutResponses,
  UpdatePatientDocumentPatientsPatientIdDocumentsDocumentIdPatchData,
  UpdatePatientDocumentPatientsPatientIdDocumentsDocumentIdPatchErrors,
  UpdatePatientDocumentPatientsPatientIdDocumentsDocumentIdPatchResponses,
  UpdatePatientInsurancePatientsPatientIdInsurancePatientInsuranceIdPutData,
  UpdatePatientInsurancePatientsPatientIdInsurancePatientInsuranceIdPutErrors,
  UpdatePatientInsurancePatientsPatientIdInsurancePatientInsuranceIdPutResponses,
  UpdatePatientMedicationInternalPatientsPatientIdMedicationsMedicationIdPutData,
  UpdatePatientMedicationInternalPatientsPatientIdMedicationsMedicationIdPutErrors,
  UpdatePatientMedicationInternalPatientsPatientIdMedicationsMedicationIdPutResponses,
  UpdatePatientMedicationPatientsPatientIdMedicationsMedicationIdPutData,
  UpdatePatientMedicationPatientsPatientIdMedicationsMedicationIdPutErrors,
  UpdatePatientMedicationPatientsPatientIdMedicationsMedicationIdPutResponses,
  UpdatePatientPatientsPatientIdPutData,
  UpdatePatientPatientsPatientIdPutErrors,
  UpdatePatientPatientsPatientIdPutResponses,
  UpdatePatientWoundPatientsPatientIdWoundsWoundIdPutData,
  UpdatePatientWoundPatientsPatientIdWoundsWoundIdPutErrors,
  UpdatePatientWoundPatientsPatientIdWoundsWoundIdPutResponses,
  UpdatePayorEndpointPayorsPayorIdPutData,
  UpdatePayorEndpointPayorsPayorIdPutErrors,
  UpdatePayorEndpointPayorsPayorIdPutResponses,
  UpdatePayorNoaSettingsInternalToolsPayorsPayorIdNoaSettingsPatchData,
  UpdatePayorNoaSettingsInternalToolsPayorsPayorIdNoaSettingsPatchErrors,
  UpdatePayorNoaSettingsInternalToolsPayorsPayorIdNoaSettingsPatchResponses,
  UpdatePayrollSettingsPayrollSettingsPutData,
  UpdatePayrollSettingsPayrollSettingsPutErrors,
  UpdatePayrollSettingsPayrollSettingsPutResponses,
  UpdatePermissionRbacPermissionsPermissionIdPatchData,
  UpdatePermissionRbacPermissionsPermissionIdPatchErrors,
  UpdatePermissionRbacPermissionsPermissionIdPatchResponses,
  UpdatePortOrderFaxNumberPortsPortOrderIdPatchData,
  UpdatePortOrderFaxNumberPortsPortOrderIdPatchErrors,
  UpdatePortOrderFaxNumberPortsPortOrderIdPatchResponses,
  UpdateProductUpdateEntryInternalToolsProductUpdatesManagementPatchData,
  UpdateProductUpdateEntryInternalToolsProductUpdatesManagementPatchErrors,
  UpdateProductUpdateEntryInternalToolsProductUpdatesManagementPatchResponses,
  UpdateRemittanceWorksheetRemittancesRemittanceIdPutData,
  UpdateRemittanceWorksheetRemittancesRemittanceIdPutErrors,
  UpdateRemittanceWorksheetRemittancesRemittanceIdPutResponses,
  UpdateReportDefinitionReportingReportDefinitionsDefinitionIdPatchData,
  UpdateReportDefinitionReportingReportDefinitionsDefinitionIdPatchErrors,
  UpdateReportDefinitionReportingReportDefinitionsDefinitionIdPatchResponses,
  UpdateReportWidgetReportingWidgetsWidgetIdPatchData,
  UpdateReportWidgetReportingWidgetsWidgetIdPatchErrors,
  UpdateReportWidgetReportingWidgetsWidgetIdPatchResponses,
  UpdateRoleRbacRolesRoleIdPatchData,
  UpdateRoleRbacRolesRoleIdPatchErrors,
  UpdateRoleRbacRolesRoleIdPatchResponses,
  UpdateTaskDetailsKinnserPatientTaskDetailsClinicIdPostData,
  UpdateTaskDetailsKinnserPatientTaskDetailsClinicIdPostErrors,
  UpdateTaskDetailsKinnserPatientTaskDetailsClinicIdPostResponses,
  UpdateTaskDetailsNotesTasksTaskIdDetailsNotesPutData,
  UpdateTaskDetailsNotesTasksTaskIdDetailsNotesPutErrors,
  UpdateTaskDetailsNotesTasksTaskIdDetailsNotesPutResponses,
  UpdateTaskDetailsVisitFieldsTasksTaskIdDetailsVisitFieldsPutData,
  UpdateTaskDetailsVisitFieldsTasksTaskIdDetailsVisitFieldsPutErrors,
  UpdateTaskDetailsVisitFieldsTasksTaskIdDetailsVisitFieldsPutResponses,
  UpdateTaskNotesTasksTaskIdNotesPutData,
  UpdateTaskNotesTasksTaskIdNotesPutErrors,
  UpdateTaskNotesTasksTaskIdNotesPutResponses,
  UpdateTaskOutsideRecordEndpointTasksTaskIdOutsideRecordPatchData,
  UpdateTaskOutsideRecordEndpointTasksTaskIdOutsideRecordPatchErrors,
  UpdateTaskOutsideRecordEndpointTasksTaskIdOutsideRecordPatchResponses,
  UpdateTaskTypesTaskTypesPutData,
  UpdateTaskTypesTaskTypesPutErrors,
  UpdateTaskTypesTaskTypesPutResponses,
  UpdateTemporalScalingOverrideInternalToolsTemporalScalingOverridesPutData,
  UpdateTemporalScalingOverrideInternalToolsTemporalScalingOverridesPutErrors,
  UpdateTemporalScalingOverrideInternalToolsTemporalScalingOverridesPutResponses,
  UpdateUserCredentialsUsersUserIdCredentialsPatchData,
  UpdateUserCredentialsUsersUserIdCredentialsPatchErrors,
  UpdateUserCredentialsUsersUserIdCredentialsPatchResponses,
  UpdateUserLicenseTypeAdminUserLicenseTypesTypeIdPutData,
  UpdateUserLicenseTypeAdminUserLicenseTypesTypeIdPutErrors,
  UpdateUserLicenseTypeAdminUserLicenseTypesTypeIdPutResponses,
  UpdateUserLicenseUserLicensesLicenseIdPutData,
  UpdateUserLicenseUserLicensesLicenseIdPutErrors,
  UpdateUserLicenseUserLicensesLicenseIdPutResponses,
  UpdateUserNpiUsersUserIdNpiPatchData,
  UpdateUserNpiUsersUserIdNpiPatchErrors,
  UpdateUserNpiUsersUserIdNpiPatchResponses,
  UpdateUserRolesUsersUserIdRolesPutData,
  UpdateUserRolesUsersUserIdRolesPutErrors,
  UpdateUserRolesUsersUserIdRolesPutResponses,
  UpdateUserTypeUsersUserIdUserTypePatchData,
  UpdateUserTypeUsersUserIdUserTypePatchErrors,
  UpdateUserTypeUsersUserIdUserTypePatchResponses,
  UpdateUserUsersUserIdPutData,
  UpdateUserUsersUserIdPutErrors,
  UpdateUserUsersUserIdPutResponses,
  UpdateVisitDataInternalInternalVisitsVisitIdDataPutData,
  UpdateVisitDataInternalInternalVisitsVisitIdDataPutErrors,
  UpdateVisitDataInternalInternalVisitsVisitIdDataPutResponses,
  UpdateVisitDataVisitsVisitIdDataPutData,
  UpdateVisitDataVisitsVisitIdDataPutErrors,
  UpdateVisitDataVisitsVisitIdDataPutResponses,
  UpdateVisitDiagnosisInternalInternalVisitsDiagnosesDiagnosisIdPutData,
  UpdateVisitDiagnosisInternalInternalVisitsDiagnosesDiagnosisIdPutErrors,
  UpdateVisitDiagnosisInternalInternalVisitsDiagnosesDiagnosisIdPutResponses,
  UpdateVisitDiagnosisVisitsDiagnosesDiagnosisIdPutData,
  UpdateVisitDiagnosisVisitsDiagnosesDiagnosisIdPutErrors,
  UpdateVisitDiagnosisVisitsDiagnosesDiagnosisIdPutResponses,
  UpdateVisitInternalInternalVisitsVisitIdPutData,
  UpdateVisitInternalInternalVisitsVisitIdPutErrors,
  UpdateVisitInternalInternalVisitsVisitIdPutResponses,
  UpdateVisitTaskDetailAnswersVisitsVisitIdTaskDetailAnswersPutData,
  UpdateVisitTaskDetailAnswersVisitsVisitIdTaskDetailAnswersPutErrors,
  UpdateVisitTaskDetailAnswersVisitsVisitIdTaskDetailAnswersPutResponses,
  UpdateVisitVisitsVisitIdPutData,
  UpdateVisitVisitsVisitIdPutErrors,
  UpdateVisitVisitsVisitIdPutResponses,
  UpdateWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsAssessmentIdPutData,
  UpdateWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsAssessmentIdPutErrors,
  UpdateWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsAssessmentIdPutResponses,
  UploadClaimDocumentForPatientStediPatientsPatientIdClaimDocumentsPostData,
  UploadClaimDocumentForPatientStediPatientsPatientIdClaimDocumentsPostErrors,
  UploadClaimDocumentForPatientStediPatientsPatientIdClaimDocumentsPostResponses,
  UploadCodingFilesRogerdocCodingUploadFilesPostData,
  UploadCodingFilesRogerdocCodingUploadFilesPostErrors,
  UploadCodingFilesRogerdocCodingUploadFilesPostResponses,
  UploadDocumentToIntakeIntakeIntakeIdDocumentsPostData,
  UploadDocumentToIntakeIntakeIntakeIdDocumentsPostErrors,
  UploadDocumentToIntakeIntakeIntakeIdDocumentsPostResponses,
  UploadFileAndCreateIntakeIntakeUploadPostData,
  UploadFileAndCreateIntakeIntakeUploadPostErrors,
  UploadFileAndCreateIntakeIntakeUploadPostResponses,
  UploadImporterRosterImporterRosterPostData,
  UploadImporterRosterImporterRosterPostErrors,
  UploadImporterRosterImporterRosterPostResponses,
  UploadMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsPostData,
  UploadMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsPostErrors,
  UploadMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsPostResponses,
  UploadMultipleFilesAndCreateIntakeIntakeUploadMultiplePostData,
  UploadMultipleFilesAndCreateIntakeIntakeUploadMultiplePostErrors,
  UploadMultipleFilesAndCreateIntakeIntakeUploadMultiplePostResponses,
  UploadPatientDocumentPatientsPatientIdDocumentsPostData,
  UploadPatientDocumentPatientsPatientIdDocumentsPostErrors,
  UploadPatientDocumentPatientsPatientIdDocumentsPostResponses,
  UploadPortDocumentFaxNumberPortsPortOrderIdDocumentsDocumentKindPostData,
  UploadPortDocumentFaxNumberPortsPortOrderIdDocumentsDocumentKindPostErrors,
  UploadPortDocumentFaxNumberPortsPortOrderIdDocumentsDocumentKindPostResponses,
  UploadProductUpdateImageInternalToolsProductUpdatesManagementImagesPostData,
  UploadProductUpdateImageInternalToolsProductUpdatesManagementImagesPostErrors,
  UploadProductUpdateImageInternalToolsProductUpdatesManagementImagesPostResponses,
  UploadRemittanceRemittancesUploadPostData,
  UploadRemittanceRemittancesUploadPostErrors,
  UploadRemittanceRemittancesUploadPostResponses,
  UploadTaskDetailsDocumentTasksTaskIdDetailsDocumentsPostData,
  UploadTaskDetailsDocumentTasksTaskIdDetailsDocumentsPostErrors,
  UploadTaskDetailsDocumentTasksTaskIdDetailsDocumentsPostResponses,
  UploadTaskDocumentTasksTaskIdDocumentsPostData,
  UploadTaskDocumentTasksTaskIdDocumentsPostErrors,
  UploadTaskDocumentTasksTaskIdDocumentsPostResponses,
  UploadTaskOutsideRecordDocumentEndpointTasksTaskIdOutsideRecordDocumentsPostData,
  UploadTaskOutsideRecordDocumentEndpointTasksTaskIdOutsideRecordDocumentsPostErrors,
  UploadTaskOutsideRecordDocumentEndpointTasksTaskIdOutsideRecordDocumentsPostResponses,
  UploadUserLicenseDocumentUserLicensesLicenseIdDocumentsPostData,
  UploadUserLicenseDocumentUserLicensesLicenseIdDocumentsPostErrors,
  UploadUserLicenseDocumentUserLicensesLicenseIdDocumentsPostResponses,
  UploadWoundAttachmentPatientsPatientIdWoundsWoundIdAttachmentsPostData,
  UploadWoundAttachmentPatientsPatientIdWoundsWoundIdAttachmentsPostErrors,
  UploadWoundAttachmentPatientsPatientIdWoundsWoundIdAttachmentsPostResponses,
  UpsertPatientPharmacyPatientsPatientIdPharmacyPutData,
  UpsertPatientPharmacyPatientsPatientIdPharmacyPutErrors,
  UpsertPatientPharmacyPatientsPatientIdPharmacyPutResponses,
  ValidateNoaNoasNoaIdValidatePostData,
  ValidateNoaNoasNoaIdValidatePostErrors,
  ValidateNoaNoasNoaIdValidatePostResponses,
  ValidateOasisVisitsVisitIdValidateOasisPostData,
  ValidateOasisVisitsVisitIdValidateOasisPostErrors,
  ValidateOasisVisitsVisitIdValidateOasisPostResponses,
  VerifyEvvCorrectionInternalToolsEvvCorrectionsVerifyPostData,
  VerifyEvvCorrectionInternalToolsEvvCorrectionsVerifyPostErrors,
  VerifyEvvCorrectionInternalToolsEvvCorrectionsVerifyPostResponses,
  VerifyPatientDocumentSignaturePatientsPatientIdDocumentsDocumentIdVerifyGetData,
  VerifyPatientDocumentSignaturePatientsPatientIdDocumentsDocumentIdVerifyGetErrors,
  VerifyPatientDocumentSignaturePatientsPatientIdDocumentsDocumentIdVerifyGetResponses,
  VerifyTaskSignatureBypassEndpointTasksTaskIdSignatureBypassesBypassIdVerifyGetData,
  VerifyTaskSignatureBypassEndpointTasksTaskIdSignatureBypassesBypassIdVerifyGetErrors,
  VerifyTaskSignatureBypassEndpointTasksTaskIdSignatureBypassesBypassIdVerifyGetResponses,
  VerifyTaskSignatureEndpointTasksTaskIdSignaturesSignatureIdVerifyGetData,
  VerifyTaskSignatureEndpointTasksTaskIdSignaturesSignatureIdVerifyGetErrors,
  VerifyTaskSignatureEndpointTasksTaskIdSignaturesSignatureIdVerifyGetResponses,
  WriteKinnserClinicIdentityInternalToolsKinnserAgencySyncAgenciesAgencyIdClinicsClinicKeyIdentityPutData,
  WriteKinnserClinicIdentityInternalToolsKinnserAgencySyncAgenciesAgencyIdClinicsClinicKeyIdentityPutErrors,
  WriteKinnserClinicIdentityInternalToolsKinnserAgencySyncAgenciesAgencyIdClinicsClinicKeyIdentityPutResponses,
} from './types.gen';

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Trigger Error
 */
export const triggerErrorSentryDebugExceptionGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<TriggerErrorSentryDebugExceptionGetData, ThrowOnError>
): RequestResult<
  TriggerErrorSentryDebugExceptionGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    TriggerErrorSentryDebugExceptionGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/sentry-debug/exception',
    ...options,
  });

/**
 * Log Error
 */
export const logErrorSentryDebugLogErrorGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<LogErrorSentryDebugLogErrorGetData, ThrowOnError>
): RequestResult<
  LogErrorSentryDebugLogErrorGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    LogErrorSentryDebugLogErrorGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/sentry-debug/log-error',
    ...options,
  });

/**
 * Health Check
 *
 * Health check endpoint
 */
export const healthCheckHealthGet = <ThrowOnError extends boolean = false>(
  options?: Options<HealthCheckHealthGetData, ThrowOnError>
): RequestResult<HealthCheckHealthGetResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    HealthCheckHealthGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/health',
    ...options,
  });

/**
 * Database Health Check
 */
export const databaseHealthCheckHealthDbGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<DatabaseHealthCheckHealthDbGetData, ThrowOnError>
): RequestResult<
  DatabaseHealthCheckHealthDbGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    DatabaseHealthCheckHealthDbGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/health/db',
    ...options,
  });

/**
 * Decode Payloads
 */
export const decodePayloadsTemporalCodecDecodePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DecodePayloadsTemporalCodecDecodePostData, ThrowOnError>
): RequestResult<
  DecodePayloadsTemporalCodecDecodePostResponses,
  DecodePayloadsTemporalCodecDecodePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DecodePayloadsTemporalCodecDecodePostResponses,
    DecodePayloadsTemporalCodecDecodePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/temporal-codec/decode',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Encode Payloads
 */
export const encodePayloadsTemporalCodecEncodePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<EncodePayloadsTemporalCodecEncodePostData, ThrowOnError>
): RequestResult<
  EncodePayloadsTemporalCodecEncodePostResponses,
  EncodePayloadsTemporalCodecEncodePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    EncodePayloadsTemporalCodecEncodePostResponses,
    EncodePayloadsTemporalCodecEncodePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/temporal-codec/encode',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Poll Events
 *
 * The polling fallback. Same frames as the stream for the same cursor.
 *
 * Stays mounted on the API on every stage: polling runs precisely when the
 * stream service is unreachable.
 *
 * The two parity rules with the stream handler:
 *
 * * a cursor above the user's max seq is unknown, so the answer is the same
 * ``reset`` frame the stream sends, not an empty page the client would poll
 * forever (acceptance criteria 14 and 20);
 * * every poll is a fresh read with no recent-seq memory, which is exactly the
 * stream's first read after a resume, so it carries the same 60 s recovery
 * read below the cursor. A transaction that took a lower seq and committed
 * late is therefore found here too. Rows at or below ``after`` can come back
 * a second time inside that window; the client's duplicate-seq guard drops
 * them (acceptance criterion 16).
 *
 * The two reads are separate queries, as they are in the stream handler, so a
 * burst of recent rows below the cursor can never fill the forward page and
 * stop the poll from advancing. A body can therefore hold up to ``2 * limit``
 * frames: the recovery rows first, then the page after the cursor.
 */
export const pollEventsEventsGet = <ThrowOnError extends boolean = false>(
  options?: Options<PollEventsEventsGetData, ThrowOnError>
): RequestResult<
  PollEventsEventsGetResponses,
  PollEventsEventsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    PollEventsEventsGetResponses,
    PollEventsEventsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/events',
    ...options,
  });

/**
 * Stream Events
 *
 * One long-lived SSE connection per browser tab.
 *
 * ``Last-Event-ID`` is what the browser sends when it reconnects on its own;
 * ``after`` is what the wrapper sends on a fresh connection, because
 * EventSource cannot set headers. Neither form means "start at my current max
 * seq and send no backlog".
 *
 * The route takes no ``EventBrokerDep``: it publishes nothing. Only producer
 * routes inject the broker (spec: Dependency injection), and AGENTS.md forbids
 * a dependency parameter the handler never reads.
 */
export const streamEventsEventsStreamGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<StreamEventsEventsStreamGetData, ThrowOnError>
): RequestResult<
  StreamEventsEventsStreamGetResponses,
  StreamEventsEventsStreamGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    StreamEventsEventsStreamGetResponses,
    StreamEventsEventsStreamGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/events/stream',
    ...options,
  });

/**
 * Login
 *
 * Redirect to WorkOS SSO login page.
 */
export const loginAuthLoginGet = <ThrowOnError extends boolean = false>(
  options?: Options<LoginAuthLoginGetData, ThrowOnError>
): RequestResult<LoginAuthLoginGetResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    LoginAuthLoginGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/auth/login',
    ...options,
  });

/**
 * Auth Callback
 *
 * Handle the WorkOS callback while keeping credential data out of telemetry.
 */
export const authCallbackAuthCallbackGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<AuthCallbackAuthCallbackGetData, ThrowOnError>
): RequestResult<
  AuthCallbackAuthCallbackGetResponses,
  AuthCallbackAuthCallbackGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    AuthCallbackAuthCallbackGetResponses,
    AuthCallbackAuthCallbackGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/auth/callback',
    ...options,
  });

/**
 * Logout
 *
 * Logout user by clearing cookies and triggering WorkOS logout.
 */
export const logoutAuthLogoutGet = <ThrowOnError extends boolean = false>(
  options?: Options<LogoutAuthLogoutGetData, ThrowOnError>
): RequestResult<LogoutAuthLogoutGetResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    LogoutAuthLogoutGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/auth/logout',
    ...options,
  });

/**
 * Get Current Ctx Info
 *
 * Get current user information with agency details.
 */
export const getCurrentCtxInfoAuthMeGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetCurrentCtxInfoAuthMeGetData, ThrowOnError>
): RequestResult<
  GetCurrentCtxInfoAuthMeGetResponses,
  GetCurrentCtxInfoAuthMeGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetCurrentCtxInfoAuthMeGetResponses,
    GetCurrentCtxInfoAuthMeGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/auth/me',
    ...options,
  });

/**
 * Get Widget Token
 *
 * Get widget token for WorkOS widgets (e.g., OrganizationSwitcher).
 * Returns the access token from the current session.
 */
export const getWidgetTokenAuthWidgetTokenGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetWidgetTokenAuthWidgetTokenGetData, ThrowOnError>
): RequestResult<
  GetWidgetTokenAuthWidgetTokenGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetWidgetTokenAuthWidgetTokenGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/auth/widget-token',
    ...options,
  });

/**
 * Switch Organization
 *
 * Switch to a different organization.
 * Returns a redirect URL to re-authenticate with the new organization.
 */
export const switchOrganizationAuthSwitchOrganizationPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SwitchOrganizationAuthSwitchOrganizationPostData,
    ThrowOnError
  >
): RequestResult<
  SwitchOrganizationAuthSwitchOrganizationPostResponses,
  SwitchOrganizationAuthSwitchOrganizationPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SwitchOrganizationAuthSwitchOrganizationPostResponses,
    SwitchOrganizationAuthSwitchOrganizationPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/auth/switch-organization',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get User Organizations
 *
 * Get all organizations that the current user belongs to.
 * Used for the organization switcher to display available organizations.
 */
export const getUserOrganizationsAuthOrganizationsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetUserOrganizationsAuthOrganizationsGetData, ThrowOnError>
): RequestResult<
  GetUserOrganizationsAuthOrganizationsGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetUserOrganizationsAuthOrganizationsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/auth/organizations',
    ...options,
  });

/**
 * Get Active Attestations
 *
 * Return the currently active attestation text per family for the signing UI.
 *
 * Clients display this text before calling sign/approve; they send
 * ``attestation_version`` on those calls for server validation.
 */
export const getActiveAttestationsSigningAttestationsActiveGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetActiveAttestationsSigningAttestationsActiveGetData,
    ThrowOnError
  >
): RequestResult<
  GetActiveAttestationsSigningAttestationsActiveGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetActiveAttestationsSigningAttestationsActiveGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/signing/attestations/active',
    ...options,
  });

/**
 * Get Esignature Credential Status
 *
 * Whether the caller has an e-signature password, and any active lockout.
 *
 * The signing dialog uses this to choose between asking for the existing
 * password and walking a first-time signer through creating one. It also
 * carries the default signing date, because the dialog re-fetches this on
 * every open and the server is the only side that knows the signing zone.
 *
 * ``patient_id`` and ``task_id`` are optional and narrow only that date. The
 * dialog seeds its picker from this value and then sends it back, so the seed
 * — not the server's own fallback — is what a clinician who accepts the
 * default actually binds into the signature. A clinician usually documents a
 * visit after performing it, so the task's own date is the right offer,
 * Capped at today so a visit signed ahead of its date never
 * binds a date that has not happened; today is resolved per clinic because an
 * agency-wide date would offer a nurse at an Eastern clinic yesterday's date
 * after 9pm Pacific.
 */
export const getEsignatureCredentialStatusSigningCredentialGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetEsignatureCredentialStatusSigningCredentialGetData,
    ThrowOnError
  >
): RequestResult<
  GetEsignatureCredentialStatusSigningCredentialGetResponses,
  GetEsignatureCredentialStatusSigningCredentialGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetEsignatureCredentialStatusSigningCredentialGetResponses,
    GetEsignatureCredentialStatusSigningCredentialGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/signing/credential',
    ...options,
  });

/**
 * Set Esignature Credential
 *
 * Create the caller's first e-signature password.
 */
export const setEsignatureCredentialSigningCredentialPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SetEsignatureCredentialSigningCredentialPutData,
    ThrowOnError
  >
): RequestResult<
  SetEsignatureCredentialSigningCredentialPutResponses,
  SetEsignatureCredentialSigningCredentialPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    SetEsignatureCredentialSigningCredentialPutResponses,
    SetEsignatureCredentialSigningCredentialPutErrors,
    ThrowOnError
  >({
    url: '/signing/credential',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Change Esignature Credential
 *
 * Replace the caller's e-signature password, proving the current one.
 */
export const changeEsignatureCredentialSigningCredentialChangePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ChangeEsignatureCredentialSigningCredentialChangePostData,
    ThrowOnError
  >
): RequestResult<
  ChangeEsignatureCredentialSigningCredentialChangePostResponses,
  ChangeEsignatureCredentialSigningCredentialChangePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ChangeEsignatureCredentialSigningCredentialChangePostResponses,
    ChangeEsignatureCredentialSigningCredentialChangePostErrors,
    ThrowOnError
  >({
    url: '/signing/credential/change',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Request Esignature Credential Reset
 *
 * Email the caller a single-use code to reset their e-signature password.
 *
 * The destination is always the caller's own stored email. There is no address
 * parameter, so a reset can neither be aimed at someone else nor used to probe
 * which addresses exist.
 */
export const requestEsignatureCredentialResetSigningCredentialResetRequestPost =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      RequestEsignatureCredentialResetSigningCredentialResetRequestPostData,
      ThrowOnError
    >
  ): RequestResult<
    RequestEsignatureCredentialResetSigningCredentialResetRequestPostResponses,
    unknown,
    ThrowOnError
  > =>
    (options?.client ?? client).post<
      RequestEsignatureCredentialResetSigningCredentialResetRequestPostResponses,
      unknown,
      ThrowOnError
    >({ url: '/signing/credential/reset-request', ...options });

/**
 * Complete Esignature Credential Reset
 *
 * Set a new e-signature password from an emailed reset code.
 *
 * Authenticated, so a reset needs both the emailed code (proving control of
 * the inbox) and a live session (proving SSO identity).
 */
export const completeEsignatureCredentialResetSigningCredentialResetPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CompleteEsignatureCredentialResetSigningCredentialResetPostData,
    ThrowOnError
  >
): RequestResult<
  CompleteEsignatureCredentialResetSigningCredentialResetPostResponses,
  CompleteEsignatureCredentialResetSigningCredentialResetPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CompleteEsignatureCredentialResetSigningCredentialResetPostResponses,
    CompleteEsignatureCredentialResetSigningCredentialResetPostErrors,
    ThrowOnError
  >({
    url: '/signing/credential/reset',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Intakes For Auth Management
 *
 * Get intake records for authorization management.
 * Returns intakes that need attention for:
 * - Missing eligibility check (no successful check in last 30 days)
 * - Missing prior authorization (requires_prior_auth=true but not VERIFIED)
 * - Pending review or under review status
 * - Accepted status (ready to admit)
 *
 * Excludes:
 * - Rejected intakes (not active for authorization management)
 * - Scheduled intakes that don't have eligibility or authorization issues
 *
 * If user has an agency, results are filtered to that agency.
 *
 * Args:
 * limit: Maximum number of records to return
 * offset: Number of records to skip
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * List of IntakeResponse objects
 */
export const getIntakesForAuthManagementAuthorizationGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetIntakesForAuthManagementAuthorizationGetData,
    ThrowOnError
  >
): RequestResult<
  GetIntakesForAuthManagementAuthorizationGetResponses,
  GetIntakesForAuthManagementAuthorizationGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetIntakesForAuthManagementAuthorizationGetResponses,
    GetIntakesForAuthManagementAuthorizationGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/authorization/',
    ...options,
  });

/**
 * List Permissions
 *
 * List permissions from the global catalog.
 */
export const listPermissionsRbacPermissionsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListPermissionsRbacPermissionsGetData, ThrowOnError>
): RequestResult<
  ListPermissionsRbacPermissionsGetResponses,
  ListPermissionsRbacPermissionsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListPermissionsRbacPermissionsGetResponses,
    ListPermissionsRbacPermissionsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/permissions',
    ...options,
  });

/**
 * Create Permission
 *
 * Create a new permission (system-wide).
 */
export const createPermissionRbacPermissionsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreatePermissionRbacPermissionsPostData, ThrowOnError>
): RequestResult<
  CreatePermissionRbacPermissionsPostResponses,
  CreatePermissionRbacPermissionsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreatePermissionRbacPermissionsPostResponses,
    CreatePermissionRbacPermissionsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/permissions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Permission
 *
 * Get a specific permission by ID.
 */
export const getPermissionRbacPermissionsPermissionIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPermissionRbacPermissionsPermissionIdGetData,
    ThrowOnError
  >
): RequestResult<
  GetPermissionRbacPermissionsPermissionIdGetResponses,
  GetPermissionRbacPermissionsPermissionIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetPermissionRbacPermissionsPermissionIdGetResponses,
    GetPermissionRbacPermissionsPermissionIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/permissions/{permission_id}',
    ...options,
  });

/**
 * Update Permission
 *
 * Update a permission's name and/or description.
 */
export const updatePermissionRbacPermissionsPermissionIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdatePermissionRbacPermissionsPermissionIdPatchData,
    ThrowOnError
  >
): RequestResult<
  UpdatePermissionRbacPermissionsPermissionIdPatchResponses,
  UpdatePermissionRbacPermissionsPermissionIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdatePermissionRbacPermissionsPermissionIdPatchResponses,
    UpdatePermissionRbacPermissionsPermissionIdPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/permissions/{permission_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Roles
 *
 * List roles visible to the current agency (system + agency-specific).
 * When agency_id is provided, requires strawhat super-user access and returns
 * roles for that specific agency instead of the caller's current agency.
 *
 * Without SHOW_UNASSIGNED_ROLES, a non-super-user sees only roles they
 * already hold. While the products switch is on, a role is listed only when
 * the agency has one of its products or its products contain "core".
 *
 * chat:edit-groups alone lists only GROUP roles: the chat Announcers view
 * needs the announcer role id, and nothing else on this route.
 */
export const listRolesRbacRolesGet = <ThrowOnError extends boolean = false>(
  options?: Options<ListRolesRbacRolesGetData, ThrowOnError>
): RequestResult<
  ListRolesRbacRolesGetResponses,
  ListRolesRbacRolesGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListRolesRbacRolesGetResponses,
    ListRolesRbacRolesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/roles',
    ...options,
  });

/**
 * Create Role
 *
 * Create a role for the current agency, optionally attaching permissions in the same transaction.
 */
export const createRoleRbacRolesPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateRoleRbacRolesPostData, ThrowOnError>
): RequestResult<
  CreateRoleRbacRolesPostResponses,
  CreateRoleRbacRolesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateRoleRbacRolesPostResponses,
    CreateRoleRbacRolesPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/roles',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Role
 *
 * Soft-delete a custom role.
 */
export const deleteRoleRbacRolesRoleIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteRoleRbacRolesRoleIdDeleteData, ThrowOnError>
): RequestResult<
  DeleteRoleRbacRolesRoleIdDeleteResponses,
  DeleteRoleRbacRolesRoleIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteRoleRbacRolesRoleIdDeleteResponses,
    DeleteRoleRbacRolesRoleIdDeleteErrors,
    ThrowOnError
  >({ url: '/rbac/roles/{role_id}', ...options });

/**
 * Get Role
 *
 * Get a specific role by ID.
 */
export const getRoleRbacRolesRoleIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetRoleRbacRolesRoleIdGetData, ThrowOnError>
): RequestResult<
  GetRoleRbacRolesRoleIdGetResponses,
  GetRoleRbacRolesRoleIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetRoleRbacRolesRoleIdGetResponses,
    GetRoleRbacRolesRoleIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/roles/{role_id}',
    ...options,
  });

/**
 * Update Role
 *
 * Update a custom role's name, description, and permissions in a single transaction.
 */
export const updateRoleRbacRolesRoleIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateRoleRbacRolesRoleIdPatchData, ThrowOnError>
): RequestResult<
  UpdateRoleRbacRolesRoleIdPatchResponses,
  UpdateRoleRbacRolesRoleIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateRoleRbacRolesRoleIdPatchResponses,
    UpdateRoleRbacRolesRoleIdPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/roles/{role_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Role Permissions
 *
 * List all permissions assigned to a role.
 */
export const listRolePermissionsRbacRolePermissionsRoleIdPermissionsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListRolePermissionsRbacRolePermissionsRoleIdPermissionsGetData,
    ThrowOnError
  >
): RequestResult<
  ListRolePermissionsRbacRolePermissionsRoleIdPermissionsGetResponses,
  ListRolePermissionsRbacRolePermissionsRoleIdPermissionsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListRolePermissionsRbacRolePermissionsRoleIdPermissionsGetResponses,
    ListRolePermissionsRbacRolePermissionsRoleIdPermissionsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/role_permissions/{role_id}/permissions',
    ...options,
  });

/**
 * Add Permission To Role
 *
 * Add a permission to a role.
 */
export const addPermissionToRoleRbacRolePermissionsRoleIdPermissionsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AddPermissionToRoleRbacRolePermissionsRoleIdPermissionsPostData,
    ThrowOnError
  >
): RequestResult<
  AddPermissionToRoleRbacRolePermissionsRoleIdPermissionsPostResponses,
  AddPermissionToRoleRbacRolePermissionsRoleIdPermissionsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AddPermissionToRoleRbacRolePermissionsRoleIdPermissionsPostResponses,
    AddPermissionToRoleRbacRolePermissionsRoleIdPermissionsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/role_permissions/{role_id}/permissions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove Permission From Role
 *
 * Remove a permission from a role.
 */
export const removePermissionFromRoleRbacRolePermissionsRoleIdPermissionsPermissionIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      RemovePermissionFromRoleRbacRolePermissionsRoleIdPermissionsPermissionIdDeleteData,
      ThrowOnError
    >
  ): RequestResult<
    RemovePermissionFromRoleRbacRolePermissionsRoleIdPermissionsPermissionIdDeleteResponses,
    RemovePermissionFromRoleRbacRolePermissionsRoleIdPermissionsPermissionIdDeleteErrors,
    ThrowOnError
  > =>
    (options.client ?? client).delete<
      RemovePermissionFromRoleRbacRolePermissionsRoleIdPermissionsPermissionIdDeleteResponses,
      RemovePermissionFromRoleRbacRolePermissionsRoleIdPermissionsPermissionIdDeleteErrors,
      ThrowOnError
    >({
      url: '/rbac/role_permissions/{role_id}/permissions/{permission_id}',
      ...options,
    });

/**
 * Create Agency Assignment
 *
 * Assign a role to a user at agency level.
 */
export const createAgencyAssignmentRbacRoleAssignmentsAgencyPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateAgencyAssignmentRbacRoleAssignmentsAgencyPostData,
    ThrowOnError
  >
): RequestResult<
  CreateAgencyAssignmentRbacRoleAssignmentsAgencyPostResponses,
  CreateAgencyAssignmentRbacRoleAssignmentsAgencyPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateAgencyAssignmentRbacRoleAssignmentsAgencyPostResponses,
    CreateAgencyAssignmentRbacRoleAssignmentsAgencyPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/role_assignments/agency',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Clinic Assignment
 *
 * Assign a role to a user at clinic level.
 */
export const createClinicAssignmentRbacRoleAssignmentsClinicPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateClinicAssignmentRbacRoleAssignmentsClinicPostData,
    ThrowOnError
  >
): RequestResult<
  CreateClinicAssignmentRbacRoleAssignmentsClinicPostResponses,
  CreateClinicAssignmentRbacRoleAssignmentsClinicPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateClinicAssignmentRbacRoleAssignmentsClinicPostResponses,
    CreateClinicAssignmentRbacRoleAssignmentsClinicPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/role_assignments/clinic',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Group Assignment
 *
 * Name a member of one channel's group as an announcer.
 */
export const createGroupAssignmentRbacRoleAssignmentsGroupPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateGroupAssignmentRbacRoleAssignmentsGroupPostData,
    ThrowOnError
  >
): RequestResult<
  CreateGroupAssignmentRbacRoleAssignmentsGroupPostResponses,
  CreateGroupAssignmentRbacRoleAssignmentsGroupPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateGroupAssignmentRbacRoleAssignmentsGroupPostResponses,
    CreateGroupAssignmentRbacRoleAssignmentsGroupPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/role_assignments/group',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Group Assignments
 *
 * Live announcer grants on one group, each with its user's name.
 */
export const listGroupAssignmentsRbacRoleAssignmentsGroupGroupIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListGroupAssignmentsRbacRoleAssignmentsGroupGroupIdGetData,
    ThrowOnError
  >
): RequestResult<
  ListGroupAssignmentsRbacRoleAssignmentsGroupGroupIdGetResponses,
  ListGroupAssignmentsRbacRoleAssignmentsGroupGroupIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListGroupAssignmentsRbacRoleAssignmentsGroupGroupIdGetResponses,
    ListGroupAssignmentsRbacRoleAssignmentsGroupGroupIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/role_assignments/group/{group_id}',
    ...options,
  });

/**
 * Bulk Upsert Assignments
 *
 * Upsert role assignments for a set of users, reconciling against the current state.
 *
 * Users in user_ids get active assignments (created or restored).
 * Users not in user_ids have their active assignments soft-deleted.
 * For clinic-scoped roles, reconciliation is scoped to the provided clinic_ids.
 * Returns all currently active assignments for the role after the operation.
 */
export const bulkUpsertAssignmentsRbacRoleAssignmentsBulkPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    BulkUpsertAssignmentsRbacRoleAssignmentsBulkPutData,
    ThrowOnError
  >
): RequestResult<
  BulkUpsertAssignmentsRbacRoleAssignmentsBulkPutResponses,
  BulkUpsertAssignmentsRbacRoleAssignmentsBulkPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    BulkUpsertAssignmentsRbacRoleAssignmentsBulkPutResponses,
    BulkUpsertAssignmentsRbacRoleAssignmentsBulkPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/role_assignments/bulk',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Users By Role
 *
 * Return all users that have the given role, optionally scoped to specific clinics.
 *
 * - Without `clinic_ids`: returns users with an agency-scoped assignment. `clinic_ids` in
 * each item will be empty.
 * - With `clinic_ids`: returns users with a clinic-scoped assignment at any of the given
 * clinics the actor may administer. Requested ids outside that bound are
 * dropped; if none remain, the response is empty. `clinic_ids` in each item lists
 * only the remaining clinics where the user holds the role.
 */
export const getUsersByRoleRbacRoleAssignmentsUsersByRoleRoleIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetUsersByRoleRbacRoleAssignmentsUsersByRoleRoleIdGetData,
    ThrowOnError
  >
): RequestResult<
  GetUsersByRoleRbacRoleAssignmentsUsersByRoleRoleIdGetResponses,
  GetUsersByRoleRbacRoleAssignmentsUsersByRoleRoleIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetUsersByRoleRbacRoleAssignmentsUsersByRoleRoleIdGetResponses,
    GetUsersByRoleRbacRoleAssignmentsUsersByRoleRoleIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/role_assignments/users-by-role/{role_id}',
    ...options,
  });

/**
 * List User Assignments
 *
 * List active role assignments for a user in the current agency.
 *
 * Clinic-scoped rows are clamped to clinics the actor may administer.
 * Agency-scoped rows stay visible. The default CRUD list
 * stays unclamped so onboarding can still union the full set.
 */
export const listUserAssignmentsRbacRoleAssignmentsUserUserIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListUserAssignmentsRbacRoleAssignmentsUserUserIdGetData,
    ThrowOnError
  >
): RequestResult<
  ListUserAssignmentsRbacRoleAssignmentsUserUserIdGetResponses,
  ListUserAssignmentsRbacRoleAssignmentsUserUserIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListUserAssignmentsRbacRoleAssignmentsUserUserIdGetResponses,
    ListUserAssignmentsRbacRoleAssignmentsUserUserIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/role_assignments/user/{user_id}',
    ...options,
  });

/**
 * Bulk Assign Agency Roles To User
 *
 * Reconcile agency-scoped role assignments for a single user.
 *
 * role_ids defines the complete desired set of agency-scoped roles.
 * Any active agency-scoped assignments not in role_ids are soft-deleted.
 */
export const bulkAssignAgencyRolesToUserRbacRoleAssignmentsUserUserIdAgencyRolesPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      BulkAssignAgencyRolesToUserRbacRoleAssignmentsUserUserIdAgencyRolesPutData,
      ThrowOnError
    >
  ): RequestResult<
    BulkAssignAgencyRolesToUserRbacRoleAssignmentsUserUserIdAgencyRolesPutResponses,
    BulkAssignAgencyRolesToUserRbacRoleAssignmentsUserUserIdAgencyRolesPutErrors,
    ThrowOnError
  > =>
    (options.client ?? client).put<
      BulkAssignAgencyRolesToUserRbacRoleAssignmentsUserUserIdAgencyRolesPutResponses,
      BulkAssignAgencyRolesToUserRbacRoleAssignmentsUserUserIdAgencyRolesPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/rbac/role_assignments/user/{user_id}/agency-roles',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Bulk Assign Clinic Roles To User
 *
 * Reconcile clinic-scoped role assignments for a single user.
 *
 * assignments defines the desired set of (role_id, clinic_id) pairs at
 * clinics the actor may administer. Active assignments at clinics they
 * cannot see are preserved, not revoked. The JSON response
 * omits those preserved pairs; they remain in the database.
 *
 * ``agency_id`` names the agency to administer instead of the caller's own,
 * and is refused for anyone who is not a Strawhat super user. Internal tools
 * needs it because it repairs a user in an agency the operator does not
 * belong to.
 */
export const bulkAssignClinicRolesToUserRbacRoleAssignmentsUserUserIdClinicRolesPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      BulkAssignClinicRolesToUserRbacRoleAssignmentsUserUserIdClinicRolesPutData,
      ThrowOnError
    >
  ): RequestResult<
    BulkAssignClinicRolesToUserRbacRoleAssignmentsUserUserIdClinicRolesPutResponses,
    BulkAssignClinicRolesToUserRbacRoleAssignmentsUserUserIdClinicRolesPutErrors,
    ThrowOnError
  > =>
    (options.client ?? client).put<
      BulkAssignClinicRolesToUserRbacRoleAssignmentsUserUserIdClinicRolesPutResponses,
      BulkAssignClinicRolesToUserRbacRoleAssignmentsUserUserIdClinicRolesPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/rbac/role_assignments/user/{user_id}/clinic-roles',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * List Distinct Roles Assigned At Agency
 *
 * Distinct roles that have at least one active user assignment at the given agency.
 *
 * Cross-agency reads require strawhat super-user access (enforced by
 * ``optional_agency_execution_scope`` before calling CRUD).
 */
export const listDistinctRolesAssignedAtAgencyRbacRoleAssignmentsAgenciesAgencyIdAssignedRolesGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ListDistinctRolesAssignedAtAgencyRbacRoleAssignmentsAgenciesAgencyIdAssignedRolesGetData,
      ThrowOnError
    >
  ): RequestResult<
    ListDistinctRolesAssignedAtAgencyRbacRoleAssignmentsAgenciesAgencyIdAssignedRolesGetResponses,
    ListDistinctRolesAssignedAtAgencyRbacRoleAssignmentsAgenciesAgencyIdAssignedRolesGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      ListDistinctRolesAssignedAtAgencyRbacRoleAssignmentsAgenciesAgencyIdAssignedRolesGetResponses,
      ListDistinctRolesAssignedAtAgencyRbacRoleAssignmentsAgenciesAgencyIdAssignedRolesGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/rbac/role_assignments/agencies/{agency_id}/assigned_roles',
      ...options,
    });

/**
 * Delete Assignment
 *
 * Soft-delete a role assignment.
 */
export const deleteAssignmentRbacRoleAssignmentsAssignmentIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAssignmentRbacRoleAssignmentsAssignmentIdDeleteData,
    ThrowOnError
  >
): RequestResult<
  DeleteAssignmentRbacRoleAssignmentsAssignmentIdDeleteResponses,
  DeleteAssignmentRbacRoleAssignmentsAssignmentIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteAssignmentRbacRoleAssignmentsAssignmentIdDeleteResponses,
    DeleteAssignmentRbacRoleAssignmentsAssignmentIdDeleteErrors,
    ThrowOnError
  >({ url: '/rbac/role_assignments/{assignment_id}', ...options });

/**
 * Get Assignment
 *
 * Get a specific role assignment by ID.
 *
 * Clinic-scoped assignments outside the actor's administrable clinics
 * 404 as not found, matching DELETE.
 */
export const getAssignmentRbacRoleAssignmentsAssignmentIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAssignmentRbacRoleAssignmentsAssignmentIdGetData,
    ThrowOnError
  >
): RequestResult<
  GetAssignmentRbacRoleAssignmentsAssignmentIdGetResponses,
  GetAssignmentRbacRoleAssignmentsAssignmentIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAssignmentRbacRoleAssignmentsAssignmentIdGetResponses,
    GetAssignmentRbacRoleAssignmentsAssignmentIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/role_assignments/{assignment_id}',
    ...options,
  });

/**
 * List User Role Assignments
 *
 * List active role assignments for a user in an agency, including both:
 * - agency-scoped roles (clinic_id is null)
 * - clinic-scoped roles (clinic_id is set)
 *
 * Every editor reconciles against what it read here, so a page that cuts off
 * silently revokes the assignments past the cut. Clinic roles multiply by
 * clinic, so the default page is reachable in a large agency.
 *
 * Clinic-scoped rows are clamped to clinics the actor may administer.
 * The clamp is passed into the list query so the page limit
 * applies after it, rather than filtering a full page afterwards.
 */
export const listUserRoleAssignments = <ThrowOnError extends boolean = false>(
  options: Options<ListUserRoleAssignmentsData, ThrowOnError>
): RequestResult<
  ListUserRoleAssignmentsResponses,
  ListUserRoleAssignmentsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListUserRoleAssignmentsResponses,
    ListUserRoleAssignmentsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/role_assignments/users/{user_id}/assignments',
    ...options,
  });

/**
 * List Workos Feature Flags
 *
 * List all feature-flag slugs defined in the WorkOS environment.
 */
export const listWorkosFeatureFlagsRbacFeatureFlagsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListWorkosFeatureFlagsRbacFeatureFlagsGetData, ThrowOnError>
): RequestResult<
  ListWorkosFeatureFlagsRbacFeatureFlagsGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListWorkosFeatureFlagsRbacFeatureFlagsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/feature-flags',
    ...options,
  });

/**
 * Get Users
 *
 * Get all users with pagination
 */
export const getUsersUsersGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetUsersUsersGetData, ThrowOnError>
): RequestResult<
  GetUsersUsersGetResponses,
  GetUsersUsersGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetUsersUsersGetResponses,
    GetUsersUsersGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/',
    ...options,
  });

/**
 * Create User
 *
 * Create a new user
 */
export const createUserUsersPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateUserUsersPostData, ThrowOnError>
): RequestResult<
  CreateUserUsersPostResponses,
  CreateUserUsersPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateUserUsersPostResponses,
    CreateUserUsersPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Agency Members
 *
 * Returns user records ordered by last name, first name.
 * Does not require elevated permissions beyond normal agency access, so
 * phone numbers are only populated for callers who administer users.
 * When agency_id is provided, requires strawhat super-user access and returns
 * users for that specific agency instead of the caller's current agency.
 */
export const getAgencyMembersUsersAgencyMembersGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetAgencyMembersUsersAgencyMembersGetData, ThrowOnError>
): RequestResult<
  GetAgencyMembersUsersAgencyMembersGetResponses,
  GetAgencyMembersUsersAgencyMembersGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetAgencyMembersUsersAgencyMembersGetResponses,
    GetAgencyMembersUsersAgencyMembersGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/agency-members',
    ...options,
  });

/**
 * Get Users By Permission
 *
 * Return users in the current agency who have the given permission at the requested scope.
 */
export const getUsersByPermissionUsersByPermissionGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetUsersByPermissionUsersByPermissionGetData, ThrowOnError>
): RequestResult<
  GetUsersByPermissionUsersByPermissionGetResponses,
  GetUsersByPermissionUsersByPermissionGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetUsersByPermissionUsersByPermissionGetResponses,
    GetUsersByPermissionUsersByPermissionGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/by-permission',
    ...options,
  });

/**
 * List Org Members
 *
 * List all members of the current WorkOS organization who are not Roger Admins unless
 * the user making the request is a super user.
 * Used by Clinician Manager to list all users in the current organization.
 *
 * For each member, includes their Roger User record (if it exists),
 * all UserClinic assignments in the current agency, and distinct RBAC role
 * display names from active role assignments in this agency.
 */
export const listOrgMembersUsersOrgMembersGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListOrgMembersUsersOrgMembersGetData, ThrowOnError>
): RequestResult<
  ListOrgMembersUsersOrgMembersGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListOrgMembersUsersOrgMembersGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/org-members',
    ...options,
  });

/**
 * Invite User
 *
 * Invite one or more users to the agency.
 *
 * Accepts a list of emails and processes them all in a single request.
 * Creates Roger DB records (User, UserAgency, RoleAssignments) for each email,
 * then sends WorkOS invitations/memberships in parallel to avoid N+1 API calls.
 */
export const inviteUserUsersInvitePost = <ThrowOnError extends boolean = false>(
  options: Options<InviteUserUsersInvitePostData, ThrowOnError>
): RequestResult<
  InviteUserUsersInvitePostResponses,
  InviteUserUsersInvitePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    InviteUserUsersInvitePostResponses,
    InviteUserUsersInvitePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/invite',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Onboard Users Endpoint
 *
 * Add one or more new members, doing everything they need in one pass.
 *
 * Everything RogerEMR owns is written first, as one transaction with a
 * savepoint per person, so a bad row in a batch cannot roll back the good ones.
 * WorkOS and Roger App run afterwards and report their own outcome, because
 * neither can be undone and neither belongs in our transaction.
 */
export const onboardUsersEndpointUsersOnboardPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OnboardUsersEndpointUsersOnboardPostData, ThrowOnError>
): RequestResult<
  OnboardUsersEndpointUsersOnboardPostResponses,
  OnboardUsersEndpointUsersOnboardPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OnboardUsersEndpointUsersOnboardPostResponses,
    OnboardUsersEndpointUsersOnboardPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/onboard',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Resend Invite
 *
 * Resend an invitation, except when WorkOS records it as rescinded.
 *
 * A fresh invitation after rescinding would recreate an agency member without
 * the local grants that rescinding removed. WorkOS retains the terminal state,
 * which distinguishes that case from an ordinary expired invitation.
 */
export const resendInviteUsersResendInvitePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ResendInviteUsersResendInvitePostData, ThrowOnError>
): RequestResult<
  ResendInviteUsersResendInvitePostResponses,
  ResendInviteUsersResendInvitePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ResendInviteUsersResendInvitePostResponses,
    ResendInviteUsersResendInvitePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/resend-invite',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Rescind Invite
 *
 * Revoke one pending WorkOS invitation in the caller's agency.
 */
export const rescindInviteUsersRescindInvitePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RescindInviteUsersRescindInvitePostData, ThrowOnError>
): RequestResult<
  RescindInviteUsersRescindInvitePostResponses,
  RescindInviteUsersRescindInvitePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RescindInviteUsersRescindInvitePostResponses,
    RescindInviteUsersRescindInvitePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/rescind-invite',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List User Merge Candidates
 *
 * The accounts here the caller may merge: every clinic each held is theirs.
 */
export const listUserMergeCandidatesUsersMergeCandidatesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ListUserMergeCandidatesUsersMergeCandidatesGetData,
    ThrowOnError
  >
): RequestResult<
  ListUserMergeCandidatesUsersMergeCandidatesGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListUserMergeCandidatesUsersMergeCandidatesGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/merge-candidates',
    ...options,
  });

/**
 * Preview User Merge
 *
 * What merging the source into the target would do now, and its token.
 */
export const previewUserMergeUsersMergePreviewGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PreviewUserMergeUsersMergePreviewGetData, ThrowOnError>
): RequestResult<
  PreviewUserMergeUsersMergePreviewGetResponses,
  PreviewUserMergeUsersMergePreviewGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    PreviewUserMergeUsersMergePreviewGetResponses,
    PreviewUserMergeUsersMergePreviewGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/merge-preview',
    ...options,
  });

/**
 * Merge Users
 *
 * Merge as previewed, commit, then move the RogerDoc account links.
 *
 * The token lists the old account's clinic rows, roles and intakes with
 * their clinics, so one it gains after this bound check is refused as
 * stale. The bound is checked again once the merge holds the rows it moved.
 * The kept account's other clinics are never written.
 */
export const mergeUsersUsersMergePost = <ThrowOnError extends boolean = false>(
  options: Options<MergeUsersUsersMergePostData, ThrowOnError>
): RequestResult<
  MergeUsersUsersMergePostResponses,
  MergeUsersUsersMergePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    MergeUsersUsersMergePostResponses,
    MergeUsersUsersMergePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/merge',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Retry User Merge Steps
 *
 * Move the RogerDoc account links a merge still owes.
 */
export const retryUserMergeStepsUsersMergesMergeIdRetryPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RetryUserMergeStepsUsersMergesMergeIdRetryPostData,
    ThrowOnError
  >
): RequestResult<
  RetryUserMergeStepsUsersMergesMergeIdRetryPostResponses,
  RetryUserMergeStepsUsersMergesMergeIdRetryPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RetryUserMergeStepsUsersMergesMergeIdRetryPostResponses,
    RetryUserMergeStepsUsersMergesMergeIdRetryPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/merges/{merge_id}/retry',
    ...options,
  });

/**
 * Deactivate User
 *
 * Deactivate this user's membership while preserving their Roger history.
 *
 * Administrative roles are soft-deleted during deactivation. Reactivation
 * leaves those roles off the member until an administrator grants them again.
 */
export const deactivateUserUsersUserIdDeactivatePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeactivateUserUsersUserIdDeactivatePostData, ThrowOnError>
): RequestResult<
  DeactivateUserUsersUserIdDeactivatePostResponses,
  DeactivateUserUsersUserIdDeactivatePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DeactivateUserUsersUserIdDeactivatePostResponses,
    DeactivateUserUsersUserIdDeactivatePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/{user_id}/deactivate',
    ...options,
  });

/**
 * Retry Deactivate User
 *
 * Retry directory removal without restoring the local agency membership.
 */
export const retryDeactivateUserUsersUserIdDeactivateRetryPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RetryDeactivateUserUsersUserIdDeactivateRetryPostData,
    ThrowOnError
  >
): RequestResult<
  RetryDeactivateUserUsersUserIdDeactivateRetryPostResponses,
  RetryDeactivateUserUsersUserIdDeactivateRetryPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RetryDeactivateUserUsersUserIdDeactivateRetryPostResponses,
    RetryDeactivateUserUsersUserIdDeactivateRetryPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/{user_id}/deactivate/retry',
    ...options,
  });

/**
 * Update User Roles
 *
 * Replace a user's agency-scoped role assignments.
 * Works for both active users and pending (invited-but-not-yet-logged-in) users.
 * When agency_id is provided, requires strawhat super-user access and operates
 * on that specific agency instead of the caller's current agency.
 */
export const updateUserRolesUsersUserIdRolesPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateUserRolesUsersUserIdRolesPutData, ThrowOnError>
): RequestResult<
  UpdateUserRolesUsersUserIdRolesPutResponses,
  UpdateUserRolesUsersUserIdRolesPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateUserRolesUsersUserIdRolesPutResponses,
    UpdateUserRolesUsersUserIdRolesPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/{user_id}/roles',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get User
 *
 * Get a specific user by ID. Restricted to Strawhat super-users.
 */
export const getUserUsersUserIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetUserUsersUserIdGetData, ThrowOnError>
): RequestResult<
  GetUserUsersUserIdGetResponses,
  GetUserUsersUserIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetUserUsersUserIdGetResponses,
    GetUserUsersUserIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/{user_id}',
    ...options,
  });

/**
 * Update User
 *
 * Update a user
 */
export const updateUserUsersUserIdPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateUserUsersUserIdPutData, ThrowOnError>
): RequestResult<
  UpdateUserUsersUserIdPutResponses,
  UpdateUserUsersUserIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateUserUsersUserIdPutResponses,
    UpdateUserUsersUserIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/{user_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Reactivate Agency Member
 *
 * Restore a deactivated member's WorkOS and agency access.
 *
 * WorkOS membership restoration happens first. If it fails, the local member
 * stays deactivated so the operation can be retried. The member's clinic
 * access remains bounded by the same administrative scope as deactivation.
 */
export const reactivateAgencyMemberUsersUserIdReactivatePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ReactivateAgencyMemberUsersUserIdReactivatePostData,
    ThrowOnError
  >
): RequestResult<
  ReactivateAgencyMemberUsersUserIdReactivatePostResponses,
  ReactivateAgencyMemberUsersUserIdReactivatePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ReactivateAgencyMemberUsersUserIdReactivatePostResponses,
    ReactivateAgencyMemberUsersUserIdReactivatePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/{user_id}/reactivate',
    ...options,
  });

/**
 * Update Clinic Access
 *
 * Reconcile which clinics a user can access — the set the clinic filter enforces.
 *
 * Clinics listed are granted (created or restored), clinics omitted are
 * revoked. Revocation soft-deletes the ``user_clinics`` row rather than
 * hard-deleting it: the row is the clinical identity referenced by
 * visits, episodes and orders, so history survives and a later re-grant
 * restores the same row. Assigning a clinic-scoped role re-grants access on
 * its own, so revoking here while leaving clinic roles in place is possible
 * but temporary; the UI keeps role-holding clinics checked for that reason.
 *
 * ``agency_id`` names the agency to administer instead of the caller's own,
 * and is refused for anyone who is not a Strawhat super user. Internal tools
 * needs it because it repairs a user in an agency the operator does not
 * belong to; without it this looked the target user up in the caller's own
 * agency and answered "User not found".
 */
export const updateClinicAccessUsersUserIdClinicAccessPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateClinicAccessUsersUserIdClinicAccessPutData,
    ThrowOnError
  >
): RequestResult<
  UpdateClinicAccessUsersUserIdClinicAccessPutResponses,
  UpdateClinicAccessUsersUserIdClinicAccessPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateClinicAccessUsersUserIdClinicAccessPutResponses,
    UpdateClinicAccessUsersUserIdClinicAccessPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/{user_id}/clinic-access',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Clinic Setup
 *
 * Save a member's whole per-clinic setup in one transaction.
 *
 * Inside the administrator's bound this replaces the member's clinic
 * access, clinic roles, disciplines and employee types with the body: a
 * listed clinic is granted with exactly its ``role_ids``, an administrable
 * clinic left out loses access and its clinic roles. Everything at clinics
 * the administrator cannot administer is preserved. See
 * :class:`~app.schemas.ClinicSetupItem` for which attributes are kept.
 *
 * Any failure rolls the whole save back, and the Slack notice for a role
 * change is sent only after the commit.
 */
export const updateClinicSetupUsersUserIdClinicSetupPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateClinicSetupUsersUserIdClinicSetupPutData, ThrowOnError>
): RequestResult<
  UpdateClinicSetupUsersUserIdClinicSetupPutResponses,
  UpdateClinicSetupUsersUserIdClinicSetupPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateClinicSetupUsersUserIdClinicSetupPutResponses,
    UpdateClinicSetupUsersUserIdClinicSetupPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/{user_id}/clinic-setup',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Clinic Disciplines
 *
 * Update clinical disciplines for a user at each clinic.
 */
export const updateClinicDisciplinesUsersUserIdClinicDisciplinesPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateClinicDisciplinesUsersUserIdClinicDisciplinesPutData,
    ThrowOnError
  >
): RequestResult<
  UpdateClinicDisciplinesUsersUserIdClinicDisciplinesPutResponses,
  UpdateClinicDisciplinesUsersUserIdClinicDisciplinesPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateClinicDisciplinesUsersUserIdClinicDisciplinesPutResponses,
    UpdateClinicDisciplinesUsersUserIdClinicDisciplinesPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/{user_id}/clinic-disciplines',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Employee Types
 *
 * Update per-clinic employee types for a user.
 */
export const updateEmployeeTypesUsersUserIdEmployeeTypePut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateEmployeeTypesUsersUserIdEmployeeTypePutData,
    ThrowOnError
  >
): RequestResult<
  UpdateEmployeeTypesUsersUserIdEmployeeTypePutResponses,
  UpdateEmployeeTypesUsersUserIdEmployeeTypePutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateEmployeeTypesUsersUserIdEmployeeTypePutResponses,
    UpdateEmployeeTypesUsersUserIdEmployeeTypePutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/{user_id}/employee-type',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Sync Clinic Assignments
 *
 * Endpoint no longer used. Keeping it here for now so that merge conflicts are minimized.
 */
export const syncClinicAssignmentsUsersUserIdClinicAssignmentsPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SyncClinicAssignmentsUsersUserIdClinicAssignmentsPutData,
    ThrowOnError
  >
): RequestResult<
  SyncClinicAssignmentsUsersUserIdClinicAssignmentsPutResponses,
  SyncClinicAssignmentsUsersUserIdClinicAssignmentsPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    SyncClinicAssignmentsUsersUserIdClinicAssignmentsPutResponses,
    SyncClinicAssignmentsUsersUserIdClinicAssignmentsPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/{user_id}/clinic-assignments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Assign User To All Clinics
 *
 * Endpoint no longer used. Keeping it here for now so that merge conflicts are minimized.
 */
export const assignUserToAllClinicsUsersUserIdAssignAllClinicsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AssignUserToAllClinicsUsersUserIdAssignAllClinicsPostData,
    ThrowOnError
  >
): RequestResult<
  AssignUserToAllClinicsUsersUserIdAssignAllClinicsPostResponses,
  AssignUserToAllClinicsUsersUserIdAssignAllClinicsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AssignUserToAllClinicsUsersUserIdAssignAllClinicsPostResponses,
    AssignUserToAllClinicsUsersUserIdAssignAllClinicsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/{user_id}/assign-all-clinics',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update User Npi
 *
 * Update a user's NPI number. Requires clinician-mgr:access permission.
 */
export const updateUserNpiUsersUserIdNpiPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateUserNpiUsersUserIdNpiPatchData, ThrowOnError>
): RequestResult<
  UpdateUserNpiUsersUserIdNpiPatchResponses,
  UpdateUserNpiUsersUserIdNpiPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateUserNpiUsersUserIdNpiPatchResponses,
    UpdateUserNpiUsersUserIdNpiPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/{user_id}/npi',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update User Type
 *
 * Replace a user's agency-scoped clinical titles.
 *
 * Takes the whole set: a person can hold several, and writing one through the
 * single-title adapter discarded the rest.
 */
export const updateUserTypeUsersUserIdUserTypePatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateUserTypeUsersUserIdUserTypePatchData, ThrowOnError>
): RequestResult<
  UpdateUserTypeUsersUserIdUserTypePatchResponses,
  UpdateUserTypeUsersUserIdUserTypePatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateUserTypeUsersUserIdUserTypePatchResponses,
    UpdateUserTypeUsersUserIdUserTypePatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/{user_id}/user-type',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update User Credentials
 *
 * Set or clear a user's agency-scoped display credentials.
 *
 * Used for e-signature suffixes and name formatting. Not the same as clinical
 * titles (``user_types``), which control visit assignment.
 */
export const updateUserCredentialsUsersUserIdCredentialsPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateUserCredentialsUsersUserIdCredentialsPatchData,
    ThrowOnError
  >
): RequestResult<
  UpdateUserCredentialsUsersUserIdCredentialsPatchResponses,
  UpdateUserCredentialsUsersUserIdCredentialsPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateUserCredentialsUsersUserIdCredentialsPatchResponses,
    UpdateUserCredentialsUsersUserIdCredentialsPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/{user_id}/credentials',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Export Org Members
 *
 * The whole roster the caller may see, as a two-sheet workbook.
 *
 * Gated exactly as the list endpoint is, so the file adds a format, not
 * exposure: whoever may load the roster may download it.
 */
export const exportOrgMembersUsersOrgMembersExportGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ExportOrgMembersUsersOrgMembersExportGetData, ThrowOnError>
): RequestResult<
  ExportOrgMembersUsersOrgMembersExportGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ExportOrgMembersUsersOrgMembersExportGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/users/org-members/export',
    ...options,
  });

/**
 * Get Available Clinicians
 *
 * Get available clinicians for the current context's agency. Raises error if no agency in context.
 */
export const getAvailableCliniciansUserClinicsAvailableGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetAvailableCliniciansUserClinicsAvailableGetData,
    ThrowOnError
  >
): RequestResult<
  GetAvailableCliniciansUserClinicsAvailableGetResponses,
  GetAvailableCliniciansUserClinicsAvailableGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetAvailableCliniciansUserClinicsAvailableGetResponses,
    GetAvailableCliniciansUserClinicsAvailableGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/user-clinics/available',
    ...options,
  });

/**
 * Delete Current Agency
 *
 * Delete the caller's current agency (Strawhat super-user only).
 */
export const deleteCurrentAgencyAgenciesDelete = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<DeleteCurrentAgencyAgenciesDeleteData, ThrowOnError>
): RequestResult<
  DeleteCurrentAgencyAgenciesDeleteResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).delete<
    DeleteCurrentAgencyAgenciesDeleteResponses,
    unknown,
    ThrowOnError
  >({ url: '/agencies', ...options });

/**
 * Update Current Agency
 *
 * Update the caller's current agency (Roger super users only).
 *
 * ``AgencyUpdate`` carries ``is_kinnser_enabled`` and ``system_name``, the
 * agency's key into Docs. ``is_rogeremr_enabled`` is never written here: it
 * copies Docs' emr product, set on the Docs Products page, and a save here
 * would overwrite that copy.
 * Its caller is Internal Admin, which staff open from inside the customer's
 * agency, so the gate is ``admin:super-user`` rather than the Strawhat-agency
 * check that would always refuse there.
 */
export const updateCurrentAgencyAgenciesPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateCurrentAgencyAgenciesPutData, ThrowOnError>
): RequestResult<
  UpdateCurrentAgencyAgenciesPutResponses,
  UpdateCurrentAgencyAgenciesPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateCurrentAgencyAgenciesPutResponses,
    UpdateCurrentAgencyAgenciesPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/agencies',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Current Agency Written Name
 *
 * Update the caller's agency print name (``agency-print-name:edit``).
 */
export const updateCurrentAgencyWrittenNameAgenciesWrittenNamePut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateCurrentAgencyWrittenNameAgenciesWrittenNamePutData,
    ThrowOnError
  >
): RequestResult<
  UpdateCurrentAgencyWrittenNameAgenciesWrittenNamePutResponses,
  UpdateCurrentAgencyWrittenNameAgenciesWrittenNamePutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateCurrentAgencyWrittenNameAgenciesWrittenNamePutResponses,
    UpdateCurrentAgencyWrittenNameAgenciesWrittenNamePutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/agencies/written-name',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Agency Config
 *
 * Return Intake Manager column customization for the current agency.
 */
export const getAgencyConfigAgencyConfigGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetAgencyConfigAgencyConfigGetData, ThrowOnError>
): RequestResult<
  GetAgencyConfigAgencyConfigGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetAgencyConfigAgencyConfigGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/agency-config',
    ...options,
  });

/**
 * Update Agency Config
 *
 * Update configuration for the current agency.
 *
 * Both fields are independently optional: a caller that sends only one leaves
 * the other untouched. That matters because the column layout and the
 * signature-workflow toggle are edited from different screens, and a partial
 * update from one must not reset the other.
 */
export const updateAgencyConfigAgencyConfigPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateAgencyConfigAgencyConfigPutData, ThrowOnError>
): RequestResult<
  UpdateAgencyConfigAgencyConfigPutResponses,
  UpdateAgencyConfigAgencyConfigPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateAgencyConfigAgencyConfigPutResponses,
    UpdateAgencyConfigAgencyConfigPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/agency-config',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Agency Clinics
 *
 * The caller's clinics, or another agency's for a Strawhat super user.
 *
 * ``agency_id`` names the agency to list instead of the caller's own, and is
 * refused for anyone who is not a Strawhat super user. Internal tools needs it
 * because it administers an agency the operator is not a member of: without it
 * the clinic pickers there listed Strawhat's clinics while inviting somebody
 * into somebody else's agency.
 *
 * Omitting it leaves this exactly as it was -- the caller's own accessible
 * clinics, narrowed by the ORM clinic filter -- which is what every other
 * clinic picker in the app depends on.
 */
export const getAgencyClinicsAgencyClinicsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetAgencyClinicsAgencyClinicsGetData, ThrowOnError>
): RequestResult<
  GetAgencyClinicsAgencyClinicsGetResponses,
  GetAgencyClinicsAgencyClinicsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetAgencyClinicsAgencyClinicsGetResponses,
    GetAgencyClinicsAgencyClinicsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/agency-clinics/',
    ...options,
  });

/**
 * Create Agency Clinic
 *
 * Create a new agency clinic
 */
export const createAgencyClinicAgencyClinicsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateAgencyClinicAgencyClinicsPostData, ThrowOnError>
): RequestResult<
  CreateAgencyClinicAgencyClinicsPostResponses,
  CreateAgencyClinicAgencyClinicsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateAgencyClinicAgencyClinicsPostResponses,
    CreateAgencyClinicAgencyClinicsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/agency-clinics/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Agency Clinic Scope
 *
 * Report whether the caller can access every clinic in the agency.
 */
export const getAgencyClinicScopeAgencyClinicsScopeGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetAgencyClinicScopeAgencyClinicsScopeGetData, ThrowOnError>
): RequestResult<
  GetAgencyClinicScopeAgencyClinicsScopeGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetAgencyClinicScopeAgencyClinicsScopeGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/agency-clinics/scope',
    ...options,
  });

/**
 * List Agency Clinic Physicians
 *
 * List active clinic physicians for task creation and order assignment.
 */
export const listAgencyClinicPhysiciansAgencyClinicsAgencyClinicIdPhysiciansGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ListAgencyClinicPhysiciansAgencyClinicsAgencyClinicIdPhysiciansGetData,
      ThrowOnError
    >
  ): RequestResult<
    ListAgencyClinicPhysiciansAgencyClinicsAgencyClinicIdPhysiciansGetResponses,
    ListAgencyClinicPhysiciansAgencyClinicsAgencyClinicIdPhysiciansGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      ListAgencyClinicPhysiciansAgencyClinicsAgencyClinicIdPhysiciansGetResponses,
      ListAgencyClinicPhysiciansAgencyClinicsAgencyClinicIdPhysiciansGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/agency-clinics/{agency_clinic_id}/physicians',
      ...options,
    });

/**
 * Get Agency Clinic Hhrg Costs
 */
export const getAgencyClinicHhrgCostsAgencyClinicsAgencyClinicIdHhrgCostsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAgencyClinicHhrgCostsAgencyClinicsAgencyClinicIdHhrgCostsGetData,
    ThrowOnError
  >
): RequestResult<
  GetAgencyClinicHhrgCostsAgencyClinicsAgencyClinicIdHhrgCostsGetResponses,
  GetAgencyClinicHhrgCostsAgencyClinicsAgencyClinicIdHhrgCostsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAgencyClinicHhrgCostsAgencyClinicsAgencyClinicIdHhrgCostsGetResponses,
    GetAgencyClinicHhrgCostsAgencyClinicsAgencyClinicIdHhrgCostsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/agency-clinics/{agency_clinic_id}/hhrg-costs',
    ...options,
  });

/**
 * Update Agency Clinic Hhrg Costs
 */
export const updateAgencyClinicHhrgCostsAgencyClinicsAgencyClinicIdHhrgCostsPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdateAgencyClinicHhrgCostsAgencyClinicsAgencyClinicIdHhrgCostsPutData,
      ThrowOnError
    >
  ): RequestResult<
    UpdateAgencyClinicHhrgCostsAgencyClinicsAgencyClinicIdHhrgCostsPutResponses,
    UpdateAgencyClinicHhrgCostsAgencyClinicsAgencyClinicIdHhrgCostsPutErrors,
    ThrowOnError
  > =>
    (options.client ?? client).put<
      UpdateAgencyClinicHhrgCostsAgencyClinicsAgencyClinicIdHhrgCostsPutResponses,
      UpdateAgencyClinicHhrgCostsAgencyClinicsAgencyClinicIdHhrgCostsPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/agency-clinics/{agency_clinic_id}/hhrg-costs',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Delete Agency Clinic
 *
 * Delete an agency clinic
 */
export const deleteAgencyClinicAgencyClinicsAgencyClinicIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAgencyClinicAgencyClinicsAgencyClinicIdDeleteData,
    ThrowOnError
  >
): RequestResult<
  DeleteAgencyClinicAgencyClinicsAgencyClinicIdDeleteResponses,
  DeleteAgencyClinicAgencyClinicsAgencyClinicIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteAgencyClinicAgencyClinicsAgencyClinicIdDeleteResponses,
    DeleteAgencyClinicAgencyClinicsAgencyClinicIdDeleteErrors,
    ThrowOnError
  >({ url: '/agency-clinics/{agency_clinic_id}', ...options });

/**
 * Get Agency Clinic
 *
 * Get a specific agency clinic by ID
 */
export const getAgencyClinicAgencyClinicsAgencyClinicIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAgencyClinicAgencyClinicsAgencyClinicIdGetData,
    ThrowOnError
  >
): RequestResult<
  GetAgencyClinicAgencyClinicsAgencyClinicIdGetResponses,
  GetAgencyClinicAgencyClinicsAgencyClinicIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAgencyClinicAgencyClinicsAgencyClinicIdGetResponses,
    GetAgencyClinicAgencyClinicsAgencyClinicIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/agency-clinics/{agency_clinic_id}',
    ...options,
  });

/**
 * Update Agency Clinic
 *
 * Update an agency clinic
 */
export const updateAgencyClinicAgencyClinicsAgencyClinicIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateAgencyClinicAgencyClinicsAgencyClinicIdPutData,
    ThrowOnError
  >
): RequestResult<
  UpdateAgencyClinicAgencyClinicsAgencyClinicIdPutResponses,
  UpdateAgencyClinicAgencyClinicsAgencyClinicIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateAgencyClinicAgencyClinicsAgencyClinicIdPutResponses,
    UpdateAgencyClinicAgencyClinicsAgencyClinicIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/agency-clinics/{agency_clinic_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Check Clinic Oasis Export Errors
 *
 * What CMS and the nightly SHP batch would refuse in these clinic settings,
 * judged while they are typed so the clinic dialog can show each under its
 * field in the OASIS Manager's words. Writes nothing.
 *
 * Behind the clinic-information edit permission, like the edit it advises.
 */
export const checkClinicOasisExportErrorsAgencyClinicsOasisExportErrorsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CheckClinicOasisExportErrorsAgencyClinicsOasisExportErrorsPostData,
    ThrowOnError
  >
): RequestResult<
  CheckClinicOasisExportErrorsAgencyClinicsOasisExportErrorsPostResponses,
  CheckClinicOasisExportErrorsAgencyClinicsOasisExportErrorsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CheckClinicOasisExportErrorsAgencyClinicsOasisExportErrorsPostResponses,
    CheckClinicOasisExportErrorsAgencyClinicsOasisExportErrorsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/agency-clinics/oasis-export-errors',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Disconnect Agency Clinic From Kinnser
 *
 * Give up Kinnser/WellSky participation for one clinic.
 *
 * Roger takes over the clinic: its payers become manually creatable, and the
 * clinic-info sync stops writing to it. The stamp this leaves is sticky, so
 * the next scrape does not promote the clinic back. ``clinic_key`` and the
 * WellSky roster snapshot are kept, so participation can be restored.
 */
export const disconnectAgencyClinicFromKinnserAgencyClinicsAgencyClinicIdKinnserDisconnectPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DisconnectAgencyClinicFromKinnserAgencyClinicsAgencyClinicIdKinnserDisconnectPostData,
      ThrowOnError
    >
  ): RequestResult<
    DisconnectAgencyClinicFromKinnserAgencyClinicsAgencyClinicIdKinnserDisconnectPostResponses,
    DisconnectAgencyClinicFromKinnserAgencyClinicsAgencyClinicIdKinnserDisconnectPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      DisconnectAgencyClinicFromKinnserAgencyClinicsAgencyClinicIdKinnserDisconnectPostResponses,
      DisconnectAgencyClinicFromKinnserAgencyClinicsAgencyClinicIdKinnserDisconnectPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/agency-clinics/{agency_clinic_id}/kinnser-disconnect',
      ...options,
    });

/**
 * Reconnect Agency Clinic To Kinnser
 *
 * Restore Kinnser/WellSky participation for a disconnected clinic.
 *
 * Clears the sticky stamp and marks the clinic participating again straight
 * away, rather than waiting for a scrape to re-promote it. The scrape runs
 * daily, so an operator reverting mid-cutover would otherwise click this and
 * see nothing change. It is also the conservative direction: payers go back to
 * being sync-owned immediately.
 */
export const reconnectAgencyClinicToKinnserAgencyClinicsAgencyClinicIdKinnserReconnectPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ReconnectAgencyClinicToKinnserAgencyClinicsAgencyClinicIdKinnserReconnectPostData,
      ThrowOnError
    >
  ): RequestResult<
    ReconnectAgencyClinicToKinnserAgencyClinicsAgencyClinicIdKinnserReconnectPostResponses,
    ReconnectAgencyClinicToKinnserAgencyClinicsAgencyClinicIdKinnserReconnectPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      ReconnectAgencyClinicToKinnserAgencyClinicsAgencyClinicIdKinnserReconnectPostResponses,
      ReconnectAgencyClinicToKinnserAgencyClinicsAgencyClinicIdKinnserReconnectPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/agency-clinics/{agency_clinic_id}/kinnser-reconnect',
      ...options,
    });

/**
 * Sync Clinics From Clinic Info
 *
 * Sync AgencyClinic and AgencyInsurance records by fetching clinic information from RogerDoc API.
 *
 * This endpoint retrieves clinic information from the RogerDoc API and creates
 * or updates AgencyClinic and AgencyInsurance records in the database.
 * Clinic records are deduplicated based on clinic_key, and insurance records
 * are deduplicated based on clinic_key and insurance_key.
 *
 * Args:
 * request: FastAPI request object
 * ctx: Current context for authentication
 * db: Database session
 *
 * Returns:
 * Dictionary with sync results:
 * {
 * "clinics": {
 * "created_count": 5,
 * "updated_count": 2,
 * "skipped_count": 1,
 * "total_count": 8
 * },
 * "insurances": {
 * "created_count": 12,
 * "updated_count": 3,
 * "skipped_count": 2,
 * "total_count": 17
 * },
 * "message": "Clinics and insurances synced successfully"
 * }
 *
 * Raises:
 * HTTPException: If RogerDoc API is unavailable or database operations fail
 */
export const syncClinicsFromClinicInfoAgencyClinicsSyncFromClinicInfoPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    SyncClinicsFromClinicInfoAgencyClinicsSyncFromClinicInfoPostData,
    ThrowOnError
  >
): RequestResult<
  SyncClinicsFromClinicInfoAgencyClinicsSyncFromClinicInfoPostResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    SyncClinicsFromClinicInfoAgencyClinicsSyncFromClinicInfoPostResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/agency-clinics/sync-from-clinic-info',
    ...options,
  });

/**
 * Get Agency Insurances
 *
 * Get agency insurance records.
 *
 * Retrieve insurance provider configurations for agencies. Can filter by
 * agency ID and/or agency clinic ID.
 *
 * Args:
 * agency_id: Optional UUID to filter by specific agency
 * agency_clinic_id: Optional UUID to filter by specific agency clinic
 * skip: Number of records to skip for pagination
 * limit: Optional maximum number of records to return (no limit if not specified)
 * ctx: Current context for authentication
 * db: Database session
 *
 * Returns:
 * List of agency insurance records
 */
export const getAgencyInsurancesClinicsInsuranceGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetAgencyInsurancesClinicsInsuranceGetData, ThrowOnError>
): RequestResult<
  GetAgencyInsurancesClinicsInsuranceGetResponses,
  GetAgencyInsurancesClinicsInsuranceGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetAgencyInsurancesClinicsInsuranceGetResponses,
    GetAgencyInsurancesClinicsInsuranceGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/clinics/insurance',
    ...options,
  });

/**
 * Create Agency Insurance
 *
 * Create a new agency insurance record.
 *
 * Only available when the agency has is_rogeremr_enabled=True.
 * The selected clinic must belong to the agency and must not participate in
 * Kinnser (``is_kinnser`` / deprecated KINNSER_SYNCED origin); Kinnser-
 * participating clinics manage insurances through the clinic-info sync.
 */
export const createAgencyInsuranceClinicsInsurancePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateAgencyInsuranceClinicsInsurancePostData, ThrowOnError>
): RequestResult<
  CreateAgencyInsuranceClinicsInsurancePostResponses,
  CreateAgencyInsuranceClinicsInsurancePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateAgencyInsuranceClinicsInsurancePostResponses,
    CreateAgencyInsuranceClinicsInsurancePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/clinics/insurance',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Duplicate Clinic Insurances
 *
 * Copy every insurance from a source clinic onto a destination clinic.
 *
 * Useful when onboarding a clinic that should reuse the insurance roster of
 * another (e.g. copying from a scraped Kinnser clinic onto a Roger-only
 * clinic). Destination must not participate in Kinnser. Insurances whose
 * Payer ID and name already exist on the destination clinic are skipped, so
 * the operation is safe to re-run.
 *
 * Only available when the agency has is_rogeremr_enabled=True. Both clinics
 * must belong to the agency.
 */
export const duplicateClinicInsurancesClinicsInsuranceDuplicatePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DuplicateClinicInsurancesClinicsInsuranceDuplicatePostData,
    ThrowOnError
  >
): RequestResult<
  DuplicateClinicInsurancesClinicsInsuranceDuplicatePostResponses,
  DuplicateClinicInsurancesClinicsInsuranceDuplicatePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DuplicateClinicInsurancesClinicsInsuranceDuplicatePostResponses,
    DuplicateClinicInsurancesClinicsInsuranceDuplicatePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/clinics/insurance/duplicate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Agency Insurance
 *
 * Retire an agency insurance record (``is_active = False``).
 *
 * Not a row delete: it leaves the pickers, while claims and charts that
 * already use it keep resolving it. Refused (409) while a patient policy,
 * active episode, billing cycle or authorization references it.
 *
 * Only available when the agency has is_rogeremr_enabled=True.
 * Only insurances belonging to the current user's agency can be retired.
 */
export const deleteAgencyInsuranceClinicsInsuranceInsuranceIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAgencyInsuranceClinicsInsuranceInsuranceIdDeleteData,
    ThrowOnError
  >
): RequestResult<
  DeleteAgencyInsuranceClinicsInsuranceInsuranceIdDeleteResponses,
  DeleteAgencyInsuranceClinicsInsuranceInsuranceIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteAgencyInsuranceClinicsInsuranceInsuranceIdDeleteResponses,
    DeleteAgencyInsuranceClinicsInsuranceInsuranceIdDeleteErrors,
    ThrowOnError
  >({ url: '/clinics/insurance/{insurance_id}', ...options });

/**
 * Update Agency Insurance
 *
 * Update an existing agency insurance record.
 *
 * Only available when the agency has is_rogeremr_enabled=True.
 * Only insurances belonging to the current user's agency can be updated.
 * Re-maps payor_id when edi_payer_id changes.
 */
export const updateAgencyInsuranceClinicsInsuranceInsuranceIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateAgencyInsuranceClinicsInsuranceInsuranceIdPutData,
    ThrowOnError
  >
): RequestResult<
  UpdateAgencyInsuranceClinicsInsuranceInsuranceIdPutResponses,
  UpdateAgencyInsuranceClinicsInsuranceInsuranceIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateAgencyInsuranceClinicsInsuranceInsuranceIdPutResponses,
    UpdateAgencyInsuranceClinicsInsuranceInsuranceIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/clinics/insurance/{insurance_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Insurance Visit Rates
 *
 * Get the per-visit rate grid for an insurance.
 *
 * Only available when the agency has is_rogeremr_enabled=True. Only
 * insurances belonging to the current user's agency are visible.
 */
export const getInsuranceVisitRatesClinicsInsuranceInsuranceIdRatesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetInsuranceVisitRatesClinicsInsuranceInsuranceIdRatesGetData,
    ThrowOnError
  >
): RequestResult<
  GetInsuranceVisitRatesClinicsInsuranceInsuranceIdRatesGetResponses,
  GetInsuranceVisitRatesClinicsInsuranceInsuranceIdRatesGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetInsuranceVisitRatesClinicsInsuranceInsuranceIdRatesGetResponses,
    GetInsuranceVisitRatesClinicsInsuranceInsuranceIdRatesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/clinics/insurance/{insurance_id}/rates',
    ...options,
  });

/**
 * Replace Insurance Visit Rates
 *
 * Replace an insurance's per-visit rate rows with an admin edit (replace-all).
 *
 * Rows absent from the payload are deleted; created rows are MANUAL; existing
 * rows whose values change flip to MANUAL but keep their WellSky provenance.
 * Returns the fresh, authoritative grid after saving.
 *
 * Only available when the agency has is_rogeremr_enabled=True. Only
 * insurances belonging to the current user's agency can be edited.
 */
export const replaceInsuranceVisitRatesClinicsInsuranceInsuranceIdRatesPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ReplaceInsuranceVisitRatesClinicsInsuranceInsuranceIdRatesPutData,
    ThrowOnError
  >
): RequestResult<
  ReplaceInsuranceVisitRatesClinicsInsuranceInsuranceIdRatesPutResponses,
  ReplaceInsuranceVisitRatesClinicsInsuranceInsuranceIdRatesPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    ReplaceInsuranceVisitRatesClinicsInsuranceInsuranceIdRatesPutResponses,
    ReplaceInsuranceVisitRatesClinicsInsuranceInsuranceIdRatesPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/clinics/insurance/{insurance_id}/rates',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Insurance Visit Rate Defaults
 *
 * Get the Roger default billing codes for an insurance's rate grid.
 *
 * Pure lookup — never writes. One record per non-legacy visit type: revenue
 * and HCPCS G-code both from VISIT_TYPE_INFO, payer-independent.
 *
 * Only available when the agency has is_rogeremr_enabled=True. Only
 * insurances belonging to the current user's agency are visible.
 */
export const getInsuranceVisitRateDefaultsClinicsInsuranceInsuranceIdRatesDefaultsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetInsuranceVisitRateDefaultsClinicsInsuranceInsuranceIdRatesDefaultsGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetInsuranceVisitRateDefaultsClinicsInsuranceInsuranceIdRatesDefaultsGetResponses,
    GetInsuranceVisitRateDefaultsClinicsInsuranceInsuranceIdRatesDefaultsGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetInsuranceVisitRateDefaultsClinicsInsuranceInsuranceIdRatesDefaultsGetResponses,
      GetInsuranceVisitRateDefaultsClinicsInsuranceInsuranceIdRatesDefaultsGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/clinics/insurance/{insurance_id}/rates/defaults',
      ...options,
    });

/**
 * Get Agency Enrollments
 *
 * Stedi enrollment state for every clinic in the agency.
 *
 * Reads stored records only; refreshing them is a separate call.
 */
export const getAgencyEnrollmentsClinicsEnrollmentsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetAgencyEnrollmentsClinicsEnrollmentsGetData, ThrowOnError>
): RequestResult<
  GetAgencyEnrollmentsClinicsEnrollmentsGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetAgencyEnrollmentsClinicsEnrollmentsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/clinics/enrollments',
    ...options,
  });

/**
 * Get Agency Payer Enrollments
 *
 * The same enrollments as GET /enrollments, one row per payer.
 *
 * Same guards as that view: an EMR agency and full clinic scope. A demo sandbox
 * still gets its payer rows, since the frontend lists every insurance not
 * under one as having no payer ID, but none of the real agency's enrollment
 * data.
 */
export const getAgencyPayerEnrollmentsClinicsEnrollmentsPayersGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetAgencyPayerEnrollmentsClinicsEnrollmentsPayersGetData,
    ThrowOnError
  >
): RequestResult<
  GetAgencyPayerEnrollmentsClinicsEnrollmentsPayersGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetAgencyPayerEnrollmentsClinicsEnrollmentsPayersGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/clinics/enrollments/payers',
    ...options,
  });

/**
 * Get Agency Enrollment Count
 *
 * How many enrollments need a person, for the count on the Admin tab.
 *
 * The Admin page renders its tab bar without mounting the tab, so this is
 * fetched separately rather than taken from the enrollments view. It answers
 * with a number rather than rows, and the same guards as the view — including
 * the demo sandbox, which must not be told anything about the real agency
 * whose NPI it carries.
 */
export const getAgencyEnrollmentCountClinicsEnrollmentsCountGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetAgencyEnrollmentCountClinicsEnrollmentsCountGetData,
    ThrowOnError
  >
): RequestResult<
  GetAgencyEnrollmentCountClinicsEnrollmentsCountGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetAgencyEnrollmentCountClinicsEnrollmentsCountGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/clinics/enrollments/count',
    ...options,
  });

/**
 * Complete Agency Enrollment Task
 *
 * Send the answers to one Stedi enrollment task, such as an NGS packet ID.
 *
 * An outward action in the agency's name, so it has its own permission rather
 * than riding on the tab's. The answers are sent to Stedi and not kept — see
 * ``app.services.enrollment_tasks`` for what may be sent.
 */
export const completeAgencyEnrollmentTaskClinicsEnrollmentsRecordIdTasksTaskIdCompletePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      CompleteAgencyEnrollmentTaskClinicsEnrollmentsRecordIdTasksTaskIdCompletePostData,
      ThrowOnError
    >
  ): RequestResult<
    CompleteAgencyEnrollmentTaskClinicsEnrollmentsRecordIdTasksTaskIdCompletePostResponses,
    CompleteAgencyEnrollmentTaskClinicsEnrollmentsRecordIdTasksTaskIdCompletePostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      CompleteAgencyEnrollmentTaskClinicsEnrollmentsRecordIdTasksTaskIdCompletePostResponses,
      CompleteAgencyEnrollmentTaskClinicsEnrollmentsRecordIdTasksTaskIdCompletePostErrors,
      ThrowOnError
    >({
      url: '/clinics/enrollments/{record_id}/tasks/{task_id}/complete',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Get Bulk Enroll Review
 *
 * What Start enrollments would submit for these clinics (all, when none).
 */
export const getBulkEnrollReviewClinicsEnrollmentsBulkGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetBulkEnrollReviewClinicsEnrollmentsBulkGetData,
    ThrowOnError
  >
): RequestResult<
  GetBulkEnrollReviewClinicsEnrollmentsBulkGetResponses,
  GetBulkEnrollReviewClinicsEnrollmentsBulkGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetBulkEnrollReviewClinicsEnrollmentsBulkGetResponses,
    GetBulkEnrollReviewClinicsEnrollmentsBulkGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/clinics/enrollments/bulk',
    ...options,
  });

/**
 * Submit Bulk Enroll
 *
 * Create the chosen enrollments in Stedi, submitted, and store them.
 *
 * Each line reports its own outcome; one clinic failing does not stop the
 * rest. What was stored is committed even when some lines failed.
 */
export const submitBulkEnrollClinicsEnrollmentsBulkPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SubmitBulkEnrollClinicsEnrollmentsBulkPostData, ThrowOnError>
): RequestResult<
  SubmitBulkEnrollClinicsEnrollmentsBulkPostResponses,
  SubmitBulkEnrollClinicsEnrollmentsBulkPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SubmitBulkEnrollClinicsEnrollmentsBulkPostResponses,
    SubmitBulkEnrollClinicsEnrollmentsBulkPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/clinics/enrollments/bulk',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Refresh Agency Enrollments
 *
 * Pull Stedi enrollments for every clinic in the agency that has an NPI.
 *
 * The same code the hourly schedule runs, narrowed to this agency. The fetch
 * is one account-wide request either way; ``only_agency_id`` bounds what is
 * written, because the request carries this agency's ExecutionContext and the
 * records are agency-private rows.
 */
export const refreshAgencyEnrollmentsClinicsEnrollmentsRefreshPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    RefreshAgencyEnrollmentsClinicsEnrollmentsRefreshPostData,
    ThrowOnError
  >
): RequestResult<
  RefreshAgencyEnrollmentsClinicsEnrollmentsRefreshPostResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    RefreshAgencyEnrollmentsClinicsEnrollmentsRefreshPostResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/clinics/enrollments/refresh',
    ...options,
  });

/**
 * Get External Emr Summary
 *
 * Counts for the Patient Manager's External EMR view.
 *
 * Shells not yet imported, how many of those are ready, how many patients
 * are importing now, how many charts came from the External EMR (with the
 * list's test and active filters), when the latest completed census
 * refresh finished, and the latest refresh itself (running, completed with
 * counts, or failed with a sentence to show). Narrowed to the clinics the
 * caller can see.
 *
 * ``import_ready`` says whether the agency's stored External EMR login and
 * consent can carry an import now; when not, ``import_blocked_reason`` is
 * the sentence to show in place of the Import and refresh controls. Read
 * from Roger Docs at most every 30 s per agency, since the page polls this
 * while a census runs; an Import or refresh press always asks fresh.
 */
export const getExternalEmrSummaryPatientsExternalEmrSummaryGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetExternalEmrSummaryPatientsExternalEmrSummaryGetData,
    ThrowOnError
  >
): RequestResult<
  GetExternalEmrSummaryPatientsExternalEmrSummaryGetResponses,
  GetExternalEmrSummaryPatientsExternalEmrSummaryGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetExternalEmrSummaryPatientsExternalEmrSummaryGetResponses,
    GetExternalEmrSummaryPatientsExternalEmrSummaryGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/external-emr/summary',
    ...options,
  });

/**
 * Get External Emr Custody Filter
 *
 * Whether task lists offer "Show only Roger EMR tasks" (Take Over v2).
 *
 * Offered while the agency has an External EMR, syncing or not. Without
 * one no task is marked External, so the filter would hide nothing.
 * ``external_current`` still answers, for the UI's copy. Behind the Roger
 * EMR gate only. No permission: it filters lists the caller already sees.
 */
export const getExternalEmrCustodyFilterPatientsExternalEmrCustodyFilterGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetExternalEmrCustodyFilterPatientsExternalEmrCustodyFilterGetData,
    ThrowOnError
  >
): RequestResult<
  GetExternalEmrCustodyFilterPatientsExternalEmrCustodyFilterGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetExternalEmrCustodyFilterPatientsExternalEmrCustodyFilterGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/external-emr/custody-filter',
    ...options,
  });

/**
 * Get External Emr Import Readiness
 *
 * Whether the agency's stored External EMR login and consent can carry an
 * import now, and the sentence to show when not.
 *
 * The shell chart page reads it on load, so the reason shows in place of
 * Import before anyone presses. Reads only; asks Roger Docs fresh.
 */
export const getExternalEmrImportReadinessPatientsExternalEmrImportReadinessGet =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      GetExternalEmrImportReadinessPatientsExternalEmrImportReadinessGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetExternalEmrImportReadinessPatientsExternalEmrImportReadinessGetResponses,
    unknown,
    ThrowOnError
  > =>
    (options?.client ?? client).get<
      GetExternalEmrImportReadinessPatientsExternalEmrImportReadinessGetResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/external-emr/import-readiness',
      ...options,
    });

/**
 * Sync External Emr Census
 *
 * Refresh the External EMR census in the background.
 *
 * Commits a ``running`` run row, then starts the agency's census sync (a
 * Temporal workflow) with it, and answers at once: ``started``, or
 * ``already_running`` when a refresh is under way. The summary shows the
 * run as running from the moment this answers. A workflow that cannot
 * start settles the row as failed and answers 503.
 * Roger Docs then reads the census (up to 420 s: one External EMR sign-in
 * and one report per branch) and the shells are refreshed. Read the outcome
 * from ``census_sync`` on ``GET /patients/external-emr/summary``.
 *
 * The census is an agency-level fact, so any ``chart-import:start`` holder
 * may refresh it, a clinic-scoped one included. The run's counts (created,
 * updated, missing, ...) are agency-wide, so they tell a clinic-scoped
 * caller how many census patients sit in clinics they cannot see. The
 * patients themselves stay behind the clinic filter.
 *
 * 409 with the reason when the agency's stored login or consent cannot
 * carry a refresh; nothing is started. A press while a refresh runs answers
 * ``already_running`` without asking: it starts no new work.
 */
export const syncExternalEmrCensusPatientsExternalEmrCensusPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    SyncExternalEmrCensusPatientsExternalEmrCensusPostData,
    ThrowOnError
  >
): RequestResult<
  SyncExternalEmrCensusPatientsExternalEmrCensusPostResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    SyncExternalEmrCensusPatientsExternalEmrCensusPostResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/external-emr/census',
    ...options,
  });

/**
 * Start Patient External Emr Import
 *
 * Import External EMR shells' charts, one or many.
 *
 * One patient goes ahead of any bulk capture; several go at bulk priority.
 * Each patient answers on its own: the queue row it now has, or why it was
 * refused. Pressing again returns a live import as it stands, or reopens a
 * failed one. 409 with the reason, and nothing queued, when a press that
 * would queue new work meets a stored login or consent that cannot carry
 * it. A press that only finds live imports never asks.
 */
export const startPatientExternalEmrImportPatientsExternalEmrImportStartPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    StartPatientExternalEmrImportPatientsExternalEmrImportStartPostData,
    ThrowOnError
  >
): RequestResult<
  StartPatientExternalEmrImportPatientsExternalEmrImportStartPostResponses,
  StartPatientExternalEmrImportPatientsExternalEmrImportStartPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    StartPatientExternalEmrImportPatientsExternalEmrImportStartPostResponses,
    StartPatientExternalEmrImportPatientsExternalEmrImportStartPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/external-emr-import/start',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Refresh Patient External Emr Import
 *
 * Refresh an imported chart from the External EMR.
 *
 * Queues a refresh of this chart at interactive priority: what is new in
 * the External EMR is added, matched rows nobody edited in Roger are
 * brought forward, and every row a person edited in Roger is left exactly
 * as saved. Never an overwrite. The office uses it at cutover, and again
 * once the External EMR has QA'd and exported the recert.
 *
 * The answer is the queue row the chart now has, or ``refused_reason``:
 * the chart is a shell or did not come from the External EMR, it has no
 * MRN or clinic, or another kind of import of this patient is live. While
 * the chart's earlier episodes are still arriving, the refresh waits:
 * ``refused_code`` is ``history_arriving``.
 * Pressing again returns the live refresh as it stands, or reopens a
 * failed one. 409 with the reason, and nothing queued, when a press that
 * would queue new work meets a stored login or consent that cannot carry
 * it. Read progress and the result from
 * ``GET /patients/{patient_id}/external-emr-import``.
 */
export const refreshPatientExternalEmrImportPatientsPatientIdExternalEmrImportRefreshPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      RefreshPatientExternalEmrImportPatientsPatientIdExternalEmrImportRefreshPostData,
      ThrowOnError
    >
  ): RequestResult<
    RefreshPatientExternalEmrImportPatientsPatientIdExternalEmrImportRefreshPostResponses,
    RefreshPatientExternalEmrImportPatientsPatientIdExternalEmrImportRefreshPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      RefreshPatientExternalEmrImportPatientsPatientIdExternalEmrImportRefreshPostResponses,
      RefreshPatientExternalEmrImportPatientsPatientIdExternalEmrImportRefreshPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/external-emr-import/refresh',
      ...options,
    });

/**
 * Cancel Patient External Emr Import Route
 *
 * Cancel this patient's import, or detach the patient from it.
 *
 * Only an import the Patient Manager started is canceled. An operator's
 * import keeps running and only the patient's link is removed. A failed or canceled import is detached; a
 * completed one stays.
 */
export const cancelPatientExternalEmrImportRoutePatientsPatientIdExternalEmrImportDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      CancelPatientExternalEmrImportRoutePatientsPatientIdExternalEmrImportDeleteData,
      ThrowOnError
    >
  ): RequestResult<
    CancelPatientExternalEmrImportRoutePatientsPatientIdExternalEmrImportDeleteResponses,
    CancelPatientExternalEmrImportRoutePatientsPatientIdExternalEmrImportDeleteErrors,
    ThrowOnError
  > =>
    (options.client ?? client).delete<
      CancelPatientExternalEmrImportRoutePatientsPatientIdExternalEmrImportDeleteResponses,
      CancelPatientExternalEmrImportRoutePatientsPatientIdExternalEmrImportDeleteErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/external-emr-import',
      ...options,
    });

/**
 * Get Patient External Emr Import
 *
 * Where this patient's Patient Manager import stands, with its stage.
 *
 * Behind the Roger EMR gate only, so an import stays readable after the
 * agency's import is switched off, through to its outcome: a shell linked
 * to an import in any state still answers here, so a failed or canceled
 * import reads as such. A shell with no import answers 404 like any
 * hidden shell.
 *
 * ``can_start`` says whether the agency's import is switched on. With it
 * off, the status still reads but Retry and Cancel would be refused, so the
 * page shows neither.
 */
export const getPatientExternalEmrImportPatientsPatientIdExternalEmrImportGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetPatientExternalEmrImportPatientsPatientIdExternalEmrImportGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetPatientExternalEmrImportPatientsPatientIdExternalEmrImportGetResponses,
    GetPatientExternalEmrImportPatientsPatientIdExternalEmrImportGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetPatientExternalEmrImportPatientsPatientIdExternalEmrImportGetResponses,
      GetPatientExternalEmrImportPatientsPatientIdExternalEmrImportGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/external-emr-import',
      ...options,
    });

/**
 * Put External Emr Planned Charts From
 *
 * Store or clear the day Roger charts from, planned on the census row.
 *
 * Inside the census episode, from tomorrow, and no later than the day
 * after the last day in the External EMR, else 422. A stored day on or
 * before today is locked while it fits: moving or clearing it is 422. Take
 * Over prefills it. Gated on ``episode:take-over`` here and again in the
 * service.
 */
export const putExternalEmrPlannedChartsFromPatientsPatientIdExternalEmrPlannedChartsFromPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      PutExternalEmrPlannedChartsFromPatientsPatientIdExternalEmrPlannedChartsFromPutData,
      ThrowOnError
    >
  ): RequestResult<
    PutExternalEmrPlannedChartsFromPatientsPatientIdExternalEmrPlannedChartsFromPutResponses,
    PutExternalEmrPlannedChartsFromPatientsPatientIdExternalEmrPlannedChartsFromPutErrors,
    ThrowOnError
  > =>
    (options.client ?? client).put<
      PutExternalEmrPlannedChartsFromPatientsPatientIdExternalEmrPlannedChartsFromPutResponses,
      PutExternalEmrPlannedChartsFromPatientsPatientIdExternalEmrPlannedChartsFromPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/external-emr-planned-charts-from',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Match Patients
 *
 * Find potential duplicate patients in Roger EMR for the same agency clinic.
 *
 * Weighted scoring (SSN, name, DOB, phone, zip, gender) with a minimum score
 * threshold; intended to mirror Kinnser-style duplicate detection for intakes.
 */
export const matchPatientsPatientsMatchPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MatchPatientsPatientsMatchPostData, ThrowOnError>
): RequestResult<
  MatchPatientsPatientsMatchPostResponses,
  MatchPatientsPatientsMatchPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    MatchPatientsPatientsMatchPostResponses,
    MatchPatientsPatientsMatchPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/match',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Patients
 *
 * Get a bounded Patient Manager page with matching-population metadata.
 */
export const getPatientsPatientsGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetPatientsPatientsGetData, ThrowOnError>
): RequestResult<
  GetPatientsPatientsGetResponses,
  GetPatientsPatientsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetPatientsPatientsGetResponses,
    GetPatientsPatientsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/',
    ...options,
  });

/**
 * Create Patient
 *
 * Create a new patient.
 * Admission and episode are NOT auto-created - they must be created separately
 * with a valid start date through the intake workflow or admission endpoint.
 */
export const createPatientPatientsPost = <ThrowOnError extends boolean = false>(
  options: Options<CreatePatientPatientsPostData, ThrowOnError>
): RequestResult<
  CreatePatientPatientsPostResponses,
  CreatePatientPatientsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreatePatientPatientsPostResponses,
    CreatePatientPatientsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Set Patient Test Status
 *
 * Mark or un-mark a patient as a test/practice patient.
 *
 * Available to any authenticated clinician (Keyur) — clinicians in
 * training may need to run test patients before committing to real work. The
 * flag is set only here, never through the general patient update body. It does
 * not block billing: the payer/CMS exits warn-and-confirm (claim, NOA) or mock
 * (eligibility) for a flagged patient. The marking UI explains this up front.
 */
export const setPatientTestStatusPatientsPatientIdTestStatusPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SetPatientTestStatusPatientsPatientIdTestStatusPatchData,
    ThrowOnError
  >
): RequestResult<
  SetPatientTestStatusPatientsPatientIdTestStatusPatchResponses,
  SetPatientTestStatusPatientsPatientIdTestStatusPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    SetPatientTestStatusPatientsPatientIdTestStatusPatchResponses,
    SetPatientTestStatusPatientsPatientIdTestStatusPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/test-status',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Set Patient Import Badge
 *
 * Hide or re-show the Imported badge on an imported patient.
 *
 * Demotion, not removal: once care is established in Roger the badge is
 * noise, so any clinician can hide it — the same ungated UX call as the
 * test-patient toggle above. The provenance columns are untouched; the
 * toggle in the Patient Info tab remains the residual indicator. 422 for a
 * patient that was never imported.
 */
export const setPatientImportBadgePatientsPatientIdImportBadgePatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SetPatientImportBadgePatientsPatientIdImportBadgePatchData,
    ThrowOnError
  >
): RequestResult<
  SetPatientImportBadgePatientsPatientIdImportBadgePatchResponses,
  SetPatientImportBadgePatientsPatientIdImportBadgePatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    SetPatientImportBadgePatientsPatientIdImportBadgePatchResponses,
    SetPatientImportBadgePatientsPatientIdImportBadgePatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/import-badge',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Export Patients
 *
 * Every patient the list would show under these filters, as one worksheet.
 *
 * A file of up to EXPORT_ROW_LIMIT charts with their notes leaves the
 * system, so unlike the page it needs the Patient Manager permission and
 * is audited. More matching patients than the limit is refused (422).
 */
export const exportPatientsPatientsExportGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ExportPatientsPatientsExportGetData, ThrowOnError>
): RequestResult<
  ExportPatientsPatientsExportGetResponses,
  ExportPatientsPatientsExportGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ExportPatientsPatientsExportGetResponses,
    ExportPatientsPatientsExportGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/patients/export',
    ...options,
  });

/**
 * Get Patient Count
 *
 * Get total count of patients.
 * If user has an agency, count is filtered to that agency.
 */
export const getPatientCountPatientsCountGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetPatientCountPatientsCountGetData, ThrowOnError>
): RequestResult<
  GetPatientCountPatientsCountGetResponses,
  GetPatientCountPatientsCountGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetPatientCountPatientsCountGetResponses,
    GetPatientCountPatientsCountGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/count',
    ...options,
  });

/**
 * Delete Patient
 *
 * Delete a patient.
 */
export const deletePatientPatientsPatientIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeletePatientPatientsPatientIdDeleteData, ThrowOnError>
): RequestResult<
  DeletePatientPatientsPatientIdDeleteResponses,
  DeletePatientPatientsPatientIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeletePatientPatientsPatientIdDeleteResponses,
    DeletePatientPatientsPatientIdDeleteErrors,
    ThrowOnError
  >({ url: '/patients/{patient_id}', ...options });

/**
 * Get Patient
 *
 * Get a specific patient by ID.
 *
 * A hidden External EMR shell answers 404 (``visible_patient_or_404``).
 */
export const getPatientPatientsPatientIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetPatientPatientsPatientIdGetData, ThrowOnError>
): RequestResult<
  GetPatientPatientsPatientIdGetResponses,
  GetPatientPatientsPatientIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetPatientPatientsPatientIdGetResponses,
    GetPatientPatientsPatientIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}',
    ...options,
  });

/**
 * Update Patient
 *
 * Update a patient, with a manager gate for Patient Info form fields.
 *
 * Patient Allergies shares this endpoint for its single ``no_known_allergies``
 * flag. Keep that exact payload available to clinicians while requiring the
 * Patient Info edit permission for fields sent by PatientInfoTab.
 */
export const updatePatientPatientsPatientIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdatePatientPatientsPatientIdPutData, ThrowOnError>
): RequestResult<
  UpdatePatientPatientsPatientIdPutResponses,
  UpdatePatientPatientsPatientIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdatePatientPatientsPatientIdPutResponses,
    UpdatePatientPatientsPatientIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Check Oasis Mrn Sync
 *
 * Which of this patient's charts still answer M0020 with an older MRN.
 *
 * Patient Info calls this straight after a save that changed the MRN, and
 * opens its popup only when something comes back. Editing the MRN never
 * changes a chart by itself, so an empty answer here means the edit is simply
 * done.
 *
 * Behind the same permission as the update it precedes: this is the offer, so
 * it should be visible to exactly the people who could accept it.
 */
export const checkOasisMrnSyncPatientsPatientIdOasisMrnSyncCheckGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CheckOasisMrnSyncPatientsPatientIdOasisMrnSyncCheckGetData,
    ThrowOnError
  >
): RequestResult<
  CheckOasisMrnSyncPatientsPatientIdOasisMrnSyncCheckGetResponses,
  CheckOasisMrnSyncPatientsPatientIdOasisMrnSyncCheckGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    CheckOasisMrnSyncPatientsPatientIdOasisMrnSyncCheckGetResponses,
    CheckOasisMrnSyncPatientsPatientIdOasisMrnSyncCheckGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/oasis-mrn-sync/check',
    ...options,
  });

/**
 * Check Patient Oasis Export Errors
 *
 * The CMS fatals these Patient Info values would give the patient's OASIS
 * export, judged while they are typed so Patient Info can show each under
 * its field in the OASIS Manager's words. Writes nothing.
 *
 * Behind the Patient Info edit permission, like the edit it advises.
 */
export const checkPatientOasisExportErrorsPatientsPatientIdOasisExportErrorsPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      CheckPatientOasisExportErrorsPatientsPatientIdOasisExportErrorsPostData,
      ThrowOnError
    >
  ): RequestResult<
    CheckPatientOasisExportErrorsPatientsPatientIdOasisExportErrorsPostResponses,
    CheckPatientOasisExportErrorsPatientsPatientIdOasisExportErrorsPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      CheckPatientOasisExportErrorsPatientsPatientIdOasisExportErrorsPostResponses,
      CheckPatientOasisExportErrorsPatientsPatientIdOasisExportErrorsPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/oasis-export-errors',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Sync Oasis Mrn
 *
 * Write the confirmed MRN into M0020 on the charts the user accepted.
 *
 * Gated by the Patient Info edit permission, the same one that let them
 * change the MRN in the first place. Per-chart editability is the real bound
 * and is re-checked under each row's lock, so this cannot reach a chart the
 * caller could not have opened and edited by hand.
 *
 * Confined to charts belonging to ``patient_id``: the request names visit ids,
 * and re-deriving the offer here is what stops one being pointed at another
 * patient's chart.
 *
 * The body's MRN is what the user was shown, and it must still be the
 * patient's. That makes this endpoint a way to copy the record onto the
 * charts, never a way to write an arbitrary Patient ID into clinical
 * documentation, and it turns another edit landing in between into a refusal
 * rather than a silent write of a value nobody confirmed.
 */
export const syncOasisMrnPatientsPatientIdOasisMrnSyncPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SyncOasisMrnPatientsPatientIdOasisMrnSyncPostData,
    ThrowOnError
  >
): RequestResult<
  SyncOasisMrnPatientsPatientIdOasisMrnSyncPostResponses,
  SyncOasisMrnPatientsPatientIdOasisMrnSyncPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SyncOasisMrnPatientsPatientIdOasisMrnSyncPostResponses,
    SyncOasisMrnPatientsPatientIdOasisMrnSyncPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/oasis-mrn-sync',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Current Episode
 *
 * Return the latest episode for a patient with its case manager assignment.
 */
export const getCurrentEpisodePatientsPatientIdCurrentEpisodeGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetCurrentEpisodePatientsPatientIdCurrentEpisodeGetData,
    ThrowOnError
  >
): RequestResult<
  GetCurrentEpisodePatientsPatientIdCurrentEpisodeGetResponses,
  GetCurrentEpisodePatientsPatientIdCurrentEpisodeGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetCurrentEpisodePatientsPatientIdCurrentEpisodeGetResponses,
    GetCurrentEpisodePatientsPatientIdCurrentEpisodeGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/current-episode',
    ...options,
  });

/**
 * Update Current Episode Case Manager
 *
 * Update the case manager on the patient's latest episode.
 */
export const updateCurrentEpisodeCaseManagerPatientsPatientIdCurrentEpisodeCaseManagerPatch =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdateCurrentEpisodeCaseManagerPatientsPatientIdCurrentEpisodeCaseManagerPatchData,
      ThrowOnError
    >
  ): RequestResult<
    UpdateCurrentEpisodeCaseManagerPatientsPatientIdCurrentEpisodeCaseManagerPatchResponses,
    UpdateCurrentEpisodeCaseManagerPatientsPatientIdCurrentEpisodeCaseManagerPatchErrors,
    ThrowOnError
  > =>
    (options.client ?? client).patch<
      UpdateCurrentEpisodeCaseManagerPatientsPatientIdCurrentEpisodeCaseManagerPatchResponses,
      UpdateCurrentEpisodeCaseManagerPatientsPatientIdCurrentEpisodeCaseManagerPatchErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/current-episode/case-manager',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Update Current Episode Clinical Manager
 *
 * Set or clear the clinical manager on the patient's latest episode.
 */
export const updateCurrentEpisodeClinicalManagerPatientsPatientIdCurrentEpisodeClinicalManagerPatch =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdateCurrentEpisodeClinicalManagerPatientsPatientIdCurrentEpisodeClinicalManagerPatchData,
      ThrowOnError
    >
  ): RequestResult<
    UpdateCurrentEpisodeClinicalManagerPatientsPatientIdCurrentEpisodeClinicalManagerPatchResponses,
    UpdateCurrentEpisodeClinicalManagerPatientsPatientIdCurrentEpisodeClinicalManagerPatchErrors,
    ThrowOnError
  > =>
    (options.client ?? client).patch<
      UpdateCurrentEpisodeClinicalManagerPatientsPatientIdCurrentEpisodeClinicalManagerPatchResponses,
      UpdateCurrentEpisodeClinicalManagerPatientsPatientIdCurrentEpisodeClinicalManagerPatchErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/current-episode/clinical-manager',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Update Current Episode Disaster Triage Codes
 *
 * Update both safety codes on the patient's latest episode.
 */
export const updateCurrentEpisodeDisasterTriageCodesPatientsPatientIdCurrentEpisodeDisasterTriageCodesPatch =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdateCurrentEpisodeDisasterTriageCodesPatientsPatientIdCurrentEpisodeDisasterTriageCodesPatchData,
      ThrowOnError
    >
  ): RequestResult<
    UpdateCurrentEpisodeDisasterTriageCodesPatientsPatientIdCurrentEpisodeDisasterTriageCodesPatchResponses,
    UpdateCurrentEpisodeDisasterTriageCodesPatientsPatientIdCurrentEpisodeDisasterTriageCodesPatchErrors,
    ThrowOnError
  > =>
    (options.client ?? client).patch<
      UpdateCurrentEpisodeDisasterTriageCodesPatientsPatientIdCurrentEpisodeDisasterTriageCodesPatchResponses,
      UpdateCurrentEpisodeDisasterTriageCodesPatientsPatientIdCurrentEpisodeDisasterTriageCodesPatchErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/current-episode/disaster-triage-codes',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Get Patient Visits
 *
 * Get all visits for a patient (across all admissions/episodes).
 * Pass `episode_id` to restrict to a single episode's visits (still scoped to
 * the patient). If user has an agency, results are filtered to that agency.
 * Includes episode start and end dates for each visit.
 */
export const getPatientVisitsPatientsPatientIdVisitsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetPatientVisitsPatientsPatientIdVisitsGetData, ThrowOnError>
): RequestResult<
  GetPatientVisitsPatientsPatientIdVisitsGetResponses,
  GetPatientVisitsPatientsPatientIdVisitsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetPatientVisitsPatientsPatientIdVisitsGetResponses,
    GetPatientVisitsPatientsPatientIdVisitsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/visits',
    ...options,
  });

/**
 * Create Patient Visit
 *
 * Create a new visit for a patient.
 *
 * The visit will be created for the provided episode, or the most recent
 * episode of the patient when no episode is provided.
 * If no episode exists, returns an error - episodes must be created explicitly
 * with proper start dates through the intake workflow or admission endpoint.
 * If user has an agency, ensures the patient belongs to that agency.
 */
export const createPatientVisitPatientsPatientIdVisitsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreatePatientVisitPatientsPatientIdVisitsPostData,
    ThrowOnError
  >
): RequestResult<
  CreatePatientVisitPatientsPatientIdVisitsPostResponses,
  CreatePatientVisitPatientsPatientIdVisitsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreatePatientVisitPatientsPatientIdVisitsPostResponses,
    CreatePatientVisitPatientsPatientIdVisitsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/visits',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Episode Vitals Summary
 *
 * Episode-level vital signs from completed, non-missed visits.
 *
 * Aggregates RN and OASIS Enhanced vital qids from each visit's ``visit_data``
 * into a time series for the patient chart Vitals tab. Min/max/latest are
 * computed on the client from the readings (so filters stay consistent).
 */
export const getEpisodeVitalsSummaryPatientsPatientIdEpisodesEpisodeIdVitalsSummaryGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetEpisodeVitalsSummaryPatientsPatientIdEpisodesEpisodeIdVitalsSummaryGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetEpisodeVitalsSummaryPatientsPatientIdEpisodesEpisodeIdVitalsSummaryGetResponses,
    GetEpisodeVitalsSummaryPatientsPatientIdEpisodesEpisodeIdVitalsSummaryGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetEpisodeVitalsSummaryPatientsPatientIdEpisodesEpisodeIdVitalsSummaryGetResponses,
      GetEpisodeVitalsSummaryPatientsPatientIdEpisodesEpisodeIdVitalsSummaryGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/episodes/{episode_id}/vitals-summary',
      ...options,
    });

/**
 * Get Patient Tasks
 *
 * Get all tasks (visits + orders) for a patient with task-scope fields only.
 */
export const getPatientTasksPatientsPatientIdTasksGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetPatientTasksPatientsPatientIdTasksGetData, ThrowOnError>
): RequestResult<
  GetPatientTasksPatientsPatientIdTasksGetResponses,
  GetPatientTasksPatientsPatientIdTasksGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetPatientTasksPatientsPatientIdTasksGetResponses,
    GetPatientTasksPatientsPatientIdTasksGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/tasks',
    ...options,
  });

/**
 * Get Deleted Patient Tasks
 *
 * List the patient's soft-deleted tasks, newest deletion first.
 *
 * Deleted work stays readable: a task removed by mistake, or one holding data
 * that still has to come off the chart, can be printed and inspected without
 * being restored. Kept separate from the live task list so nothing downstream
 * of it (calendar, counts, batch actions, billing selection) has to learn to
 * skip deleted rows.
 *
 * Deliberately gated the same way as the live task list: agency scope and an
 * authenticated session, no extra permission. Anyone who could read the task
 * before it was deleted can read it after, which is the point. Narrowing this
 * to a role is a product decision, not something to add by default.
 */
export const getDeletedPatientTasksPatientsPatientIdDeletedTasksGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetDeletedPatientTasksPatientsPatientIdDeletedTasksGetData,
    ThrowOnError
  >
): RequestResult<
  GetDeletedPatientTasksPatientsPatientIdDeletedTasksGetResponses,
  GetDeletedPatientTasksPatientsPatientIdDeletedTasksGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetDeletedPatientTasksPatientsPatientIdDeletedTasksGetResponses,
    GetDeletedPatientTasksPatientsPatientIdDeletedTasksGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/deleted-tasks',
    ...options,
  });

/**
 * Bulk Create Patient Visits
 *
 * Create several visits on a visit-accepting episode, then finalize prefills.
 *
 * Visit rows commit together before OASIS prefills and derived-code sync run.
 * A failure in that later finalization leaves the initial visits committed.
 */
export const bulkCreatePatientVisitsPatientsPatientIdVisitsBulkPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    BulkCreatePatientVisitsPatientsPatientIdVisitsBulkPostData,
    ThrowOnError
  >
): RequestResult<
  BulkCreatePatientVisitsPatientsPatientIdVisitsBulkPostResponses,
  BulkCreatePatientVisitsPatientsPatientIdVisitsBulkPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    BulkCreatePatientVisitsPatientsPatientIdVisitsBulkPostResponses,
    BulkCreatePatientVisitsPatientsPatientIdVisitsBulkPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/visits/bulk',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Patient External Order Renders
 *
 * The previous EMR's order and plan-of-care renders for a patient.
 *
 * Renders of orders the import carried over as Roger orders belong to those
 * orders and are not listed. What remains are prints tied to no order, as a
 * patient document with no task behind it. The Orders tab lists these so the
 * chart still shows them.
 */
export const getPatientExternalOrderRendersPatientsPatientIdExternalOrderRendersGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetPatientExternalOrderRendersPatientsPatientIdExternalOrderRendersGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetPatientExternalOrderRendersPatientsPatientIdExternalOrderRendersGetResponses,
    GetPatientExternalOrderRendersPatientsPatientIdExternalOrderRendersGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetPatientExternalOrderRendersPatientsPatientIdExternalOrderRendersGetResponses,
      GetPatientExternalOrderRendersPatientsPatientIdExternalOrderRendersGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/external-order-renders',
      ...options,
    });

/**
 * Get Patient Documents
 *
 * Get all documents for a patient.
 */
export const getPatientDocumentsPatientsPatientIdDocumentsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPatientDocumentsPatientsPatientIdDocumentsGetData,
    ThrowOnError
  >
): RequestResult<
  GetPatientDocumentsPatientsPatientIdDocumentsGetResponses,
  GetPatientDocumentsPatientsPatientIdDocumentsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetPatientDocumentsPatientsPatientIdDocumentsGetResponses,
    GetPatientDocumentsPatientsPatientIdDocumentsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/documents',
    ...options,
  });

/**
 * Upload Patient Document
 *
 * Upload a new document for a patient.
 */
export const uploadPatientDocumentPatientsPatientIdDocumentsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UploadPatientDocumentPatientsPatientIdDocumentsPostData,
    ThrowOnError
  >
): RequestResult<
  UploadPatientDocumentPatientsPatientIdDocumentsPostResponses,
  UploadPatientDocumentPatientsPatientIdDocumentsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UploadPatientDocumentPatientsPatientIdDocumentsPostResponses,
    UploadPatientDocumentPatientsPatientIdDocumentsPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/patients/{patient_id}/documents',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Get Patient Document Url
 *
 * Get a presigned URL to view/download a specific patient document.
 */
export const getPatientDocumentUrlPatientsPatientIdDocumentsDocumentIdUrlGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPatientDocumentUrlPatientsPatientIdDocumentsDocumentIdUrlGetData,
    ThrowOnError
  >
): RequestResult<
  GetPatientDocumentUrlPatientsPatientIdDocumentsDocumentIdUrlGetResponses,
  GetPatientDocumentUrlPatientsPatientIdDocumentsDocumentIdUrlGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetPatientDocumentUrlPatientsPatientIdDocumentsDocumentIdUrlGetResponses,
    GetPatientDocumentUrlPatientsPatientIdDocumentsDocumentIdUrlGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/documents/{document_id}/url',
    ...options,
  });

/**
 * Verify Patient Document Signature
 *
 * Verify a signed patient document's integrity (e.g. medication record).
 *
 * Recomputes the MAC from the stored snapshot under the stored key and
 * checks the mutable signed_at column against its hashed twin in the
 * snapshot's signature_event block.
 */
export const verifyPatientDocumentSignaturePatientsPatientIdDocumentsDocumentIdVerifyGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      VerifyPatientDocumentSignaturePatientsPatientIdDocumentsDocumentIdVerifyGetData,
      ThrowOnError
    >
  ): RequestResult<
    VerifyPatientDocumentSignaturePatientsPatientIdDocumentsDocumentIdVerifyGetResponses,
    VerifyPatientDocumentSignaturePatientsPatientIdDocumentsDocumentIdVerifyGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      VerifyPatientDocumentSignaturePatientsPatientIdDocumentsDocumentIdVerifyGetResponses,
      VerifyPatientDocumentSignaturePatientsPatientIdDocumentsDocumentIdVerifyGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/documents/{document_id}/verify',
      ...options,
    });

/**
 * Delete Patient Intake Document
 *
 * Soft-delete a patient-associated intake document from Patient Manager.
 */
export const deletePatientIntakeDocumentPatientsPatientIdIntakeDocumentsDocumentIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeletePatientIntakeDocumentPatientsPatientIdIntakeDocumentsDocumentIdDeleteData,
      ThrowOnError
    >
  ): RequestResult<
    DeletePatientIntakeDocumentPatientsPatientIdIntakeDocumentsDocumentIdDeleteResponses,
    DeletePatientIntakeDocumentPatientsPatientIdIntakeDocumentsDocumentIdDeleteErrors,
    ThrowOnError
  > =>
    (options.client ?? client).delete<
      DeletePatientIntakeDocumentPatientsPatientIdIntakeDocumentsDocumentIdDeleteResponses,
      DeletePatientIntakeDocumentPatientsPatientIdIntakeDocumentsDocumentIdDeleteErrors,
      ThrowOnError
    >({
      url: '/patients/{patient_id}/intake-documents/{document_id}',
      ...options,
    });

/**
 * Delete Patient Document
 *
 * Soft-delete a patient document by setting deleted_at/deleted_by.
 */
export const deletePatientDocumentPatientsPatientIdDocumentsDocumentIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeletePatientDocumentPatientsPatientIdDocumentsDocumentIdDeleteData,
    ThrowOnError
  >
): RequestResult<
  DeletePatientDocumentPatientsPatientIdDocumentsDocumentIdDeleteResponses,
  DeletePatientDocumentPatientsPatientIdDocumentsDocumentIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeletePatientDocumentPatientsPatientIdDocumentsDocumentIdDeleteResponses,
    DeletePatientDocumentPatientsPatientIdDocumentsDocumentIdDeleteErrors,
    ThrowOnError
  >({ url: '/patients/{patient_id}/documents/{document_id}', ...options });

/**
 * Update Patient Document
 *
 * Update a patient document (e.g., rename).
 */
export const updatePatientDocumentPatientsPatientIdDocumentsDocumentIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdatePatientDocumentPatientsPatientIdDocumentsDocumentIdPatchData,
    ThrowOnError
  >
): RequestResult<
  UpdatePatientDocumentPatientsPatientIdDocumentsDocumentIdPatchResponses,
  UpdatePatientDocumentPatientsPatientIdDocumentsDocumentIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdatePatientDocumentPatientsPatientIdDocumentsDocumentIdPatchResponses,
    UpdatePatientDocumentPatientsPatientIdDocumentsDocumentIdPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/documents/{document_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Patient Tag Definitions
 */
export const listPatientTagDefinitionsPatientTagsDefinitionsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ListPatientTagDefinitionsPatientTagsDefinitionsGetData,
    ThrowOnError
  >
): RequestResult<
  ListPatientTagDefinitionsPatientTagsDefinitionsGetResponses,
  ListPatientTagDefinitionsPatientTagsDefinitionsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListPatientTagDefinitionsPatientTagsDefinitionsGetResponses,
    ListPatientTagDefinitionsPatientTagsDefinitionsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patient-tags/definitions',
    ...options,
  });

/**
 * Create Patient Tag Definition
 */
export const createPatientTagDefinitionPatientTagsDefinitionsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreatePatientTagDefinitionPatientTagsDefinitionsPostData,
    ThrowOnError
  >
): RequestResult<
  CreatePatientTagDefinitionPatientTagsDefinitionsPostResponses,
  CreatePatientTagDefinitionPatientTagsDefinitionsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreatePatientTagDefinitionPatientTagsDefinitionsPostResponses,
    CreatePatientTagDefinitionPatientTagsDefinitionsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patient-tags/definitions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Rename Patient Tag Definition
 */
export const renamePatientTagDefinitionPatientTagsDefinitionsDefinitionIdPatch =
  <ThrowOnError extends boolean = false>(
    options: Options<
      RenamePatientTagDefinitionPatientTagsDefinitionsDefinitionIdPatchData,
      ThrowOnError
    >
  ): RequestResult<
    RenamePatientTagDefinitionPatientTagsDefinitionsDefinitionIdPatchResponses,
    RenamePatientTagDefinitionPatientTagsDefinitionsDefinitionIdPatchErrors,
    ThrowOnError
  > =>
    (options.client ?? client).patch<
      RenamePatientTagDefinitionPatientTagsDefinitionsDefinitionIdPatchResponses,
      RenamePatientTagDefinitionPatientTagsDefinitionsDefinitionIdPatchErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patient-tags/definitions/{definition_id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Archive Patient Tag Definition
 */
export const archivePatientTagDefinitionPatientTagsDefinitionsDefinitionIdArchivePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ArchivePatientTagDefinitionPatientTagsDefinitionsDefinitionIdArchivePostData,
      ThrowOnError
    >
  ): RequestResult<
    ArchivePatientTagDefinitionPatientTagsDefinitionsDefinitionIdArchivePostResponses,
    ArchivePatientTagDefinitionPatientTagsDefinitionsDefinitionIdArchivePostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      ArchivePatientTagDefinitionPatientTagsDefinitionsDefinitionIdArchivePostResponses,
      ArchivePatientTagDefinitionPatientTagsDefinitionsDefinitionIdArchivePostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patient-tags/definitions/{definition_id}/archive',
      ...options,
    });

/**
 * Reactivate Patient Tag Definition
 */
export const reactivatePatientTagDefinitionPatientTagsDefinitionsDefinitionIdReactivatePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ReactivatePatientTagDefinitionPatientTagsDefinitionsDefinitionIdReactivatePostData,
      ThrowOnError
    >
  ): RequestResult<
    ReactivatePatientTagDefinitionPatientTagsDefinitionsDefinitionIdReactivatePostResponses,
    ReactivatePatientTagDefinitionPatientTagsDefinitionsDefinitionIdReactivatePostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      ReactivatePatientTagDefinitionPatientTagsDefinitionsDefinitionIdReactivatePostResponses,
      ReactivatePatientTagDefinitionPatientTagsDefinitionsDefinitionIdReactivatePostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patient-tags/definitions/{definition_id}/reactivate',
      ...options,
    });

/**
 * Get Intake Patient Tags
 */
export const getIntakePatientTagsPatientTagsIntakesIntakeIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetIntakePatientTagsPatientTagsIntakesIntakeIdGetData,
    ThrowOnError
  >
): RequestResult<
  GetIntakePatientTagsPatientTagsIntakesIntakeIdGetResponses,
  GetIntakePatientTagsPatientTagsIntakesIntakeIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetIntakePatientTagsPatientTagsIntakesIntakeIdGetResponses,
    GetIntakePatientTagsPatientTagsIntakesIntakeIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patient-tags/intakes/{intake_id}',
    ...options,
  });

/**
 * Replace Intake Patient Tags
 */
export const replaceIntakePatientTagsPatientTagsIntakesIntakeIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ReplaceIntakePatientTagsPatientTagsIntakesIntakeIdPutData,
    ThrowOnError
  >
): RequestResult<
  ReplaceIntakePatientTagsPatientTagsIntakesIntakeIdPutResponses,
  ReplaceIntakePatientTagsPatientTagsIntakesIntakeIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    ReplaceIntakePatientTagsPatientTagsIntakesIntakeIdPutResponses,
    ReplaceIntakePatientTagsPatientTagsIntakesIntakeIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patient-tags/intakes/{intake_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Patient Tags
 */
export const getPatientTagsPatientTagsPatientsPatientIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPatientTagsPatientTagsPatientsPatientIdGetData,
    ThrowOnError
  >
): RequestResult<
  GetPatientTagsPatientTagsPatientsPatientIdGetResponses,
  GetPatientTagsPatientTagsPatientsPatientIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetPatientTagsPatientTagsPatientsPatientIdGetResponses,
    GetPatientTagsPatientTagsPatientsPatientIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patient-tags/patients/{patient_id}',
    ...options,
  });

/**
 * Replace Patient Tags
 */
export const replacePatientTagsPatientTagsPatientsPatientIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ReplacePatientTagsPatientTagsPatientsPatientIdPutData,
    ThrowOnError
  >
): RequestResult<
  ReplacePatientTagsPatientTagsPatientsPatientIdPutResponses,
  ReplacePatientTagsPatientTagsPatientsPatientIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    ReplacePatientTagsPatientTagsPatientsPatientIdPutResponses,
    ReplacePatientTagsPatientTagsPatientsPatientIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patient-tags/patients/{patient_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Patient Chart Imports
 *
 * The import runs recorded for this chart, newest first.
 */
export const listPatientChartImportsPatientsPatientIdChartImportsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListPatientChartImportsPatientsPatientIdChartImportsGetData,
    ThrowOnError
  >
): RequestResult<
  ListPatientChartImportsPatientsPatientIdChartImportsGetResponses,
  ListPatientChartImportsPatientsPatientIdChartImportsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListPatientChartImportsPatientsPatientIdChartImportsGetResponses,
    ListPatientChartImportsPatientsPatientIdChartImportsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/chart-imports',
    ...options,
  });

/**
 * List Patient Import Review Items
 *
 * What a refresh left for a person to settle on this chart, open first.
 */
export const listPatientImportReviewItemsPatientsPatientIdChartImportsReviewItemsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ListPatientImportReviewItemsPatientsPatientIdChartImportsReviewItemsGetData,
      ThrowOnError
    >
  ): RequestResult<
    ListPatientImportReviewItemsPatientsPatientIdChartImportsReviewItemsGetResponses,
    ListPatientImportReviewItemsPatientsPatientIdChartImportsReviewItemsGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      ListPatientImportReviewItemsPatientsPatientIdChartImportsReviewItemsGetResponses,
      ListPatientImportReviewItemsPatientsPatientIdChartImportsReviewItemsGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/chart-imports/review-items',
      ...options,
    });

/**
 * Acknowledge All Patient Import Review Items
 *
 * Acknowledge every open item on the chart. Roger's values stay.
 */
export const acknowledgeAllPatientImportReviewItemsPatientsPatientIdChartImportsReviewItemsAcknowledgeAllPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      AcknowledgeAllPatientImportReviewItemsPatientsPatientIdChartImportsReviewItemsAcknowledgeAllPostData,
      ThrowOnError
    >
  ): RequestResult<
    AcknowledgeAllPatientImportReviewItemsPatientsPatientIdChartImportsReviewItemsAcknowledgeAllPostResponses,
    AcknowledgeAllPatientImportReviewItemsPatientsPatientIdChartImportsReviewItemsAcknowledgeAllPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      AcknowledgeAllPatientImportReviewItemsPatientsPatientIdChartImportsReviewItemsAcknowledgeAllPostResponses,
      AcknowledgeAllPatientImportReviewItemsPatientsPatientIdChartImportsReviewItemsAcknowledgeAllPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/chart-imports/review-items/acknowledge-all',
      ...options,
    });

/**
 * Acknowledge Patient Import Review Item
 *
 * Settle one item: keep Roger's value, take External EMR's, or just acknowledge.
 *
 * "Take External EMR's value" writes the value onto the chart and is refused
 * when a claim has gone out since the item was written. An item already
 * acknowledged is returned as it stands; the first answer holds.
 */
export const acknowledgePatientImportReviewItemPatientsPatientIdChartImportsReviewItemsItemIdAcknowledgePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      AcknowledgePatientImportReviewItemPatientsPatientIdChartImportsReviewItemsItemIdAcknowledgePostData,
      ThrowOnError
    >
  ): RequestResult<
    AcknowledgePatientImportReviewItemPatientsPatientIdChartImportsReviewItemsItemIdAcknowledgePostResponses,
    AcknowledgePatientImportReviewItemPatientsPatientIdChartImportsReviewItemsItemIdAcknowledgePostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      AcknowledgePatientImportReviewItemPatientsPatientIdChartImportsReviewItemsItemIdAcknowledgePostResponses,
      AcknowledgePatientImportReviewItemPatientsPatientIdChartImportsReviewItemsItemIdAcknowledgePostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/chart-imports/review-items/{item_id}/acknowledge',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Get Patient Chart Import Report
 *
 * One run's report, grouped by what the reader does with each line.
 */
export const getPatientChartImportReportPatientsPatientIdChartImportsRunIdReportGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetPatientChartImportReportPatientsPatientIdChartImportsRunIdReportGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetPatientChartImportReportPatientsPatientIdChartImportsRunIdReportGetResponses,
    GetPatientChartImportReportPatientsPatientIdChartImportsRunIdReportGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetPatientChartImportReportPatientsPatientIdChartImportsRunIdReportGetResponses,
      GetPatientChartImportReportPatientsPatientIdChartImportsRunIdReportGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/chart-imports/{run_id}/report',
      ...options,
    });

/**
 * Mark Patient Chart Import Reviewed
 *
 * Record that the caller read this run's report.
 */
export const markPatientChartImportReviewedPatientsPatientIdChartImportsRunIdReviewPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      MarkPatientChartImportReviewedPatientsPatientIdChartImportsRunIdReviewPostData,
      ThrowOnError
    >
  ): RequestResult<
    MarkPatientChartImportReviewedPatientsPatientIdChartImportsRunIdReviewPostResponses,
    MarkPatientChartImportReviewedPatientsPatientIdChartImportsRunIdReviewPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      MarkPatientChartImportReviewedPatientsPatientIdChartImportsRunIdReviewPostResponses,
      MarkPatientChartImportReviewedPatientsPatientIdChartImportsRunIdReviewPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/chart-imports/{run_id}/review',
      ...options,
    });

/**
 * Get Patient Sync Review
 *
 * What the External EMR changed on this moved chart since the review was closed.
 *
 * Read the way the import report is read: anyone who can see the patient.
 */
export const getPatientSyncReviewPatientsPatientIdChartImportsSyncReviewGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPatientSyncReviewPatientsPatientIdChartImportsSyncReviewGetData,
    ThrowOnError
  >
): RequestResult<
  GetPatientSyncReviewPatientsPatientIdChartImportsSyncReviewGetResponses,
  GetPatientSyncReviewPatientsPatientIdChartImportsSyncReviewGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetPatientSyncReviewPatientsPatientIdChartImportsSyncReviewGetResponses,
    GetPatientSyncReviewPatientsPatientIdChartImportsSyncReviewGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/chart-imports/sync-review',
    ...options,
  });

/**
 * Close Patient Sync Review
 *
 * Record that the review showing these runs was opened and closed.
 *
 * One mark per run, shared by the agency: the review stops listing these
 * changes for everyone. Runs that landed after the dialog opened stay new.
 */
export const closePatientSyncReviewPatientsPatientIdChartImportsSyncReviewClosePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ClosePatientSyncReviewPatientsPatientIdChartImportsSyncReviewClosePostData,
      ThrowOnError
    >
  ): RequestResult<
    ClosePatientSyncReviewPatientsPatientIdChartImportsSyncReviewClosePostResponses,
    ClosePatientSyncReviewPatientsPatientIdChartImportsSyncReviewClosePostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      ClosePatientSyncReviewPatientsPatientIdChartImportsSyncReviewClosePostResponses,
      ClosePatientSyncReviewPatientsPatientIdChartImportsSyncReviewClosePostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/chart-imports/sync-review/close',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Get Inbox
 */
export const getInboxChatInboxGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetInboxChatInboxGetData, ThrowOnError>
): RequestResult<
  GetInboxChatInboxGetResponses,
  GetInboxChatInboxGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetInboxChatInboxGetResponses,
    GetInboxChatInboxGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/chat/inbox',
    ...options,
  });

/**
 * Post Link Titles
 */
export const postLinkTitlesChatLinkTitlesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostLinkTitlesChatLinkTitlesPostData, ThrowOnError>
): RequestResult<
  PostLinkTitlesChatLinkTitlesPostResponses,
  PostLinkTitlesChatLinkTitlesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostLinkTitlesChatLinkTitlesPostResponses,
    PostLinkTitlesChatLinkTitlesPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/chat/link-titles',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Directory
 */
export const getDirectoryChatDirectoryGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetDirectoryChatDirectoryGetData, ThrowOnError>
): RequestResult<
  GetDirectoryChatDirectoryGetResponses,
  GetDirectoryChatDirectoryGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetDirectoryChatDirectoryGetResponses,
    GetDirectoryChatDirectoryGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/chat/directory',
    ...options,
  });

/**
 * Start Conversation
 */
export const startConversationChatConversationsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<StartConversationChatConversationsPostData, ThrowOnError>
): RequestResult<
  StartConversationChatConversationsPostResponses,
  StartConversationChatConversationsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    StartConversationChatConversationsPostResponses,
    StartConversationChatConversationsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/chat/conversations',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Channel By Episode
 */
export const getChannelByEpisodeChatChannelsByEpisodeEpisodeIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetChannelByEpisodeChatChannelsByEpisodeEpisodeIdGetData,
    ThrowOnError
  >
): RequestResult<
  GetChannelByEpisodeChatChannelsByEpisodeEpisodeIdGetResponses,
  GetChannelByEpisodeChatChannelsByEpisodeEpisodeIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetChannelByEpisodeChatChannelsByEpisodeEpisodeIdGetResponses,
    GetChannelByEpisodeChatChannelsByEpisodeEpisodeIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/chat/channels/by-episode/{episode_id}',
    ...options,
  });

/**
 * Open Channel By Episode
 */
export const openChannelByEpisodeChatChannelsByEpisodeEpisodeIdPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    OpenChannelByEpisodeChatChannelsByEpisodeEpisodeIdPostData,
    ThrowOnError
  >
): RequestResult<
  OpenChannelByEpisodeChatChannelsByEpisodeEpisodeIdPostResponses,
  OpenChannelByEpisodeChatChannelsByEpisodeEpisodeIdPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OpenChannelByEpisodeChatChannelsByEpisodeEpisodeIdPostResponses,
    OpenChannelByEpisodeChatChannelsByEpisodeEpisodeIdPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/chat/channels/by-episode/{episode_id}',
    ...options,
  });

/**
 * Get Channel
 */
export const getChannelChatChannelsChannelIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetChannelChatChannelsChannelIdGetData, ThrowOnError>
): RequestResult<
  GetChannelChatChannelsChannelIdGetResponses,
  GetChannelChatChannelsChannelIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetChannelChatChannelsChannelIdGetResponses,
    GetChannelChatChannelsChannelIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/chat/channels/{channel_id}',
    ...options,
  });

/**
 * Search Channel Members
 */
export const searchChannelMembersChatChannelsChannelIdMembersGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SearchChannelMembersChatChannelsChannelIdMembersGetData,
    ThrowOnError
  >
): RequestResult<
  SearchChannelMembersChatChannelsChannelIdMembersGetResponses,
  SearchChannelMembersChatChannelsChannelIdMembersGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    SearchChannelMembersChatChannelsChannelIdMembersGetResponses,
    SearchChannelMembersChatChannelsChannelIdMembersGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/chat/channels/{channel_id}/members',
    ...options,
  });

/**
 * Get Messages
 */
export const getMessagesChatChannelsChannelIdMessagesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetMessagesChatChannelsChannelIdMessagesGetData,
    ThrowOnError
  >
): RequestResult<
  GetMessagesChatChannelsChannelIdMessagesGetResponses,
  GetMessagesChatChannelsChannelIdMessagesGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetMessagesChatChannelsChannelIdMessagesGetResponses,
    GetMessagesChatChannelsChannelIdMessagesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/chat/channels/{channel_id}/messages',
    ...options,
  });

/**
 * Send Message
 *
 * The route owns the transaction: commit, then publish (ruling 22).
 *
 * A rollback never reaches the publish line, so no frame is produced for a
 * message that does not exist. ``publish_user_events`` logs and swallows
 * ``EventBrokerError``; the stream's 5 s poll covers a lost publish.
 */
export const sendMessageChatChannelsChannelIdMessagesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SendMessageChatChannelsChannelIdMessagesPostData,
    ThrowOnError
  >
): RequestResult<
  SendMessageChatChannelsChannelIdMessagesPostResponses,
  SendMessageChatChannelsChannelIdMessagesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SendMessageChatChannelsChannelIdMessagesPostResponses,
    SendMessageChatChannelsChannelIdMessagesPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/chat/channels/{channel_id}/messages',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Message
 *
 * Commit, then publish, the same order as a send.
 */
export const deleteMessageChatChannelsChannelIdMessagesMessageIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteMessageChatChannelsChannelIdMessagesMessageIdDeleteData,
    ThrowOnError
  >
): RequestResult<
  DeleteMessageChatChannelsChannelIdMessagesMessageIdDeleteResponses,
  DeleteMessageChatChannelsChannelIdMessagesMessageIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteMessageChatChannelsChannelIdMessagesMessageIdDeleteResponses,
    DeleteMessageChatChannelsChannelIdMessagesMessageIdDeleteErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/chat/channels/{channel_id}/messages/{message_id}',
    ...options,
  });

/**
 * Edit Message
 *
 * Commit, then publish, the same order as a send.
 */
export const editMessageChatChannelsChannelIdMessagesMessageIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    EditMessageChatChannelsChannelIdMessagesMessageIdPatchData,
    ThrowOnError
  >
): RequestResult<
  EditMessageChatChannelsChannelIdMessagesMessageIdPatchResponses,
  EditMessageChatChannelsChannelIdMessagesMessageIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    EditMessageChatChannelsChannelIdMessagesMessageIdPatchResponses,
    EditMessageChatChannelsChannelIdMessagesMessageIdPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/chat/channels/{channel_id}/messages/{message_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Set Message Reaction
 *
 * Commit, then publish, the same order as a send. A no-op change has no
 * recipients, so nothing is published.
 */
export const setMessageReactionChatChannelsChannelIdMessagesMessageIdReactionsPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      SetMessageReactionChatChannelsChannelIdMessagesMessageIdReactionsPutData,
      ThrowOnError
    >
  ): RequestResult<
    SetMessageReactionChatChannelsChannelIdMessagesMessageIdReactionsPutResponses,
    SetMessageReactionChatChannelsChannelIdMessagesMessageIdReactionsPutErrors,
    ThrowOnError
  > =>
    (options.client ?? client).put<
      SetMessageReactionChatChannelsChannelIdMessagesMessageIdReactionsPutResponses,
      SetMessageReactionChatChannelsChannelIdMessagesMessageIdReactionsPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/chat/channels/{channel_id}/messages/{message_id}/reactions',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Mark Read
 */
export const markReadChatChannelsChannelIdReadPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MarkReadChatChannelsChannelIdReadPostData, ThrowOnError>
): RequestResult<
  MarkReadChatChannelsChannelIdReadPostResponses,
  MarkReadChatChannelsChannelIdReadPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    MarkReadChatChannelsChannelIdReadPostResponses,
    MarkReadChatChannelsChannelIdReadPostErrors,
    ThrowOnError
  >({
    url: '/chat/channels/{channel_id}/read',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Archive Channel
 */
export const archiveChannelChatChannelsChannelIdArchivePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ArchiveChannelChatChannelsChannelIdArchivePostData,
    ThrowOnError
  >
): RequestResult<
  ArchiveChannelChatChannelsChannelIdArchivePostResponses,
  ArchiveChannelChatChannelsChannelIdArchivePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ArchiveChannelChatChannelsChannelIdArchivePostResponses,
    ArchiveChannelChatChannelsChannelIdArchivePostErrors,
    ThrowOnError
  >({ url: '/chat/channels/{channel_id}/archive', ...options });

/**
 * Request Attachment Upload
 */
export const requestAttachmentUploadChatChannelsChannelIdAttachmentsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RequestAttachmentUploadChatChannelsChannelIdAttachmentsPostData,
    ThrowOnError
  >
): RequestResult<
  RequestAttachmentUploadChatChannelsChannelIdAttachmentsPostResponses,
  RequestAttachmentUploadChatChannelsChannelIdAttachmentsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RequestAttachmentUploadChatChannelsChannelIdAttachmentsPostResponses,
    RequestAttachmentUploadChatChannelsChannelIdAttachmentsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/chat/channels/{channel_id}/attachments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Issue Attachment Urls
 */
export const issueAttachmentUrlsChatAttachmentsUrlsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<IssueAttachmentUrlsChatAttachmentsUrlsPostData, ThrowOnError>
): RequestResult<
  IssueAttachmentUrlsChatAttachmentsUrlsPostResponses,
  IssueAttachmentUrlsChatAttachmentsUrlsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    IssueAttachmentUrlsChatAttachmentsUrlsPostResponses,
    IssueAttachmentUrlsChatAttachmentsUrlsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/chat/attachments/urls',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Download Attachment
 */
export const downloadAttachmentChatAttachmentsAttachmentIdDownloadGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DownloadAttachmentChatAttachmentsAttachmentIdDownloadGetData,
    ThrowOnError
  >
): RequestResult<
  DownloadAttachmentChatAttachmentsAttachmentIdDownloadGetResponses,
  DownloadAttachmentChatAttachmentsAttachmentIdDownloadGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    DownloadAttachmentChatAttachmentsAttachmentIdDownloadGetResponses,
    DownloadAttachmentChatAttachmentsAttachmentIdDownloadGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/chat/attachments/{attachment_id}/download',
    ...options,
  });

/**
 * List Groups
 */
export const listGroupsChatGroupsGet = <ThrowOnError extends boolean = false>(
  options?: Options<ListGroupsChatGroupsGetData, ThrowOnError>
): RequestResult<
  ListGroupsChatGroupsGetResponses,
  ListGroupsChatGroupsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListGroupsChatGroupsGetResponses,
    ListGroupsChatGroupsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/chat/groups',
    ...options,
  });

/**
 * Create Group
 */
export const createGroupChatGroupsPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateGroupChatGroupsPostData, ThrowOnError>
): RequestResult<
  CreateGroupChatGroupsPostResponses,
  CreateGroupChatGroupsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateGroupChatGroupsPostResponses,
    CreateGroupChatGroupsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/chat/groups',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Pickable Roles
 */
export const listPickableRolesChatGroupsRolesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListPickableRolesChatGroupsRolesGetData, ThrowOnError>
): RequestResult<
  ListPickableRolesChatGroupsRolesGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListPickableRolesChatGroupsRolesGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/chat/groups/roles',
    ...options,
  });

/**
 * List Pickable Sources
 */
export const listPickableSourcesChatGroupsSourcesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListPickableSourcesChatGroupsSourcesGetData, ThrowOnError>
): RequestResult<
  ListPickableSourcesChatGroupsSourcesGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListPickableSourcesChatGroupsSourcesGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/chat/groups/sources',
    ...options,
  });

/**
 * Get Group
 */
export const getGroupChatGroupsGroupIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetGroupChatGroupsGroupIdGetData, ThrowOnError>
): RequestResult<
  GetGroupChatGroupsGroupIdGetResponses,
  GetGroupChatGroupsGroupIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetGroupChatGroupsGroupIdGetResponses,
    GetGroupChatGroupsGroupIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/chat/groups/{group_id}',
    ...options,
  });

/**
 * Update Group
 */
export const updateGroupChatGroupsGroupIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateGroupChatGroupsGroupIdPutData, ThrowOnError>
): RequestResult<
  UpdateGroupChatGroupsGroupIdPutResponses,
  UpdateGroupChatGroupsGroupIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateGroupChatGroupsGroupIdPutResponses,
    UpdateGroupChatGroupsGroupIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/chat/groups/{group_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Patient Communications
 *
 * List all patient communication log entries for a patient.
 */
export const listPatientCommunicationsPatientsPatientIdCommunicationsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListPatientCommunicationsPatientsPatientIdCommunicationsGetData,
    ThrowOnError
  >
): RequestResult<
  ListPatientCommunicationsPatientsPatientIdCommunicationsGetResponses,
  ListPatientCommunicationsPatientsPatientIdCommunicationsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListPatientCommunicationsPatientsPatientIdCommunicationsGetResponses,
    ListPatientCommunicationsPatientsPatientIdCommunicationsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/communications',
    ...options,
  });

/**
 * Create Patient Communication
 *
 * Create a communication log entry for the patient's current episode.
 */
export const createPatientCommunicationPatientsPatientIdCommunicationsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreatePatientCommunicationPatientsPatientIdCommunicationsPostData,
    ThrowOnError
  >
): RequestResult<
  CreatePatientCommunicationPatientsPatientIdCommunicationsPostResponses,
  CreatePatientCommunicationPatientsPatientIdCommunicationsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreatePatientCommunicationPatientsPatientIdCommunicationsPostResponses,
    CreatePatientCommunicationPatientsPatientIdCommunicationsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/communications',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Patient Communication
 */
export const deletePatientCommunicationPatientCommunicationsCommunicationIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeletePatientCommunicationPatientCommunicationsCommunicationIdDeleteData,
      ThrowOnError
    >
  ): RequestResult<
    DeletePatientCommunicationPatientCommunicationsCommunicationIdDeleteResponses,
    DeletePatientCommunicationPatientCommunicationsCommunicationIdDeleteErrors,
    ThrowOnError
  > =>
    (options.client ?? client).delete<
      DeletePatientCommunicationPatientCommunicationsCommunicationIdDeleteResponses,
      DeletePatientCommunicationPatientCommunicationsCommunicationIdDeleteErrors,
      ThrowOnError
    >({ url: '/patient-communications/{communication_id}', ...options });

/**
 * Get Patient Communication
 */
export const getPatientCommunicationPatientCommunicationsCommunicationIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPatientCommunicationPatientCommunicationsCommunicationIdGetData,
    ThrowOnError
  >
): RequestResult<
  GetPatientCommunicationPatientCommunicationsCommunicationIdGetResponses,
  GetPatientCommunicationPatientCommunicationsCommunicationIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetPatientCommunicationPatientCommunicationsCommunicationIdGetResponses,
    GetPatientCommunicationPatientCommunicationsCommunicationIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patient-communications/{communication_id}',
    ...options,
  });

/**
 * Update Patient Communication
 */
export const updatePatientCommunicationPatientCommunicationsCommunicationIdPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdatePatientCommunicationPatientCommunicationsCommunicationIdPutData,
      ThrowOnError
    >
  ): RequestResult<
    UpdatePatientCommunicationPatientCommunicationsCommunicationIdPutResponses,
    UpdatePatientCommunicationPatientCommunicationsCommunicationIdPutErrors,
    ThrowOnError
  > =>
    (options.client ?? client).put<
      UpdatePatientCommunicationPatientCommunicationsCommunicationIdPutResponses,
      UpdatePatientCommunicationPatientCommunicationsCommunicationIdPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patient-communications/{communication_id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Get Patient Communication Pdf
 *
 * Generate a PDF print view for a single patient communication.
 *
 * Renders the communication metadata (date, type, physician, assignee)
 * plus the free-form notes/details. Returns the PDF inline so the client
 * can open it in a new tab.
 */
export const getPatientCommunicationPdfPatientCommunicationsCommunicationIdPdfGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetPatientCommunicationPdfPatientCommunicationsCommunicationIdPdfGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetPatientCommunicationPdfPatientCommunicationsCommunicationIdPdfGetResponses,
    GetPatientCommunicationPdfPatientCommunicationsCommunicationIdPdfGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetPatientCommunicationPdfPatientCommunicationsCommunicationIdPdfGetResponses,
      GetPatientCommunicationPdfPatientCommunicationsCommunicationIdPdfGetErrors,
      ThrowOnError
    >({
      responseType: 'blob',
      url: '/patient-communications/{communication_id}/pdf',
      ...options,
    });

/**
 * Get Patient Communication Work Log
 *
 * Return the communication's work log, reconstructed from audit rows.
 *
 * Consecutive events of the same type by the same actor collapse into one
 * entry (see ``compact_work_log``), oldest first. A deleted communication's
 * log reads as it did before, with the deletion as its last event.
 */
export const getPatientCommunicationWorkLogPatientCommunicationsCommunicationIdWorkLogGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetPatientCommunicationWorkLogPatientCommunicationsCommunicationIdWorkLogGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetPatientCommunicationWorkLogPatientCommunicationsCommunicationIdWorkLogGetResponses,
    GetPatientCommunicationWorkLogPatientCommunicationsCommunicationIdWorkLogGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetPatientCommunicationWorkLogPatientCommunicationsCommunicationIdWorkLogGetResponses,
      GetPatientCommunicationWorkLogPatientCommunicationsCommunicationIdWorkLogGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patient-communications/{communication_id}/work-log',
      ...options,
    });

/**
 * Get Patient Communication Pdf Revision
 *
 * Render the communication's print view as it stood at a past point in time.
 *
 * Reconstructs the communication and its form answers from the ``zz_`` history
 * (see ``task_revision``) and prints them with the signatures and bypass in
 * force at ``as_of``. Patient, agency, clinic and episode details (including
 * the episode's case manager) are read as they stand today, as the visit
 * revision reads them. A communication with no history at or before ``as_of``
 * (it predates audit coverage) is reported as unavailable with a 422 rather
 * than rendered from present-day values.
 */
export const getPatientCommunicationPdfRevisionPatientCommunicationsCommunicationIdPdfRevisionGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetPatientCommunicationPdfRevisionPatientCommunicationsCommunicationIdPdfRevisionGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetPatientCommunicationPdfRevisionPatientCommunicationsCommunicationIdPdfRevisionGetResponses,
    GetPatientCommunicationPdfRevisionPatientCommunicationsCommunicationIdPdfRevisionGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetPatientCommunicationPdfRevisionPatientCommunicationsCommunicationIdPdfRevisionGetResponses,
      GetPatientCommunicationPdfRevisionPatientCommunicationsCommunicationIdPdfRevisionGetErrors,
      ThrowOnError
    >({
      responseType: 'blob',
      url: '/patient-communications/{communication_id}/pdf-revision',
      ...options,
    });

/**
 * Get Thirty Day Summary Prefill
 *
 * Return 30-Day Summary fields prefilled from CMS-485 (preferred) or SOC OASIS.
 *
 * Demographics and physician header blocks on the PDF are resolved at render time
 * from patient/episode records; this endpoint only returns editable
 * ``communication_data`` fields.
 */
export const getThirtyDaySummaryPrefillPatientCommunicationsCommunicationIdThirtyDaySummaryPrefillGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetThirtyDaySummaryPrefillPatientCommunicationsCommunicationIdThirtyDaySummaryPrefillGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetThirtyDaySummaryPrefillPatientCommunicationsCommunicationIdThirtyDaySummaryPrefillGetResponses,
    GetThirtyDaySummaryPrefillPatientCommunicationsCommunicationIdThirtyDaySummaryPrefillGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetThirtyDaySummaryPrefillPatientCommunicationsCommunicationIdThirtyDaySummaryPrefillGetResponses,
      GetThirtyDaySummaryPrefillPatientCommunicationsCommunicationIdThirtyDaySummaryPrefillGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patient-communications/{communication_id}/thirty-day-summary-prefill',
      ...options,
    });

/**
 * Get Thirty Day Summary Pdf
 *
 * Generate a PDF print view for a 30-Day Summary communication.
 *
 * Mirrors ``get_discharge_summary_pdf`` in ``orders.py``: loads the
 * communication with full PDF context, rejects any non-30-Day-Summary type
 * with HTTP 400, and renders the clinical sections stored in
 * ``communication_data`` via :func:`render_communication_pdf_bytes`, which
 * dispatches a 30-Day Summary to its dedicated boxed-form generator.
 *
 * The prefill route above deliberately does not take ``include_deleted``: it
 * exists to populate a form for editing, and a deleted summary is read only.
 */
export const getThirtyDaySummaryPdfPatientCommunicationsCommunicationIdThirtyDaySummaryPdfGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetThirtyDaySummaryPdfPatientCommunicationsCommunicationIdThirtyDaySummaryPdfGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetThirtyDaySummaryPdfPatientCommunicationsCommunicationIdThirtyDaySummaryPdfGetResponses,
    GetThirtyDaySummaryPdfPatientCommunicationsCommunicationIdThirtyDaySummaryPdfGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetThirtyDaySummaryPdfPatientCommunicationsCommunicationIdThirtyDaySummaryPdfGetResponses,
      GetThirtyDaySummaryPdfPatientCommunicationsCommunicationIdThirtyDaySummaryPdfGetErrors,
      ThrowOnError
    >({
      responseType: 'blob',
      url: '/patient-communications/{communication_id}/thirty-day-summary-pdf',
      ...options,
    });

/**
 * Create Misc Task
 *
 * Create a misc task on the patient's selected (or latest) episode.
 */
export const createMiscTaskPatientsPatientIdMiscTasksPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateMiscTaskPatientsPatientIdMiscTasksPostData,
    ThrowOnError
  >
): RequestResult<
  CreateMiscTaskPatientsPatientIdMiscTasksPostResponses,
  CreateMiscTaskPatientsPatientIdMiscTasksPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateMiscTaskPatientsPatientIdMiscTasksPostResponses,
    CreateMiscTaskPatientsPatientIdMiscTasksPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/misc-tasks',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Misc Task
 */
export const deleteMiscTaskMiscTasksMiscTaskIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteMiscTaskMiscTasksMiscTaskIdDeleteData, ThrowOnError>
): RequestResult<
  DeleteMiscTaskMiscTasksMiscTaskIdDeleteResponses,
  DeleteMiscTaskMiscTasksMiscTaskIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteMiscTaskMiscTasksMiscTaskIdDeleteResponses,
    DeleteMiscTaskMiscTasksMiscTaskIdDeleteErrors,
    ThrowOnError
  >({ url: '/misc-tasks/{misc_task_id}', ...options });

/**
 * Get Misc Task
 */
export const getMiscTaskMiscTasksMiscTaskIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetMiscTaskMiscTasksMiscTaskIdGetData, ThrowOnError>
): RequestResult<
  GetMiscTaskMiscTasksMiscTaskIdGetResponses,
  GetMiscTaskMiscTasksMiscTaskIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetMiscTaskMiscTasksMiscTaskIdGetResponses,
    GetMiscTaskMiscTasksMiscTaskIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/misc-tasks/{misc_task_id}',
    ...options,
  });

/**
 * Update Misc Task
 */
export const updateMiscTaskMiscTasksMiscTaskIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateMiscTaskMiscTasksMiscTaskIdPatchData, ThrowOnError>
): RequestResult<
  UpdateMiscTaskMiscTasksMiscTaskIdPatchResponses,
  UpdateMiscTaskMiscTasksMiscTaskIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateMiscTaskMiscTasksMiscTaskIdPatchResponses,
    UpdateMiscTaskMiscTasksMiscTaskIdPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/misc-tasks/{misc_task_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Misc Task Work Log
 *
 * Return the misc task's work log, reconstructed from audit rows.
 *
 * Consecutive events of the same type by the same actor collapse into one
 * entry (see ``compact_work_log``), oldest first. A deleted task's log reads
 * as it did before, with the deletion as its last event.
 */
export const getMiscTaskWorkLogMiscTasksMiscTaskIdWorkLogGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetMiscTaskWorkLogMiscTasksMiscTaskIdWorkLogGetData,
    ThrowOnError
  >
): RequestResult<
  GetMiscTaskWorkLogMiscTasksMiscTaskIdWorkLogGetResponses,
  GetMiscTaskWorkLogMiscTasksMiscTaskIdWorkLogGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetMiscTaskWorkLogMiscTasksMiscTaskIdWorkLogGetResponses,
    GetMiscTaskWorkLogMiscTasksMiscTaskIdWorkLogGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/misc-tasks/{misc_task_id}/work-log',
    ...options,
  });

/**
 * Import Waystar Csv Endpoint
 *
 * Import payors from Waystar CSV file stored in S3.
 *
 * Downloads the CSV file from s3://roger-public-assets/waystar-payor-list.csv
 * and imports the payor data into the database. Rewrites the shared catalog,
 * so Strawhat super-users only (same gate as import-stedi-csv).
 *
 * Returns:
 * Import results with counts and any errors
 */
export const importWaystarCsvEndpointPayorsImportWaystarCsvPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ImportWaystarCsvEndpointPayorsImportWaystarCsvPostData,
    ThrowOnError
  >
): RequestResult<
  ImportWaystarCsvEndpointPayorsImportWaystarCsvPostResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    ImportWaystarCsvEndpointPayorsImportWaystarCsvPostResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payors/import-waystar-csv',
    ...options,
  });

/**
 * Import Stedi Csv Endpoint
 *
 * Refresh the payor catalog from Stedi's payer list now.
 *
 * The daily ``StediPayerCatalogSyncWorkflow`` does the same thing; this is
 * the manual fallback. It rewrites the shared catalog, so Roger super users only.
 */
export const importStediCsvEndpointPayorsImportStediCsvPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ImportStediCsvEndpointPayorsImportStediCsvPostData,
    ThrowOnError
  >
): RequestResult<
  ImportStediCsvEndpointPayorsImportStediCsvPostResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    ImportStediCsvEndpointPayorsImportStediCsvPostResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payors/import-stedi-csv',
    ...options,
  });

/**
 * Search Payors Endpoint
 *
 * Search payors by name or electronic payer ID.
 *
 * Performs case-insensitive partial matching against payor_name,
 * electronic_payor_id, and stedi_display_name fields.
 */
export const searchPayorsEndpointPayorsSearchGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SearchPayorsEndpointPayorsSearchGetData, ThrowOnError>
): RequestResult<
  SearchPayorsEndpointPayorsSearchGetResponses,
  SearchPayorsEndpointPayorsSearchGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    SearchPayorsEndpointPayorsSearchGetResponses,
    SearchPayorsEndpointPayorsSearchGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payors/search',
    ...options,
  });

/**
 * Get Payors Endpoint
 *
 * Get all payors.
 *
 * Args:
 * db_session: Database session
 *
 * Returns:
 * List of payor records
 */
export const getPayorsEndpointPayorsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetPayorsEndpointPayorsGetData, ThrowOnError>
): RequestResult<GetPayorsEndpointPayorsGetResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetPayorsEndpointPayorsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payors/',
    ...options,
  });

/**
 * Create Payor Endpoint
 *
 * Create a new payor record.
 *
 * Shared catalog row — Strawhat super-users only (same gate as import-stedi-csv).
 *
 * Args:
 * payor_data: Payor creation data
 * db_session: Database session
 *
 * Returns:
 * Created payor record
 *
 * Raises:
 * HTTPException: If payor with same name already exists
 */
export const createPayorEndpointPayorsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreatePayorEndpointPayorsPostData, ThrowOnError>
): RequestResult<
  CreatePayorEndpointPayorsPostResponses,
  CreatePayorEndpointPayorsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreatePayorEndpointPayorsPostResponses,
    CreatePayorEndpointPayorsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payors/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Payor Endpoint
 *
 * Retire a payor (``is_active = False``). The row is never deleted.
 *
 * A retired payor leaves search and the list; lookups by id still resolve it.
 * Refused with 409 while any claim, insurance, enrollment, intake,
 * eligibility check or remittance still references it.
 *
 * Shared catalog row — Strawhat super-users only (same gate as import-stedi-csv).
 *
 * Raises:
 * HTTPException: If payor not found
 */
export const deletePayorEndpointPayorsPayorIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeletePayorEndpointPayorsPayorIdDeleteData, ThrowOnError>
): RequestResult<
  DeletePayorEndpointPayorsPayorIdDeleteResponses,
  DeletePayorEndpointPayorsPayorIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeletePayorEndpointPayorsPayorIdDeleteResponses,
    DeletePayorEndpointPayorsPayorIdDeleteErrors,
    ThrowOnError
  >({ url: '/payors/{payor_id}', ...options });

/**
 * Get Payor Endpoint
 *
 * Get a specific payor by ID.
 *
 * Args:
 * payor_id: Payor UUID
 * db_session: Database session
 *
 * Returns:
 * Payor record
 *
 * Raises:
 * HTTPException: If payor not found
 */
export const getPayorEndpointPayorsPayorIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetPayorEndpointPayorsPayorIdGetData, ThrowOnError>
): RequestResult<
  GetPayorEndpointPayorsPayorIdGetResponses,
  GetPayorEndpointPayorsPayorIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetPayorEndpointPayorsPayorIdGetResponses,
    GetPayorEndpointPayorsPayorIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payors/{payor_id}',
    ...options,
  });

/**
 * Update Payor Endpoint
 *
 * Update a payor record.
 *
 * Shared catalog row — Strawhat super-users only (same gate as import-stedi-csv).
 *
 * Args:
 * payor_id: Payor UUID
 * payor_data: Payor update data
 * db_session: Database session
 *
 * Returns:
 * Updated payor record
 *
 * Raises:
 * HTTPException: If payor not found or validation fails
 */
export const updatePayorEndpointPayorsPayorIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdatePayorEndpointPayorsPayorIdPutData, ThrowOnError>
): RequestResult<
  UpdatePayorEndpointPayorsPayorIdPutResponses,
  UpdatePayorEndpointPayorsPayorIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdatePayorEndpointPayorsPayorIdPutResponses,
    UpdatePayorEndpointPayorsPayorIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payors/{payor_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Payor By Name Endpoint
 *
 * Get a payor by name.
 *
 * Args:
 * payor_name: Name of the payor
 * db_session: Database session
 *
 * Returns:
 * Payor record
 *
 * Raises:
 * HTTPException: If payor not found
 */
export const getPayorByNameEndpointPayorsByNamePayorNameGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPayorByNameEndpointPayorsByNamePayorNameGetData,
    ThrowOnError
  >
): RequestResult<
  GetPayorByNameEndpointPayorsByNamePayorNameGetResponses,
  GetPayorByNameEndpointPayorsByNamePayorNameGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetPayorByNameEndpointPayorsByNamePayorNameGetResponses,
    GetPayorByNameEndpointPayorsByNamePayorNameGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payors/by-name/{payor_name}',
    ...options,
  });

/**
 * Get Payor By Electronic Id Endpoint
 *
 * Get a payor by electronic payor ID.
 *
 * Args:
 * electronic_payor_id: Standardized industry identifier
 * db_session: Database session
 *
 * Returns:
 * Payor record
 *
 * Raises:
 * HTTPException: If payor not found
 */
export const getPayorByElectronicIdEndpointPayorsByElectronicIdElectronicPayorIdGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetPayorByElectronicIdEndpointPayorsByElectronicIdElectronicPayorIdGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetPayorByElectronicIdEndpointPayorsByElectronicIdElectronicPayorIdGetResponses,
    GetPayorByElectronicIdEndpointPayorsByElectronicIdElectronicPayorIdGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetPayorByElectronicIdEndpointPayorsByElectronicIdElectronicPayorIdGetResponses,
      GetPayorByElectronicIdEndpointPayorsByElectronicIdElectronicPayorIdGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/payors/by-electronic-id/{electronic_payor_id}',
      ...options,
    });

/**
 * Get Payor By Clearinghouse Id Endpoint
 *
 * Get a payor by clearinghouse payor ID.
 *
 * Args:
 * clearinghouse_payor_id: Clearinghouse-specific identifier
 * db_session: Database session
 *
 * Returns:
 * Payor record
 *
 * Raises:
 * HTTPException: If payor not found
 */
export const getPayorByClearinghouseIdEndpointPayorsByClearinghouseIdClearinghousePayorIdGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetPayorByClearinghouseIdEndpointPayorsByClearinghouseIdClearinghousePayorIdGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetPayorByClearinghouseIdEndpointPayorsByClearinghouseIdClearinghousePayorIdGetResponses,
    GetPayorByClearinghouseIdEndpointPayorsByClearinghouseIdClearinghousePayorIdGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetPayorByClearinghouseIdEndpointPayorsByClearinghouseIdClearinghousePayorIdGetResponses,
      GetPayorByClearinghouseIdEndpointPayorsByClearinghouseIdClearinghousePayorIdGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/payors/by-clearinghouse-id/{clearinghouse_payor_id}',
      ...options,
    });

/**
 * List Payroll Visits
 *
 * Payroll-eligible visits not yet included in any payroll (flat list).
 */
export const listPayrollVisitsPayrollVisitsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ListPayrollVisitsPayrollVisitsGetData, ThrowOnError>
): RequestResult<
  ListPayrollVisitsPayrollVisitsGetResponses,
  ListPayrollVisitsPayrollVisitsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListPayrollVisitsPayrollVisitsGetResponses,
    ListPayrollVisitsPayrollVisitsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payroll/visits',
    ...options,
  });

/**
 * Export Payroll Visits
 *
 * Export ALL matching payroll-eligible visits to an Excel (.xlsx) file.
 */
export const exportPayrollVisitsPayrollVisitsExportGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ExportPayrollVisitsPayrollVisitsExportGetData, ThrowOnError>
): RequestResult<
  ExportPayrollVisitsPayrollVisitsExportGetResponses,
  ExportPayrollVisitsPayrollVisitsExportGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ExportPayrollVisitsPayrollVisitsExportGetResponses,
    ExportPayrollVisitsPayrollVisitsExportGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payroll/visits/export',
    ...options,
  });

/**
 * Print Payroll Visits
 *
 * ALL matching payroll-eligible visits as a PDF (same rows as the export).
 */
export const printPayrollVisitsPayrollVisitsPrintGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PrintPayrollVisitsPayrollVisitsPrintGetData, ThrowOnError>
): RequestResult<
  PrintPayrollVisitsPayrollVisitsPrintGetResponses,
  PrintPayrollVisitsPayrollVisitsPrintGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    PrintPayrollVisitsPayrollVisitsPrintGetResponses,
    PrintPayrollVisitsPayrollVisitsPrintGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/payroll/visits/print',
    ...options,
  });

/**
 * List Payroll Entries
 *
 * Date-wise payroll entries for the agency (Previous Payroll list).
 */
export const listPayrollEntriesPayrollEntriesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListPayrollEntriesPayrollEntriesGetData, ThrowOnError>
): RequestResult<
  ListPayrollEntriesPayrollEntriesGetResponses,
  ListPayrollEntriesPayrollEntriesGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListPayrollEntriesPayrollEntriesGetResponses,
    ListPayrollEntriesPayrollEntriesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payroll/entries',
    ...options,
  });

/**
 * Create Payroll Entry
 *
 * Add the selected visits to this clinic's payroll for the date (upsert).
 */
export const createPayrollEntryPayrollEntriesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreatePayrollEntryPayrollEntriesPostData, ThrowOnError>
): RequestResult<
  CreatePayrollEntryPayrollEntriesPostResponses,
  CreatePayrollEntryPayrollEntriesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreatePayrollEntryPayrollEntriesPostResponses,
    CreatePayrollEntryPayrollEntriesPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payroll/entries',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Export All Payroll Entries
 *
 * Export paid payrolls in one workbook, optionally bounded by date.
 */
export const exportAllPayrollEntriesPayrollEntriesExportGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ExportAllPayrollEntriesPayrollEntriesExportGetData,
    ThrowOnError
  >
): RequestResult<
  ExportAllPayrollEntriesPayrollEntriesExportGetResponses,
  ExportAllPayrollEntriesPayrollEntriesExportGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ExportAllPayrollEntriesPayrollEntriesExportGetResponses,
    ExportAllPayrollEntriesPayrollEntriesExportGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payroll/entries/export',
    ...options,
  });

/**
 * List Payroll Entry Visits
 *
 * Visits inside a payroll entry, ordered by visit date for grouping.
 */
export const listPayrollEntryVisitsPayrollEntriesPayrollEntryIdVisitsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListPayrollEntryVisitsPayrollEntriesPayrollEntryIdVisitsGetData,
    ThrowOnError
  >
): RequestResult<
  ListPayrollEntryVisitsPayrollEntriesPayrollEntryIdVisitsGetResponses,
  ListPayrollEntryVisitsPayrollEntriesPayrollEntryIdVisitsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListPayrollEntryVisitsPayrollEntriesPayrollEntryIdVisitsGetResponses,
    ListPayrollEntryVisitsPayrollEntriesPayrollEntryIdVisitsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payroll/entries/{payroll_entry_id}/visits',
    ...options,
  });

/**
 * Export Payroll Entry Visits
 *
 * Export every visit in one payroll to an Excel (.xlsx) file.
 *
 * Takes no ``search`` parameter, unlike the unpaid export, and the menu that
 * calls it reads "Export All" (Excel or PDF) so the omission is visible before
 * the click. A payroll is a financial record that finance reconciles against:
 * handing back a subset risks a short sheet nobody realises was filtered,
 * which is unrecoverable, where a sheet wider than expected can just be
 * filtered in Excel. Do not add a search parameter here for symmetry with
 * the unpaid export.
 */
export const exportPayrollEntryVisitsPayrollEntriesPayrollEntryIdExportGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ExportPayrollEntryVisitsPayrollEntriesPayrollEntryIdExportGetData,
    ThrowOnError
  >
): RequestResult<
  ExportPayrollEntryVisitsPayrollEntriesPayrollEntryIdExportGetResponses,
  ExportPayrollEntryVisitsPayrollEntriesPayrollEntryIdExportGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ExportPayrollEntryVisitsPayrollEntriesPayrollEntryIdExportGetResponses,
    ExportPayrollEntryVisitsPayrollEntriesPayrollEntryIdExportGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payroll/entries/{payroll_entry_id}/export',
    ...options,
  });

/**
 * Print Payroll Entry Visits
 *
 * Every visit in one payroll as a PDF, laid out like its detail screen.
 *
 * Always the whole payroll, with no search: like the Excel export, a sealed
 * payroll is never handed back as a subset.
 */
export const printPayrollEntryVisitsPayrollEntriesPayrollEntryIdPrintGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PrintPayrollEntryVisitsPayrollEntriesPayrollEntryIdPrintGetData,
    ThrowOnError
  >
): RequestResult<
  PrintPayrollEntryVisitsPayrollEntriesPayrollEntryIdPrintGetResponses,
  PrintPayrollEntryVisitsPayrollEntriesPayrollEntryIdPrintGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    PrintPayrollEntryVisitsPayrollEntriesPayrollEntryIdPrintGetResponses,
    PrintPayrollEntryVisitsPayrollEntriesPayrollEntryIdPrintGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/payroll/entries/{payroll_entry_id}/print',
    ...options,
  });

/**
 * Remove Payroll Entry Visit
 *
 * Remove one visit from a payroll, releasing it.
 */
export const removePayrollEntryVisitPayrollEntriesPayrollEntryIdVisitsVisitIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      RemovePayrollEntryVisitPayrollEntriesPayrollEntryIdVisitsVisitIdDeleteData,
      ThrowOnError
    >
  ): RequestResult<
    RemovePayrollEntryVisitPayrollEntriesPayrollEntryIdVisitsVisitIdDeleteResponses,
    RemovePayrollEntryVisitPayrollEntriesPayrollEntryIdVisitsVisitIdDeleteErrors,
    ThrowOnError
  > =>
    (options.client ?? client).delete<
      RemovePayrollEntryVisitPayrollEntriesPayrollEntryIdVisitsVisitIdDeleteResponses,
      RemovePayrollEntryVisitPayrollEntriesPayrollEntryIdVisitsVisitIdDeleteErrors,
      ThrowOnError
    >({
      url: '/payroll/entries/{payroll_entry_id}/visits/{visit_id}',
      ...options,
    });

/**
 * Delete Payroll Entry
 *
 * Delete a payroll entry, releasing its visits.
 */
export const deletePayrollEntryPayrollEntriesPayrollEntryIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeletePayrollEntryPayrollEntriesPayrollEntryIdDeleteData,
    ThrowOnError
  >
): RequestResult<
  DeletePayrollEntryPayrollEntriesPayrollEntryIdDeleteResponses,
  DeletePayrollEntryPayrollEntriesPayrollEntryIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeletePayrollEntryPayrollEntriesPayrollEntryIdDeleteResponses,
    DeletePayrollEntryPayrollEntriesPayrollEntryIdDeleteErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payroll/entries/{payroll_entry_id}',
    ...options,
  });

/**
 * Get Payroll Settings
 *
 * The agency's payroll statuses, Roger's default, and every status offered.
 */
export const getPayrollSettingsPayrollSettingsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetPayrollSettingsPayrollSettingsGetData, ThrowOnError>
): RequestResult<
  GetPayrollSettingsPayrollSettingsGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetPayrollSettingsPayrollSettingsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payroll-settings',
    ...options,
  });

/**
 * Update Payroll Settings
 *
 * Replace the visit statuses that reach Payroll Manager.
 *
 * The next payroll request uses the new set. One already running keeps the
 * set it resolved when it started, and visits already in a payroll stay
 * there whatever their status.
 */
export const updatePayrollSettingsPayrollSettingsPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdatePayrollSettingsPayrollSettingsPutData, ThrowOnError>
): RequestResult<
  UpdatePayrollSettingsPayrollSettingsPutResponses,
  UpdatePayrollSettingsPayrollSettingsPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdatePayrollSettingsPayrollSettingsPutResponses,
    UpdatePayrollSettingsPayrollSettingsPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payroll-settings',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Product Updates For User
 *
 * Return visible product updates for the current user.
 */
export const getProductUpdatesForUserProductUpdatesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetProductUpdatesForUserProductUpdatesGetData, ThrowOnError>
): RequestResult<
  GetProductUpdatesForUserProductUpdatesGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetProductUpdatesForUserProductUpdatesGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/product-updates',
    ...options,
  });

/**
 * Get Reporting Manifest
 */
export const getReportingManifestReportingManifestGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetReportingManifestReportingManifestGetData, ThrowOnError>
): RequestResult<
  GetReportingManifestReportingManifestGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetReportingManifestReportingManifestGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reporting/manifest',
    ...options,
  });

/**
 * Get Reporting Extract
 *
 * Serve one dataset's Parquet extract, optionally narrowed to an axis window.
 *
 * The scope params form a discriminated contract (Epic 5.1 D1): ``scope=full``
 * (the default) takes no other predicate param; ``scope=primary`` takes
 * ``axis`` plus ``kind`` (``range`` | ``equality`` | ``is_null``) and the
 * ``lower``/``upper`` bounds with their inclusivity. Scope is an I/O optimization
 * ONLY — the browser authored and executes the real ``WHERE``, and column scope
 * comes from ``served_columns``.
 *
 * **Only the PRIMARY dataset of a report may be windowed** (D4). Each dataset is a
 * separate extract that DuckDB joins in the browser, so the server cannot see join
 * intent: if a related fetch were windowed too, a visit from last month whose episode
 * started 14 months ago would arrive without its episode row and the LEFT JOIN would
 * silently produce NULL episode columns. Related fetches must use ``scope=full``.
 *
 * Population options apply to report identity on both primary and related requests.
 * Hidden marker columns remain in the Parquet so the shared compiler can filter each
 * source before joining, which preserves unmatched primary rows and no-episode rows.
 */
export const getReportingExtractReportingExtractsDatasetKeyGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetReportingExtractReportingExtractsDatasetKeyGetData,
    ThrowOnError
  >
): RequestResult<
  GetReportingExtractReportingExtractsDatasetKeyGetResponses,
  GetReportingExtractReportingExtractsDatasetKeyGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetReportingExtractReportingExtractsDatasetKeyGetResponses,
    GetReportingExtractReportingExtractsDatasetKeyGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reporting/extracts/{dataset_key}',
    ...options,
  });

/**
 * List Report Definitions
 */
export const listReportDefinitionsReportingReportDefinitionsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ListReportDefinitionsReportingReportDefinitionsGetData,
    ThrowOnError
  >
): RequestResult<
  ListReportDefinitionsReportingReportDefinitionsGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListReportDefinitionsReportingReportDefinitionsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reporting/report-definitions',
    ...options,
  });

/**
 * Create Report Definition
 */
export const createReportDefinitionReportingReportDefinitionsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateReportDefinitionReportingReportDefinitionsPostData,
    ThrowOnError
  >
): RequestResult<
  CreateReportDefinitionReportingReportDefinitionsPostResponses,
  CreateReportDefinitionReportingReportDefinitionsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateReportDefinitionReportingReportDefinitionsPostResponses,
    CreateReportDefinitionReportingReportDefinitionsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reporting/report-definitions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Report Definition
 *
 * Delete an agency report definition. Owner-only (_get_mutable_row).
 *
 * Deliberately NOT gated on _authorize_definition_access, unlike PATCH: that
 * gate is a DISCLOSURE control (every PATCH echoes the stored definition,
 * name, and description back to the caller), and a 204 discloses nothing.
 * Adding it here would make an owner who lost a joined dataset's permission
 * unable to delete their own report — it would vanish from the listing, 403
 * on PATCH, and 403 on DELETE, i.e. become undeletable dead weight only an
 * admin could clear. It would also break the repair path
 * _authorize_definition_access's own docstring names: an unparseable stored
 * definition 403s that gate by design, and delete-and-recreate is how the
 * owner fixes it. Owner-only deletion of a row the caller can no longer read
 * is intended; see test_delete_allowed_when_stored_definition_is_hidden.
 */
export const deleteReportDefinitionReportingReportDefinitionsDefinitionIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteReportDefinitionReportingReportDefinitionsDefinitionIdDeleteData,
      ThrowOnError
    >
  ): RequestResult<
    DeleteReportDefinitionReportingReportDefinitionsDefinitionIdDeleteResponses,
    DeleteReportDefinitionReportingReportDefinitionsDefinitionIdDeleteErrors,
    ThrowOnError
  > =>
    (options.client ?? client).delete<
      DeleteReportDefinitionReportingReportDefinitionsDefinitionIdDeleteResponses,
      DeleteReportDefinitionReportingReportDefinitionsDefinitionIdDeleteErrors,
      ThrowOnError
    >({ url: '/reporting/report-definitions/{definition_id}', ...options });

/**
 * Update Report Definition
 */
export const updateReportDefinitionReportingReportDefinitionsDefinitionIdPatch =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdateReportDefinitionReportingReportDefinitionsDefinitionIdPatchData,
      ThrowOnError
    >
  ): RequestResult<
    UpdateReportDefinitionReportingReportDefinitionsDefinitionIdPatchResponses,
    UpdateReportDefinitionReportingReportDefinitionsDefinitionIdPatchErrors,
    ThrowOnError
  > =>
    (options.client ?? client).patch<
      UpdateReportDefinitionReportingReportDefinitionsDefinitionIdPatchResponses,
      UpdateReportDefinitionReportingReportDefinitionsDefinitionIdPatchErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/reporting/report-definitions/{definition_id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * List Report Widgets
 */
export const listReportWidgetsReportingWidgetsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListReportWidgetsReportingWidgetsGetData, ThrowOnError>
): RequestResult<
  ListReportWidgetsReportingWidgetsGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListReportWidgetsReportingWidgetsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reporting/widgets',
    ...options,
  });

/**
 * Create Report Widget
 */
export const createReportWidgetReportingWidgetsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateReportWidgetReportingWidgetsPostData, ThrowOnError>
): RequestResult<
  CreateReportWidgetReportingWidgetsPostResponses,
  CreateReportWidgetReportingWidgetsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateReportWidgetReportingWidgetsPostResponses,
    CreateReportWidgetReportingWidgetsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reporting/widgets',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Report Widget
 */
export const deleteReportWidgetReportingWidgetsWidgetIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteReportWidgetReportingWidgetsWidgetIdDeleteData,
    ThrowOnError
  >
): RequestResult<
  DeleteReportWidgetReportingWidgetsWidgetIdDeleteResponses,
  DeleteReportWidgetReportingWidgetsWidgetIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteReportWidgetReportingWidgetsWidgetIdDeleteResponses,
    DeleteReportWidgetReportingWidgetsWidgetIdDeleteErrors,
    ThrowOnError
  >({ url: '/reporting/widgets/{widget_id}', ...options });

/**
 * Update Report Widget
 */
export const updateReportWidgetReportingWidgetsWidgetIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateReportWidgetReportingWidgetsWidgetIdPatchData,
    ThrowOnError
  >
): RequestResult<
  UpdateReportWidgetReportingWidgetsWidgetIdPatchResponses,
  UpdateReportWidgetReportingWidgetsWidgetIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateReportWidgetReportingWidgetsWidgetIdPatchResponses,
    UpdateReportWidgetReportingWidgetsWidgetIdPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reporting/widgets/{widget_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Dashboard Tabs
 */
export const listDashboardTabsReportingDashboardTabsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ListDashboardTabsReportingDashboardTabsGetData,
    ThrowOnError
  >
): RequestResult<
  ListDashboardTabsReportingDashboardTabsGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListDashboardTabsReportingDashboardTabsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reporting/dashboard-tabs',
    ...options,
  });

/**
 * Create Dashboard Tab
 */
export const createDashboardTabReportingDashboardTabsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateDashboardTabReportingDashboardTabsPostData,
    ThrowOnError
  >
): RequestResult<
  CreateDashboardTabReportingDashboardTabsPostResponses,
  CreateDashboardTabReportingDashboardTabsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateDashboardTabReportingDashboardTabsPostResponses,
    CreateDashboardTabReportingDashboardTabsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reporting/dashboard-tabs',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Dashboard Tab
 */
export const deleteDashboardTabReportingDashboardTabsTabIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteDashboardTabReportingDashboardTabsTabIdDeleteData,
    ThrowOnError
  >
): RequestResult<
  DeleteDashboardTabReportingDashboardTabsTabIdDeleteResponses,
  DeleteDashboardTabReportingDashboardTabsTabIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteDashboardTabReportingDashboardTabsTabIdDeleteResponses,
    DeleteDashboardTabReportingDashboardTabsTabIdDeleteErrors,
    ThrowOnError
  >({ url: '/reporting/dashboard-tabs/{tab_id}', ...options });

/**
 * Update Dashboard Tab
 */
export const updateDashboardTabReportingDashboardTabsTabIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateDashboardTabReportingDashboardTabsTabIdPatchData,
    ThrowOnError
  >
): RequestResult<
  UpdateDashboardTabReportingDashboardTabsTabIdPatchResponses,
  UpdateDashboardTabReportingDashboardTabsTabIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateDashboardTabReportingDashboardTabsTabIdPatchResponses,
    UpdateDashboardTabReportingDashboardTabsTabIdPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reporting/dashboard-tabs/{tab_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Dashboard Tab Widgets
 */
export const listDashboardTabWidgetsReportingDashboardTabsTabIdWidgetsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListDashboardTabWidgetsReportingDashboardTabsTabIdWidgetsGetData,
    ThrowOnError
  >
): RequestResult<
  ListDashboardTabWidgetsReportingDashboardTabsTabIdWidgetsGetResponses,
  ListDashboardTabWidgetsReportingDashboardTabsTabIdWidgetsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListDashboardTabWidgetsReportingDashboardTabsTabIdWidgetsGetResponses,
    ListDashboardTabWidgetsReportingDashboardTabsTabIdWidgetsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reporting/dashboard-tabs/{tab_id}/widgets',
    ...options,
  });

/**
 * Replace Dashboard Tab Widgets
 */
export const replaceDashboardTabWidgetsReportingDashboardTabsTabIdWidgetsPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ReplaceDashboardTabWidgetsReportingDashboardTabsTabIdWidgetsPutData,
    ThrowOnError
  >
): RequestResult<
  ReplaceDashboardTabWidgetsReportingDashboardTabsTabIdWidgetsPutResponses,
  ReplaceDashboardTabWidgetsReportingDashboardTabsTabIdWidgetsPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    ReplaceDashboardTabWidgetsReportingDashboardTabsTabIdWidgetsPutResponses,
    ReplaceDashboardTabWidgetsReportingDashboardTabsTabIdWidgetsPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reporting/dashboard-tabs/{tab_id}/widgets',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Reload Hipps Reference
 *
 * Re-materialize the global hipps_* tables from every bundled release.
 */
export const reloadHippsReferenceHippsReferenceReloadPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ReloadHippsReferenceHippsReferenceReloadPostData,
    ThrowOnError
  >
): RequestResult<
  ReloadHippsReferenceHippsReferenceReloadPostResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    ReloadHippsReferenceHippsReferenceReloadPostResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/hipps-reference/reload',
    ...options,
  });

/**
 * Reload Cms Geography
 *
 * Re-materialize cms_zip_geography from bundled CSVs.
 */
export const reloadCmsGeographyCmsGeographyReloadPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ReloadCmsGeographyCmsGeographyReloadPostData, ThrowOnError>
): RequestResult<
  ReloadCmsGeographyCmsGeographyReloadPostResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    ReloadCmsGeographyCmsGeographyReloadPostResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/cms-geography/reload',
    ...options,
  });

/**
 * List Value Codes Route
 *
 * Full NUBC value-code list (110 assignable codes), ordered by code.
 */
export const listValueCodesRouteValueCodesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListValueCodesRouteValueCodesGetData, ThrowOnError>
): RequestResult<
  ListValueCodesRouteValueCodesGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListValueCodesRouteValueCodesGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/value-codes',
    ...options,
  });

/**
 * Reload Value Codes
 *
 * Re-materialize value_codes from the bundled CSV.
 */
export const reloadValueCodesValueCodesReloadPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ReloadValueCodesValueCodesReloadPostData, ThrowOnError>
): RequestResult<
  ReloadValueCodesValueCodesReloadPostResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    ReloadValueCodesValueCodesReloadPostResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/value-codes/reload',
    ...options,
  });

/**
 * Get Eligibility Checks Endpoint
 *
 * Get eligibility checks with optional filtering.
 *
 * The permission depends on the filter. Reading one intake's own checks is
 * part of working that intake; every other filter reaches across patients and
 * returns benefit and deductible detail, so it needs the same capability that
 * gates running a check.
 */
export const getEligibilityChecksEndpointEligibilityGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetEligibilityChecksEndpointEligibilityGetData,
    ThrowOnError
  >
): RequestResult<
  GetEligibilityChecksEndpointEligibilityGetResponses,
  GetEligibilityChecksEndpointEligibilityGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetEligibilityChecksEndpointEligibilityGetResponses,
    GetEligibilityChecksEndpointEligibilityGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/eligibility/',
    ...options,
  });

/**
 * Perform Real Eligibility Check
 *
 * Perform a real eligibility check for an intake using Stedi API.
 *
 * This endpoint resolves the intake's payor, then hands the run to
 * :func:`run_eligibility_check`, which is shared with the chart-side check.
 *
 * Note: Patient records are NOT created during eligibility checks.
 * Patients are only created at the "Push to EMR" step.
 *
 * Args:
 * intake_id: Intake UUID
 * db_session: Database session
 * current_ctx: Current user context with agency information
 *
 * Returns:
 * Created/updated eligibility check record
 *
 * Raises:
 * HTTPException: If intake not found, payor not found, or API call fails
 */
export const performRealEligibilityCheckEligibilityIntakeIntakeIdCheckPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PerformRealEligibilityCheckEligibilityIntakeIntakeIdCheckPostData,
    ThrowOnError
  >
): RequestResult<
  PerformRealEligibilityCheckEligibilityIntakeIntakeIdCheckPostResponses,
  PerformRealEligibilityCheckEligibilityIntakeIntakeIdCheckPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PerformRealEligibilityCheckEligibilityIntakeIntakeIdCheckPostResponses,
    PerformRealEligibilityCheckEligibilityIntakeIntakeIdCheckPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/eligibility/intake/{intake_id}/check',
    ...options,
  });

/**
 * Perform Patient Eligibility Check
 *
 * Perform an eligibility check for an existing patient, outside intake.
 *
 * Coverage changes between intake and a new episode, payers get added or edited on
 * the chart, and imported patients never had an intake check at all. This runs the
 * same 270/271 as the intake tab, built from the patient chart instead.
 *
 * The insurance to check is named explicitly in the body rather than inferred, so
 * the chart, an episode, and billing cannot silently disagree about which payer was
 * verified.
 *
 * Args:
 * patient_id: Patient UUID
 * body: Names the patient insurance to check
 * db_session: Database session
 * current_ctx: Current user context with agency information
 *
 * Returns:
 * Created/updated eligibility check record
 *
 * Raises:
 * HTTPException: If the patient or insurance is not found, the payer cannot do
 * eligibility, or the API call fails.
 */
export const performPatientEligibilityCheckEligibilityPatientPatientIdCheckPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      PerformPatientEligibilityCheckEligibilityPatientPatientIdCheckPostData,
      ThrowOnError
    >
  ): RequestResult<
    PerformPatientEligibilityCheckEligibilityPatientPatientIdCheckPostResponses,
    PerformPatientEligibilityCheckEligibilityPatientPatientIdCheckPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      PerformPatientEligibilityCheckEligibilityPatientPatientIdCheckPostResponses,
      PerformPatientEligibilityCheckEligibilityPatientPatientIdCheckPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/eligibility/patient/{patient_id}/check',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Get Patient Eligibility Problems
 *
 * Insurance-tab warnings: failed checks and inactive coverage.
 *
 * Mirrors ``GET /episodes/{id}/authorizations/errors`` so PatientDetail can
 * badge the Insurance tab the same way Auths is badged.
 */
export const getPatientEligibilityProblemsEligibilityPatientPatientIdProblemsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetPatientEligibilityProblemsEligibilityPatientPatientIdProblemsGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetPatientEligibilityProblemsEligibilityPatientPatientIdProblemsGetResponses,
    GetPatientEligibilityProblemsEligibilityPatientPatientIdProblemsGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetPatientEligibilityProblemsEligibilityPatientPatientIdProblemsGetResponses,
      GetPatientEligibilityProblemsEligibilityPatientPatientIdProblemsGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/eligibility/patient/{patient_id}/problems',
      ...options,
    });

/**
 * Enqueue Billing Cycle
 *
 * Enqueue a Temporal workflow to create billing cycles for the current agency.
 *
 * Creates cycles for active episodes whose billing period has ended. If
 * ``current_date`` is omitted, the agency's timezone is used to determine the
 * date. Returns the workflow ID immediately; the workflow runs asynchronously.
 */
export const enqueueBillingCycleBillingDevEnqueueBillingCycleCreationPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    EnqueueBillingCycleBillingDevEnqueueBillingCycleCreationPostData,
    ThrowOnError
  >
): RequestResult<
  EnqueueBillingCycleBillingDevEnqueueBillingCycleCreationPostResponses,
  EnqueueBillingCycleBillingDevEnqueueBillingCycleCreationPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    EnqueueBillingCycleBillingDevEnqueueBillingCycleCreationPostResponses,
    EnqueueBillingCycleBillingDevEnqueueBillingCycleCreationPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/billing/dev/enqueue-billing-cycle-creation',
    ...options,
  });

/**
 * Override Payment Oasis Hold
 *
 * Bill past the hold on an imported payment OASIS the previous EMR has
 * not exported yet.
 *
 * The decision, the lock and the audit row live in
 * ``app.services.billing.payment_oasis_hold``; this route authorizes,
 * commits and answers. 404 for a cycle the caller cannot reach, 409 when
 * the cycle is not a draft or holds no such hold.
 */
export const overridePaymentOasisHoldBillingBillingCycleBillingCycleIdPaymentOasisHoldOverridePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      OverridePaymentOasisHoldBillingBillingCycleBillingCycleIdPaymentOasisHoldOverridePostData,
      ThrowOnError
    >
  ): RequestResult<
    OverridePaymentOasisHoldBillingBillingCycleBillingCycleIdPaymentOasisHoldOverridePostResponses,
    OverridePaymentOasisHoldBillingBillingCycleBillingCycleIdPaymentOasisHoldOverridePostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      OverridePaymentOasisHoldBillingBillingCycleBillingCycleIdPaymentOasisHoldOverridePostResponses,
      OverridePaymentOasisHoldBillingBillingCycleBillingCycleIdPaymentOasisHoldOverridePostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/payment-oasis-hold/override',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Set Billing Cycle Status Pending Approval
 *
 * Set the status of a billing cycle to pending approval.
 *
 * Possible paths:
 * - User approves -> READY_TO_SEND
 * - User clicks send -> PENDING_PAYMENT (plus sent to clearinghouse)
 * - Clearinghouse pays -> PAID
 * - Clearinghouse denies -> REJECTED
 * - User updates and resubmits -> PENDING_PAYMENT
 * - Repeat this process until the claim is paid or denied & user gives up
 * - User clicks void -> CANCELLED/REJECTED
 * - No possible paths after this point. The user has marked it as effectively deleted
 * We will never actually delete this or remove it from the display for auditing purposes.
 */
export const setBillingCycleStatusPendingApprovalBillingBillingCycleBillingCycleIdSetStatusPendingApprovalPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      SetBillingCycleStatusPendingApprovalBillingBillingCycleBillingCycleIdSetStatusPendingApprovalPostData,
      ThrowOnError
    >
  ): RequestResult<
    SetBillingCycleStatusPendingApprovalBillingBillingCycleBillingCycleIdSetStatusPendingApprovalPostResponses,
    SetBillingCycleStatusPendingApprovalBillingBillingCycleBillingCycleIdSetStatusPendingApprovalPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      SetBillingCycleStatusPendingApprovalBillingBillingCycleBillingCycleIdSetStatusPendingApprovalPostResponses,
      SetBillingCycleStatusPendingApprovalBillingBillingCycleBillingCycleIdSetStatusPendingApprovalPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/set-status/pending-approval',
      ...options,
    });

/**
 * Set Billing Cycle Status Ready To Send
 *
 * Set the status of a billing cycle to ready to send.
 */
export const setBillingCycleStatusReadyToSendBillingBillingCycleBillingCycleIdSetStatusReadyToSendPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      SetBillingCycleStatusReadyToSendBillingBillingCycleBillingCycleIdSetStatusReadyToSendPostData,
      ThrowOnError
    >
  ): RequestResult<
    SetBillingCycleStatusReadyToSendBillingBillingCycleBillingCycleIdSetStatusReadyToSendPostResponses,
    SetBillingCycleStatusReadyToSendBillingBillingCycleBillingCycleIdSetStatusReadyToSendPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      SetBillingCycleStatusReadyToSendBillingBillingCycleBillingCycleIdSetStatusReadyToSendPostResponses,
      SetBillingCycleStatusReadyToSendBillingBillingCycleBillingCycleIdSetStatusReadyToSendPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/set-status/ready-to-send',
      ...options,
    });

/**
 * Set Billing Cycles Status Void
 *
 * Void several billing cycles in one transaction and rebuild their ranges
 * together (Roger-side only).
 *
 * Every id must be a cycle of this agency in Draft, Pending Approval, Ready
 * to Send, Pending Payment, or Rejected, or the whole request is refused
 * (404 / 400) and nothing is voided. A one-id body is the single-cycle
 * void. Per episode, the voided ranges and every adjacent uncovered range
 * are merged into contiguous runs and each run is re-tiled from its start
 * with the episode's current insurance length, so four weekly cycles voided
 * together under a now-monthly insurance come back as one monthly draft once
 * that month has elapsed. No piece is created before it is due or with an
 * end after today; what is not due is rebuilt by the nightly run, so
 * ``replacement_billing_cycle_ids`` may be empty. A DRAFT is
 * stamped ``draft_void``: nothing was worked, so there is no worksheet or
 * notes to carry forward, and no rebuild runs for it alone; its hole is
 * merged into the run only when a non-draft cycle on the same episode is
 * voided in the same call, otherwise the nightly run, Refresh, or the
 * forward pass fills it by date. Any linked Claim and remittance rows are
 * left untouched (the immutable record of what was submitted) and no
 * cancellation claim (TOB 0328) is sent to the payer; the row is never
 * deleted, for auditing. The void itself lives in
 * ``app.services.billing.void_billing_cycle`` so the episode insurance
 * switch voids a cycle the same way. With ``copy_notes_forward``
 * each voided cycle's notes are copied to every replacement created in this
 * call that overlaps its range, and only to those; ``copy_worksheet_forward``
 * is recorded on the void event, but the replacement's worksheet is rebuilt
 * by Refresh, not copied. One Slack message per distinct detail text (drafts
 * and non-drafts) is sent after the commit, listing the voided cycles.
 * ``voided_billing_cycle_ids`` comes back in sorted-id order (the lock
 * order), not request order.
 */
export const setBillingCyclesStatusVoidBillingBillingCyclesSetStatusVoidPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SetBillingCyclesStatusVoidBillingBillingCyclesSetStatusVoidPostData,
    ThrowOnError
  >
): RequestResult<
  SetBillingCyclesStatusVoidBillingBillingCyclesSetStatusVoidPostResponses,
  SetBillingCyclesStatusVoidBillingBillingCyclesSetStatusVoidPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SetBillingCyclesStatusVoidBillingBillingCyclesSetStatusVoidPostResponses,
    SetBillingCyclesStatusVoidBillingBillingCyclesSetStatusVoidPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/billing/billing-cycles/set-status/void',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Set Billing Cycle Status Pending Payment
 *
 * Manually advance a billing cycle to pending payment WITHOUT transmitting to a
 * clearinghouse — for claims the user submitted outside Roger (payer portal,
 * paper). The claim record and its patient control number are set once at Create
 * Claim and are left unchanged here, except that this stamps the claim's
 * ``submitted_date`` (the Billed date) when it is unset, so manually-sent claims
 * show a Billed date like Stedi-sent ones. The user is responsible for tracking
 * the claim from here; the 277/835 pipeline will not advance it automatically.
 */
export const setBillingCycleStatusPendingPaymentBillingBillingCycleBillingCycleIdSetStatusPendingPaymentPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      SetBillingCycleStatusPendingPaymentBillingBillingCycleBillingCycleIdSetStatusPendingPaymentPostData,
      ThrowOnError
    >
  ): RequestResult<
    SetBillingCycleStatusPendingPaymentBillingBillingCycleBillingCycleIdSetStatusPendingPaymentPostResponses,
    SetBillingCycleStatusPendingPaymentBillingBillingCycleBillingCycleIdSetStatusPendingPaymentPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      SetBillingCycleStatusPendingPaymentBillingBillingCycleBillingCycleIdSetStatusPendingPaymentPostResponses,
      SetBillingCycleStatusPendingPaymentBillingBillingCycleBillingCycleIdSetStatusPendingPaymentPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/set-status/pending-payment',
      ...options,
    });

/**
 * Set Billing Cycle Status Paid
 *
 * Manually mark a pending-payment billing cycle as paid (e.g. payment
 * received outside the clearinghouse). Also marks the linked claim PAID.
 */
export const setBillingCycleStatusPaidBillingBillingCycleBillingCycleIdSetStatusPaidPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      SetBillingCycleStatusPaidBillingBillingCycleBillingCycleIdSetStatusPaidPostData,
      ThrowOnError
    >
  ): RequestResult<
    SetBillingCycleStatusPaidBillingBillingCycleBillingCycleIdSetStatusPaidPostResponses,
    SetBillingCycleStatusPaidBillingBillingCycleBillingCycleIdSetStatusPaidPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      SetBillingCycleStatusPaidBillingBillingCycleBillingCycleIdSetStatusPaidPostResponses,
      SetBillingCycleStatusPaidBillingBillingCycleBillingCycleIdSetStatusPaidPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/set-status/paid',
      ...options,
    });

/**
 * Set Billing Cycle Status Rejected
 *
 * Manually mark a pending-payment billing cycle as rejected. Also marks the
 * linked claim DENIED. This is also the recovery path for a mistaken
 * "mark as sent" (undo is out of scope).
 */
export const setBillingCycleStatusRejectedBillingBillingCycleBillingCycleIdSetStatusRejectedPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      SetBillingCycleStatusRejectedBillingBillingCycleBillingCycleIdSetStatusRejectedPostData,
      ThrowOnError
    >
  ): RequestResult<
    SetBillingCycleStatusRejectedBillingBillingCycleBillingCycleIdSetStatusRejectedPostResponses,
    SetBillingCycleStatusRejectedBillingBillingCycleBillingCycleIdSetStatusRejectedPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      SetBillingCycleStatusRejectedBillingBillingCycleBillingCycleIdSetStatusRejectedPostResponses,
      SetBillingCycleStatusRejectedBillingBillingCycleBillingCycleIdSetStatusRejectedPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/set-status/rejected',
      ...options,
    });

/**
 * Reopen Billing Cycle
 *
 * Move a ready-to-send cycle back, for bill types whose manual
 * transitions allow it (invoice): to Correction Draft when it holds a
 * replacement, else to Pending Approval. A claim that was ever sent is
 * refused with a 409.
 */
export const reopenBillingCycleBillingBillingCycleBillingCycleIdSetStatusReopenPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ReopenBillingCycleBillingBillingCycleBillingCycleIdSetStatusReopenPostData,
      ThrowOnError
    >
  ): RequestResult<
    ReopenBillingCycleBillingBillingCycleBillingCycleIdSetStatusReopenPostResponses,
    ReopenBillingCycleBillingBillingCycleBillingCycleIdSetStatusReopenPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      ReopenBillingCycleBillingBillingCycleBillingCycleIdSetStatusReopenPostResponses,
      ReopenBillingCycleBillingBillingCycleBillingCycleIdSetStatusReopenPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/set-status/reopen',
      ...options,
    });

/**
 * Undo Billing Cycle Marked Sent
 *
 * Undo Mark as Sent: the manual transmission is marked failed, the Billed
 * date cleared and the claim made current-less and approved again.
 */
export const undoBillingCycleMarkedSentBillingBillingCycleBillingCycleIdSetStatusUndoSentPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UndoBillingCycleMarkedSentBillingBillingCycleBillingCycleIdSetStatusUndoSentPostData,
      ThrowOnError
    >
  ): RequestResult<
    UndoBillingCycleMarkedSentBillingBillingCycleBillingCycleIdSetStatusUndoSentPostResponses,
    UndoBillingCycleMarkedSentBillingBillingCycleBillingCycleIdSetStatusUndoSentPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      UndoBillingCycleMarkedSentBillingBillingCycleBillingCycleIdSetStatusUndoSentPostResponses,
      UndoBillingCycleMarkedSentBillingBillingCycleBillingCycleIdSetStatusUndoSentPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/set-status/undo-sent',
      ...options,
    });

/**
 * Undo Billing Cycle Marked Paid
 *
 * Undo Mark as Paid. A claim a completed remittance posted a payment to
 * is refused with a 409: reopen that remittance instead.
 */
export const undoBillingCycleMarkedPaidBillingBillingCycleBillingCycleIdSetStatusUndoPaidPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UndoBillingCycleMarkedPaidBillingBillingCycleBillingCycleIdSetStatusUndoPaidPostData,
      ThrowOnError
    >
  ): RequestResult<
    UndoBillingCycleMarkedPaidBillingBillingCycleBillingCycleIdSetStatusUndoPaidPostResponses,
    UndoBillingCycleMarkedPaidBillingBillingCycleBillingCycleIdSetStatusUndoPaidPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      UndoBillingCycleMarkedPaidBillingBillingCycleBillingCycleIdSetStatusUndoPaidPostResponses,
      UndoBillingCycleMarkedPaidBillingBillingCycleBillingCycleIdSetStatusUndoPaidPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/set-status/undo-paid',
      ...options,
    });

/**
 * Send Billing Cycle Again
 *
 * Reopen a rejected bill so the biller can correct it.
 *
 * One gate: the cycle status. A REJECTED cycle can be sent again, and nothing
 * else can. A DENIED cycle is refused here because the payer opened a record
 * and then refused it, so it is appealed rather than sent again — that
 * outcome has its own status precisely so this can be a status check.
 *
 * Payer evidence no longer gates this, and neither does the payer claim
 * control number. Chris Fenton ruled on 2026-08-17 that a rejected cycle
 * always offers send-again. ``derive_next_action`` holds the same
 * rule for the read model, so the button and this endpoint cannot disagree.
 *
 * Two consequences the biller now owns, both surfaced in the drawer rather
 * than prevented here:
 *
 * - A hand-marked rejection is resendable, and it carries no payer evidence.
 * The bill may still be in adjudication, so a resend can duplicate it.
 * - A rejection that carries a control number is resendable. The wire form
 * stays correct because this endpoint does not build the claim: FL 4 and
 * FL 64 come from the saved worksheet, and
 * ``validate_document_control_number`` already enforces the pairing. A
 * Medicare institutional resubmission keeps the original frequency code and
 * omits FL 64 (Stedi, "Resubmit or cancel claims"); a non-Medicare one
 * needs ``0327`` plus FL 64. Making that automatic is pending work.
 *
 * One hard stop: while the cycle's claim version holds an
 * unresolved (pending or uncertain) transmission, reopening the bill for
 * another send is refused with 409 — the previous attempt may already be
 * at the payer, and a resend could duplicate it.
 *
 * A frozen rejected claim is copied into an editable resubmission version.
 * The submitted worksheet stays immutable. Pending Approval opens the copy
 * for correction and review.
 */
export const sendBillingCycleAgainBillingBillingCycleBillingCycleIdSendAgainPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      SendBillingCycleAgainBillingBillingCycleBillingCycleIdSendAgainPostData,
      ThrowOnError
    >
  ): RequestResult<
    SendBillingCycleAgainBillingBillingCycleBillingCycleIdSendAgainPostResponses,
    SendBillingCycleAgainBillingBillingCycleBillingCycleIdSendAgainPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      SendBillingCycleAgainBillingBillingCycleBillingCycleIdSendAgainPostResponses,
      SendBillingCycleAgainBillingBillingCycleBillingCycleIdSendAgainPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/send-again',
      ...options,
    });

/**
 * Send Billing Cycle To Clearinghouse
 *
 * Send a billing cycle to the clearinghouse and update the status to pending payment.
 * After this point the billing cycle status will be updated by the back end listening
 * to the clearinghouse webhook.
 *
 * Right now it's just for stedi cause that's all we support
 *
 * Possible paths:
 * - clearinghouse pays -> PAID
 * - clearinghouse denies -> REJECTED
 * - User updates and resubmits -> PENDING_PAYMENT
 * - Repeat this process until the claim is paid or denied & user gives up
 */
export const sendBillingCycleToClearinghouseBillingBillingCycleBillingCycleIdSendToClearinghousePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      SendBillingCycleToClearinghouseBillingBillingCycleBillingCycleIdSendToClearinghousePostData,
      ThrowOnError
    >
  ): RequestResult<
    SendBillingCycleToClearinghouseBillingBillingCycleBillingCycleIdSendToClearinghousePostResponses,
    SendBillingCycleToClearinghouseBillingBillingCycleBillingCycleIdSendToClearinghousePostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      SendBillingCycleToClearinghouseBillingBillingCycleBillingCycleIdSendToClearinghousePostResponses,
      SendBillingCycleToClearinghouseBillingBillingCycleBillingCycleIdSendToClearinghousePostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/send-to-clearinghouse',
      ...options,
    });

/**
 * Create Replacement Claim
 *
 * Open the correction draft for a denied claim.
 *
 * Creates the next claim version in the cycle's chain — a REPLACEMENT
 * draft with the payer-appropriate PCN (Medicare-like reuses the denied
 * predecessor's PCN; other payers get a fresh derived
 * one), chained to the denied predecessor, its reviewed worksheet copied
 * and prepopulated with the correction values (FL 4 frequency 7, FL 64
 * prior payer claim control number) — and moves the cycle to
 * CORRECTION_DRAFT. The predecessor stays as ``current_claim_id`` until a
 * successful transmission promotes the replacement (Task 16's invariant),
 * so nothing here is payer-facing yet.
 *
 * Refused with 409 while the predecessor/current claim holds an unresolved
 * (pending or uncertain) transmission: the Task 17 open-pre-submission
 * predicate cannot see a ``SUBMITTED`` claim with an uncertain attempt —
 * that claim is not an open draft — so this explicit check is what blocks a
 * new correction while an uncertain outward attempt is unresolved.
 */
export const createReplacementClaimBillingBillingCycleBillingCycleIdReplacementPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      CreateReplacementClaimBillingBillingCycleBillingCycleIdReplacementPostData,
      ThrowOnError
    >
  ): RequestResult<
    CreateReplacementClaimBillingBillingCycleBillingCycleIdReplacementPostResponses,
    CreateReplacementClaimBillingBillingCycleBillingCycleIdReplacementPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      CreateReplacementClaimBillingBillingCycleBillingCycleIdReplacementPostResponses,
      CreateReplacementClaimBillingBillingCycleBillingCycleIdReplacementPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/replacement',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Abandon Replacement Claim
 *
 * Close the cycle's unsent replacement draft.
 *
 * Sets the open draft to ``ABANDONED`` (outside the one-open-pre-submission
 * set), leaves the predecessor as ``current_claim_id``, and moves the cycle
 * back to its denied state, so another correction can start immediately.
 * Abandoning an unsent draft is not a payer void: nothing is transmitted.
 */
export const abandonReplacementClaimBillingBillingCycleBillingCycleIdReplacementAbandonPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      AbandonReplacementClaimBillingBillingCycleBillingCycleIdReplacementAbandonPostData,
      ThrowOnError
    >
  ): RequestResult<
    AbandonReplacementClaimBillingBillingCycleBillingCycleIdReplacementAbandonPostResponses,
    AbandonReplacementClaimBillingBillingCycleBillingCycleIdReplacementAbandonPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      AbandonReplacementClaimBillingBillingCycleBillingCycleIdReplacementAbandonPostResponses,
      AbandonReplacementClaimBillingBillingCycleBillingCycleIdReplacementAbandonPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/replacement/abandon',
      ...options,
    });

/**
 * Get Billing Cycle Claim Timeline
 *
 * The ordered claim and transmission timeline for a billing cycle.
 *
 * Every claim version in the cycle's chain — cycle-owned versions,
 * including pre-Task-8 rows the Task 8 backfill linked onto the chain —
 * in sequence order, each with its outbound transmissions and the
 * 277CA / 835 evidence linked to THAT version. Read-gated like the
 * Billing Manager's other data routes (``billing:view``), not with the
 * submission authority: this is a read.
 * A cycle of another agency reports the same 404 as a missing one.
 */
export const getBillingCycleClaimTimelineBillingBillingCycleBillingCycleIdClaimTimelineGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetBillingCycleClaimTimelineBillingBillingCycleBillingCycleIdClaimTimelineGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetBillingCycleClaimTimelineBillingBillingCycleBillingCycleIdClaimTimelineGetResponses,
    GetBillingCycleClaimTimelineBillingBillingCycleBillingCycleIdClaimTimelineGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetBillingCycleClaimTimelineBillingBillingCycleBillingCycleIdClaimTimelineGetResponses,
      GetBillingCycleClaimTimelineBillingBillingCycleBillingCycleIdClaimTimelineGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/claim-timeline',
      ...options,
    });

/**
 * Get Episode Hhrg Costs
 *
 * Return scheduled episode visits with clinic defaults for one worksheet period.
 */
export const getEpisodeHhrgCostsBillingWorksheetEpisodeEpisodeIdHhrgCostsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetEpisodeHhrgCostsBillingWorksheetEpisodeEpisodeIdHhrgCostsGetData,
    ThrowOnError
  >
): RequestResult<
  GetEpisodeHhrgCostsBillingWorksheetEpisodeEpisodeIdHhrgCostsGetResponses,
  GetEpisodeHhrgCostsBillingWorksheetEpisodeEpisodeIdHhrgCostsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetEpisodeHhrgCostsBillingWorksheetEpisodeEpisodeIdHhrgCostsGetResponses,
    GetEpisodeHhrgCostsBillingWorksheetEpisodeEpisodeIdHhrgCostsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/billing/worksheet/episode/{episode_id}/hhrg-costs',
    ...options,
  });

/**
 * Get Episode Hhrg Periods Api
 */
export const getEpisodeHhrgPeriodsApiBillingWorksheetEpisodeEpisodeIdPeriodsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetEpisodeHhrgPeriodsApiBillingWorksheetEpisodeEpisodeIdPeriodsGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetEpisodeHhrgPeriodsApiBillingWorksheetEpisodeEpisodeIdPeriodsGetResponses,
    GetEpisodeHhrgPeriodsApiBillingWorksheetEpisodeEpisodeIdPeriodsGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetEpisodeHhrgPeriodsApiBillingWorksheetEpisodeEpisodeIdPeriodsGetResponses,
      GetEpisodeHhrgPeriodsApiBillingWorksheetEpisodeEpisodeIdPeriodsGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/worksheet/episode/{episode_id}/periods',
      ...options,
    });

/**
 * Get Episode Revenue Estimate Api
 *
 * Return a read-only CY2026 payment projection for one episode period.
 *
 * Works with or without a billing cycle. It is never booked or fed to AR.
 */
export const getEpisodeRevenueEstimateApiBillingWorksheetEpisodeEpisodeIdRevenueEstimateGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetEpisodeRevenueEstimateApiBillingWorksheetEpisodeEpisodeIdRevenueEstimateGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetEpisodeRevenueEstimateApiBillingWorksheetEpisodeEpisodeIdRevenueEstimateGetResponses,
    GetEpisodeRevenueEstimateApiBillingWorksheetEpisodeEpisodeIdRevenueEstimateGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetEpisodeRevenueEstimateApiBillingWorksheetEpisodeEpisodeIdRevenueEstimateGetResponses,
      GetEpisodeRevenueEstimateApiBillingWorksheetEpisodeEpisodeIdRevenueEstimateGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/worksheet/episode/{episode_id}/revenue-estimate',
      ...options,
    });

/**
 * Get Billing Cycles Meta Api
 *
 * Get metadata for the current agency's billing cycles.
 */
export const getBillingCyclesMetaApiBillingBillingCyclesMetaGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetBillingCyclesMetaApiBillingBillingCyclesMetaGetData,
    ThrowOnError
  >
): RequestResult<
  GetBillingCyclesMetaApiBillingBillingCyclesMetaGetResponses,
  GetBillingCyclesMetaApiBillingBillingCyclesMetaGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetBillingCyclesMetaApiBillingBillingCyclesMetaGetResponses,
    GetBillingCyclesMetaApiBillingBillingCyclesMetaGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/billing/billing-cycles/meta',
    ...options,
  });

/**
 * Get Billing Cycle Count For Patient Api
 *
 * Count the patient's visible billing cycles across all statuses.
 */
export const getBillingCycleCountForPatientApiBillingBillingCyclesCountGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetBillingCycleCountForPatientApiBillingBillingCyclesCountGetData,
    ThrowOnError
  >
): RequestResult<
  GetBillingCycleCountForPatientApiBillingBillingCyclesCountGetResponses,
  GetBillingCycleCountForPatientApiBillingBillingCyclesCountGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetBillingCycleCountForPatientApiBillingBillingCyclesCountGetResponses,
    GetBillingCycleCountForPatientApiBillingBillingCyclesCountGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/billing/billing-cycles/count',
    ...options,
  });

/**
 * Get Patient Geographic Value Codes Api
 *
 * Return the generated UB-04 geographic value codes (VC 61/85) for a patient.
 *
 * VC 61 is the CBSA and VC 85 the FIPS county, both derived from the patient's
 * ZIP via the same CMS/HUD geography lookup that worksheet population uses to
 * fill missing VC 61/85 (see
 * ``fill_missing_geographic_value_codes_for_episode``). This is a read-only
 * derivation: it neither writes a worksheet nor applies the PDGM eligibility
 * gate (there is no billing cycle / insurance in scope here), so it always
 * reports whatever geography the patient's ZIP maps to.
 *
 * ``amount`` fields are ``None`` when the patient has no ZIP on file, the ZIP
 * does not map to CMS geography, or the reference table has no value for that
 * field. The values are raw code literals, not dollar amounts.
 */
export const getPatientGeographicValueCodesApiBillingPatientPatientIdGeographicValueCodesGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetPatientGeographicValueCodesApiBillingPatientPatientIdGeographicValueCodesGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetPatientGeographicValueCodesApiBillingPatientPatientIdGeographicValueCodesGetResponses,
    GetPatientGeographicValueCodesApiBillingPatientPatientIdGeographicValueCodesGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetPatientGeographicValueCodesApiBillingPatientPatientIdGeographicValueCodesGetResponses,
      GetPatientGeographicValueCodesApiBillingPatientPatientIdGeographicValueCodesGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/patient/{patient_id}/geographic-value-codes',
      ...options,
    });

/**
 * Get Draft Billing Cycles Api
 *
 * Get a paginated page of draft billing cycles for the current agency.
 */
export const getDraftBillingCyclesApiBillingBillingCyclesDraftsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetDraftBillingCyclesApiBillingBillingCyclesDraftsPostData,
    ThrowOnError
  >
): RequestResult<
  GetDraftBillingCyclesApiBillingBillingCyclesDraftsPostResponses,
  GetDraftBillingCyclesApiBillingBillingCyclesDraftsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GetDraftBillingCyclesApiBillingBillingCyclesDraftsPostResponses,
    GetDraftBillingCyclesApiBillingBillingCyclesDraftsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/billing/billing-cycles/drafts',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Active Billing Cycles Api
 *
 * Get a paginated page of billing cycles matching the given statuses.
 */
export const getActiveBillingCyclesApiBillingBillingCyclesActiveCyclesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetActiveBillingCyclesApiBillingBillingCyclesActiveCyclesPostData,
    ThrowOnError
  >
): RequestResult<
  GetActiveBillingCyclesApiBillingBillingCyclesActiveCyclesPostResponses,
  GetActiveBillingCyclesApiBillingBillingCyclesActiveCyclesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GetActiveBillingCyclesApiBillingBillingCyclesActiveCyclesPostResponses,
    GetActiveBillingCyclesApiBillingBillingCyclesActiveCyclesPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/billing/billing-cycles/active-cycles',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Export Billing Cycles
 *
 * Every claims row matching the filters, as a spreadsheet.
 *
 * GET rather than POST, unlike the list endpoints beside it: every export
 * route in this tree is a GET, and `reject_unknown_file_params` reads
 * `request.query_params`.
 *
 * Test patients are hidden unless the request explicitly passes
 * `hide_test_patients=false`, matching the list endpoints beside it. Cycles on
 * an inactive (cancelled) episode are likewise left out unless the request
 * passes `show_inactive_episodes=true`. Draft cycles with nothing to bill are
 * left out of the Not Ready rows unless the request passes
 * `show_nothing_to_bill=true`.
 *
 * All-stage exports group rows in workflow-stage order. Sorting applies within
 * each stage, not across the whole file. Unsupported sort keys use that stage's
 * default (billing-period end date descending).
 *
 * Visit collections are not loaded. Export columns do not use them, and
 * selectin-loading every visit's ``visit_data`` JSON at the row cap OOMs the
 * API worker on imported-chart agencies.
 */
export const exportBillingCyclesBillingBillingCyclesExportGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ExportBillingCyclesBillingBillingCyclesExportGetData,
    ThrowOnError
  >
): RequestResult<
  ExportBillingCyclesBillingBillingCyclesExportGetResponses,
  ExportBillingCyclesBillingBillingCyclesExportGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ExportBillingCyclesBillingBillingCyclesExportGetResponses,
    ExportBillingCyclesBillingBillingCyclesExportGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/billing/billing-cycles/export',
    ...options,
  });

/**
 * Get Billing Cycle Payer Response
 *
 * What the payer said about this cycle's claim, and what the biller may do.
 *
 * The same summary type the NOA Manager reads, so the two screens cannot
 * disagree about a reason or about whether the bill is still correctable.
 * A cycle of another agency is absent from the batched read, so it
 * reports the same 404 as a genuine miss. So does an EXTERNAL cycle:
 * Roger sent no claim for it.
 */
export const getBillingCyclePayerResponseBillingBillingCycleBillingCycleIdPayerResponseGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetBillingCyclePayerResponseBillingBillingCycleBillingCycleIdPayerResponseGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetBillingCyclePayerResponseBillingBillingCycleBillingCycleIdPayerResponseGetResponses,
    GetBillingCyclePayerResponseBillingBillingCycleBillingCycleIdPayerResponseGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetBillingCyclePayerResponseBillingBillingCycleBillingCycleIdPayerResponseGetResponses,
      GetBillingCyclePayerResponseBillingBillingCycleBillingCycleIdPayerResponseGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/payer-response',
      ...options,
    });

/**
 * Get Billing Cycle Readiness Api
 *
 * One draft billing cycle in the drafts-list row shape, with its readiness
 * flags recomputed. The EOE preview popup refetches this after an in-place
 * edit instead of keeping the list row it opened from.
 */
export const getBillingCycleReadinessApiBillingBillingCycleBillingCycleIdReadinessGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetBillingCycleReadinessApiBillingBillingCycleBillingCycleIdReadinessGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetBillingCycleReadinessApiBillingBillingCycleBillingCycleIdReadinessGetResponses,
    GetBillingCycleReadinessApiBillingBillingCycleBillingCycleIdReadinessGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetBillingCycleReadinessApiBillingBillingCycleBillingCycleIdReadinessGetResponses,
      GetBillingCycleReadinessApiBillingBillingCycleBillingCycleIdReadinessGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/readiness',
      ...options,
    });

/**
 * Get Billing Cycle Eoe Preview Api
 *
 * Get EOE claim preview data for a billing cycle, including patient demographics,
 * address, episode information, admission information, and OASIS visit details.
 */
export const getBillingCycleEoePreviewApiBillingBillingCycleBillingCycleIdEoePreviewGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetBillingCycleEoePreviewApiBillingBillingCycleBillingCycleIdEoePreviewGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetBillingCycleEoePreviewApiBillingBillingCycleBillingCycleIdEoePreviewGetResponses,
    GetBillingCycleEoePreviewApiBillingBillingCycleBillingCycleIdEoePreviewGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetBillingCycleEoePreviewApiBillingBillingCycleBillingCycleIdEoePreviewGetResponses,
      GetBillingCycleEoePreviewApiBillingBillingCycleBillingCycleIdEoePreviewGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/eoe-preview',
      ...options,
    });

/**
 * Get Billing Cycle Readiness Details Api
 *
 * Cycle-anchored readiness evidence for the draft category popovers.
 *
 * Independent of full-preview eligibility, so an all-missed cycle still
 * reports its blocking orders. Mirrors ``get_billing_cycle_eoe_preview_api``:
 * authenticated, agency-scoped object access, no extra permission slug.
 */
export const getBillingCycleReadinessDetails = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetBillingCycleReadinessDetailsData, ThrowOnError>
): RequestResult<
  GetBillingCycleReadinessDetailsResponses,
  GetBillingCycleReadinessDetailsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetBillingCycleReadinessDetailsResponses,
    GetBillingCycleReadinessDetailsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/billing/billing-cycle/{billing_cycle_id}/readiness-details',
    ...options,
  });

/**
 * Get Billing Cycle Revenue Estimate Api
 *
 * Return a read-only CY2026 expected-payment estimate for one cycle.
 *
 * The patient's ZIP supplies the beneficiary site-of-service geography. No
 * agency address, worksheet adjustment, or claim field is inferred here.
 */
export const getBillingCycleRevenueEstimateApiBillingBillingCycleBillingCycleIdRevenueEstimateGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetBillingCycleRevenueEstimateApiBillingBillingCycleBillingCycleIdRevenueEstimateGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetBillingCycleRevenueEstimateApiBillingBillingCycleBillingCycleIdRevenueEstimateGetResponses,
    GetBillingCycleRevenueEstimateApiBillingBillingCycleBillingCycleIdRevenueEstimateGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetBillingCycleRevenueEstimateApiBillingBillingCycleBillingCycleIdRevenueEstimateGetResponses,
      GetBillingCycleRevenueEstimateApiBillingBillingCycleBillingCycleIdRevenueEstimateGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/revenue-estimate',
      ...options,
    });

/**
 * Get Billing Cycle Hipps Preview Api
 *
 * Resolve the HIPPS code the claim will carry, without saving it.
 *
 * Used by the EOE claim preview popup to display the expected HIPPS code
 * before the user creates the claim, so it answers with the claim's own
 * resolution (externally billed history resolves to the saved
 * biller override or the marked submission default, never "unavailable")
 * while a real clinical refusal still surfaces its biller-actionable reason.
 */
export const getBillingCycleHippsPreviewApiBillingBillingCycleBillingCycleIdHippsPreviewGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetBillingCycleHippsPreviewApiBillingBillingCycleBillingCycleIdHippsPreviewGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetBillingCycleHippsPreviewApiBillingBillingCycleBillingCycleIdHippsPreviewGetResponses,
    GetBillingCycleHippsPreviewApiBillingBillingCycleBillingCycleIdHippsPreviewGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetBillingCycleHippsPreviewApiBillingBillingCycleBillingCycleIdHippsPreviewGetResponses,
      GetBillingCycleHippsPreviewApiBillingBillingCycleBillingCycleIdHippsPreviewGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/hipps-preview',
      ...options,
    });

/**
 * Get Billing Cycle Visits And Supplies Api
 *
 * Get all visits and supplies for a billing cycle.
 */
export const getBillingCycleVisitsAndSuppliesApiBillingBillingCycleBillingCycleIdVisitsAndSuppliesGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetBillingCycleVisitsAndSuppliesApiBillingBillingCycleBillingCycleIdVisitsAndSuppliesGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetBillingCycleVisitsAndSuppliesApiBillingBillingCycleBillingCycleIdVisitsAndSuppliesGetResponses,
    GetBillingCycleVisitsAndSuppliesApiBillingBillingCycleBillingCycleIdVisitsAndSuppliesGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetBillingCycleVisitsAndSuppliesApiBillingBillingCycleBillingCycleIdVisitsAndSuppliesGetResponses,
      GetBillingCycleVisitsAndSuppliesApiBillingBillingCycleBillingCycleIdVisitsAndSuppliesGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/visits-and-supplies',
      ...options,
    });

/**
 * Update Billing Worksheet Api
 *
 * Update editable fields on the claims worksheet for a billing cycle.
 *
 * Applies all changes in a single transaction. Currently supports updating
 * the billable status of visits.
 */
export const updateBillingWorksheetApiBillingBillingCycleUpdateWorksheetPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateBillingWorksheetApiBillingBillingCycleUpdateWorksheetPostData,
    ThrowOnError
  >
): RequestResult<
  UpdateBillingWorksheetApiBillingBillingCycleUpdateWorksheetPostResponses,
  UpdateBillingWorksheetApiBillingBillingCycleUpdateWorksheetPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UpdateBillingWorksheetApiBillingBillingCycleUpdateWorksheetPostResponses,
    UpdateBillingWorksheetApiBillingBillingCycleUpdateWorksheetPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/billing/billing-cycle/update-worksheet',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Stedi 837 Claim Json Api
 *
 * Create a Stedi 837I claim JSON for a billing cycle.
 */
export const createStedi837ClaimJsonApiBillingBillingCycleBillingCycleIdCreateStedi837ClaimJsonPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      CreateStedi837ClaimJsonApiBillingBillingCycleBillingCycleIdCreateStedi837ClaimJsonPostData,
      ThrowOnError
    >
  ): RequestResult<
    CreateStedi837ClaimJsonApiBillingBillingCycleBillingCycleIdCreateStedi837ClaimJsonPostResponses,
    CreateStedi837ClaimJsonApiBillingBillingCycleBillingCycleIdCreateStedi837ClaimJsonPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      CreateStedi837ClaimJsonApiBillingBillingCycleBillingCycleIdCreateStedi837ClaimJsonPostResponses,
      CreateStedi837ClaimJsonApiBillingBillingCycleBillingCycleIdCreateStedi837ClaimJsonPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/create-stedi-837-claim-json',
      ...options,
    });

/**
 * Download Billing Cycle 837 Edi
 *
 * Generate X12 837I EDI for a billing cycle without persisting a claim or calling Stedi.
 *
 * Builds the 837I claim JSON from the billing cycle, transforms it to EDI locally, and
 * returns the raw X12 message as plain text.
 */
export const downloadBillingCycle837EdiBillingBillingCycleBillingCycleIdDownload837EdiGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DownloadBillingCycle837EdiBillingBillingCycleBillingCycleIdDownload837EdiGetData,
      ThrowOnError
    >
  ): RequestResult<
    DownloadBillingCycle837EdiBillingBillingCycleBillingCycleIdDownload837EdiGetResponses,
    DownloadBillingCycle837EdiBillingBillingCycleBillingCycleIdDownload837EdiGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      DownloadBillingCycle837EdiBillingBillingCycleBillingCycleIdDownload837EdiGetResponses,
      DownloadBillingCycle837EdiBillingBillingCycleBillingCycleIdDownload837EdiGetErrors,
      ThrowOnError
    >({
      responseType: 'text',
      url: '/billing/billing-cycle/{billing_cycle_id}/download-837-edi',
      ...options,
    });

/**
 * Download Billing Cycle Ub04 Pdf
 *
 * Generate a UB-04 (CMS-1450) PDF from the current saved worksheet.
 */
export const downloadBillingCycleUb04PdfBillingBillingCycleBillingCycleIdDownloadUb04PdfGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DownloadBillingCycleUb04PdfBillingBillingCycleBillingCycleIdDownloadUb04PdfGetData,
      ThrowOnError
    >
  ): RequestResult<
    DownloadBillingCycleUb04PdfBillingBillingCycleBillingCycleIdDownloadUb04PdfGetResponses,
    DownloadBillingCycleUb04PdfBillingBillingCycleBillingCycleIdDownloadUb04PdfGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      DownloadBillingCycleUb04PdfBillingBillingCycleBillingCycleIdDownloadUb04PdfGetResponses,
      DownloadBillingCycleUb04PdfBillingBillingCycleBillingCycleIdDownloadUb04PdfGetErrors,
      ThrowOnError
    >({
      responseType: 'blob',
      url: '/billing/billing-cycle/{billing_cycle_id}/download-ub04-pdf',
      ...options,
    });

/**
 * Refresh Billing Cycles
 *
 * Enqueue a billing cycle refresh for the current agency: reruns cycle
 * creation and fills every period inside an episode window that no live
 * cycle covers. Returns the workflow id; poll the status endpoint to track
 * completion.
 *
 * Requires ``claims:submit``: the run creates and re-creates the
 * cycles that are then sent, the same authority as the dev enqueue route and
 * the send routes.
 */
export const refreshBillingCyclesBillingRefreshBillingCyclesPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    RefreshBillingCyclesBillingRefreshBillingCyclesPostData,
    ThrowOnError
  >
): RequestResult<
  RefreshBillingCyclesBillingRefreshBillingCyclesPostResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    RefreshBillingCyclesBillingRefreshBillingCyclesPostResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/billing/refresh-billing-cycles',
    ...options,
  });

/**
 * Get Refresh Billing Cycles Status
 *
 * Return the latest run status for an agency's refresh workflow.
 */
export const getRefreshBillingCyclesStatusBillingRefreshBillingCyclesWorkflowIdStatusGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetRefreshBillingCyclesStatusBillingRefreshBillingCyclesWorkflowIdStatusGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetRefreshBillingCyclesStatusBillingRefreshBillingCyclesWorkflowIdStatusGetResponses,
    GetRefreshBillingCyclesStatusBillingRefreshBillingCyclesWorkflowIdStatusGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetRefreshBillingCyclesStatusBillingRefreshBillingCyclesWorkflowIdStatusGetResponses,
      GetRefreshBillingCyclesStatusBillingRefreshBillingCyclesWorkflowIdStatusGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/refresh-billing-cycles/{workflow_id}/status',
      ...options,
    });

/**
 * Get Billing Cycle Worksheet
 *
 * Return the (agency-scoped) worksheet for a billing cycle.
 */
export const getBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetGetResponses,
    GetBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetGetResponses,
      GetBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/worksheet',
      ...options,
    });

/**
 * Replace Billing Cycle Worksheet
 *
 * Replace the expanded saved UB-04 worksheet document without changing status.
 */
export const replaceBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetFullPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ReplaceBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetFullPutData,
      ThrowOnError
    >
  ): RequestResult<
    ReplaceBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetFullPutResponses,
    ReplaceBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetFullPutErrors,
    ThrowOnError
  > =>
    (options.client ?? client).put<
      ReplaceBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetFullPutResponses,
      ReplaceBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetFullPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/worksheet/full',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Refresh Billing Cycle Worksheet
 *
 * Destructively refresh worksheet data without changing cycle status.
 */
export const refreshBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetRefreshPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      RefreshBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetRefreshPostData,
      ThrowOnError
    >
  ): RequestResult<
    RefreshBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetRefreshPostResponses,
    RefreshBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetRefreshPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      RefreshBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetRefreshPostResponses,
      RefreshBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetRefreshPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/worksheet/refresh',
      ...options,
    });

/**
 * Get Billing Claim Worksheet
 *
 * Return one claim version's own preserved worksheet.
 *
 * The claim timeline links every version's worksheet: submitted versions
 * open their frozen UB-04 PDF, the open draft opens the cycle's editable
 * worksheet, and an ABANDONED replacement has neither — its preserved
 * copy (``uq_billing_cycle_worksheets_one_per_claim``) is what this read
 * exposes, so a biller can review what the abandoned version held.
 *
 * Read-only by construction: the worksheet write routes resolve the
 * cycle's biller-facing row, which an abandoned claim never is.
 *
 * A claim of another agency reports the same 404 as a missing one, and a
 * claim without a worksheet reports the same 404 as the cycle worksheet
 * route.
 */
export const getBillingClaimWorksheetBillingClaimsClaimIdWorksheetGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetBillingClaimWorksheetBillingClaimsClaimIdWorksheetGetData,
    ThrowOnError
  >
): RequestResult<
  GetBillingClaimWorksheetBillingClaimsClaimIdWorksheetGetResponses,
  GetBillingClaimWorksheetBillingClaimsClaimIdWorksheetGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetBillingClaimWorksheetBillingClaimsClaimIdWorksheetGetResponses,
    GetBillingClaimWorksheetBillingClaimsClaimIdWorksheetGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/billing/claims/{claim_id}/worksheet',
    ...options,
  });

/**
 * List Billing Cycle Notes
 *
 * List notes for a billing cycle, newest first.
 */
export const listBillingCycleNotesBillingBillingCycleBillingCycleIdNotesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListBillingCycleNotesBillingBillingCycleBillingCycleIdNotesGetData,
    ThrowOnError
  >
): RequestResult<
  ListBillingCycleNotesBillingBillingCycleBillingCycleIdNotesGetResponses,
  ListBillingCycleNotesBillingBillingCycleBillingCycleIdNotesGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListBillingCycleNotesBillingBillingCycleBillingCycleIdNotesGetResponses,
    ListBillingCycleNotesBillingBillingCycleBillingCycleIdNotesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/billing/billing-cycle/{billing_cycle_id}/notes',
    ...options,
  });

/**
 * Create Billing Cycle Note
 *
 * Create a new note on a billing cycle.
 */
export const createBillingCycleNoteBillingBillingCycleBillingCycleIdNotesPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      CreateBillingCycleNoteBillingBillingCycleBillingCycleIdNotesPostData,
      ThrowOnError
    >
  ): RequestResult<
    CreateBillingCycleNoteBillingBillingCycleBillingCycleIdNotesPostResponses,
    CreateBillingCycleNoteBillingBillingCycleBillingCycleIdNotesPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      CreateBillingCycleNoteBillingBillingCycleBillingCycleIdNotesPostResponses,
      CreateBillingCycleNoteBillingBillingCycleBillingCycleIdNotesPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/notes',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Delete Billing Cycle Note
 *
 * Soft-delete a note. Only the author may delete.
 */
export const deleteBillingCycleNoteBillingBillingCycleNotesNoteIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteBillingCycleNoteBillingBillingCycleNotesNoteIdDeleteData,
    ThrowOnError
  >
): RequestResult<
  DeleteBillingCycleNoteBillingBillingCycleNotesNoteIdDeleteResponses,
  DeleteBillingCycleNoteBillingBillingCycleNotesNoteIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteBillingCycleNoteBillingBillingCycleNotesNoteIdDeleteResponses,
    DeleteBillingCycleNoteBillingBillingCycleNotesNoteIdDeleteErrors,
    ThrowOnError
  >({ url: '/billing/billing-cycle/notes/{note_id}', ...options });

/**
 * Get Billing Cycle Note
 *
 * Get a single billing cycle note by ID.
 */
export const getBillingCycleNoteBillingBillingCycleNotesNoteIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetBillingCycleNoteBillingBillingCycleNotesNoteIdGetData,
    ThrowOnError
  >
): RequestResult<
  GetBillingCycleNoteBillingBillingCycleNotesNoteIdGetResponses,
  GetBillingCycleNoteBillingBillingCycleNotesNoteIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetBillingCycleNoteBillingBillingCycleNotesNoteIdGetResponses,
    GetBillingCycleNoteBillingBillingCycleNotesNoteIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/billing/billing-cycle/notes/{note_id}',
    ...options,
  });

/**
 * Update Billing Cycle Note
 *
 * Update a note's body. Only the author may edit.
 */
export const updateBillingCycleNoteBillingBillingCycleNotesNoteIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateBillingCycleNoteBillingBillingCycleNotesNoteIdPatchData,
    ThrowOnError
  >
): RequestResult<
  UpdateBillingCycleNoteBillingBillingCycleNotesNoteIdPatchResponses,
  UpdateBillingCycleNoteBillingBillingCycleNotesNoteIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateBillingCycleNoteBillingBillingCycleNotesNoteIdPatchResponses,
    UpdateBillingCycleNoteBillingBillingCycleNotesNoteIdPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/billing/billing-cycle/notes/{note_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Unmatched 277Ca Claim Statuses
 *
 * List the tenant's unmatched 277CA claim evidence for biller review.
 */
export const reconciliationListUnmatched277CaClaimStatuses = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ReconciliationListUnmatched277CaClaimStatusesData,
    ThrowOnError
  >
): RequestResult<
  ReconciliationListUnmatched277CaClaimStatusesResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ReconciliationListUnmatched277CaClaimStatusesResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/billing/reconciliation/claim-statuses/unmatched',
    ...options,
  });

/**
 * Resolve Claim Transmission
 *
 * Confirm an uncertain or expired pending outbound attempt's result.
 */
export const reconciliationResolveClaimTransmission = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ReconciliationResolveClaimTransmissionData, ThrowOnError>
): RequestResult<
  ReconciliationResolveClaimTransmissionResponses,
  ReconciliationResolveClaimTransmissionErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ReconciliationResolveClaimTransmissionResponses,
    ReconciliationResolveClaimTransmissionErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/billing/reconciliation/transmissions/{transmission_id}/resolve',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Attach 277Ca Claim Status
 *
 * Attach one unmatched 277CA claim status to a claim version.
 */
export const reconciliationAttach277CaClaimStatus = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ReconciliationAttach277CaClaimStatusData, ThrowOnError>
): RequestResult<
  ReconciliationAttach277CaClaimStatusResponses,
  ReconciliationAttach277CaClaimStatusErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ReconciliationAttach277CaClaimStatusResponses,
    ReconciliationAttach277CaClaimStatusErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/billing/reconciliation/claim-statuses/{status_id}/attach',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Attach 835 Remittance Payment
 *
 * Attach one unmatched 835 remittance payment to a claim version.
 */
export const reconciliationAttach835RemittancePayment = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ReconciliationAttach835RemittancePaymentData, ThrowOnError>
): RequestResult<
  ReconciliationAttach835RemittancePaymentResponses,
  ReconciliationAttach835RemittancePaymentErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ReconciliationAttach835RemittancePaymentResponses,
    ReconciliationAttach835RemittancePaymentErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/billing/reconciliation/remittance-payments/{payment_id}/attach',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Ar Roll Forward
 *
 * Every month's AR movement by clinic and payer class, plus the cash block.
 */
export const billingGetArRollForward = <ThrowOnError extends boolean = false>(
  options?: Options<BillingGetArRollForwardData, ThrowOnError>
): RequestResult<BillingGetArRollForwardResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    BillingGetArRollForwardResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/billing/ar-roll-forward',
    ...options,
  });

/**
 * Get Ar Roll Forward Lines
 *
 * The rows behind one cell, or every money line's rows with no ``line``.
 *
 * ``clinic=none`` means no billing clinic name.
 */
export const billingGetArRollForwardLines = <
  ThrowOnError extends boolean = false,
>(
  options: Options<BillingGetArRollForwardLinesData, ThrowOnError>
): RequestResult<
  BillingGetArRollForwardLinesResponses,
  BillingGetArRollForwardLinesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    BillingGetArRollForwardLinesResponses,
    BillingGetArRollForwardLinesErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/billing/ar-roll-forward/lines',
    ...options,
  });

/**
 * List Write Offs
 *
 * Open balance, net written off and the write-off rows for the current claim.
 */
export const billingListWriteOffs = <ThrowOnError extends boolean = false>(
  options: Options<BillingListWriteOffsData, ThrowOnError>
): RequestResult<
  BillingListWriteOffsResponses,
  BillingListWriteOffsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    BillingListWriteOffsResponses,
    BillingListWriteOffsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/billing/billing-cycle/{billing_cycle_id}/write-offs',
    ...options,
  });

/**
 * Create Write Off
 *
 * Post a write-off. A retry with the same id returns the stored row (200).
 */
export const billingPostWriteOff = <ThrowOnError extends boolean = false>(
  options: Options<BillingPostWriteOffData, ThrowOnError>
): RequestResult<
  BillingPostWriteOffResponses,
  BillingPostWriteOffErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    BillingPostWriteOffResponses,
    BillingPostWriteOffErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/billing/billing-cycle/{billing_cycle_id}/write-offs',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Reverse Write Off Route
 *
 * Reverse a write-off with a new negative row. A retry returns the stored row.
 */
export const billingReverseWriteOff = <ThrowOnError extends boolean = false>(
  options: Options<BillingReverseWriteOffData, ThrowOnError>
): RequestResult<
  BillingReverseWriteOffResponses,
  BillingReverseWriteOffErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    BillingReverseWriteOffResponses,
    BillingReverseWriteOffErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/billing/write-offs/{write_off_id}/reverse',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Upload Remittance
 *
 * Upload a raw 835 EDI file: translate, dedupe, and store every ST as a row.
 */
export const uploadRemittanceRemittancesUploadPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UploadRemittanceRemittancesUploadPostData, ThrowOnError>
): RequestResult<
  UploadRemittanceRemittancesUploadPostResponses,
  UploadRemittanceRemittancesUploadPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UploadRemittanceRemittancesUploadPostResponses,
    UploadRemittanceRemittancesUploadPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/remittances/upload',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * List Remittance Payors
 *
 * The agency's payor options for the remittance list's Insurance filter.
 */
export const listRemittancePayorsRemittancesPayorsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListRemittancePayorsRemittancesPayorsGetData, ThrowOnError>
): RequestResult<
  ListRemittancePayorsRemittancesPayorsGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListRemittancePayorsRemittancesPayorsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/remittances/payors',
    ...options,
  });

/**
 * Get Remittance Status Counts
 *
 * Per-status totals for the remittance status tab bar.
 */
export const getRemittanceStatusCountsRemittancesStatusCountsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetRemittanceStatusCountsRemittancesStatusCountsGetData,
    ThrowOnError
  >
): RequestResult<
  GetRemittanceStatusCountsRemittancesStatusCountsGetResponses,
  GetRemittanceStatusCountsRemittancesStatusCountsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetRemittanceStatusCountsRemittancesStatusCountsGetResponses,
    GetRemittanceStatusCountsRemittancesStatusCountsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/remittances/status-counts',
    ...options,
  });

/**
 * List Remittances
 *
 * Paginated remittance list for the current agency (default newest first).
 */
export const listRemittancesRemittancesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListRemittancesRemittancesGetData, ThrowOnError>
): RequestResult<
  ListRemittancesRemittancesGetResponses,
  ListRemittancesRemittancesGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListRemittancesRemittancesGetResponses,
    ListRemittancesRemittancesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/remittances/',
    ...options,
  });

/**
 * Export Remittances
 *
 * Every remittance matching the filters, as a spreadsheet.
 *
 * One row per remittance: the check register the table shows. Claim-level
 * posting detail lives behind the detail dialog and is a separate ticket.
 */
export const exportRemittancesRemittancesExportGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ExportRemittancesRemittancesExportGetData, ThrowOnError>
): RequestResult<
  ExportRemittancesRemittancesExportGetResponses,
  ExportRemittancesRemittancesExportGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ExportRemittancesRemittancesExportGetResponses,
    ExportRemittancesRemittancesExportGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/remittances/export',
    ...options,
  });

/**
 * Create Remittance
 *
 * Create a Saved manual remittance worksheet.
 */
export const createRemittanceRemittancesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateRemittanceRemittancesPostData, ThrowOnError>
): RequestResult<
  CreateRemittanceRemittancesPostResponses,
  CreateRemittanceRemittancesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateRemittanceRemittancesPostResponses,
    CreateRemittanceRemittancesPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/remittances',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Remittance Claims
 *
 * Search this agency's claims for the worksheet Add Claims dialog and
 * the detail-dialog attach flow.
 */
export const searchRemittanceClaimsRemittancesClaimsSearchGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    SearchRemittanceClaimsRemittancesClaimsSearchGetData,
    ThrowOnError
  >
): RequestResult<
  SearchRemittanceClaimsRemittancesClaimsSearchGetResponses,
  SearchRemittanceClaimsRemittancesClaimsSearchGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    SearchRemittanceClaimsRemittancesClaimsSearchGetResponses,
    SearchRemittanceClaimsRemittancesClaimsSearchGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/remittances/claims/search',
    ...options,
  });

/**
 * Delete Remittance
 *
 * Soft-delete a Saved remittance worksheet.
 */
export const deleteRemittanceRemittancesRemittanceIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteRemittanceRemittancesRemittanceIdDeleteData,
    ThrowOnError
  >
): RequestResult<
  DeleteRemittanceRemittancesRemittanceIdDeleteResponses,
  DeleteRemittanceRemittancesRemittanceIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteRemittanceRemittancesRemittanceIdDeleteResponses,
    DeleteRemittanceRemittancesRemittanceIdDeleteErrors,
    ThrowOnError
  >({ url: '/remittances/{remittance_id}', ...options });

/**
 * Get Remittance Detail
 *
 * Full nested detail for one remittance advice: payments, lines, adjustments.
 */
export const getRemittanceDetailRemittancesRemittanceIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetRemittanceDetailRemittancesRemittanceIdGetData,
    ThrowOnError
  >
): RequestResult<
  GetRemittanceDetailRemittancesRemittanceIdGetResponses,
  GetRemittanceDetailRemittancesRemittanceIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetRemittanceDetailRemittancesRemittanceIdGetResponses,
    GetRemittanceDetailRemittancesRemittanceIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/remittances/{remittance_id}',
    ...options,
  });

/**
 * Update Remittance
 *
 * Save the editable fields of a Saved remittance worksheet.
 */
export const updateRemittanceWorksheetRemittancesRemittanceIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateRemittanceWorksheetRemittancesRemittanceIdPutData,
    ThrowOnError
  >
): RequestResult<
  UpdateRemittanceWorksheetRemittancesRemittanceIdPutResponses,
  UpdateRemittanceWorksheetRemittancesRemittanceIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateRemittanceWorksheetRemittancesRemittanceIdPutResponses,
    UpdateRemittanceWorksheetRemittancesRemittanceIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/remittances/{remittance_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Complete Remittance Worksheet
 *
 * Complete a Saved worksheet and atomically post its claim payments.
 */
export const completeRemittanceRemittancesRemittanceIdCompletePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CompleteRemittanceRemittancesRemittanceIdCompletePostData,
    ThrowOnError
  >
): RequestResult<
  CompleteRemittanceRemittancesRemittanceIdCompletePostResponses,
  CompleteRemittanceRemittancesRemittanceIdCompletePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CompleteRemittanceRemittancesRemittanceIdCompletePostResponses,
    CompleteRemittanceRemittancesRemittanceIdCompletePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/remittances/{remittance_id}/complete',
    ...options,
  });

/**
 * Reopen Remittance Worksheet
 *
 * Reopen a completed worksheet and reverse what its payments posted.
 */
export const reopenRemittanceRemittancesRemittanceIdReopenPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ReopenRemittanceRemittancesRemittanceIdReopenPostData,
    ThrowOnError
  >
): RequestResult<
  ReopenRemittanceRemittancesRemittanceIdReopenPostResponses,
  ReopenRemittanceRemittancesRemittanceIdReopenPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ReopenRemittanceRemittancesRemittanceIdReopenPostResponses,
    ReopenRemittanceRemittancesRemittanceIdReopenPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/remittances/{remittance_id}/reopen',
    ...options,
  });

/**
 * Download Remittance
 *
 * Download the raw 835 X12 for a remittance advice.
 *
 * An uploaded file is served as stored. A remittance received from Stedi is
 * fetched from Stedi and served as this remittance's own transaction set in
 * an X12 envelope, so the file can be imported into another billing system.
 */
export const downloadRemittanceRemittancesRemittanceIdDownloadGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DownloadRemittanceRemittancesRemittanceIdDownloadGetData,
    ThrowOnError
  >
): RequestResult<
  DownloadRemittanceRemittancesRemittanceIdDownloadGetResponses,
  DownloadRemittanceRemittancesRemittanceIdDownloadGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    DownloadRemittanceRemittancesRemittanceIdDownloadGetResponses,
    DownloadRemittanceRemittancesRemittanceIdDownloadGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/remittances/{remittance_id}/download',
    ...options,
  });

/**
 * Get Active Users Report
 */
export const getActiveUsersReportReportsActiveUsersGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetActiveUsersReportReportsActiveUsersGetData, ThrowOnError>
): RequestResult<
  GetActiveUsersReportReportsActiveUsersGetResponses,
  GetActiveUsersReportReportsActiveUsersGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetActiveUsersReportReportsActiveUsersGetResponses,
    GetActiveUsersReportReportsActiveUsersGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/active-users',
    ...options,
  });

/**
 * Export Active Users Report
 */
export const exportActiveUsersReportReportsActiveUsersExportGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ExportActiveUsersReportReportsActiveUsersExportGetData,
    ThrowOnError
  >
): RequestResult<
  ExportActiveUsersReportReportsActiveUsersExportGetResponses,
  ExportActiveUsersReportReportsActiveUsersExportGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ExportActiveUsersReportReportsActiveUsersExportGetResponses,
    ExportActiveUsersReportReportsActiveUsersExportGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/reports/active-users/export',
    ...options,
  });

/**
 * Get Patient Diagnoses Report Clinic Options
 */
export const getPatientDiagnosesReportClinicOptionsReportsPatientDiagnosesClinicOptionsGet =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      GetPatientDiagnosesReportClinicOptionsReportsPatientDiagnosesClinicOptionsGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetPatientDiagnosesReportClinicOptionsReportsPatientDiagnosesClinicOptionsGetResponses,
    GetPatientDiagnosesReportClinicOptionsReportsPatientDiagnosesClinicOptionsGetErrors,
    ThrowOnError
  > =>
    (options?.client ?? client).get<
      GetPatientDiagnosesReportClinicOptionsReportsPatientDiagnosesClinicOptionsGetResponses,
      GetPatientDiagnosesReportClinicOptionsReportsPatientDiagnosesClinicOptionsGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/reports/patient-diagnoses/clinic-options',
      ...options,
    });

/**
 * Get Patient Diagnoses Report
 */
export const getPatientDiagnosesReportReportsPatientDiagnosesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetPatientDiagnosesReportReportsPatientDiagnosesGetData,
    ThrowOnError
  >
): RequestResult<
  GetPatientDiagnosesReportReportsPatientDiagnosesGetResponses,
  GetPatientDiagnosesReportReportsPatientDiagnosesGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetPatientDiagnosesReportReportsPatientDiagnosesGetResponses,
    GetPatientDiagnosesReportReportsPatientDiagnosesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/patient-diagnoses',
    ...options,
  });

/**
 * Export Patient Diagnoses Report
 */
export const exportPatientDiagnosesReportReportsPatientDiagnosesExportGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ExportPatientDiagnosesReportReportsPatientDiagnosesExportGetData,
    ThrowOnError
  >
): RequestResult<
  ExportPatientDiagnosesReportReportsPatientDiagnosesExportGetResponses,
  ExportPatientDiagnosesReportReportsPatientDiagnosesExportGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ExportPatientDiagnosesReportReportsPatientDiagnosesExportGetResponses,
    ExportPatientDiagnosesReportReportsPatientDiagnosesExportGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/reports/patient-diagnoses/export',
    ...options,
  });

/**
 * Get Patient Roster Clinic Options
 */
export const getPatientRosterClinicOptionsReportsPatientRosterClinicOptionsGet =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      GetPatientRosterClinicOptionsReportsPatientRosterClinicOptionsGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetPatientRosterClinicOptionsReportsPatientRosterClinicOptionsGetResponses,
    unknown,
    ThrowOnError
  > =>
    (options?.client ?? client).get<
      GetPatientRosterClinicOptionsReportsPatientRosterClinicOptionsGetResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/reports/patient-roster/clinic-options',
      ...options,
    });

/**
 * Get Patient Roster Report
 */
export const getPatientRosterReportReportsPatientRosterGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetPatientRosterReportReportsPatientRosterGetData,
    ThrowOnError
  >
): RequestResult<
  GetPatientRosterReportReportsPatientRosterGetResponses,
  GetPatientRosterReportReportsPatientRosterGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetPatientRosterReportReportsPatientRosterGetResponses,
    GetPatientRosterReportReportsPatientRosterGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/patient-roster',
    ...options,
  });

/**
 * Export Patient Roster Report
 */
export const exportPatientRosterReportReportsPatientRosterExportGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ExportPatientRosterReportReportsPatientRosterExportGetData,
    ThrowOnError
  >
): RequestResult<
  ExportPatientRosterReportReportsPatientRosterExportGetResponses,
  ExportPatientRosterReportReportsPatientRosterExportGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ExportPatientRosterReportReportsPatientRosterExportGetResponses,
    ExportPatientRosterReportReportsPatientRosterExportGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/reports/patient-roster/export',
    ...options,
  });

/**
 * Get Pcr Report
 */
export const getPcrReportReportsPcrGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetPcrReportReportsPcrGetData, ThrowOnError>
): RequestResult<
  GetPcrReportReportsPcrGetResponses,
  GetPcrReportReportsPcrGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetPcrReportReportsPcrGetResponses,
    GetPcrReportReportsPcrGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/pcr',
    ...options,
  });

/**
 * Export Pcr Report
 */
export const exportPcrReportReportsPcrExportGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ExportPcrReportReportsPcrExportGetData, ThrowOnError>
): RequestResult<
  ExportPcrReportReportsPcrExportGetResponses,
  ExportPcrReportReportsPcrExportGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ExportPcrReportReportsPcrExportGetResponses,
    ExportPcrReportReportsPcrExportGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/reports/pcr/export',
    ...options,
  });

/**
 * Get Open Oasis Report Options
 */
export const getOpenOasisReportOptionsReportsOpenOasisOptionsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetOpenOasisReportOptionsReportsOpenOasisOptionsGetData,
    ThrowOnError
  >
): RequestResult<
  GetOpenOasisReportOptionsReportsOpenOasisOptionsGetResponses,
  GetOpenOasisReportOptionsReportsOpenOasisOptionsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetOpenOasisReportOptionsReportsOpenOasisOptionsGetResponses,
    GetOpenOasisReportOptionsReportsOpenOasisOptionsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/open-oasis/options',
    ...options,
  });

/**
 * Get Open Oasis Report
 */
export const getOpenOasisReportReportsOpenOasisGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetOpenOasisReportReportsOpenOasisGetData, ThrowOnError>
): RequestResult<
  GetOpenOasisReportReportsOpenOasisGetResponses,
  GetOpenOasisReportReportsOpenOasisGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetOpenOasisReportReportsOpenOasisGetResponses,
    GetOpenOasisReportReportsOpenOasisGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/open-oasis',
    ...options,
  });

/**
 * Export Open Oasis Report
 */
export const exportOpenOasisReportReportsOpenOasisExportGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ExportOpenOasisReportReportsOpenOasisExportGetData,
    ThrowOnError
  >
): RequestResult<
  ExportOpenOasisReportReportsOpenOasisExportGetResponses,
  ExportOpenOasisReportReportsOpenOasisExportGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ExportOpenOasisReportReportsOpenOasisExportGetResponses,
    ExportOpenOasisReportReportsOpenOasisExportGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/reports/open-oasis/export',
    ...options,
  });

/**
 * Get Recertification Timing Options
 */
export const getRecertificationTimingOptionsReportsRecertificationTimingOptionsGet =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      GetRecertificationTimingOptionsReportsRecertificationTimingOptionsGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetRecertificationTimingOptionsReportsRecertificationTimingOptionsGetResponses,
    unknown,
    ThrowOnError
  > =>
    (options?.client ?? client).get<
      GetRecertificationTimingOptionsReportsRecertificationTimingOptionsGetResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/reports/recertification-timing/options',
      ...options,
    });

/**
 * Get Recertification Timing Report
 */
export const getRecertificationTimingReportReportsRecertificationTimingGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetRecertificationTimingReportReportsRecertificationTimingGetData,
    ThrowOnError
  >
): RequestResult<
  GetRecertificationTimingReportReportsRecertificationTimingGetResponses,
  GetRecertificationTimingReportReportsRecertificationTimingGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetRecertificationTimingReportReportsRecertificationTimingGetResponses,
    GetRecertificationTimingReportReportsRecertificationTimingGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/recertification-timing',
    ...options,
  });

/**
 * Export Recertification Timing Report
 */
export const exportRecertificationTimingReportReportsRecertificationTimingExportGet =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      ExportRecertificationTimingReportReportsRecertificationTimingExportGetData,
      ThrowOnError
    >
  ): RequestResult<
    ExportRecertificationTimingReportReportsRecertificationTimingExportGetResponses,
    ExportRecertificationTimingReportReportsRecertificationTimingExportGetErrors,
    ThrowOnError
  > =>
    (options?.client ?? client).get<
      ExportRecertificationTimingReportReportsRecertificationTimingExportGetResponses,
      ExportRecertificationTimingReportReportsRecertificationTimingExportGetErrors,
      ThrowOnError
    >({
      responseType: 'blob',
      url: '/reports/recertification-timing/export',
      ...options,
    });

/**
 * Get Rehospitalization Clinic Options
 */
export const getRehospitalizationClinicOptionsReportsRehospitalizationClinicOptionsGet =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      GetRehospitalizationClinicOptionsReportsRehospitalizationClinicOptionsGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetRehospitalizationClinicOptionsReportsRehospitalizationClinicOptionsGetResponses,
    unknown,
    ThrowOnError
  > =>
    (options?.client ?? client).get<
      GetRehospitalizationClinicOptionsReportsRehospitalizationClinicOptionsGetResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/reports/rehospitalization/clinic-options',
      ...options,
    });

/**
 * Get Rehospitalization Report
 */
export const getRehospitalizationReportReportsRehospitalizationGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetRehospitalizationReportReportsRehospitalizationGetData,
    ThrowOnError
  >
): RequestResult<
  GetRehospitalizationReportReportsRehospitalizationGetResponses,
  GetRehospitalizationReportReportsRehospitalizationGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetRehospitalizationReportReportsRehospitalizationGetResponses,
    GetRehospitalizationReportReportsRehospitalizationGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/rehospitalization',
    ...options,
  });

/**
 * Export Rehospitalization Report
 */
export const exportRehospitalizationReportReportsRehospitalizationExportGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ExportRehospitalizationReportReportsRehospitalizationExportGetData,
    ThrowOnError
  >
): RequestResult<
  ExportRehospitalizationReportReportsRehospitalizationExportGetResponses,
  ExportRehospitalizationReportReportsRehospitalizationExportGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ExportRehospitalizationReportReportsRehospitalizationExportGetResponses,
    ExportRehospitalizationReportReportsRehospitalizationExportGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/reports/rehospitalization/export',
    ...options,
  });

/**
 * Get Schedule Report Options
 */
export const getScheduleReportOptionsReportsScheduleOptionsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetScheduleReportOptionsReportsScheduleOptionsGetData,
    ThrowOnError
  >
): RequestResult<
  GetScheduleReportOptionsReportsScheduleOptionsGetResponses,
  GetScheduleReportOptionsReportsScheduleOptionsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetScheduleReportOptionsReportsScheduleOptionsGetResponses,
    GetScheduleReportOptionsReportsScheduleOptionsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/schedule/options',
    ...options,
  });

/**
 * Get Schedule Report
 */
export const getScheduleReportReportsScheduleGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetScheduleReportReportsScheduleGetData, ThrowOnError>
): RequestResult<
  GetScheduleReportReportsScheduleGetResponses,
  GetScheduleReportReportsScheduleGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetScheduleReportReportsScheduleGetResponses,
    GetScheduleReportReportsScheduleGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/schedule',
    ...options,
  });

/**
 * Export Schedule Report
 */
export const exportScheduleReportReportsScheduleExportGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ExportScheduleReportReportsScheduleExportGetData,
    ThrowOnError
  >
): RequestResult<
  ExportScheduleReportReportsScheduleExportGetResponses,
  ExportScheduleReportReportsScheduleExportGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ExportScheduleReportReportsScheduleExportGetResponses,
    ExportScheduleReportReportsScheduleExportGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/reports/schedule/export',
    ...options,
  });

/**
 * Get Schedule Deviation Report Options
 */
export const getScheduleDeviationReportOptionsReportsScheduleDeviationOptionsGet =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      GetScheduleDeviationReportOptionsReportsScheduleDeviationOptionsGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetScheduleDeviationReportOptionsReportsScheduleDeviationOptionsGetResponses,
    GetScheduleDeviationReportOptionsReportsScheduleDeviationOptionsGetErrors,
    ThrowOnError
  > =>
    (options?.client ?? client).get<
      GetScheduleDeviationReportOptionsReportsScheduleDeviationOptionsGetResponses,
      GetScheduleDeviationReportOptionsReportsScheduleDeviationOptionsGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/reports/schedule-deviation/options',
      ...options,
    });

/**
 * Get Schedule Deviation Report
 */
export const getScheduleDeviationReportReportsScheduleDeviationGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetScheduleDeviationReportReportsScheduleDeviationGetData,
    ThrowOnError
  >
): RequestResult<
  GetScheduleDeviationReportReportsScheduleDeviationGetResponses,
  GetScheduleDeviationReportReportsScheduleDeviationGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetScheduleDeviationReportReportsScheduleDeviationGetResponses,
    GetScheduleDeviationReportReportsScheduleDeviationGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/schedule-deviation',
    ...options,
  });

/**
 * Export Schedule Deviation Report
 */
export const exportScheduleDeviationReportReportsScheduleDeviationExportGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ExportScheduleDeviationReportReportsScheduleDeviationExportGetData,
    ThrowOnError
  >
): RequestResult<
  ExportScheduleDeviationReportReportsScheduleDeviationExportGetResponses,
  ExportScheduleDeviationReportReportsScheduleDeviationExportGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ExportScheduleDeviationReportReportsScheduleDeviationExportGetResponses,
    ExportScheduleDeviationReportReportsScheduleDeviationExportGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/reports/schedule-deviation/export',
    ...options,
  });

/**
 * Get User Onboarding Report
 */
export const getUserOnboardingReportReportsUserOnboardingGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetUserOnboardingReportReportsUserOnboardingGetData,
    ThrowOnError
  >
): RequestResult<
  GetUserOnboardingReportReportsUserOnboardingGetResponses,
  GetUserOnboardingReportReportsUserOnboardingGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetUserOnboardingReportReportsUserOnboardingGetResponses,
    GetUserOnboardingReportReportsUserOnboardingGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/user-onboarding',
    ...options,
  });

/**
 * Export User Onboarding Report
 */
export const exportUserOnboardingReportReportsUserOnboardingExportGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ExportUserOnboardingReportReportsUserOnboardingExportGetData,
    ThrowOnError
  >
): RequestResult<
  ExportUserOnboardingReportReportsUserOnboardingExportGetResponses,
  ExportUserOnboardingReportReportsUserOnboardingExportGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ExportUserOnboardingReportReportsUserOnboardingExportGetResponses,
    ExportUserOnboardingReportReportsUserOnboardingExportGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/reports/user-onboarding/export',
    ...options,
  });

/**
 * Get Census Report Clinic Options
 */
export const getCensusReportClinicOptionsReportsCensusClinicOptionsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetCensusReportClinicOptionsReportsCensusClinicOptionsGetData,
    ThrowOnError
  >
): RequestResult<
  GetCensusReportClinicOptionsReportsCensusClinicOptionsGetResponses,
  GetCensusReportClinicOptionsReportsCensusClinicOptionsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetCensusReportClinicOptionsReportsCensusClinicOptionsGetResponses,
    GetCensusReportClinicOptionsReportsCensusClinicOptionsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/census/clinic-options',
    ...options,
  });

/**
 * Get Census Report
 */
export const getCensusReportReportsCensusGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetCensusReportReportsCensusGetData, ThrowOnError>
): RequestResult<
  GetCensusReportReportsCensusGetResponses,
  GetCensusReportReportsCensusGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetCensusReportReportsCensusGetResponses,
    GetCensusReportReportsCensusGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/census',
    ...options,
  });

/**
 * Export Census Report
 */
export const exportCensusReportReportsCensusExportGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ExportCensusReportReportsCensusExportGetData, ThrowOnError>
): RequestResult<
  ExportCensusReportReportsCensusExportGetResponses,
  ExportCensusReportReportsCensusExportGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ExportCensusReportReportsCensusExportGetResponses,
    ExportCensusReportReportsCensusExportGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/reports/census/export',
    ...options,
  });

/**
 * Print Census Report
 */
export const printCensusReportReportsCensusPrintGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PrintCensusReportReportsCensusPrintGetData, ThrowOnError>
): RequestResult<
  PrintCensusReportReportsCensusPrintGetResponses,
  PrintCensusReportReportsCensusPrintGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    PrintCensusReportReportsCensusPrintGetResponses,
    PrintCensusReportReportsCensusPrintGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/reports/census/print',
    ...options,
  });

/**
 * Get Worklog Report Options
 */
export const getWorklogReportOptionsReportsWorklogOptionsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetWorklogReportOptionsReportsWorklogOptionsGetData,
    ThrowOnError
  >
): RequestResult<
  GetWorklogReportOptionsReportsWorklogOptionsGetResponses,
  GetWorklogReportOptionsReportsWorklogOptionsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetWorklogReportOptionsReportsWorklogOptionsGetResponses,
    GetWorklogReportOptionsReportsWorklogOptionsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/worklog/options',
    ...options,
  });

/**
 * Get Worklog Report
 */
export const getWorklogReportReportsWorklogGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetWorklogReportReportsWorklogGetData, ThrowOnError>
): RequestResult<
  GetWorklogReportReportsWorklogGetResponses,
  GetWorklogReportReportsWorklogGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetWorklogReportReportsWorklogGetResponses,
    GetWorklogReportReportsWorklogGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/worklog',
    ...options,
  });

/**
 * Export Worklog Report
 */
export const exportWorklogReportReportsWorklogExportGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ExportWorklogReportReportsWorklogExportGetData, ThrowOnError>
): RequestResult<
  ExportWorklogReportReportsWorklogExportGetResponses,
  ExportWorklogReportReportsWorklogExportGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ExportWorklogReportReportsWorklogExportGetResponses,
    ExportWorklogReportReportsWorklogExportGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/reports/worklog/export',
    ...options,
  });

/**
 * Get Wound Status Report Options
 */
export const getWoundStatusReportOptionsReportsWoundStatusOptionsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetWoundStatusReportOptionsReportsWoundStatusOptionsGetData,
    ThrowOnError
  >
): RequestResult<
  GetWoundStatusReportOptionsReportsWoundStatusOptionsGetResponses,
  GetWoundStatusReportOptionsReportsWoundStatusOptionsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetWoundStatusReportOptionsReportsWoundStatusOptionsGetResponses,
    GetWoundStatusReportOptionsReportsWoundStatusOptionsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/wound-status/options',
    ...options,
  });

/**
 * Get Wound Status Report
 */
export const getWoundStatusReportReportsWoundStatusGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetWoundStatusReportReportsWoundStatusGetData, ThrowOnError>
): RequestResult<
  GetWoundStatusReportReportsWoundStatusGetResponses,
  GetWoundStatusReportReportsWoundStatusGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetWoundStatusReportReportsWoundStatusGetResponses,
    GetWoundStatusReportReportsWoundStatusGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/wound-status',
    ...options,
  });

/**
 * Export Wound Status Report
 */
export const exportWoundStatusReportReportsWoundStatusExportGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ExportWoundStatusReportReportsWoundStatusExportGetData,
    ThrowOnError
  >
): RequestResult<
  ExportWoundStatusReportReportsWoundStatusExportGetResponses,
  ExportWoundStatusReportReportsWoundStatusExportGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ExportWoundStatusReportReportsWoundStatusExportGetResponses,
    ExportWoundStatusReportReportsWoundStatusExportGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/reports/wound-status/export',
    ...options,
  });

/**
 * Get Past Due Tasks Report Options
 */
export const getPastDueVisitsReportOptionsReportsPastDueVisitsOptionsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetPastDueVisitsReportOptionsReportsPastDueVisitsOptionsGetData,
    ThrowOnError
  >
): RequestResult<
  GetPastDueVisitsReportOptionsReportsPastDueVisitsOptionsGetResponses,
  GetPastDueVisitsReportOptionsReportsPastDueVisitsOptionsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetPastDueVisitsReportOptionsReportsPastDueVisitsOptionsGetResponses,
    GetPastDueVisitsReportOptionsReportsPastDueVisitsOptionsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/past-due-visits/options',
    ...options,
  });

/**
 * Get Past Due Tasks Report
 */
export const getPastDueVisitsReportReportsPastDueVisitsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetPastDueVisitsReportReportsPastDueVisitsGetData,
    ThrowOnError
  >
): RequestResult<
  GetPastDueVisitsReportReportsPastDueVisitsGetResponses,
  GetPastDueVisitsReportReportsPastDueVisitsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetPastDueVisitsReportReportsPastDueVisitsGetResponses,
    GetPastDueVisitsReportReportsPastDueVisitsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/past-due-visits',
    ...options,
  });

/**
 * Export Past Due Tasks Report
 */
export const exportPastDueVisitsReportReportsPastDueVisitsExportGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ExportPastDueVisitsReportReportsPastDueVisitsExportGetData,
    ThrowOnError
  >
): RequestResult<
  ExportPastDueVisitsReportReportsPastDueVisitsExportGetResponses,
  ExportPastDueVisitsReportReportsPastDueVisitsExportGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ExportPastDueVisitsReportReportsPastDueVisitsExportGetResponses,
    ExportPastDueVisitsReportReportsPastDueVisitsExportGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/reports/past-due-visits/export',
    ...options,
  });

/**
 * Get Marketing Report Options
 */
export const getMarketingReportOptionsReportsMarketingOptionsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetMarketingReportOptionsReportsMarketingOptionsGetData,
    ThrowOnError
  >
): RequestResult<
  GetMarketingReportOptionsReportsMarketingOptionsGetResponses,
  GetMarketingReportOptionsReportsMarketingOptionsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetMarketingReportOptionsReportsMarketingOptionsGetResponses,
    GetMarketingReportOptionsReportsMarketingOptionsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/marketing/options',
    ...options,
  });

/**
 * Get Marketing Report
 */
export const getMarketingReportReportsMarketingGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetMarketingReportReportsMarketingGetData, ThrowOnError>
): RequestResult<
  GetMarketingReportReportsMarketingGetResponses,
  GetMarketingReportReportsMarketingGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetMarketingReportReportsMarketingGetResponses,
    GetMarketingReportReportsMarketingGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/marketing',
    ...options,
  });

/**
 * Export Marketing Report
 */
export const exportMarketingReportReportsMarketingExportGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ExportMarketingReportReportsMarketingExportGetData,
    ThrowOnError
  >
): RequestResult<
  ExportMarketingReportReportsMarketingExportGetResponses,
  ExportMarketingReportReportsMarketingExportGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ExportMarketingReportReportsMarketingExportGetResponses,
    ExportMarketingReportReportsMarketingExportGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/reports/marketing/export',
    ...options,
  });

/**
 * Get Lupa Risk Options
 */
export const getLupaRiskOptionsReportsLupaRiskClinicOptionsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetLupaRiskOptionsReportsLupaRiskClinicOptionsGetData,
    ThrowOnError
  >
): RequestResult<
  GetLupaRiskOptionsReportsLupaRiskClinicOptionsGetResponses,
  GetLupaRiskOptionsReportsLupaRiskClinicOptionsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetLupaRiskOptionsReportsLupaRiskClinicOptionsGetResponses,
    GetLupaRiskOptionsReportsLupaRiskClinicOptionsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/lupa-risk/clinic-options',
    ...options,
  });

/**
 * Get Lupa Risk Report
 */
export const getLupaRiskReportReportsLupaRiskGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetLupaRiskReportReportsLupaRiskGetData, ThrowOnError>
): RequestResult<
  GetLupaRiskReportReportsLupaRiskGetResponses,
  GetLupaRiskReportReportsLupaRiskGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetLupaRiskReportReportsLupaRiskGetResponses,
    GetLupaRiskReportReportsLupaRiskGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/lupa-risk',
    ...options,
  });

/**
 * Export Lupa Risk Report
 */
export const exportLupaRiskReportReportsLupaRiskExportGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ExportLupaRiskReportReportsLupaRiskExportGetData,
    ThrowOnError
  >
): RequestResult<
  ExportLupaRiskReportReportsLupaRiskExportGetResponses,
  ExportLupaRiskReportReportsLupaRiskExportGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ExportLupaRiskReportReportsLupaRiskExportGetResponses,
    ExportLupaRiskReportReportsLupaRiskExportGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/reports/lupa-risk/export',
    ...options,
  });

/**
 * Get Late Starts Options
 */
export const getLateStartsOptionsReportsLateStartsOptionsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetLateStartsOptionsReportsLateStartsOptionsGetData,
    ThrowOnError
  >
): RequestResult<
  GetLateStartsOptionsReportsLateStartsOptionsGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetLateStartsOptionsReportsLateStartsOptionsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/late-starts/options',
    ...options,
  });

/**
 * Get Late Starts Report
 */
export const getLateStartsReportReportsLateStartsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetLateStartsReportReportsLateStartsGetData, ThrowOnError>
): RequestResult<
  GetLateStartsReportReportsLateStartsGetResponses,
  GetLateStartsReportReportsLateStartsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetLateStartsReportReportsLateStartsGetResponses,
    GetLateStartsReportReportsLateStartsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/late-starts',
    ...options,
  });

/**
 * Export Late Starts Report
 */
export const exportLateStartsReportReportsLateStartsExportGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ExportLateStartsReportReportsLateStartsExportGetData,
    ThrowOnError
  >
): RequestResult<
  ExportLateStartsReportReportsLateStartsExportGetResponses,
  ExportLateStartsReportReportsLateStartsExportGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ExportLateStartsReportReportsLateStartsExportGetResponses,
    ExportLateStartsReportReportsLateStartsExportGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/reports/late-starts/export',
    ...options,
  });

/**
 * Get Insurance Eligibility Options
 */
export const getInsuranceEligibilityOptionsReportsInsuranceEligibilityOptionsGet =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      GetInsuranceEligibilityOptionsReportsInsuranceEligibilityOptionsGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetInsuranceEligibilityOptionsReportsInsuranceEligibilityOptionsGetResponses,
    unknown,
    ThrowOnError
  > =>
    (options?.client ?? client).get<
      GetInsuranceEligibilityOptionsReportsInsuranceEligibilityOptionsGetResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/reports/insurance-eligibility/options',
      ...options,
    });

/**
 * Get Insurance Eligibility Report
 */
export const getInsuranceEligibilityReportReportsInsuranceEligibilityGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetInsuranceEligibilityReportReportsInsuranceEligibilityGetData,
    ThrowOnError
  >
): RequestResult<
  GetInsuranceEligibilityReportReportsInsuranceEligibilityGetResponses,
  GetInsuranceEligibilityReportReportsInsuranceEligibilityGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetInsuranceEligibilityReportReportsInsuranceEligibilityGetResponses,
    GetInsuranceEligibilityReportReportsInsuranceEligibilityGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/insurance-eligibility',
    ...options,
  });

/**
 * Export Insurance Eligibility Report
 */
export const exportInsuranceEligibilityReportReportsInsuranceEligibilityExportGet =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      ExportInsuranceEligibilityReportReportsInsuranceEligibilityExportGetData,
      ThrowOnError
    >
  ): RequestResult<
    ExportInsuranceEligibilityReportReportsInsuranceEligibilityExportGetResponses,
    ExportInsuranceEligibilityReportReportsInsuranceEligibilityExportGetErrors,
    ThrowOnError
  > =>
    (options?.client ?? client).get<
      ExportInsuranceEligibilityReportReportsInsuranceEligibilityExportGetResponses,
      ExportInsuranceEligibilityReportReportsInsuranceEligibilityExportGetErrors,
      ThrowOnError
    >({
      responseType: 'blob',
      url: '/reports/insurance-eligibility/export',
      ...options,
    });

/**
 * Get Bucket Status
 *
 * Get the status of the S3 bucket.
 */
export const getBucketStatusS3BucketStatusGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetBucketStatusS3BucketStatusGetData, ThrowOnError>
): RequestResult<
  GetBucketStatusS3BucketStatusGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetBucketStatusS3BucketStatusGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/s3/bucket/status',
    ...options,
  });

/**
 * Health Check
 *
 * Health check endpoint for Temporal integration.
 */
export const healthCheckTemporalHealthGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<HealthCheckTemporalHealthGetData, ThrowOnError>
): RequestResult<
  HealthCheckTemporalHealthGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    HealthCheckTemporalHealthGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/temporal/health',
    ...options,
  });

/**
 * Get Intake Form Schema
 *
 * Get the intake form schema.
 *
 * Returns the JSON schema that defines the intake form structure,
 * field definitions, and validation rules. Used by the frontend
 * to dynamically render the intake form.
 *
 * Returns:
 * The intake form schema as a dict
 */
export const getIntakeFormSchemaIntakeFormSchemaGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetIntakeFormSchemaIntakeFormSchemaGetData, ThrowOnError>
): RequestResult<
  GetIntakeFormSchemaIntakeFormSchemaGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetIntakeFormSchemaIntakeFormSchemaGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/form-schema',
    ...options,
  });

/**
 * Get Intake Extraction Prompt
 *
 * Get the current intake extraction prompt.
 *
 * Returns the LLM prompt used for extracting referral data from
 * intake documents, including field-specific instructions derived
 * from the intake schema.
 *
 * Returns:
 * Dict with 'prompt' key containing the extraction prompt
 */
export const getIntakeExtractionPromptIntakeExtractionPromptGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetIntakeExtractionPromptIntakeExtractionPromptGetData,
    ThrowOnError
  >
): RequestResult<
  GetIntakeExtractionPromptIntakeExtractionPromptGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetIntakeExtractionPromptIntakeExtractionPromptGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/extraction-prompt',
    ...options,
  });

/**
 * Upload File And Create Intake
 *
 * Upload a file directly through the backend and create an intake record.
 *
 * This endpoint handles the file upload through the backend to avoid CORS issues
 * with direct S3 uploads.
 *
 * Args:
 * file: The uploaded file
 * trigger_parsing: Whether to trigger the referral parsing workflow
 * fake_extraction: Dev-only (non-prod): skip the parsing workflow and fill
 * the intake with sample extraction data instead
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * IntakeCreateFromUploadResponse with created intake and parsing status
 */
export const uploadFileAndCreateIntakeIntakeUploadPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UploadFileAndCreateIntakeIntakeUploadPostData, ThrowOnError>
): RequestResult<
  UploadFileAndCreateIntakeIntakeUploadPostResponses,
  UploadFileAndCreateIntakeIntakeUploadPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UploadFileAndCreateIntakeIntakeUploadPostResponses,
    UploadFileAndCreateIntakeIntakeUploadPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/intake/upload',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Upload Multiple Files And Create Intake
 *
 * Upload multiple files and create a single intake record with multiple documents.
 *
 * This endpoint handles uploading multiple PDF files and creates one intake
 * with all documents attached.
 *
 * Args:
 * files: List of uploaded files
 * trigger_parsing: Whether to trigger the referral parsing workflow
 * parsing_strategy: Strategy for parsing multiple documents:
 * - "sequential": Process each document separately and merge results (default, processes all pages)
 * - "combined": Process all documents together in a single AI call
 * fake_extraction: Dev-only (non-prod): skip the parsing workflow and fill
 * the intake with sample extraction data instead
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * IntakeCreateFromUploadResponse with created intake and parsing status
 */
export const uploadMultipleFilesAndCreateIntakeIntakeUploadMultiplePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UploadMultipleFilesAndCreateIntakeIntakeUploadMultiplePostData,
    ThrowOnError
  >
): RequestResult<
  UploadMultipleFilesAndCreateIntakeIntakeUploadMultiplePostResponses,
  UploadMultipleFilesAndCreateIntakeIntakeUploadMultiplePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UploadMultipleFilesAndCreateIntakeIntakeUploadMultiplePostResponses,
    UploadMultipleFilesAndCreateIntakeIntakeUploadMultiplePostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/intake/upload-multiple',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Create Manual Intake
 *
 * Start a referral with no documents, for test patients or manual entry.
 *
 * No extraction is pending, so the intake is stored as processed: the intake
 * list and export then treat it as openable rather than in flight. It is
 * never extracted: documents added later are attached only.
 */
export const createManualIntakeIntakeManualPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<CreateManualIntakeIntakeManualPostData, ThrowOnError>
): RequestResult<
  CreateManualIntakeIntakeManualPostResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    CreateManualIntakeIntakeManualPostResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/manual',
    ...options,
  });

/**
 * Create Intake From Fax Documents
 *
 * Start one referral from one or more assembled fax documents.
 *
 * The documents are copied into the intake in the order they were named, and
 * extraction runs over them the way it does for an upload, so a referral that
 * arrived by fax reaches the Intake Manager without anyone downloading and
 * re-uploading it.
 */
export const createIntakeFromFaxDocumentsIntakeFromFaxDocumentsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateIntakeFromFaxDocumentsIntakeFromFaxDocumentsPostData,
    ThrowOnError
  >
): RequestResult<
  CreateIntakeFromFaxDocumentsIntakeFromFaxDocumentsPostResponses,
  CreateIntakeFromFaxDocumentsIntakeFromFaxDocumentsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateIntakeFromFaxDocumentsIntakeFromFaxDocumentsPostResponses,
    CreateIntakeFromFaxDocumentsIntakeFromFaxDocumentsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/from-fax-documents',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Auth Queue Endpoint
 *
 * Get intakes that need prior authorization work.
 *
 * Returns intakes that:
 * - Are not rejected
 * - Have eligibility check result (insurance_verified = True)
 * - Require prior auth (requires_prior_auth = True)
 * - Don't yet have prior auth (authorization_status is None or 'PENDING')
 *
 * Args:
 * limit: Maximum number of records to return
 * offset: Number of records to skip
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * List of IntakeResponse objects needing prior auth
 */
export const getAuthQueueEndpointIntakeAuthQueueGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetAuthQueueEndpointIntakeAuthQueueGetData, ThrowOnError>
): RequestResult<
  GetAuthQueueEndpointIntakeAuthQueueGetResponses,
  GetAuthQueueEndpointIntakeAuthQueueGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetAuthQueueEndpointIntakeAuthQueueGetResponses,
    GetAuthQueueEndpointIntakeAuthQueueGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/auth-queue',
    ...options,
  });

/**
 * Export Intakes Endpoint
 *
 * Export filtered intakes to an Excel (.xlsx) file.
 *
 * Omitting start_date/end_date applies no date filter, so the export covers
 * every intake the other filters match. Exports are capped at
 * INTAKE_EXPORT_ROW_LIMIT rows; a filter set matching more than that is
 * rejected with 400 rather than returning a silently truncated spreadsheet.
 */
export const exportIntakesEndpointIntakeExportGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ExportIntakesEndpointIntakeExportGetData, ThrowOnError>
): RequestResult<
  ExportIntakesEndpointIntakeExportGetResponses,
  ExportIntakesEndpointIntakeExportGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ExportIntakesEndpointIntakeExportGetResponses,
    ExportIntakesEndpointIntakeExportGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/export',
    ...options,
  });

/**
 * Delete Intake Endpoint
 *
 * Delete an intake record by ID.
 * NOTE: THIS CAN CURRENTLY BE TRIGGERED BY ANY USER. WILL ADD SECURITY AFTER WE
 * HAVE THE CONCEPT OF USER LOGIN IN FASTAPI.
 * Currently only verifies the intake belongs to that agency if user is authenticated
 *
 * An intake that created an admission, was pushed, or names a patient is
 * soft-deleted with its documents, and the files are kept: that packet is the
 * referral record. A draft that never reached a patient is removed with its
 * history and documents.
 *
 * Args:
 * intake_id: Intake ID to delete
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Raises:
 * HTTPException: If intake not found or access denied
 */
export const deleteIntakeEndpointIntakeIntakeIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteIntakeEndpointIntakeIntakeIdDeleteData, ThrowOnError>
): RequestResult<
  DeleteIntakeEndpointIntakeIntakeIdDeleteResponses,
  DeleteIntakeEndpointIntakeIntakeIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteIntakeEndpointIntakeIntakeIdDeleteResponses,
    DeleteIntakeEndpointIntakeIntakeIdDeleteErrors,
    ThrowOnError
  >({ url: '/intake/{intake_id}', ...options });

/**
 * Get Intake Endpoint
 *
 * Get an intake record by ID.
 *
 * Gated to ``intake:access`` on the user path; internal API-key callers are
 * admitted without a slug check.
 *
 * Args:
 * intake_id: Intake ID
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * IntakeResponse with intake data
 *
 * Raises:
 * HTTPException: If intake not found
 */
export const getIntakeEndpointIntakeIntakeIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetIntakeEndpointIntakeIntakeIdGetData, ThrowOnError>
): RequestResult<
  GetIntakeEndpointIntakeIntakeIdGetResponses,
  GetIntakeEndpointIntakeIntakeIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetIntakeEndpointIntakeIntakeIdGetResponses,
    GetIntakeEndpointIntakeIntakeIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}',
    ...options,
  });

/**
 * Update Intake Endpoint
 *
 * Update an intake record.
 * If user has an agency, verifies the intake belongs to that agency.
 *
 * Args:
 * intake_id: Intake ID
 * intake_update: Intake update data
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * Updated IntakeResponse
 *
 * Raises:
 * HTTPException: If intake not found
 */
export const updateIntakeEndpointIntakeIntakeIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateIntakeEndpointIntakeIntakeIdPutData, ThrowOnError>
): RequestResult<
  UpdateIntakeEndpointIntakeIntakeIdPutResponses,
  UpdateIntakeEndpointIntakeIntakeIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateIntakeEndpointIntakeIntakeIdPutResponses,
    UpdateIntakeEndpointIntakeIntakeIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Set Intake Test Status
 *
 * Mark or un-mark an intake as a test/practice record.
 *
 * Gated to ``intake:access`` (super-users pass via the RBAC short-circuit). The
 * marker propagates to the patient at push-to-EMR and short-circuits the
 * intake-time eligibility check, so it is set only here.
 */
export const setIntakeTestStatusIntakeIntakeIdTestStatusPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SetIntakeTestStatusIntakeIntakeIdTestStatusPatchData,
    ThrowOnError
  >
): RequestResult<
  SetIntakeTestStatusIntakeIntakeIdTestStatusPatchResponses,
  SetIntakeTestStatusIntakeIntakeIdTestStatusPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    SetIntakeTestStatusIntakeIntakeIdTestStatusPatchResponses,
    SetIntakeTestStatusIntakeIntakeIdTestStatusPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/test-status',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Intake Processing Status
 *
 * Get the current processing status of an intake's workflow.
 *
 * This queries the running Temporal workflow (if active) to get real-time
 * status without polling the database. The workflow exposes current stage,
 * progress percentage, activity name, and any error messages.
 *
 * Args:
 * intake_id: UUID of the intake
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * Current processing status from the workflow, or fallback status
 * if workflow is not running
 *
 * Raises:
 * HTTPException: If intake not found or not authorized
 */
export const getIntakeProcessingStatusIntakeIntakeIdProcessingStatusGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetIntakeProcessingStatusIntakeIntakeIdProcessingStatusGetData,
    ThrowOnError
  >
): RequestResult<
  GetIntakeProcessingStatusIntakeIntakeIdProcessingStatusGetResponses,
  GetIntakeProcessingStatusIntakeIntakeIdProcessingStatusGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetIntakeProcessingStatusIntakeIntakeIdProcessingStatusGetResponses,
    GetIntakeProcessingStatusIntakeIntakeIdProcessingStatusGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/processing-status',
    ...options,
  });

/**
 * Get Intakes Endpoint
 *
 * Get intake records with optional filtering and pagination.
 * If user has an agency, results are filtered to that agency.
 *
 * Unscoped list is gated to ``intake:access``. Calls with ``patient_id`` are
 * allowed for any authenticated agency user so the patient chart can load
 * referral docs.
 *
 * Args:
 * intake_status: Filter by intake status
 * patient_id: Filter by patient ID
 * search: Search term across patient, referral, insurance, clinic, assignee, and extracted field data
 * start_date: Start date filter (no date filter applied when omitted)
 * end_date: End date filter (no date filter applied when omitted)
 * clinic_id: Filter by clinic ID (agency_clinic_id)
 * page: Page number (1-indexed)
 * per_page: Number of items per page (default 25, max 100)
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * IntakeListResponse with paginated intake data
 */
export const getIntakesEndpointIntakeGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetIntakesEndpointIntakeGetData, ThrowOnError>
): RequestResult<
  GetIntakesEndpointIntakeGetResponses,
  GetIntakesEndpointIntakeGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetIntakesEndpointIntakeGetResponses,
    GetIntakesEndpointIntakeGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/',
    ...options,
  });

/**
 * Initialize Emr Selection Endpoint
 *
 * Initialize EMR selection when entering the Push to EMR step.
 *
 * This endpoint is called when a user navigates to the "Push to EMR" step.
 * If only one EMR option (Roger or Kinnser) is enabled via agency settings,
 * and no EMR selection has been made yet, it automatically sets the
 * appropriate push flag.
 *
 * Args:
 * intake_id: Intake ID
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * IntakeResponse with potentially updated EMR selection flags
 *
 * Raises:
 * HTTPException: If intake not found or access denied
 */
export const initializeEmrSelectionEndpointIntakeIntakeIdInitializeEmrSelectionPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      InitializeEmrSelectionEndpointIntakeIntakeIdInitializeEmrSelectionPostData,
      ThrowOnError
    >
  ): RequestResult<
    InitializeEmrSelectionEndpointIntakeIntakeIdInitializeEmrSelectionPostResponses,
    InitializeEmrSelectionEndpointIntakeIntakeIdInitializeEmrSelectionPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      InitializeEmrSelectionEndpointIntakeIntakeIdInitializeEmrSelectionPostResponses,
      InitializeEmrSelectionEndpointIntakeIntakeIdInitializeEmrSelectionPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/intake/{intake_id}/initialize-emr-selection',
      ...options,
    });

/**
 * Schedule In Kinnser
 *
 * Schedule an intake on an existing Kinnser patient+episode (task → upload → details).
 */
export const scheduleInKinnserIntakeIntakeIdScheduleInKinnserPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ScheduleInKinnserIntakeIntakeIdScheduleInKinnserPostData,
    ThrowOnError
  >
): RequestResult<
  ScheduleInKinnserIntakeIntakeIdScheduleInKinnserPostResponses,
  ScheduleInKinnserIntakeIntakeIdScheduleInKinnserPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ScheduleInKinnserIntakeIntakeIdScheduleInKinnserPostResponses,
    ScheduleInKinnserIntakeIntakeIdScheduleInKinnserPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/schedule_in_kinnser',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Auto Add In Kinnser
 *
 * Auto-add admission/episode (or episode) then upload docs and update task details.
 */
export const autoAddInKinnserIntakeIntakeIdAutoAddInKinnserPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AutoAddInKinnserIntakeIntakeIdAutoAddInKinnserPostData,
    ThrowOnError
  >
): RequestResult<
  AutoAddInKinnserIntakeIntakeIdAutoAddInKinnserPostResponses,
  AutoAddInKinnserIntakeIntakeIdAutoAddInKinnserPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AutoAddInKinnserIntakeIntakeIdAutoAddInKinnserPostResponses,
    AutoAddInKinnserIntakeIntakeIdAutoAddInKinnserPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/auto_add_in_kinnser',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Kinnser Upload Status
 *
 * Status of the async Kinnser document upload.
 *
 * Applies idempotent terminal transitions: an observed completed job marks
 * the intake PUSHED_TO_KINNSER; an observed permanent failure records
 * PUSH_FAILED. Transport errors return ``unknown`` and never write, so there
 * is no lock-on-exception wrapper (same as the onboard status route).
 */
export const getKinnserUploadStatusIntakeIntakeIdKinnserUploadStatusGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetKinnserUploadStatusIntakeIntakeIdKinnserUploadStatusGetData,
    ThrowOnError
  >
): RequestResult<
  GetKinnserUploadStatusIntakeIntakeIdKinnserUploadStatusGetResponses,
  GetKinnserUploadStatusIntakeIntakeIdKinnserUploadStatusGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKinnserUploadStatusIntakeIntakeIdKinnserUploadStatusGetResponses,
    GetKinnserUploadStatusIntakeIntakeIdKinnserUploadStatusGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/kinnser_upload_status',
    ...options,
  });

/**
 * Update Intake Fields Endpoint
 *
 * Update specific fields in the intake's JSONB 'fields' column.
 * Merges updates with existing fields rather than replacing.
 *
 * Args:
 * intake_id: Intake ID
 * field_updates: Dictionary of field names and values to update
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * Updated IntakeResponse
 *
 * Raises:
 * HTTPException: If intake not found or access denied
 */
export const updateIntakeFieldsEndpointIntakeIntakeIdFieldsPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateIntakeFieldsEndpointIntakeIntakeIdFieldsPatchData,
    ThrowOnError
  >
): RequestResult<
  UpdateIntakeFieldsEndpointIntakeIntakeIdFieldsPatchResponses,
  UpdateIntakeFieldsEndpointIntakeIntakeIdFieldsPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateIntakeFieldsEndpointIntakeIntakeIdFieldsPatchResponses,
    UpdateIntakeFieldsEndpointIntakeIntakeIdFieldsPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/fields',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Intake Status Endpoint
 *
 * Update intake status and create history record.
 * If user has an agency, verifies the intake belongs to that agency.
 *
 * Args:
 * intake_id: Intake ID
 * status_update: Status update data
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * Success message
 *
 * Raises:
 * HTTPException: If intake not found
 */
export const updateIntakeStatusEndpointIntakeIntakeIdStatusPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateIntakeStatusEndpointIntakeIntakeIdStatusPutData,
    ThrowOnError
  >
): RequestResult<
  UpdateIntakeStatusEndpointIntakeIntakeIdStatusPutResponses,
  UpdateIntakeStatusEndpointIntakeIntakeIdStatusPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateIntakeStatusEndpointIntakeIntakeIdStatusPutResponses,
    UpdateIntakeStatusEndpointIntakeIntakeIdStatusPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/status',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Reject Intake Endpoint
 *
 * Reject an intake with all required information in one atomic operation.
 *
 * This endpoint:
 * 1. Sets rejection_reason and rejection_details in the database
 * 2. Sets reviewed_date to current timestamp
 * 3. Sets reviewed_by to the current user
 * 4. Updates status to REJECTED
 *
 * Args:
 * intake_id: Intake ID
 * rejection_request: Rejection details
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * Success message with rejection details
 *
 * Raises:
 * HTTPException: If intake not found or access denied
 */
export const rejectIntakeEndpointIntakeIntakeIdRejectPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RejectIntakeEndpointIntakeIntakeIdRejectPutData,
    ThrowOnError
  >
): RequestResult<
  RejectIntakeEndpointIntakeIntakeIdRejectPutResponses,
  RejectIntakeEndpointIntakeIntakeIdRejectPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    RejectIntakeEndpointIntakeIntakeIdRejectPutResponses,
    RejectIntakeEndpointIntakeIntakeIdRejectPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/reject',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Confirm Tab Status Endpoint
 *
 * Confirm completion status for a specific intake workflow tab.
 *
 * This endpoint updates the tab_statuses JSONB field for a specific tab
 * and recomputes the global intake status based on the new tab statuses.
 *
 * Note: Tabs can be completed in any order. There is no enforced prerequisite
 * ordering - users may skip ahead or complete tabs out of sequence as needed
 * for their workflow.
 *
 * Special case: When push_to_emr tab is confirmed as 'complete', ALL tabs
 * are marked as complete (since the patient is now locked/created).
 *
 * Args:
 * intake_id: Intake ID
 * tab_key: Tab key (extraction, eligibility, prior_auth, ready_to_call, scheduling, push_to_emr)
 * tab_status_update: Status update data
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * Updated IntakeResponse
 *
 * Raises:
 * HTTPException: If intake not found or access denied
 */
export const confirmTabStatusEndpointIntakeIntakeIdTabTabKeyConfirmPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ConfirmTabStatusEndpointIntakeIntakeIdTabTabKeyConfirmPutData,
    ThrowOnError
  >
): RequestResult<
  ConfirmTabStatusEndpointIntakeIntakeIdTabTabKeyConfirmPutResponses,
  ConfirmTabStatusEndpointIntakeIntakeIdTabTabKeyConfirmPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    ConfirmTabStatusEndpointIntakeIntakeIdTabTabKeyConfirmPutResponses,
    ConfirmTabStatusEndpointIntakeIntakeIdTabTabKeyConfirmPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/tab/{tab_key}/confirm',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Referral Doc Presigned Url
 *
 * Get a presigned S3 URL for the intake's referral document (PDF).
 * If user has an agency, verifies the intake belongs to that agency.
 *
 * Args:
 * intake_id: Intake ID
 * db_session: Database session
 * ctx: Current context with user and agency information
 * Returns:
 * dict: { 'url': <presigned_url> }
 * Raises:
 * HTTPException: If intake or PDF is missing
 */
export const getReferralDocPresignedUrlIntakeIntakeIdReferralDocGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetReferralDocPresignedUrlIntakeIntakeIdReferralDocGetData,
    ThrowOnError
  >
): RequestResult<
  GetReferralDocPresignedUrlIntakeIntakeIdReferralDocGetResponses,
  GetReferralDocPresignedUrlIntakeIntakeIdReferralDocGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetReferralDocPresignedUrlIntakeIntakeIdReferralDocGetResponses,
    GetReferralDocPresignedUrlIntakeIntakeIdReferralDocGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/referral-doc',
    ...options,
  });

/**
 * Get Referral Docs Presigned Urls
 *
 * Get presigned S3 URLs for all of the intake's referral documents (PDFs).
 * If user has an agency, verifies the intake belongs to that agency.
 *
 * Args:
 * intake_id: Intake ID
 * db_session: Database session
 * ctx: Current context with user and agency information
 * Returns:
 * dict: { 'documents': [{ 'id': <doc_id>, 'file_name': <name>, 'url': <presigned_url> }, ...] }
 * Raises:
 * HTTPException: If intake is not found
 */
export const getReferralDocsPresignedUrlsIntakeIntakeIdReferralDocsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetReferralDocsPresignedUrlsIntakeIntakeIdReferralDocsGetData,
    ThrowOnError
  >
): RequestResult<
  GetReferralDocsPresignedUrlsIntakeIntakeIdReferralDocsGetResponses,
  GetReferralDocsPresignedUrlsIntakeIntakeIdReferralDocsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetReferralDocsPresignedUrlsIntakeIntakeIdReferralDocsGetResponses,
    GetReferralDocsPresignedUrlsIntakeIntakeIdReferralDocsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/referral-docs',
    ...options,
  });

/**
 * Get Intake Documents Name Dict
 *
 * Return a mapping of document upload names to display names for all documents
 * attached to the given intake. Upload name is the file path with the
 * referral_docs/ prefix stripped; display name is the document's file_name.
 */
export const getIntakeDocumentsNameDictIntakeIntakeIdDocumentsNameDictGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetIntakeDocumentsNameDictIntakeIntakeIdDocumentsNameDictGetData,
    ThrowOnError
  >
): RequestResult<
  GetIntakeDocumentsNameDictIntakeIntakeIdDocumentsNameDictGetResponses,
  GetIntakeDocumentsNameDictIntakeIntakeIdDocumentsNameDictGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetIntakeDocumentsNameDictIntakeIntakeIdDocumentsNameDictGetResponses,
    GetIntakeDocumentsNameDictIntakeIntakeIdDocumentsNameDictGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/documents/name_dict',
    ...options,
  });

/**
 * Delete Intake Document
 *
 * Soft-delete an intake document while preserving its S3 object.
 *
 * Extraction and post-extraction documents follow the same rule.
 */
export const deleteIntakeDocumentIntakeDocumentsDocumentIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteIntakeDocumentIntakeDocumentsDocumentIdDeleteData,
    ThrowOnError
  >
): RequestResult<
  DeleteIntakeDocumentIntakeDocumentsDocumentIdDeleteResponses,
  DeleteIntakeDocumentIntakeDocumentsDocumentIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteIntakeDocumentIntakeDocumentsDocumentIdDeleteResponses,
    DeleteIntakeDocumentIntakeDocumentsDocumentIdDeleteErrors,
    ThrowOnError
  >({ url: '/intake/documents/{document_id}', ...options });

/**
 * Update Intake Document
 *
 * Update an intake document's metadata (e.g., display filename).
 *
 * Args:
 * document_id: Document ID
 * request: Update request containing new file_name
 * db_session: Database session
 * ctx: Current context with user and agency information
 * Returns:
 * IntakeDocumentResponse: Updated document data
 * Raises:
 * HTTPException: If document is not found or access denied
 */
export const updateIntakeDocumentIntakeDocumentsDocumentIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateIntakeDocumentIntakeDocumentsDocumentIdPatchData,
    ThrowOnError
  >
): RequestResult<
  UpdateIntakeDocumentIntakeDocumentsDocumentIdPatchResponses,
  UpdateIntakeDocumentIntakeDocumentsDocumentIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateIntakeDocumentIntakeDocumentsDocumentIdPatchResponses,
    UpdateIntakeDocumentIntakeDocumentsDocumentIdPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/documents/{document_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Upload Document To Intake
 *
 * Upload a new document to an existing intake.
 *
 * Documents uploaded via this endpoint are marked with used_in_extraction=False
 * since they were added after the initial extraction.
 *
 * Args:
 * intake_id: The intake ID to add the document to
 * file: The uploaded PDF file
 * display_name: Optional display name (defaults to original filename)
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * IntakeDocumentResponse: The created document record
 */
export const uploadDocumentToIntakeIntakeIntakeIdDocumentsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UploadDocumentToIntakeIntakeIntakeIdDocumentsPostData,
    ThrowOnError
  >
): RequestResult<
  UploadDocumentToIntakeIntakeIntakeIdDocumentsPostResponses,
  UploadDocumentToIntakeIntakeIntakeIdDocumentsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UploadDocumentToIntakeIntakeIntakeIdDocumentsPostResponses,
    UploadDocumentToIntakeIntakeIntakeIdDocumentsPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/intake/{intake_id}/documents',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Stamp Intake Document
 *
 * Append a stamp page to an intake document PDF.
 *
 * The stamp page contains "Received by {initials} on {date}" centered on a
 * blank page, where initials come from the current user and date is today in
 * Pacific Time. The S3 object is overwritten in-place so the stamped PDF is
 * used for all downstream operations (push to EMR, etc.).
 */
export const stampIntakeDocumentIntakeDocumentsDocumentIdStampPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    StampIntakeDocumentIntakeDocumentsDocumentIdStampPostData,
    ThrowOnError
  >
): RequestResult<
  StampIntakeDocumentIntakeDocumentsDocumentIdStampPostResponses,
  StampIntakeDocumentIntakeDocumentsDocumentIdStampPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    StampIntakeDocumentIntakeDocumentsDocumentIdStampPostResponses,
    StampIntakeDocumentIntakeDocumentsDocumentIdStampPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/documents/{document_id}/stamp',
    ...options,
  });

/**
 * Reprocess Intake Endpoint
 *
 * Re-trigger the referral parsing workflow for an existing intake.
 *
 * This endpoint allows reprocessing of an intake's documents without
 * re-uploading the files. It collects all existing document S3 keys
 * and starts a new IntakeReferralParsingWorkflow.
 *
 * Args:
 * intake_id: ID of the intake to reprocess
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * IntakeReprocessResponse with workflow ID and status
 *
 * Raises:
 * HTTPException: If intake not found or reprocessing fails
 */
export const reprocessIntakeEndpointIntakeIntakeIdReprocessPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ReprocessIntakeEndpointIntakeIntakeIdReprocessPostData,
    ThrowOnError
  >
): RequestResult<
  ReprocessIntakeEndpointIntakeIntakeIdReprocessPostResponses,
  ReprocessIntakeEndpointIntakeIntakeIdReprocessPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ReprocessIntakeEndpointIntakeIntakeIdReprocessPostResponses,
    ReprocessIntakeEndpointIntakeIntakeIdReprocessPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/reprocess',
    ...options,
  });

/**
 * Get Episode Details Endpoint
 *
 * Get episode and admission details for a scheduled intake.
 *
 * Args:
 * intake_id: ID of the intake
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * Dictionary with episode and admission details
 *
 * Raises:
 * HTTPException: If intake not found or not scheduled
 */
export const getEpisodeDetailsEndpointIntakeIntakeIdEpisodeDetailsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetEpisodeDetailsEndpointIntakeIntakeIdEpisodeDetailsGetData,
    ThrowOnError
  >
): RequestResult<
  GetEpisodeDetailsEndpointIntakeIntakeIdEpisodeDetailsGetResponses,
  GetEpisodeDetailsEndpointIntakeIntakeIdEpisodeDetailsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetEpisodeDetailsEndpointIntakeIntakeIdEpisodeDetailsGetResponses,
    GetEpisodeDetailsEndpointIntakeIntakeIdEpisodeDetailsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/episode-details',
    ...options,
  });

/**
 * Onboard Patient Roger
 *
 * Onboard a patient to Roger EMR using an intake ID.
 * This is the final step of the intake process.
 */
export const onboardPatientRogerIntakeIntakeIdOnboardPatientRogerPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    OnboardPatientRogerIntakeIntakeIdOnboardPatientRogerPostData,
    ThrowOnError
  >
): RequestResult<
  OnboardPatientRogerIntakeIntakeIdOnboardPatientRogerPostResponses,
  OnboardPatientRogerIntakeIntakeIdOnboardPatientRogerPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OnboardPatientRogerIntakeIntakeIdOnboardPatientRogerPostResponses,
    OnboardPatientRogerIntakeIntakeIdOnboardPatientRogerPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/onboard_patient_roger',
    ...options,
  });

/**
 * Schedule Roger Existing Patient
 *
 * Schedule an admission/episode/visit on an EXISTING Roger patient for a matched intake.
 *
 * Unlike `onboard_patient_roger`, this never creates a new Patient. The exact records
 * created depend on `kinnser_visit_type` / `kinnser_creation_type` stored in intake.fields
 * (the `kinnser_` prefix is historical — these keys are shared by both Kinnser and Roger
 * scheduling flows):
 *
 * - SOC + new_admission:  Admission + Episode + Visit
 * - SOC + new_episode:    Episode + Visit on the patient's most recent Admission
 * - ROC:                  Visit (ROC*) on the patient's most recent Episode
 *
 * Intake documents are copied onto the patient on each call (same as onboarding).
 */
export const scheduleRogerExistingPatientIntakeIntakeIdScheduleRogerExistingPatientPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ScheduleRogerExistingPatientIntakeIntakeIdScheduleRogerExistingPatientPostData,
      ThrowOnError
    >
  ): RequestResult<
    ScheduleRogerExistingPatientIntakeIntakeIdScheduleRogerExistingPatientPostResponses,
    ScheduleRogerExistingPatientIntakeIntakeIdScheduleRogerExistingPatientPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      ScheduleRogerExistingPatientIntakeIntakeIdScheduleRogerExistingPatientPostResponses,
      ScheduleRogerExistingPatientIntakeIntakeIdScheduleRogerExistingPatientPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/intake/{intake_id}/schedule_roger_existing_patient',
      ...options,
    });

/**
 * List Intake Drafts
 *
 * Open drafts, for the Intake Manager and the fax inbox's patient picker.
 */
export const listIntakeDraftsIntakeDraftsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListIntakeDraftsIntakeDraftsGetData, ThrowOnError>
): RequestResult<
  ListIntakeDraftsIntakeDraftsGetResponses,
  ListIntakeDraftsIntakeDraftsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListIntakeDraftsIntakeDraftsGetResponses,
    ListIntakeDraftsIntakeDraftsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake-drafts',
    ...options,
  });

/**
 * Create Intake Draft
 *
 * Start a draft, or return the open one already using that name.
 */
export const createIntakeDraftIntakeDraftsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateIntakeDraftIntakeDraftsPostData, ThrowOnError>
): RequestResult<
  CreateIntakeDraftIntakeDraftsPostResponses,
  CreateIntakeDraftIntakeDraftsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateIntakeDraftIntakeDraftsPostResponses,
    CreateIntakeDraftIntakeDraftsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake-drafts',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove Intake Draft
 *
 * Abandon a draft, releasing its faxes back to the inbox.
 */
export const removeIntakeDraftIntakeDraftsDraftIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RemoveIntakeDraftIntakeDraftsDraftIdDeleteData, ThrowOnError>
): RequestResult<
  RemoveIntakeDraftIntakeDraftsDraftIdDeleteResponses,
  RemoveIntakeDraftIntakeDraftsDraftIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    RemoveIntakeDraftIntakeDraftsDraftIdDeleteResponses,
    RemoveIntakeDraftIntakeDraftsDraftIdDeleteErrors,
    ThrowOnError
  >({ url: '/intake-drafts/{draft_id}', ...options });

/**
 * Get Intake Draft
 *
 * One draft and everything gathered under it.
 */
export const getIntakeDraftIntakeDraftsDraftIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetIntakeDraftIntakeDraftsDraftIdGetData, ThrowOnError>
): RequestResult<
  GetIntakeDraftIntakeDraftsDraftIdGetResponses,
  GetIntakeDraftIntakeDraftsDraftIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetIntakeDraftIntakeDraftsDraftIdGetResponses,
    GetIntakeDraftIntakeDraftsDraftIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake-drafts/{draft_id}',
    ...options,
  });

/**
 * Rename Intake Draft
 *
 * Correct a draft's name.
 */
export const renameIntakeDraftIntakeDraftsDraftIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RenameIntakeDraftIntakeDraftsDraftIdPutData, ThrowOnError>
): RequestResult<
  RenameIntakeDraftIntakeDraftsDraftIdPutResponses,
  RenameIntakeDraftIntakeDraftsDraftIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    RenameIntakeDraftIntakeDraftsDraftIdPutResponses,
    RenameIntakeDraftIntakeDraftsDraftIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake-drafts/{draft_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Start Referral From Draft
 *
 * Turn a draft into a referral, with anything else the person added.
 */
export const startReferralFromDraftIntakeDraftsDraftIdReferralPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    StartReferralFromDraftIntakeDraftsDraftIdReferralPostData,
    ThrowOnError
  >
): RequestResult<
  StartReferralFromDraftIntakeDraftsDraftIdReferralPostResponses,
  StartReferralFromDraftIntakeDraftsDraftIdReferralPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    StartReferralFromDraftIntakeDraftsDraftIdReferralPostResponses,
    StartReferralFromDraftIntakeDraftsDraftIdReferralPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/intake-drafts/{draft_id}/referral',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Get Visit Type Options
 *
 * Return all visit types with metadata for the create-task UI.
 *
 * Legacy OASIS-E2 types are included with ``is_legacy=True``; the frontend
 * filters them out of creation pickers. Order types live behind
 * ``/orders/type-options``. The frontend merges both lists for the create-task UI.
 *
 * SN Visit w/ Supervisory Visit is omitted unless the agency has the
 * ``sn-visit-with-supervisory-visit`` flag, and SN Visit w/ Discharge Summary
 * unless it has ``sn-visit-with-discharge-summary``. Reads the flags already resolved
 * at auth time rather than calling WorkOS, matching ``require_payroll_feature``.
 * This hides the alias from every create-task picker, which all read this
 * endpoint; it does not reject a create, and visits already charted keep
 * rendering normally.
 */
export const getVisitTypeOptionsVisitsTypeOptionsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetVisitTypeOptionsVisitsTypeOptionsGetData, ThrowOnError>
): RequestResult<
  GetVisitTypeOptionsVisitsTypeOptionsGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetVisitTypeOptionsVisitsTypeOptionsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/type-options',
    ...options,
  });

/**
 * Get Missed Visit Options
 *
 * Reason + notification-method options (value + display label, in display
 * order) for the missed-visit form.
 *
 * The labels come from ``MISSED_VISIT_REASON_LABELS`` /
 * ``NOTIFICATION_METHOD_LABELS`` in ``app.models.enum.visit`` — the single
 * source of truth shared with the missed-visit print view — so the on-screen
 * form and the printed PDF render identical copy.
 */
export const getMissedVisitOptionsVisitsMissedVisitOptionsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetMissedVisitOptionsVisitsMissedVisitOptionsGetData,
    ThrowOnError
  >
): RequestResult<
  GetMissedVisitOptionsVisitsMissedVisitOptionsGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetMissedVisitOptionsVisitsMissedVisitOptionsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/missed-visit-options',
    ...options,
  });

/**
 * Get My Tasks
 *
 * Legacy Hotbox work queue route retained for generated client compatibility.
 */
export const getMyTasksVisitsMyTasksGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetMyTasksVisitsMyTasksGetData, ThrowOnError>
): RequestResult<
  GetMyTasksVisitsMyTasksGetResponses,
  GetMyTasksVisitsMyTasksGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetMyTasksVisitsMyTasksGetResponses,
    GetMyTasksVisitsMyTasksGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/my-tasks',
    ...options,
  });

/**
 * Validate Oasis
 *
 * Validate OASIS answers using the same derived field enrichment as export.
 */
export const validateOasisVisitsVisitIdValidateOasisPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ValidateOasisVisitsVisitIdValidateOasisPostData,
    ThrowOnError
  >
): RequestResult<
  ValidateOasisVisitsVisitIdValidateOasisPostResponses,
  ValidateOasisVisitsVisitIdValidateOasisPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ValidateOasisVisitsVisitIdValidateOasisPostResponses,
    ValidateOasisVisitsVisitIdValidateOasisPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/validateOasis',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Restore Qa Scrubber Item
 *
 * Restore a dismissed QA scrubber finding so it counts again.
 */
export const restoreQaScrubberItemVisitsVisitIdQaScrubberRuleIdDismissDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RestoreQaScrubberItemVisitsVisitIdQaScrubberRuleIdDismissDeleteData,
    ThrowOnError
  >
): RequestResult<
  RestoreQaScrubberItemVisitsVisitIdQaScrubberRuleIdDismissDeleteResponses,
  RestoreQaScrubberItemVisitsVisitIdQaScrubberRuleIdDismissDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    RestoreQaScrubberItemVisitsVisitIdQaScrubberRuleIdDismissDeleteResponses,
    RestoreQaScrubberItemVisitsVisitIdQaScrubberRuleIdDismissDeleteErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/qa-scrubber/{rule_id}/dismiss',
    ...options,
  });

/**
 * Dismiss Qa Scrubber Item
 *
 * Dismiss one QA scrubber finding on this visit so it stops counting.
 */
export const dismissQaScrubberItemVisitsVisitIdQaScrubberRuleIdDismissPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DismissQaScrubberItemVisitsVisitIdQaScrubberRuleIdDismissPostData,
    ThrowOnError
  >
): RequestResult<
  DismissQaScrubberItemVisitsVisitIdQaScrubberRuleIdDismissPostResponses,
  DismissQaScrubberItemVisitsVisitIdQaScrubberRuleIdDismissPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DismissQaScrubberItemVisitsVisitIdQaScrubberRuleIdDismissPostResponses,
    DismissQaScrubberItemVisitsVisitIdQaScrubberRuleIdDismissPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/qa-scrubber/{rule_id}/dismiss',
    ...options,
  });

/**
 * Precheck Oasis Batch
 *
 * Validate an OASIS batch through CMS iQIES before the agency downloads it.
 *
 * Builds the exact archive ``/exportOasis/batch`` would return and submits it to
 * the CMS Validation Utility Tool. Anything CMS rejects raises
 * ``OasisVutValidationError`` so the caller can name the patients and skip the
 * download entirely.
 *
 * Charts our own CMS scrubber already knows will fail are refused first, with
 * ``OasisCmsFatalErrorsExportError``, without asking CMS.
 *
 * Fails open: if CMS is unreachable this returns ``vut_available=False`` rather
 * than an error, because an outage at CMS must not block an agency's submission
 * deadline. The Slack notification is what keeps that from being silent.
 */
export const precheckOasisBatchVisitsExportOasisPrecheckPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PrecheckOasisBatchVisitsExportOasisPrecheckPostData,
    ThrowOnError
  >
): RequestResult<
  PrecheckOasisBatchVisitsExportOasisPrecheckPostResponses,
  PrecheckOasisBatchVisitsExportOasisPrecheckPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PrecheckOasisBatchVisitsExportOasisPrecheckPostResponses,
    PrecheckOasisBatchVisitsExportOasisPrecheckPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/exportOasis/precheck',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Export Oasis Batch
 *
 * Export multiple OASIS assessments as a ZIP archive.
 */
export const exportOasisBatchVisitsExportOasisBatchPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ExportOasisBatchVisitsExportOasisBatchPostData, ThrowOnError>
): RequestResult<
  ExportOasisBatchVisitsExportOasisBatchPostResponses,
  ExportOasisBatchVisitsExportOasisBatchPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ExportOasisBatchVisitsExportOasisBatchPostResponses,
    ExportOasisBatchVisitsExportOasisBatchPostErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/visits/exportOasis/batch',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Preview Shp Batch
 *
 * Download the XML the next nightly SHP run would send, as a ZIP.
 *
 * Nothing is sent to SHP and nothing is recorded. One file per SHP batch.
 */
export const previewShpBatchVisitsOasisManagerShpBatchPreviewGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    PreviewShpBatchVisitsOasisManagerShpBatchPreviewGetData,
    ThrowOnError
  >
): RequestResult<
  PreviewShpBatchVisitsOasisManagerShpBatchPreviewGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    PreviewShpBatchVisitsOasisManagerShpBatchPreviewGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/visits/oasis-manager/shp-batch-preview',
    ...options,
  });

/**
 * Download Shp Sent Xml
 *
 * Download the CMS OASIS record Roger last sent to SHP for this chart.
 *
 * The record the batch SHP accepted carried for it, as a file of its own,
 * so it can be uploaded again. 404 for a chart of another agency, never
 * sent, or sent before Roger kept the XML.
 */
export const downloadShpSentXmlVisitsOasisManagerVisitIdShpSentXmlGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DownloadShpSentXmlVisitsOasisManagerVisitIdShpSentXmlGetData,
    ThrowOnError
  >
): RequestResult<
  DownloadShpSentXmlVisitsOasisManagerVisitIdShpSentXmlGetResponses,
  DownloadShpSentXmlVisitsOasisManagerVisitIdShpSentXmlGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    DownloadShpSentXmlVisitsOasisManagerVisitIdShpSentXmlGetResponses,
    DownloadShpSentXmlVisitsOasisManagerVisitIdShpSentXmlGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/visits/oasis-manager/{visit_id}/shp-sent-xml',
    ...options,
  });

/**
 * Get Oasis Shp Last Check
 *
 * The latest SHP check of this chart (null when none was run) and the
 * reason the nightly run would never send it, as the OASIS Manager row has it.
 */
export const getOasisShpLastCheckVisitsOasisManagerVisitIdShpCheckGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetOasisShpLastCheckVisitsOasisManagerVisitIdShpCheckGetData,
    ThrowOnError
  >
): RequestResult<
  GetOasisShpLastCheckVisitsOasisManagerVisitIdShpCheckGetResponses,
  GetOasisShpLastCheckVisitsOasisManagerVisitIdShpCheckGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetOasisShpLastCheckVisitsOasisManagerVisitIdShpCheckGetResponses,
    GetOasisShpLastCheckVisitsOasisManagerVisitIdShpCheckGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/oasis-manager/{visit_id}/shp-check',
    ...options,
  });

/**
 * Run Oasis Shp Check
 *
 * Send this one assessment to SHP and return SHP's alert link for it.
 *
 * The record is the one the nightly run would send. 409 with a ``code`` when
 * the check cannot run; a chart with CMS export errors comes back with them
 * in ``readiness`` and nothing is sent; 502 when SHP refused it or did not
 * answer, and then no check is recorded.
 */
export const runOasisShpCheckVisitsOasisManagerVisitIdShpCheckPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RunOasisShpCheckVisitsOasisManagerVisitIdShpCheckPostData,
    ThrowOnError
  >
): RequestResult<
  RunOasisShpCheckVisitsOasisManagerVisitIdShpCheckPostResponses,
  RunOasisShpCheckVisitsOasisManagerVisitIdShpCheckPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RunOasisShpCheckVisitsOasisManagerVisitIdShpCheckPostResponses,
    RunOasisShpCheckVisitsOasisManagerVisitIdShpCheckPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/oasis-manager/{visit_id}/shp-check',
    ...options,
  });

/**
 * Get Oasis Export Readiness
 *
 * Which of these OASIS charts CMS will reject, and why.
 *
 * The OASIS Manager asks for the rows on screen after the list loads, so a
 * slow scrub never holds the list up. Empty when the agency has switched the
 * export check off; the export endpoints enforce the same answer. The nightly
 * SHP batch does not read it: a chart with CMS errors still goes to SHP.
 */
export const getOasisExportReadinessVisitsOasisManagerExportReadinessPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetOasisExportReadinessVisitsOasisManagerExportReadinessPostData,
    ThrowOnError
  >
): RequestResult<
  GetOasisExportReadinessVisitsOasisManagerExportReadinessPostResponses,
  GetOasisExportReadinessVisitsOasisManagerExportReadinessPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GetOasisExportReadinessVisitsOasisManagerExportReadinessPostResponses,
    GetOasisExportReadinessVisitsOasisManagerExportReadinessPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/oasis-manager/export-readiness',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Oasis Manager Visits
 *
 * List OASIS visits for the OASIS Manager page.
 */
export const listOasisManagerVisitsVisitsOasisManagerGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ListOasisManagerVisitsVisitsOasisManagerGetData,
    ThrowOnError
  >
): RequestResult<
  ListOasisManagerVisitsVisitsOasisManagerGetResponses,
  ListOasisManagerVisitsVisitsOasisManagerGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListOasisManagerVisitsVisitsOasisManagerGetResponses,
    ListOasisManagerVisitsVisitsOasisManagerGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/oasis-manager',
    ...options,
  });

/**
 * Mark Visits Exported
 *
 * Mark completed OASIS visits as exported (uploaded to iQIES).
 */
export const markVisitsExportedVisitsMarkExportedPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MarkVisitsExportedVisitsMarkExportedPostData, ThrowOnError>
): RequestResult<
  MarkVisitsExportedVisitsMarkExportedPostResponses,
  MarkVisitsExportedVisitsMarkExportedPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    MarkVisitsExportedVisitsMarkExportedPostResponses,
    MarkVisitsExportedVisitsMarkExportedPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/mark-exported',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Unmark Visits Exported
 *
 * Revert exported OASIS visits back to completed status.
 */
export const unmarkVisitsExportedVisitsUnmarkExportedPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UnmarkVisitsExportedVisitsUnmarkExportedPostData,
    ThrowOnError
  >
): RequestResult<
  UnmarkVisitsExportedVisitsUnmarkExportedPostResponses,
  UnmarkVisitsExportedVisitsUnmarkExportedPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UnmarkVisitsExportedVisitsUnmarkExportedPostResponses,
    UnmarkVisitsExportedVisitsUnmarkExportedPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/unmark-exported',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Visits By Clinician
 *
 * Get visits assigned to a specific clinician for the current agency.
 *
 * Args:
 * clinician_id: Clinician account UUID
 * db_session: Database session
 * ctx: Current context for agency-based access control
 * limit: Maximum number of visits to return
 * offset: Number of visits to skip for pagination
 *
 * Returns:
 * List of visits assigned to the clinician
 *
 * Raises:
 * HTTPException: If clinician not found or not accessible by current agency
 */
export const getVisitsByClinicianVisitsByClinicianClinicianIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetVisitsByClinicianVisitsByClinicianClinicianIdGetData,
    ThrowOnError
  >
): RequestResult<
  GetVisitsByClinicianVisitsByClinicianClinicianIdGetResponses,
  GetVisitsByClinicianVisitsByClinicianClinicianIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetVisitsByClinicianVisitsByClinicianClinicianIdGetResponses,
    GetVisitsByClinicianVisitsByClinicianClinicianIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/by-clinician/{clinician_id}',
    ...options,
  });

/**
 * Delete Visit
 *
 * Delete a visit.
 *
 * Args:
 * visit_id: Visit UUID
 * db_session: Database session
 * ctx: Current context for agency-based access control
 *
 * Raises:
 * HTTPException: If visit not found or not accessible by current agency
 */
export const deleteVisitVisitsVisitIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteVisitVisitsVisitIdDeleteData, ThrowOnError>
): RequestResult<
  DeleteVisitVisitsVisitIdDeleteResponses,
  DeleteVisitVisitsVisitIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteVisitVisitsVisitIdDeleteResponses,
    DeleteVisitVisitsVisitIdDeleteErrors,
    ThrowOnError
  >({ url: '/visits/{visit_id}', ...options });

/**
 * Get Visit
 *
 * Get a specific visit by ID.
 *
 * Args:
 * visit_id: Visit UUID
 * include_deleted: Resolve soft-deleted visits as well
 * db_session: Database session
 *
 * Returns:
 * Visit details including visit_data and visit_data_last_updated
 *
 * Raises:
 * HTTPException: If visit not found or not accessible by current agency
 */
export const getVisitVisitsVisitIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetVisitVisitsVisitIdGetData, ThrowOnError>
): RequestResult<
  GetVisitVisitsVisitIdGetResponses,
  GetVisitVisitsVisitIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetVisitVisitsVisitIdGetResponses,
    GetVisitVisitsVisitIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}',
    ...options,
  });

/**
 * Update Visit
 *
 * Update visit basic information.
 *
 * Args:
 * visit_id: Visit UUID
 * visit_update: Updated visit information
 * db_session: Database session
 * ctx: Current context for agency-based access control
 *
 * Returns:
 * Updated visit details
 *
 * Raises:
 * HTTPException: If visit not found or not accessible by current agency
 */
export const updateVisitVisitsVisitIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateVisitVisitsVisitIdPutData, ThrowOnError>
): RequestResult<
  UpdateVisitVisitsVisitIdPutResponses,
  UpdateVisitVisitsVisitIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateVisitVisitsVisitIdPutResponses,
    UpdateVisitVisitsVisitIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Visit Work Log
 *
 * Return the visit's work log: lifecycle events reconstructed from audit rows.
 *
 * Consecutive events of the same type by the same actor are collapsed into a
 * single entry (see ``compact_work_log``), oldest first.
 *
 * ``include_deleted`` only widens the existence check above the log itself. The
 * entries come from audit rows, which are never soft-deleted, so a deleted
 * visit's log reads exactly as it did before the deletion, with the delete
 * recorded as its last event.
 */
export const getVisitWorkLogVisitsVisitIdWorkLogGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetVisitWorkLogVisitsVisitIdWorkLogGetData, ThrowOnError>
): RequestResult<
  GetVisitWorkLogVisitsVisitIdWorkLogGetResponses,
  GetVisitWorkLogVisitsVisitIdWorkLogGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetVisitWorkLogVisitsVisitIdWorkLogGetResponses,
    GetVisitWorkLogVisitsVisitIdWorkLogGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/work-log',
    ...options,
  });

/**
 * Remove Visit Evv
 *
 * Remove (cancel) a visit's EVV verification.
 *
 * Soft-deletes the verification (``removed_at`` / ``removed_by_id``) so the
 * captured data is retained for audit and a new reading can be taken. A visit
 * with no verification returns 404. Gated by the ``evv:remove`` permission.
 */
export const removeVisitEvvVisitsVisitIdEvvDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RemoveVisitEvvVisitsVisitIdEvvDeleteData, ThrowOnError>
): RequestResult<
  RemoveVisitEvvVisitsVisitIdEvvDeleteResponses,
  RemoveVisitEvvVisitsVisitIdEvvDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    RemoveVisitEvvVisitsVisitIdEvvDeleteResponses,
    RemoveVisitEvvVisitsVisitIdEvvDeleteErrors,
    ThrowOnError
  >({ url: '/visits/{visit_id}/evv', ...options });

/**
 * Get Visit Evv Readings
 *
 * Return a visit's EVV readings next to the ground truth.
 *
 * Read-only. Pairs what the clinician's device recorded (clock in/out time,
 * GPS, patient signature) with what we independently know — the times written
 * on the visit form and the patient's home address — so QA can spot a
 * misreported visit. Deltas are computed here so the comparison is defined in
 * one place.
 *
 * Most visits have no EVV data; `has_evv_data` is false for those and the rest
 * of the payload is empty.
 */
export const getVisitEvvReadingsVisitsVisitIdEvvGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetVisitEvvReadingsVisitsVisitIdEvvGetData, ThrowOnError>
): RequestResult<
  GetVisitEvvReadingsVisitsVisitIdEvvGetResponses,
  GetVisitEvvReadingsVisitsVisitIdEvvGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetVisitEvvReadingsVisitsVisitIdEvvGetResponses,
    GetVisitEvvReadingsVisitsVisitIdEvvGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/evv',
    ...options,
  });

/**
 * Create Visit
 *
 * Create a new visit.
 *
 * Args:
 * visit_create: Visit creation data
 * db_session: Database session
 * ctx: Current context for agency-based access control
 *
 * Returns:
 * Created visit details
 *
 * Raises:
 * HTTPException: If episode not found or not accessible by current agency
 */
export const createVisitVisitsPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateVisitVisitsPostData, ThrowOnError>
): RequestResult<
  CreateVisitVisitsPostResponses,
  CreateVisitVisitsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateVisitVisitsPostResponses,
    CreateVisitVisitsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Visit Data
 *
 * Get only the visit_data for a specific visit.
 *
 * Args:
 * visit_id: Visit UUID
 * db_session: Database session
 * ctx: Current context for agency-based access control
 *
 * Returns:
 * Dictionary containing visit_data and visit_data_last_updated
 *
 * Raises:
 * HTTPException: If visit not found or not accessible by current agency
 */
export const getVisitDataVisitsVisitIdDataGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetVisitDataVisitsVisitIdDataGetData, ThrowOnError>
): RequestResult<
  GetVisitDataVisitsVisitIdDataGetResponses,
  GetVisitDataVisitsVisitIdDataGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetVisitDataVisitsVisitIdDataGetResponses,
    GetVisitDataVisitsVisitIdDataGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/data',
    ...options,
  });

/**
 * Update Visit Data
 *
 * Update visit data with optimistic concurrency control.
 *
 * Uses visit_data_last_updated for optimistic locking to prevent concurrent edit conflicts.
 *
 * Args:
 * visit_id: Visit UUID
 * visit_update: Updated visit data and last updated timestamp
 * db_session: Database session
 * ctx: Current context for agency-based access control
 *
 * Returns:
 * Updated visit with new visit_data_last_updated timestamp
 *
 * Raises:
 * HTTPException: If visit not found, not accessible, or update is stale
 */
export const updateVisitDataVisitsVisitIdDataPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateVisitDataVisitsVisitIdDataPutData, ThrowOnError>
): RequestResult<
  UpdateVisitDataVisitsVisitIdDataPutResponses,
  UpdateVisitDataVisitsVisitIdDataPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateVisitDataVisitsVisitIdDataPutResponses,
    UpdateVisitDataVisitsVisitIdDataPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/data',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Visit Task Detail Answers
 *
 * Save the form's answers to the questions whose values live in Task Details.
 *
 * The same people who may save the chart may call this, while the chart is
 * editable. It is not a chart save: no signature is invalidated and the
 * chart's timestamp does not move, so mileage logged late holds nothing up.
 * When the agency locks visit note billing codes, a routine visit's location
 * of care and HCPCS change only for Task Details editors; a change from anyone
 * else is refused with ``error_code`` ``billing_codes_locked`` and writes nothing.
 */
export const updateVisitTaskDetailAnswersVisitsVisitIdTaskDetailAnswersPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateVisitTaskDetailAnswersVisitsVisitIdTaskDetailAnswersPutData,
    ThrowOnError
  >
): RequestResult<
  UpdateVisitTaskDetailAnswersVisitsVisitIdTaskDetailAnswersPutResponses,
  UpdateVisitTaskDetailAnswersVisitsVisitIdTaskDetailAnswersPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateVisitTaskDetailAnswersVisitsVisitIdTaskDetailAnswersPutResponses,
    UpdateVisitTaskDetailAnswersVisitsVisitIdTaskDetailAnswersPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/task-detail-answers',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Visit External Answers
 *
 * Answers from other documents for this visit's `external-answer` nodes.
 *
 * Keyed `source -> qid -> answer`. Read-only, and nothing here is ever written
 * back to this visit: the values belong to the source document.
 *
 * Deliberately its own endpoint rather than a field on `VisitResponse`. That
 * response is also built for every row of the calendar and task lists, so
 * resolving an episode-scoped source there would run this lookup for hundreds of
 * visits to serve data only the open chart reads.
 */
export const getVisitExternalAnswersVisitsVisitIdExternalAnswersGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetVisitExternalAnswersVisitsVisitIdExternalAnswersGetData,
    ThrowOnError
  >
): RequestResult<
  GetVisitExternalAnswersVisitsVisitIdExternalAnswersGetResponses,
  GetVisitExternalAnswersVisitsVisitIdExternalAnswersGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetVisitExternalAnswersVisitsVisitIdExternalAnswersGetResponses,
    GetVisitExternalAnswersVisitsVisitIdExternalAnswersGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/external-answers',
    ...options,
  });

/**
 * Get Carryover Sources
 *
 * Prior visits whose answers can be carried into this visit.
 *
 * Read-only. Scoped to the target visit's admission and to routine visits of
 * the target's own form type, so source and target always share a form schema
 * and their answers line up by qid.
 */
export const getCarryoverSourcesVisitsVisitIdCarryoverSourcesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetCarryoverSourcesVisitsVisitIdCarryoverSourcesGetData,
    ThrowOnError
  >
): RequestResult<
  GetCarryoverSourcesVisitsVisitIdCarryoverSourcesGetResponses,
  GetCarryoverSourcesVisitsVisitIdCarryoverSourcesGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetCarryoverSourcesVisitsVisitIdCarryoverSourcesGetResponses,
    GetCarryoverSourcesVisitsVisitIdCarryoverSourcesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/carryover/sources',
    ...options,
  });

/**
 * Get Carryover Preview
 *
 * The answers that would be staged from ``source_visit_id``.
 *
 * Strictly read-only: the caller stages these client-side so the clinician can
 * review them, and commits with a normal visit-data save. Nothing here writes
 * to the target visit, so no signature is invalidated and no work-log entry is
 * produced until the clinician actually commits.
 */
export const getCarryoverPreviewVisitsVisitIdCarryoverPreviewGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetCarryoverPreviewVisitsVisitIdCarryoverPreviewGetData,
    ThrowOnError
  >
): RequestResult<
  GetCarryoverPreviewVisitsVisitIdCarryoverPreviewGetResponses,
  GetCarryoverPreviewVisitsVisitIdCarryoverPreviewGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetCarryoverPreviewVisitsVisitIdCarryoverPreviewGetResponses,
    GetCarryoverPreviewVisitsVisitIdCarryoverPreviewGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/carryover/preview',
    ...options,
  });

/**
 * Update Active Diagnoses Data
 *
 * Update active diagnoses comorbidity data (M1028) for a visit.
 */
export const updateActiveDiagnosesDataVisitsVisitIdActiveDiagnosesDataPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateActiveDiagnosesDataVisitsVisitIdActiveDiagnosesDataPutData,
    ThrowOnError
  >
): RequestResult<
  UpdateActiveDiagnosesDataVisitsVisitIdActiveDiagnosesDataPutResponses,
  UpdateActiveDiagnosesDataVisitsVisitIdActiveDiagnosesDataPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateActiveDiagnosesDataVisitsVisitIdActiveDiagnosesDataPutResponses,
    UpdateActiveDiagnosesDataVisitsVisitIdActiveDiagnosesDataPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/active-diagnoses-data',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Visit Pdf
 *
 * Generate and return a PDF report for a visit.
 *
 * For a missed visit, renders the documented missed-visit details instead
 * of the (empty) assessment chart. Otherwise fetches the question schema
 * from RogerDoc and renders the visit data as a PDF with sections and
 * questions.
 *
 * Args:
 * visit_id: Visit UUID
 * include_deleted: Resolve soft-deleted visits as well
 * db_session: Database session
 * ctx: Current context for agency-based access control
 *
 * Returns:
 * PDF file as application/pdf response
 *
 * Raises:
 * HTTPException: If visit not found, schema unavailable, or PDF generation fails
 */
export const getVisitPdfVisitsVisitIdPdfGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetVisitPdfVisitsVisitIdPdfGetData, ThrowOnError>
): RequestResult<
  GetVisitPdfVisitsVisitIdPdfGetResponses,
  GetVisitPdfVisitsVisitIdPdfGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetVisitPdfVisitsVisitIdPdfGetResponses,
    GetVisitPdfVisitsVisitIdPdfGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/visits/{visit_id}/pdf',
    ...options,
  });

/**
 * Get Visit Pdf Revision
 *
 * Render the chart's print view as it stood at a past point in time.
 *
 * Reconstructs the visit's form answers, task metadata, diagnoses,
 * comorbidities, and wounds/assessments as of ``as_of`` from the ``zz_``
 * audit-history tables, then renders the standard chart print view. Goals are
 * not yet reconstructed and are omitted so present-day goals are never shown on
 * a historical revision. A chart with no ``zz_`` history at or before ``as_of``
 * (it predates audit coverage) is reported as unavailable with a 422 rather
 * than rendered from present-day values (see ``visit_chart_revision``).
 */
export const getVisitPdfRevisionVisitsVisitIdPdfRevisionGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetVisitPdfRevisionVisitsVisitIdPdfRevisionGetData,
    ThrowOnError
  >
): RequestResult<
  GetVisitPdfRevisionVisitsVisitIdPdfRevisionGetResponses,
  GetVisitPdfRevisionVisitsVisitIdPdfRevisionGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetVisitPdfRevisionVisitsVisitIdPdfRevisionGetResponses,
    GetVisitPdfRevisionVisitsVisitIdPdfRevisionGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/visits/{visit_id}/pdf-revision',
    ...options,
  });

/**
 * Unmark Visit As Missed
 *
 * Unmark a missed visit: deletes missed_visit_data row, restores original billable_status.
 *
 * Deleting the missed_visit_data row clears Visit.is_missed, which is what
 * brings the visit back into billing-cycle logic; required_for_billing is not
 * touched here.
 */
export const unmarkVisitAsMissedVisitsVisitIdMarkMissedDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UnmarkVisitAsMissedVisitsVisitIdMarkMissedDeleteData,
    ThrowOnError
  >
): RequestResult<
  UnmarkVisitAsMissedVisitsVisitIdMarkMissedDeleteResponses,
  UnmarkVisitAsMissedVisitsVisitIdMarkMissedDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    UnmarkVisitAsMissedVisitsVisitIdMarkMissedDeleteResponses,
    UnmarkVisitAsMissedVisitsVisitIdMarkMissedDeleteErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/mark-missed',
    ...options,
  });

/**
 * Mark Visit As Missed
 *
 * Mark a visit as missed: creates missed_visit_data row, sets billable_status=NON_BILLABLE.
 *
 * The missed_visit_data row (via Visit.is_missed) is what excludes the visit
 * from billing-cycle logic; required_for_billing is left untouched so it keeps
 * its "skip readiness checks" meaning.
 */
export const markVisitAsMissedVisitsVisitIdMarkMissedPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MarkVisitAsMissedVisitsVisitIdMarkMissedPostData,
    ThrowOnError
  >
): RequestResult<
  MarkVisitAsMissedVisitsVisitIdMarkMissedPostResponses,
  MarkVisitAsMissedVisitsVisitIdMarkMissedPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    MarkVisitAsMissedVisitsVisitIdMarkMissedPostResponses,
    MarkVisitAsMissedVisitsVisitIdMarkMissedPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/mark-missed',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Missed Visit Data
 *
 * Update fields on an existing missed_visit_data row.
 */
export const updateMissedVisitDataVisitsVisitIdMissedDataPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateMissedVisitDataVisitsVisitIdMissedDataPatchData,
    ThrowOnError
  >
): RequestResult<
  UpdateMissedVisitDataVisitsVisitIdMissedDataPatchResponses,
  UpdateMissedVisitDataVisitsVisitIdMissedDataPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateMissedVisitDataVisitsVisitIdMissedDataPatchResponses,
    UpdateMissedVisitDataVisitsVisitIdMissedDataPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/missed-data',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Set Visit Authorization
 *
 * Link, switch, or unlink a visit's authorization.
 */
export const setVisitAuthorizationVisitsVisitIdAuthorizationPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SetVisitAuthorizationVisitsVisitIdAuthorizationPatchData,
    ThrowOnError
  >
): RequestResult<
  SetVisitAuthorizationVisitsVisitIdAuthorizationPatchResponses,
  SetVisitAuthorizationVisitsVisitIdAuthorizationPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    SetVisitAuthorizationVisitsVisitIdAuthorizationPatchResponses,
    SetVisitAuthorizationVisitsVisitIdAuthorizationPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/authorization',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Visit Type Change Options
 *
 * Aliases this visit can be renamed to without losing charted data.
 *
 * Empty when the visit's alias has no interchangeable siblings, which the UI
 * reads as "hide the Change task type action" — the check lives here rather
 * than in the client so the two can't disagree about what is switchable.
 *
 * Narrowed to the siblings this agency also treats the same way for billing,
 * so the list never offers a rename the change endpoint would then refuse.
 */
export const getVisitTypeChangeOptionsVisitsVisitIdTypeOptionsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetVisitTypeChangeOptionsVisitsVisitIdTypeOptionsGetData,
    ThrowOnError
  >
): RequestResult<
  GetVisitTypeChangeOptionsVisitsVisitIdTypeOptionsGetResponses,
  GetVisitTypeChangeOptionsVisitsVisitIdTypeOptionsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetVisitTypeChangeOptionsVisitsVisitIdTypeOptionsGetResponses,
    GetVisitTypeChangeOptionsVisitsVisitIdTypeOptionsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/type-options',
    ...options,
  });

/**
 * Change Visit Type
 *
 * Rename a visit to another alias sharing its form schema.
 *
 * Raises 404 when the visit is missing and 409 (with a ``ConflictCode``) when
 * the target alias is not interchangeable or the visit is locked, billed, or
 * marked missed.
 */
export const changeVisitTypeVisitsVisitIdTypePatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ChangeVisitTypeVisitsVisitIdTypePatchData, ThrowOnError>
): RequestResult<
  ChangeVisitTypeVisitsVisitIdTypePatchResponses,
  ChangeVisitTypeVisitsVisitIdTypePatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    ChangeVisitTypeVisitsVisitIdTypePatchResponses,
    ChangeVisitTypeVisitsVisitIdTypePatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/type',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Set Visit Order Not Required
 *
 * Mark an evaluation as needing no physician signature order, or undo it.
 *
 * Marking deletes the order its completion raised; unmarking a completed
 * evaluation raises it again. Raises 404 when the visit is missing, 422 when
 * the visit is not an evaluation that raises one, and 409 (with a
 * ``ConflictCode``) when marking would remove an order that has already left
 * To Be Sent. Unmarking is never refused over the order's status.
 */
export const setVisitOrderNotRequiredVisitsVisitIdOrderNotRequiredPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SetVisitOrderNotRequiredVisitsVisitIdOrderNotRequiredPatchData,
    ThrowOnError
  >
): RequestResult<
  SetVisitOrderNotRequiredVisitsVisitIdOrderNotRequiredPatchResponses,
  SetVisitOrderNotRequiredVisitsVisitIdOrderNotRequiredPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    SetVisitOrderNotRequiredVisitsVisitIdOrderNotRequiredPatchResponses,
    SetVisitOrderNotRequiredVisitsVisitIdOrderNotRequiredPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/order-not-required',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Visit Evv Capture Context
 */
export const getVisitEvvCaptureContextVisitsVisitIdEvvCaptureContextGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetVisitEvvCaptureContextVisitsVisitIdEvvCaptureContextGetData,
    ThrowOnError
  >
): RequestResult<
  GetVisitEvvCaptureContextVisitsVisitIdEvvCaptureContextGetResponses,
  GetVisitEvvCaptureContextVisitsVisitIdEvvCaptureContextGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetVisitEvvCaptureContextVisitsVisitIdEvvCaptureContextGetResponses,
    GetVisitEvvCaptureContextVisitsVisitIdEvvCaptureContextGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/evv/capture-context',
    ...options,
  });

/**
 * Capture Visit Evv Clock In
 */
export const captureVisitEvvClockInVisitsVisitIdEvvClockInPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CaptureVisitEvvClockInVisitsVisitIdEvvClockInPostData,
    ThrowOnError
  >
): RequestResult<
  CaptureVisitEvvClockInVisitsVisitIdEvvClockInPostResponses,
  CaptureVisitEvvClockInVisitsVisitIdEvvClockInPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CaptureVisitEvvClockInVisitsVisitIdEvvClockInPostResponses,
    CaptureVisitEvvClockInVisitsVisitIdEvvClockInPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/evv/clock-in',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Capture Visit Evv Clock Out
 */
export const captureVisitEvvClockOutVisitsVisitIdEvvClockOutPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CaptureVisitEvvClockOutVisitsVisitIdEvvClockOutPostData,
    ThrowOnError
  >
): RequestResult<
  CaptureVisitEvvClockOutVisitsVisitIdEvvClockOutPostResponses,
  CaptureVisitEvvClockOutVisitsVisitIdEvvClockOutPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CaptureVisitEvvClockOutVisitsVisitIdEvvClockOutPostResponses,
    CaptureVisitEvvClockOutVisitsVisitIdEvvClockOutPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/evv/clock-out',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Capture Visit Evv Signature
 */
export const captureVisitEvvSignatureVisitsVisitIdEvvSignaturePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CaptureVisitEvvSignatureVisitsVisitIdEvvSignaturePostData,
    ThrowOnError
  >
): RequestResult<
  CaptureVisitEvvSignatureVisitsVisitIdEvvSignaturePostResponses,
  CaptureVisitEvvSignatureVisitsVisitIdEvvSignaturePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CaptureVisitEvvSignatureVisitsVisitIdEvvSignaturePostResponses,
    CaptureVisitEvvSignatureVisitsVisitIdEvvSignaturePostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/visits/{visit_id}/evv/signature',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Get Visit Evv Capture Readings
 *
 * Return assigned-visit EVV evidence for Hotbox capture or review.
 */
export const getVisitEvvCaptureReadingsVisitsVisitIdEvvCaptureViewGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetVisitEvvCaptureReadingsVisitsVisitIdEvvCaptureViewGetData,
    ThrowOnError
  >
): RequestResult<
  GetVisitEvvCaptureReadingsVisitsVisitIdEvvCaptureViewGetResponses,
  GetVisitEvvCaptureReadingsVisitsVisitIdEvvCaptureViewGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetVisitEvvCaptureReadingsVisitsVisitIdEvvCaptureViewGetResponses,
    GetVisitEvvCaptureReadingsVisitsVisitIdEvvCaptureViewGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/evv/capture-view',
    ...options,
  });

/**
 * List Visit Diagnoses
 */
export const listVisitDiagnosesVisitsVisitIdDiagnosesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListVisitDiagnosesVisitsVisitIdDiagnosesGetData,
    ThrowOnError
  >
): RequestResult<
  ListVisitDiagnosesVisitsVisitIdDiagnosesGetResponses,
  ListVisitDiagnosesVisitsVisitIdDiagnosesGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListVisitDiagnosesVisitsVisitIdDiagnosesGetResponses,
    ListVisitDiagnosesVisitsVisitIdDiagnosesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/diagnoses',
    ...options,
  });

/**
 * Create Visit Diagnosis
 */
export const createVisitDiagnosisVisitsVisitIdDiagnosesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateVisitDiagnosisVisitsVisitIdDiagnosesPostData,
    ThrowOnError
  >
): RequestResult<
  CreateVisitDiagnosisVisitsVisitIdDiagnosesPostResponses,
  CreateVisitDiagnosisVisitsVisitIdDiagnosesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateVisitDiagnosisVisitsVisitIdDiagnosesPostResponses,
    CreateVisitDiagnosisVisitsVisitIdDiagnosesPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/diagnoses',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Diagnosis Review
 *
 * The episode's in-force diagnoses for a note that displays but never records them.
 *
 * Read-only by construction: this resolves the most recent OASIS on the
 * episode and returns *its* rows. Nothing here writes to ``visit_diagnoses``,
 * and it must stay that way -- the billing worksheet handler overwrites
 * ``diagnosis_codes`` from any completed visit that owns rows, so giving this
 * note its own copy would let a discharge summary outrank the assessment the
 * codes came from.
 *
 * 404s for a visit type without the module rather than returning an empty
 * list, so a caller that asks the wrong note learns it is asking the wrong
 * note.
 */
export const listDiagnosisReviewVisitsVisitIdDiagnosisReviewGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListDiagnosisReviewVisitsVisitIdDiagnosisReviewGetData,
    ThrowOnError
  >
): RequestResult<
  ListDiagnosisReviewVisitsVisitIdDiagnosisReviewGetResponses,
  ListDiagnosisReviewVisitsVisitIdDiagnosisReviewGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListDiagnosisReviewVisitsVisitIdDiagnosisReviewGetResponses,
    ListDiagnosisReviewVisitsVisitIdDiagnosisReviewGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/diagnosis-review',
    ...options,
  });

/**
 * Delete Visit Diagnosis
 */
export const deleteVisitDiagnosisVisitsDiagnosesDiagnosisIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteVisitDiagnosisVisitsDiagnosesDiagnosisIdDeleteData,
    ThrowOnError
  >
): RequestResult<
  DeleteVisitDiagnosisVisitsDiagnosesDiagnosisIdDeleteResponses,
  DeleteVisitDiagnosisVisitsDiagnosesDiagnosisIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteVisitDiagnosisVisitsDiagnosesDiagnosisIdDeleteResponses,
    DeleteVisitDiagnosisVisitsDiagnosesDiagnosisIdDeleteErrors,
    ThrowOnError
  >({ url: '/visits/diagnoses/{diagnosis_id}', ...options });

/**
 * Update Visit Diagnosis
 */
export const updateVisitDiagnosisVisitsDiagnosesDiagnosisIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateVisitDiagnosisVisitsDiagnosesDiagnosisIdPutData,
    ThrowOnError
  >
): RequestResult<
  UpdateVisitDiagnosisVisitsDiagnosesDiagnosisIdPutResponses,
  UpdateVisitDiagnosisVisitsDiagnosesDiagnosisIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateVisitDiagnosisVisitsDiagnosesDiagnosisIdPutResponses,
    UpdateVisitDiagnosisVisitsDiagnosesDiagnosisIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/diagnoses/{diagnosis_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Diagnosis Positions
 */
export const updateDiagnosisPositionsVisitsVisitIdDiagnosesPositionsPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateDiagnosisPositionsVisitsVisitIdDiagnosesPositionsPutData,
    ThrowOnError
  >
): RequestResult<
  UpdateDiagnosisPositionsVisitsVisitIdDiagnosesPositionsPutResponses,
  UpdateDiagnosisPositionsVisitsVisitIdDiagnosesPositionsPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateDiagnosisPositionsVisitsVisitIdDiagnosesPositionsPutResponses,
    UpdateDiagnosisPositionsVisitsVisitIdDiagnosesPositionsPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/diagnoses/positions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Diagnosis Codes Route
 */
export const searchDiagnosisCodesRouteDiagnosisCodesSearchGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SearchDiagnosisCodesRouteDiagnosisCodesSearchGetData,
    ThrowOnError
  >
): RequestResult<
  SearchDiagnosisCodesRouteDiagnosisCodesSearchGetResponses,
  SearchDiagnosisCodesRouteDiagnosisCodesSearchGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    SearchDiagnosisCodesRouteDiagnosisCodesSearchGetResponses,
    SearchDiagnosisCodesRouteDiagnosisCodesSearchGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/diagnosis-codes/search',
    ...options,
  });

/**
 * Diagnosis Code Fitness Route
 *
 * Principal-diagnosis fitness for codes the caller already holds.
 *
 * A POST because the code list is the payload, not a filter; the reference
 * table is global, so no agency scoping applies beyond requiring a session.
 * Episode and visit lookups stay agency-scoped through the ORM filter.
 *
 * Codes are judged against the release in force on ``as_of``.
 * Codes not valid then also get the CMS conversion table's replacements in
 * ``successors_by_code``, as suggestions.
 *
 * A claim period carries two dates. Validity, the replacements
 * and ``release_id`` follow ``as_of``, the Through date: codes valid after
 * an ICD-10 update are reported on a claim that spans it (Medicare Claims
 * Processing Manual Ch.10 §80.2). Principal fitness follows
 * ``claim_from_date``: its grouper version's tables judge each code, and on
 * a spanning period a code those tables lack is judged as its one-hop
 * predecessor, as the HH Grouper maps it (``span_predecessor_by_code`` names
 * each substitution). Replacement chips are judged by the same rule. A From
 * date before the first bundled grouper keeps the ``as_of`` verdict; see
 * ``lookup_claim_primary_fitness``.
 */
export const diagnosisCodeFitnessRouteDiagnosisCodesFitnessPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DiagnosisCodeFitnessRouteDiagnosisCodesFitnessPostData,
    ThrowOnError
  >
): RequestResult<
  DiagnosisCodeFitnessRouteDiagnosisCodesFitnessPostResponses,
  DiagnosisCodeFitnessRouteDiagnosisCodesFitnessPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DiagnosisCodeFitnessRouteDiagnosisCodesFitnessPostResponses,
    DiagnosisCodeFitnessRouteDiagnosisCodesFitnessPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/diagnosis-codes/fitness',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Roger Doc Form Type Catalog
 *
 * Roger Doc form types for schema tooling (`visit.iter_roger_doc_form_type_catalog`).
 */
export const getRogerDocFormTypeCatalogRogerdocFormTypeCatalogGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetRogerDocFormTypeCatalogRogerdocFormTypeCatalogGetData,
    ThrowOnError
  >
): RequestResult<
  GetRogerDocFormTypeCatalogRogerdocFormTypeCatalogGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetRogerDocFormTypeCatalogRogerdocFormTypeCatalogGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/form-type-catalog',
    ...options,
  });

/**
 * Get Question Customizations Catalog
 *
 * Return the complete RogerDocs catalog and current agency selection.
 */
export const getQuestionCustomizations = <ThrowOnError extends boolean = false>(
  options?: Options<GetQuestionCustomizationsData, ThrowOnError>
): RequestResult<GetQuestionCustomizationsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetQuestionCustomizationsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/question-customizations',
    ...options,
  });

/**
 * Replace Question Customizations
 *
 * Replace the current agency's ordered RogerDocs question additions.
 */
export const replaceQuestionCustomizations = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ReplaceQuestionCustomizationsData, ThrowOnError>
): RequestResult<
  ReplaceQuestionCustomizationsResponses,
  ReplaceQuestionCustomizationsErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    ReplaceQuestionCustomizationsResponses,
    ReplaceQuestionCustomizationsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/question-customizations',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Question Schema
 *
 * Get the question schema from Roger Calls API.
 *
 * This schema is used to generate dynamic forms for visit data collection.
 *
 * Args:
 * visit_type: VisitTypeId to get schema for (must map to a RogerDocFormType)
 * ctx: Current context for authentication
 *
 * Returns:
 * Question schema dictionary from Roger Calls API
 *
 * Raises:
 * HTTPException: If visit type has no Roger Doc schema, API is unavailable,
 * or authentication fails
 */
export const getQuestionSchemaRogerdocQuestionSchemaGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetQuestionSchemaRogerdocQuestionSchemaGetData, ThrowOnError>
): RequestResult<
  GetQuestionSchemaRogerdocQuestionSchemaGetResponses,
  GetQuestionSchemaRogerdocQuestionSchemaGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetQuestionSchemaRogerdocQuestionSchemaGetResponses,
    GetQuestionSchemaRogerdocQuestionSchemaGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/question-schema',
    ...options,
  });

/**
 * Get Versioned Question Schema
 *
 * Build a ready-to-render versioned schema for a visit type.
 *
 * Proxies `POST /form-schemas/by-form-type/{form_type}` on RogerDoc. An optional
 * body can specify `schema_version` (`name` / `version`) for exact lookup or
 * `as_of` for historical resolution; omitting the body returns the newest
 * currently-effective version.
 */
export const getVersionedQuestionSchemaRogerdocV2QuestionSchemaPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetVersionedQuestionSchemaRogerdocV2QuestionSchemaPostData,
    ThrowOnError
  >
): RequestResult<
  GetVersionedQuestionSchemaRogerdocV2QuestionSchemaPostResponses,
  GetVersionedQuestionSchemaRogerdocV2QuestionSchemaPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GetVersionedQuestionSchemaRogerdocV2QuestionSchemaPostResponses,
    GetVersionedQuestionSchemaRogerdocV2QuestionSchemaPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/v2/question-schema',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Visit Schema
 *
 * Return the form schema for a specific visit.
 *
 * Resolves the pin in the same order as visit creation:
 * 1. EXPLICIT_FORM_SCHEMA_PINS constant (source of truth for now)
 * 2. Stored pin on the visit record (form_schema_version_name / form_schema_version)
 *
 * Returns 422 if neither source has a pin. There is no fallback to newest version.
 */
export const getVisitSchemaRogerdocV2VisitsVisitIdSchemaGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetVisitSchemaRogerdocV2VisitsVisitIdSchemaGetData,
    ThrowOnError
  >
): RequestResult<
  GetVisitSchemaRogerdocV2VisitsVisitIdSchemaGetResponses,
  GetVisitSchemaRogerdocV2VisitsVisitIdSchemaGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetVisitSchemaRogerdocV2VisitsVisitIdSchemaGetResponses,
    GetVisitSchemaRogerdocV2VisitsVisitIdSchemaGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/v2/visits/{visit_id}/schema',
    ...options,
  });

/**
 * Get Current Form Schema Versions
 *
 * List currently-effective schema versions for a visit type.
 *
 * Proxies `GET /form-schemas/by-form-type/{form_type}/current` on RogerDoc.
 * Returns every version whose effective range covers `as_of` (defaults to now),
 * suitable for populating a picker. Use an entry's `name` + `version` with
 * `POST /v2/question-schema` to fetch its full form tree.
 *
 * Optional ``emr_type`` is forwarded to RogerDoc so filtering happens at the
 * Docs catalog boundary (Forms Manager passes ``rogeremr``). Omit for the
 * unfiltered list.
 */
export const getCurrentFormSchemaVersionsRogerdocFormSchemasCurrentGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetCurrentFormSchemaVersionsRogerdocFormSchemasCurrentGetData,
    ThrowOnError
  >
): RequestResult<
  GetCurrentFormSchemaVersionsRogerdocFormSchemasCurrentGetResponses,
  GetCurrentFormSchemaVersionsRogerdocFormSchemasCurrentGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetCurrentFormSchemaVersionsRogerdocFormSchemasCurrentGetResponses,
    GetCurrentFormSchemaVersionsRogerdocFormSchemasCurrentGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/form-schemas/current',
    ...options,
  });

/**
 * Check Rogerdoc Health
 *
 * Check if Roger-Doc service is available and authentication works.
 *
 * Returns:
 * Health status information
 */
export const checkRogerdocHealthRogerdocHealthGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<CheckRogerdocHealthRogerdocHealthGetData, ThrowOnError>
): RequestResult<
  CheckRogerdocHealthRogerdocHealthGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    CheckRogerdocHealthRogerdocHealthGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/health',
    ...options,
  });

/**
 * Get Coding Upload Urls
 *
 * Generate presigned URLs for uploading files for medical coding.
 *
 * Files are uploaded to the RogerDoc storage service which handles
 * bucket selection and presigned URL generation.
 *
 * Args:
 * request: List of files to generate upload URLs for
 * ctx: Current context for authentication
 *
 * Returns:
 * Presigned upload URLs for each file
 *
 * Raises:
 * HTTPException: If URL generation fails
 */
export const getCodingUploadUrlsRogerdocCodingUploadUrlsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetCodingUploadUrlsRogerdocCodingUploadUrlsPostData,
    ThrowOnError
  >
): RequestResult<
  GetCodingUploadUrlsRogerdocCodingUploadUrlsPostResponses,
  GetCodingUploadUrlsRogerdocCodingUploadUrlsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GetCodingUploadUrlsRogerdocCodingUploadUrlsPostResponses,
    GetCodingUploadUrlsRogerdocCodingUploadUrlsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/coding/upload-urls',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Upload Coding Files
 *
 * Upload files for medical coding.
 *
 * Files are uploaded to the RogerDoc storage service. The backend handles
 * getting presigned URLs and uploading files to S3, avoiding CORS issues.
 *
 * All files are placed in a folder with a unique UUID:
 * roger_emr/{agency_id}/{folder_id}/{filename}
 *
 * Args:
 * files: List of files to upload
 * ctx: Current context for authentication
 *
 * Returns:
 * Upload results with S3 keys for each file
 *
 * Raises:
 * HTTPException: If upload fails
 */
export const uploadCodingFilesRogerdocCodingUploadFilesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UploadCodingFilesRogerdocCodingUploadFilesPostData,
    ThrowOnError
  >
): RequestResult<
  UploadCodingFilesRogerdocCodingUploadFilesPostResponses,
  UploadCodingFilesRogerdocCodingUploadFilesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UploadCodingFilesRogerdocCodingUploadFilesPostResponses,
    UploadCodingFilesRogerdocCodingUploadFilesPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/rogerdoc/coding/upload-files',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Rogerdoc Vsp Update
 *
 * Custom handler for VSP updates with audit logging.
 *
 * 1. Fetches current VSP state from RogerDoc
 * 2. Proxies the update request to RogerDoc
 * 3. On success, computes diff and creates audit log entry
 */
export const rogerdocVspUpdate = <ThrowOnError extends boolean = false>(
  options?: Options<RogerdocVspUpdateData, ThrowOnError>
): RequestResult<RogerdocVspUpdateResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    RogerdocVspUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/vsp/update',
    ...options,
  });

/**
 * Rogerdoc Get Feature Flags
 *
 * Docs feature flags for the caller's agency, from the backend's Docs flag cache.
 *
 * 503 when Docs has not answered for this agency, so the frontend keeps the
 * flags it already has instead of reading them all as off. The answer is in
 * the shared cache, so this is a fleet-wide state, not a cold process.
 */
export const rogerdocGetFeatureFlags = <ThrowOnError extends boolean = false>(
  options?: Options<RogerdocGetFeatureFlagsData, ThrowOnError>
): RequestResult<RogerdocGetFeatureFlagsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    RogerdocGetFeatureFlagsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/feature_flags',
    ...options,
  });

/**
 * List Rogerdoc Account Links
 *
 * List RogerDoc clinician accounts (and their RogerEMR links) for the agency.
 *
 * The frontend fetches this separately after the member list loads and matches
 * each account's `roger_emr.user_email` to the agency member's email.
 */
export const listRogerdocAccountLinksRogerdocAccountLinksGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ListRogerdocAccountLinksRogerdocAccountLinksGetData,
    ThrowOnError
  >
): RequestResult<
  ListRogerdocAccountLinksRogerdocAccountLinksGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListRogerdocAccountLinksRogerdocAccountLinksGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/account-links',
    ...options,
  });

/**
 * Create Rogerdoc Account Link
 *
 * Create a new RogerDoc clinician account linked to a RogerEMR user.
 */
export const createRogerdocAccountLinkRogerdocAccountLinksPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateRogerdocAccountLinkRogerdocAccountLinksPostData,
    ThrowOnError
  >
): RequestResult<
  CreateRogerdocAccountLinkRogerdocAccountLinksPostResponses,
  CreateRogerdocAccountLinkRogerdocAccountLinksPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateRogerdocAccountLinkRogerdocAccountLinksPostResponses,
    CreateRogerdocAccountLinkRogerdocAccountLinksPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/account-links',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Clear Rogerdoc Account Link
 *
 * Clear the RogerEMR association on a RogerDoc clinician account.
 */
export const clearRogerdocAccountLinkRogerdocAccountLinksAccountIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ClearRogerdocAccountLinkRogerdocAccountLinksAccountIdDeleteData,
    ThrowOnError
  >
): RequestResult<
  ClearRogerdocAccountLinkRogerdocAccountLinksAccountIdDeleteResponses,
  ClearRogerdocAccountLinkRogerdocAccountLinksAccountIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    ClearRogerdocAccountLinkRogerdocAccountLinksAccountIdDeleteResponses,
    ClearRogerdocAccountLinkRogerdocAccountLinksAccountIdDeleteErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/account-links/{account_id}',
    ...options,
  });

/**
 * Assign Rogerdoc Account Link
 *
 * Link an existing RogerDoc clinician account to a RogerEMR user.
 */
export const assignRogerdocAccountLinkRogerdocAccountLinksAccountIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AssignRogerdocAccountLinkRogerdocAccountLinksAccountIdPutData,
    ThrowOnError
  >
): RequestResult<
  AssignRogerdocAccountLinkRogerdocAccountLinksAccountIdPutResponses,
  AssignRogerdocAccountLinkRogerdocAccountLinksAccountIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    AssignRogerdocAccountLinkRogerdocAccountLinksAccountIdPutResponses,
    AssignRogerdocAccountLinkRogerdocAccountLinksAccountIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/account-links/{account_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Goals Progress Validation Config
 *
 * Get goals progress validation config for the current agency.
 *
 * Requires goals:admin-tab permission.
 */
export const getGoalsProgressValidationConfig = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetGoalsProgressValidationConfigData, ThrowOnError>
): RequestResult<
  GetGoalsProgressValidationConfigResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetGoalsProgressValidationConfigResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/goals/progress-validation-config',
    ...options,
  });

/**
 * Set Goals Progress Validation Config
 *
 * Update goals progress validation config for the current agency.
 *
 * Requires goals:admin-tab permission.
 */
export const setGoalsProgressValidationConfig = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SetGoalsProgressValidationConfigData, ThrowOnError>
): RequestResult<
  SetGoalsProgressValidationConfigResponses,
  SetGoalsProgressValidationConfigErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SetGoalsProgressValidationConfigResponses,
    SetGoalsProgressValidationConfigErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/goals/progress-validation-config',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Rogerdoc Worksheet Goals Passthrough Post
 *
 * Passthrough POST for worksheet goals admin (requires goals:admin-tab).
 */
export const rogerdocWorksheetGoalsPassthroughPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RogerdocWorksheetGoalsPassthroughPostData, ThrowOnError>
): RequestResult<
  RogerdocWorksheetGoalsPassthroughPostResponses,
  RogerdocWorksheetGoalsPassthroughPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RogerdocWorksheetGoalsPassthroughPostResponses,
    RogerdocWorksheetGoalsPassthroughPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/worksheet-goals/{subpath}',
    ...options,
  });

/**
 * Rogerdoc Fetch Goals Templates Passthrough Post
 *
 * Passthrough POST for Wellsky goals resync (requires goals:admin-tab).
 *
 * Also syncs AgencyClinic and AgencyInsurance records from RogerDoc for the
 * current agency. Does not return until both operations complete.
 */
export const rogerdocFetchGoalsTemplatesPassthroughPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    RogerdocFetchGoalsTemplatesPassthroughPostData,
    ThrowOnError
  >
): RequestResult<
  RogerdocFetchGoalsTemplatesPassthroughPostResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    RogerdocFetchGoalsTemplatesPassthroughPostResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/fetch-goals-templates-by-dict-temporal',
    ...options,
  });

/**
 * Forward
 */
export const rogerdocCodingPassthroughDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RogerdocCodingPassthroughDeleteData, ThrowOnError>
): RequestResult<
  RogerdocCodingPassthroughDeleteResponses,
  RogerdocCodingPassthroughDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    RogerdocCodingPassthroughDeleteResponses,
    RogerdocCodingPassthroughDeleteErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/coding/{subpath}',
    ...options,
  });

/**
 * Forward
 */
export const rogerdocCodingPassthroughGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RogerdocCodingPassthroughGetData, ThrowOnError>
): RequestResult<
  RogerdocCodingPassthroughGetResponses,
  RogerdocCodingPassthroughGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    RogerdocCodingPassthroughGetResponses,
    RogerdocCodingPassthroughGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/coding/{subpath}',
    ...options,
  });

/**
 * Forward
 */
export const rogerdocCodingPassthroughPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RogerdocCodingPassthroughPatchData, ThrowOnError>
): RequestResult<
  RogerdocCodingPassthroughPatchResponses,
  RogerdocCodingPassthroughPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    RogerdocCodingPassthroughPatchResponses,
    RogerdocCodingPassthroughPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/coding/{subpath}',
    ...options,
  });

/**
 * Forward
 */
export const rogerdocCodingPassthroughPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RogerdocCodingPassthroughPostData, ThrowOnError>
): RequestResult<
  RogerdocCodingPassthroughPostResponses,
  RogerdocCodingPassthroughPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RogerdocCodingPassthroughPostResponses,
    RogerdocCodingPassthroughPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/coding/{subpath}',
    ...options,
  });

/**
 * Forward
 */
export const rogerdocCodingPassthroughPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RogerdocCodingPassthroughPutData, ThrowOnError>
): RequestResult<
  RogerdocCodingPassthroughPutResponses,
  RogerdocCodingPassthroughPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    RogerdocCodingPassthroughPutResponses,
    RogerdocCodingPassthroughPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/coding/{subpath}',
    ...options,
  });

/**
 * Forward
 */
export const rogerdocPatientSelectorCodingPassthroughDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RogerdocPatientSelectorCodingPassthroughDeleteData,
    ThrowOnError
  >
): RequestResult<
  RogerdocPatientSelectorCodingPassthroughDeleteResponses,
  RogerdocPatientSelectorCodingPassthroughDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    RogerdocPatientSelectorCodingPassthroughDeleteResponses,
    RogerdocPatientSelectorCodingPassthroughDeleteErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/dashboard/patient-selector/coding/{subpath}',
    ...options,
  });

/**
 * Forward
 */
export const rogerdocPatientSelectorCodingPassthroughGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RogerdocPatientSelectorCodingPassthroughGetData,
    ThrowOnError
  >
): RequestResult<
  RogerdocPatientSelectorCodingPassthroughGetResponses,
  RogerdocPatientSelectorCodingPassthroughGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    RogerdocPatientSelectorCodingPassthroughGetResponses,
    RogerdocPatientSelectorCodingPassthroughGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/dashboard/patient-selector/coding/{subpath}',
    ...options,
  });

/**
 * Forward
 */
export const rogerdocPatientSelectorCodingPassthroughPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RogerdocPatientSelectorCodingPassthroughPatchData,
    ThrowOnError
  >
): RequestResult<
  RogerdocPatientSelectorCodingPassthroughPatchResponses,
  RogerdocPatientSelectorCodingPassthroughPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    RogerdocPatientSelectorCodingPassthroughPatchResponses,
    RogerdocPatientSelectorCodingPassthroughPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/dashboard/patient-selector/coding/{subpath}',
    ...options,
  });

/**
 * Forward
 */
export const rogerdocPatientSelectorCodingPassthroughPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RogerdocPatientSelectorCodingPassthroughPostData,
    ThrowOnError
  >
): RequestResult<
  RogerdocPatientSelectorCodingPassthroughPostResponses,
  RogerdocPatientSelectorCodingPassthroughPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RogerdocPatientSelectorCodingPassthroughPostResponses,
    RogerdocPatientSelectorCodingPassthroughPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/dashboard/patient-selector/coding/{subpath}',
    ...options,
  });

/**
 * Forward
 */
export const rogerdocPatientSelectorCodingPassthroughPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RogerdocPatientSelectorCodingPassthroughPutData,
    ThrowOnError
  >
): RequestResult<
  RogerdocPatientSelectorCodingPassthroughPutResponses,
  RogerdocPatientSelectorCodingPassthroughPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    RogerdocPatientSelectorCodingPassthroughPutResponses,
    RogerdocPatientSelectorCodingPassthroughPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/dashboard/patient-selector/coding/{subpath}',
    ...options,
  });

/**
 *  Visit Coding Passthrough
 */
export const rogerdocVisitCodingPassthroughDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RogerdocVisitCodingPassthroughDeleteData, ThrowOnError>
): RequestResult<
  RogerdocVisitCodingPassthroughDeleteResponses,
  RogerdocVisitCodingPassthroughDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    RogerdocVisitCodingPassthroughDeleteResponses,
    RogerdocVisitCodingPassthroughDeleteErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/visits/{visit_id}/coding/{subpath}',
    ...options,
  });

/**
 *  Visit Coding Passthrough
 */
export const rogerdocVisitCodingPassthroughGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RogerdocVisitCodingPassthroughGetData, ThrowOnError>
): RequestResult<
  RogerdocVisitCodingPassthroughGetResponses,
  RogerdocVisitCodingPassthroughGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    RogerdocVisitCodingPassthroughGetResponses,
    RogerdocVisitCodingPassthroughGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/visits/{visit_id}/coding/{subpath}',
    ...options,
  });

/**
 *  Visit Coding Passthrough
 */
export const rogerdocVisitCodingPassthroughPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RogerdocVisitCodingPassthroughPatchData, ThrowOnError>
): RequestResult<
  RogerdocVisitCodingPassthroughPatchResponses,
  RogerdocVisitCodingPassthroughPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    RogerdocVisitCodingPassthroughPatchResponses,
    RogerdocVisitCodingPassthroughPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/visits/{visit_id}/coding/{subpath}',
    ...options,
  });

/**
 *  Visit Coding Passthrough
 */
export const rogerdocVisitCodingPassthroughPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RogerdocVisitCodingPassthroughPostData, ThrowOnError>
): RequestResult<
  RogerdocVisitCodingPassthroughPostResponses,
  RogerdocVisitCodingPassthroughPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RogerdocVisitCodingPassthroughPostResponses,
    RogerdocVisitCodingPassthroughPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/visits/{visit_id}/coding/{subpath}',
    ...options,
  });

/**
 *  Visit Coding Passthrough
 */
export const rogerdocVisitCodingPassthroughPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RogerdocVisitCodingPassthroughPutData, ThrowOnError>
): RequestResult<
  RogerdocVisitCodingPassthroughPutResponses,
  RogerdocVisitCodingPassthroughPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    RogerdocVisitCodingPassthroughPutResponses,
    RogerdocVisitCodingPassthroughPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/visits/{visit_id}/coding/{subpath}',
    ...options,
  });

/**
 *  Dashboard Clinicians Create Passthrough
 */
export const rogerdocClinicianCreatePassthroughPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<RogerdocClinicianCreatePassthroughPostData, ThrowOnError>
): RequestResult<
  RogerdocClinicianCreatePassthroughPostResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    RogerdocClinicianCreatePassthroughPostResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/dashboard/clinicians/create',
    ...options,
  });

/**
 *  Dashboard Clinician Reset Passthrough
 */
export const rogerdocClinicianResetPassthroughPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RogerdocClinicianResetPassthroughPostData, ThrowOnError>
): RequestResult<
  RogerdocClinicianResetPassthroughPostResponses,
  RogerdocClinicianResetPassthroughPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RogerdocClinicianResetPassthroughPostResponses,
    RogerdocClinicianResetPassthroughPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/dashboard/clinicians/{username}/reset',
    ...options,
  });

/**
 *  Dashboard Clinician Deactivate Passthrough
 */
export const rogerdocClinicianDeactivatePassthroughPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RogerdocClinicianDeactivatePassthroughPostData, ThrowOnError>
): RequestResult<
  RogerdocClinicianDeactivatePassthroughPostResponses,
  RogerdocClinicianDeactivatePassthroughPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RogerdocClinicianDeactivatePassthroughPostResponses,
    RogerdocClinicianDeactivatePassthroughPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/dashboard/clinicians/{username}/deactivate',
    ...options,
  });

/**
 * Rogerdoc Passthrough Delete
 *
 * Passthrough DELETE request to RogerDoc API.
 */
export const rogerdocPassthroughDelete = <ThrowOnError extends boolean = false>(
  options: Options<RogerdocPassthroughDeleteData, ThrowOnError>
): RequestResult<
  RogerdocPassthroughDeleteResponses,
  RogerdocPassthroughDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    RogerdocPassthroughDeleteResponses,
    RogerdocPassthroughDeleteErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/{path}',
    ...options,
  });

/**
 * Rogerdoc Passthrough Get
 *
 * Passthrough GET request to RogerDoc API.
 */
export const rogerdocPassthroughGet = <ThrowOnError extends boolean = false>(
  options: Options<RogerdocPassthroughGetData, ThrowOnError>
): RequestResult<
  RogerdocPassthroughGetResponses,
  RogerdocPassthroughGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    RogerdocPassthroughGetResponses,
    RogerdocPassthroughGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/{path}',
    ...options,
  });

/**
 * Rogerdoc Passthrough Patch
 *
 * Passthrough PATCH request to RogerDoc API.
 */
export const rogerdocPassthroughPatch = <ThrowOnError extends boolean = false>(
  options: Options<RogerdocPassthroughPatchData, ThrowOnError>
): RequestResult<
  RogerdocPassthroughPatchResponses,
  RogerdocPassthroughPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    RogerdocPassthroughPatchResponses,
    RogerdocPassthroughPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/{path}',
    ...options,
  });

/**
 * Rogerdoc Passthrough Post
 *
 * Passthrough POST request to RogerDoc API.
 */
export const rogerdocPassthroughPost = <ThrowOnError extends boolean = false>(
  options: Options<RogerdocPassthroughPostData, ThrowOnError>
): RequestResult<
  RogerdocPassthroughPostResponses,
  RogerdocPassthroughPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RogerdocPassthroughPostResponses,
    RogerdocPassthroughPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/{path}',
    ...options,
  });

/**
 * Rogerdoc Passthrough Put
 *
 * Passthrough PUT request to RogerDoc API.
 */
export const rogerdocPassthroughPut = <ThrowOnError extends boolean = false>(
  options: Options<RogerdocPassthroughPutData, ThrowOnError>
): RequestResult<
  RogerdocPassthroughPutResponses,
  RogerdocPassthroughPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    RogerdocPassthroughPutResponses,
    RogerdocPassthroughPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/{path}',
    ...options,
  });

/**
 * List Bespoke Templates
 *
 * List all bespoke templates (environment-wide catalog).
 *
 * Optionally filter by schema_version_name, form_type and/or
 * form_schema_version.
 *
 * Accepts the internal API key as well as a user session so the Forms Manager
 * MCP reads this catalog rather than a second, filterless copy of it. The
 * rows are environment-wide -- ``BespokeTemplate`` is deliberately not
 * ``AgencyPrivateMixin`` -- so there is no tenant data here to widen access
 * to, and ``get_current_ctx_or_internal`` falls through to ``get_current_ctx``
 * when no key is present, leaving every existing session on its current path.
 */
export const listBespokeTemplatesBespokeTemplatesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListBespokeTemplatesBespokeTemplatesGetData, ThrowOnError>
): RequestResult<
  ListBespokeTemplatesBespokeTemplatesGetResponses,
  ListBespokeTemplatesBespokeTemplatesGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListBespokeTemplatesBespokeTemplatesGetResponses,
    ListBespokeTemplatesBespokeTemplatesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/bespoke-templates/',
    ...options,
  });

/**
 * List Bespoke Templates Export All
 *
 * Legacy super-user export entrypoint; returns the same catalog as ``GET /``.
 *
 * Kept for tooling that still calls this URL; prefer ``GET /`` for new code.
 */
export const listBespokeTemplatesExportAllBespokeTemplatesExportAllGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ListBespokeTemplatesExportAllBespokeTemplatesExportAllGetData,
    ThrowOnError
  >
): RequestResult<
  ListBespokeTemplatesExportAllBespokeTemplatesExportAllGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListBespokeTemplatesExportAllBespokeTemplatesExportAllGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/bespoke-templates/export-all',
    ...options,
  });

/**
 * List Enabled Sections
 *
 * Return the layouts a visit on this pin renders, one per section.
 *
 * Resolved like print and the Forms Manager, so a section missing on the
 * visit pin reads its bare-name row (``RN`` for ``RN Initial``). With
 * ``visit_id``, a completed visit answers from the layouts it was completed
 * with instead; a visit the caller cannot see is a 404.
 */
export const listEnabledSectionsBespokeTemplatesEnabledGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListEnabledSectionsBespokeTemplatesEnabledGetData,
    ThrowOnError
  >
): RequestResult<
  ListEnabledSectionsBespokeTemplatesEnabledGetResponses,
  ListEnabledSectionsBespokeTemplatesEnabledGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListEnabledSectionsBespokeTemplatesEnabledGetResponses,
    ListEnabledSectionsBespokeTemplatesEnabledGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/bespoke-templates/enabled',
    ...options,
  });

/**
 * List Bespoke Template Revisions
 *
 * Lightweight template metadata for a full pin, for live-refresh polling.
 *
 * Excludes ``layout_json`` to keep the poll payload cheap; a changed
 * ``updated_at`` tells the page an MCP push or import landed.
 */
export const listBespokeTemplateRevisionsBespokeTemplatesRevisionsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListBespokeTemplateRevisionsBespokeTemplatesRevisionsGetData,
    ThrowOnError
  >
): RequestResult<
  ListBespokeTemplateRevisionsBespokeTemplatesRevisionsGetResponses,
  ListBespokeTemplateRevisionsBespokeTemplatesRevisionsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListBespokeTemplateRevisionsBespokeTemplatesRevisionsGetResponses,
    ListBespokeTemplateRevisionsBespokeTemplatesRevisionsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/bespoke-templates/revisions',
    ...options,
  });

/**
 * Import Bespoke Templates Bundle
 *
 * Upsert one layout per pin + section from a JSON export bundle.
 */
export const importBespokeTemplatesBundleBespokeTemplatesImportBundlePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ImportBespokeTemplatesBundleBespokeTemplatesImportBundlePostData,
    ThrowOnError
  >
): RequestResult<
  ImportBespokeTemplatesBundleBespokeTemplatesImportBundlePostResponses,
  ImportBespokeTemplatesBundleBespokeTemplatesImportBundlePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ImportBespokeTemplatesBundleBespokeTemplatesImportBundlePostResponses,
    ImportBespokeTemplatesBundleBespokeTemplatesImportBundlePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/bespoke-templates/import-bundle',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Preview Bespoke Template Pdf
 *
 * Render the visit-PDF print view of one section's working-draft layout.
 *
 * Goes through ``DefaultVisitPDFGenerator`` — the same class the visit PDF
 * download uses — so the Forms Manager preview is the real print output
 * rather than a letter-width guess at the on-screen form. The ``Visit`` is
 * transient: constructed here, never added to a session, only read for its
 * (empty) answers and its title.
 */
export const previewBespokeTemplatePdfBespokeTemplatesPreviewPdfPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PreviewBespokeTemplatePdfBespokeTemplatesPreviewPdfPostData,
    ThrowOnError
  >
): RequestResult<
  PreviewBespokeTemplatePdfBespokeTemplatesPreviewPdfPostResponses,
  PreviewBespokeTemplatePdfBespokeTemplatesPreviewPdfPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PreviewBespokeTemplatePdfBespokeTemplatesPreviewPdfPostResponses,
    PreviewBespokeTemplatePdfBespokeTemplatesPreviewPdfPostErrors,
    ThrowOnError
  >({
    url: '/bespoke-templates/preview-pdf',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Context Section Layout
 *
 * The section's bespoke layout_json, or null when it has none.
 */
export const contextSectionLayoutFormsManagerContextSectionLayoutGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ContextSectionLayoutFormsManagerContextSectionLayoutGetData,
    ThrowOnError
  >
): RequestResult<
  ContextSectionLayoutFormsManagerContextSectionLayoutGetResponses,
  ContextSectionLayoutFormsManagerContextSectionLayoutGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ContextSectionLayoutFormsManagerContextSectionLayoutGetResponses,
    ContextSectionLayoutFormsManagerContextSectionLayoutGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/forms-manager/context/section-layout',
    ...options,
  });

/**
 * Context Section Layouts
 *
 * The section's one layout, with its id and metadata, under its effective pin.
 */
export const contextSectionLayoutsFormsManagerContextSectionLayoutsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ContextSectionLayoutsFormsManagerContextSectionLayoutsGetData,
    ThrowOnError
  >
): RequestResult<
  ContextSectionLayoutsFormsManagerContextSectionLayoutsGetResponses,
  ContextSectionLayoutsFormsManagerContextSectionLayoutsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ContextSectionLayoutsFormsManagerContextSectionLayoutsGetResponses,
    ContextSectionLayoutsFormsManagerContextSectionLayoutsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/forms-manager/context/section-layouts',
    ...options,
  });

/**
 * Context Form Questions
 *
 * Canonical MCP schema pin plus every section's questions, in one response.
 *
 * Resolving the pin normalizes the *whole* form schema, so returning one
 * section of it -- or only the section names -- throws away work the request
 * already paid for and makes the caller come back for the rest. Finding a
 * section to copy compares QID sets across every already-built form, which is
 * that access pattern at its worst: a form near the bottom of
 * ``FORM_PRECEDENCE`` scans several hundred candidate sections.
 *
 * Section names are ``sections.keys()`` and one section is a lookup into
 * ``sections``, so this replaces the former ``/context/sections`` and
 * ``/context/section-questions``; the MCP tools of those names now project
 * this payload client-side.
 */
export const contextFormQuestionsFormsManagerContextFormQuestionsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ContextFormQuestionsFormsManagerContextFormQuestionsGetData,
    ThrowOnError
  >
): RequestResult<
  ContextFormQuestionsFormsManagerContextFormQuestionsGetResponses,
  ContextFormQuestionsFormsManagerContextFormQuestionsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ContextFormQuestionsFormsManagerContextFormQuestionsGetResponses,
    ContextFormQuestionsFormsManagerContextFormQuestionsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/forms-manager/context/form-questions',
    ...options,
  });

/**
 * Push Layout
 *
 * Upsert the section's one layout. Local development only.
 *
 * The row is keyed by the section's effective pin (the one a visit renders)
 * and section: it is created when the section has none, and otherwise its
 * ``layout_json`` and description are replaced. That is the layout a
 * clinician sees, so the endpoint refuses outright anywhere but local
 * development. The guard is here rather than only in the MCP client because
 * anything holding the internal key can reach this route.
 */
export const pushLayoutFormsManagerPushLayoutPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PushLayoutFormsManagerPushLayoutPostData, ThrowOnError>
): RequestResult<
  PushLayoutFormsManagerPushLayoutPostResponses,
  PushLayoutFormsManagerPushLayoutPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PushLayoutFormsManagerPushLayoutPostResponses,
    PushLayoutFormsManagerPushLayoutPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/forms-manager/push-layout',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Generate X12 270
 *
 * Generate X12 270 eligibility inquiry message.
 */
export const generateX12270X12270GeneratePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GenerateX12270X12270GeneratePostData, ThrowOnError>
): RequestResult<
  GenerateX12270X12270GeneratePostResponses,
  GenerateX12270X12270GeneratePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GenerateX12270X12270GeneratePostResponses,
    GenerateX12270X12270GeneratePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/x12/270/generate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Check Eligibility With X12 270
 *
 * Generate X12 270 message and submit to Waystar for eligibility check.
 */
export const checkEligibilityWithX12270X12270EligibilityCheckPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CheckEligibilityWithX12270X12270EligibilityCheckPostData,
    ThrowOnError
  >
): RequestResult<
  CheckEligibilityWithX12270X12270EligibilityCheckPostResponses,
  CheckEligibilityWithX12270X12270EligibilityCheckPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CheckEligibilityWithX12270X12270EligibilityCheckPostResponses,
    CheckEligibilityWithX12270X12270EligibilityCheckPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/x12/270/eligibility-check',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Generate X12 271
 *
 * Generate X12 271 eligibility response message.
 */
export const generateX12271X12271GeneratePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GenerateX12271X12271GeneratePostData, ThrowOnError>
): RequestResult<
  GenerateX12271X12271GeneratePostResponses,
  GenerateX12271X12271GeneratePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GenerateX12271X12271GeneratePostResponses,
    GenerateX12271X12271GeneratePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/x12/271/generate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Parse X12 271
 *
 * Parse a raw X12 271 message and return the parsed response as JSON.
 */
export const parseX12271X12271ParsePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ParseX12271X12271ParsePostData, ThrowOnError>
): RequestResult<
  ParseX12271X12271ParsePostResponses,
  ParseX12271X12271ParsePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ParseX12271X12271ParsePostResponses,
    ParseX12271X12271ParsePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/x12/271/parse',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Generate X12 837I
 *
 * Generate X12 837I institutional healthcare claim message.
 */
export const generateX12837iX12837iGeneratePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GenerateX12837iX12837iGeneratePostData, ThrowOnError>
): RequestResult<
  GenerateX12837iX12837iGeneratePostResponses,
  GenerateX12837iX12837iGeneratePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GenerateX12837iX12837iGeneratePostResponses,
    GenerateX12837iX12837iGeneratePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/x12/837i/generate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Check Eligibility X12
 *
 * Check eligibility using X12 270 message via Waystar.
 */
export const checkEligibilityX12WaystarEligibilityPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CheckEligibilityX12WaystarEligibilityPostData, ThrowOnError>
): RequestResult<
  CheckEligibilityX12WaystarEligibilityPostResponses,
  CheckEligibilityX12WaystarEligibilityPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CheckEligibilityX12WaystarEligibilityPostResponses,
    CheckEligibilityX12WaystarEligibilityPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/waystar/eligibility',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Check Eligibility Direct
 *
 * Check eligibility directly via Waystar API.
 */
export const checkEligibilityDirectWaystarEligibilityDirectPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CheckEligibilityDirectWaystarEligibilityDirectPostData,
    ThrowOnError
  >
): RequestResult<
  CheckEligibilityDirectWaystarEligibilityDirectPostResponses,
  CheckEligibilityDirectWaystarEligibilityDirectPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CheckEligibilityDirectWaystarEligibilityDirectPostResponses,
    CheckEligibilityDirectWaystarEligibilityDirectPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/waystar/eligibility/direct',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Check Prior Authorization
 *
 * Check prior authorization via Waystar API.
 */
export const checkPriorAuthorizationWaystarPriorAuthPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CheckPriorAuthorizationWaystarPriorAuthPostData,
    ThrowOnError
  >
): RequestResult<
  CheckPriorAuthorizationWaystarPriorAuthPostResponses,
  CheckPriorAuthorizationWaystarPriorAuthPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CheckPriorAuthorizationWaystarPriorAuthPostResponses,
    CheckPriorAuthorizationWaystarPriorAuthPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/waystar/prior-auth',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Submit Claim
 *
 * Submit an X12 837i claim to Waystar via SFTP.
 */
export const submitClaimWaystarClaimsSubmit837iPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SubmitClaimWaystarClaimsSubmit837iPostData, ThrowOnError>
): RequestResult<
  SubmitClaimWaystarClaimsSubmit837iPostResponses,
  SubmitClaimWaystarClaimsSubmit837iPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SubmitClaimWaystarClaimsSubmit837iPostResponses,
    SubmitClaimWaystarClaimsSubmit837iPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/waystar/claims/submit/837i',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Check Claim Acknowledgment
 *
 * Check for 999 acknowledgment file for a submitted claim.
 */
export const checkClaimAcknowledgmentWaystarClaimsClaimIdAckGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CheckClaimAcknowledgmentWaystarClaimsClaimIdAckGetData,
    ThrowOnError
  >
): RequestResult<
  CheckClaimAcknowledgmentWaystarClaimsClaimIdAckGetResponses,
  CheckClaimAcknowledgmentWaystarClaimsClaimIdAckGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    CheckClaimAcknowledgmentWaystarClaimsClaimIdAckGetResponses,
    CheckClaimAcknowledgmentWaystarClaimsClaimIdAckGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/waystar/claims/{claim_id}/ack',
    ...options,
  });

/**
 * Check Eligibility
 *
 * Submit a real-time eligibility check to Stedi.
 *
 * This endpoint accepts a request in Stedi's JSON format and returns
 * the eligibility response also in Stedi's JSON format.
 */
export const checkEligibilityStediEligibilityPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CheckEligibilityStediEligibilityPostData, ThrowOnError>
): RequestResult<
  CheckEligibilityStediEligibilityPostResponses,
  CheckEligibilityStediEligibilityPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CheckEligibilityStediEligibilityPostResponses,
    CheckEligibilityStediEligibilityPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/stedi/eligibility',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Check Coordination Of Benefits
 *
 * Submit a coordination of benefits check to Stedi.
 *
 * This endpoint accepts a request in Stedi's JSON format (same as eligibility)
 * and returns the COB response from Stedi.
 */
export const checkCoordinationOfBenefitsStediCoordinationOfBenefitsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CheckCoordinationOfBenefitsStediCoordinationOfBenefitsPostData,
    ThrowOnError
  >
): RequestResult<
  CheckCoordinationOfBenefitsStediCoordinationOfBenefitsPostResponses,
  CheckCoordinationOfBenefitsStediCoordinationOfBenefitsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CheckCoordinationOfBenefitsStediCoordinationOfBenefitsPostResponses,
    CheckCoordinationOfBenefitsStediCoordinationOfBenefitsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/stedi/coordination-of-benefits',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Submit Claim 837I
 *
 * Submit an 837I institutional claim to Stedi.
 *
 * This endpoint implements a two-phase workflow:
 * 1. Create claim record in database with DRAFT status
 * 2. Submit to Stedi and update status to SUBMITTED on success
 *
 * Args:
 * request: 837I claim submission request data including patient_id and payor_id
 * db: Database session
 *
 * Returns:
 * 837I claim submission response from Stedi with database claim ID
 */
export const submitClaim837iStediClaim837iPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SubmitClaim837iStediClaim837iPostData, ThrowOnError>
): RequestResult<
  SubmitClaim837iStediClaim837iPostResponses,
  SubmitClaim837iStediClaim837iPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SubmitClaim837iStediClaim837iPostResponses,
    SubmitClaim837iStediClaim837iPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/stedi/claim-837i',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Stedi Claim Ub04 Pdf
 *
 * Export a stored 837I claim as a UB-04 (CMS-1450) PDF.
 *
 * Uses JSON in ``claim.claim_data`` (same payload sent to Stedi). Requires
 * that claim data exists and the claim belongs to the current agency.
 */
export const getStediClaimUb04PdfStediClaimsClaimIdUb04Get = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetStediClaimUb04PdfStediClaimsClaimIdUb04GetData,
    ThrowOnError
  >
): RequestResult<
  GetStediClaimUb04PdfStediClaimsClaimIdUb04GetResponses,
  GetStediClaimUb04PdfStediClaimsClaimIdUb04GetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetStediClaimUb04PdfStediClaimsClaimIdUb04GetResponses,
    GetStediClaimUb04PdfStediClaimsClaimIdUb04GetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/stedi/claims/{claim_id}/ub04',
    ...options,
  });

/**
 * Upload Claim Document For Patient
 *
 * Upload a document for a patient that will be attached to a future claim.
 *
 * Args:
 * patient_id: Patient ID
 * file: File to upload (max 64MB)
 * report_type_code: PWK01 code (default: BM for attachments)
 * attachment_description: Description of the attachment
 * service_line_number: Optional service line number
 * provider_control_number: Optional provider control number
 * db: Database session
 * context: Current user context
 *
 * Returns:
 * ClaimDocumentResponse with attachment control number
 */
export const uploadClaimDocumentForPatientStediPatientsPatientIdClaimDocumentsPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UploadClaimDocumentForPatientStediPatientsPatientIdClaimDocumentsPostData,
      ThrowOnError
    >
  ): RequestResult<
    UploadClaimDocumentForPatientStediPatientsPatientIdClaimDocumentsPostResponses,
    UploadClaimDocumentForPatientStediPatientsPatientIdClaimDocumentsPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      UploadClaimDocumentForPatientStediPatientsPatientIdClaimDocumentsPostResponses,
      UploadClaimDocumentForPatientStediPatientsPatientIdClaimDocumentsPostErrors,
      ThrowOnError
    >({
      ...formDataBodySerializer,
      responseType: 'json',
      url: '/stedi/patients/{patient_id}/claim-documents',
      ...options,
      headers: {
        'Content-Type': null,
        ...options.headers,
      },
    });

/**
 * Receive Stedi Webhook
 *
 * Receive and process Stedi webhook events.
 *
 * This endpoint receives webhook notifications from Stedi for transaction processing events.
 * Currently, it only processes 277 (claim status) transactions.
 */
export const receiveStediWebhookStediWebhooksReceivePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ReceiveStediWebhookStediWebhooksReceivePostData,
    ThrowOnError
  >
): RequestResult<
  ReceiveStediWebhookStediWebhooksReceivePostResponses,
  ReceiveStediWebhookStediWebhooksReceivePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ReceiveStediWebhookStediWebhooksReceivePostResponses,
    ReceiveStediWebhookStediWebhooksReceivePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/stedi/webhooks/receive',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Clinic Scheduling Points
 *
 * The resolved grid for one clinic, with provenance per row.
 */
export const getClinicSchedulingPointsSchedulingPointsClinicsClinicIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetClinicSchedulingPointsSchedulingPointsClinicsClinicIdGetData,
    ThrowOnError
  >
): RequestResult<
  GetClinicSchedulingPointsSchedulingPointsClinicsClinicIdGetResponses,
  GetClinicSchedulingPointsSchedulingPointsClinicsClinicIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetClinicSchedulingPointsSchedulingPointsClinicsClinicIdGetResponses,
    GetClinicSchedulingPointsSchedulingPointsClinicsClinicIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/scheduling-points/clinics/{clinic_id}',
    ...options,
  });

/**
 * Update Clinic Scheduling Points
 *
 * Save changed cells for one clinic and return the grid as it now reads.
 *
 * Takes ``include_all_disciplines`` for the same reason the GET does, and must:
 * the response *is* the grid the caller will render next, so it has to be the
 * same grid she was looking at when she typed.
 */
export const updateClinicSchedulingPointsSchedulingPointsClinicsClinicIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateClinicSchedulingPointsSchedulingPointsClinicsClinicIdPutData,
    ThrowOnError
  >
): RequestResult<
  UpdateClinicSchedulingPointsSchedulingPointsClinicsClinicIdPutResponses,
  UpdateClinicSchedulingPointsSchedulingPointsClinicsClinicIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateClinicSchedulingPointsSchedulingPointsClinicsClinicIdPutResponses,
    UpdateClinicSchedulingPointsSchedulingPointsClinicsClinicIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/scheduling-points/clinics/{clinic_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Agency Scheduling Points
 *
 * The agency's house values — what a clinic inherits when it says nothing.
 *
 * Not narrowed by discipline: the agency standard has to cover every clinic,
 * including ones staffing a discipline none of its siblings do.
 */
export const getAgencySchedulingPointsSchedulingPointsAgencyGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetAgencySchedulingPointsSchedulingPointsAgencyGetData,
    ThrowOnError
  >
): RequestResult<
  GetAgencySchedulingPointsSchedulingPointsAgencyGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetAgencySchedulingPointsSchedulingPointsAgencyGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/scheduling-points/agency',
    ...options,
  });

/**
 * Update Agency Scheduling Points
 *
 * Save the agency's house values. Callers should confirm the blast radius first.
 */
export const updateAgencySchedulingPointsSchedulingPointsAgencyPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateAgencySchedulingPointsSchedulingPointsAgencyPutData,
    ThrowOnError
  >
): RequestResult<
  UpdateAgencySchedulingPointsSchedulingPointsAgencyPutResponses,
  UpdateAgencySchedulingPointsSchedulingPointsAgencyPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateAgencySchedulingPointsSchedulingPointsAgencyPutResponses,
    UpdateAgencySchedulingPointsSchedulingPointsAgencyPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/scheduling-points/agency',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Preview Agency Blast Radius
 *
 * How many clinics *this* agency-tier save would move.
 *
 * The risk with an agency edit is accidental breadth, not malice, so the
 * instrument is a confirmation that states what is about to happen —
 * "this changes the default for 6 clinics; 2 have their own values and will
 * not be affected" — rather than a permission the manager does not have.
 *
 * A POST taking the exact body the PUT would receive, so the preview and the
 * save can never disagree about what is changing. Asked without the pending
 * save the count could only describe *some* change, and a manager repricing
 * one alias would be quoted the number for repricing everything.
 *
 * A clinic is counted as unaffected only when its own tier states a value for
 * every alias and every config field this body touches; inheriting even one of
 * them means it moves. See :func:`clinics_stating_own_points` for why resolving
 * beats scanning the raw history, and why per-alias is the honest grain.
 *
 * An empty body moves nothing, so every clinic is unaffected — vacuous, and
 * truthful. The grid never sends one; it offers the save only once something
 * is pending.
 *
 * Deliberately no :func:`_reject_uncataloged` here. The save refuses the same
 * body a moment later, and a preview that failed would only cost the dialog
 * its counts, which it already knows how to do without.
 */
export const previewAgencyBlastRadiusSchedulingPointsAgencyBlastRadiusPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PreviewAgencyBlastRadiusSchedulingPointsAgencyBlastRadiusPostData,
    ThrowOnError
  >
): RequestResult<
  PreviewAgencyBlastRadiusSchedulingPointsAgencyBlastRadiusPostResponses,
  PreviewAgencyBlastRadiusSchedulingPointsAgencyBlastRadiusPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PreviewAgencyBlastRadiusSchedulingPointsAgencyBlastRadiusPostResponses,
    PreviewAgencyBlastRadiusSchedulingPointsAgencyBlastRadiusPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/scheduling-points/agency/blast-radius',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Scheduling Point Load
 *
 * Every candidate's workload for the ISO week containing ``date``.
 *
 * One request for the whole cohort rather than one per candidate: the number
 * only means anything comparatively, and a scheduler weighing four people
 * should not be able to see three of them while the fourth is still loading.
 */
export const getSchedulingPointLoadSchedulingPointsLoadGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetSchedulingPointLoadSchedulingPointsLoadGetData,
    ThrowOnError
  >
): RequestResult<
  GetSchedulingPointLoadSchedulingPointsLoadGetResponses,
  GetSchedulingPointLoadSchedulingPointsLoadGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetSchedulingPointLoadSchedulingPointsLoadGetResponses,
    GetSchedulingPointLoadSchedulingPointsLoadGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/scheduling-points/load',
    ...options,
  });

/**
 * Get Task Types
 *
 * Every schedulable task type with this agency's billing answer for it.
 */
export const getTaskTypesTaskTypesGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetTaskTypesTaskTypesGetData, ThrowOnError>
): RequestResult<GetTaskTypesTaskTypesGetResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetTaskTypesTaskTypesGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/task-types',
    ...options,
  });

/**
 * Update Task Types
 *
 * Record this agency's answer for each changed task type.
 *
 * Returns the whole grid rather than the changed rows: the answers the manager
 * did not touch can still have moved underneath them, and a partial response
 * would leave the screen showing a mix of before and after.
 */
export const updateTaskTypesTaskTypesPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateTaskTypesTaskTypesPutData, ThrowOnError>
): RequestResult<
  UpdateTaskTypesTaskTypesPutResponses,
  UpdateTaskTypesTaskTypesPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateTaskTypesTaskTypesPutResponses,
    UpdateTaskTypesTaskTypesPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/task-types',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Task Type Alias
 *
 * Add another name for a visit type. It behaves exactly like the visit type.
 */
export const createTaskTypeAliasTaskTypesAliasesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateTaskTypeAliasTaskTypesAliasesPostData, ThrowOnError>
): RequestResult<
  CreateTaskTypeAliasTaskTypesAliasesPostResponses,
  CreateTaskTypeAliasTaskTypesAliasesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateTaskTypeAliasTaskTypesAliasesPostResponses,
    CreateTaskTypeAliasTaskTypesAliasesPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/task-types/aliases',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Rename Task Type Alias
 *
 * Rename one of this agency's aliases, including on tasks already using it.
 */
export const renameTaskTypeAliasTaskTypesAliasesAliasIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RenameTaskTypeAliasTaskTypesAliasesAliasIdPatchData,
    ThrowOnError
  >
): RequestResult<
  RenameTaskTypeAliasTaskTypesAliasesAliasIdPatchResponses,
  RenameTaskTypeAliasTaskTypesAliasesAliasIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    RenameTaskTypeAliasTaskTypesAliasesAliasIdPatchResponses,
    RenameTaskTypeAliasTaskTypesAliasesAliasIdPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/task-types/aliases/{alias_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Archive Task Type Alias
 *
 * Stop offering an alias. Tasks already scheduled under it keep the name.
 */
export const archiveTaskTypeAliasTaskTypesAliasesAliasIdArchivePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ArchiveTaskTypeAliasTaskTypesAliasesAliasIdArchivePostData,
    ThrowOnError
  >
): RequestResult<
  ArchiveTaskTypeAliasTaskTypesAliasesAliasIdArchivePostResponses,
  ArchiveTaskTypeAliasTaskTypesAliasesAliasIdArchivePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ArchiveTaskTypeAliasTaskTypesAliasesAliasIdArchivePostResponses,
    ArchiveTaskTypeAliasTaskTypesAliasesAliasIdArchivePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/task-types/aliases/{alias_id}/archive',
    ...options,
  });

/**
 * Create Patient In Kinnser
 *
 * Create/push a patient to Kinnser from intake data.
 *
 * This endpoint validates the intake data and pushes it to Kinnser's system.
 * If validation fails, returns success=False with validation errors.
 *
 * Args:
 * request: Create request containing intake_id
 * db: Database session
 * context: Current user context
 *
 * Returns:
 * Response with success status and Kinnser patient ID if successful,
 * or validation errors if validation failed
 */
export const createPatientInKinnserKinnserPatientsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreatePatientInKinnserKinnserPatientsPostData, ThrowOnError>
): RequestResult<
  CreatePatientInKinnserKinnserPatientsPostResponses,
  CreatePatientInKinnserKinnserPatientsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreatePatientInKinnserKinnserPatientsPostResponses,
    CreatePatientInKinnserKinnserPatientsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/kinnser/patients',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Start Onboard Patient
 *
 * Start the async patient onboard workflow in RogerDocs.
 *
 * Validates the intake, starts the onboard Temporal workflow, persists its
 * workflow id on the intake, and returns immediately. Poll
 * ``GET /kinnser/patient/onboard/status/{intake_id}`` for the outcome.
 *
 * Deliberately NOT wrapped in ``safe_record_push_to_emr_failure`` (unlike
 * ``create_patient_in_kinnser``): a failed start pushed nothing, so it must
 * never lock the intake into PUSH_FAILED.
 */
export const startOnboardPatientKinnserPatientOnboardAsyncClinicIdBranchIdPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      StartOnboardPatientKinnserPatientOnboardAsyncClinicIdBranchIdPostData,
      ThrowOnError
    >
  ): RequestResult<
    StartOnboardPatientKinnserPatientOnboardAsyncClinicIdBranchIdPostResponses,
    StartOnboardPatientKinnserPatientOnboardAsyncClinicIdBranchIdPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      StartOnboardPatientKinnserPatientOnboardAsyncClinicIdBranchIdPostResponses,
      StartOnboardPatientKinnserPatientOnboardAsyncClinicIdBranchIdPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/kinnser/patient/onboard/async/{clinic_id}/{branch_id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Get Onboard Patient Status
 *
 * Get the status of an async patient onboard.
 *
 * Applies idempotent server-side terminal transitions: an observed completed
 * job marks the intake PUSHED_TO_KINNSER; an observed non-surfaceable
 * workflow failure records PUSH_FAILED. Transport errors return ``unknown``
 * and never write — locking happens only in the service's explicit
 * non-surfaceable-failed branch, so there is no lock-on-exception wrapper.
 */
export const getOnboardPatientStatusKinnserPatientOnboardStatusIntakeIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetOnboardPatientStatusKinnserPatientOnboardStatusIntakeIdGetData,
    ThrowOnError
  >
): RequestResult<
  GetOnboardPatientStatusKinnserPatientOnboardStatusIntakeIdGetResponses,
  GetOnboardPatientStatusKinnserPatientOnboardStatusIntakeIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetOnboardPatientStatusKinnserPatientOnboardStatusIntakeIdGetResponses,
    GetOnboardPatientStatusKinnserPatientOnboardStatusIntakeIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/kinnser/patient/onboard/status/{intake_id}',
    ...options,
  });

/**
 * Create Task For Episode
 *
 * Create a task on an existing episode (e.g. ROC) in WellSky.
 *
 * Uses the Kinnser service to call Roger Doc API, returns a structured
 * response, and raises HTTPException with a clear detail message on errors.
 */
export const createTaskForEpisodeKinnserClinicClinicIdEpisodeEpisodeKeyTaskPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      CreateTaskForEpisodeKinnserClinicClinicIdEpisodeEpisodeKeyTaskPostData,
      ThrowOnError
    >
  ): RequestResult<
    CreateTaskForEpisodeKinnserClinicClinicIdEpisodeEpisodeKeyTaskPostResponses,
    CreateTaskForEpisodeKinnserClinicClinicIdEpisodeEpisodeKeyTaskPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      CreateTaskForEpisodeKinnserClinicClinicIdEpisodeEpisodeKeyTaskPostResponses,
      CreateTaskForEpisodeKinnserClinicClinicIdEpisodeEpisodeKeyTaskPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/kinnser/clinic/{clinic_id}/episode/{episode_key}/task',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Auto Add Admission And Episode
 *
 * Create a new admission and a new episode for an existing WellSky patient.
 *
 * Asynchronous; does not wait for WellSky to finish. No demographics sent.
 * Idempotent on (patient_key, new_admission_date, new_episode_date, clinic_id).
 */
export const autoAddAdmissionAndEpisodeKinnserPatientAddAdmissionAndEpisodeAutoClinicIdPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      AutoAddAdmissionAndEpisodeKinnserPatientAddAdmissionAndEpisodeAutoClinicIdPostData,
      ThrowOnError
    >
  ): RequestResult<
    AutoAddAdmissionAndEpisodeKinnserPatientAddAdmissionAndEpisodeAutoClinicIdPostResponses,
    AutoAddAdmissionAndEpisodeKinnserPatientAddAdmissionAndEpisodeAutoClinicIdPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      AutoAddAdmissionAndEpisodeKinnserPatientAddAdmissionAndEpisodeAutoClinicIdPostResponses,
      AutoAddAdmissionAndEpisodeKinnserPatientAddAdmissionAndEpisodeAutoClinicIdPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/kinnser/patient/add-admission-and-episode/auto/{clinic_id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Auto Add Episode
 *
 * Create a new episode only for an existing WellSky patient who already has an admission.
 *
 * Asynchronous; does not wait for WellSky to finish. Patient must already have an admission.
 * Idempotent on (patient_key, new_episode_date, clinic_id).
 */
export const autoAddEpisodeKinnserPatientAddEpisodeAutoClinicIdPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AutoAddEpisodeKinnserPatientAddEpisodeAutoClinicIdPostData,
    ThrowOnError
  >
): RequestResult<
  AutoAddEpisodeKinnserPatientAddEpisodeAutoClinicIdPostResponses,
  AutoAddEpisodeKinnserPatientAddEpisodeAutoClinicIdPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AutoAddEpisodeKinnserPatientAddEpisodeAutoClinicIdPostResponses,
    AutoAddEpisodeKinnserPatientAddEpisodeAutoClinicIdPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/kinnser/patient/add-episode/auto/{clinic_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Task Details
 *
 * Update task details (e.g. comment) for an existing WellSky task.
 *
 * Runs a Temporal workflow that locates the task by episode, tab, and patient task key,
 * then applies the requested updates.
 */
export const updateTaskDetailsKinnserPatientTaskDetailsClinicIdPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateTaskDetailsKinnserPatientTaskDetailsClinicIdPostData,
    ThrowOnError
  >
): RequestResult<
  UpdateTaskDetailsKinnserPatientTaskDetailsClinicIdPostResponses,
  UpdateTaskDetailsKinnserPatientTaskDetailsClinicIdPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UpdateTaskDetailsKinnserPatientTaskDetailsClinicIdPostResponses,
    UpdateTaskDetailsKinnserPatientTaskDetailsClinicIdPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/kinnser/patient/task/details/{clinic_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Task Upload For Episode
 *
 * Upload S3 files to a WellSky task for the given episode.
 *
 * Navigates to clinic, opens episode manager for the episode, verifies patient key,
 * locates the task by patient_task_key on the given tab, and uploads files from S3.
 */
export const taskUploadForEpisodeKinnserTaskUploadForEpisodeEpisodeKeyClinicIdTabNamePatientTaskKeyPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      TaskUploadForEpisodeKinnserTaskUploadForEpisodeEpisodeKeyClinicIdTabNamePatientTaskKeyPostData,
      ThrowOnError
    >
  ): RequestResult<
    TaskUploadForEpisodeKinnserTaskUploadForEpisodeEpisodeKeyClinicIdTabNamePatientTaskKeyPostResponses,
    TaskUploadForEpisodeKinnserTaskUploadForEpisodeEpisodeKeyClinicIdTabNamePatientTaskKeyPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      TaskUploadForEpisodeKinnserTaskUploadForEpisodeEpisodeKeyClinicIdTabNamePatientTaskKeyPostResponses,
      TaskUploadForEpisodeKinnserTaskUploadForEpisodeEpisodeKeyClinicIdTabNamePatientTaskKeyPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/kinnser/task/upload/for-episode/{episode_key}/{clinic_id}/{tab_name}/{patient_task_key}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Get Kinnser Clinic Data
 *
 * Get Kinnser clinic data for a specific clinic.
 *
 * Returns the clinic-specific Kinnser data including
 * physicians, clinicians, managers, approvers, and insurance providers.
 *
 * Args:
 * clinic_id: The ID of the clinic to get data for
 * context: Current user context
 *
 * Returns:
 * Clinic data with available options
 */
export const getKinnserClinicDataKinnserClinicsClinicIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetKinnserClinicDataKinnserClinicsClinicIdGetData,
    ThrowOnError
  >
): RequestResult<
  GetKinnserClinicDataKinnserClinicsClinicIdGetResponses,
  GetKinnserClinicDataKinnserClinicsClinicIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKinnserClinicDataKinnserClinicsClinicIdGetResponses,
    GetKinnserClinicDataKinnserClinicsClinicIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/kinnser/clinics/{clinic_id}',
    ...options,
  });

/**
 * Get Kinnser Clinics
 *
 * Get list of available Kinnser clinics.
 *
 * Returns the list of available clinics for dropdown selection.
 *
 * Args:
 * context: Current user context
 *
 * Returns:
 * Response with list of available clinics
 */
export const getKinnserClinicsKinnserClinicsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetKinnserClinicsKinnserClinicsGetData, ThrowOnError>
): RequestResult<
  GetKinnserClinicsKinnserClinicsGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetKinnserClinicsKinnserClinicsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/kinnser/clinics',
    ...options,
  });

/**
 * Search Allergies
 *
 * Search the live FDB allergen picklist (auth required).
 *
 * Results are FDB-proxied items with no local id until one is selected and
 * materialized (``POST /patients/{id}/allergy`` with ``fdb_allergen_id``).
 * Queries shorter than 3 characters return an empty result.
 */
export const searchAllergiesAllergiesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<SearchAllergiesAllergiesGetData, ThrowOnError>
): RequestResult<
  SearchAllergiesAllergiesGetResponses,
  SearchAllergiesAllergiesGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    SearchAllergiesAllergiesGetResponses,
    SearchAllergiesAllergiesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/allergies/',
    ...options,
  });

/**
 * Create Allergy
 *
 * Create a new allergy (get-or-create).
 *
 * Returns the existing row of the same name when the caller may reference
 * it: a global catalog row, or the caller's own agency's user-defined row.
 * Other agencies' rows are never matched or returned.
 * User-defined rows always belong to the caller's agency.
 */
export const createAllergyAllergiesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateAllergyAllergiesPostData, ThrowOnError>
): RequestResult<
  CreateAllergyAllergiesPostResponses,
  CreateAllergyAllergiesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateAllergyAllergiesPostResponses,
    CreateAllergyAllergiesPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/allergies/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get User Defined Allergies
 *
 * Get all user-defined allergies.
 */
export const getUserDefinedAllergiesAllergiesUserDefinedGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetUserDefinedAllergiesAllergiesUserDefinedGetData,
    ThrowOnError
  >
): RequestResult<
  GetUserDefinedAllergiesAllergiesUserDefinedGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetUserDefinedAllergiesAllergiesUserDefinedGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/allergies/user-defined',
    ...options,
  });

/**
 * Import Allergies From File
 *
 * Import allergies from the hardcoded data file.
 * File format: allergy_name|num|letter|<br> (one per line).
 * Uses CRUD to create allergies; skips duplicates.
 * Strawhat super-user only — writes global catalog rows.
 */
export const importAllergiesFromFileAllergiesImportPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ImportAllergiesFromFileAllergiesImportPostData,
    ThrowOnError
  >
): RequestResult<
  ImportAllergiesFromFileAllergiesImportPostResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    ImportAllergiesFromFileAllergiesImportPostResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/allergies/import',
    ...options,
  });

/**
 * Delete Allergy
 *
 * Retire an allergy (``is_active = False``). The row is never deleted.
 *
 * It leaves the user-defined picker; patient allergies that name it keep
 * resolving it. Refused with 409 while a patient allergy references it.
 *
 * Own user-defined rows may be retired by the owning agency. Global
 * catalog rows require a Strawhat super-user. Foreign user-defined rows
 * return 404 (same detail as a genuine miss).
 */
export const deleteAllergyAllergiesAllergyIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAllergyAllergiesAllergyIdDeleteData, ThrowOnError>
): RequestResult<
  DeleteAllergyAllergiesAllergyIdDeleteResponses,
  DeleteAllergyAllergiesAllergyIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteAllergyAllergiesAllergyIdDeleteResponses,
    DeleteAllergyAllergiesAllergyIdDeleteErrors,
    ThrowOnError
  >({ url: '/allergies/{allergy_id}', ...options });

/**
 * Get Allergy
 *
 * Get a specific allergy by ID.
 *
 * Visible when the row is a global catalog entry or belongs to the
 * caller's agency. Other agencies' user-defined rows return 404
 * (same detail as a genuine miss).
 */
export const getAllergyAllergiesAllergyIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAllergyAllergiesAllergyIdGetData, ThrowOnError>
): RequestResult<
  GetAllergyAllergiesAllergyIdGetResponses,
  GetAllergyAllergiesAllergyIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAllergyAllergiesAllergyIdGetResponses,
    GetAllergyAllergiesAllergyIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/allergies/{allergy_id}',
    ...options,
  });

/**
 * Get Patient Allergies
 *
 * Get all allergies for a specific patient.
 */
export const getPatientAllergiesPatientsPatientIdAllergyGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPatientAllergiesPatientsPatientIdAllergyGetData,
    ThrowOnError
  >
): RequestResult<
  GetPatientAllergiesPatientsPatientIdAllergyGetResponses,
  GetPatientAllergiesPatientsPatientIdAllergyGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetPatientAllergiesPatientsPatientIdAllergyGetResponses,
    GetPatientAllergiesPatientsPatientIdAllergyGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/allergy',
    ...options,
  });

/**
 * Create Patient Allergy
 *
 * Add an allergy to a patient.
 *
 * Identify the allergen by an existing catalog allergy_id, or by a selected
 * FDB picklist result (fdb_allergen_id + fdb_allergen_name) which the server
 * verifies against FDB and materializes into the local catalog.
 *
 * The patient row is locked so the NKA check cannot race the imported-NKA
 * carry-forward setting it.
 *
 * Returns 409 (code PATIENT_ALLERGY_EXISTS) if this catalog allergy row is
 * already on the patient's chart. Detected by a pre-check and, for the
 * concurrent-create race, by mapping the uq_patient_allergy_allergy_patient_active
 * unique-constraint violation to the same coded conflict. The guard is
 * row-identity based: the same allergen reachable through a different
 * catalog row (e.g. a user-defined duplicate of an FDB row) is not detected.
 */
export const createPatientAllergyPatientsPatientIdAllergyPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreatePatientAllergyPatientsPatientIdAllergyPostData,
    ThrowOnError
  >
): RequestResult<
  CreatePatientAllergyPatientsPatientIdAllergyPostResponses,
  CreatePatientAllergyPatientsPatientIdAllergyPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreatePatientAllergyPatientsPatientIdAllergyPostResponses,
    CreatePatientAllergyPatientsPatientIdAllergyPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/allergy',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Imported Allergy Profile
 *
 * The raw Kinnser allergy profile on this chart, for display only.
 *
 * Served separately from ``GET /{patient_id}/allergy`` and typed separately.
 * A line here carries no ``fdb_allergen_id``, which is the only
 * identity drug-allergy screening reads — so an uncoded allergen can never
 * silently stand in for a screened one.
 *
 * The envelope carries what a list cannot. ``profile_imported`` false means no
 * scrape read this patient's allergy page at all; ``no_known_allergies`` true
 * means Kinnser records that the patient has none. An empty ``lines`` array
 * means neither by itself, which is exactly why both flags are here.
 */
export const getImportedAllergyProfilePatientsPatientIdAllergyImportedGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetImportedAllergyProfilePatientsPatientIdAllergyImportedGetData,
    ThrowOnError
  >
): RequestResult<
  GetImportedAllergyProfilePatientsPatientIdAllergyImportedGetResponses,
  GetImportedAllergyProfilePatientsPatientIdAllergyImportedGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetImportedAllergyProfilePatientsPatientIdAllergyImportedGetResponses,
    GetImportedAllergyProfilePatientsPatientIdAllergyImportedGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/allergy/imported',
    ...options,
  });

/**
 * Carry Forward Imported No Known Allergies
 *
 * Accept Kinnser's No Known Allergies assertion onto the Roger chart.
 *
 * RogerEMR records NKA as ``patients.no_known_allergies``, and that boolean
 * is what the order PDF, the CMS-485 and drug-allergy screening read. So
 * carrying the assertion forward means setting it — there is no second place
 * the fact could live.
 *
 * Refused when the patient already has coded allergies. "No known allergies"
 * and a list of allergies are contradictory claims, and the existing allergy
 * surface prevents the same pairing from the other direction.
 *
 * The patient row is locked: this check and every allergy-creating
 * endpoint's NKA check read state the other side is about to change, and
 * without one shared lock two concurrent requests could record both claims.
 */
export const carryForwardImportedNoKnownAllergies = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CarryForwardImportedNoKnownAllergiesData, ThrowOnError>
): RequestResult<
  CarryForwardImportedNoKnownAllergiesResponses,
  CarryForwardImportedNoKnownAllergiesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CarryForwardImportedNoKnownAllergiesResponses,
    CarryForwardImportedNoKnownAllergiesErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/allergy/imported/no-known-allergies/carry-forward',
    ...options,
  });

/**
 * Reconcile Imported Allergy Line
 *
 * Turn one raw Kinnser allergy line into a coded allergy on this chart.
 *
 * The body is the ordinary allergy create. Kinnser carries no severity and no
 * onset, so nothing is copied across — the clinician reads the imported line
 * and enters what Roger records. The reaction they type is theirs, not the
 * intake clerk's.
 *
 * The coded row and the line's retirement land in one transaction: a retired
 * line with no allergy behind it is an allergy that silently left the chart.
 *
 * The patient row is locked so this cannot interleave with the NKA
 * carry-forward: unlocked, each request reads the earlier state, locks a
 * different record, and the chart ends up asserting both no-known-allergies
 * and an allergy.
 */
export const reconcileImportedAllergyLine = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ReconcileImportedAllergyLineData, ThrowOnError>
): RequestResult<
  ReconcileImportedAllergyLineResponses,
  ReconcileImportedAllergyLineErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ReconcileImportedAllergyLineResponses,
    ReconcileImportedAllergyLineErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/allergy/imported/{line_id}/reconcile',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Decline Imported Allergy Line
 *
 * Retire one raw Kinnser allergy line without carrying it onto the chart.
 *
 * The reason is required, and it matters more here than for a medication: a
 * dropped allergy is a safety-relevant absence, and the stored reason is the
 * chart's record of why it is absent.
 */
export const declineImportedAllergyLine = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeclineImportedAllergyLineData, ThrowOnError>
): RequestResult<
  DeclineImportedAllergyLineResponses,
  DeclineImportedAllergyLineErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DeclineImportedAllergyLineResponses,
    DeclineImportedAllergyLineErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/allergy/imported/{line_id}/not-carried',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Revert Imported Allergy Line
 *
 * Undo the importer's automatic conversion of one allergy line.
 *
 * Removes the coded allergy the import made and reopens the line as raw.
 * When two Kinnser lines were merged into that one allergy, both reopen:
 * the row they shared is gone. Refused with 409 when the allergy has
 * changed in Roger since it was made.
 *
 * The patient row is locked first, as every allergy writer does, so two
 * reverts of merged lines, or a revert and a refresh, queue rather than
 * deadlock over the shared row.
 */
export const revertImportedAllergyLine = <ThrowOnError extends boolean = false>(
  options: Options<RevertImportedAllergyLineData, ThrowOnError>
): RequestResult<
  RevertImportedAllergyLineResponses,
  RevertImportedAllergyLineErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RevertImportedAllergyLineResponses,
    RevertImportedAllergyLineErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/allergy/imported/{line_id}/revert',
    ...options,
  });

/**
 * Get Imported Allergy Suggestion
 *
 * The allergen concepts the offline map suggests for one line, named live.
 *
 * A suggestion only. The Importer tool shows it beside the picker and never
 * selects it; the clinician's click does.
 */
export const getImportedAllergySuggestion = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetImportedAllergySuggestionData, ThrowOnError>
): RequestResult<
  GetImportedAllergySuggestionResponses,
  GetImportedAllergySuggestionErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetImportedAllergySuggestionResponses,
    GetImportedAllergySuggestionErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/allergy/imported/{line_id}/suggestion',
    ...options,
  });

/**
 * Create User Defined Patient Allergy
 *
 * Create and add a user-defined allergy to a patient.
 * Accepts allergy_name and reaction.
 * Reuses the agency's existing user-defined allergy of the same name
 * (case-insensitive), creating one only when none exists.
 *
 * The patient row is locked so the NKA check cannot race the imported-NKA
 * carry-forward setting it.
 *
 * Returns 409 (code PATIENT_ALLERGY_EXISTS) if this catalog allergy row is
 * already on the patient's chart. Detected by a pre-check and, for the
 * concurrent-create race, by mapping the uq_patient_allergy_allergy_patient_active
 * unique-constraint violation to the same coded conflict. The guard is
 * row-identity based: the same allergen charted via an FDB/global catalog
 * row is not detected.
 */
export const createUserDefinedPatientAllergyPatientsPatientIdAllergyUserDefinedPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      CreateUserDefinedPatientAllergyPatientsPatientIdAllergyUserDefinedPostData,
      ThrowOnError
    >
  ): RequestResult<
    CreateUserDefinedPatientAllergyPatientsPatientIdAllergyUserDefinedPostResponses,
    CreateUserDefinedPatientAllergyPatientsPatientIdAllergyUserDefinedPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      CreateUserDefinedPatientAllergyPatientsPatientIdAllergyUserDefinedPostResponses,
      CreateUserDefinedPatientAllergyPatientsPatientIdAllergyUserDefinedPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/allergy/user-defined',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Delete Patient Allergy
 *
 * Delete a patient allergy entry.
 */
export const deletePatientAllergyPatientsAllergyPatientAllergyIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeletePatientAllergyPatientsAllergyPatientAllergyIdDeleteData,
    ThrowOnError
  >
): RequestResult<
  DeletePatientAllergyPatientsAllergyPatientAllergyIdDeleteResponses,
  DeletePatientAllergyPatientsAllergyPatientAllergyIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeletePatientAllergyPatientsAllergyPatientAllergyIdDeleteResponses,
    DeletePatientAllergyPatientsAllergyPatientAllergyIdDeleteErrors,
    ThrowOnError
  >({ url: '/patients/allergy/{patient_allergy_id}', ...options });

/**
 * List Patient Insurances
 */
export const listPatientInsurancesPatientsPatientIdInsuranceGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListPatientInsurancesPatientsPatientIdInsuranceGetData,
    ThrowOnError
  >
): RequestResult<
  ListPatientInsurancesPatientsPatientIdInsuranceGetResponses,
  ListPatientInsurancesPatientsPatientIdInsuranceGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListPatientInsurancesPatientsPatientIdInsuranceGetResponses,
    ListPatientInsurancesPatientsPatientIdInsuranceGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/insurance',
    ...options,
  });

/**
 * Create Patient Insurance
 */
export const createPatientInsurancePatientsPatientIdInsurancePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreatePatientInsurancePatientsPatientIdInsurancePostData,
    ThrowOnError
  >
): RequestResult<
  CreatePatientInsurancePatientsPatientIdInsurancePostResponses,
  CreatePatientInsurancePatientsPatientIdInsurancePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreatePatientInsurancePatientsPatientIdInsurancePostResponses,
    CreatePatientInsurancePatientsPatientIdInsurancePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/insurance',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Patient Insurance
 */
export const deletePatientInsurancePatientsPatientIdInsurancePatientInsuranceIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeletePatientInsurancePatientsPatientIdInsurancePatientInsuranceIdDeleteData,
      ThrowOnError
    >
  ): RequestResult<
    DeletePatientInsurancePatientsPatientIdInsurancePatientInsuranceIdDeleteResponses,
    DeletePatientInsurancePatientsPatientIdInsurancePatientInsuranceIdDeleteErrors,
    ThrowOnError
  > =>
    (options.client ?? client).delete<
      DeletePatientInsurancePatientsPatientIdInsurancePatientInsuranceIdDeleteResponses,
      DeletePatientInsurancePatientsPatientIdInsurancePatientInsuranceIdDeleteErrors,
      ThrowOnError
    >({
      url: '/patients/{patient_id}/insurance/{patient_insurance_id}',
      ...options,
    });

/**
 * Get Patient Insurance
 */
export const getPatientInsurancePatientsPatientIdInsurancePatientInsuranceIdGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetPatientInsurancePatientsPatientIdInsurancePatientInsuranceIdGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetPatientInsurancePatientsPatientIdInsurancePatientInsuranceIdGetResponses,
    GetPatientInsurancePatientsPatientIdInsurancePatientInsuranceIdGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetPatientInsurancePatientsPatientIdInsurancePatientInsuranceIdGetResponses,
      GetPatientInsurancePatientsPatientIdInsurancePatientInsuranceIdGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/insurance/{patient_insurance_id}',
      ...options,
    });

/**
 * Update Patient Insurance
 */
export const updatePatientInsurancePatientsPatientIdInsurancePatientInsuranceIdPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdatePatientInsurancePatientsPatientIdInsurancePatientInsuranceIdPutData,
      ThrowOnError
    >
  ): RequestResult<
    UpdatePatientInsurancePatientsPatientIdInsurancePatientInsuranceIdPutResponses,
    UpdatePatientInsurancePatientsPatientIdInsurancePatientInsuranceIdPutErrors,
    ThrowOnError
  > =>
    (options.client ?? client).put<
      UpdatePatientInsurancePatientsPatientIdInsurancePatientInsuranceIdPutResponses,
      UpdatePatientInsurancePatientsPatientIdInsurancePatientInsuranceIdPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/insurance/{patient_insurance_id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Search Medications Endpoint
 *
 * Search the live FDB medication catalog (auth required).
 *
 * Text search with optional form/route filters (``form``/``route`` carry FDB
 * ``doseFormID``/``routeID`` from the facet options). Results are reranked and
 * paginated; each item is an FDB-proxied row with no local id until it is
 * selected and materialized.
 */
export const searchMedicationsEndpointMedicationsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<SearchMedicationsEndpointMedicationsGetData, ThrowOnError>
): RequestResult<
  SearchMedicationsEndpointMedicationsGetResponses,
  SearchMedicationsEndpointMedicationsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    SearchMedicationsEndpointMedicationsGetResponses,
    SearchMedicationsEndpointMedicationsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/medications/',
    ...options,
  });

/**
 * Get Medication Endpoint
 *
 * Get a specific medication by ID.
 *
 * Args:
 * medication_id: Medication UUID
 *
 * Returns:
 * Medication record
 *
 * Raises:
 * HTTPException: If medication not found
 */
export const getMedicationEndpointMedicationsMedicationIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetMedicationEndpointMedicationsMedicationIdGetData,
    ThrowOnError
  >
): RequestResult<
  GetMedicationEndpointMedicationsMedicationIdGetResponses,
  GetMedicationEndpointMedicationsMedicationIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetMedicationEndpointMedicationsMedicationIdGetResponses,
    GetMedicationEndpointMedicationsMedicationIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/medications/{medication_id}',
    ...options,
  });

/**
 * Get Patient Medications
 *
 * Get all medications for a patient.
 *
 * Optionally filter out discontinued medications with include_discontinued=false.
 */
export const getPatientMedicationsPatientsPatientIdMedicationsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPatientMedicationsPatientsPatientIdMedicationsGetData,
    ThrowOnError
  >
): RequestResult<
  GetPatientMedicationsPatientsPatientIdMedicationsGetResponses,
  GetPatientMedicationsPatientsPatientIdMedicationsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetPatientMedicationsPatientsPatientIdMedicationsGetResponses,
    GetPatientMedicationsPatientsPatientIdMedicationsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/medications/',
    ...options,
  });

/**
 * Create Patient Medication
 *
 * Create a new medication for a patient.
 *
 * For on-market medications, provide either medication_id or
 * fdb_dispensable_drug_id (a selected FDB search result, which the
 * server materializes into a local medication row). For off-market
 * medications, set is_off_market=true and provide off_market_description.
 */
export const createPatientMedicationPatientsPatientIdMedicationsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreatePatientMedicationPatientsPatientIdMedicationsPostData,
    ThrowOnError
  >
): RequestResult<
  CreatePatientMedicationPatientsPatientIdMedicationsPostResponses,
  CreatePatientMedicationPatientsPatientIdMedicationsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreatePatientMedicationPatientsPatientIdMedicationsPostResponses,
    CreatePatientMedicationPatientsPatientIdMedicationsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/medications/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Imported Medication Lines
 *
 * The raw Kinnser medication profile on this chart, for display only.
 *
 * Served separately from ``GET /`` and typed separately.
 * These rows carry no FDB concept: they are what another EMR held, not
 * what a clinician has asserted here. Keeping them out of the coded
 * list is what stops one reaching drug-interaction screening, the MAR,
 * order generation or the CMS-485 — every one of which takes the coded
 * list and would treat anything in it as clinical fact.
 *
 * A caller that wants the whole medication picture calls both and shows
 * them apart. That separation is the feature, not an inconvenience.
 *
 * The envelope carries what the lines cannot: whether the profile was
 * ever read, and whether the discontinued lines are a thirty-day window
 * rather than full history. Both change what an empty list is entitled
 * to mean.
 *
 * Web mount only. The separation above depends on a human reading the
 * two lists apart, which is exactly what the service-to-service mount
 * has none of.
 */
export const getImportedMedicationLinesPatientsPatientIdMedicationsImportedGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetImportedMedicationLinesPatientsPatientIdMedicationsImportedGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetImportedMedicationLinesPatientsPatientIdMedicationsImportedGetResponses,
    GetImportedMedicationLinesPatientsPatientIdMedicationsImportedGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetImportedMedicationLinesPatientsPatientIdMedicationsImportedGetResponses,
      GetImportedMedicationLinesPatientsPatientIdMedicationsImportedGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/medications/imported',
      ...options,
    });

/**
 * Reconcile Imported Medication Line
 *
 * Turn one raw Kinnser line into a coded medication on this chart.
 *
 * The body is an ordinary medication create — the same one the Add
 * Medication dialog sends, and deliberately nothing more. Kinnser
 * carries no prescriber, no route and no frequency worth trusting, so
 * the clinician supplies them here and the created row asserts only
 * what they entered. Nothing is copied across from the line: the line
 * is evidence they read, not a source the server merges in.
 *
 * The coded row and the line's retirement land in one transaction. A
 * failed insert must leave the line raw and outstanding, because a
 * retired line with no medication behind it is a drug that silently
 * left the chart.
 */
export const reconcileImportedMedicationLine = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ReconcileImportedMedicationLineData, ThrowOnError>
): RequestResult<
  ReconcileImportedMedicationLineResponses,
  ReconcileImportedMedicationLineErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ReconcileImportedMedicationLineResponses,
    ReconcileImportedMedicationLineErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/medications/imported/{line_id}/reconcile',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Revert Imported Medication Line
 *
 * Undo the importer's automatic conversion of one line.
 *
 * Removes the coded medication the import made and reopens the line
 * as raw, so it waits in the Importer tool like any other. Refused
 * with 409 when the medication has changed in Roger since, or a
 * visit's MAR records it: that is a clinician's work now. Only a line
 * the importer converted can be reverted; a clinician's ruling is
 * changed by editing the medication itself.
 */
export const revertImportedMedicationLine = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RevertImportedMedicationLineData, ThrowOnError>
): RequestResult<
  RevertImportedMedicationLineResponses,
  RevertImportedMedicationLineErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RevertImportedMedicationLineResponses,
    RevertImportedMedicationLineErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/medications/imported/{line_id}/revert',
    ...options,
  });

/**
 * Get Imported Medication Suggestion
 *
 * The drug the offline map suggests for one line, named live.
 *
 * A suggestion only. The Importer tool shows it beside the picker
 * and never selects it; the clinician's click does. Behind the
 * reconcile gate because only the tool reads it.
 */
export const getImportedMedicationSuggestion = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetImportedMedicationSuggestionData, ThrowOnError>
): RequestResult<
  GetImportedMedicationSuggestionResponses,
  GetImportedMedicationSuggestionErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetImportedMedicationSuggestionResponses,
    GetImportedMedicationSuggestionErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/medications/imported/{line_id}/suggestion',
    ...options,
  });

/**
 * Decline Imported Medication Line
 *
 * Retire one raw Kinnser line without carrying it onto the chart.
 *
 * The reason is required. It stays on the retired line, so the chart
 * itself records why the drug was not carried forward.
 */
export const declineImportedMedicationLine = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeclineImportedMedicationLineData, ThrowOnError>
): RequestResult<
  DeclineImportedMedicationLineResponses,
  DeclineImportedMedicationLineErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DeclineImportedMedicationLineResponses,
    DeclineImportedMedicationLineErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/medications/imported/{line_id}/not-carried',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Medication Order Launch Validation
 */
export const getMedicationOrderLaunchValidation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetMedicationOrderLaunchValidationData, ThrowOnError>
): RequestResult<
  GetMedicationOrderLaunchValidationResponses,
  GetMedicationOrderLaunchValidationErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetMedicationOrderLaunchValidationResponses,
    GetMedicationOrderLaunchValidationErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/medications/orders/launch-validation',
    ...options,
  });

/**
 * Create Order From Medications
 */
export const createMedicationOrder = <ThrowOnError extends boolean = false>(
  options: Options<CreateMedicationOrderData, ThrowOnError>
): RequestResult<
  CreateMedicationOrderResponses,
  CreateMedicationOrderErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateMedicationOrderResponses,
    CreateMedicationOrderErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/medications/orders',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Screen Medication Interactions
 *
 * Preview drug-drug and drug-allergy interaction screening.
 *
 * Runs the same screen the sign flow performs, for display only — the
 * result is not persisted. Absorbs FDB latency ahead of signing.
 */
export const screenMedicationInteractions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ScreenMedicationInteractionsData, ThrowOnError>
): RequestResult<
  ScreenMedicationInteractionsResponses,
  ScreenMedicationInteractionsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ScreenMedicationInteractionsResponses,
    ScreenMedicationInteractionsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/medications/screen',
    ...options,
  });

/**
 * Screen Candidate Medication
 *
 * Prospectively screen a drug being considered for assignment.
 *
 * Screens the candidate against the patient's current medications and
 * allergies, narrowed to findings involving the candidate. Advisory
 * only — nothing is persisted and assignment is never blocked; the
 * authoritative screen still runs at signing.
 */
export const screenCandidateMedication = <ThrowOnError extends boolean = false>(
  options: Options<ScreenCandidateMedicationData, ThrowOnError>
): RequestResult<
  ScreenCandidateMedicationResponses,
  ScreenCandidateMedicationErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ScreenCandidateMedicationResponses,
    ScreenCandidateMedicationErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/medications/screen/candidate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Print Patient Medications
 *
 * Unsigned current medication list for office staff.
 *
 * Lists medications started on or before the clinic's business date and
 * not stopped by it. Nothing is saved or audited.
 */
export const printPatientMedicationsPatientsPatientIdMedicationsPrintGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PrintPatientMedicationsPatientsPatientIdMedicationsPrintGetData,
    ThrowOnError
  >
): RequestResult<
  PrintPatientMedicationsPatientsPatientIdMedicationsPrintGetResponses,
  PrintPatientMedicationsPatientsPatientIdMedicationsPrintGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    PrintPatientMedicationsPatientsPatientIdMedicationsPrintGetResponses,
    PrintPatientMedicationsPatientsPatientIdMedicationsPrintGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/patients/{patient_id}/medications/print',
    ...options,
  });

/**
 * Get Medication Pdf
 *
 * Generate and return a Patient Medication Record PDF.
 *
 * Includes:
 * - Pharmacy on file (or "None on file")
 * - Medications grouped by: Future, Current, Discontinued
 * - Legend with status indicators (LS, N, C)
 * - Form sections for physician contact and medication interactions
 * - Signature section
 *
 * The PDF is dynamically generated from current medication data.
 *
 * Args:
 * patient_id: Patient UUID
 * db: Database session
 * ctx: Current context for agency-based access control
 *
 * Returns:
 * PDF file as application/pdf response
 *
 * Raises:
 * HTTPException: If patient not found or PDF generation fails
 */
export const getMedicationPdfPatientsPatientIdMedicationsPdfPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetMedicationPdfPatientsPatientIdMedicationsPdfPostData,
    ThrowOnError
  >
): RequestResult<
  GetMedicationPdfPatientsPatientIdMedicationsPdfPostResponses,
  GetMedicationPdfPatientsPatientIdMedicationsPdfPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GetMedicationPdfPatientsPatientIdMedicationsPdfPostResponses,
    GetMedicationPdfPatientsPatientIdMedicationsPdfPostErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/patients/{patient_id}/medications/pdf',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Patient Medication
 *
 * Delete a medication.
 */
export const deletePatientMedicationPatientsPatientIdMedicationsMedicationIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeletePatientMedicationPatientsPatientIdMedicationsMedicationIdDeleteData,
      ThrowOnError
    >
  ): RequestResult<
    DeletePatientMedicationPatientsPatientIdMedicationsMedicationIdDeleteResponses,
    DeletePatientMedicationPatientsPatientIdMedicationsMedicationIdDeleteErrors,
    ThrowOnError
  > =>
    (options.client ?? client).delete<
      DeletePatientMedicationPatientsPatientIdMedicationsMedicationIdDeleteResponses,
      DeletePatientMedicationPatientsPatientIdMedicationsMedicationIdDeleteErrors,
      ThrowOnError
    >({
      url: '/patients/{patient_id}/medications/{medication_id}',
      ...options,
    });

/**
 * Get Patient Medication
 *
 * Get a specific medication by ID.
 */
export const getPatientMedicationPatientsPatientIdMedicationsMedicationIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPatientMedicationPatientsPatientIdMedicationsMedicationIdGetData,
    ThrowOnError
  >
): RequestResult<
  GetPatientMedicationPatientsPatientIdMedicationsMedicationIdGetResponses,
  GetPatientMedicationPatientsPatientIdMedicationsMedicationIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetPatientMedicationPatientsPatientIdMedicationsMedicationIdGetResponses,
    GetPatientMedicationPatientsPatientIdMedicationsMedicationIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/medications/{medication_id}',
    ...options,
  });

/**
 * Update Patient Medication
 *
 * Update a medication.
 */
export const updatePatientMedicationPatientsPatientIdMedicationsMedicationIdPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdatePatientMedicationPatientsPatientIdMedicationsMedicationIdPutData,
      ThrowOnError
    >
  ): RequestResult<
    UpdatePatientMedicationPatientsPatientIdMedicationsMedicationIdPutResponses,
    UpdatePatientMedicationPatientsPatientIdMedicationsMedicationIdPutErrors,
    ThrowOnError
  > =>
    (options.client ?? client).put<
      UpdatePatientMedicationPatientsPatientIdMedicationsMedicationIdPutResponses,
      UpdatePatientMedicationPatientsPatientIdMedicationsMedicationIdPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/medications/{medication_id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Get Medication Profile Attachments
 *
 * Get all medication profile attachments for a patient.
 */
export const getMedicationProfileAttachmentsPatientsPatientIdMedicationsAttachmentsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetMedicationProfileAttachmentsPatientsPatientIdMedicationsAttachmentsGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetMedicationProfileAttachmentsPatientsPatientIdMedicationsAttachmentsGetResponses,
    GetMedicationProfileAttachmentsPatientsPatientIdMedicationsAttachmentsGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetMedicationProfileAttachmentsPatientsPatientIdMedicationsAttachmentsGetResponses,
      GetMedicationProfileAttachmentsPatientsPatientIdMedicationsAttachmentsGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/medications/attachments/',
      ...options,
    });

/**
 * Upload Medication Profile Attachment
 *
 * Upload a new attachment to the patient's medication profile.
 */
export const uploadMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UploadMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsPostData,
      ThrowOnError
    >
  ): RequestResult<
    UploadMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsPostResponses,
    UploadMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      UploadMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsPostResponses,
      UploadMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsPostErrors,
      ThrowOnError
    >({
      ...formDataBodySerializer,
      responseType: 'json',
      url: '/patients/{patient_id}/medications/attachments/',
      ...options,
      headers: {
        'Content-Type': null,
        ...options.headers,
      },
    });

/**
 * Get Medication Attachment Url
 *
 * Get a presigned URL to download an attachment.
 */
export const getMedicationAttachmentUrlPatientsPatientIdMedicationsAttachmentsAttachmentIdUrlGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetMedicationAttachmentUrlPatientsPatientIdMedicationsAttachmentsAttachmentIdUrlGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetMedicationAttachmentUrlPatientsPatientIdMedicationsAttachmentsAttachmentIdUrlGetResponses,
    GetMedicationAttachmentUrlPatientsPatientIdMedicationsAttachmentsAttachmentIdUrlGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetMedicationAttachmentUrlPatientsPatientIdMedicationsAttachmentsAttachmentIdUrlGetResponses,
      GetMedicationAttachmentUrlPatientsPatientIdMedicationsAttachmentsAttachmentIdUrlGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/medications/attachments/{attachment_id}/url',
      ...options,
    });

/**
 * Delete Medication Profile Attachment
 *
 * Delete a medication profile attachment.
 */
export const deleteMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsAttachmentIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsAttachmentIdDeleteData,
      ThrowOnError
    >
  ): RequestResult<
    DeleteMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsAttachmentIdDeleteResponses,
    DeleteMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsAttachmentIdDeleteErrors,
    ThrowOnError
  > =>
    (options.client ?? client).delete<
      DeleteMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsAttachmentIdDeleteResponses,
      DeleteMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsAttachmentIdDeleteErrors,
      ThrowOnError
    >({
      url: '/patients/{patient_id}/medications/attachments/{attachment_id}',
      ...options,
    });

/**
 * Get Patient Pharmacy
 *
 * Get the pharmacy for a patient, or null if none is set.
 */
export const getPatientPharmacyPatientsPatientIdPharmacyGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPatientPharmacyPatientsPatientIdPharmacyGetData,
    ThrowOnError
  >
): RequestResult<
  GetPatientPharmacyPatientsPatientIdPharmacyGetResponses,
  GetPatientPharmacyPatientsPatientIdPharmacyGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetPatientPharmacyPatientsPatientIdPharmacyGetResponses,
    GetPatientPharmacyPatientsPatientIdPharmacyGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/pharmacy',
    ...options,
  });

/**
 * Upsert Patient Pharmacy
 *
 * Create or update the pharmacy for a patient.
 *
 * Returns null when every field is empty, which clears the pharmacy.
 */
export const upsertPatientPharmacyPatientsPatientIdPharmacyPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpsertPatientPharmacyPatientsPatientIdPharmacyPutData,
    ThrowOnError
  >
): RequestResult<
  UpsertPatientPharmacyPatientsPatientIdPharmacyPutResponses,
  UpsertPatientPharmacyPatientsPatientIdPharmacyPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpsertPatientPharmacyPatientsPatientIdPharmacyPutResponses,
    UpsertPatientPharmacyPatientsPatientIdPharmacyPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/pharmacy',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Mar Medications
 *
 * List all administration records for a visit.
 */
export const listMarMedicationsPatientsPatientIdVisitsVisitIdMarGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListMarMedicationsPatientsPatientIdVisitsVisitIdMarGetData,
    ThrowOnError
  >
): RequestResult<
  ListMarMedicationsPatientsPatientIdVisitsVisitIdMarGetResponses,
  ListMarMedicationsPatientsPatientIdVisitsVisitIdMarGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListMarMedicationsPatientsPatientIdVisitsVisitIdMarGetResponses,
    ListMarMedicationsPatientsPatientIdVisitsVisitIdMarGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/visits/{visit_id}/mar/',
    ...options,
  });

/**
 * Create Mar Medication
 *
 * Record an administration of a profile medication during the visit.
 */
export const createMarMedicationPatientsPatientIdVisitsVisitIdMarPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateMarMedicationPatientsPatientIdVisitsVisitIdMarPostData,
    ThrowOnError
  >
): RequestResult<
  CreateMarMedicationPatientsPatientIdVisitsVisitIdMarPostResponses,
  CreateMarMedicationPatientsPatientIdVisitsVisitIdMarPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateMarMedicationPatientsPatientIdVisitsVisitIdMarPostResponses,
    CreateMarMedicationPatientsPatientIdVisitsVisitIdMarPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/visits/{visit_id}/mar/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Mar Medication
 *
 * Delete a MAR entry.
 */
export const deleteMarMedicationPatientsPatientIdVisitsVisitIdMarMarIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteMarMedicationPatientsPatientIdVisitsVisitIdMarMarIdDeleteData,
    ThrowOnError
  >
): RequestResult<
  DeleteMarMedicationPatientsPatientIdVisitsVisitIdMarMarIdDeleteResponses,
  DeleteMarMedicationPatientsPatientIdVisitsVisitIdMarMarIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteMarMedicationPatientsPatientIdVisitsVisitIdMarMarIdDeleteResponses,
    DeleteMarMedicationPatientsPatientIdVisitsVisitIdMarMarIdDeleteErrors,
    ThrowOnError
  >({
    url: '/patients/{patient_id}/visits/{visit_id}/mar/{mar_id}',
    ...options,
  });

/**
 * Update Mar Medication
 *
 * Update the administration details of a MAR entry.
 */
export const updateMarMedicationPatientsPatientIdVisitsVisitIdMarMarIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateMarMedicationPatientsPatientIdVisitsVisitIdMarMarIdPutData,
    ThrowOnError
  >
): RequestResult<
  UpdateMarMedicationPatientsPatientIdVisitsVisitIdMarMarIdPutResponses,
  UpdateMarMedicationPatientsPatientIdVisitsVisitIdMarMarIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateMarMedicationPatientsPatientIdVisitsVisitIdMarMarIdPutResponses,
    UpdateMarMedicationPatientsPatientIdVisitsVisitIdMarMarIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/visits/{visit_id}/mar/{mar_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Patient Wounds
 *
 * Get all wounds for a patient.
 *
 * Optionally filter out healed wounds with include_discontinued=false.
 */
export const getPatientWoundsPatientsPatientIdWoundsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetPatientWoundsPatientsPatientIdWoundsGetData, ThrowOnError>
): RequestResult<
  GetPatientWoundsPatientsPatientIdWoundsGetResponses,
  GetPatientWoundsPatientsPatientIdWoundsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetPatientWoundsPatientsPatientIdWoundsGetResponses,
    GetPatientWoundsPatientsPatientIdWoundsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/wounds/',
    ...options,
  });

/**
 * Create Patient Wound
 *
 * Create a new wound for a patient.
 */
export const createPatientWoundPatientsPatientIdWoundsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreatePatientWoundPatientsPatientIdWoundsPostData,
    ThrowOnError
  >
): RequestResult<
  CreatePatientWoundPatientsPatientIdWoundsPostResponses,
  CreatePatientWoundPatientsPatientIdWoundsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreatePatientWoundPatientsPatientIdWoundsPostResponses,
    CreatePatientWoundPatientsPatientIdWoundsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/wounds/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Patient Wound Visit Activity
 *
 * Per-visit distinct wound counts (added, assessed, or discontinued).
 */
export const getPatientWoundVisitActivityPatientsPatientIdWoundsVisitActivityGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetPatientWoundVisitActivityPatientsPatientIdWoundsVisitActivityGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetPatientWoundVisitActivityPatientsPatientIdWoundsVisitActivityGetResponses,
    GetPatientWoundVisitActivityPatientsPatientIdWoundsVisitActivityGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetPatientWoundVisitActivityPatientsPatientIdWoundsVisitActivityGetResponses,
      GetPatientWoundVisitActivityPatientsPatientIdWoundsVisitActivityGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/wounds/visit-activity',
      ...options,
    });

/**
 * Delete Patient Wound
 *
 * Delete a wound. Blocked if the wound has any assessments.
 */
export const deletePatientWoundPatientsPatientIdWoundsWoundIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeletePatientWoundPatientsPatientIdWoundsWoundIdDeleteData,
    ThrowOnError
  >
): RequestResult<
  DeletePatientWoundPatientsPatientIdWoundsWoundIdDeleteResponses,
  DeletePatientWoundPatientsPatientIdWoundsWoundIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeletePatientWoundPatientsPatientIdWoundsWoundIdDeleteResponses,
    DeletePatientWoundPatientsPatientIdWoundsWoundIdDeleteErrors,
    ThrowOnError
  >({ url: '/patients/{patient_id}/wounds/{wound_id}', ...options });

/**
 * Update Patient Wound
 *
 * Update a wound (including marking it as healed).
 */
export const updatePatientWoundPatientsPatientIdWoundsWoundIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdatePatientWoundPatientsPatientIdWoundsWoundIdPutData,
    ThrowOnError
  >
): RequestResult<
  UpdatePatientWoundPatientsPatientIdWoundsWoundIdPutResponses,
  UpdatePatientWoundPatientsPatientIdWoundsWoundIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdatePatientWoundPatientsPatientIdWoundsWoundIdPutResponses,
    UpdatePatientWoundPatientsPatientIdWoundsWoundIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/wounds/{wound_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Wound Care Worksheet Pdf
 *
 * Generate a Wound Care Worksheet PDF for a specific visit.
 *
 * Includes wounds added, discontinued, addressed, or left unassessed on the visit.
 */
export const getWoundCareWorksheetPdfPatientsPatientIdWoundsPdfPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetWoundCareWorksheetPdfPatientsPatientIdWoundsPdfPostData,
    ThrowOnError
  >
): RequestResult<
  GetWoundCareWorksheetPdfPatientsPatientIdWoundsPdfPostResponses,
  GetWoundCareWorksheetPdfPatientsPatientIdWoundsPdfPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GetWoundCareWorksheetPdfPatientsPatientIdWoundsPdfPostResponses,
    GetWoundCareWorksheetPdfPatientsPatientIdWoundsPdfPostErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/patients/{patient_id}/wounds/pdf',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Wound Assessments
 *
 * Get all assessments for a wound.
 */
export const getWoundAssessmentsPatientsPatientIdWoundsWoundIdAssessmentsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetWoundAssessmentsPatientsPatientIdWoundsWoundIdAssessmentsGetData,
    ThrowOnError
  >
): RequestResult<
  GetWoundAssessmentsPatientsPatientIdWoundsWoundIdAssessmentsGetResponses,
  GetWoundAssessmentsPatientsPatientIdWoundsWoundIdAssessmentsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetWoundAssessmentsPatientsPatientIdWoundsWoundIdAssessmentsGetResponses,
    GetWoundAssessmentsPatientsPatientIdWoundsWoundIdAssessmentsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/wounds/{wound_id}/assessments',
    ...options,
  });

/**
 * Create Wound Assessment
 *
 * Create a new assessment for a wound.
 *
 * Returns 409 (code WOUND_ASSESSMENT_EXISTS) when the wound already has an
 * assessment on this visit; a wound holds one assessment per visit.
 */
export const createWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      CreateWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsPostData,
      ThrowOnError
    >
  ): RequestResult<
    CreateWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsPostResponses,
    CreateWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      CreateWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsPostResponses,
      CreateWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/wounds/{wound_id}/assessments',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Delete Wound Assessment
 *
 * Delete a wound assessment.
 */
export const deleteWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsAssessmentIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsAssessmentIdDeleteData,
      ThrowOnError
    >
  ): RequestResult<
    DeleteWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsAssessmentIdDeleteResponses,
    DeleteWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsAssessmentIdDeleteErrors,
    ThrowOnError
  > =>
    (options.client ?? client).delete<
      DeleteWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsAssessmentIdDeleteResponses,
      DeleteWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsAssessmentIdDeleteErrors,
      ThrowOnError
    >({
      url: '/patients/{patient_id}/wounds/{wound_id}/assessments/{assessment_id}',
      ...options,
    });

/**
 * Update Wound Assessment
 *
 * Update a wound assessment.
 */
export const updateWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsAssessmentIdPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdateWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsAssessmentIdPutData,
      ThrowOnError
    >
  ): RequestResult<
    UpdateWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsAssessmentIdPutResponses,
    UpdateWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsAssessmentIdPutErrors,
    ThrowOnError
  > =>
    (options.client ?? client).put<
      UpdateWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsAssessmentIdPutResponses,
      UpdateWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsAssessmentIdPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/wounds/{wound_id}/assessments/{assessment_id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Get Wound Attachments
 *
 * Get all attachments for a wound, optionally filtered by assessment.
 */
export const getWoundAttachmentsPatientsPatientIdWoundsWoundIdAttachmentsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetWoundAttachmentsPatientsPatientIdWoundsWoundIdAttachmentsGetData,
    ThrowOnError
  >
): RequestResult<
  GetWoundAttachmentsPatientsPatientIdWoundsWoundIdAttachmentsGetResponses,
  GetWoundAttachmentsPatientsPatientIdWoundsWoundIdAttachmentsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetWoundAttachmentsPatientsPatientIdWoundsWoundIdAttachmentsGetResponses,
    GetWoundAttachmentsPatientsPatientIdWoundsWoundIdAttachmentsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/wounds/{wound_id}/attachments/',
    ...options,
  });

/**
 * Upload Wound Attachment
 *
 * Upload an attachment for a wound, optionally scoped to an assessment.
 */
export const uploadWoundAttachmentPatientsPatientIdWoundsWoundIdAttachmentsPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UploadWoundAttachmentPatientsPatientIdWoundsWoundIdAttachmentsPostData,
      ThrowOnError
    >
  ): RequestResult<
    UploadWoundAttachmentPatientsPatientIdWoundsWoundIdAttachmentsPostResponses,
    UploadWoundAttachmentPatientsPatientIdWoundsWoundIdAttachmentsPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      UploadWoundAttachmentPatientsPatientIdWoundsWoundIdAttachmentsPostResponses,
      UploadWoundAttachmentPatientsPatientIdWoundsWoundIdAttachmentsPostErrors,
      ThrowOnError
    >({
      ...formDataBodySerializer,
      responseType: 'json',
      url: '/patients/{patient_id}/wounds/{wound_id}/attachments/',
      ...options,
      headers: {
        'Content-Type': null,
        ...options.headers,
      },
    });

/**
 * Ingest Wound Attachments From S3
 *
 * Ingest wound images from a source S3 bucket.
 *
 * Used by RogerDocs to push wound photos at fill-time: it passes the S3 keys
 * of the images already in its bucket, and we download → re-upload into the
 * EMR's own bucket and create a WoundAttachment row per item.
 *
 * Per-item failures are returned in the `errors` list; successful items land
 * in `attachments`. A re-sent file (same wound + file_name) is skipped and
 * its existing record is returned in `attachments`; see
 * `WoundAttachmentCRUD.find_or_adopt_by_dedupe_key` for the assessment rule.
 */
export const ingestWoundAttachmentsFromS3PatientsPatientIdWoundsWoundIdAttachmentsFromS3Post =
  <ThrowOnError extends boolean = false>(
    options: Options<
      IngestWoundAttachmentsFromS3PatientsPatientIdWoundsWoundIdAttachmentsFromS3PostData,
      ThrowOnError
    >
  ): RequestResult<
    IngestWoundAttachmentsFromS3PatientsPatientIdWoundsWoundIdAttachmentsFromS3PostResponses,
    IngestWoundAttachmentsFromS3PatientsPatientIdWoundsWoundIdAttachmentsFromS3PostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      IngestWoundAttachmentsFromS3PatientsPatientIdWoundsWoundIdAttachmentsFromS3PostResponses,
      IngestWoundAttachmentsFromS3PatientsPatientIdWoundsWoundIdAttachmentsFromS3PostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/wounds/{wound_id}/attachments/from-s3',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Ingest Wound Attachments From Url
 *
 * Ingest wound images from presigned HTTPS GET URLs.
 *
 * Used by RogerDocs at fill-time: it generates short-lived presigned URLs for
 * wound photos in its bucket and passes them here. RogerEMR downloads each
 * URL via HTTP (no cross-account S3 IAM), re-uploads into the EMR bucket, and
 * creates a WoundAttachment row per item.
 *
 * Per-item failures are returned in the `errors` list; successful items land
 * in `attachments`. A re-sent file (same wound + file_name) is skipped and
 * its existing record is returned in `attachments`; see
 * `WoundAttachmentCRUD.find_or_adopt_by_dedupe_key` for the assessment rule.
 */
export const ingestWoundAttachmentsFromUrlPatientsPatientIdWoundsWoundIdAttachmentsFromUrlPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      IngestWoundAttachmentsFromUrlPatientsPatientIdWoundsWoundIdAttachmentsFromUrlPostData,
      ThrowOnError
    >
  ): RequestResult<
    IngestWoundAttachmentsFromUrlPatientsPatientIdWoundsWoundIdAttachmentsFromUrlPostResponses,
    IngestWoundAttachmentsFromUrlPatientsPatientIdWoundsWoundIdAttachmentsFromUrlPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      IngestWoundAttachmentsFromUrlPatientsPatientIdWoundsWoundIdAttachmentsFromUrlPostResponses,
      IngestWoundAttachmentsFromUrlPatientsPatientIdWoundsWoundIdAttachmentsFromUrlPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/wounds/{wound_id}/attachments/from-url',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Get Wound Attachment Url
 *
 * Get a presigned URL to download a wound attachment.
 */
export const getWoundAttachmentUrlPatientsPatientIdWoundsWoundIdAttachmentsAttachmentIdUrlGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetWoundAttachmentUrlPatientsPatientIdWoundsWoundIdAttachmentsAttachmentIdUrlGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetWoundAttachmentUrlPatientsPatientIdWoundsWoundIdAttachmentsAttachmentIdUrlGetResponses,
    GetWoundAttachmentUrlPatientsPatientIdWoundsWoundIdAttachmentsAttachmentIdUrlGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetWoundAttachmentUrlPatientsPatientIdWoundsWoundIdAttachmentsAttachmentIdUrlGetResponses,
      GetWoundAttachmentUrlPatientsPatientIdWoundsWoundIdAttachmentsAttachmentIdUrlGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/wounds/{wound_id}/attachments/{attachment_id}/url',
      ...options,
    });

/**
 * Delete Wound Attachment
 *
 * Delete a wound attachment (soft delete; the stored file is kept).
 */
export const deleteWoundAttachmentPatientsPatientIdWoundsWoundIdAttachmentsAttachmentIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteWoundAttachmentPatientsPatientIdWoundsWoundIdAttachmentsAttachmentIdDeleteData,
      ThrowOnError
    >
  ): RequestResult<
    DeleteWoundAttachmentPatientsPatientIdWoundsWoundIdAttachmentsAttachmentIdDeleteResponses,
    DeleteWoundAttachmentPatientsPatientIdWoundsWoundIdAttachmentsAttachmentIdDeleteErrors,
    ThrowOnError
  > =>
    (options.client ?? client).delete<
      DeleteWoundAttachmentPatientsPatientIdWoundsWoundIdAttachmentsAttachmentIdDeleteResponses,
      DeleteWoundAttachmentPatientsPatientIdWoundsWoundIdAttachmentsAttachmentIdDeleteErrors,
      ThrowOnError
    >({
      url: '/patients/{patient_id}/wounds/{wound_id}/attachments/{attachment_id}',
      ...options,
    });

/**
 * List Infection Logs
 */
export const listInfectionLogsPatientsPatientIdInfectionLogsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListInfectionLogsPatientsPatientIdInfectionLogsGetData,
    ThrowOnError
  >
): RequestResult<
  ListInfectionLogsPatientsPatientIdInfectionLogsGetResponses,
  ListInfectionLogsPatientsPatientIdInfectionLogsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListInfectionLogsPatientsPatientIdInfectionLogsGetResponses,
    ListInfectionLogsPatientsPatientIdInfectionLogsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/infection-logs/',
    ...options,
  });

/**
 * Create Infection Log Endpoint
 */
export const createInfectionLogEndpointPatientsPatientIdInfectionLogsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateInfectionLogEndpointPatientsPatientIdInfectionLogsPostData,
    ThrowOnError
  >
): RequestResult<
  CreateInfectionLogEndpointPatientsPatientIdInfectionLogsPostResponses,
  CreateInfectionLogEndpointPatientsPatientIdInfectionLogsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateInfectionLogEndpointPatientsPatientIdInfectionLogsPostResponses,
    CreateInfectionLogEndpointPatientsPatientIdInfectionLogsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/infection-logs/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Infection Log Endpoint
 */
export const deleteInfectionLogEndpointPatientsPatientIdInfectionLogsInfectionLogIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteInfectionLogEndpointPatientsPatientIdInfectionLogsInfectionLogIdDeleteData,
      ThrowOnError
    >
  ): RequestResult<
    DeleteInfectionLogEndpointPatientsPatientIdInfectionLogsInfectionLogIdDeleteResponses,
    DeleteInfectionLogEndpointPatientsPatientIdInfectionLogsInfectionLogIdDeleteErrors,
    ThrowOnError
  > =>
    (options.client ?? client).delete<
      DeleteInfectionLogEndpointPatientsPatientIdInfectionLogsInfectionLogIdDeleteResponses,
      DeleteInfectionLogEndpointPatientsPatientIdInfectionLogsInfectionLogIdDeleteErrors,
      ThrowOnError
    >({
      url: '/patients/{patient_id}/infection-logs/{infection_log_id}',
      ...options,
    });

/**
 * Get Infection Log Detail
 */
export const getInfectionLogDetailPatientsPatientIdInfectionLogsInfectionLogIdGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetInfectionLogDetailPatientsPatientIdInfectionLogsInfectionLogIdGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetInfectionLogDetailPatientsPatientIdInfectionLogsInfectionLogIdGetResponses,
    GetInfectionLogDetailPatientsPatientIdInfectionLogsInfectionLogIdGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetInfectionLogDetailPatientsPatientIdInfectionLogsInfectionLogIdGetResponses,
      GetInfectionLogDetailPatientsPatientIdInfectionLogsInfectionLogIdGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/infection-logs/{infection_log_id}',
      ...options,
    });

/**
 * Update Infection Log Endpoint
 */
export const updateInfectionLogEndpointPatientsPatientIdInfectionLogsInfectionLogIdPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdateInfectionLogEndpointPatientsPatientIdInfectionLogsInfectionLogIdPutData,
      ThrowOnError
    >
  ): RequestResult<
    UpdateInfectionLogEndpointPatientsPatientIdInfectionLogsInfectionLogIdPutResponses,
    UpdateInfectionLogEndpointPatientsPatientIdInfectionLogsInfectionLogIdPutErrors,
    ThrowOnError
  > =>
    (options.client ?? client).put<
      UpdateInfectionLogEndpointPatientsPatientIdInfectionLogsInfectionLogIdPutResponses,
      UpdateInfectionLogEndpointPatientsPatientIdInfectionLogsInfectionLogIdPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/infection-logs/{infection_log_id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Save Follow Up
 */
export const saveFollowUpPatientsPatientIdInfectionLogsInfectionLogIdFollowUpsPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      SaveFollowUpPatientsPatientIdInfectionLogsInfectionLogIdFollowUpsPostData,
      ThrowOnError
    >
  ): RequestResult<
    SaveFollowUpPatientsPatientIdInfectionLogsInfectionLogIdFollowUpsPostResponses,
    SaveFollowUpPatientsPatientIdInfectionLogsInfectionLogIdFollowUpsPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      SaveFollowUpPatientsPatientIdInfectionLogsInfectionLogIdFollowUpsPostResponses,
      SaveFollowUpPatientsPatientIdInfectionLogsInfectionLogIdFollowUpsPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/infection-logs/{infection_log_id}/follow-ups',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Re Screen Covid
 */
export const reScreenCovidPatientsPatientIdInfectionLogsInfectionLogIdReScreenPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ReScreenCovidPatientsPatientIdInfectionLogsInfectionLogIdReScreenPostData,
      ThrowOnError
    >
  ): RequestResult<
    ReScreenCovidPatientsPatientIdInfectionLogsInfectionLogIdReScreenPostResponses,
    ReScreenCovidPatientsPatientIdInfectionLogsInfectionLogIdReScreenPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      ReScreenCovidPatientsPatientIdInfectionLogsInfectionLogIdReScreenPostResponses,
      ReScreenCovidPatientsPatientIdInfectionLogsInfectionLogIdReScreenPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/infection-logs/{infection_log_id}/re-screen',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Get Infection Log Pdf
 *
 * Return a printable one-event infection report, for audits and surveys.
 */
export const getInfectionLogPdfPatientsPatientIdInfectionLogsInfectionLogIdPdfGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetInfectionLogPdfPatientsPatientIdInfectionLogsInfectionLogIdPdfGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetInfectionLogPdfPatientsPatientIdInfectionLogsInfectionLogIdPdfGetResponses,
    GetInfectionLogPdfPatientsPatientIdInfectionLogsInfectionLogIdPdfGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetInfectionLogPdfPatientsPatientIdInfectionLogsInfectionLogIdPdfGetResponses,
      GetInfectionLogPdfPatientsPatientIdInfectionLogsInfectionLogIdPdfGetErrors,
      ThrowOnError
    >({
      responseType: 'blob',
      url: '/patients/{patient_id}/infection-logs/{infection_log_id}/pdf',
      ...options,
    });

/**
 * List Noa Payers
 *
 * Return distinct payers with NOA counts, respecting the active filters.
 */
export const listNoaPayersNoasPayersGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListNoaPayersNoasPayersGetData, ThrowOnError>
): RequestResult<
  ListNoaPayersNoasPayersGetResponses,
  ListNoaPayersNoasPayersGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListNoaPayersNoasPayersGetResponses,
    ListNoaPayersNoasPayersGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/noas/payers',
    ...options,
  });

/**
 * List Noas
 *
 * List NOAs for the current agency with optional filters.
 */
export const listNoasNoasGet = <ThrowOnError extends boolean = false>(
  options?: Options<ListNoasNoasGetData, ThrowOnError>
): RequestResult<
  ListNoasNoasGetResponses,
  ListNoasNoasGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListNoasNoasGetResponses,
    ListNoasNoasGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/noas/',
    ...options,
  });

/**
 * Export Noas
 *
 * Every NOA matching the filters, as a spreadsheet.
 *
 * The router already requires `noa-manager:view`, so this route adds only the
 * export slug and both apply — export implies view.
 */
export const exportNoasNoasExportGet = <ThrowOnError extends boolean = false>(
  options?: Options<ExportNoasNoasExportGetData, ThrowOnError>
): RequestResult<
  ExportNoasNoasExportGetResponses,
  ExportNoasNoasExportGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ExportNoasNoasExportGetResponses,
    ExportNoasNoasExportGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/noas/export',
    ...options,
  });

/**
 * Get Noa Status Counts
 *
 * Per-tab NOA totals for the NOA Manager tab badges.
 *
 * Statuses group into tabs the same way the list endpoint's STATUS_BY_TAB
 * mapping does in the frontend: not_ready → Not Yet Ready, ready_to_send →
 * Unsent, rejected → Rejected, and everything else sent-or-later → Sent.
 * Applies the same
 * sidebar filters (search, branch, payer) as the list endpoints, so each
 * badge shows how many NOAs in that tab match the current filters.
 */
export const getNoaStatusCountsNoasStatusCountsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetNoaStatusCountsNoasStatusCountsGetData, ThrowOnError>
): RequestResult<
  GetNoaStatusCountsNoasStatusCountsGetResponses,
  GetNoaStatusCountsNoasStatusCountsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetNoaStatusCountsNoasStatusCountsGetResponses,
    GetNoaStatusCountsNoasStatusCountsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/noas/status-counts',
    ...options,
  });

/**
 * Get Noa Payer Response
 *
 * What the payer said about this NOA, in the Billing Manager's own type.
 *
 * One shared rule serves both managers, so a rejected NOA and a rejected claim
 * can never disagree about whether the bill is still correctable.
 * An NOA of another agency is absent from the batched read, so it reports the
 * same 404 as a genuine miss.
 */
export const getNoaPayerResponseNoasNoaIdPayerResponseGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetNoaPayerResponseNoasNoaIdPayerResponseGetData,
    ThrowOnError
  >
): RequestResult<
  GetNoaPayerResponseNoasNoaIdPayerResponseGetResponses,
  GetNoaPayerResponseNoasNoaIdPayerResponseGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetNoaPayerResponseNoasNoaIdPayerResponseGetResponses,
    GetNoaPayerResponseNoasNoaIdPayerResponseGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/noas/{noa_id}/payer-response',
    ...options,
  });

/**
 * Get Noa
 *
 * Get full NOA detail.
 */
export const getNoaNoasNoaIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetNoaNoasNoaIdGetData, ThrowOnError>
): RequestResult<
  GetNoaNoasNoaIdGetResponses,
  GetNoaNoasNoaIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetNoaNoasNoaIdGetResponses,
    GetNoaNoasNoaIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/noas/{noa_id}',
    ...options,
  });

/**
 * Update Noa
 *
 * Update editable fields on a NOA.
 */
export const updateNoaNoasNoaIdPatch = <ThrowOnError extends boolean = false>(
  options: Options<UpdateNoaNoasNoaIdPatchData, ThrowOnError>
): RequestResult<
  UpdateNoaNoasNoaIdPatchResponses,
  UpdateNoaNoasNoaIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateNoaNoasNoaIdPatchResponses,
    UpdateNoaNoasNoaIdPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/noas/{noa_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Noa Work Log
 *
 * Return the NOA's work log: who edited it, when, and what changed.
 *
 * One entry per recorded action, oldest first. Gated by the same
 * ``worklog:view`` slug as every other work log, on top of the router's NOA
 * Manager access.
 */
export const getNoaWorkLogNoasNoaIdWorkLogGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetNoaWorkLogNoasNoaIdWorkLogGetData, ThrowOnError>
): RequestResult<
  GetNoaWorkLogNoasNoaIdWorkLogGetResponses,
  GetNoaWorkLogNoasNoaIdWorkLogGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetNoaWorkLogNoasNoaIdWorkLogGetResponses,
    GetNoaWorkLogNoasNoaIdWorkLogGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/noas/{noa_id}/work-log',
    ...options,
  });

/**
 * Get Noa 837I
 *
 * Export a NOA as an 837I claim file (EDI text or Stedi JSON).
 *
 * Query param: format=edi (default) | format=json
 * Available in every status except not_ready and not_applicable
 * (``NOA_EXPORTABLE_STATUSES``).
 */
export const getNoa837iNoasNoaId837iGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetNoa837iNoasNoaId837iGetData, ThrowOnError>
): RequestResult<
  GetNoa837iNoasNoaId837iGetResponses,
  GetNoa837iNoasNoaId837iGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetNoa837iNoasNoaId837iGetResponses,
    GetNoa837iNoasNoaId837iGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/noas/{noa_id}/837i',
    ...options,
  });

/**
 * Get Noa Ub04 Pdf
 *
 * Export a NOA as a filled UB-04 (CMS-1450) PDF.
 *
 * Generates the PDF on demand by overlaying NOA claim data onto the
 * standard UB-04 template. Available in every status except not_ready and
 * not_applicable (``NOA_EXPORTABLE_STATUSES``).
 */
export const getNoaUb04PdfNoasNoaIdUb04Get = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetNoaUb04PdfNoasNoaIdUb04GetData, ThrowOnError>
): RequestResult<
  GetNoaUb04PdfNoasNoaIdUb04GetResponses,
  GetNoaUb04PdfNoasNoaIdUb04GetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetNoaUb04PdfNoasNoaIdUb04GetResponses,
    GetNoaUb04PdfNoasNoaIdUb04GetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/noas/{noa_id}/ub04',
    ...options,
  });

/**
 * Submit Noa 837I
 *
 * Submit a NOA as an 837I claim to Stedi electronically.
 *
 * Allowed from ready_to_send, and from rejected so the biller can correct a
 * rejected NOA in place and send it again in one step. Marks the
 * NOA as sent on success and stores the Stedi correlation ID in claim_number.
 */
export const submitNoa837iNoasNoaIdSubmitPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SubmitNoa837iNoasNoaIdSubmitPostData, ThrowOnError>
): RequestResult<
  SubmitNoa837iNoasNoaIdSubmitPostResponses,
  SubmitNoa837iNoasNoaIdSubmitPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SubmitNoa837iNoasNoaIdSubmitPostResponses,
    SubmitNoa837iNoasNoaIdSubmitPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/noas/{noa_id}/submit',
    ...options,
  });

/**
 * Validate Noa
 *
 * Re-run validation and update status (not_ready <-> ready_to_send).
 */
export const validateNoaNoasNoaIdValidatePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ValidateNoaNoasNoaIdValidatePostData, ThrowOnError>
): RequestResult<
  ValidateNoaNoasNoaIdValidatePostResponses,
  ValidateNoaNoasNoaIdValidatePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ValidateNoaNoasNoaIdValidatePostResponses,
    ValidateNoaNoasNoaIdValidatePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/noas/{noa_id}/validate',
    ...options,
  });

/**
 * Send Noa
 *
 * Mark a NOA as sent. Only allowed from ready_to_send status.
 */
export const sendNoaNoasNoaIdSendPost = <ThrowOnError extends boolean = false>(
  options: Options<SendNoaNoasNoaIdSendPostData, ThrowOnError>
): RequestResult<
  SendNoaNoasNoaIdSendPostResponses,
  SendNoaNoasNoaIdSendPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SendNoaNoasNoaIdSendPostResponses,
    SendNoaNoasNoaIdSendPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/noas/{noa_id}/send',
    ...options,
  });

/**
 * Mark Not Applicable
 *
 * Mark a NOA as not applicable.
 */
export const markNotApplicableNoasNoaIdMarkNotApplicablePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MarkNotApplicableNoasNoaIdMarkNotApplicablePostData,
    ThrowOnError
  >
): RequestResult<
  MarkNotApplicableNoasNoaIdMarkNotApplicablePostResponses,
  MarkNotApplicableNoasNoaIdMarkNotApplicablePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    MarkNotApplicableNoasNoaIdMarkNotApplicablePostResponses,
    MarkNotApplicableNoasNoaIdMarkNotApplicablePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/noas/{noa_id}/mark-not-applicable',
    ...options,
  });

/**
 * Mark Paid
 *
 * Mark a sent, acknowledged, or accepted NOA as paid.
 */
export const markPaidNoasNoaIdMarkPaidPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MarkPaidNoasNoaIdMarkPaidPostData, ThrowOnError>
): RequestResult<
  MarkPaidNoasNoaIdMarkPaidPostResponses,
  MarkPaidNoasNoaIdMarkPaidPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    MarkPaidNoasNoaIdMarkPaidPostResponses,
    MarkPaidNoasNoaIdMarkPaidPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/noas/{noa_id}/mark-paid',
    ...options,
  });

/**
 * Mark Sent
 *
 * Revert a paid or not-applicable NOA back to sent.
 */
export const markSentNoasNoaIdMarkSentPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MarkSentNoasNoaIdMarkSentPostData, ThrowOnError>
): RequestResult<
  MarkSentNoasNoaIdMarkSentPostResponses,
  MarkSentNoasNoaIdMarkSentPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    MarkSentNoasNoaIdMarkSentPostResponses,
    MarkSentNoasNoaIdMarkSentPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/noas/{noa_id}/mark-sent',
    ...options,
  });

/**
 * Mark Rejected
 *
 * Record a rejection the payer sent somewhere Roger cannot see.
 *
 * An agency not enrolled for responses through Roger's clearinghouse hears
 * of a rejection through its old one, and the NOA stays ``sent`` here. This
 * lands it in ``rejected``, the same state a 277 writes, so the existing
 * correct-and-resend flow applies. The audit row names who marked it.
 */
export const markRejectedNoasNoaIdMarkRejectedPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MarkRejectedNoasNoaIdMarkRejectedPostData, ThrowOnError>
): RequestResult<
  MarkRejectedNoasNoaIdMarkRejectedPostResponses,
  MarkRejectedNoasNoaIdMarkRejectedPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    MarkRejectedNoasNoaIdMarkRejectedPostResponses,
    MarkRejectedNoasNoaIdMarkRejectedPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/noas/{noa_id}/mark-rejected',
    ...options,
  });

/**
 * Revert To Not Ready
 *
 * Revert a not-applicable NOA back to not_ready.
 */
export const revertToNotReadyNoasNoaIdRevertToNotReadyPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RevertToNotReadyNoasNoaIdRevertToNotReadyPostData,
    ThrowOnError
  >
): RequestResult<
  RevertToNotReadyNoasNoaIdRevertToNotReadyPostResponses,
  RevertToNotReadyNoasNoaIdRevertToNotReadyPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RevertToNotReadyNoasNoaIdRevertToNotReadyPostResponses,
    RevertToNotReadyNoasNoaIdRevertToNotReadyPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/noas/{noa_id}/revert-to-not-ready',
    ...options,
  });

/**
 * Revert To Ready
 *
 * Reopen a rejected NOA so the biller can correct it and send it again.
 *
 * A rejected NOA was never accepted, so the fix is a corrected NOA rather than
 * a cancellation: CGS, "Billing the home health Notice of Admission" — there
 * is no 032D cancel of a rejected NOA. The status gate is the whole gate here,
 * unlike the billing cycle's send-again, because ``rejected`` is the only way
 * an NOA reaches this state and it always records what the payer said, whether
 * a 277 wrote it or the biller recorded it by hand.
 *
 * The read model agrees rather than being consulted: ``derive_next_action``
 * returns ``fix_and_resend`` for every rejected NOA, payer claim control
 * number or not, so the button the list draws and the transition this endpoint
 * allows are one answer to one question.
 */
export const revertToReadyNoasNoaIdRevertToReadyPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RevertToReadyNoasNoaIdRevertToReadyPostData, ThrowOnError>
): RequestResult<
  RevertToReadyNoasNoaIdRevertToReadyPostResponses,
  RevertToReadyNoasNoaIdRevertToReadyPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RevertToReadyNoasNoaIdRevertToReadyPostResponses,
    RevertToReadyNoasNoaIdRevertToReadyPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/noas/{noa_id}/revert-to-ready',
    ...options,
  });

/**
 * Bulk Send
 *
 * Bulk mark NOAs as sent (manual submission path — does NOT call Stedi).
 *
 * Only processes NOAs in ready_to_send status; others are silently skipped.
 * For electronic Stedi submission use POST /{noa_id}/submit instead.
 */
export const bulkSendNoasBulkSendPost = <ThrowOnError extends boolean = false>(
  options: Options<BulkSendNoasBulkSendPostData, ThrowOnError>
): RequestResult<
  BulkSendNoasBulkSendPostResponses,
  BulkSendNoasBulkSendPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    BulkSendNoasBulkSendPostResponses,
    BulkSendNoasBulkSendPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/noas/bulk-send',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Noa For Admission
 *
 * Create a NOA for an admission (idempotent).
 */
export const createNoaForAdmissionNoasAdmissionsAdmissionIdNoaPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateNoaForAdmissionNoasAdmissionsAdmissionIdNoaPostData,
    ThrowOnError
  >
): RequestResult<
  CreateNoaForAdmissionNoasAdmissionsAdmissionIdNoaPostResponses,
  CreateNoaForAdmissionNoasAdmissionsAdmissionIdNoaPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateNoaForAdmissionNoasAdmissionsAdmissionIdNoaPostResponses,
    CreateNoaForAdmissionNoasAdmissionsAdmissionIdNoaPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/noas/admissions/{admission_id}/noa',
    ...options,
  });

/**
 * List Cahps Exports
 */
export const listCahpsExportsCahpsExportsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListCahpsExportsCahpsExportsGetData, ThrowOnError>
): RequestResult<
  ListCahpsExportsCahpsExportsGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListCahpsExportsCahpsExportsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/cahps-exports',
    ...options,
  });

/**
 * Preview Cahps Export
 *
 * Whether Generate would read Kinnser for the month; never calls Kinnser.
 */
export const previewCahpsExportCahpsExportsPreviewGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PreviewCahpsExportCahpsExportsPreviewGetData, ThrowOnError>
): RequestResult<
  PreviewCahpsExportCahpsExportsPreviewGetResponses,
  PreviewCahpsExportCahpsExportsPreviewGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    PreviewCahpsExportCahpsExportsPreviewGetResponses,
    PreviewCahpsExportCahpsExportsPreviewGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/cahps-exports/preview',
    ...options,
  });

/**
 * Generate Cahps Export
 *
 * Make and store the month's file, and say what Generate did.
 *
 * A Roger-side refusal answers 400 and stores nothing. Kinnser problems never
 * refuse: the file is stored and its summary marks it incomplete.
 */
export const generateCahpsExportCahpsExportsGeneratePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GenerateCahpsExportCahpsExportsGeneratePostData,
    ThrowOnError
  >
): RequestResult<
  GenerateCahpsExportCahpsExportsGeneratePostResponses,
  GenerateCahpsExportCahpsExportsGeneratePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GenerateCahpsExportCahpsExportsGeneratePostResponses,
    GenerateCahpsExportCahpsExportsGeneratePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/cahps-exports/generate',
    ...options,
  });

/**
 * Download Cahps Export
 */
export const downloadCahpsExportCahpsExportsExportIdDownloadGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DownloadCahpsExportCahpsExportsExportIdDownloadGetData,
    ThrowOnError
  >
): RequestResult<
  DownloadCahpsExportCahpsExportsExportIdDownloadGetResponses,
  DownloadCahpsExportCahpsExportsExportIdDownloadGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    DownloadCahpsExportCahpsExportsExportIdDownloadGetResponses,
    DownloadCahpsExportCahpsExportsExportIdDownloadGetErrors,
    ThrowOnError
  >({
    responseType: 'text',
    url: '/cahps-exports/{export_id}/download',
    ...options,
  });

/**
 * List Patient Duplicate Imports
 *
 * Imported charts created because this patient already had the MRN or key.
 *
 * An empty list is the answer both for a patient with no duplicates and for
 * an id this agency cannot see. The read does not look the patient up, so a
 * clinic filter cannot turn a real patient into a not-found, and another
 * agency's link cannot be probed.
 */
export const listPatientDuplicateImportsImporterPatientsPatientIdDuplicateImportsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ListPatientDuplicateImportsImporterPatientsPatientIdDuplicateImportsGetData,
      ThrowOnError
    >
  ): RequestResult<
    ListPatientDuplicateImportsImporterPatientsPatientIdDuplicateImportsGetResponses,
    ListPatientDuplicateImportsImporterPatientsPatientIdDuplicateImportsGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      ListPatientDuplicateImportsImporterPatientsPatientIdDuplicateImportsGetResponses,
      ListPatientDuplicateImportsImporterPatientsPatientIdDuplicateImportsGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/importer/patients/{patient_id}/duplicate-imports',
      ...options,
    });

/**
 * Get Importer Queue
 *
 * This agency's import queue: per-lane aggregates, then a page of rows.
 *
 * Agency scoping is the ORM's, not a filter written here: every table read
 * below is ``AgencyPrivateMixin``, so the agency in the request's
 * ``ExecutionContext`` — the one the user switched to — is the only one that
 * can come back.
 */
export const getImporterQueueImporterQueueGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetImporterQueueImporterQueueGetData, ThrowOnError>
): RequestResult<
  GetImporterQueueImporterQueueGetResponses,
  GetImporterQueueImporterQueueGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetImporterQueueImporterQueueGetResponses,
    GetImporterQueueImporterQueueGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/importer/queue',
    ...options,
  });

/**
 * Get Importer Settings
 *
 * What this agency's capture is currently allowed to run.
 */
export const getImporterSettingsImporterSettingsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetImporterSettingsImporterSettingsGetData, ThrowOnError>
): RequestResult<
  GetImporterSettingsImporterSettingsGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetImporterSettingsImporterSettingsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/importer/settings',
    ...options,
  });

/**
 * Update Importer Settings
 *
 * Change how many logins may work this agency's capture, or stop it.
 *
 * Lowering the number never interrupts a chart, and neither does pausing.
 * Both stop lanes *claiming*: a lane over the new number, or on a paused
 * capture, keeps its sequencer, finishes the patient it is scraping, settles
 * the row, and then claims nothing more. A half-scraped chart is somebody's
 * afternoon; a lane that runs on a few minutes longer than the operator
 * wanted is not.
 *
 * Raising it takes effect when a pool is next kicked, which the five-minute
 * watchdog does for every pool with work, so nothing has to be pressed.
 * Setting it above the number of stored logins is not an error and not a
 * promise: the lanes that start are the logins that exist.
 *
 * Resuming does not wait for that watchdog. The sequencers of a paused
 * capture idle out within a minute, so a resume with nothing to wake it
 * would leave a page reading "running" over a queue that does not move for
 * five minutes.
 */
export const updateImporterSettingsImporterSettingsPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateImporterSettingsImporterSettingsPutData, ThrowOnError>
): RequestResult<
  UpdateImporterSettingsImporterSettingsPutResponses,
  UpdateImporterSettingsImporterSettingsPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateImporterSettingsImporterSettingsPutResponses,
    UpdateImporterSettingsImporterSettingsPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/importer/settings',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Pause Importer Lane
 *
 * Stop one utility login from claiming anything more.
 *
 * Two routes rather than one taking a boolean, because these are two
 * different things to be able to see in an audit log and in a URL, and
 * because neither carries anything else: the id is in the path and there is
 * nothing to send. It also matches ``/queue/{item_id}/retry`` on this router.
 *
 * The chart this login is holding right now is not touched. Pausing stops the
 * *next* claim, exactly as lowering the lane count does, so the operator does
 * not have to choose between stopping a login and abandoning a patient
 * half-scraped.
 *
 * Deliberately not the breaker. The lane comes back saying ``is_paused``
 * while its breaker keeps whatever it already said, so the page can tell
 * somebody "you paused this login" rather than "the source EMR refused it".
 */
export const pauseImporterLaneImporterLanesLaneKeyPausePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PauseImporterLaneImporterLanesLaneKeyPausePostData,
    ThrowOnError
  >
): RequestResult<
  PauseImporterLaneImporterLanesLaneKeyPausePostResponses,
  PauseImporterLaneImporterLanesLaneKeyPausePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PauseImporterLaneImporterLanesLaneKeyPausePostResponses,
    PauseImporterLaneImporterLanesLaneKeyPausePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/importer/lanes/{lane_key}/pause',
    ...options,
  });

/**
 * Resume Importer Lane
 *
 * Let one utility login claim again.
 *
 * Undoes the pause and nothing else. A lane whose breaker is also open stays
 * stopped and says so in the response — resuming must not quietly declare a
 * credential Kinnser refused to be healthy; ``reset-breaker`` is the separate
 * press for that, and the cooldown probe still does it on its own.
 *
 * The pool is kicked because a paused lane's sequencer idles out within a
 * minute, and a resumed lane with nothing to wake it would sit still until
 * the five-minute watchdog noticed.
 */
export const resumeImporterLaneImporterLanesLaneKeyResumePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResumeImporterLaneImporterLanesLaneKeyResumePostData,
    ThrowOnError
  >
): RequestResult<
  ResumeImporterLaneImporterLanesLaneKeyResumePostResponses,
  ResumeImporterLaneImporterLanesLaneKeyResumePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ResumeImporterLaneImporterLanesLaneKeyResumePostResponses,
    ResumeImporterLaneImporterLanesLaneKeyResumePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/importer/lanes/{lane_key}/resume',
    ...options,
  });

/**
 * Reset Importer Lane Breaker
 *
 * Close a tripped breaker now instead of waiting out the cooldown.
 *
 * The breaker reopens itself after half an hour by letting one claim through
 * as a probe, which is right when nobody is watching and wrong when somebody
 * has just fixed the password: the capture then loses up to thirty minutes on
 * a login that works. This is that probe taken early. The automatic one is
 * untouched, and so is the window that trips the breaker again — if the
 * credential is still refused, three more patients put it straight back.
 *
 * An operator pause on the same lane is left exactly as it was. The two stop
 * the lane for different reasons and are cleared by different presses.
 */
export const resetImporterLaneBreakerImporterLanesLaneKeyResetBreakerPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResetImporterLaneBreakerImporterLanesLaneKeyResetBreakerPostData,
    ThrowOnError
  >
): RequestResult<
  ResetImporterLaneBreakerImporterLanesLaneKeyResetBreakerPostResponses,
  ResetImporterLaneBreakerImporterLanesLaneKeyResetBreakerPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ResetImporterLaneBreakerImporterLanesLaneKeyResetBreakerPostResponses,
    ResetImporterLaneBreakerImporterLanesLaneKeyResetBreakerPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/importer/lanes/{lane_key}/reset-breaker',
    ...options,
  });

/**
 * Retry Importer Queue Item
 *
 * Put one failed chart back in its lane's queue.
 *
 * A lane whose breaker is open still takes the retry. The breaker is a
 * claim-time guard on the login, not on the row: a reopened row waits in
 * ``queued`` exactly like every other row on that lane until the cooldown
 * probe, and the lane card says it is paused. Refusing here would only mean
 * the operator has to come back and press the same button later.
 */
export const retryImporterQueueItemImporterQueueItemIdRetryPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RetryImporterQueueItemImporterQueueItemIdRetryPostData,
    ThrowOnError
  >
): RequestResult<
  RetryImporterQueueItemImporterQueueItemIdRetryPostResponses,
  RetryImporterQueueItemImporterQueueItemIdRetryPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RetryImporterQueueItemImporterQueueItemIdRetryPostResponses,
    RetryImporterQueueItemImporterQueueItemIdRetryPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/importer/queue/{item_id}/retry',
    ...options,
  });

/**
 * Retry Importer Lane Failures
 *
 * Reopen up to ``_RETRY_FAILED_LIMIT`` of one lane's failed charts.
 *
 * One at a time is not a recovery plan for a capture of 24,000 charts: a
 * credential that expired overnight fails every row it is tried on, and the
 * operator's morning is a lane of failures that all want the same press.
 *
 * Rows are taken oldest-first, the order the sequencer will drain them in.
 * The lane is named by ``queue_key`` and nothing here checks it belongs to
 * this agency, because the ORM already does: every row read below is
 * ``AgencyPrivateMixin``, so another agency's key simply selects nothing.
 */
export const retryImporterLaneFailuresImporterQueueRetryFailedPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RetryImporterLaneFailuresImporterQueueRetryFailedPostData,
    ThrowOnError
  >
): RequestResult<
  RetryImporterLaneFailuresImporterQueueRetryFailedPostResponses,
  RetryImporterLaneFailuresImporterQueueRetryFailedPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RetryImporterLaneFailuresImporterQueueRetryFailedPostResponses,
    RetryImporterLaneFailuresImporterQueueRetryFailedPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/importer/queue/retry-failed',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Upload Importer Roster
 *
 * Queue one page of the patients named in an exported episode roster.
 *
 * Partial by design. A 24,000-row export has blank rows and blank identifiers
 * in it — thirteen of the real ones have no Medical Record Key — and refusing
 * the file over them would mean the capture does not happen. Everything that
 * parses is queued and everything that does not comes back with its sheet,
 * its row number and a reason.
 *
 * The page's buckets add up to the rows it read, and a row that deduplicated
 * onto an existing queue row is *not* in the enqueued bucket. That is the
 * whole reason this route exists rather than a loop over the internal one:
 * the shared enqueue answers a duplicate with the row it found, so a roster
 * that collapses 7,098 episodes onto 17,294 patients would otherwise report
 * 24,405 charts queued and lose the difference silently.
 *
 * The caller re-posts the same file with ``next_offset`` until it comes back
 * null. The whole file in one request would be a two-and-a-half-minute silence
 * on a connection the load balancer closes after sixty.
 *
 * ``print_mode`` is one of the two choices the operator makes about the
 * upload, and says how the charts come across: ``auto`` (the default) prints
 * one chart PDF per episode for patients whose latest episode ended over
 * sixty days ago and a PDF per task for the rest; ``episode`` or ``task``
 * gives every row of the upload that kind. Claims, fall and infection
 * records ride every import either way.
 *
 * ``overwrite_existing`` is the other, and this is the only place the
 * roster's own data and Overwrite can be asked for together. The internal
 * tool that has carried Overwrite until now sends no episode dates and does
 * not ask for roster admissions, so re-queueing a patient there rebuilds the
 * chart from a narrower scrape than the roster would have bought. Ticked,
 * every row of the page asks to rebuild the chart Roger already holds for
 * that patient instead of being refused for it -- which is what re-imports
 * the ~2,200 charts captured before Overwrite knew about the
 * claim captures an import re-creates. Nothing is deleted here: the rebuild
 * happens at scrape time, and a chart holding Roger work still refuses with
 * the work it found.
 *
 * Send the same two choices with every page of one file.
 */
export const uploadImporterRosterImporterRosterPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UploadImporterRosterImporterRosterPostData, ThrowOnError>
): RequestResult<
  UploadImporterRosterImporterRosterPostResponses,
  UploadImporterRosterImporterRosterPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UploadImporterRosterImporterRosterPostResponses,
    UploadImporterRosterImporterRosterPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/importer/roster',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Download Importer Roster Status
 *
 * Hand the uploaded roster back with what became of each of its rows.
 *
 * A read, and only a read: nothing is queued, nothing is stored, and the file
 * is not kept. The operator uploads the same workbook they queued from and
 * gets it back with status columns on the end, because the question they have
 * after a capture is about a row of their spreadsheet and the queue page can
 * only answer about a lane.
 *
 * The rows are matched to the queue the way the upload created it — the same
 * agency-scoped identity digest over the same Medical Record Key — so a row
 * finds its own queue item or none at all. What that item became, the chart
 * it produced and whether this row's own episode is on that chart are three
 * separate columns, because they fail separately: a completed import whose
 * episode is missing is a different problem from one that never ran.
 *
 * A row whose own chart does not hold its period is checked against the
 * year-variant siblings the roster itself names — the same grouping the
 * upload used to widen the scrape — because a key Kinnser re-issued can have
 * its stays imported under the newer key while its own row reads as a
 * failure, or as a completed import of some earlier stay. The report says so
 * as ``yes_via_sibling`` rather than as a plain ``yes``, and the chart
 * columns name the chart that actually holds the stay.
 *
 * The whole file in one request, unlike the upload. This writes nothing, so a
 * request that dies loses nothing and can simply be made again; paging it
 * would hand the operator several files to join up by hand.
 */
export const downloadImporterRosterStatusImporterRosterStatusPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DownloadImporterRosterStatusImporterRosterStatusPostData,
    ThrowOnError
  >
): RequestResult<
  DownloadImporterRosterStatusImporterRosterStatusPostResponses,
  DownloadImporterRosterStatusImporterRosterStatusPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DownloadImporterRosterStatusImporterRosterStatusPostResponses,
    DownloadImporterRosterStatusImporterRosterStatusPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'blob',
    url: '/importer/roster/status',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Reset Importer Agency
 *
 * Cancel live import jobs, empty the queue, and delete imported patients.
 *
 * Charts with no import provenance are not touched. Imported charts that
 * carry Roger work the import did not create are skipped. One request
 * deletes a bounded page of deletable imported charts; call again until
 * ``done`` is true. The page exists so a 17,000-chart wipe cannot sit on
 * a connection the load balancer closes.
 */
export const resetImporterAgencyImporterResetPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ResetImporterAgencyImporterResetPostData, ThrowOnError>
): RequestResult<
  ResetImporterAgencyImporterResetPostResponses,
  ResetImporterAgencyImporterResetPostErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    ResetImporterAgencyImporterResetPostResponses,
    ResetImporterAgencyImporterResetPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/importer/reset',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * List Dashboard Clinics
 *
 * List clinics assigned to the authenticated user in this agency.
 */
export const listDashboardClinics = <ThrowOnError extends boolean = false>(
  options?: Options<ListDashboardClinicsData, ThrowOnError>
): RequestResult<
  ListDashboardClinicsResponses,
  ListDashboardClinicsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListDashboardClinicsResponses,
    ListDashboardClinicsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/dashboard/clinics',
    ...options,
  });

/**
 * Get Dashboard Onboarding
 *
 * Agency setup checklist and onboarding counters for the selected clinics.
 */
export const getDashboardOnboarding = <ThrowOnError extends boolean = false>(
  options?: Options<GetDashboardOnboardingData, ThrowOnError>
): RequestResult<
  GetDashboardOnboardingResponses,
  GetDashboardOnboardingErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetDashboardOnboardingResponses,
    GetDashboardOnboardingErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/dashboard/onboarding',
    ...options,
  });

/**
 * Update Dashboard Onboarding Task
 *
 * Tick or untick one hand-ticked setup task; answers for the selected clinics.
 */
export const updateDashboardOnboardingTask = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateDashboardOnboardingTaskData, ThrowOnError>
): RequestResult<
  UpdateDashboardOnboardingTaskResponses,
  UpdateDashboardOnboardingTaskErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateDashboardOnboardingTaskResponses,
    UpdateDashboardOnboardingTaskErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/dashboard/onboarding/tasks/{task_key}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Query Dashboard
 *
 * Return only the requested dashboard widgets.
 */
export const queryDashboard = <ThrowOnError extends boolean = false>(
  options: Options<QueryDashboardData, ThrowOnError>
): RequestResult<QueryDashboardResponses, QueryDashboardErrors, ThrowOnError> =>
  (options.client ?? client).post<
    QueryDashboardResponses,
    QueryDashboardErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/dashboard/query',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Cms485 Oasis Visits
 *
 * Return OASIS visits eligible to source a CMS-485, earliest first.
 *
 * Eligibility follows Kinnser's plan-of-care window
 * (``app.services.cms485_oasis_eligibility``): the first ``+/- 10 days``
 * of the current episode plus the trailing ``10`` days of the previous
 * episode, restricted to non-discharge OASIS assessments.
 */
export const listCms485OasisVisitsPatientsPatientIdCms485OasisVisitsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListCms485OasisVisitsPatientsPatientIdCms485OasisVisitsGetData,
    ThrowOnError
  >
): RequestResult<
  ListCms485OasisVisitsPatientsPatientIdCms485OasisVisitsGetResponses,
  ListCms485OasisVisitsPatientsPatientIdCms485OasisVisitsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListCms485OasisVisitsPatientsPatientIdCms485OasisVisitsGetResponses,
    ListCms485OasisVisitsPatientsPatientIdCms485OasisVisitsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/cms485/oasis-visits',
    ...options,
  });

/**
 * Get Cms485 Prefill
 *
 * Return CMS-485 fields prefilled from an OASIS visit of the episode.
 *
 * Fields are sourced from visit_data JSONB using stable QID keys. If no OASIS
 * visit exists yet, all fields are returned empty so the dialog still opens cleanly.
 */
export const getCms485PrefillPatientsPatientIdCms485PrefillGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetCms485PrefillPatientsPatientIdCms485PrefillGetData,
    ThrowOnError
  >
): RequestResult<
  GetCms485PrefillPatientsPatientIdCms485PrefillGetResponses,
  GetCms485PrefillPatientsPatientIdCms485PrefillGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetCms485PrefillPatientsPatientIdCms485PrefillGetResponses,
    GetCms485PrefillPatientsPatientIdCms485PrefillGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/cms485/prefill',
    ...options,
  });

/**
 * List Pho Roc Visits
 *
 * Return ROC OASIS visits eligible to source a Post Hospital Order, earliest first.
 *
 * Eligibility: ROC assessments (``ROC``, ``ROCPT``, ``ROCOT``, ``ROCST``) on the
 * order's current episode only. Each ROC may link to at most one PHO in the episode.
 */
export const listPhoRocVisitsPatientsPatientIdPhoRocVisitsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListPhoRocVisitsPatientsPatientIdPhoRocVisitsGetData,
    ThrowOnError
  >
): RequestResult<
  ListPhoRocVisitsPatientsPatientIdPhoRocVisitsGetResponses,
  ListPhoRocVisitsPatientsPatientIdPhoRocVisitsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListPhoRocVisitsPatientsPatientIdPhoRocVisitsGetResponses,
    ListPhoRocVisitsPatientsPatientIdPhoRocVisitsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/pho/roc-visits',
    ...options,
  });

/**
 * Get Episode
 *
 * Fetch an episode by ID.
 */
export const getEpisodeEpisodesEpisodeIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetEpisodeEpisodesEpisodeIdGetData, ThrowOnError>
): RequestResult<
  GetEpisodeEpisodesEpisodeIdGetResponses,
  GetEpisodeEpisodesEpisodeIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetEpisodeEpisodesEpisodeIdGetResponses,
    GetEpisodeEpisodesEpisodeIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}',
    ...options,
  });

/**
 * Update Episode
 *
 * Update episode core properties (dates/status) and/or RCD participation fields.
 *
 * ``acknowledge_warnings`` is a query parameter (not a schema field) so the schema's
 * field set maps one-to-one to episode columns for the audit diff and bulk update.
 */
export const updateEpisodeEpisodesEpisodeIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateEpisodeEpisodesEpisodeIdPatchData, ThrowOnError>
): RequestResult<
  UpdateEpisodeEpisodesEpisodeIdPatchResponses,
  UpdateEpisodeEpisodesEpisodeIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateEpisodeEpisodesEpisodeIdPatchResponses,
    UpdateEpisodeEpisodesEpisodeIdPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Episode Notes
 *
 * List an episode's notes, oldest first.
 */
export const listEpisodeNotesEpisodesEpisodeIdNotesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ListEpisodeNotesEpisodesEpisodeIdNotesGetData, ThrowOnError>
): RequestResult<
  ListEpisodeNotesEpisodesEpisodeIdNotesGetResponses,
  ListEpisodeNotesEpisodesEpisodeIdNotesGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListEpisodeNotesEpisodesEpisodeIdNotesGetResponses,
    ListEpisodeNotesEpisodesEpisodeIdNotesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/notes',
    ...options,
  });

/**
 * Create Episode Note
 *
 * Append a note to an episode.
 *
 * Any authenticated agency user who can reach the episode may add one, the
 * same policy the task sticky notes and the billing cycle notes follow.
 * Editing and deleting are narrower: only the note's own author may do either.
 * No audit log call on any of the three, because the table carries an audit
 * trigger that records every insert, update and delete with its prior value.
 */
export const createEpisodeNoteEpisodesEpisodeIdNotesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateEpisodeNoteEpisodesEpisodeIdNotesPostData,
    ThrowOnError
  >
): RequestResult<
  CreateEpisodeNoteEpisodesEpisodeIdNotesPostResponses,
  CreateEpisodeNoteEpisodesEpisodeIdNotesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateEpisodeNoteEpisodesEpisodeIdNotesPostResponses,
    CreateEpisodeNoteEpisodesEpisodeIdNotesPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/notes',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Episode Note
 *
 * Soft-delete a note. Only the note's author may delete it.
 */
export const deleteEpisodeNoteEpisodesEpisodeIdNotesNoteIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteEpisodeNoteEpisodesEpisodeIdNotesNoteIdDeleteData,
    ThrowOnError
  >
): RequestResult<
  DeleteEpisodeNoteEpisodesEpisodeIdNotesNoteIdDeleteResponses,
  DeleteEpisodeNoteEpisodesEpisodeIdNotesNoteIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteEpisodeNoteEpisodesEpisodeIdNotesNoteIdDeleteResponses,
    DeleteEpisodeNoteEpisodesEpisodeIdNotesNoteIdDeleteErrors,
    ThrowOnError
  >({ url: '/episodes/{episode_id}/notes/{note_id}', ...options });

/**
 * Update Episode Note
 *
 * Rewrite a note's body. Only the note's author may edit it.
 *
 * A note written by anyone else 404s rather than 403s, so that the response
 * says no more about a note the caller cannot touch than it does about one on
 * an episode they cannot reach.
 */
export const updateEpisodeNoteEpisodesEpisodeIdNotesNoteIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateEpisodeNoteEpisodesEpisodeIdNotesNoteIdPatchData,
    ThrowOnError
  >
): RequestResult<
  UpdateEpisodeNoteEpisodesEpisodeIdNotesNoteIdPatchResponses,
  UpdateEpisodeNoteEpisodesEpisodeIdNotesNoteIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateEpisodeNoteEpisodesEpisodeIdNotesNoteIdPatchResponses,
    UpdateEpisodeNoteEpisodesEpisodeIdNotesNoteIdPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/notes/{note_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Next Active Episode
 *
 * Return the next non-cancelled episode in the same admission, or null.
 *
 * Backs the goal push-to-next-episode UI: a goal can only be
 * pushed once the next episode exists, so the UI checks this before
 * offering the action. Only CANCELLED episodes are excluded — a completed
 * or interrupted next episode is still a valid push target (late
 * documentation after it already ran). The route path keeps its historical
 * "next-active" segment for generated-client stability.
 * See ``EpisodeCRUD.get_next_episode``.
 */
export const getNextActiveEpisodeEpisodesEpisodeIdNextActiveGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetNextActiveEpisodeEpisodesEpisodeIdNextActiveGetData,
    ThrowOnError
  >
): RequestResult<
  GetNextActiveEpisodeEpisodesEpisodeIdNextActiveGetResponses,
  GetNextActiveEpisodeEpisodesEpisodeIdNextActiveGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetNextActiveEpisodeEpisodesEpisodeIdNextActiveGetResponses,
    GetNextActiveEpisodeEpisodesEpisodeIdNextActiveGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/next-active',
    ...options,
  });

/**
 * Get Episode Worksheet
 *
 * Return the agency-scoped episode worksheet, creating it if missing.
 */
export const getEpisodeWorksheetEpisodesEpisodeIdWorksheetGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetEpisodeWorksheetEpisodesEpisodeIdWorksheetGetData,
    ThrowOnError
  >
): RequestResult<
  GetEpisodeWorksheetEpisodesEpisodeIdWorksheetGetResponses,
  GetEpisodeWorksheetEpisodesEpisodeIdWorksheetGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetEpisodeWorksheetEpisodesEpisodeIdWorksheetGetResponses,
    GetEpisodeWorksheetEpisodesEpisodeIdWorksheetGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/worksheet',
    ...options,
  });

/**
 * Update Episode Worksheet
 *
 * Replace the agency-scoped episode worksheet. Always editable.
 *
 * Full-replace (PUT): the body carries the complete worksheet, so the
 * accident/employer rule is validated against the payload directly and every
 * editable column is overwritten.
 */
export const updateEpisodeWorksheetEpisodesEpisodeIdWorksheetPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateEpisodeWorksheetEpisodesEpisodeIdWorksheetPutData,
    ThrowOnError
  >
): RequestResult<
  UpdateEpisodeWorksheetEpisodesEpisodeIdWorksheetPutResponses,
  UpdateEpisodeWorksheetEpisodesEpisodeIdWorksheetPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateEpisodeWorksheetEpisodesEpisodeIdWorksheetPutResponses,
    UpdateEpisodeWorksheetEpisodesEpisodeIdWorksheetPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/worksheet',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Batch Print Episode Tasks
 *
 * Assemble a chart record from selected episode tasks as a ZIP or merged PDF.
 *
 * Two passes, run sequentially (the session is not ``gather``-safe):
 *
 * 1. **Validate-all (fail-fast):** every referenced task must load in the
 * current agency *and* belong to ``episode_id``. Any miss → 404 for the
 * whole request — a mismatch is an integrity/tamper signal, not a
 * per-task placeholder.
 * 2. **Render-each (partial-success):** each validated task renders via the
 * same single-task renderer its own PDF route uses. A render failure is
 * swapped for a self-identifying placeholder page and logged; the bundle
 * still returns 200 so one bad task never sinks the export.
 *
 * Read-only — no ``db.commit()``.
 */
export const batchPrintEpisodeTasksEpisodesEpisodeIdTasksBatchPrintPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    BatchPrintEpisodeTasksEpisodesEpisodeIdTasksBatchPrintPostData,
    ThrowOnError
  >
): RequestResult<
  BatchPrintEpisodeTasksEpisodesEpisodeIdTasksBatchPrintPostResponses,
  BatchPrintEpisodeTasksEpisodesEpisodeIdTasksBatchPrintPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    BatchPrintEpisodeTasksEpisodesEpisodeIdTasksBatchPrintPostResponses,
    BatchPrintEpisodeTasksEpisodesEpisodeIdTasksBatchPrintPostErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/episodes/{episode_id}/tasks/batch-print',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Episode Lupa
 *
 * Per-30-day-period LUPA threshold and billable-visit count for an episode.
 */
export const getEpisodeLupa = <ThrowOnError extends boolean = false>(
  options: Options<GetEpisodeLupaData, ThrowOnError>
): RequestResult<GetEpisodeLupaResponses, GetEpisodeLupaErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetEpisodeLupaResponses,
    GetEpisodeLupaErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/lupa',
    ...options,
  });

/**
 * Reopen Episode
 *
 * Return a completed episode to active so its visits can be corrected.
 *
 * Clears ``closed_at``, which lifts the closed-episode lock for everyone who can
 * see the chart, and stamps ``reopened_at`` so the episode can later be marked
 * completed again. The admission is untouched, discharged or not.
 */
export const reopenEpisode = <ThrowOnError extends boolean = false>(
  options: Options<ReopenEpisodeData, ThrowOnError>
): RequestResult<ReopenEpisodeResponses, ReopenEpisodeErrors, ThrowOnError> =>
  (options.client ?? client).post<
    ReopenEpisodeResponses,
    ReopenEpisodeErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/reopen',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Complete Episode
 *
 * Mark a reopened episode completed again once its correction is done.
 *
 * Only an episode reopened through ``reopen_episode`` qualifies. Unfinished
 * visits do not block completion, but the caller must confirm them first: the
 * 409 lists them, and ``acknowledge_unfinished`` proceeds.
 */
export const completeEpisode = <ThrowOnError extends boolean = false>(
  options: Options<CompleteEpisodeData, ThrowOnError>
): RequestResult<
  CompleteEpisodeResponses,
  CompleteEpisodeErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CompleteEpisodeResponses,
    CompleteEpisodeErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/complete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Sync Episode Date To Visit
 *
 * Move an episode boundary to follow a boundary-defining visit's new date.
 *
 * Rescheduling a Start of Care visit updates the episode start date; a
 * Discharge / Transfer / Death visit updates the end date. The visit and the
 * episode move together in one transaction so the visit reschedule (which
 * otherwise rejects a date outside the current window) always lands inside the
 * new window. Standard episode rules still apply: end after start, the 60-day
 * maximum, overlap, locked billing, and the stranded-record impact confirmation
 * (``acknowledge_warnings``).
 *
 * This route is intentionally separate from the general episode edit so it can be
 * authorized as a visit reschedule for users who may not edit episode dates
 * directly.
 */
export const syncEpisodeDateToVisit = <ThrowOnError extends boolean = false>(
  options: Options<SyncEpisodeDateToVisitData, ThrowOnError>
): RequestResult<
  SyncEpisodeDateToVisitResponses,
  SyncEpisodeDateToVisitErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    SyncEpisodeDateToVisitResponses,
    SyncEpisodeDateToVisitErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/sync-date-to-visit',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Episode Assignments
 *
 * Update physician, case manager, and/or insurance on an episode.
 *
 * An insurance change may carry one of two billing actions. With
 * ``void_billing_cycle_ids`` (error correction) the listed unsent billing
 * cycles under the previous insurance are voided and their periods rebuilt
 * under the new one once due (see ``void_unsent_cycles_for_insurance_switch``);
 * a period that is not due yet is left for the nightly run. With
 * ``close_out_old_insurance`` (a real change of coverage) one short Draft
 * cycle is created under the previous insurance for the days it still covers
 * (see ``create_close_out_cycle_for_insurance_switch``). Both run in the
 * same transaction as the switch.
 */
export const updateEpisodeAssignmentsEpisodesEpisodeIdAssignmentsPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateEpisodeAssignmentsEpisodesEpisodeIdAssignmentsPatchData,
    ThrowOnError
  >
): RequestResult<
  UpdateEpisodeAssignmentsEpisodesEpisodeIdAssignmentsPatchResponses,
  UpdateEpisodeAssignmentsEpisodesEpisodeIdAssignmentsPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateEpisodeAssignmentsEpisodesEpisodeIdAssignmentsPatchResponses,
    UpdateEpisodeAssignmentsEpisodesEpisodeIdAssignmentsPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/assignments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Episode Unsent Billing Cycles
 *
 * The episode's billing cycles under one insurance that have not left the
 * agency (Draft, Pending Approval, Ready to Send), oldest first, plus the
 * defaults for a close-out cycle under that insurance.
 *
 * The insurance editor uses both: an error correction chooses which unsent
 * cycles to void and rebuild under the new insurance; a real insurance change
 * bills the old insurance from ``close_out_start_date`` to a chosen end.
 * ``close_out_external`` says the switch would refuse that close-out (the
 * External EMR bills the period), so the dialog starts it unticked.
 * Gated exactly like that switch: the caller must be allowed to change this
 * episode's insurance.
 */
export const listEpisodeUnsentBillingCyclesEpisodesEpisodeIdUnsentBillingCyclesGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ListEpisodeUnsentBillingCyclesEpisodesEpisodeIdUnsentBillingCyclesGetData,
      ThrowOnError
    >
  ): RequestResult<
    ListEpisodeUnsentBillingCyclesEpisodesEpisodeIdUnsentBillingCyclesGetResponses,
    ListEpisodeUnsentBillingCyclesEpisodesEpisodeIdUnsentBillingCyclesGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      ListEpisodeUnsentBillingCyclesEpisodesEpisodeIdUnsentBillingCyclesGetResponses,
      ListEpisodeUnsentBillingCyclesEpisodesEpisodeIdUnsentBillingCyclesGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/episodes/{episode_id}/unsent-billing-cycles',
      ...options,
    });

/**
 * Check Noa Physician Sync
 *
 * Would syncing this physician onto the admission's NOA change anything?
 *
 * The Patient Manager popup is only shown when this returns true: there is an
 * unsent NOA for the admission AND its stored physician NPI/name differ from
 * what this physician would be stored as.
 */
export const checkNoaPhysicianSyncEpisodesEpisodeIdSyncNoaPhysicianCheckGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CheckNoaPhysicianSyncEpisodesEpisodeIdSyncNoaPhysicianCheckGetData,
    ThrowOnError
  >
): RequestResult<
  CheckNoaPhysicianSyncEpisodesEpisodeIdSyncNoaPhysicianCheckGetResponses,
  CheckNoaPhysicianSyncEpisodesEpisodeIdSyncNoaPhysicianCheckGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    CheckNoaPhysicianSyncEpisodesEpisodeIdSyncNoaPhysicianCheckGetResponses,
    CheckNoaPhysicianSyncEpisodesEpisodeIdSyncNoaPhysicianCheckGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/sync-noa-physician/check',
    ...options,
  });

/**
 * Sync Noa Physician
 *
 * Copy a physician onto the admission's NOA, if the NOA hasn't been sent.
 *
 * Called by the Patient Manager confirmation popup after a physician
 * reassignment. The physician ID comes from the request rather than the
 * episode so the popup applies exactly the physician the user confirmed —
 * not whatever the episode happens to point at by the time this runs.
 */
export const syncNoaPhysicianEpisodesEpisodeIdSyncNoaPhysicianPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SyncNoaPhysicianEpisodesEpisodeIdSyncNoaPhysicianPostData,
    ThrowOnError
  >
): RequestResult<
  SyncNoaPhysicianEpisodesEpisodeIdSyncNoaPhysicianPostResponses,
  SyncNoaPhysicianEpisodesEpisodeIdSyncNoaPhysicianPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SyncNoaPhysicianEpisodesEpisodeIdSyncNoaPhysicianPostResponses,
    SyncNoaPhysicianEpisodesEpisodeIdSyncNoaPhysicianPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/sync-noa-physician',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Episode
 *
 * Create a new Episode on the patient's latest open Admission.
 *
 * On an imported chart whose prior period closed with a recertification,
 * the response says whether that recert's diagnoses seeded the new claim
 * worksheet, or why they did not.
 */
export const createEpisode = <ThrowOnError extends boolean = false>(
  options: Options<CreateEpisodeData, ThrowOnError>
): RequestResult<CreateEpisodeResponses, CreateEpisodeErrors, ThrowOnError> =>
  (options.client ?? client).post<
    CreateEpisodeResponses,
    CreateEpisodeErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Take Over Plan
 *
 * What Take Over would do to this imported period, before anyone confirms.
 *
 * The claim periods with their default custody, the Notice of Admission
 * row, unfinished visits, edited rows, the chart's last refresh, and the
 * digest the confirm must name. Reads only. Gated on ``episode:take-over``
 * here and again in the CRUD. 404 for a period at a clinic the caller
 * cannot reach; 400 for a period Take Over cannot take.
 */
export const getEpisodeTakeOverPlan = <ThrowOnError extends boolean = false>(
  options: Options<GetEpisodeTakeOverPlanData, ThrowOnError>
): RequestResult<
  GetEpisodeTakeOverPlanResponses,
  GetEpisodeTakeOverPlanErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetEpisodeTakeOverPlanResponses,
    GetEpisodeTakeOverPlanErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/take-over/plan',
    ...options,
  });

/**
 * Take Over Episode
 *
 * Take the imported period over, exactly as the named plan showed it.
 *
 * Gated on ``episode:take-over`` at the route and again in the CRUD. The
 * access-lost override, for an agency Roger no longer syncs with, needs
 * only that slug and a reason (Daniel, 2026-10-13). Roger
 * bills every claim period the External EMR does not keep, the chart moves
 * to Roger, and the Notice of Admission is settled as chosen. It runs the
 * recert diagnosis carry as Add Episode does (Daniel, 2026-10-09: "1)
 * Yes."). 409 for a stale plan or a refresh still running; 400 for a
 * choice the plan does not allow.
 */
export const takeOverEpisode = <ThrowOnError extends boolean = false>(
  options: Options<TakeOverEpisodeData, ThrowOnError>
): RequestResult<
  TakeOverEpisodeResponses,
  TakeOverEpisodeErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    TakeOverEpisodeResponses,
    TakeOverEpisodeErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/take-over',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Set Roger Charts From
 *
 * Change the day Roger charts from after Take Over.
 *
 * Only on the taken-over episode that moved the chart, inside the period
 * and no later than the day after the last day in the External EMR (400
 * otherwise). Gated on ``episode:take-over`` here and again in the CRUD;
 * 404 for a period the caller cannot reach; 409 while a refresh of the
 * chart is live, as for the confirm. Imported visits between the
 * old and the new day change custody and are counted, never blocked. An
 * unchanged day writes nothing.
 */
export const setEpisodeRogerChartsFrom = <ThrowOnError extends boolean = false>(
  options: Options<SetEpisodeRogerChartsFromData, ThrowOnError>
): RequestResult<
  SetEpisodeRogerChartsFromResponses,
  SetEpisodeRogerChartsFromErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    SetEpisodeRogerChartsFromResponses,
    SetEpisodeRogerChartsFromErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/roger-charts-from',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Take Over Episode Basic
 *
 * Make an imported, unworked period Roger's instead of adding one beside it.
 *
 * The basic Take Over from Add Episode, as on main, for an agency without
 * Take Over v2. Refused with the permission wording where v2 is on, so an
 * agency has one path at a time (Daniel, 2026-10-14). Gated on
 * ``chart-import:start`` at the route and again in the CRUD (Daniel,
 * 2026-10-09: "Whoever can run the import can do this until we lock it
 * down later"). Roger bills the period from now on; the External EMR stops
 * being the record for it; a refresh never changes it again. It runs the
 * recert diagnosis carry as Add Episode does, and the response says what it
 * did.
 */
export const takeOverEpisodeBasic = <ThrowOnError extends boolean = false>(
  options: Options<TakeOverEpisodeBasicData, ThrowOnError>
): RequestResult<
  TakeOverEpisodeBasicResponses,
  TakeOverEpisodeBasicErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    TakeOverEpisodeBasicResponses,
    TakeOverEpisodeBasicErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/take-over/basic',
    ...options,
  });

/**
 * Get Take Over Undo Check
 *
 * Whether Take Over of this period can be undone now, and what undo does.
 *
 * Undo applies only while Roger has no work on this chart to keep. Lists
 * every family that refuses it, the claim periods undo removes, and what
 * happens to the Notice of Admission. Reads only. Gated on
 * ``episode:take-over`` here and again in the CRUD. 404 for a period at a
 * clinic the caller cannot reach; 400 for a period that is not the chart's
 * Take Over.
 */
export const getEpisodeTakeOverUndoCheck = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetEpisodeTakeOverUndoCheckData, ThrowOnError>
): RequestResult<
  GetEpisodeTakeOverUndoCheckResponses,
  GetEpisodeTakeOverUndoCheckErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetEpisodeTakeOverUndoCheckResponses,
    GetEpisodeTakeOverUndoCheckErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/take-over/undo-check',
    ...options,
  });

/**
 * Undo Take Over Episode
 *
 * Hand a taken-over period back to the External EMR (Take Over v2, WP-U1).
 *
 * Daniel, 2026-10-13: "a narrow-scope undo now, so long as no work or claim
 * has been done in Roger." Removes the claim periods Take Over created, puts
 * the Notice of Admission and the claim worksheet back, and the chart lock
 * applies again. Gated on ``episode:take-over`` at the route and again in
 * the CRUD. 403 at an agency without an External EMR, as for Take Over.
 * 409 with a ``code`` when anything refuses it (syncing off, a live
 * refresh, Roger's work since the move); 400 for a period that is not the chart's Take
 * Over; 404 for another clinic's period.
 */
export const undoEpisodeTakeOver = <ThrowOnError extends boolean = false>(
  options: Options<UndoEpisodeTakeOverData, ThrowOnError>
): RequestResult<
  UndoEpisodeTakeOverResponses,
  UndoEpisodeTakeOverErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UndoEpisodeTakeOverResponses,
    UndoEpisodeTakeOverErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/take-over/undo',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Episode Authorizations
 */
export const listEpisodeAuthorizationsEpisodesEpisodeIdAuthorizationsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListEpisodeAuthorizationsEpisodesEpisodeIdAuthorizationsGetData,
    ThrowOnError
  >
): RequestResult<
  ListEpisodeAuthorizationsEpisodesEpisodeIdAuthorizationsGetResponses,
  ListEpisodeAuthorizationsEpisodesEpisodeIdAuthorizationsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListEpisodeAuthorizationsEpisodesEpisodeIdAuthorizationsGetResponses,
    ListEpisodeAuthorizationsEpisodesEpisodeIdAuthorizationsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/authorizations/',
    ...options,
  });

/**
 * Create Episode Authorization
 */
export const createEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsPostData,
    ThrowOnError
  >
): RequestResult<
  CreateEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsPostResponses,
  CreateEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsPostResponses,
    CreateEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/authorizations/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Authorization Errors
 *
 * Return authorization compliance errors for an episode.
 *
 * Placed before ``/{authorization_id}`` so the literal path segment ``errors``
 * is not captured as a UUID path parameter.
 */
export const getAuthorizationErrorsEpisodesEpisodeIdAuthorizationsErrorsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAuthorizationErrorsEpisodesEpisodeIdAuthorizationsErrorsGetData,
    ThrowOnError
  >
): RequestResult<
  GetAuthorizationErrorsEpisodesEpisodeIdAuthorizationsErrorsGetResponses,
  GetAuthorizationErrorsEpisodesEpisodeIdAuthorizationsErrorsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAuthorizationErrorsEpisodesEpisodeIdAuthorizationsErrorsGetResponses,
    GetAuthorizationErrorsEpisodesEpisodeIdAuthorizationsErrorsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/authorizations/errors',
    ...options,
  });

/**
 * Check Planned Visits Endpoint
 *
 * Dry-run of authorization allocation for planned visits.
 *
 * Does not hard-block create; the create path's hard block refuses using
 * the same helper.
 */
export const checkPlannedVisits = <ThrowOnError extends boolean = false>(
  options: Options<CheckPlannedVisitsData, ThrowOnError>
): RequestResult<
  CheckPlannedVisitsResponses,
  CheckPlannedVisitsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CheckPlannedVisitsResponses,
    CheckPlannedVisitsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/authorizations/check',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Authorization Evaluation
 *
 * Return authorization utilization, links, and suggested assignments.
 */
export const getAuthorizationEvaluationEpisodesEpisodeIdAuthorizationsEvaluationGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetAuthorizationEvaluationEpisodesEpisodeIdAuthorizationsEvaluationGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetAuthorizationEvaluationEpisodesEpisodeIdAuthorizationsEvaluationGetResponses,
    GetAuthorizationEvaluationEpisodesEpisodeIdAuthorizationsEvaluationGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetAuthorizationEvaluationEpisodesEpisodeIdAuthorizationsEvaluationGetResponses,
      GetAuthorizationEvaluationEpisodesEpisodeIdAuthorizationsEvaluationGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/episodes/{episode_id}/authorizations/evaluation',
      ...options,
    });

/**
 * Delete Episode Authorization
 */
export const deleteEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdDeleteData,
      ThrowOnError
    >
  ): RequestResult<
    DeleteEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdDeleteResponses,
    DeleteEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdDeleteErrors,
    ThrowOnError
  > =>
    (options.client ?? client).delete<
      DeleteEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdDeleteResponses,
      DeleteEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdDeleteErrors,
      ThrowOnError
    >({
      url: '/episodes/{episode_id}/authorizations/{authorization_id}',
      ...options,
    });

/**
 * Get Episode Authorization
 */
export const getEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdGetResponses,
    GetEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdGetResponses,
      GetEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/episodes/{episode_id}/authorizations/{authorization_id}',
      ...options,
    });

/**
 * Update Episode Authorization
 */
export const updateEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdateEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdPutData,
      ThrowOnError
    >
  ): RequestResult<
    UpdateEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdPutResponses,
    UpdateEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdPutErrors,
    ThrowOnError
  > =>
    (options.client ?? client).put<
      UpdateEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdPutResponses,
      UpdateEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/episodes/{episode_id}/authorizations/{authorization_id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * List Episode Frequencies
 */
export const listEpisodeFrequenciesEpisodesEpisodeIdFrequenciesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListEpisodeFrequenciesEpisodesEpisodeIdFrequenciesGetData,
    ThrowOnError
  >
): RequestResult<
  ListEpisodeFrequenciesEpisodesEpisodeIdFrequenciesGetResponses,
  ListEpisodeFrequenciesEpisodesEpisodeIdFrequenciesGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListEpisodeFrequenciesEpisodesEpisodeIdFrequenciesGetResponses,
    ListEpisodeFrequenciesEpisodesEpisodeIdFrequenciesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/frequencies/',
    ...options,
  });

/**
 * Create Episode Frequency
 */
export const createEpisodeFrequencyEpisodesEpisodeIdFrequenciesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateEpisodeFrequencyEpisodesEpisodeIdFrequenciesPostData,
    ThrowOnError
  >
): RequestResult<
  CreateEpisodeFrequencyEpisodesEpisodeIdFrequenciesPostResponses,
  CreateEpisodeFrequencyEpisodesEpisodeIdFrequenciesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateEpisodeFrequencyEpisodesEpisodeIdFrequenciesPostResponses,
    CreateEpisodeFrequencyEpisodesEpisodeIdFrequenciesPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/frequencies/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Episode Frequency
 */
export const deleteEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdDeleteData,
      ThrowOnError
    >
  ): RequestResult<
    DeleteEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdDeleteResponses,
    DeleteEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdDeleteErrors,
    ThrowOnError
  > =>
    (options.client ?? client).delete<
      DeleteEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdDeleteResponses,
      DeleteEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdDeleteErrors,
      ThrowOnError
    >({ url: '/episodes/{episode_id}/frequencies/{frequency_id}', ...options });

/**
 * Get Episode Frequency
 */
export const getEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdGetData,
    ThrowOnError
  >
): RequestResult<
  GetEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdGetResponses,
  GetEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdGetResponses,
    GetEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/frequencies/{frequency_id}',
    ...options,
  });

/**
 * Update Episode Frequency
 */
export const updateEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdateEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdPutData,
      ThrowOnError
    >
  ): RequestResult<
    UpdateEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdPutResponses,
    UpdateEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdPutErrors,
    ThrowOnError
  > =>
    (options.client ?? client).put<
      UpdateEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdPutResponses,
      UpdateEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/episodes/{episode_id}/frequencies/{frequency_id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * List Fall Logs
 */
export const listFallLogsPatientsPatientIdFallLogsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ListFallLogsPatientsPatientIdFallLogsGetData, ThrowOnError>
): RequestResult<
  ListFallLogsPatientsPatientIdFallLogsGetResponses,
  ListFallLogsPatientsPatientIdFallLogsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListFallLogsPatientsPatientIdFallLogsGetResponses,
    ListFallLogsPatientsPatientIdFallLogsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/fall-logs/',
    ...options,
  });

/**
 * Create Fall Log Endpoint
 */
export const createFallLogEndpointPatientsPatientIdFallLogsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateFallLogEndpointPatientsPatientIdFallLogsPostData,
    ThrowOnError
  >
): RequestResult<
  CreateFallLogEndpointPatientsPatientIdFallLogsPostResponses,
  CreateFallLogEndpointPatientsPatientIdFallLogsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateFallLogEndpointPatientsPatientIdFallLogsPostResponses,
    CreateFallLogEndpointPatientsPatientIdFallLogsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/fall-logs/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Fall Log Endpoint
 */
export const deleteFallLogEndpointPatientsPatientIdFallLogsFallLogIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteFallLogEndpointPatientsPatientIdFallLogsFallLogIdDeleteData,
    ThrowOnError
  >
): RequestResult<
  DeleteFallLogEndpointPatientsPatientIdFallLogsFallLogIdDeleteResponses,
  DeleteFallLogEndpointPatientsPatientIdFallLogsFallLogIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteFallLogEndpointPatientsPatientIdFallLogsFallLogIdDeleteResponses,
    DeleteFallLogEndpointPatientsPatientIdFallLogsFallLogIdDeleteErrors,
    ThrowOnError
  >({ url: '/patients/{patient_id}/fall-logs/{fall_log_id}', ...options });

/**
 * Update Fall Log Endpoint
 */
export const updateFallLogEndpointPatientsPatientIdFallLogsFallLogIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateFallLogEndpointPatientsPatientIdFallLogsFallLogIdPutData,
    ThrowOnError
  >
): RequestResult<
  UpdateFallLogEndpointPatientsPatientIdFallLogsFallLogIdPutResponses,
  UpdateFallLogEndpointPatientsPatientIdFallLogsFallLogIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateFallLogEndpointPatientsPatientIdFallLogsFallLogIdPutResponses,
    UpdateFallLogEndpointPatientsPatientIdFallLogsFallLogIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/fall-logs/{fall_log_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Fall Log Pdf
 *
 * Return a printable one-event fall report, for audits and surveys.
 */
export const getFallLogPdfPatientsPatientIdFallLogsFallLogIdPdfGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetFallLogPdfPatientsPatientIdFallLogsFallLogIdPdfGetData,
    ThrowOnError
  >
): RequestResult<
  GetFallLogPdfPatientsPatientIdFallLogsFallLogIdPdfGetResponses,
  GetFallLogPdfPatientsPatientIdFallLogsFallLogIdPdfGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetFallLogPdfPatientsPatientIdFallLogsFallLogIdPdfGetResponses,
    GetFallLogPdfPatientsPatientIdFallLogsFallLogIdPdfGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/patients/{patient_id}/fall-logs/{fall_log_id}/pdf',
    ...options,
  });

/**
 * List Historical Claim Captures
 */
export const listHistoricalClaimCaptures = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ListHistoricalClaimCapturesData, ThrowOnError>
): RequestResult<
  ListHistoricalClaimCapturesResponses,
  ListHistoricalClaimCapturesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListHistoricalClaimCapturesResponses,
    ListHistoricalClaimCapturesErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/historical-claims',
    ...options,
  });

/**
 * Get Historical Claim Capture
 */
export const getHistoricalClaimCapture = <ThrowOnError extends boolean = false>(
  options: Options<GetHistoricalClaimCaptureData, ThrowOnError>
): RequestResult<
  GetHistoricalClaimCaptureResponses,
  GetHistoricalClaimCaptureErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetHistoricalClaimCaptureResponses,
    GetHistoricalClaimCaptureErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/historical-claims/{capture_id}',
    ...options,
  });

/**
 * Download Historical Claim Print
 */
export const downloadHistoricalClaimPrint = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DownloadHistoricalClaimPrintData, ThrowOnError>
): RequestResult<
  DownloadHistoricalClaimPrintResponses,
  DownloadHistoricalClaimPrintErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    DownloadHistoricalClaimPrintResponses,
    DownloadHistoricalClaimPrintErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/patients/{patient_id}/historical-claims/{capture_id}/prints/{print_id}',
    ...options,
  });

/**
 * List Episodes For Patient
 *
 * List a patient's episodes and whether a new one can be added.
 */
export const listEpisodesForPatient = <ThrowOnError extends boolean = false>(
  options: Options<ListEpisodesForPatientData, ThrowOnError>
): RequestResult<
  ListEpisodesForPatientResponses,
  ListEpisodesForPatientErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListEpisodesForPatientResponses,
    ListEpisodesForPatientErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/episodes',
    ...options,
  });

/**
 * List Clinic Physicians
 *
 * List active clinic physicians for a clinic.
 */
export const listClinicPhysiciansAdminClinicPhysiciansGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListClinicPhysiciansAdminClinicPhysiciansGetData,
    ThrowOnError
  >
): RequestResult<
  ListClinicPhysiciansAdminClinicPhysiciansGetResponses,
  ListClinicPhysiciansAdminClinicPhysiciansGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListClinicPhysiciansAdminClinicPhysiciansGetResponses,
    ListClinicPhysiciansAdminClinicPhysiciansGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/admin/clinic-physicians/',
    ...options,
  });

/**
 * Create Clinic Physician
 *
 * Create a new clinic physician.
 */
export const createClinicPhysicianAdminClinicPhysiciansPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateClinicPhysicianAdminClinicPhysiciansPostData,
    ThrowOnError
  >
): RequestResult<
  CreateClinicPhysicianAdminClinicPhysiciansPostResponses,
  CreateClinicPhysicianAdminClinicPhysiciansPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateClinicPhysicianAdminClinicPhysiciansPostResponses,
    CreateClinicPhysicianAdminClinicPhysiciansPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/admin/clinic-physicians/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Duplicate Clinic Physicians
 *
 * Copy every physician from a source clinic onto a destination clinic.
 *
 * Useful when onboarding a clinic that should reuse the physician roster of
 * another (e.g. copying from a scraped Kinnser clinic onto a Roger-only
 * clinic). Destination must not participate in Kinnser. Physicians whose NPI
 * already exists on the destination clinic — or that have no NPI — are
 * skipped, so the operation is safe to re-run.
 *
 * Only available when the agency has is_rogeremr_enabled=True. Both clinics
 * must belong to the agency.
 */
export const duplicateClinicPhysiciansAdminClinicPhysiciansDuplicatePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DuplicateClinicPhysiciansAdminClinicPhysiciansDuplicatePostData,
    ThrowOnError
  >
): RequestResult<
  DuplicateClinicPhysiciansAdminClinicPhysiciansDuplicatePostResponses,
  DuplicateClinicPhysiciansAdminClinicPhysiciansDuplicatePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DuplicateClinicPhysiciansAdminClinicPhysiciansDuplicatePostResponses,
    DuplicateClinicPhysiciansAdminClinicPhysiciansDuplicatePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/admin/clinic-physicians/duplicate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Clinic Physician
 *
 * Soft-delete a clinic physician. 409 if referenced by an episode, intake, or communication.
 */
export const deleteClinicPhysicianAdminClinicPhysiciansClinicPhysicianIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteClinicPhysicianAdminClinicPhysiciansClinicPhysicianIdDeleteData,
      ThrowOnError
    >
  ): RequestResult<
    DeleteClinicPhysicianAdminClinicPhysiciansClinicPhysicianIdDeleteResponses,
    DeleteClinicPhysicianAdminClinicPhysiciansClinicPhysicianIdDeleteErrors,
    ThrowOnError
  > =>
    (options.client ?? client).delete<
      DeleteClinicPhysicianAdminClinicPhysiciansClinicPhysicianIdDeleteResponses,
      DeleteClinicPhysicianAdminClinicPhysiciansClinicPhysicianIdDeleteErrors,
      ThrowOnError
    >({ url: '/admin/clinic-physicians/{clinic_physician_id}', ...options });

/**
 * Update Clinic Physician
 *
 * Update a clinic physician.
 */
export const updateClinicPhysicianAdminClinicPhysiciansClinicPhysicianIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateClinicPhysicianAdminClinicPhysiciansClinicPhysicianIdPutData,
    ThrowOnError
  >
): RequestResult<
  UpdateClinicPhysicianAdminClinicPhysiciansClinicPhysicianIdPutResponses,
  UpdateClinicPhysicianAdminClinicPhysiciansClinicPhysicianIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateClinicPhysicianAdminClinicPhysiciansClinicPhysicianIdPutResponses,
    UpdateClinicPhysicianAdminClinicPhysiciansClinicPhysicianIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/admin/clinic-physicians/{clinic_physician_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Admission
 *
 * Fetch one admission.
 */
export const getAdmissionAdmissionsAdmissionIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdmissionAdmissionsAdmissionIdGetData, ThrowOnError>
): RequestResult<
  GetAdmissionAdmissionsAdmissionIdGetResponses,
  GetAdmissionAdmissionsAdmissionIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAdmissionAdmissionsAdmissionIdGetResponses,
    GetAdmissionAdmissionsAdmissionIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/admissions/{admission_id}',
    ...options,
  });

/**
 * Update Admission
 *
 * Update the editable subset of an admission.
 */
export const updateAdmissionAdmissionsAdmissionIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateAdmissionAdmissionsAdmissionIdPatchData, ThrowOnError>
): RequestResult<
  UpdateAdmissionAdmissionsAdmissionIdPatchResponses,
  UpdateAdmissionAdmissionsAdmissionIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateAdmissionAdmissionsAdmissionIdPatchResponses,
    UpdateAdmissionAdmissionsAdmissionIdPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/admissions/{admission_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Admission Work Log
 *
 * Return one page of the admission's work log, oldest first.
 *
 * Who changed the admission, when, and what moved. Needs ``worklog:view``
 * and ``patient-info:edit`` together. An admission of another agency, or of
 * a clinic the caller cannot reach, answers 404 like one that does not
 * exist. Pass a page's ``next_cursor`` back as ``cursor`` for the next one.
 */
export const getAdmissionWorkLogAdmissionsAdmissionIdWorkLogGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdmissionWorkLogAdmissionsAdmissionIdWorkLogGetData,
    ThrowOnError
  >
): RequestResult<
  GetAdmissionWorkLogAdmissionsAdmissionIdWorkLogGetResponses,
  GetAdmissionWorkLogAdmissionsAdmissionIdWorkLogGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAdmissionWorkLogAdmissionsAdmissionIdWorkLogGetResponses,
    GetAdmissionWorkLogAdmissionsAdmissionIdWorkLogGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/admissions/{admission_id}/work-log',
    ...options,
  });

/**
 * List Internal Referral Sources For Intake
 *
 * List active internal referral sources for a clinic.
 */
export const listInternalReferralSourcesForIntakeInternalReferralSourcesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListInternalReferralSourcesForIntakeInternalReferralSourcesGetData,
    ThrowOnError
  >
): RequestResult<
  ListInternalReferralSourcesForIntakeInternalReferralSourcesGetResponses,
  ListInternalReferralSourcesForIntakeInternalReferralSourcesGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListInternalReferralSourcesForIntakeInternalReferralSourcesGetResponses,
    ListInternalReferralSourcesForIntakeInternalReferralSourcesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-referral-sources/',
    ...options,
  });

/**
 * List Internal Referral Sources
 *
 * List active internal referral sources for a clinic.
 */
export const listInternalReferralSourcesAdminInternalReferralSourcesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListInternalReferralSourcesAdminInternalReferralSourcesGetData,
    ThrowOnError
  >
): RequestResult<
  ListInternalReferralSourcesAdminInternalReferralSourcesGetResponses,
  ListInternalReferralSourcesAdminInternalReferralSourcesGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListInternalReferralSourcesAdminInternalReferralSourcesGetResponses,
    ListInternalReferralSourcesAdminInternalReferralSourcesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/admin/internal-referral-sources/',
    ...options,
  });

/**
 * Create Internal Referral Source
 *
 * Create an internal referral source.
 */
export const createInternalReferralSourceAdminInternalReferralSourcesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateInternalReferralSourceAdminInternalReferralSourcesPostData,
    ThrowOnError
  >
): RequestResult<
  CreateInternalReferralSourceAdminInternalReferralSourcesPostResponses,
  CreateInternalReferralSourceAdminInternalReferralSourcesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateInternalReferralSourceAdminInternalReferralSourcesPostResponses,
    CreateInternalReferralSourceAdminInternalReferralSourcesPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/admin/internal-referral-sources/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Internal Referral Source
 *
 * Retire an internal referral source.
 *
 * Admissions and intakes that already reference it keep resolving the name;
 * the row simply stops appearing in the dropdown.
 */
export const deleteInternalReferralSourceAdminInternalReferralSourcesSourceIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteInternalReferralSourceAdminInternalReferralSourcesSourceIdDeleteData,
      ThrowOnError
    >
  ): RequestResult<
    DeleteInternalReferralSourceAdminInternalReferralSourcesSourceIdDeleteResponses,
    DeleteInternalReferralSourceAdminInternalReferralSourcesSourceIdDeleteErrors,
    ThrowOnError
  > =>
    (options.client ?? client).delete<
      DeleteInternalReferralSourceAdminInternalReferralSourcesSourceIdDeleteResponses,
      DeleteInternalReferralSourceAdminInternalReferralSourcesSourceIdDeleteErrors,
      ThrowOnError
    >({ url: '/admin/internal-referral-sources/{source_id}', ...options });

/**
 * Update Internal Referral Source
 *
 * Update an internal referral source.
 */
export const updateInternalReferralSourceAdminInternalReferralSourcesSourceIdPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdateInternalReferralSourceAdminInternalReferralSourcesSourceIdPutData,
      ThrowOnError
    >
  ): RequestResult<
    UpdateInternalReferralSourceAdminInternalReferralSourcesSourceIdPutResponses,
    UpdateInternalReferralSourceAdminInternalReferralSourcesSourceIdPutErrors,
    ThrowOnError
  > =>
    (options.client ?? client).put<
      UpdateInternalReferralSourceAdminInternalReferralSourcesSourceIdPutResponses,
      UpdateInternalReferralSourceAdminInternalReferralSourcesSourceIdPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/admin/internal-referral-sources/{source_id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * List Form Templates For Visit
 *
 * Every active template for the agency with this target, for a picker.
 *
 * For a form question, the whole library in one response on purpose: a form
 * renders many text fields and matches by QID, and asking per field would be
 * one request per box.
 */
export const listFormTemplatesForVisitFormTemplatesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListFormTemplatesForVisitFormTemplatesGetData, ThrowOnError>
): RequestResult<
  ListFormTemplatesForVisitFormTemplatesGetResponses,
  ListFormTemplatesForVisitFormTemplatesGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListFormTemplatesForVisitFormTemplatesGetResponses,
    ListFormTemplatesForVisitFormTemplatesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/form-templates/',
    ...options,
  });

/**
 * List Allowed Form Template Questions
 *
 * Question ids a template may be authored for, sorted.
 *
 * The Admin screen narrows its field picker to these, and marks a template
 * whose question has since left the list. Serving them rather than shipping a
 * second copy to the client keeps one definition of the policy the create
 * route enforces.
 */
export const listAllowedFormTemplateQuestionsAdminFormTemplatesAllowedQuestionsGet =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      ListAllowedFormTemplateQuestionsAdminFormTemplatesAllowedQuestionsGetData,
      ThrowOnError
    >
  ): RequestResult<
    ListAllowedFormTemplateQuestionsAdminFormTemplatesAllowedQuestionsGetResponses,
    unknown,
    ThrowOnError
  > =>
    (options?.client ?? client).get<
      ListAllowedFormTemplateQuestionsAdminFormTemplatesAllowedQuestionsGetResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/admin/form-templates/allowed-questions',
      ...options,
    });

/**
 * List Form Templates
 *
 * Every template with this target including retired ones, for its Admin screen.
 */
export const listFormTemplatesAdminFormTemplatesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListFormTemplatesAdminFormTemplatesGetData, ThrowOnError>
): RequestResult<
  ListFormTemplatesAdminFormTemplatesGetResponses,
  ListFormTemplatesAdminFormTemplatesGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListFormTemplatesAdminFormTemplatesGetResponses,
    ListFormTemplatesAdminFormTemplatesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/admin/form-templates/',
    ...options,
  });

/**
 * Create Form Template
 *
 * Create a form template.
 */
export const createFormTemplateAdminFormTemplatesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateFormTemplateAdminFormTemplatesPostData, ThrowOnError>
): RequestResult<
  CreateFormTemplateAdminFormTemplatesPostResponses,
  CreateFormTemplateAdminFormTemplatesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateFormTemplateAdminFormTemplatesPostResponses,
    CreateFormTemplateAdminFormTemplatesPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/admin/form-templates/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Form Template
 *
 * Retire a form template.
 *
 * Not a delete. The row stays so an admin who retired the wrong template can
 * bring it back by setting ``is_active`` again, which matters because the text
 * is prose the agency wrote and nothing else holds a copy.
 */
export const deleteFormTemplateAdminFormTemplatesTemplateIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteFormTemplateAdminFormTemplatesTemplateIdDeleteData,
    ThrowOnError
  >
): RequestResult<
  DeleteFormTemplateAdminFormTemplatesTemplateIdDeleteResponses,
  DeleteFormTemplateAdminFormTemplatesTemplateIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteFormTemplateAdminFormTemplatesTemplateIdDeleteResponses,
    DeleteFormTemplateAdminFormTemplatesTemplateIdDeleteErrors,
    ThrowOnError
  >({ url: '/admin/form-templates/{template_id}', ...options });

/**
 * Update Form Template
 *
 * Update a form template.
 */
export const updateFormTemplateAdminFormTemplatesTemplateIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateFormTemplateAdminFormTemplatesTemplateIdPutData,
    ThrowOnError
  >
): RequestResult<
  UpdateFormTemplateAdminFormTemplatesTemplateIdPutResponses,
  UpdateFormTemplateAdminFormTemplatesTemplateIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateFormTemplateAdminFormTemplatesTemplateIdPutResponses,
    UpdateFormTemplateAdminFormTemplatesTemplateIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/admin/form-templates/{template_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List User License Types For Picker
 *
 * Active license types this agency may record a license against.
 */
export const listUserLicenseTypesForPickerUserLicenseTypesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ListUserLicenseTypesForPickerUserLicenseTypesGetData,
    ThrowOnError
  >
): RequestResult<
  ListUserLicenseTypesForPickerUserLicenseTypesGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListUserLicenseTypesForPickerUserLicenseTypesGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/user-license-types/',
    ...options,
  });

/**
 * List User License Types
 *
 * Every license type this agency sees, defaults included.
 */
export const listUserLicenseTypesAdminUserLicenseTypesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ListUserLicenseTypesAdminUserLicenseTypesGetData,
    ThrowOnError
  >
): RequestResult<
  ListUserLicenseTypesAdminUserLicenseTypesGetResponses,
  ListUserLicenseTypesAdminUserLicenseTypesGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListUserLicenseTypesAdminUserLicenseTypesGetResponses,
    ListUserLicenseTypesAdminUserLicenseTypesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/admin/user-license-types/',
    ...options,
  });

/**
 * Create User License Type
 *
 * Add a license type to this agency's own list.
 */
export const createUserLicenseTypeAdminUserLicenseTypesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateUserLicenseTypeAdminUserLicenseTypesPostData,
    ThrowOnError
  >
): RequestResult<
  CreateUserLicenseTypeAdminUserLicenseTypesPostResponses,
  CreateUserLicenseTypeAdminUserLicenseTypesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateUserLicenseTypeAdminUserLicenseTypesPostResponses,
    CreateUserLicenseTypeAdminUserLicenseTypesPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/admin/user-license-types/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete User License Type
 *
 * Retire one of this agency's own license types.
 *
 * Not a row delete: the licenses already recorded against it keep resolving
 * its name, and the foreign key from ``user_licenses`` would refuse a delete
 * anyway. The type simply stops appearing in the picker.
 */
export const deleteUserLicenseTypeAdminUserLicenseTypesTypeIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteUserLicenseTypeAdminUserLicenseTypesTypeIdDeleteData,
    ThrowOnError
  >
): RequestResult<
  DeleteUserLicenseTypeAdminUserLicenseTypesTypeIdDeleteResponses,
  DeleteUserLicenseTypeAdminUserLicenseTypesTypeIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteUserLicenseTypeAdminUserLicenseTypesTypeIdDeleteResponses,
    DeleteUserLicenseTypeAdminUserLicenseTypesTypeIdDeleteErrors,
    ThrowOnError
  >({ url: '/admin/user-license-types/{type_id}', ...options });

/**
 * Update User License Type
 *
 * Rename or reactivate one of this agency's own license types.
 */
export const updateUserLicenseTypeAdminUserLicenseTypesTypeIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateUserLicenseTypeAdminUserLicenseTypesTypeIdPutData,
    ThrowOnError
  >
): RequestResult<
  UpdateUserLicenseTypeAdminUserLicenseTypesTypeIdPutResponses,
  UpdateUserLicenseTypeAdminUserLicenseTypesTypeIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateUserLicenseTypeAdminUserLicenseTypesTypeIdPutResponses,
    UpdateUserLicenseTypeAdminUserLicenseTypesTypeIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/admin/user-license-types/{type_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Count User Licenses
 *
 * License counts per member of staff, for the User Manager grid.
 *
 * Members with none are left out. One grouped count rather than a list call
 * per row.
 */
export const countUserLicensesUserLicensesCountsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<CountUserLicensesUserLicensesCountsGetData, ThrowOnError>
): RequestResult<
  CountUserLicensesUserLicensesCountsGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    CountUserLicensesUserLicensesCountsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/user-licenses/counts',
    ...options,
  });

/**
 * List User Licenses
 *
 * Licenses this agency holds for one member of staff.
 */
export const listUserLicensesUserLicensesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ListUserLicensesUserLicensesGetData, ThrowOnError>
): RequestResult<
  ListUserLicensesUserLicensesGetResponses,
  ListUserLicensesUserLicensesGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListUserLicensesUserLicensesGetResponses,
    ListUserLicensesUserLicensesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/user-licenses/',
    ...options,
  });

/**
 * Create User License
 *
 * Record a license against a member of staff.
 */
export const createUserLicenseUserLicensesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateUserLicenseUserLicensesPostData, ThrowOnError>
): RequestResult<
  CreateUserLicenseUserLicensesPostResponses,
  CreateUserLicenseUserLicensesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateUserLicenseUserLicensesPostResponses,
    CreateUserLicenseUserLicensesPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/user-licenses/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete User License
 *
 * Remove a license and reclaim the scans attached to it.
 *
 * The rows go first and the bytes follow the commit, because deleting the
 * objects inside the transaction breaks the surviving rows' files on a
 * rollback. What makes that order safe is queuing the condemned keys in the
 * same transaction that kills the rows naming them: the row is otherwise the
 * only record of where those bytes live, so a worker lost between the commit
 * and the purge — a deploy, an eviction, one transient S3 error — would strand
 * an image of somebody's Social Security card in the bucket with nothing left
 * to find it by. Queued, it survives all three and the next drain finishes.
 */
export const deleteUserLicenseUserLicensesLicenseIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteUserLicenseUserLicensesLicenseIdDeleteData,
    ThrowOnError
  >
): RequestResult<
  DeleteUserLicenseUserLicensesLicenseIdDeleteResponses,
  DeleteUserLicenseUserLicensesLicenseIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteUserLicenseUserLicensesLicenseIdDeleteResponses,
    DeleteUserLicenseUserLicensesLicenseIdDeleteErrors,
    ThrowOnError
  >({ url: '/user-licenses/{license_id}', ...options });

/**
 * Update User License
 *
 * Edit a license. Absent fields are left alone, explicit nulls clear.
 */
export const updateUserLicenseUserLicensesLicenseIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateUserLicenseUserLicensesLicenseIdPutData, ThrowOnError>
): RequestResult<
  UpdateUserLicenseUserLicensesLicenseIdPutResponses,
  UpdateUserLicenseUserLicensesLicenseIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateUserLicenseUserLicensesLicenseIdPutResponses,
    UpdateUserLicenseUserLicensesLicenseIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/user-licenses/{license_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List User License Documents
 *
 * Scans attached to one license.
 */
export const listUserLicenseDocumentsUserLicensesLicenseIdDocumentsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListUserLicenseDocumentsUserLicensesLicenseIdDocumentsGetData,
    ThrowOnError
  >
): RequestResult<
  ListUserLicenseDocumentsUserLicensesLicenseIdDocumentsGetResponses,
  ListUserLicenseDocumentsUserLicensesLicenseIdDocumentsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListUserLicenseDocumentsUserLicensesLicenseIdDocumentsGetResponses,
    ListUserLicenseDocumentsUserLicensesLicenseIdDocumentsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/user-licenses/{license_id}/documents',
    ...options,
  });

/**
 * Upload User License Document
 *
 * Attach a scan to a license.
 */
export const uploadUserLicenseDocumentUserLicensesLicenseIdDocumentsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UploadUserLicenseDocumentUserLicensesLicenseIdDocumentsPostData,
    ThrowOnError
  >
): RequestResult<
  UploadUserLicenseDocumentUserLicensesLicenseIdDocumentsPostResponses,
  UploadUserLicenseDocumentUserLicensesLicenseIdDocumentsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UploadUserLicenseDocumentUserLicensesLicenseIdDocumentsPostResponses,
    UploadUserLicenseDocumentUserLicensesLicenseIdDocumentsPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/user-licenses/{license_id}/documents',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Get User License Document Url
 *
 * A short-lived download URL for one scan.
 *
 * The URL carries its own authorization for an hour, so somebody whose view
 * permission is removed inside that window can still fetch a URL they already
 * hold. That is true of every presigned download in the product; shortening the
 * expiry is the lever if it ever matters for these documents.
 */
export const getUserLicenseDocumentUrlUserLicensesLicenseIdDocumentsDocumentIdUrlGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetUserLicenseDocumentUrlUserLicensesLicenseIdDocumentsDocumentIdUrlGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetUserLicenseDocumentUrlUserLicensesLicenseIdDocumentsDocumentIdUrlGetResponses,
    GetUserLicenseDocumentUrlUserLicensesLicenseIdDocumentsDocumentIdUrlGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetUserLicenseDocumentUrlUserLicensesLicenseIdDocumentsDocumentIdUrlGetResponses,
      GetUserLicenseDocumentUrlUserLicensesLicenseIdDocumentsDocumentIdUrlGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/user-licenses/{license_id}/documents/{document_id}/url',
      ...options,
    });

/**
 * Delete User License Document
 *
 * Remove one scan, and reclaim its bytes once the row is really gone.
 *
 * Same order and same reason as ``delete_user_license``: the key is queued in
 * the transaction that removes the row naming it, so nothing can lose track of
 * the object between the commit and the purge.
 */
export const deleteUserLicenseDocumentUserLicensesLicenseIdDocumentsDocumentIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteUserLicenseDocumentUserLicensesLicenseIdDocumentsDocumentIdDeleteData,
      ThrowOnError
    >
  ): RequestResult<
    DeleteUserLicenseDocumentUserLicensesLicenseIdDocumentsDocumentIdDeleteResponses,
    DeleteUserLicenseDocumentUserLicensesLicenseIdDocumentsDocumentIdDeleteErrors,
    ThrowOnError
  > =>
    (options.client ?? client).delete<
      DeleteUserLicenseDocumentUserLicensesLicenseIdDocumentsDocumentIdDeleteResponses,
      DeleteUserLicenseDocumentUserLicensesLicenseIdDocumentsDocumentIdDeleteErrors,
      ThrowOnError
    >({
      url: '/user-licenses/{license_id}/documents/{document_id}',
      ...options,
    });

/**
 * Get Order Manager Counts
 *
 * Return order counts for each Order Manager tab.
 */
export const getOrderManagerCountsOrdersManagerCountsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetOrderManagerCountsOrdersManagerCountsGetData,
    ThrowOnError
  >
): RequestResult<
  GetOrderManagerCountsOrdersManagerCountsGetResponses,
  GetOrderManagerCountsOrdersManagerCountsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetOrderManagerCountsOrdersManagerCountsGetResponses,
    GetOrderManagerCountsOrdersManagerCountsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/orders/manager/counts',
    ...options,
  });

/**
 * Get Order Manager Filter Options
 *
 * Return physician and order-type options for Order Manager filters.
 */
export const getOrderManagerFilterOptionsOrdersManagerOptionsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetOrderManagerFilterOptionsOrdersManagerOptionsGetData,
    ThrowOnError
  >
): RequestResult<
  GetOrderManagerFilterOptionsOrdersManagerOptionsGetResponses,
  GetOrderManagerFilterOptionsOrdersManagerOptionsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetOrderManagerFilterOptionsOrdersManagerOptionsGetResponses,
    GetOrderManagerFilterOptionsOrdersManagerOptionsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/orders/manager/options',
    ...options,
  });

/**
 * Get Order Type Options
 *
 * Return the list of order type IDs with display names + signature flag.
 *
 * Mirrors ``/visits/type-options``. The frontend merges both lists for the
 * create-task UI. Excludes generated-only types (e.g. MEDICATION_ORDER) that
 * POST /orders rejects — those flow through their own workflows.
 */
export const getOrderTypeOptionsOrdersTypeOptionsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetOrderTypeOptionsOrdersTypeOptionsGetData, ThrowOnError>
): RequestResult<
  GetOrderTypeOptionsOrdersTypeOptionsGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetOrderTypeOptionsOrdersTypeOptionsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/orders/type-options',
    ...options,
  });

/**
 * Get Order Manager Items
 *
 * List a page of orders for the Order Manager, filtered by status.
 */
export const getOrderManagerItemsOrdersManagerGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetOrderManagerItemsOrdersManagerGetData, ThrowOnError>
): RequestResult<
  GetOrderManagerItemsOrdersManagerGetResponses,
  GetOrderManagerItemsOrdersManagerGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetOrderManagerItemsOrdersManagerGetResponses,
    GetOrderManagerItemsOrdersManagerGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/orders/manager',
    ...options,
  });

/**
 * Get Order Cms485 Prefill
 *
 * Return CMS-485 prefill fields for this order's episode and a chosen OASIS visit.
 *
 * Resolves the order's episode and patient automatically so the frontend can
 * request prefill using only the order id plus the linked OASIS visit id.
 */
export const getOrderCms485PrefillOrdersOrderIdCms485PrefillGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetOrderCms485PrefillOrdersOrderIdCms485PrefillGetData,
    ThrowOnError
  >
): RequestResult<
  GetOrderCms485PrefillOrdersOrderIdCms485PrefillGetResponses,
  GetOrderCms485PrefillOrdersOrderIdCms485PrefillGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetOrderCms485PrefillOrdersOrderIdCms485PrefillGetResponses,
    GetOrderCms485PrefillOrdersOrderIdCms485PrefillGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/orders/{order_id}/cms485-prefill',
    ...options,
  });

/**
 * Get Order Cms485 Form
 *
 * Return the full CMS-485 form snapshot for rendering the order form.
 */
export const getOrderCms485FormOrdersOrderIdCms485FormGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetOrderCms485FormOrdersOrderIdCms485FormGetData,
    ThrowOnError
  >
): RequestResult<
  GetOrderCms485FormOrdersOrderIdCms485FormGetResponses,
  GetOrderCms485FormOrdersOrderIdCms485FormGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetOrderCms485FormOrdersOrderIdCms485FormGetResponses,
    GetOrderCms485FormOrdersOrderIdCms485FormGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/orders/{order_id}/cms485-form',
    ...options,
  });

/**
 * Get Order Pho Prefill
 *
 * Return prefill fields for a Post Hospital Order from a ROC visit.
 *
 * Uses the same OASIS extraction logic as CMS-485 since ROC assessments
 * contain the same clinical data fields.
 */
export const getOrderPhoPrefillOrdersOrderIdPhoPrefillGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetOrderPhoPrefillOrdersOrderIdPhoPrefillGetData,
    ThrowOnError
  >
): RequestResult<
  GetOrderPhoPrefillOrdersOrderIdPhoPrefillGetResponses,
  GetOrderPhoPrefillOrdersOrderIdPhoPrefillGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetOrderPhoPrefillOrdersOrderIdPhoPrefillGetResponses,
    GetOrderPhoPrefillOrdersOrderIdPhoPrefillGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/orders/{order_id}/pho-prefill',
    ...options,
  });

/**
 * Checkout Order
 *
 * Send a completed order (Order Manager checkout).
 *
 * Branches on the order type's signature_required flag:
 * - True  → SENT_TO_PHYSICIAN (awaits physician sign-back via checkin_order)
 * - False → SENT_NO_SIGNATURE_REQUIRED (terminal; no checkin step)
 */
export const checkoutOrderOrdersOrderIdCheckoutPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CheckoutOrderOrdersOrderIdCheckoutPostData, ThrowOnError>
): RequestResult<
  CheckoutOrderOrdersOrderIdCheckoutPostResponses,
  CheckoutOrderOrdersOrderIdCheckoutPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CheckoutOrderOrdersOrderIdCheckoutPostResponses,
    CheckoutOrderOrdersOrderIdCheckoutPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/orders/{order_id}/checkout',
    ...options,
  });

/**
 * Checkin Order
 *
 * Mark a sent order as returned with physician signature.
 *
 * Only valid for signature-required order types; rejects others with 409.
 */
export const checkinOrderOrdersOrderIdCheckinPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CheckinOrderOrdersOrderIdCheckinPostData, ThrowOnError>
): RequestResult<
  CheckinOrderOrdersOrderIdCheckinPostResponses,
  CheckinOrderOrdersOrderIdCheckinPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CheckinOrderOrdersOrderIdCheckinPostResponses,
    CheckinOrderOrdersOrderIdCheckinPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/orders/{order_id}/checkin',
    ...options,
  });

/**
 * Revert Checkout Order
 *
 * Move a sent order back to the Order Manager To Be Sent tab.
 */
export const revertCheckoutOrderOrdersOrderIdRevertCheckoutPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RevertCheckoutOrderOrdersOrderIdRevertCheckoutPostData,
    ThrowOnError
  >
): RequestResult<
  RevertCheckoutOrderOrdersOrderIdRevertCheckoutPostResponses,
  RevertCheckoutOrderOrdersOrderIdRevertCheckoutPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RevertCheckoutOrderOrdersOrderIdRevertCheckoutPostResponses,
    RevertCheckoutOrderOrdersOrderIdRevertCheckoutPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/orders/{order_id}/revert-checkout',
    ...options,
  });

/**
 * Revert Checkin Order
 *
 * Move a returned order back to the Order Manager Pending Signature tab.
 */
export const revertCheckinOrderOrdersOrderIdRevertCheckinPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RevertCheckinOrderOrdersOrderIdRevertCheckinPostData,
    ThrowOnError
  >
): RequestResult<
  RevertCheckinOrderOrdersOrderIdRevertCheckinPostResponses,
  RevertCheckinOrderOrdersOrderIdRevertCheckinPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RevertCheckinOrderOrdersOrderIdRevertCheckinPostResponses,
    RevertCheckinOrderOrdersOrderIdRevertCheckinPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/orders/{order_id}/revert-checkin',
    ...options,
  });

/**
 * Delete Order
 *
 * Delete an order by ID.
 */
export const deleteOrderOrdersOrderIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteOrderOrdersOrderIdDeleteData, ThrowOnError>
): RequestResult<
  DeleteOrderOrdersOrderIdDeleteResponses,
  DeleteOrderOrdersOrderIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteOrderOrdersOrderIdDeleteResponses,
    DeleteOrderOrdersOrderIdDeleteErrors,
    ThrowOnError
  >({ url: '/orders/{order_id}', ...options });

/**
 * Get Order
 *
 * Get a single order by ID.
 */
export const getOrderOrdersOrderIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetOrderOrdersOrderIdGetData, ThrowOnError>
): RequestResult<
  GetOrderOrdersOrderIdGetResponses,
  GetOrderOrdersOrderIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetOrderOrdersOrderIdGetResponses,
    GetOrderOrdersOrderIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/orders/{order_id}',
    ...options,
  });

/**
 * Update Order
 *
 * Update order fields and/or the JSONB `order_data` payload.
 *
 * This is the single edit endpoint used by both the Order Manager (admin
 * actions: status, scheduling, sent_to_physician_date) and the order forms
 * (form saves: order_text/date/time/summary, order_data). Form saves are
 * distinguished by `order_data` being present in the request and get extra
 * handling: OCC against `order_data_last_updated`, merge into JSONB,
 * auto-advance NOT_STARTED -> SAVED.
 */
export const updateOrderOrdersOrderIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateOrderOrdersOrderIdPatchData, ThrowOnError>
): RequestResult<
  UpdateOrderOrdersOrderIdPatchResponses,
  UpdateOrderOrdersOrderIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateOrderOrdersOrderIdPatchResponses,
    UpdateOrderOrdersOrderIdPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/orders/{order_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Order Pdf
 *
 * Return the canonical print/download PDF for a single order.
 *
 * Resolves the right artifact by order type:
 *
 * * A locked signed CMS-485 returns its stored signed form (streamed from S3).
 * An editable or unsigned CMS-485 renders the live CMS-485 preview PDF.
 * * Every other order renders the generic sendable print view (allergies,
 * episode dates, diagnosis, physician, orders, and signature rows).
 *
 * This is the single entry point both the episode-manager task table and the
 * order detail panel call, so the same gesture yields the same document
 * everywhere. Returns the PDF inline so the client can open it in a new tab.
 */
export const getOrderPdfOrdersOrderIdPdfGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetOrderPdfOrdersOrderIdPdfGetData, ThrowOnError>
): RequestResult<
  GetOrderPdfOrdersOrderIdPdfGetResponses,
  GetOrderPdfOrdersOrderIdPdfGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetOrderPdfOrdersOrderIdPdfGetResponses,
    GetOrderPdfOrdersOrderIdPdfGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/orders/{order_id}/pdf',
    ...options,
  });

/**
 * Get Order Work Log
 *
 * Return the order's work log: lifecycle events reconstructed from audit rows.
 *
 * Consecutive events of the same type by the same actor collapse into one
 * entry (see ``compact_work_log``), oldest first. The entries come from audit
 * rows, which are never soft-deleted, so a deleted order's log reads as it did
 * before, with the deletion as its last event.
 */
export const getOrderWorkLogOrdersOrderIdWorkLogGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetOrderWorkLogOrdersOrderIdWorkLogGetData, ThrowOnError>
): RequestResult<
  GetOrderWorkLogOrdersOrderIdWorkLogGetResponses,
  GetOrderWorkLogOrdersOrderIdWorkLogGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetOrderWorkLogOrdersOrderIdWorkLogGetResponses,
    GetOrderWorkLogOrdersOrderIdWorkLogGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/orders/{order_id}/work-log',
    ...options,
  });

/**
 * Get Order Pdf Revision
 *
 * Render the order's print view as it stood at a past point in time.
 *
 * Reconstructs the order from the ``zz_`` history (see ``task_revision``) and
 * prints it with the signatures and bypass in force at ``as_of``. A CMS-485
 * always renders from its reconstructed form data, never from a stored signed
 * file: a form signed, reopened and signed again keeps a file per signing, and
 * none of them is reliably the one in force at an arbitrary moment.
 *
 * Left off a revision, because they are not part of the order's own record
 * and cannot be read as they stood then:
 *
 * * Diagnoses and allergies. A generic order resolves them from the episode's
 * worksheet, its OASIS visits and the patient's allergy list, none of which
 * the order's history holds. A CMS-485 prints only the medications,
 * allergies, diagnoses and goals saved in its form data, never today's.
 * * Goal sections, which read live goal rows. The visit revision leaves goals
 * out for the same reason.
 *
 * Patient, agency, clinic and episode details are read as they stand today,
 * as the visit revision reads them. An order with no history at or before
 * ``as_of`` (it predates audit coverage) is reported as unavailable with a 422
 * rather than rendered from present-day values.
 */
export const getOrderPdfRevisionOrdersOrderIdPdfRevisionGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetOrderPdfRevisionOrdersOrderIdPdfRevisionGetData,
    ThrowOnError
  >
): RequestResult<
  GetOrderPdfRevisionOrdersOrderIdPdfRevisionGetResponses,
  GetOrderPdfRevisionOrdersOrderIdPdfRevisionGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetOrderPdfRevisionOrdersOrderIdPdfRevisionGetResponses,
    GetOrderPdfRevisionOrdersOrderIdPdfRevisionGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/orders/{order_id}/pdf-revision',
    ...options,
  });

/**
 * Create Order
 *
 * Create a new order.
 *
 * Provide either ``episode_id`` or ``patient_id`` in the request body.
 * When ``patient_id`` is given the order is attached to the patient's most
 * recent episode.
 */
export const createOrderOrdersPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateOrderOrdersPostData, ThrowOnError>
): RequestResult<
  CreateOrderOrdersPostResponses,
  CreateOrderOrdersPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateOrderOrdersPostResponses,
    CreateOrderOrdersPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/orders/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Send Order Fax
 *
 * Fax one completed order to its physician, and record the attempt.
 *
 * The order moves to Pending Physician Signature only when RingCentral has
 * actually accepted the fax. A refusal leaves it in To Be Sent with a reason,
 * which is the honest answer to a physician with no fax number on file.
 */
export const sendOrderFaxOrdersOrderIdFaxPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SendOrderFaxOrdersOrderIdFaxPostData, ThrowOnError>
): RequestResult<
  SendOrderFaxOrdersOrderIdFaxPostResponses,
  SendOrderFaxOrdersOrderIdFaxPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SendOrderFaxOrdersOrderIdFaxPostResponses,
    SendOrderFaxOrdersOrderIdFaxPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/orders/{order_id}/fax',
    ...options,
  });

/**
 * Decide Order Fax Signature
 *
 * Say whether the returned page is actually signed, and move the order.
 *
 * This is the only thing that moves an order on the strength of a returned
 * fax. The match that filed the page knows which order it belongs to and
 * nothing about whether anybody signed it.
 */
export const decideOrderFaxSignatureOrdersOrderIdFaxSignaturePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DecideOrderFaxSignatureOrdersOrderIdFaxSignaturePostData,
    ThrowOnError
  >
): RequestResult<
  DecideOrderFaxSignatureOrdersOrderIdFaxSignaturePostResponses,
  DecideOrderFaxSignatureOrdersOrderIdFaxSignaturePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DecideOrderFaxSignatureOrdersOrderIdFaxSignaturePostResponses,
    DecideOrderFaxSignatureOrdersOrderIdFaxSignaturePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/orders/{order_id}/fax-signature',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Returned Fax
 *
 * How many pages the returned fax has.
 */
export const getReturnedFaxOrdersOrderIdReturnedFaxGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetReturnedFaxOrdersOrderIdReturnedFaxGetData, ThrowOnError>
): RequestResult<
  GetReturnedFaxOrdersOrderIdReturnedFaxGetResponses,
  GetReturnedFaxOrdersOrderIdReturnedFaxGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetReturnedFaxOrdersOrderIdReturnedFaxGetResponses,
    GetReturnedFaxOrdersOrderIdReturnedFaxGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/orders/{order_id}/returned-fax',
    ...options,
  });

/**
 * Get Returned Fax Page
 *
 * One page of the returned fax, as an image.
 *
 * An image rather than the file itself. The page came from a sender nobody
 * vetted, the fax inbox serves these only as downloads so that whatever
 * arrived cannot run in a reader's browser, and an inline copy here would
 * undo that. A picture of the page cannot execute anything, and looking at
 * it is the whole purpose.
 */
export const getReturnedFaxPageOrdersOrderIdReturnedFaxPagesIndexGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetReturnedFaxPageOrdersOrderIdReturnedFaxPagesIndexGetData,
    ThrowOnError
  >
): RequestResult<
  GetReturnedFaxPageOrdersOrderIdReturnedFaxPagesIndexGetResponses,
  GetReturnedFaxPageOrdersOrderIdReturnedFaxPagesIndexGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetReturnedFaxPageOrdersOrderIdReturnedFaxPagesIndexGetResponses,
    GetReturnedFaxPageOrdersOrderIdReturnedFaxPagesIndexGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/orders/{order_id}/returned-fax/pages/{index}',
    ...options,
  });

/**
 * Get My Tasks
 *
 * Get the current user's Hotbox work queue (visits and orders).
 */
export const getMyTasksTasksMyTasksGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetMyTasksTasksMyTasksGetData, ThrowOnError>
): RequestResult<
  GetMyTasksTasksMyTasksGetResponses,
  GetMyTasksTasksMyTasksGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetMyTasksTasksMyTasksGetResponses,
    GetMyTasksTasksMyTasksGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/tasks/my-tasks',
    ...options,
  });

/**
 * Get My Tasks Type Options
 *
 * Distinct Type-column values in the user's Hotbox queue, for the Type filter.
 *
 * Deliberately takes no status or EVV filter: the menu describes the queue,
 * not the current narrowing, so a type the user picked on purpose is never
 * pruned away by a status that happens to have no rows of that type.
 */
export const getMyTasksTypeOptionsTasksMyTasksTypeOptionsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetMyTasksTypeOptionsTasksMyTasksTypeOptionsGetData,
    ThrowOnError
  >
): RequestResult<
  GetMyTasksTypeOptionsTasksMyTasksTypeOptionsGetResponses,
  GetMyTasksTypeOptionsTasksMyTasksTypeOptionsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetMyTasksTypeOptionsTasksMyTasksTypeOptionsGetResponses,
    GetMyTasksTypeOptionsTasksMyTasksTypeOptionsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/tasks/my-tasks/type-options',
    ...options,
  });

/**
 * Get My Tasks Pdx Options
 *
 * Distinct primary-diagnosis codes in the user's Hotbox queue, for the PDX filter.
 *
 * Takes the same parameters as the Type menu, and for the same reason: it
 * describes the queue, not the current narrowing. The PDX filter itself is
 * out — a filter that hid its own options would collapse to whatever was
 * already picked — and so are status, EVV, the Type filter and the name
 * search.
 */
export const getMyTasksPdxOptionsTasksMyTasksPdxOptionsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetMyTasksPdxOptionsTasksMyTasksPdxOptionsGetData,
    ThrowOnError
  >
): RequestResult<
  GetMyTasksPdxOptionsTasksMyTasksPdxOptionsGetResponses,
  GetMyTasksPdxOptionsTasksMyTasksPdxOptionsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetMyTasksPdxOptionsTasksMyTasksPdxOptionsGetResponses,
    GetMyTasksPdxOptionsTasksMyTasksPdxOptionsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/tasks/my-tasks/pdx-options',
    ...options,
  });

/**
 * Export Qa All Tasks
 *
 * Download the complete, filtered QA All Tasks queue as an Excel workbook.
 */
export const exportQaAllTasksTasksMyTasksExportGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ExportQaAllTasksTasksMyTasksExportGetData, ThrowOnError>
): RequestResult<
  ExportQaAllTasksTasksMyTasksExportGetResponses,
  ExportQaAllTasksTasksMyTasksExportGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ExportQaAllTasksTasksMyTasksExportGetResponses,
    ExportQaAllTasksTasksMyTasksExportGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/tasks/my-tasks/export',
    ...options,
  });

/**
 * Get Task Documents
 *
 * List all documents attached to a task.
 */
export const getTaskDocumentsTasksTaskIdDocumentsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetTaskDocumentsTasksTaskIdDocumentsGetData, ThrowOnError>
): RequestResult<
  GetTaskDocumentsTasksTaskIdDocumentsGetResponses,
  GetTaskDocumentsTasksTaskIdDocumentsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetTaskDocumentsTasksTaskIdDocumentsGetResponses,
    GetTaskDocumentsTasksTaskIdDocumentsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/tasks/{task_id}/documents',
    ...options,
  });

/**
 * Upload Task Document
 *
 * Upload a document and attach it to a task.
 */
export const uploadTaskDocumentTasksTaskIdDocumentsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UploadTaskDocumentTasksTaskIdDocumentsPostData, ThrowOnError>
): RequestResult<
  UploadTaskDocumentTasksTaskIdDocumentsPostResponses,
  UploadTaskDocumentTasksTaskIdDocumentsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UploadTaskDocumentTasksTaskIdDocumentsPostResponses,
    UploadTaskDocumentTasksTaskIdDocumentsPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/tasks/{task_id}/documents',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Get Task Document Url
 *
 * Get a presigned URL to view/download a task document.
 */
export const getTaskDocumentUrlTasksTaskIdDocumentsDocumentIdUrlGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetTaskDocumentUrlTasksTaskIdDocumentsDocumentIdUrlGetData,
    ThrowOnError
  >
): RequestResult<
  GetTaskDocumentUrlTasksTaskIdDocumentsDocumentIdUrlGetResponses,
  GetTaskDocumentUrlTasksTaskIdDocumentsDocumentIdUrlGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetTaskDocumentUrlTasksTaskIdDocumentsDocumentIdUrlGetResponses,
    GetTaskDocumentUrlTasksTaskIdDocumentsDocumentIdUrlGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/tasks/{task_id}/documents/{document_id}/url',
    ...options,
  });

/**
 * Delete Task Document
 *
 * Soft-delete a document attached to a task.
 */
export const deleteTaskDocumentTasksTaskIdDocumentsDocumentIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteTaskDocumentTasksTaskIdDocumentsDocumentIdDeleteData,
    ThrowOnError
  >
): RequestResult<
  DeleteTaskDocumentTasksTaskIdDocumentsDocumentIdDeleteResponses,
  DeleteTaskDocumentTasksTaskIdDocumentsDocumentIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteTaskDocumentTasksTaskIdDocumentsDocumentIdDeleteResponses,
    DeleteTaskDocumentTasksTaskIdDocumentsDocumentIdDeleteErrors,
    ThrowOnError
  >({ url: '/tasks/{task_id}/documents/{document_id}', ...options });

/**
 * Restore Task Endpoint
 *
 * Restore a soft-deleted task (visit, order, misc task or communication).
 *
 * One route for all four subtypes, matching the deleted-tasks list it is
 * reached from: the rules differ per subtype but the request does not.
 *
 * Gated on authentication and agency scope only, the same as creating the task
 * would be. A deleted task is gated however it would be gated were it not
 * deleted, and none of the four creation paths carries a permission
 * dependency.
 *
 * Refusals come back as 409 with a message naming the reason (see
 * ``app.services.task_restore``); a task that is not deleted, not in this
 * agency, or not there at all is a 404.
 */
export const restoreTaskEndpointTasksTaskIdRestorePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RestoreTaskEndpointTasksTaskIdRestorePostData, ThrowOnError>
): RequestResult<
  RestoreTaskEndpointTasksTaskIdRestorePostResponses,
  RestoreTaskEndpointTasksTaskIdRestorePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RestoreTaskEndpointTasksTaskIdRestorePostResponses,
    RestoreTaskEndpointTasksTaskIdRestorePostErrors,
    ThrowOnError
  >({ url: '/tasks/{task_id}/restore', ...options });

/**
 * Get Task Signatures
 *
 * Get all signatures for a task (visit or order).
 *
 * ``include_deleted`` only widens the existence check. Signatures are not
 * soft-deleted, so deleting a task leaves its history intact and the rows read
 * the same either way.
 */
export const getTaskSignaturesTasksTaskIdSignaturesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetTaskSignaturesTasksTaskIdSignaturesGetData, ThrowOnError>
): RequestResult<
  GetTaskSignaturesTasksTaskIdSignaturesGetResponses,
  GetTaskSignaturesTasksTaskIdSignaturesGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetTaskSignaturesTasksTaskIdSignaturesGetResponses,
    GetTaskSignaturesTasksTaskIdSignaturesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/tasks/{task_id}/signatures',
    ...options,
  });

/**
 * Sign Task Endpoint
 *
 * Sign a task (visit or order) and advance its status.
 */
export const signTaskEndpointTasksTaskIdSignPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SignTaskEndpointTasksTaskIdSignPostData, ThrowOnError>
): RequestResult<
  SignTaskEndpointTasksTaskIdSignPostResponses,
  SignTaskEndpointTasksTaskIdSignPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SignTaskEndpointTasksTaskIdSignPostResponses,
    SignTaskEndpointTasksTaskIdSignPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/tasks/{task_id}/sign',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Approve Task Endpoint
 *
 * QA-approve a task (submitted_with_signature → completed).
 */
export const approveTaskEndpointTasksTaskIdApprovePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ApproveTaskEndpointTasksTaskIdApprovePostData, ThrowOnError>
): RequestResult<
  ApproveTaskEndpointTasksTaskIdApprovePostResponses,
  ApproveTaskEndpointTasksTaskIdApprovePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ApproveTaskEndpointTasksTaskIdApprovePostResponses,
    ApproveTaskEndpointTasksTaskIdApprovePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/tasks/{task_id}/approve',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Approve Task For Signature Endpoint
 *
 * QA-approve a task and hand it back for the clinician's signature.
 *
 * ``submitted_with_signature`` -> ``pending_clinician_signature``.
 */
export const approveTaskForSignatureEndpointTasksTaskIdApproveForSignaturePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ApproveTaskForSignatureEndpointTasksTaskIdApproveForSignaturePostData,
      ThrowOnError
    >
  ): RequestResult<
    ApproveTaskForSignatureEndpointTasksTaskIdApproveForSignaturePostResponses,
    ApproveTaskForSignatureEndpointTasksTaskIdApproveForSignaturePostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      ApproveTaskForSignatureEndpointTasksTaskIdApproveForSignaturePostResponses,
      ApproveTaskForSignatureEndpointTasksTaskIdApproveForSignaturePostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/tasks/{task_id}/approve-for-signature',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Get Signature Bypass Options
 *
 * Reason options for the bypass dialog, in display order.
 *
 * Served from ``SIGNATURE_BYPASS_REASON_LABELS`` so the picker, the reporting
 * dataset, and any print view render the same strings.
 */
export const getSignatureBypassOptionsTasksSignatureBypassOptionsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetSignatureBypassOptionsTasksSignatureBypassOptionsGetData,
    ThrowOnError
  >
): RequestResult<
  GetSignatureBypassOptionsTasksSignatureBypassOptionsGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetSignatureBypassOptionsTasksSignatureBypassOptionsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/tasks/signature-bypass-options',
    ...options,
  });

/**
 * Bypass Task Signature Endpoint
 *
 * Complete a task whose clinician cannot sign it.
 *
 * Gated exactly like signing — the e-signature password is required — even
 * though the actor is not signing. The password is what ties the recorded
 * forfeiture to a specific person.
 */
export const bypassTaskSignatureEndpointTasksTaskIdBypassSignaturePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    BypassTaskSignatureEndpointTasksTaskIdBypassSignaturePostData,
    ThrowOnError
  >
): RequestResult<
  BypassTaskSignatureEndpointTasksTaskIdBypassSignaturePostResponses,
  BypassTaskSignatureEndpointTasksTaskIdBypassSignaturePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    BypassTaskSignatureEndpointTasksTaskIdBypassSignaturePostResponses,
    BypassTaskSignatureEndpointTasksTaskIdBypassSignaturePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/tasks/{task_id}/bypass-signature',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Complete Task Outside Record Endpoint
 *
 * Complete a Not Started visit performed and documented outside Roger.
 *
 * No note, signature or password: the click is the signature, as the
 * attestation says. The outside document is attached afterwards.
 */
export const completeTaskOutsideRecordEndpointTasksTaskIdCompleteOutsideRecordPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      CompleteTaskOutsideRecordEndpointTasksTaskIdCompleteOutsideRecordPostData,
      ThrowOnError
    >
  ): RequestResult<
    CompleteTaskOutsideRecordEndpointTasksTaskIdCompleteOutsideRecordPostResponses,
    CompleteTaskOutsideRecordEndpointTasksTaskIdCompleteOutsideRecordPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      CompleteTaskOutsideRecordEndpointTasksTaskIdCompleteOutsideRecordPostResponses,
      CompleteTaskOutsideRecordEndpointTasksTaskIdCompleteOutsideRecordPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/tasks/{task_id}/complete-outside-record',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Get Task Outside Record Endpoint
 *
 * The Outside record dialog: needs only ``tasks:edit-outside-record``.
 */
export const getTaskOutsideRecordEndpointTasksTaskIdOutsideRecordGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetTaskOutsideRecordEndpointTasksTaskIdOutsideRecordGetData,
    ThrowOnError
  >
): RequestResult<
  GetTaskOutsideRecordEndpointTasksTaskIdOutsideRecordGetResponses,
  GetTaskOutsideRecordEndpointTasksTaskIdOutsideRecordGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetTaskOutsideRecordEndpointTasksTaskIdOutsideRecordGetResponses,
    GetTaskOutsideRecordEndpointTasksTaskIdOutsideRecordGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/tasks/{task_id}/outside-record',
    ...options,
  });

/**
 * Update Task Outside Record Endpoint
 *
 * Change the date, times and end-of-care fields of an outside-record visit.
 *
 * Allowed after completion; the status does not change.
 */
export const updateTaskOutsideRecordEndpointTasksTaskIdOutsideRecordPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateTaskOutsideRecordEndpointTasksTaskIdOutsideRecordPatchData,
    ThrowOnError
  >
): RequestResult<
  UpdateTaskOutsideRecordEndpointTasksTaskIdOutsideRecordPatchResponses,
  UpdateTaskOutsideRecordEndpointTasksTaskIdOutsideRecordPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateTaskOutsideRecordEndpointTasksTaskIdOutsideRecordPatchResponses,
    UpdateTaskOutsideRecordEndpointTasksTaskIdOutsideRecordPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/tasks/{task_id}/outside-record',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Upload Task Outside Record Document Endpoint
 *
 * Attach the outside document to a visit completed with an outside record.
 */
export const uploadTaskOutsideRecordDocumentEndpointTasksTaskIdOutsideRecordDocumentsPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UploadTaskOutsideRecordDocumentEndpointTasksTaskIdOutsideRecordDocumentsPostData,
      ThrowOnError
    >
  ): RequestResult<
    UploadTaskOutsideRecordDocumentEndpointTasksTaskIdOutsideRecordDocumentsPostResponses,
    UploadTaskOutsideRecordDocumentEndpointTasksTaskIdOutsideRecordDocumentsPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      UploadTaskOutsideRecordDocumentEndpointTasksTaskIdOutsideRecordDocumentsPostResponses,
      UploadTaskOutsideRecordDocumentEndpointTasksTaskIdOutsideRecordDocumentsPostErrors,
      ThrowOnError
    >({
      ...formDataBodySerializer,
      responseType: 'json',
      url: '/tasks/{task_id}/outside-record/documents',
      ...options,
      headers: {
        'Content-Type': null,
        ...options.headers,
      },
    });

/**
 * Delete Task Outside Record Document Endpoint
 *
 * Remove a document from a visit completed with an outside record.
 */
export const deleteTaskOutsideRecordDocumentEndpointTasksTaskIdOutsideRecordDocumentsDocumentIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteTaskOutsideRecordDocumentEndpointTasksTaskIdOutsideRecordDocumentsDocumentIdDeleteData,
      ThrowOnError
    >
  ): RequestResult<
    DeleteTaskOutsideRecordDocumentEndpointTasksTaskIdOutsideRecordDocumentsDocumentIdDeleteResponses,
    DeleteTaskOutsideRecordDocumentEndpointTasksTaskIdOutsideRecordDocumentsDocumentIdDeleteErrors,
    ThrowOnError
  > =>
    (options.client ?? client).delete<
      DeleteTaskOutsideRecordDocumentEndpointTasksTaskIdOutsideRecordDocumentsDocumentIdDeleteResponses,
      DeleteTaskOutsideRecordDocumentEndpointTasksTaskIdOutsideRecordDocumentsDocumentIdDeleteErrors,
      ThrowOnError
    >({
      url: '/tasks/{task_id}/outside-record/documents/{document_id}',
      ...options,
    });

/**
 * List Task Signature Bypasses
 *
 * Every bypass recorded against a task, newest first.
 */
export const listTaskSignatureBypassesTasksTaskIdSignatureBypassesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListTaskSignatureBypassesTasksTaskIdSignatureBypassesGetData,
    ThrowOnError
  >
): RequestResult<
  ListTaskSignatureBypassesTasksTaskIdSignatureBypassesGetResponses,
  ListTaskSignatureBypassesTasksTaskIdSignatureBypassesGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListTaskSignatureBypassesTasksTaskIdSignatureBypassesGetResponses,
    ListTaskSignatureBypassesTasksTaskIdSignatureBypassesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/tasks/{task_id}/signature-bypasses',
    ...options,
  });

/**
 * Verify Task Signature Bypass Endpoint
 *
 * Verify a signature bypass's integrity.
 *
 * Counterpart of the task-signature verify route. A bypass is signed with the
 * same keyring over the same canonical snapshot, so it answers the same
 * questions — with one caveat worth reading in the response: a superseded
 * bypass is expected to report snapshot_drift, because superseding and the
 * status change that causes it are the same act.
 */
export const verifyTaskSignatureBypassEndpointTasksTaskIdSignatureBypassesBypassIdVerifyGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      VerifyTaskSignatureBypassEndpointTasksTaskIdSignatureBypassesBypassIdVerifyGetData,
      ThrowOnError
    >
  ): RequestResult<
    VerifyTaskSignatureBypassEndpointTasksTaskIdSignatureBypassesBypassIdVerifyGetResponses,
    VerifyTaskSignatureBypassEndpointTasksTaskIdSignatureBypassesBypassIdVerifyGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      VerifyTaskSignatureBypassEndpointTasksTaskIdSignatureBypassesBypassIdVerifyGetResponses,
      VerifyTaskSignatureBypassEndpointTasksTaskIdSignatureBypassesBypassIdVerifyGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/tasks/{task_id}/signature-bypasses/{bypass_id}/verify',
      ...options,
    });

/**
 * Submit Task Without Signature Endpoint
 *
 * Advance a draft to SUBMITTED without signing it.
 *
 * No e-signature password: nothing is being attested to. The signature is
 * still owed and the clinician will supply it later.
 */
export const submitTaskWithoutSignatureEndpointTasksTaskIdSubmitWithoutSignaturePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      SubmitTaskWithoutSignatureEndpointTasksTaskIdSubmitWithoutSignaturePostData,
      ThrowOnError
    >
  ): RequestResult<
    SubmitTaskWithoutSignatureEndpointTasksTaskIdSubmitWithoutSignaturePostResponses,
    SubmitTaskWithoutSignatureEndpointTasksTaskIdSubmitWithoutSignaturePostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      SubmitTaskWithoutSignatureEndpointTasksTaskIdSubmitWithoutSignaturePostResponses,
      SubmitTaskWithoutSignatureEndpointTasksTaskIdSubmitWithoutSignaturePostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/tasks/{task_id}/submit-without-signature',
      ...options,
    });

/**
 * Return Task To Clinician Endpoint
 *
 * Send a chart back to the clinician without QA-approving it.
 */
export const returnTaskToClinicianEndpointTasksTaskIdReturnToClinicianPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ReturnTaskToClinicianEndpointTasksTaskIdReturnToClinicianPostData,
    ThrowOnError
  >
): RequestResult<
  ReturnTaskToClinicianEndpointTasksTaskIdReturnToClinicianPostResponses,
  ReturnTaskToClinicianEndpointTasksTaskIdReturnToClinicianPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ReturnTaskToClinicianEndpointTasksTaskIdReturnToClinicianPostResponses,
    ReturnTaskToClinicianEndpointTasksTaskIdReturnToClinicianPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/tasks/{task_id}/return-to-clinician',
    ...options,
  });

/**
 * Verify Task Signature Endpoint
 *
 * Verify a task signature's integrity.
 *
 * Recomputes the MAC from the stored snapshot under the stored key and
 * rebuilds the snapshot from live DB state to flag drift.
 */
export const verifyTaskSignatureEndpointTasksTaskIdSignaturesSignatureIdVerifyGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      VerifyTaskSignatureEndpointTasksTaskIdSignaturesSignatureIdVerifyGetData,
      ThrowOnError
    >
  ): RequestResult<
    VerifyTaskSignatureEndpointTasksTaskIdSignaturesSignatureIdVerifyGetResponses,
    VerifyTaskSignatureEndpointTasksTaskIdSignaturesSignatureIdVerifyGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      VerifyTaskSignatureEndpointTasksTaskIdSignaturesSignatureIdVerifyGetResponses,
      VerifyTaskSignatureEndpointTasksTaskIdSignaturesSignatureIdVerifyGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/tasks/{task_id}/signatures/{signature_id}/verify',
      ...options,
    });

/**
 * Break Signatures Endpoint
 *
 * Break all signatures on a task to allow editing.
 */
export const breakSignaturesEndpointTasksTaskIdEditPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<BreakSignaturesEndpointTasksTaskIdEditPostData, ThrowOnError>
): RequestResult<
  BreakSignaturesEndpointTasksTaskIdEditPostResponses,
  BreakSignaturesEndpointTasksTaskIdEditPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    BreakSignaturesEndpointTasksTaskIdEditPostResponses,
    BreakSignaturesEndpointTasksTaskIdEditPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/tasks/{task_id}/edit',
    ...options,
  });

/**
 * Update Task Notes
 *
 * Update the notes (sticky note) for any task (visit or order).
 *
 * Any authenticated agency user who can access the task may update notes —
 * not only the assigned clinician or case manager. Sticky notes are shared
 * chart coordination comments visible to everyone handling the chart.
 */
export const updateTaskNotesTasksTaskIdNotesPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateTaskNotesTasksTaskIdNotesPutData, ThrowOnError>
): RequestResult<
  UpdateTaskNotesTasksTaskIdNotesPutResponses,
  UpdateTaskNotesTasksTaskIdNotesPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateTaskNotesTasksTaskIdNotesPutResponses,
    UpdateTaskNotesTasksTaskIdNotesPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/tasks/{task_id}/notes',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Reschedule Task
 *
 * Move a Hotbox task to another day in the same calendar week.
 *
 * Deliberately its own route rather than a permission on ``PUT /visits/{id}``:
 * that route is the Episode Manager's reschedule path and gating it on
 * ``hotbox:reschedule`` would revoke rescheduling from everyone who edits dates
 * from the patient chart.
 *
 * The rules live in ``app.services.task_reschedule`` so another surface can
 * move a task without copying them. A Start of Care or Discharge visit moves
 * like any other task: only the visit moves, never the episode. Moving the
 * episode with it stays an Episode Manager action.
 */
export const rescheduleTaskTasksTaskIdReschedulePatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RescheduleTaskTasksTaskIdReschedulePatchData, ThrowOnError>
): RequestResult<
  RescheduleTaskTasksTaskIdReschedulePatchResponses,
  RescheduleTaskTasksTaskIdReschedulePatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    RescheduleTaskTasksTaskIdReschedulePatchResponses,
    RescheduleTaskTasksTaskIdReschedulePatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/tasks/{task_id}/reschedule',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Bulk Append Task Notes
 *
 * Append a notes entry to multiple tasks (orders/visits).
 *
 * Each entry is prefixed with ``[YYYY-MM-DD user@email]`` and appended on a
 * new line. Any authenticated agency user who can access the tasks may use
 * this endpoint (same policy as ``update_task_notes``). The update is
 * transactional: if any task is not found, no notes are written and the
 * request fails. Notes are metadata and do not advance task status, whether
 * applied to one task or to a batch.
 */
export const bulkAppendTaskNotesTasksNotesBulkPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<BulkAppendTaskNotesTasksNotesBulkPostData, ThrowOnError>
): RequestResult<
  BulkAppendTaskNotesTasksNotesBulkPostResponses,
  BulkAppendTaskNotesTasksNotesBulkPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    BulkAppendTaskNotesTasksNotesBulkPostResponses,
    BulkAppendTaskNotesTasksNotesBulkPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/tasks/notes/bulk',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Task Details
 *
 * Read a task's details: its sticky note and its attachments.
 */
export const getTaskDetailsTasksTaskIdDetailsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetTaskDetailsTasksTaskIdDetailsGetData, ThrowOnError>
): RequestResult<
  GetTaskDetailsTasksTaskIdDetailsGetResponses,
  GetTaskDetailsTasksTaskIdDetailsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetTaskDetailsTasksTaskIdDetailsGetResponses,
    GetTaskDetailsTasksTaskIdDetailsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/tasks/{task_id}/details',
    ...options,
  });

/**
 * Update Task Details Notes
 *
 * Replace a task's sticky note from Task Details.
 */
export const updateTaskDetailsNotesTasksTaskIdDetailsNotesPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateTaskDetailsNotesTasksTaskIdDetailsNotesPutData,
    ThrowOnError
  >
): RequestResult<
  UpdateTaskDetailsNotesTasksTaskIdDetailsNotesPutResponses,
  UpdateTaskDetailsNotesTasksTaskIdDetailsNotesPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateTaskDetailsNotesTasksTaskIdDetailsNotesPutResponses,
    UpdateTaskDetailsNotesTasksTaskIdDetailsNotesPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/tasks/{task_id}/details/notes',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Task Details Visit Fields
 *
 * Change a visit's site of service, HCPCS override or mileage.
 *
 * Open whatever the visit's status: these are what billing and payroll keep
 * correcting after the clinician signs. Only the fields sent are applied.
 */
export const updateTaskDetailsVisitFieldsTasksTaskIdDetailsVisitFieldsPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateTaskDetailsVisitFieldsTasksTaskIdDetailsVisitFieldsPutData,
    ThrowOnError
  >
): RequestResult<
  UpdateTaskDetailsVisitFieldsTasksTaskIdDetailsVisitFieldsPutResponses,
  UpdateTaskDetailsVisitFieldsTasksTaskIdDetailsVisitFieldsPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateTaskDetailsVisitFieldsTasksTaskIdDetailsVisitFieldsPutResponses,
    UpdateTaskDetailsVisitFieldsTasksTaskIdDetailsVisitFieldsPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/tasks/{task_id}/details/visit-fields',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Upload Task Details Document
 *
 * Upload a document and attach it to a task from Task Details.
 */
export const uploadTaskDetailsDocumentTasksTaskIdDetailsDocumentsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UploadTaskDetailsDocumentTasksTaskIdDetailsDocumentsPostData,
    ThrowOnError
  >
): RequestResult<
  UploadTaskDetailsDocumentTasksTaskIdDetailsDocumentsPostResponses,
  UploadTaskDetailsDocumentTasksTaskIdDetailsDocumentsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UploadTaskDetailsDocumentTasksTaskIdDetailsDocumentsPostResponses,
    UploadTaskDetailsDocumentTasksTaskIdDetailsDocumentsPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/tasks/{task_id}/details/documents',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Delete Task Details Document
 *
 * Soft-delete a document attached to a task from Task Details.
 */
export const deleteTaskDetailsDocumentTasksTaskIdDetailsDocumentsDocumentIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteTaskDetailsDocumentTasksTaskIdDetailsDocumentsDocumentIdDeleteData,
      ThrowOnError
    >
  ): RequestResult<
    DeleteTaskDetailsDocumentTasksTaskIdDetailsDocumentsDocumentIdDeleteResponses,
    DeleteTaskDetailsDocumentTasksTaskIdDetailsDocumentsDocumentIdDeleteErrors,
    ThrowOnError
  > =>
    (options.client ?? client).delete<
      DeleteTaskDetailsDocumentTasksTaskIdDetailsDocumentsDocumentIdDeleteResponses,
      DeleteTaskDetailsDocumentTasksTaskIdDetailsDocumentsDocumentIdDeleteErrors,
      ThrowOnError
    >({ url: '/tasks/{task_id}/details/documents/{document_id}', ...options });

/**
 * Get Print View For Goals
 *
 * Get a formatted plain text summary of goals and progress for a visit.
 */
export const getPrintViewForGoalsGoalsVisitPrintViewVisitIdPrintViewGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPrintViewForGoalsGoalsVisitPrintViewVisitIdPrintViewGetData,
    ThrowOnError
  >
): RequestResult<
  GetPrintViewForGoalsGoalsVisitPrintViewVisitIdPrintViewGetResponses,
  GetPrintViewForGoalsGoalsVisitPrintViewVisitIdPrintViewGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetPrintViewForGoalsGoalsVisitPrintViewVisitIdPrintViewGetResponses,
    GetPrintViewForGoalsGoalsVisitPrintViewVisitIdPrintViewGetErrors,
    ThrowOnError
  >({
    responseType: 'text',
    url: '/goals/visit/print_view/{visit_id}/print_view',
    ...options,
  });

/**
 * Mark Patient Goal Met
 *
 * Mark a patient goal as met for this task. Creates or updates goal progress.
 */
export const markPatientGoalMetGoalsVisitProgressVisitIdProgressPatientGoalIdMarkMetPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      MarkPatientGoalMetGoalsVisitProgressVisitIdProgressPatientGoalIdMarkMetPostData,
      ThrowOnError
    >
  ): RequestResult<
    MarkPatientGoalMetGoalsVisitProgressVisitIdProgressPatientGoalIdMarkMetPostResponses,
    MarkPatientGoalMetGoalsVisitProgressVisitIdProgressPatientGoalIdMarkMetPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      MarkPatientGoalMetGoalsVisitProgressVisitIdProgressPatientGoalIdMarkMetPostResponses,
      MarkPatientGoalMetGoalsVisitProgressVisitIdProgressPatientGoalIdMarkMetPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/goals/visit/progress/{visit_id}/progress/{patient_goal_id}/mark_met',
      ...options,
    });

/**
 * Mark Patient Goal Unattainable
 *
 * Mark a patient goal as unattainable for this task. Creates or updates goal progress.
 */
export const markPatientGoalUnattainableGoalsVisitProgressVisitIdProgressPatientGoalIdMarkUnattainablePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      MarkPatientGoalUnattainableGoalsVisitProgressVisitIdProgressPatientGoalIdMarkUnattainablePostData,
      ThrowOnError
    >
  ): RequestResult<
    MarkPatientGoalUnattainableGoalsVisitProgressVisitIdProgressPatientGoalIdMarkUnattainablePostResponses,
    MarkPatientGoalUnattainableGoalsVisitProgressVisitIdProgressPatientGoalIdMarkUnattainablePostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      MarkPatientGoalUnattainableGoalsVisitProgressVisitIdProgressPatientGoalIdMarkUnattainablePostResponses,
      MarkPatientGoalUnattainableGoalsVisitProgressVisitIdProgressPatientGoalIdMarkUnattainablePostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/goals/visit/progress/{visit_id}/progress/{patient_goal_id}/mark_unattainable',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Record Goal Progress
 *
 * Record progress on a patient goal for this task. Creates or updates goal progress.
 */
export const recordGoalProgressGoalsVisitProgressVisitIdProgressPatientGoalIdRecordProgressPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      RecordGoalProgressGoalsVisitProgressVisitIdProgressPatientGoalIdRecordProgressPostData,
      ThrowOnError
    >
  ): RequestResult<
    RecordGoalProgressGoalsVisitProgressVisitIdProgressPatientGoalIdRecordProgressPostResponses,
    RecordGoalProgressGoalsVisitProgressVisitIdProgressPatientGoalIdRecordProgressPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      RecordGoalProgressGoalsVisitProgressVisitIdProgressPatientGoalIdRecordProgressPostResponses,
      RecordGoalProgressGoalsVisitProgressVisitIdProgressPatientGoalIdRecordProgressPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/goals/visit/progress/{visit_id}/progress/{patient_goal_id}/record_progress',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Perform Intervention For Visit
 *
 * Record performance of an intervention for this task. Creates or updates intervention progress.
 */
export const performInterventionForVisitGoalsVisitProgressVisitIdProgressPatientInterventionIdPerformPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      PerformInterventionForVisitGoalsVisitProgressVisitIdProgressPatientInterventionIdPerformPostData,
      ThrowOnError
    >
  ): RequestResult<
    PerformInterventionForVisitGoalsVisitProgressVisitIdProgressPatientInterventionIdPerformPostResponses,
    PerformInterventionForVisitGoalsVisitProgressVisitIdProgressPatientInterventionIdPerformPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      PerformInterventionForVisitGoalsVisitProgressVisitIdProgressPatientInterventionIdPerformPostResponses,
      PerformInterventionForVisitGoalsVisitProgressVisitIdProgressPatientInterventionIdPerformPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/goals/visit/progress/{visit_id}/progress/{patient_intervention_id}/perform',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Complete Intervention For Visit
 *
 * Mark the intervention progress for this task as complete.
 *
 * Same validation as perform except existing progress may already be
 * performed. An intervention must have been performed at least once (on
 * some visit) before it can be completed; an order cannot perform an
 * intervention, so completing from an order only ever succeeds for an
 * intervention already performed on a visit (goal business rule --
 * unchanged from the visit-only behavior, just reachable from an
 * allowlisted order too).
 */
export const completeInterventionForVisitGoalsVisitProgressVisitIdProgressPatientInterventionIdCompletePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      CompleteInterventionForVisitGoalsVisitProgressVisitIdProgressPatientInterventionIdCompletePostData,
      ThrowOnError
    >
  ): RequestResult<
    CompleteInterventionForVisitGoalsVisitProgressVisitIdProgressPatientInterventionIdCompletePostResponses,
    CompleteInterventionForVisitGoalsVisitProgressVisitIdProgressPatientInterventionIdCompletePostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      CompleteInterventionForVisitGoalsVisitProgressVisitIdProgressPatientInterventionIdCompletePostResponses,
      CompleteInterventionForVisitGoalsVisitProgressVisitIdProgressPatientInterventionIdCompletePostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/goals/visit/progress/{visit_id}/progress/{patient_intervention_id}/complete',
      ...options,
    });

/**
 * Extend Goal To Next Episode
 *
 * Push a patient goal (and its interventions) into the patient's next episode.
 *
 * Creates a copy in the next episode sharing the source's lineage keys and
 * marks the source goal extended, in one transaction. Requires the next
 * episode to already exist for the same admission (a product
 * decision: there is no episode-less copy). See
 * ``PatientGoalCRUD.extend_to_next_episode`` for the copy semantics and
 * ``EpisodeCRUD.get_next_episode`` for how the target episode is found.
 *
 * Callable from a visit that can track goal progress or from an
 * allowlisted order; the acting task -- visit or order -- is
 * passed through as ``extended_on_task_id`` either way.
 */
export const extendGoalToNextEpisodeGoalsVisitProgressVisitIdGoalPatientGoalIdExtendPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ExtendGoalToNextEpisodeGoalsVisitProgressVisitIdGoalPatientGoalIdExtendPostData,
      ThrowOnError
    >
  ): RequestResult<
    ExtendGoalToNextEpisodeGoalsVisitProgressVisitIdGoalPatientGoalIdExtendPostResponses,
    ExtendGoalToNextEpisodeGoalsVisitProgressVisitIdGoalPatientGoalIdExtendPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      ExtendGoalToNextEpisodeGoalsVisitProgressVisitIdGoalPatientGoalIdExtendPostResponses,
      ExtendGoalToNextEpisodeGoalsVisitProgressVisitIdGoalPatientGoalIdExtendPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/goals/visit/progress/{visit_id}/goal/{patient_goal_id}/extend',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Get Patient Goals For Visit
 *
 * Get all patient goals for the task's episode with progress history.
 *
 * Each goal and intervention progress row says whether the External EMR
 * manages its task, from one batch custody read over every row's task.
 */
export const getPatientGoalsForVisitGoalsVisitVisitIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPatientGoalsForVisitGoalsVisitVisitIdGetData,
    ThrowOnError
  >
): RequestResult<
  GetPatientGoalsForVisitGoalsVisitVisitIdGetResponses,
  GetPatientGoalsForVisitGoalsVisitVisitIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetPatientGoalsForVisitGoalsVisitVisitIdGetResponses,
    GetPatientGoalsForVisitGoalsVisitVisitIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/goals/visit/{visit_id}',
    ...options,
  });

/**
 * Add Goal To Visit
 *
 * Add a goal to a task by creating a patient goal for its episode.
 *
 * Supports a visit (per ``can_add_goals``) or an order whose type is on the
 * code-level goals allowlist; the task's episode ends up holding
 * the goal either way.
 */
export const addGoalToVisitGoalsVisitVisitIdPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AddGoalToVisitGoalsVisitVisitIdPostData, ThrowOnError>
): RequestResult<
  AddGoalToVisitGoalsVisitVisitIdPostResponses,
  AddGoalToVisitGoalsVisitVisitIdPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AddGoalToVisitGoalsVisitVisitIdPostResponses,
    AddGoalToVisitGoalsVisitVisitIdPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/goals/visit/{visit_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Patient Goal For Visit
 *
 * Get single patient goal with progress history.
 */
export const getPatientGoalForVisitGoalsVisitVisitIdGoalPatientGoalIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPatientGoalForVisitGoalsVisitVisitIdGoalPatientGoalIdGetData,
    ThrowOnError
  >
): RequestResult<
  GetPatientGoalForVisitGoalsVisitVisitIdGoalPatientGoalIdGetResponses,
  GetPatientGoalForVisitGoalsVisitVisitIdGoalPatientGoalIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetPatientGoalForVisitGoalsVisitVisitIdGoalPatientGoalIdGetResponses,
    GetPatientGoalForVisitGoalsVisitVisitIdGoalPatientGoalIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/goals/visit/{visit_id}/goal/{patient_goal_id}',
    ...options,
  });

/**
 * Get Goal Template
 *
 * Get a single goal template by id with its attached intervention templates.
 *
 * Only honored for templates the task could be offered (active, in the
 * patient's clinic, and matching the relevant discipline); anything else is
 * a plain 404, indistinguishable from a template that does not exist.
 *
 * An order task has no discipline of its own the way a visit does, so
 * ``discipline`` is REQUIRED for an order (400 if missing) and the
 * clinic+discipline-scoped set is used -- there is never an all-disciplines
 * lookup for an order. For a visit, the visit's own discipline is
 * authoritative and scopes the query as before; a ``discipline`` param is
 * accepted but ignored.
 */
export const getGoalTemplateGoalsVisitVisitIdTemplateGoalTemplateIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetGoalTemplateGoalsVisitVisitIdTemplateGoalTemplateIdGetData,
    ThrowOnError
  >
): RequestResult<
  GetGoalTemplateGoalsVisitVisitIdTemplateGoalTemplateIdGetResponses,
  GetGoalTemplateGoalsVisitVisitIdTemplateGoalTemplateIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetGoalTemplateGoalsVisitVisitIdTemplateGoalTemplateIdGetResponses,
    GetGoalTemplateGoalsVisitVisitIdTemplateGoalTemplateIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/goals/visit/{visit_id}/template/{goal_template_id}',
    ...options,
  });

/**
 * Get Goal Templates
 *
 * Get goal templates by ids with their attached intervention templates.
 *
 * Ids are only honored for templates the task could be offered (active, in
 * the patient's clinic, and matching the relevant discipline -- the same
 * set the options endpoint returns); anything else is dropped.
 *
 * An order task has no discipline of its own the way a visit does, so
 * ``discipline`` is REQUIRED for an order (400 if missing) and the
 * clinic+discipline-scoped set is used -- there is never an all-disciplines
 * lookup for an order. For a visit, the visit's own discipline is
 * authoritative; a ``discipline`` param is accepted but ignored.
 */
export const getGoalTemplatesGoalsVisitVisitIdTemplateBatchPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetGoalTemplatesGoalsVisitVisitIdTemplateBatchPostData,
    ThrowOnError
  >
): RequestResult<
  GetGoalTemplatesGoalsVisitVisitIdTemplateBatchPostResponses,
  GetGoalTemplatesGoalsVisitVisitIdTemplateBatchPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GetGoalTemplatesGoalsVisitVisitIdTemplateBatchPostResponses,
    GetGoalTemplatesGoalsVisitVisitIdTemplateBatchPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/goals/visit/{visit_id}/template/batch',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Intervention Template
 *
 * Get a single intervention template by id (id, name, instruction).
 */
export const getInterventionTemplateGoalsVisitInterventionInterventionTemplateIdGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetInterventionTemplateGoalsVisitInterventionInterventionTemplateIdGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetInterventionTemplateGoalsVisitInterventionInterventionTemplateIdGetResponses,
    GetInterventionTemplateGoalsVisitInterventionInterventionTemplateIdGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetInterventionTemplateGoalsVisitInterventionInterventionTemplateIdGetResponses,
      GetInterventionTemplateGoalsVisitInterventionInterventionTemplateIdGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/goals/visit/intervention/{intervention_template_id}',
      ...options,
    });

/**
 * Get Goal Options For Visit
 *
 * Get all possible goal templates for a task.
 *
 * A visit gets clinic + discipline matched options, unchanged -- the
 * visit's own discipline is authoritative, so a ``discipline`` param is
 * accepted but ignored here.
 *
 * An order task has no single discipline of its own the way a visit does,
 * so ``discipline`` is REQUIRED for an order (400 if missing) and the
 * server returns only that clinic+discipline's templates -- there is never
 * an all-disciplines template set for an order.
 * ``GoalTemplateOptionWithDisciplines`` is a strict superset of
 * ``GoalTemplateOption`` (it just adds ``disciplines``), so returning it
 * here for the order branch validates fine against this endpoint's
 * declared ``response_model`` and leaves the visit branch's wire shape
 * untouched; options still carry their discipline tags for labeling even
 * though the set itself is now server-filtered. The return type is
 * declared covariant (``Sequence``, not ``list``) so both concrete list
 * types type-check.
 */
export const getGoalOptionsForVisitGoalsVisitVisitIdOptionsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetGoalOptionsForVisitGoalsVisitVisitIdOptionsGetData,
    ThrowOnError
  >
): RequestResult<
  GetGoalOptionsForVisitGoalsVisitVisitIdOptionsGetResponses,
  GetGoalOptionsForVisitGoalsVisitVisitIdOptionsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetGoalOptionsForVisitGoalsVisitVisitIdOptionsGetResponses,
    GetGoalOptionsForVisitGoalsVisitVisitIdOptionsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/goals/visit/{visit_id}/options',
    ...options,
  });

/**
 * Get Intervention Options For Visit
 *
 * Get all active intervention templates at the task patient's clinic.
 *
 * Intervention options carry no discipline, so unlike goal options there is
 * no discipline-tagged episode variant to fall back to for an order -- the
 * plain episode-scoped clinic lookup is reused for both task types (an
 * order's episode has no visit to join through, so ``get_possible_for_visit``
 * would return nothing for it).
 */
export const getInterventionOptionsForVisitGoalsVisitVisitIdInterventionOptionsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetInterventionOptionsForVisitGoalsVisitVisitIdInterventionOptionsGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetInterventionOptionsForVisitGoalsVisitVisitIdInterventionOptionsGetResponses,
    GetInterventionOptionsForVisitGoalsVisitVisitIdInterventionOptionsGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetInterventionOptionsForVisitGoalsVisitVisitIdInterventionOptionsGetResponses,
      GetInterventionOptionsForVisitGoalsVisitVisitIdInterventionOptionsGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/goals/visit/{visit_id}/intervention/options',
      ...options,
    });

/**
 * Get Interventions For Patient Goal
 *
 * Get all interventions for a patient goal.
 */
export const getInterventionsForPatientGoalGoalsVisitVisitIdInterventionPatientGoalIdGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetInterventionsForPatientGoalGoalsVisitVisitIdInterventionPatientGoalIdGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetInterventionsForPatientGoalGoalsVisitVisitIdInterventionPatientGoalIdGetResponses,
    GetInterventionsForPatientGoalGoalsVisitVisitIdInterventionPatientGoalIdGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetInterventionsForPatientGoalGoalsVisitVisitIdInterventionPatientGoalIdGetResponses,
      GetInterventionsForPatientGoalGoalsVisitVisitIdInterventionPatientGoalIdGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/goals/visit/{visit_id}/intervention/{patient_goal_id}',
      ...options,
    });

/**
 * Delete Goal From Visit
 *
 * Delete a patient goal. Goal must belong to the task's episode.
 *
 * Visits keep the existing ungated behavior; an order never supports
 * DELETE (goal business rules) and 400s.
 */
export const deleteGoalFromVisitGoalsVisitVisitIdPatientGoalIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteGoalFromVisitGoalsVisitVisitIdPatientGoalIdDeleteData,
    ThrowOnError
  >
): RequestResult<
  DeleteGoalFromVisitGoalsVisitVisitIdPatientGoalIdDeleteResponses,
  DeleteGoalFromVisitGoalsVisitVisitIdPatientGoalIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteGoalFromVisitGoalsVisitVisitIdPatientGoalIdDeleteResponses,
    DeleteGoalFromVisitGoalsVisitVisitIdPatientGoalIdDeleteErrors,
    ThrowOnError
  >({ url: '/goals/visit/{visit_id}/{patient_goal_id}', ...options });

/**
 * Update Goal For Visit
 *
 * Update a patient goal for a task (goal must belong to the task's episode).
 *
 * Visits keep the existing ungated behavior (any note type may edit); an
 * order never supports MODIFY (goal business rules) and 400s.
 */
export const updateGoalForVisitGoalsVisitVisitIdPatientGoalIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateGoalForVisitGoalsVisitVisitIdPatientGoalIdPutData,
    ThrowOnError
  >
): RequestResult<
  UpdateGoalForVisitGoalsVisitVisitIdPatientGoalIdPutResponses,
  UpdateGoalForVisitGoalsVisitVisitIdPatientGoalIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateGoalForVisitGoalsVisitVisitIdPatientGoalIdPutResponses,
    UpdateGoalForVisitGoalsVisitVisitIdPatientGoalIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/goals/visit/{visit_id}/{patient_goal_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Accept Imported Goal
 *
 * Accept an imported goal's values as reviewed.
 *
 * Recorded as a touch of ``updated_at``: the Imported marker and the
 * overwrite guard both read ``updated_at != imported_at`` as "a clinician
 * owns this row now", so acceptance clears the marker and, like any other
 * edit, protects the chart from a destructive overwrite re-import.
 *
 * No visit-status gate: acceptance reviews the goal, not the visit, and
 * the marker shows wherever the goal does — including on visits that can
 * no longer be edited. It skips task-type gating like the goal-correction
 * endpoints above (see the header comment); ratified 2026-08-26. The chart
 * lock is a different door and still applies: a locked chart refuses it.
 */
export const acceptImportedGoalGoalsVisitVisitIdPatientGoalIdAcceptImportPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      AcceptImportedGoalGoalsVisitVisitIdPatientGoalIdAcceptImportPostData,
      ThrowOnError
    >
  ): RequestResult<
    AcceptImportedGoalGoalsVisitVisitIdPatientGoalIdAcceptImportPostResponses,
    AcceptImportedGoalGoalsVisitVisitIdPatientGoalIdAcceptImportPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      AcceptImportedGoalGoalsVisitVisitIdPatientGoalIdAcceptImportPostResponses,
      AcceptImportedGoalGoalsVisitVisitIdPatientGoalIdAcceptImportPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/goals/visit/{visit_id}/{patient_goal_id}/accept-import',
      ...options,
    });

/**
 * Add Intervention To Visit
 *
 * Add an intervention to a task by creating a patient intervention for
 * the given patient goal.
 *
 * Interventions shape the plan of care the same way goals do, so they ride
 * the goal-creation gate (``GoalTaskAction.ADD``): progress-only visit notes
 * (routine visits, discharge) score the existing interventions but cannot
 * attach new ones. An allowlisted order supports ADD the same as it does
 * for goals.
 */
export const addInterventionToVisitGoalsVisitVisitIdInterventionPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AddInterventionToVisitGoalsVisitVisitIdInterventionPostData,
    ThrowOnError
  >
): RequestResult<
  AddInterventionToVisitGoalsVisitVisitIdInterventionPostResponses,
  AddInterventionToVisitGoalsVisitVisitIdInterventionPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AddInterventionToVisitGoalsVisitVisitIdInterventionPostResponses,
    AddInterventionToVisitGoalsVisitVisitIdInterventionPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/goals/visit/{visit_id}/intervention',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Intervention From Visit
 *
 * Delete a patient intervention. Intervention must belong to a patient
 * goal in the task's episode.
 *
 * Visits keep the existing ungated behavior; an order never supports
 * DELETE (goal business rules) and 400s.
 */
export const deleteInterventionFromVisitGoalsVisitVisitIdInterventionPatientInterventionIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteInterventionFromVisitGoalsVisitVisitIdInterventionPatientInterventionIdDeleteData,
      ThrowOnError
    >
  ): RequestResult<
    DeleteInterventionFromVisitGoalsVisitVisitIdInterventionPatientInterventionIdDeleteResponses,
    DeleteInterventionFromVisitGoalsVisitVisitIdInterventionPatientInterventionIdDeleteErrors,
    ThrowOnError
  > =>
    (options.client ?? client).delete<
      DeleteInterventionFromVisitGoalsVisitVisitIdInterventionPatientInterventionIdDeleteResponses,
      DeleteInterventionFromVisitGoalsVisitVisitIdInterventionPatientInterventionIdDeleteErrors,
      ThrowOnError
    >({
      url: '/goals/visit/{visit_id}/intervention/{patient_intervention_id}',
      ...options,
    });

/**
 * Add Kinnser Goal To Episode
 *
 * Add a goal migrated from Kinnser directly to an episode, with no visit.
 *
 * A migrated episode may have no visit that can open goals (its Start of Care
 * happened in Kinnser) but still needs its goals carried over. The goal is
 * episode-scoped like any other; it is simply not recorded on a visit, so the
 * visit-type and visit-status gates of ``add_goal_to_visit`` do not apply.
 * Only Kinnser-enabled agencies can use this endpoint.
 */
export const addKinnserGoalToEpisodeGoalsEpisodeEpisodeIdPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AddKinnserGoalToEpisodeGoalsEpisodeEpisodeIdPostData,
    ThrowOnError
  >
): RequestResult<
  AddKinnserGoalToEpisodeGoalsEpisodeEpisodeIdPostResponses,
  AddKinnserGoalToEpisodeGoalsEpisodeEpisodeIdPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AddKinnserGoalToEpisodeGoalsEpisodeEpisodeIdPostResponses,
    AddKinnserGoalToEpisodeGoalsEpisodeEpisodeIdPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/goals/episode/{episode_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Goal Options For Episode
 *
 * Get goal templates for an episode across all disciplines.
 *
 * Used by the external-EMR migration flow (see ``add_kinnser_goal_to_episode``):
 * there is no visit to scope the options to a single discipline, so each
 * option carries its discipline types for labeling and filtering in the UI.
 * Only Kinnser-enabled agencies can use this endpoint.
 */
export const getGoalOptionsForEpisodeGoalsEpisodeEpisodeIdOptionsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetGoalOptionsForEpisodeGoalsEpisodeEpisodeIdOptionsGetData,
    ThrowOnError
  >
): RequestResult<
  GetGoalOptionsForEpisodeGoalsEpisodeEpisodeIdOptionsGetResponses,
  GetGoalOptionsForEpisodeGoalsEpisodeEpisodeIdOptionsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetGoalOptionsForEpisodeGoalsEpisodeEpisodeIdOptionsGetResponses,
    GetGoalOptionsForEpisodeGoalsEpisodeEpisodeIdOptionsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/goals/episode/{episode_id}/options',
    ...options,
  });

/**
 * Get Goal Templates For Episode
 *
 * Get goal templates by ids with attached interventions, for the episode flow.
 *
 * Mirror of the visit-scoped ``get_goal_templates`` for the external-EMR
 * migration flow, where goals are created on an episode with no visit.
 * Ids are only honored for active templates in the episode patient's clinic
 * (the same set the options endpoint offers); anything else is dropped.
 * Only Kinnser-enabled agencies can use this endpoint.
 */
export const getGoalTemplatesForEpisodeGoalsEpisodeEpisodeIdTemplateBatchPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetGoalTemplatesForEpisodeGoalsEpisodeEpisodeIdTemplateBatchPostData,
      ThrowOnError
    >
  ): RequestResult<
    GetGoalTemplatesForEpisodeGoalsEpisodeEpisodeIdTemplateBatchPostResponses,
    GetGoalTemplatesForEpisodeGoalsEpisodeEpisodeIdTemplateBatchPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      GetGoalTemplatesForEpisodeGoalsEpisodeEpisodeIdTemplateBatchPostResponses,
      GetGoalTemplatesForEpisodeGoalsEpisodeEpisodeIdTemplateBatchPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/goals/episode/{episode_id}/template/batch',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Get Goals To Continue
 *
 * The previous episode's open goals that can continue into this episode.
 */
export const getGoalsToContinueGoalsEpisodeEpisodeIdCarryForwardGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetGoalsToContinueGoalsEpisodeEpisodeIdCarryForwardGetData,
    ThrowOnError
  >
): RequestResult<
  GetGoalsToContinueGoalsEpisodeEpisodeIdCarryForwardGetResponses,
  GetGoalsToContinueGoalsEpisodeEpisodeIdCarryForwardGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetGoalsToContinueGoalsEpisodeEpisodeIdCarryForwardGetResponses,
    GetGoalsToContinueGoalsEpisodeEpisodeIdCarryForwardGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/goals/episode/{episode_id}/carry-forward',
    ...options,
  });

/**
 * Continue Goals From Previous Episode
 *
 * Extend the confirmed goals of the previous episode into this one.
 *
 * All or nothing, and safe to resend: goals already continued are reported
 * and left alone. No visit is credited with the push; the audit log records
 * who continued each goal and from which episode.
 */
export const continueGoalsFromPreviousEpisodeGoalsEpisodeEpisodeIdCarryForwardPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ContinueGoalsFromPreviousEpisodeGoalsEpisodeEpisodeIdCarryForwardPostData,
      ThrowOnError
    >
  ): RequestResult<
    ContinueGoalsFromPreviousEpisodeGoalsEpisodeEpisodeIdCarryForwardPostResponses,
    ContinueGoalsFromPreviousEpisodeGoalsEpisodeEpisodeIdCarryForwardPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      ContinueGoalsFromPreviousEpisodeGoalsEpisodeEpisodeIdCarryForwardPostResponses,
      ContinueGoalsFromPreviousEpisodeGoalsEpisodeEpisodeIdCarryForwardPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/goals/episode/{episode_id}/carry-forward',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Import Goals From Rogerdocs
 *
 * Fetch goal templates from RogerDocs and prepare them for import.
 * Fetches IDs for the target agency/clinic and parses the RogerDocs response.
 * If to_clinic is omitted, writes goals and interventions to all clinics for the agency.
 */
export const importGoalsFromRogerdocsGoalsDashboardImportFromRogerdocsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ImportGoalsFromRogerdocsGoalsDashboardImportFromRogerdocsPostData,
    ThrowOnError
  >
): RequestResult<
  ImportGoalsFromRogerdocsGoalsDashboardImportFromRogerdocsPostResponses,
  ImportGoalsFromRogerdocsGoalsDashboardImportFromRogerdocsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ImportGoalsFromRogerdocsGoalsDashboardImportFromRogerdocsPostResponses,
    ImportGoalsFromRogerdocsGoalsDashboardImportFromRogerdocsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/goals/dashboard/import-from-rogerdocs',
    ...options,
  });

/**
 * Sync Goals For Agency
 *
 * Sync goal and intervention templates from RogerDocs for every clinic in an agency.
 *
 * For each EMR clinic that has a clinic_key (i.e. a RogerDocs clinic_id), fetches
 * goal and intervention templates from RogerDocs and upserts them into the EMR clinic.
 * Existing records are updated in place without losing their EMR IDs; new records are
 * created. Clinics with no data in RogerDocs are logged and skipped.
 */
export const syncGoalsForAgencyGoalsDashboardSyncGoalsForAgencyPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SyncGoalsForAgencyGoalsDashboardSyncGoalsForAgencyPostData,
    ThrowOnError
  >
): RequestResult<
  SyncGoalsForAgencyGoalsDashboardSyncGoalsForAgencyPostResponses,
  SyncGoalsForAgencyGoalsDashboardSyncGoalsForAgencyPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SyncGoalsForAgencyGoalsDashboardSyncGoalsForAgencyPostResponses,
    SyncGoalsForAgencyGoalsDashboardSyncGoalsForAgencyPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/goals/dashboard/sync-goals-for-agency',
    ...options,
  });

/**
 * Start Sync Goals For Agency Workflow
 *
 * Start the full agency goal sync as a background Temporal workflow.
 *
 * The workflow first runs the RogerDocs WellSky/Kinnser goal scrape and waits
 * for it to complete, then syncs the scraped templates into every EMR clinic
 * in the agency. Poll ``/sync-goals-for-agency/status`` for progress/results.
 *
 * The workflow id is stable per agency per day: a sync already running today
 * returns 409 (wait for it to finish), while a stale run from a previous day
 * never blocks a new one. A run that failed today can be retried immediately
 * (``ALLOW_DUPLICATE_FAILED_ONLY``); a run that already completed successfully
 * today also returns 409.
 */
export const startSyncGoalsForAgencyWorkflowGoalsDashboardSyncGoalsForAgencyAsyncPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      StartSyncGoalsForAgencyWorkflowGoalsDashboardSyncGoalsForAgencyAsyncPostData,
      ThrowOnError
    >
  ): RequestResult<
    StartSyncGoalsForAgencyWorkflowGoalsDashboardSyncGoalsForAgencyAsyncPostResponses,
    StartSyncGoalsForAgencyWorkflowGoalsDashboardSyncGoalsForAgencyAsyncPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      StartSyncGoalsForAgencyWorkflowGoalsDashboardSyncGoalsForAgencyAsyncPostResponses,
      StartSyncGoalsForAgencyWorkflowGoalsDashboardSyncGoalsForAgencyAsyncPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/goals/dashboard/sync-goals-for-agency/async',
      ...options,
    });

/**
 * Get Sync Goals For Agency Workflow Status
 *
 * Return the status of today's goal sync workflow for the agency.
 *
 * The workflow id is derived from the agency system_name and today's business
 * date, so callers never need to store a job id — any user can poll the
 * current run. When the workflow has completed, ``result`` carries the
 * per-clinic sync outcome (including skipped clinics and errors); when it
 * failed, ``error`` carries the failure message. 404 when no sync has run
 * today.
 */
export const getSyncGoalsForAgencyWorkflowStatusGoalsDashboardSyncGoalsForAgencyStatusGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetSyncGoalsForAgencyWorkflowStatusGoalsDashboardSyncGoalsForAgencyStatusGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetSyncGoalsForAgencyWorkflowStatusGoalsDashboardSyncGoalsForAgencyStatusGetResponses,
    GetSyncGoalsForAgencyWorkflowStatusGoalsDashboardSyncGoalsForAgencyStatusGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetSyncGoalsForAgencyWorkflowStatusGoalsDashboardSyncGoalsForAgencyStatusGetResponses,
      GetSyncGoalsForAgencyWorkflowStatusGoalsDashboardSyncGoalsForAgencyStatusGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/goals/dashboard/sync-goals-for-agency/status',
      ...options,
    });

/**
 * Copy Goals Between Clinics
 *
 * HTTP wrapper around :func:`copy_goals_between_clinic_keys`.
 */
export const copyGoalsBetweenClinicsGoalsDashboardCopyGoalsBetweenClinicsPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      CopyGoalsBetweenClinicsGoalsDashboardCopyGoalsBetweenClinicsPostData,
      ThrowOnError
    >
  ): RequestResult<
    CopyGoalsBetweenClinicsGoalsDashboardCopyGoalsBetweenClinicsPostResponses,
    CopyGoalsBetweenClinicsGoalsDashboardCopyGoalsBetweenClinicsPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      CopyGoalsBetweenClinicsGoalsDashboardCopyGoalsBetweenClinicsPostResponses,
      CopyGoalsBetweenClinicsGoalsDashboardCopyGoalsBetweenClinicsPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/goals/dashboard/copy-goals-between-clinics',
      ...options,
    });

/**
 * Bulk Upsert To Rogerdocs
 *
 * Bulk upsert goal and intervention templates from RogerEMR to RogerDocs.
 *
 * Fetches all goal templates and intervention templates for the specified
 * agency/clinic from RogerEMR, transforms them into RogerDocs format, and
 * calls the RogerDocs /v1/worksheet-goals/bulk-upsert endpoint.
 *
 * This endpoint blindly returns or raises whatever is returned or raised
 * by the RogerDocs endpoint.
 */
export const bulkUpsertToRogerdocsGoalsDashboardBulkUpsertToRogerdocsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    BulkUpsertToRogerdocsGoalsDashboardBulkUpsertToRogerdocsPostData,
    ThrowOnError
  >
): RequestResult<
  BulkUpsertToRogerdocsGoalsDashboardBulkUpsertToRogerdocsPostResponses,
  BulkUpsertToRogerdocsGoalsDashboardBulkUpsertToRogerdocsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    BulkUpsertToRogerdocsGoalsDashboardBulkUpsertToRogerdocsPostResponses,
    BulkUpsertToRogerdocsGoalsDashboardBulkUpsertToRogerdocsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/goals/dashboard/bulk-upsert-to-rogerdocs',
    ...options,
  });

/**
 * Send Support Email
 *
 * Send a support email from the EMR to the support team.
 */
export const sendSupportEmailApiSupportContactPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SendSupportEmailApiSupportContactPostData, ThrowOnError>
): RequestResult<
  SendSupportEmailApiSupportContactPostResponses,
  SendSupportEmailApiSupportContactPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SendSupportEmailApiSupportContactPostResponses,
    SendSupportEmailApiSupportContactPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/support/contact',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Preview Test Patient Cleanup
 *
 * List ``is_test_patient`` records and related entity counts (no deletes).
 */
export const previewTestPatientCleanupAdminTestPatientsPreviewPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PreviewTestPatientCleanupAdminTestPatientsPreviewPostData,
    ThrowOnError
  >
): RequestResult<
  PreviewTestPatientCleanupAdminTestPatientsPreviewPostResponses,
  PreviewTestPatientCleanupAdminTestPatientsPreviewPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PreviewTestPatientCleanupAdminTestPatientsPreviewPostResponses,
    PreviewTestPatientCleanupAdminTestPatientsPreviewPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/admin/test-patients/preview',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Test Patients
 *
 * Hard-delete previewed test patients after token + phrase confirmation.
 */
export const deleteTestPatientsAdminTestPatientsDeletePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteTestPatientsAdminTestPatientsDeletePostData,
    ThrowOnError
  >
): RequestResult<
  DeleteTestPatientsAdminTestPatientsDeletePostResponses,
  DeleteTestPatientsAdminTestPatientsDeletePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DeleteTestPatientsAdminTestPatientsDeletePostResponses,
    DeleteTestPatientsAdminTestPatientsDeletePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/admin/test-patients/delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Unset Episode Billed Externally
 *
 * Set billed_externally to false. No-op when it is already false.
 */
export const unsetEpisodeBilledExternally = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UnsetEpisodeBilledExternallyData, ThrowOnError>
): RequestResult<
  UnsetEpisodeBilledExternallyResponses,
  UnsetEpisodeBilledExternallyErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UnsetEpisodeBilledExternallyResponses,
    UnsetEpisodeBilledExternallyErrors,
    ThrowOnError
  >({
    url: '/admin/episodes/{episode_id}/unset-billed-externally',
    ...options,
  });

/**
 * Receive Fax Webhook
 *
 * Capture one RingCentral notification and acknowledge it.
 */
export const receiveFaxWebhookFaxInboxWebhooksReceivePost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ReceiveFaxWebhookFaxInboxWebhooksReceivePostData,
    ThrowOnError
  >
): RequestResult<
  ReceiveFaxWebhookFaxInboxWebhooksReceivePostResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    ReceiveFaxWebhookFaxInboxWebhooksReceivePostResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/fax-inbox/webhooks/receive',
    ...options,
  });

/**
 * List Received Faxes
 *
 * The agency's inbox, newest first.
 */
export const listReceivedFaxesReceivedFaxesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListReceivedFaxesReceivedFaxesGetData, ThrowOnError>
): RequestResult<
  ListReceivedFaxesReceivedFaxesGetResponses,
  ListReceivedFaxesReceivedFaxesGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListReceivedFaxesReceivedFaxesGetResponses,
    ListReceivedFaxesReceivedFaxesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/received-faxes',
    ...options,
  });

/**
 * Get Received Fax
 *
 * One transmission and its documents.
 */
export const getReceivedFaxReceivedFaxesFaxIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetReceivedFaxReceivedFaxesFaxIdGetData, ThrowOnError>
): RequestResult<
  GetReceivedFaxReceivedFaxesFaxIdGetResponses,
  GetReceivedFaxReceivedFaxesFaxIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetReceivedFaxReceivedFaxesFaxIdGetResponses,
    GetReceivedFaxReceivedFaxesFaxIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/received-faxes/{fax_id}',
    ...options,
  });

/**
 * Download Received Fax Document
 *
 * A short-lived URL for one document's contents.
 */
export const downloadReceivedFaxDocumentReceivedFaxesFaxIdDocumentsDocumentIdDownloadGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DownloadReceivedFaxDocumentReceivedFaxesFaxIdDocumentsDocumentIdDownloadGetData,
      ThrowOnError
    >
  ): RequestResult<
    DownloadReceivedFaxDocumentReceivedFaxesFaxIdDocumentsDocumentIdDownloadGetResponses,
    DownloadReceivedFaxDocumentReceivedFaxesFaxIdDocumentsDocumentIdDownloadGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      DownloadReceivedFaxDocumentReceivedFaxesFaxIdDocumentsDocumentIdDownloadGetResponses,
      DownloadReceivedFaxDocumentReceivedFaxesFaxIdDocumentsDocumentIdDownloadGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/received-faxes/{fax_id}/documents/{document_id}/download',
      ...options,
    });

/**
 * List Fax Documents
 *
 * The agency's assembled documents, newest first.
 */
export const listFaxDocumentsFaxDocumentsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListFaxDocumentsFaxDocumentsGetData, ThrowOnError>
): RequestResult<
  ListFaxDocumentsFaxDocumentsGetResponses,
  ListFaxDocumentsFaxDocumentsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListFaxDocumentsFaxDocumentsGetResponses,
    ListFaxDocumentsFaxDocumentsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/fax-documents',
    ...options,
  });

/**
 * Assemble Fax Document
 *
 * Build a document from chosen pages of chosen arrivals.
 */
export const assembleFaxDocumentFaxDocumentsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AssembleFaxDocumentFaxDocumentsPostData, ThrowOnError>
): RequestResult<
  AssembleFaxDocumentFaxDocumentsPostResponses,
  AssembleFaxDocumentFaxDocumentsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AssembleFaxDocumentFaxDocumentsPostResponses,
    AssembleFaxDocumentFaxDocumentsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/fax-documents',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Edit Fax Document Pages
 *
 * Rotate, rearrange or drop pages by naming the ones to keep.
 */
export const editFaxDocumentPagesFaxDocumentsDocumentIdPagesPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    EditFaxDocumentPagesFaxDocumentsDocumentIdPagesPatchData,
    ThrowOnError
  >
): RequestResult<
  EditFaxDocumentPagesFaxDocumentsDocumentIdPagesPatchResponses,
  EditFaxDocumentPagesFaxDocumentsDocumentIdPagesPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    EditFaxDocumentPagesFaxDocumentsDocumentIdPagesPatchResponses,
    EditFaxDocumentPagesFaxDocumentsDocumentIdPagesPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/fax-documents/{document_id}/pages',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Fax Document
 */
export const getFaxDocumentFaxDocumentsDocumentIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetFaxDocumentFaxDocumentsDocumentIdGetData, ThrowOnError>
): RequestResult<
  GetFaxDocumentFaxDocumentsDocumentIdGetResponses,
  GetFaxDocumentFaxDocumentsDocumentIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetFaxDocumentFaxDocumentsDocumentIdGetResponses,
    GetFaxDocumentFaxDocumentsDocumentIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/fax-documents/{document_id}',
    ...options,
  });

/**
 * Rename Fax Document
 *
 * Give a document a name a person will recognise.
 */
export const renameFaxDocumentFaxDocumentsDocumentIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RenameFaxDocumentFaxDocumentsDocumentIdPatchData,
    ThrowOnError
  >
): RequestResult<
  RenameFaxDocumentFaxDocumentsDocumentIdPatchResponses,
  RenameFaxDocumentFaxDocumentsDocumentIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    RenameFaxDocumentFaxDocumentsDocumentIdPatchResponses,
    RenameFaxDocumentFaxDocumentsDocumentIdPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/fax-documents/{document_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Download Fax Document
 *
 * A short-lived URL for the assembled PDF.
 */
export const downloadFaxDocumentFaxDocumentsDocumentIdDownloadGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DownloadFaxDocumentFaxDocumentsDocumentIdDownloadGetData,
    ThrowOnError
  >
): RequestResult<
  DownloadFaxDocumentFaxDocumentsDocumentIdDownloadGetResponses,
  DownloadFaxDocumentFaxDocumentsDocumentIdDownloadGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    DownloadFaxDocumentFaxDocumentsDocumentIdDownloadGetResponses,
    DownloadFaxDocumentFaxDocumentsDocumentIdDownloadGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/fax-documents/{document_id}/download',
    ...options,
  });

/**
 * Merge Fax Items
 *
 * Staple several inbox items into one document.
 *
 * Merging one item is allowed and is how an arrival becomes a document
 * without anything else changing: what arrived stays exactly as it arrived,
 * on record, and the document is a new object beside it.
 */
export const mergeFaxItemsFaxDocumentsMergePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MergeFaxItemsFaxDocumentsMergePostData, ThrowOnError>
): RequestResult<
  MergeFaxItemsFaxDocumentsMergePostResponses,
  MergeFaxItemsFaxDocumentsMergePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    MergeFaxItemsFaxDocumentsMergePostResponses,
    MergeFaxItemsFaxDocumentsMergePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/fax-documents/merge',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Split Fax Document
 *
 * Separate a document into two, and answer with the new one.
 *
 * A transmission often holds several stapled documents, and taking them
 * apart is the other half of the job merging does. The pages move rather
 * than being copied: a ten page fax carrying two referrals becomes a six and
 * a four, with no page in both and none left behind.
 *
 * One transaction and one version bump, because this is two writes to the
 * same document. Done as two requests, a failure between them would leave
 * the pages either duplicated across both or gone from both, and there is no
 * way for the caller to tell which.
 */
export const splitFaxDocumentFaxDocumentsDocumentIdSplitPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SplitFaxDocumentFaxDocumentsDocumentIdSplitPostData,
    ThrowOnError
  >
): RequestResult<
  SplitFaxDocumentFaxDocumentsDocumentIdSplitPostResponses,
  SplitFaxDocumentFaxDocumentsDocumentIdSplitPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SplitFaxDocumentFaxDocumentsDocumentIdSplitPostResponses,
    SplitFaxDocumentFaxDocumentsDocumentIdSplitPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/fax-documents/{document_id}/split',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Fax Items
 *
 * The agency's inbox, newest first, across both kinds.
 */
export const listFaxItemsFaxItemsGet = <ThrowOnError extends boolean = false>(
  options?: Options<ListFaxItemsFaxItemsGetData, ThrowOnError>
): RequestResult<
  ListFaxItemsFaxItemsGetResponses,
  ListFaxItemsFaxItemsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListFaxItemsFaxItemsGetResponses,
    ListFaxItemsFaxItemsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/fax-items',
    ...options,
  });

/**
 * Rename Arrival
 *
 * Give a transmission a name a person will recognise.
 *
 * Only the name: the pages that arrived are left exactly as they arrived.
 * Changing those makes a document out of it instead, which is a different
 * route and keeps the original on record.
 */
export const renameArrivalFaxItemsArrivalItemIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RenameArrivalFaxItemsArrivalItemIdPatchData, ThrowOnError>
): RequestResult<
  RenameArrivalFaxItemsArrivalItemIdPatchResponses,
  RenameArrivalFaxItemsArrivalItemIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    RenameArrivalFaxItemsArrivalItemIdPatchResponses,
    RenameArrivalFaxItemsArrivalItemIdPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/fax-items/arrival/{item_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Rename Document
 *
 * Rename an assembled document.
 */
export const renameDocumentFaxItemsDocumentItemIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RenameDocumentFaxItemsDocumentItemIdPatchData, ThrowOnError>
): RequestResult<
  RenameDocumentFaxItemsDocumentItemIdPatchResponses,
  RenameDocumentFaxItemsDocumentItemIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    RenameDocumentFaxItemsDocumentItemIdPatchResponses,
    RenameDocumentFaxItemsDocumentItemIdPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/fax-items/document/{item_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Check Portability
 *
 * Whether each number can move to Roger, before anything is created.
 */
export const checkPortabilityFaxNumberPortsPortabilityCheckPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CheckPortabilityFaxNumberPortsPortabilityCheckPostData,
    ThrowOnError
  >
): RequestResult<
  CheckPortabilityFaxNumberPortsPortabilityCheckPostResponses,
  CheckPortabilityFaxNumberPortsPortabilityCheckPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CheckPortabilityFaxNumberPortsPortabilityCheckPostResponses,
    CheckPortabilityFaxNumberPortsPortabilityCheckPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/fax-number-ports/portability-check',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Port Orders
 *
 * The agency's orders as last seen. Opening one refreshes it from Telnyx.
 */
export const listPortOrdersFaxNumberPortsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListPortOrdersFaxNumberPortsGetData, ThrowOnError>
): RequestResult<
  ListPortOrdersFaxNumberPortsGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListPortOrdersFaxNumberPortsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/fax-number-ports/',
    ...options,
  });

/**
 * Create Port Orders
 *
 * Start a port. Telnyx may split one request into several orders.
 *
 * An agency without a Telnyx fax line gets one first, where this stage may
 * call Telnyx; a line that cannot be set up is reported and fails nothing.
 * An invoice sent along is attached to every order made that has a number
 * it lists (to the only one when there is one), which is then filled from
 * its reading; a failure there is reported per order.
 */
export const createPortOrdersFaxNumberPortsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreatePortOrdersFaxNumberPortsPostData, ThrowOnError>
): RequestResult<
  CreatePortOrdersFaxNumberPortsPostResponses,
  CreatePortOrdersFaxNumberPortsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreatePortOrdersFaxNumberPortsPostResponses,
    CreatePortOrdersFaxNumberPortsPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/fax-number-ports/',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Read Invoice
 *
 * What a carrier invoice says, before any order exists. Touches nothing
 * at Telnyx, and keeps neither the file nor the reading.
 */
export const readInvoiceFaxNumberPortsInvoiceReadingPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ReadInvoiceFaxNumberPortsInvoiceReadingPostData,
    ThrowOnError
  >
): RequestResult<
  ReadInvoiceFaxNumberPortsInvoiceReadingPostResponses,
  ReadInvoiceFaxNumberPortsInvoiceReadingPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ReadInvoiceFaxNumberPortsInvoiceReadingPostResponses,
    ReadInvoiceFaxNumberPortsInvoiceReadingPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/fax-number-ports/invoice-reading',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Delete Port Order
 *
 * Delete a draft at Telnyx. The row stays, marked cancelled, as the record.
 */
export const deletePortOrderFaxNumberPortsPortOrderIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeletePortOrderFaxNumberPortsPortOrderIdDeleteData,
    ThrowOnError
  >
): RequestResult<
  DeletePortOrderFaxNumberPortsPortOrderIdDeleteResponses,
  DeletePortOrderFaxNumberPortsPortOrderIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeletePortOrderFaxNumberPortsPortOrderIdDeleteResponses,
    DeletePortOrderFaxNumberPortsPortOrderIdDeleteErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/fax-number-ports/{port_order_id}',
    ...options,
  });

/**
 * Get Port Order
 *
 * The order, refreshed from Telnyx unless it is already cancelled.
 *
 * The refresh that first sees it ported maps its numbers to the agency and
 * puts them on the agency's Telnyx fax application, where this stage may call
 * Telnyx. Anything left over is retried by the scheduled order poll, not on
 * every view, since the screen polls.
 */
export const getPortOrderFaxNumberPortsPortOrderIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetPortOrderFaxNumberPortsPortOrderIdGetData, ThrowOnError>
): RequestResult<
  GetPortOrderFaxNumberPortsPortOrderIdGetResponses,
  GetPortOrderFaxNumberPortsPortOrderIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetPortOrderFaxNumberPortsPortOrderIdGetResponses,
    GetPortOrderFaxNumberPortsPortOrderIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/fax-number-ports/{port_order_id}',
    ...options,
  });

/**
 * Update Port Order
 *
 * Save the details somebody supplied, and only those.
 */
export const updatePortOrderFaxNumberPortsPortOrderIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdatePortOrderFaxNumberPortsPortOrderIdPatchData,
    ThrowOnError
  >
): RequestResult<
  UpdatePortOrderFaxNumberPortsPortOrderIdPatchResponses,
  UpdatePortOrderFaxNumberPortsPortOrderIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdatePortOrderFaxNumberPortsPortOrderIdPatchResponses,
    UpdatePortOrderFaxNumberPortsPortOrderIdPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/fax-number-ports/{port_order_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Confirm Port Details
 *
 * Record that the person checked the details against their invoice.
 * Needed to submit once they uploaded one, whether or not it was read.
 */
export const confirmPortDetailsFaxNumberPortsPortOrderIdDetailsConfirmationPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ConfirmPortDetailsFaxNumberPortsPortOrderIdDetailsConfirmationPutData,
      ThrowOnError
    >
  ): RequestResult<
    ConfirmPortDetailsFaxNumberPortsPortOrderIdDetailsConfirmationPutResponses,
    ConfirmPortDetailsFaxNumberPortsPortOrderIdDetailsConfirmationPutErrors,
    ThrowOnError
  > =>
    (options.client ?? client).put<
      ConfirmPortDetailsFaxNumberPortsPortOrderIdDetailsConfirmationPutResponses,
      ConfirmPortDetailsFaxNumberPortsPortOrderIdDetailsConfirmationPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/fax-number-ports/{port_order_id}/details-confirmation',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Set Port Type
 *
 * Make a draft a full port, which moves every number and closes the
 * carrier account, or a partial one, which keeps a number there.
 */
export const setPortTypeFaxNumberPortsPortOrderIdPortTypePut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SetPortTypeFaxNumberPortsPortOrderIdPortTypePutData,
    ThrowOnError
  >
): RequestResult<
  SetPortTypeFaxNumberPortsPortOrderIdPortTypePutResponses,
  SetPortTypeFaxNumberPortsPortOrderIdPortTypePutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    SetPortTypeFaxNumberPortsPortOrderIdPortTypePutResponses,
    SetPortTypeFaxNumberPortsPortOrderIdPortTypePutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/fax-number-ports/{port_order_id}/port-type',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Settle Invoice Difference
 *
 * Use the invoice's value, keep the entered one, or undo keeping it.
 */
export const settleInvoiceDifferenceFaxNumberPortsPortOrderIdInvoiceDifferencesFieldPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      SettleInvoiceDifferenceFaxNumberPortsPortOrderIdInvoiceDifferencesFieldPostData,
      ThrowOnError
    >
  ): RequestResult<
    SettleInvoiceDifferenceFaxNumberPortsPortOrderIdInvoiceDifferencesFieldPostResponses,
    SettleInvoiceDifferenceFaxNumberPortsPortOrderIdInvoiceDifferencesFieldPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      SettleInvoiceDifferenceFaxNumberPortsPortOrderIdInvoiceDifferencesFieldPostResponses,
      SettleInvoiceDifferenceFaxNumberPortsPortOrderIdInvoiceDifferencesFieldPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/fax-number-ports/{port_order_id}/invoice-differences/{field}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Get Loa Template
 *
 * Telnyx's letter of authorization for this order, to print and sign.
 */
export const getLoaTemplateFaxNumberPortsPortOrderIdLoaTemplateGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetLoaTemplateFaxNumberPortsPortOrderIdLoaTemplateGetData,
    ThrowOnError
  >
): RequestResult<
  GetLoaTemplateFaxNumberPortsPortOrderIdLoaTemplateGetResponses,
  GetLoaTemplateFaxNumberPortsPortOrderIdLoaTemplateGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetLoaTemplateFaxNumberPortsPortOrderIdLoaTemplateGetResponses,
    GetLoaTemplateFaxNumberPortsPortOrderIdLoaTemplateGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/fax-number-ports/{port_order_id}/loa-template',
    ...options,
  });

/**
 * Get Loa Signing
 *
 * What the sign dialog shows: the letter, the signer and the consent.
 */
export const getLoaSigningFaxNumberPortsPortOrderIdLoaSigningGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetLoaSigningFaxNumberPortsPortOrderIdLoaSigningGetData,
    ThrowOnError
  >
): RequestResult<
  GetLoaSigningFaxNumberPortsPortOrderIdLoaSigningGetResponses,
  GetLoaSigningFaxNumberPortsPortOrderIdLoaSigningGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetLoaSigningFaxNumberPortsPortOrderIdLoaSigningGetResponses,
    GetLoaSigningFaxNumberPortsPortOrderIdLoaSigningGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/fax-number-ports/{port_order_id}/loa-signing',
    ...options,
  });

/**
 * Sign Loa
 *
 * Sign the letter electronically, keep the signed copy and attach it.
 *
 * The signing is recorded before Telnyx is asked, so its evidence survives a
 * failed attach; the letter counts as signed only once Telnyx holds it.
 */
export const signLoaFaxNumberPortsPortOrderIdLoaSignaturePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SignLoaFaxNumberPortsPortOrderIdLoaSignaturePostData,
    ThrowOnError
  >
): RequestResult<
  SignLoaFaxNumberPortsPortOrderIdLoaSignaturePostResponses,
  SignLoaFaxNumberPortsPortOrderIdLoaSignaturePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SignLoaFaxNumberPortsPortOrderIdLoaSignaturePostResponses,
    SignLoaFaxNumberPortsPortOrderIdLoaSignaturePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/fax-number-ports/{port_order_id}/loa-signature',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove Port Document
 *
 * Unlink a draft's document at Telnyx and delete it there.
 */
export const removePortDocumentFaxNumberPortsPortOrderIdDocumentsDocumentKindDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      RemovePortDocumentFaxNumberPortsPortOrderIdDocumentsDocumentKindDeleteData,
      ThrowOnError
    >
  ): RequestResult<
    RemovePortDocumentFaxNumberPortsPortOrderIdDocumentsDocumentKindDeleteResponses,
    RemovePortDocumentFaxNumberPortsPortOrderIdDocumentsDocumentKindDeleteErrors,
    ThrowOnError
  > =>
    (options.client ?? client).delete<
      RemovePortDocumentFaxNumberPortsPortOrderIdDocumentsDocumentKindDeleteResponses,
      RemovePortDocumentFaxNumberPortsPortOrderIdDocumentsDocumentKindDeleteErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/fax-number-ports/{port_order_id}/documents/{document_kind}',
      ...options,
    });

/**
 * Download Port Document
 *
 * The attached document as Telnyx holds it, at any status.
 */
export const downloadPortDocumentFaxNumberPortsPortOrderIdDocumentsDocumentKindGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DownloadPortDocumentFaxNumberPortsPortOrderIdDocumentsDocumentKindGetData,
      ThrowOnError
    >
  ): RequestResult<
    DownloadPortDocumentFaxNumberPortsPortOrderIdDocumentsDocumentKindGetResponses,
    DownloadPortDocumentFaxNumberPortsPortOrderIdDocumentsDocumentKindGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      DownloadPortDocumentFaxNumberPortsPortOrderIdDocumentsDocumentKindGetResponses,
      DownloadPortDocumentFaxNumberPortsPortOrderIdDocumentsDocumentKindGetErrors,
      ThrowOnError
    >({
      responseType: 'blob',
      url: '/fax-number-ports/{port_order_id}/documents/{document_kind}',
      ...options,
    });

/**
 * Upload Port Document
 *
 * Pass a signed LOA or an invoice to Telnyx and attach it to the order.
 *
 * Held in memory and never stored by Roger: Telnyx keeps the document. An
 * invoice is read first; it fills the order's empty details and records
 * where it differs from the others, for the person to settle.
 */
export const uploadPortDocumentFaxNumberPortsPortOrderIdDocumentsDocumentKindPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UploadPortDocumentFaxNumberPortsPortOrderIdDocumentsDocumentKindPostData,
      ThrowOnError
    >
  ): RequestResult<
    UploadPortDocumentFaxNumberPortsPortOrderIdDocumentsDocumentKindPostResponses,
    UploadPortDocumentFaxNumberPortsPortOrderIdDocumentsDocumentKindPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      UploadPortDocumentFaxNumberPortsPortOrderIdDocumentsDocumentKindPostResponses,
      UploadPortDocumentFaxNumberPortsPortOrderIdDocumentsDocumentKindPostErrors,
      ThrowOnError
    >({
      ...formDataBodySerializer,
      responseType: 'json',
      url: '/fax-number-ports/{port_order_id}/documents/{document_kind}',
      ...options,
      headers: {
        'Content-Type': null,
        ...options.headers,
      },
    });

/**
 * Submit Port Order
 *
 * Submit the order to the losing carrier. At most once, never retried.
 */
export const submitPortOrderFaxNumberPortsPortOrderIdSubmitPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SubmitPortOrderFaxNumberPortsPortOrderIdSubmitPostData,
    ThrowOnError
  >
): RequestResult<
  SubmitPortOrderFaxNumberPortsPortOrderIdSubmitPostResponses,
  SubmitPortOrderFaxNumberPortsPortOrderIdSubmitPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SubmitPortOrderFaxNumberPortsPortOrderIdSubmitPostResponses,
    SubmitPortOrderFaxNumberPortsPortOrderIdSubmitPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/fax-number-ports/{port_order_id}/submit',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Fax Types
 *
 * The types on offer, and optionally the retired ones too.
 *
 * Choosing a type for a fax gets the offered ones. Filtering a list by type
 * gets all of them, because a fax filed under a type that has since been
 * retired is still a fax somebody needs to find, and it still says what it
 * is.
 */
export const listFaxTypesFaxClassificationTypesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListFaxTypesFaxClassificationTypesGetData, ThrowOnError>
): RequestResult<
  ListFaxTypesFaxClassificationTypesGetResponses,
  ListFaxTypesFaxClassificationTypesGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListFaxTypesFaxClassificationTypesGetResponses,
    ListFaxTypesFaxClassificationTypesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/fax-classification/types',
    ...options,
  });

/**
 * List Fax Tags
 *
 * The agency's own tags, for the picker to search.
 */
export const listFaxTagsFaxClassificationTagsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListFaxTagsFaxClassificationTagsGetData, ThrowOnError>
): RequestResult<
  ListFaxTagsFaxClassificationTagsGetResponses,
  ListFaxTagsFaxClassificationTagsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListFaxTagsFaxClassificationTagsGetResponses,
    ListFaxTagsFaxClassificationTagsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/fax-classification/tags',
    ...options,
  });

/**
 * Create Fax Tag
 *
 * Add a tag, from the same picker that applies it.
 *
 * An existing tag is returned rather than refused, because somebody typing a
 * name that already exists means the same thing by it, and a 409 in the
 * middle of labelling a fax is an obstacle rather than information.
 */
export const createFaxTagFaxClassificationTagsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateFaxTagFaxClassificationTagsPostData, ThrowOnError>
): RequestResult<
  CreateFaxTagFaxClassificationTagsPostResponses,
  CreateFaxTagFaxClassificationTagsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateFaxTagFaxClassificationTagsPostResponses,
    CreateFaxTagFaxClassificationTagsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/fax-classification/tags',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Fax Tag
 *
 * Remove a tag the agency no longer uses.
 *
 * Refused while it is still on something, rather than silently unlabelling
 * those faxes: somebody filtering on it would quietly stop finding them.
 */
export const deleteFaxTagFaxClassificationTagsTagIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteFaxTagFaxClassificationTagsTagIdDeleteData,
    ThrowOnError
  >
): RequestResult<
  DeleteFaxTagFaxClassificationTagsTagIdDeleteResponses,
  DeleteFaxTagFaxClassificationTagsTagIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteFaxTagFaxClassificationTagsTagIdDeleteResponses,
    DeleteFaxTagFaxClassificationTagsTagIdDeleteErrors,
    ThrowOnError
  >({ url: '/fax-classification/tags/{tag_id}', ...options });

/**
 * List Patient Admissions
 *
 * That patient's admissions, newest first, for the second picker.
 *
 * Agency scoping is the ambient filter's: Admission carries it, so a patient
 * id from another agency simply returns nothing rather than being refused,
 * which is the same answer as a patient with no admissions and tells a
 * caller nothing either way.
 */
export const listPatientAdmissionsFaxClassificationPatientsPatientIdAdmissionsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ListPatientAdmissionsFaxClassificationPatientsPatientIdAdmissionsGetData,
      ThrowOnError
    >
  ): RequestResult<
    ListPatientAdmissionsFaxClassificationPatientsPatientIdAdmissionsGetResponses,
    ListPatientAdmissionsFaxClassificationPatientsPatientIdAdmissionsGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      ListPatientAdmissionsFaxClassificationPatientsPatientIdAdmissionsGetResponses,
      ListPatientAdmissionsFaxClassificationPatientsPatientIdAdmissionsGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/fax-classification/patients/{patient_id}/admissions',
      ...options,
    });

/**
 * Remove Fax
 *
 * Take a fax out of the inbox.
 *
 * A date rather than a delete. Somebody needs to clear a junk fax out of the
 * working list, an advert or a misdial or a duplicate, and none of that is a
 * reason to destroy the record of what a sender transmitted or to break the
 * provenance of a document already built from it.
 */
export const removeFaxFaxClassificationKindItemIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RemoveFaxFaxClassificationKindItemIdDeleteData, ThrowOnError>
): RequestResult<
  RemoveFaxFaxClassificationKindItemIdDeleteResponses,
  RemoveFaxFaxClassificationKindItemIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    RemoveFaxFaxClassificationKindItemIdDeleteResponses,
    RemoveFaxFaxClassificationKindItemIdDeleteErrors,
    ThrowOnError
  >({ url: '/fax-classification/{kind}/{item_id}', ...options });

/**
 * Set Classification
 *
 * Say what a row is, label it, and whose it is.
 */
export const setClassificationFaxClassificationKindItemIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SetClassificationFaxClassificationKindItemIdPutData,
    ThrowOnError
  >
): RequestResult<
  SetClassificationFaxClassificationKindItemIdPutResponses,
  SetClassificationFaxClassificationKindItemIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    SetClassificationFaxClassificationKindItemIdPutResponses,
    SetClassificationFaxClassificationKindItemIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/fax-classification/{kind}/{item_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove Many Faxes
 *
 * Take several faxes out of the inbox at once.
 *
 * All or nothing. Clearing a screenful of junk is one decision, and a
 * partial result would leave somebody reading a list to work out which half
 * went, which is worse than being told to try again.
 *
 * A row that was already removed is counted but not restamped, so a repeated
 * request is harmless and the date stays the one somebody will be asked
 * about.
 */
export const removeManyFaxesFaxClassificationRemovePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RemoveManyFaxesFaxClassificationRemovePostData, ThrowOnError>
): RequestResult<
  RemoveManyFaxesFaxClassificationRemovePostResponses,
  RemoveManyFaxesFaxClassificationRemovePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RemoveManyFaxesFaxClassificationRemovePostResponses,
    RemoveManyFaxesFaxClassificationRemovePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/fax-classification/remove',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Route Episodes
 *
 * The patient's episodes a fax could be filed to, newest first.
 */
export const listRouteEpisodesFaxRoutingPatientsPatientIdEpisodesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListRouteEpisodesFaxRoutingPatientsPatientIdEpisodesGetData,
    ThrowOnError
  >
): RequestResult<
  ListRouteEpisodesFaxRoutingPatientsPatientIdEpisodesGetResponses,
  ListRouteEpisodesFaxRoutingPatientsPatientIdEpisodesGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListRouteEpisodesFaxRoutingPatientsPatientIdEpisodesGetResponses,
    ListRouteEpisodesFaxRoutingPatientsPatientIdEpisodesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/fax-routing/patients/{patient_id}/episodes',
    ...options,
  });

/**
 * List Route Tasks
 *
 * The episode's tasks, newest first, and where this type goes by default.
 */
export const listRouteTasksFaxRoutingEpisodesEpisodeIdTasksGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListRouteTasksFaxRoutingEpisodesEpisodeIdTasksGetData,
    ThrowOnError
  >
): RequestResult<
  ListRouteTasksFaxRoutingEpisodesEpisodeIdTasksGetResponses,
  ListRouteTasksFaxRoutingEpisodesEpisodeIdTasksGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListRouteTasksFaxRoutingEpisodesEpisodeIdTasksGetResponses,
    ListRouteTasksFaxRoutingEpisodesEpisodeIdTasksGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/fax-routing/episodes/{episode_id}/tasks',
    ...options,
  });

/**
 * Route Fax Item
 *
 * File the fax onto a task of the episode, existing or new.
 *
 * Repeating a filing that already happened answers with it and files
 * nothing more; asking for a different task once filed is a 409.
 */
export const routeFaxItemFaxRoutingKindItemIdRoutePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RouteFaxItemFaxRoutingKindItemIdRoutePostData, ThrowOnError>
): RequestResult<
  RouteFaxItemFaxRoutingKindItemIdRoutePostResponses,
  RouteFaxItemFaxRoutingKindItemIdRoutePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RouteFaxItemFaxRoutingKindItemIdRoutePostResponses,
    RouteFaxItemFaxRoutingKindItemIdRoutePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/fax-routing/{kind}/{item_id}/route',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Unarchive Fax Item
 *
 * Put an archived fax back in the working list.
 */
export const unarchiveFaxItemFaxRoutingKindItemIdArchiveDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UnarchiveFaxItemFaxRoutingKindItemIdArchiveDeleteData,
    ThrowOnError
  >
): RequestResult<
  UnarchiveFaxItemFaxRoutingKindItemIdArchiveDeleteResponses,
  UnarchiveFaxItemFaxRoutingKindItemIdArchiveDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    UnarchiveFaxItemFaxRoutingKindItemIdArchiveDeleteResponses,
    UnarchiveFaxItemFaxRoutingKindItemIdArchiveDeleteErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/fax-routing/{kind}/{item_id}/archive',
    ...options,
  });

/**
 * Archive Fax Item
 *
 * Take the fax out of the working list without filing it.
 */
export const archiveFaxItemFaxRoutingKindItemIdArchivePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ArchiveFaxItemFaxRoutingKindItemIdArchivePostData,
    ThrowOnError
  >
): RequestResult<
  ArchiveFaxItemFaxRoutingKindItemIdArchivePostResponses,
  ArchiveFaxItemFaxRoutingKindItemIdArchivePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ArchiveFaxItemFaxRoutingKindItemIdArchivePostResponses,
    ArchiveFaxItemFaxRoutingKindItemIdArchivePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/fax-routing/{kind}/{item_id}/archive',
    ...options,
  });

/**
 * List Fax Route Settings
 *
 * Every fax type with Roger's default and the agency's choice, if any.
 */
export const listFaxRouteSettingsFaxRouteSettingsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListFaxRouteSettingsFaxRouteSettingsGetData, ThrowOnError>
): RequestResult<
  ListFaxRouteSettingsFaxRouteSettingsGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListFaxRouteSettingsFaxRouteSettingsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/fax-route-settings',
    ...options,
  });

/**
 * Reset Fax Route Override
 *
 * Go back to Roger's default for a fax type, retired or not.
 */
export const resetFaxRouteOverrideFaxRouteSettingsFaxTypeIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResetFaxRouteOverrideFaxRouteSettingsFaxTypeIdDeleteData,
    ThrowOnError
  >
): RequestResult<
  ResetFaxRouteOverrideFaxRouteSettingsFaxTypeIdDeleteResponses,
  ResetFaxRouteOverrideFaxRouteSettingsFaxTypeIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    ResetFaxRouteOverrideFaxRouteSettingsFaxTypeIdDeleteResponses,
    ResetFaxRouteOverrideFaxRouteSettingsFaxTypeIdDeleteErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/fax-route-settings/{fax_type_id}',
    ...options,
  });

/**
 * Save Fax Route Override
 *
 * Choose where faxes of an active type are filed for this agency.
 */
export const saveFaxRouteOverrideFaxRouteSettingsFaxTypeIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SaveFaxRouteOverrideFaxRouteSettingsFaxTypeIdPutData,
    ThrowOnError
  >
): RequestResult<
  SaveFaxRouteOverrideFaxRouteSettingsFaxTypeIdPutResponses,
  SaveFaxRouteOverrideFaxRouteSettingsFaxTypeIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    SaveFaxRouteOverrideFaxRouteSettingsFaxTypeIdPutResponses,
    SaveFaxRouteOverrideFaxRouteSettingsFaxTypeIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/fax-route-settings/{fax_type_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Merge Candidates
 *
 * Every account this agency knows, to pick the two to merge from.
 */
export const listMergeCandidatesInternalToolsAgenciesAgencyIdUsersMergeCandidatesGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ListMergeCandidatesInternalToolsAgenciesAgencyIdUsersMergeCandidatesGetData,
      ThrowOnError
    >
  ): RequestResult<
    ListMergeCandidatesInternalToolsAgenciesAgencyIdUsersMergeCandidatesGetResponses,
    ListMergeCandidatesInternalToolsAgenciesAgencyIdUsersMergeCandidatesGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      ListMergeCandidatesInternalToolsAgenciesAgencyIdUsersMergeCandidatesGetResponses,
      ListMergeCandidatesInternalToolsAgenciesAgencyIdUsersMergeCandidatesGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal-tools/agencies/{agency_id}/users/merge-candidates',
      ...options,
    });

/**
 * Preview Merge
 *
 * What merging the source into the target would do now, and its token.
 */
export const previewMergeInternalToolsAgenciesAgencyIdUsersMergePreviewGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PreviewMergeInternalToolsAgenciesAgencyIdUsersMergePreviewGetData,
    ThrowOnError
  >
): RequestResult<
  PreviewMergeInternalToolsAgenciesAgencyIdUsersMergePreviewGetResponses,
  PreviewMergeInternalToolsAgenciesAgencyIdUsersMergePreviewGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    PreviewMergeInternalToolsAgenciesAgencyIdUsersMergePreviewGetResponses,
    PreviewMergeInternalToolsAgenciesAgencyIdUsersMergePreviewGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/agencies/{agency_id}/users/merge-preview',
    ...options,
  });

/**
 * Merge Accounts
 *
 * Merge as previewed, commit, then move the RogerDoc account links.
 *
 * Confirming a pair merged before sweeps it again and answers with that merge.
 */
export const mergeAccountsInternalToolsAgenciesAgencyIdUsersMergePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MergeAccountsInternalToolsAgenciesAgencyIdUsersMergePostData,
    ThrowOnError
  >
): RequestResult<
  MergeAccountsInternalToolsAgenciesAgencyIdUsersMergePostResponses,
  MergeAccountsInternalToolsAgenciesAgencyIdUsersMergePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    MergeAccountsInternalToolsAgenciesAgencyIdUsersMergePostResponses,
    MergeAccountsInternalToolsAgenciesAgencyIdUsersMergePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/agencies/{agency_id}/users/merge',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Merges
 *
 * Every merge in this agency, newest first.
 */
export const listMergesInternalToolsAgenciesAgencyIdUsersMergesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListMergesInternalToolsAgenciesAgencyIdUsersMergesGetData,
    ThrowOnError
  >
): RequestResult<
  ListMergesInternalToolsAgenciesAgencyIdUsersMergesGetResponses,
  ListMergesInternalToolsAgenciesAgencyIdUsersMergesGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListMergesInternalToolsAgenciesAgencyIdUsersMergesGetResponses,
    ListMergesInternalToolsAgenciesAgencyIdUsersMergesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/agencies/{agency_id}/users/merges',
    ...options,
  });

/**
 * Retry Merge Steps
 *
 * Move the RogerDoc account links a merge or a reversal still owes.
 */
export const retryMergeStepsInternalToolsAgenciesAgencyIdUsersMergesMergeIdRetryPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      RetryMergeStepsInternalToolsAgenciesAgencyIdUsersMergesMergeIdRetryPostData,
      ThrowOnError
    >
  ): RequestResult<
    RetryMergeStepsInternalToolsAgenciesAgencyIdUsersMergesMergeIdRetryPostResponses,
    RetryMergeStepsInternalToolsAgenciesAgencyIdUsersMergesMergeIdRetryPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      RetryMergeStepsInternalToolsAgenciesAgencyIdUsersMergesMergeIdRetryPostResponses,
      RetryMergeStepsInternalToolsAgenciesAgencyIdUsersMergesMergeIdRetryPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal-tools/agencies/{agency_id}/users/merges/{merge_id}/retry',
      ...options,
    });

/**
 * Reverse Merge
 *
 * Put back what the merge moved, commit, then move RogerDoc links back.
 */
export const reverseMergeInternalToolsAgenciesAgencyIdUsersMergesMergeIdReversePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ReverseMergeInternalToolsAgenciesAgencyIdUsersMergesMergeIdReversePostData,
      ThrowOnError
    >
  ): RequestResult<
    ReverseMergeInternalToolsAgenciesAgencyIdUsersMergesMergeIdReversePostResponses,
    ReverseMergeInternalToolsAgenciesAgencyIdUsersMergesMergeIdReversePostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      ReverseMergeInternalToolsAgenciesAgencyIdUsersMergesMergeIdReversePostResponses,
      ReverseMergeInternalToolsAgenciesAgencyIdUsersMergesMergeIdReversePostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal-tools/agencies/{agency_id}/users/merges/{merge_id}/reverse',
      ...options,
    });

/**
 * Get Agencies
 *
 * List all agencies (Internal Tools only).
 */
export const getAgenciesInternalToolsAgenciesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetAgenciesInternalToolsAgenciesGetData, ThrowOnError>
): RequestResult<
  GetAgenciesInternalToolsAgenciesGetResponses,
  GetAgenciesInternalToolsAgenciesGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetAgenciesInternalToolsAgenciesGetResponses,
    GetAgenciesInternalToolsAgenciesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/agencies/',
    ...options,
  });

/**
 * Create Agency
 *
 * Create a new agency.
 *
 * Only allowed when the caller is a Strawhat super-user (router-level).
 */
export const createAgencyInternalToolsAgenciesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateAgencyInternalToolsAgenciesPostData, ThrowOnError>
): RequestResult<
  CreateAgencyInternalToolsAgenciesPostResponses,
  CreateAgencyInternalToolsAgenciesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateAgencyInternalToolsAgenciesPostResponses,
    CreateAgencyInternalToolsAgenciesPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/agencies/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Agencies With Assigned Roles
 *
 * Paginated list of agencies for the Internal Tools admin view.
 */
export const listAgenciesWithAssignedRolesInternalToolsAgenciesWithAssignedRolesGet =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      ListAgenciesWithAssignedRolesInternalToolsAgenciesWithAssignedRolesGetData,
      ThrowOnError
    >
  ): RequestResult<
    ListAgenciesWithAssignedRolesInternalToolsAgenciesWithAssignedRolesGetResponses,
    ListAgenciesWithAssignedRolesInternalToolsAgenciesWithAssignedRolesGetErrors,
    ThrowOnError
  > =>
    (options?.client ?? client).get<
      ListAgenciesWithAssignedRolesInternalToolsAgenciesWithAssignedRolesGetResponses,
      ListAgenciesWithAssignedRolesInternalToolsAgenciesWithAssignedRolesGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal-tools/agencies/with-assigned-roles',
      ...options,
    });

/**
 * Update Agency Timezone
 *
 * Set an agency's IANA timezone (Strawhat super-user only, router-level).
 */
export const updateAgencyTimezoneInternalToolsAgenciesAgencyIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateAgencyTimezoneInternalToolsAgenciesAgencyIdPatchData,
    ThrowOnError
  >
): RequestResult<
  UpdateAgencyTimezoneInternalToolsAgenciesAgencyIdPatchResponses,
  UpdateAgencyTimezoneInternalToolsAgenciesAgencyIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateAgencyTimezoneInternalToolsAgenciesAgencyIdPatchResponses,
    UpdateAgencyTimezoneInternalToolsAgenciesAgencyIdPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/agencies/{agency_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove User From Agency
 *
 * Remove a user from an agency: deactivate the membership, strip access.
 *
 * Removing is deactivating. The ``user_agencies`` row is kept, so the record
 * that the person belonged here survives and the User Manager can bring them
 * back (to an empty membership). Their roles and clinic links at the agency
 * are soft-deleted and their WorkOS membership is removed.
 */
export const removeUserFromAgencyInternalToolsAgenciesAgencyIdUsersUserIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      RemoveUserFromAgencyInternalToolsAgenciesAgencyIdUsersUserIdDeleteData,
      ThrowOnError
    >
  ): RequestResult<
    RemoveUserFromAgencyInternalToolsAgenciesAgencyIdUsersUserIdDeleteResponses,
    RemoveUserFromAgencyInternalToolsAgenciesAgencyIdUsersUserIdDeleteErrors,
    ThrowOnError
  > =>
    (options.client ?? client).delete<
      RemoveUserFromAgencyInternalToolsAgenciesAgencyIdUsersUserIdDeleteResponses,
      RemoveUserFromAgencyInternalToolsAgenciesAgencyIdUsersUserIdDeleteErrors,
      ThrowOnError
    >({
      url: '/internal-tools/agencies/{agency_id}/users/{user_id}',
      ...options,
    });

/**
 * List Agency Clinics
 *
 * The clinics of one agency, for staff acting on that agency's behalf.
 *
 * The ordinary ``/agency-clinics`` route answers for the caller's own agency,
 * which for Roger staff is Strawhat, so it can never list the agency being
 * worked on. This opts out of the automatic tenant filter for the same reason
 * and bounds the read by the agency in the path instead.
 */
export const listAgencyClinicsInternalToolsAgenciesAgencyIdClinicsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListAgencyClinicsInternalToolsAgenciesAgencyIdClinicsGetData,
    ThrowOnError
  >
): RequestResult<
  ListAgencyClinicsInternalToolsAgenciesAgencyIdClinicsGetResponses,
  ListAgencyClinicsInternalToolsAgenciesAgencyIdClinicsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListAgencyClinicsInternalToolsAgenciesAgencyIdClinicsGetResponses,
    ListAgencyClinicsInternalToolsAgenciesAgencyIdClinicsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/agencies/{agency_id}/clinics',
    ...options,
  });

/**
 * List Directory Agencies
 *
 * Every customer agency, for the agency filter.
 */
export const listDirectoryAgenciesInternalToolsClinicianDirectoryAgenciesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ListDirectoryAgenciesInternalToolsClinicianDirectoryAgenciesGetData,
    ThrowOnError
  >
): RequestResult<
  ListDirectoryAgenciesInternalToolsClinicianDirectoryAgenciesGetResponses,
  ListDirectoryAgenciesInternalToolsClinicianDirectoryAgenciesGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListDirectoryAgenciesInternalToolsClinicianDirectoryAgenciesGetResponses,
    ListDirectoryAgenciesInternalToolsClinicianDirectoryAgenciesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/clinician-directory/agencies',
    ...options,
  });

/**
 * List Clinician Directory
 *
 * One page of clinician logins; no agency ids means every agency.
 */
export const listClinicianDirectoryInternalToolsClinicianDirectoryGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ListClinicianDirectoryInternalToolsClinicianDirectoryGetData,
    ThrowOnError
  >
): RequestResult<
  ListClinicianDirectoryInternalToolsClinicianDirectoryGetResponses,
  ListClinicianDirectoryInternalToolsClinicianDirectoryGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListClinicianDirectoryInternalToolsClinicianDirectoryGetResponses,
    ListClinicianDirectoryInternalToolsClinicianDirectoryGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/clinician-directory',
    ...options,
  });

/**
 * Export Clinician Directory
 *
 * The whole filtered directory as CSV, from one Docs snapshot.
 */
export const exportClinicianDirectoryInternalToolsClinicianDirectoryExportCsvGet =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      ExportClinicianDirectoryInternalToolsClinicianDirectoryExportCsvGetData,
      ThrowOnError
    >
  ): RequestResult<
    ExportClinicianDirectoryInternalToolsClinicianDirectoryExportCsvGetResponses,
    ExportClinicianDirectoryInternalToolsClinicianDirectoryExportCsvGetErrors,
    ThrowOnError
  > =>
    (options?.client ?? client).get<
      ExportClinicianDirectoryInternalToolsClinicianDirectoryExportCsvGetResponses,
      ExportClinicianDirectoryInternalToolsClinicianDirectoryExportCsvGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal-tools/clinician-directory/export.csv',
      ...options,
    });

/**
 * Deliver Direct Fax
 *
 * Place one or more PDFs in an agency's inbox as though faxed there.
 *
 * Several files are one transmission carrying several attachments, in the
 * order given, which is what a real multi-document fax looks like: one row
 * in the inbox, one ``received_fax_documents`` row per attachment. Sending
 * them as separate faxes would misrepresent what arrived.
 *
 * Leaving the agency off parks the fax in the unassigned queue, which is
 * otherwise only reachable by a real fax arriving on an extension nobody has
 * mapped, and so was the one screen that could not be exercised at all.
 *
 * Naming the extension it arrived on is what makes that parked fax behave
 * like one. The queue keys on it, and so does the offer to collect a backlog
 * when somebody finally maps that extension; without it a placed fax is
 * parked but unreachable by either.
 */
export const deliverDirectFaxInternalToolsDirectFaxesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeliverDirectFaxInternalToolsDirectFaxesPostData,
    ThrowOnError
  >
): RequestResult<
  DeliverDirectFaxInternalToolsDirectFaxesPostResponses,
  DeliverDirectFaxInternalToolsDirectFaxesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DeliverDirectFaxInternalToolsDirectFaxesPostResponses,
    DeliverDirectFaxInternalToolsDirectFaxesPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/internal-tools/direct-faxes',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Search Evv Correction Visits
 */
export const searchEvvCorrectionVisitsInternalToolsEvvCorrectionsVisitsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SearchEvvCorrectionVisitsInternalToolsEvvCorrectionsVisitsGetData,
    ThrowOnError
  >
): RequestResult<
  SearchEvvCorrectionVisitsInternalToolsEvvCorrectionsVisitsGetResponses,
  SearchEvvCorrectionVisitsInternalToolsEvvCorrectionsVisitsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    SearchEvvCorrectionVisitsInternalToolsEvvCorrectionsVisitsGetResponses,
    SearchEvvCorrectionVisitsInternalToolsEvvCorrectionsVisitsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/evv-corrections/visits',
    ...options,
  });

/**
 * Preview Evv Correction
 */
export const previewEvvCorrectionInternalToolsEvvCorrectionsPreviewGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PreviewEvvCorrectionInternalToolsEvvCorrectionsPreviewGetData,
    ThrowOnError
  >
): RequestResult<
  PreviewEvvCorrectionInternalToolsEvvCorrectionsPreviewGetResponses,
  PreviewEvvCorrectionInternalToolsEvvCorrectionsPreviewGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    PreviewEvvCorrectionInternalToolsEvvCorrectionsPreviewGetResponses,
    PreviewEvvCorrectionInternalToolsEvvCorrectionsPreviewGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/evv-corrections/preview',
    ...options,
  });

/**
 * Delete Evv Correction
 */
export const deleteEvvCorrectionInternalToolsEvvCorrectionsDeletePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteEvvCorrectionInternalToolsEvvCorrectionsDeletePostData,
    ThrowOnError
  >
): RequestResult<
  DeleteEvvCorrectionInternalToolsEvvCorrectionsDeletePostResponses,
  DeleteEvvCorrectionInternalToolsEvvCorrectionsDeletePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DeleteEvvCorrectionInternalToolsEvvCorrectionsDeletePostResponses,
    DeleteEvvCorrectionInternalToolsEvvCorrectionsDeletePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/evv-corrections/delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Retry Evv Correction
 */
export const retryEvvCorrectionInternalToolsEvvCorrectionsRetryRequestIdPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RetryEvvCorrectionInternalToolsEvvCorrectionsRetryRequestIdPostData,
    ThrowOnError
  >
): RequestResult<
  RetryEvvCorrectionInternalToolsEvvCorrectionsRetryRequestIdPostResponses,
  RetryEvvCorrectionInternalToolsEvvCorrectionsRetryRequestIdPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RetryEvvCorrectionInternalToolsEvvCorrectionsRetryRequestIdPostResponses,
    RetryEvvCorrectionInternalToolsEvvCorrectionsRetryRequestIdPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/evv-corrections/retry/{request_id}',
    ...options,
  });

/**
 * Verify Evv Correction
 */
export const verifyEvvCorrectionInternalToolsEvvCorrectionsVerifyPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    VerifyEvvCorrectionInternalToolsEvvCorrectionsVerifyPostData,
    ThrowOnError
  >
): RequestResult<
  VerifyEvvCorrectionInternalToolsEvvCorrectionsVerifyPostResponses,
  VerifyEvvCorrectionInternalToolsEvvCorrectionsVerifyPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    VerifyEvvCorrectionInternalToolsEvvCorrectionsVerifyPostResponses,
    VerifyEvvCorrectionInternalToolsEvvCorrectionsVerifyPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/evv-corrections/verify',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Fax Number Mappings
 *
 * Every mapping, so an operator can see what an extension resolves to.
 */
export const listFaxNumberMappingsInternalToolsFaxNumberMappingsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ListFaxNumberMappingsInternalToolsFaxNumberMappingsGetData,
    ThrowOnError
  >
): RequestResult<
  ListFaxNumberMappingsInternalToolsFaxNumberMappingsGetResponses,
  ListFaxNumberMappingsInternalToolsFaxNumberMappingsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListFaxNumberMappingsInternalToolsFaxNumberMappingsGetResponses,
    ListFaxNumberMappingsInternalToolsFaxNumberMappingsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/fax-number-mappings',
    ...options,
  });

/**
 * Create Fax Number Mapping
 *
 * Point an extension at an agency, and optionally clear its backlog.
 *
 * The two halves of the same problem: the mapping stops faxes parking, and
 * claiming collects the ones that parked before it existed. They share one
 * transaction so a mapping never lands having moved somebody's referrals
 * while failing itself, or the reverse.
 */
export const createFaxNumberMappingInternalToolsFaxNumberMappingsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateFaxNumberMappingInternalToolsFaxNumberMappingsPostData,
    ThrowOnError
  >
): RequestResult<
  CreateFaxNumberMappingInternalToolsFaxNumberMappingsPostResponses,
  CreateFaxNumberMappingInternalToolsFaxNumberMappingsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateFaxNumberMappingInternalToolsFaxNumberMappingsPostResponses,
    CreateFaxNumberMappingInternalToolsFaxNumberMappingsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/fax-number-mappings',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Fax Number Mapping
 *
 * Repoint a mapping in place.
 *
 * Preferred over deactivating and adding a replacement: the audit shadow then
 * carries the change as one history, rather than leaving a retired row that
 * later reads like a second mapping for the same extension.
 */
export const updateFaxNumberMappingInternalToolsFaxNumberMappingsMappingIdPatch =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdateFaxNumberMappingInternalToolsFaxNumberMappingsMappingIdPatchData,
      ThrowOnError
    >
  ): RequestResult<
    UpdateFaxNumberMappingInternalToolsFaxNumberMappingsMappingIdPatchResponses,
    UpdateFaxNumberMappingInternalToolsFaxNumberMappingsMappingIdPatchErrors,
    ThrowOnError
  > =>
    (options.client ?? client).patch<
      UpdateFaxNumberMappingInternalToolsFaxNumberMappingsMappingIdPatchResponses,
      UpdateFaxNumberMappingInternalToolsFaxNumberMappingsMappingIdPatchErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal-tools/fax-number-mappings/{mapping_id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * List Agency Fax Numbers
 *
 * Every agency that has a fax number, with the numbers routed to it.
 *
 * Reads only our own tables. Listing RingCentral's numbers is a separate
 * call, because this screen is opened far more often than the account
 * changes and the account allows only a few auth calls a minute.
 */
export const listAgencyFaxNumbersInternalToolsFaxNumbersGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ListAgencyFaxNumbersInternalToolsFaxNumbersGetData,
    ThrowOnError
  >
): RequestResult<
  ListAgencyFaxNumbersInternalToolsFaxNumbersGetResponses,
  ListAgencyFaxNumbersInternalToolsFaxNumbersGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListAgencyFaxNumbersInternalToolsFaxNumbersGetResponses,
    ListAgencyFaxNumbersInternalToolsFaxNumbersGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/fax-numbers',
    ...options,
  });

/**
 * List Ringcentral Inventory
 *
 * The account's extensions and numbers, marked with who already claims them.
 *
 * Two RingCentral reads, which is why this is its own route rather than part
 * of the agency listing: that screen is opened far more often than the
 * account changes, and the account allows only a few auth calls a minute.
 *
 * Reading is all our application is permitted to do here, so an extension
 * appears only once somebody has created it in the RingCentral console. An
 * empty list is therefore a real answer and not an error.
 */
export const listRingcentralInventoryInternalToolsFaxNumbersRingcentralGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ListRingcentralInventoryInternalToolsFaxNumbersRingcentralGetData,
    ThrowOnError
  >
): RequestResult<
  ListRingcentralInventoryInternalToolsFaxNumbersRingcentralGetResponses,
  ListRingcentralInventoryInternalToolsFaxNumbersRingcentralGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListRingcentralInventoryInternalToolsFaxNumbersRingcentralGetResponses,
    ListRingcentralInventoryInternalToolsFaxNumbersRingcentralGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/fax-numbers/ringcentral',
    ...options,
  });

/**
 * Provision Fax Number
 *
 * Create an extension, buy a number for it, and route it to the agency.
 *
 * Refused unless this stage may buy, which is off everywhere until somebody
 * turns it on deliberately. The steps run in an order chosen so a failure
 * leaves the least mess: the extension first, because an extension without a
 * number costs a seat and is reusable, then the number, then the binding,
 * then our own mapping. A number acquired but not bound is visible in the
 * account listing, which is the state an operator can finish by hand.
 */
export const provisionFaxNumberInternalToolsFaxNumbersProvisionPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ProvisionFaxNumberInternalToolsFaxNumbersProvisionPostData,
    ThrowOnError
  >
): RequestResult<
  ProvisionFaxNumberInternalToolsFaxNumbersProvisionPostResponses,
  ProvisionFaxNumberInternalToolsFaxNumbersProvisionPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ProvisionFaxNumberInternalToolsFaxNumbersProvisionPostResponses,
    ProvisionFaxNumberInternalToolsFaxNumbersProvisionPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/fax-numbers/provision',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Fax Types
 *
 * Every type, retired ones included, in the order agencies see them.
 */
export const listFaxTypesInternalToolsFaxTypesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListFaxTypesInternalToolsFaxTypesGetData, ThrowOnError>
): RequestResult<
  ListFaxTypesInternalToolsFaxTypesGetResponses,
  ListFaxTypesInternalToolsFaxTypesGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListFaxTypesInternalToolsFaxTypesGetResponses,
    ListFaxTypesInternalToolsFaxTypesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/fax-types',
    ...options,
  });

/**
 * Create Fax Type
 *
 * Add a type to the list every agency picks from.
 */
export const createFaxTypeInternalToolsFaxTypesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateFaxTypeInternalToolsFaxTypesPostData, ThrowOnError>
): RequestResult<
  CreateFaxTypeInternalToolsFaxTypesPostResponses,
  CreateFaxTypeInternalToolsFaxTypesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateFaxTypeInternalToolsFaxTypesPostResponses,
    CreateFaxTypeInternalToolsFaxTypesPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/fax-types',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Fax Type
 *
 * Rename a type, move it in the list, or retire it.
 *
 * Retiring rather than deleting is the only way out: faxes already filed
 * under a type still have to say what they are, so the row stays and simply
 * stops being offered.
 */
export const updateFaxTypeInternalToolsFaxTypesFaxTypeIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateFaxTypeInternalToolsFaxTypesFaxTypeIdPatchData,
    ThrowOnError
  >
): RequestResult<
  UpdateFaxTypeInternalToolsFaxTypesFaxTypeIdPatchResponses,
  UpdateFaxTypeInternalToolsFaxTypesFaxTypeIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateFaxTypeInternalToolsFaxTypesFaxTypeIdPatchResponses,
    UpdateFaxTypeInternalToolsFaxTypesFaxTypeIdPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/fax-types/{fax_type_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Kinnser Field Rules
 *
 * What a sync does to each field, for the screen's legend and its marks.
 */
export const getKinnserFieldRulesInternalToolsKinnserAgencySyncFieldRulesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetKinnserFieldRulesInternalToolsKinnserAgencySyncFieldRulesGetData,
    ThrowOnError
  >
): RequestResult<
  GetKinnserFieldRulesInternalToolsKinnserAgencySyncFieldRulesGetResponses,
  GetKinnserFieldRulesInternalToolsKinnserAgencySyncFieldRulesGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetKinnserFieldRulesInternalToolsKinnserAgencySyncFieldRulesGetResponses,
    GetKinnserFieldRulesInternalToolsKinnserAgencySyncFieldRulesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/kinnser-agency-sync/field-rules',
    ...options,
  });

/**
 * List Kinnser Sync Agencies
 *
 * Every agency, with what the last fetch and apply did.
 *
 * Every agency, not only the Kinnser ones. An agency Kinnser is off for has
 * nothing to read here, and leaving it out made that look exactly like "no
 * such agency" to somebody searching the list for it. The row says so
 * instead, through ``kinnser_enabled``.
 *
 * Reads the record without its snapshot, so the list stays cheap however large
 * the stored payloads are.
 */
export const listKinnserSyncAgenciesInternalToolsKinnserAgencySyncAgenciesGet =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      ListKinnserSyncAgenciesInternalToolsKinnserAgencySyncAgenciesGetData,
      ThrowOnError
    >
  ): RequestResult<
    ListKinnserSyncAgenciesInternalToolsKinnserAgencySyncAgenciesGetResponses,
    ListKinnserSyncAgenciesInternalToolsKinnserAgencySyncAgenciesGetErrors,
    ThrowOnError
  > =>
    (options?.client ?? client).get<
      ListKinnserSyncAgenciesInternalToolsKinnserAgencySyncAgenciesGetResponses,
      ListKinnserSyncAgenciesInternalToolsKinnserAgencySyncAgenciesGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal-tools/kinnser-agency-sync/agencies',
      ...options,
    });

/**
 * Get Kinnser Sync Status
 *
 * When this agency was last fetched and applied, and what is corrected.
 */
export const getKinnserSyncStatusInternalToolsKinnserAgencySyncAgenciesAgencyIdGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetKinnserSyncStatusInternalToolsKinnserAgencySyncAgenciesAgencyIdGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetKinnserSyncStatusInternalToolsKinnserAgencySyncAgenciesAgencyIdGetResponses,
    GetKinnserSyncStatusInternalToolsKinnserAgencySyncAgenciesAgencyIdGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetKinnserSyncStatusInternalToolsKinnserAgencySyncAgenciesAgencyIdGetResponses,
      GetKinnserSyncStatusInternalToolsKinnserAgencySyncAgenciesAgencyIdGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal-tools/kinnser-agency-sync/agencies/{agency_id}',
      ...options,
    });

/**
 * List Kinnser Agency Clinics
 *
 * The agency's own clinic rows, so the screen can show what Roger holds.
 *
 * A clinic's identity -- NPI, EIN, address, the CMS ids, the billing contact --
 * lives on its row, not on the sync record, so the screen reads it from here.
 * Deliberately not folded into the status: the list route loads that for every
 * agency at once and needs none of it.
 *
 * No limit. An agency with more than a hundred clinics must not have the rest
 * silently dropped from a screen whose job is showing what it holds.
 *
 * Sorted by name, because the grid draws one column per clinic and an
 * unordered read can reorder them between visits -- which breaks the one thing
 * the grid is for, reading three clinics across to see which value is wrong.
 *
 * The clinic filter narrows to the actor's own ``user_clinics``, and inside the
 * scope below there is no such set -- ``scoped_execution_context`` carries
 * none, which reads as unrestricted -- so every clinic of the named agency is
 * returned without asking for ``across_clinics``. That flag is for callers who
 * need the unnarrowed rows to compute a bound, and its docstring says not to
 * use it to hand clinic names back.
 */
export const listKinnserAgencyClinicsInternalToolsKinnserAgencySyncAgenciesAgencyIdClinicsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ListKinnserAgencyClinicsInternalToolsKinnserAgencySyncAgenciesAgencyIdClinicsGetData,
      ThrowOnError
    >
  ): RequestResult<
    ListKinnserAgencyClinicsInternalToolsKinnserAgencySyncAgenciesAgencyIdClinicsGetResponses,
    ListKinnserAgencyClinicsInternalToolsKinnserAgencySyncAgenciesAgencyIdClinicsGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      ListKinnserAgencyClinicsInternalToolsKinnserAgencySyncAgenciesAgencyIdClinicsGetResponses,
      ListKinnserAgencyClinicsInternalToolsKinnserAgencySyncAgenciesAgencyIdClinicsGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal-tools/kinnser-agency-sync/agencies/{agency_id}/clinics',
      ...options,
    });

/**
 * Set Kinnser Clinic Left Out
 *
 * Leave this Kinnser clinic out of the sync, or put it back.
 *
 * Works for a clinic Roger has no row for yet, because the decision is kept by
 * Kinnser clinic id rather than on the row.
 */
export const setKinnserClinicLeftOutInternalToolsKinnserAgencySyncAgenciesAgencyIdClinicsClinicKeyLeftOutPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      SetKinnserClinicLeftOutInternalToolsKinnserAgencySyncAgenciesAgencyIdClinicsClinicKeyLeftOutPutData,
      ThrowOnError
    >
  ): RequestResult<
    SetKinnserClinicLeftOutInternalToolsKinnserAgencySyncAgenciesAgencyIdClinicsClinicKeyLeftOutPutResponses,
    SetKinnserClinicLeftOutInternalToolsKinnserAgencySyncAgenciesAgencyIdClinicsClinicKeyLeftOutPutErrors,
    ThrowOnError
  > =>
    (options.client ?? client).put<
      SetKinnserClinicLeftOutInternalToolsKinnserAgencySyncAgenciesAgencyIdClinicsClinicKeyLeftOutPutResponses,
      SetKinnserClinicLeftOutInternalToolsKinnserAgencySyncAgenciesAgencyIdClinicsClinicKeyLeftOutPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal-tools/kinnser-agency-sync/agencies/{agency_id}/clinics/{clinic_key}/left-out',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Pull Kinnser Data
 *
 * Read this agency's Kinnser data and write it to the agency's tables.
 *
 * One request, because the two halves were never a decision an operator was
 * making. The nightly sync applies every agency's stored payload with no
 * per-agency opt-out, so a fill declined here happens that night anyway. What
 * the split did buy was a gap between "what Kinnser sent" and "what the agency
 * holds", which is what put two versions of every value on the screen.
 *
 * Nothing is reviewed in between because nothing needs to be: a value that
 * arrives wrong is corrected on the row afterwards, and a sync never replaces
 * a value that is already there.
 *
 * Every clinic left out is a 409 rather than a quiet no-op. The payload is
 * stored by then, so saying nothing would look exactly like a fill that
 * worked.
 */
export const pullKinnserDataInternalToolsKinnserAgencySyncAgenciesAgencyIdPullPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      PullKinnserDataInternalToolsKinnserAgencySyncAgenciesAgencyIdPullPostData,
      ThrowOnError
    >
  ): RequestResult<
    PullKinnserDataInternalToolsKinnserAgencySyncAgenciesAgencyIdPullPostResponses,
    PullKinnserDataInternalToolsKinnserAgencySyncAgenciesAgencyIdPullPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      PullKinnserDataInternalToolsKinnserAgencySyncAgenciesAgencyIdPullPostResponses,
      PullKinnserDataInternalToolsKinnserAgencySyncAgenciesAgencyIdPullPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal-tools/kinnser-agency-sync/agencies/{agency_id}/pull',
      ...options,
    });

/**
 * Write Kinnser Clinic Identity
 *
 * Write what an operator typed onto this clinic's own row.
 *
 * Not stored as a correction, because there is nothing for one to defend: a
 * sync fills a clinic's identity only where the column is blank and never
 * replaces a value already on the row, so a typed value is durable without a
 * second copy outranking the payload. Clearing a field is how you ask for
 * Kinnser's value back.
 *
 * Only the fields the request mentions are written. The grid saves one cell at
 * a time, so a body naming one column must not blank the other thirteen.
 *
 * 404 for a clinic Roger has no row for yet, with the same message as a clinic
 * that does not exist: the columns live on the row, so these values wait for
 * the first pull.
 *
 * Not ``PUT /agency-clinics/{id}``, which updates the same columns: that route
 * reads the caller's own ``ctx.agency``, and a Strawhat operator's own agency
 * is Strawhat rather than the one on screen. Its CRUD is what runs below.
 *
 * Answers with the clinic as it now stands, not the agency's sync record.
 * The screen needs the stored value back -- a typed "(512) 555-0142" lands as
 * "5125550142" -- and reading it from the response is what lets the cell
 * settle at once instead of waiting on a re-read of every clinic.
 */
export const writeKinnserClinicIdentityInternalToolsKinnserAgencySyncAgenciesAgencyIdClinicsClinicKeyIdentityPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      WriteKinnserClinicIdentityInternalToolsKinnserAgencySyncAgenciesAgencyIdClinicsClinicKeyIdentityPutData,
      ThrowOnError
    >
  ): RequestResult<
    WriteKinnserClinicIdentityInternalToolsKinnserAgencySyncAgenciesAgencyIdClinicsClinicKeyIdentityPutResponses,
    WriteKinnserClinicIdentityInternalToolsKinnserAgencySyncAgenciesAgencyIdClinicsClinicKeyIdentityPutErrors,
    ThrowOnError
  > =>
    (options.client ?? client).put<
      WriteKinnserClinicIdentityInternalToolsKinnserAgencySyncAgenciesAgencyIdClinicsClinicKeyIdentityPutResponses,
      WriteKinnserClinicIdentityInternalToolsKinnserAgencySyncAgenciesAgencyIdClinicsClinicKeyIdentityPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal-tools/kinnser-agency-sync/agencies/{agency_id}/clinics/{clinic_key}/identity',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Get Onboarding Team Config
 *
 * Return the current onboarding-team config.
 */
export const getOnboardingTeamConfigInternalToolsOnboardingTeamConfigGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetOnboardingTeamConfigInternalToolsOnboardingTeamConfigGetData,
    ThrowOnError
  >
): RequestResult<
  GetOnboardingTeamConfigInternalToolsOnboardingTeamConfigGetResponses,
  GetOnboardingTeamConfigInternalToolsOnboardingTeamConfigGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetOnboardingTeamConfigInternalToolsOnboardingTeamConfigGetResponses,
    GetOnboardingTeamConfigInternalToolsOnboardingTeamConfigGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/onboarding-team-config/',
    ...options,
  });

/**
 * Update Onboarding Team Config
 *
 * Replace the onboarding-team roster and per-member role slugs.
 */
export const updateOnboardingTeamConfigInternalToolsOnboardingTeamConfigPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateOnboardingTeamConfigInternalToolsOnboardingTeamConfigPutData,
    ThrowOnError
  >
): RequestResult<
  UpdateOnboardingTeamConfigInternalToolsOnboardingTeamConfigPutResponses,
  UpdateOnboardingTeamConfigInternalToolsOnboardingTeamConfigPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateOnboardingTeamConfigInternalToolsOnboardingTeamConfigPutResponses,
    UpdateOnboardingTeamConfigInternalToolsOnboardingTeamConfigPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/onboarding-team-config/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Sync Onboarding Team
 *
 * Add the current onboarding-team config to all existing agencies.
 */
export const syncOnboardingTeamInternalToolsOnboardingTeamConfigSyncPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    SyncOnboardingTeamInternalToolsOnboardingTeamConfigSyncPostData,
    ThrowOnError
  >
): RequestResult<
  SyncOnboardingTeamInternalToolsOnboardingTeamConfigSyncPostResponses,
  SyncOnboardingTeamInternalToolsOnboardingTeamConfigSyncPostErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    SyncOnboardingTeamInternalToolsOnboardingTeamConfigSyncPostResponses,
    SyncOnboardingTeamInternalToolsOnboardingTeamConfigSyncPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/onboarding-team-config/sync',
    ...options,
  });

/**
 * Send Fax
 *
 * Fax one or more PDFs to one number, as a single transmission.
 *
 * Several documents on purpose. A referral packet is a cover sheet, an order
 * and a face to face, and sending them one at a time arrives as three faxes
 * that the far end has to work out belong together. RingCentral takes several
 * attachments and sends them as one fax, which is what somebody means by
 * sending a packet.
 *
 * One recipient, still on purpose. RingCentral reports a single status for a
 * fax sent to several, so a fax that reached one of two reads as a failure,
 * and a resend would deliver it twice to whoever already had it.
 */
export const sendFaxInternalToolsOutboundFaxesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SendFaxInternalToolsOutboundFaxesPostData, ThrowOnError>
): RequestResult<
  SendFaxInternalToolsOutboundFaxesPostResponses,
  SendFaxInternalToolsOutboundFaxesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SendFaxInternalToolsOutboundFaxesPostResponses,
    SendFaxInternalToolsOutboundFaxesPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/internal-tools/outbound-faxes',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * List Payors
 *
 * Payors by name, matching on name or electronic payer id.
 */
export const listPayorsInternalToolsPayorsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListPayorsInternalToolsPayorsGetData, ThrowOnError>
): RequestResult<
  ListPayorsInternalToolsPayorsGetResponses,
  ListPayorsInternalToolsPayorsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListPayorsInternalToolsPayorsGetResponses,
    ListPayorsInternalToolsPayorsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/payors',
    ...options,
  });

/**
 * Update Payor Noa Settings
 *
 * Set the NOA rules every insurance linked to this payor follows.
 */
export const updatePayorNoaSettingsInternalToolsPayorsPayorIdNoaSettingsPatch =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdatePayorNoaSettingsInternalToolsPayorsPayorIdNoaSettingsPatchData,
      ThrowOnError
    >
  ): RequestResult<
    UpdatePayorNoaSettingsInternalToolsPayorsPayorIdNoaSettingsPatchResponses,
    UpdatePayorNoaSettingsInternalToolsPayorsPayorIdNoaSettingsPatchErrors,
    ThrowOnError
  > =>
    (options.client ?? client).patch<
      UpdatePayorNoaSettingsInternalToolsPayorsPayorIdNoaSettingsPatchResponses,
      UpdatePayorNoaSettingsInternalToolsPayorsPayorIdNoaSettingsPatchErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal-tools/payors/{payor_id}/noa-settings',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Get Payor Noa Settings History
 *
 * Every change to the payor's NOA rules: who, which rule, old to new, oldest first.
 */
export const getPayorNoaSettingsHistoryInternalToolsPayorsPayorIdNoaSettingsHistoryGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetPayorNoaSettingsHistoryInternalToolsPayorsPayorIdNoaSettingsHistoryGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetPayorNoaSettingsHistoryInternalToolsPayorsPayorIdNoaSettingsHistoryGetResponses,
    GetPayorNoaSettingsHistoryInternalToolsPayorsPayorIdNoaSettingsHistoryGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetPayorNoaSettingsHistoryInternalToolsPayorsPayorIdNoaSettingsHistoryGetResponses,
      GetPayorNoaSettingsHistoryInternalToolsPayorsPayorIdNoaSettingsHistoryGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal-tools/payors/{payor_id}/noa-settings/history',
      ...options,
    });

/**
 * Get All Product Updates
 *
 * Return all product updates and global images (Strawhat super-user only).
 */
export const getAllProductUpdatesInternalToolsProductUpdatesAllGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetAllProductUpdatesInternalToolsProductUpdatesAllGetData,
    ThrowOnError
  >
): RequestResult<
  GetAllProductUpdatesInternalToolsProductUpdatesAllGetResponses,
  GetAllProductUpdatesInternalToolsProductUpdatesAllGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetAllProductUpdatesInternalToolsProductUpdatesAllGetResponses,
    GetAllProductUpdatesInternalToolsProductUpdatesAllGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/product-updates/all',
    ...options,
  });

/**
 * Update Product Update Entry
 *
 * Create or update a product update (Roger internal / Strawhat super-user only).
 */
export const updateProductUpdateEntryInternalToolsProductUpdatesManagementPatch =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdateProductUpdateEntryInternalToolsProductUpdatesManagementPatchData,
      ThrowOnError
    >
  ): RequestResult<
    UpdateProductUpdateEntryInternalToolsProductUpdatesManagementPatchResponses,
    UpdateProductUpdateEntryInternalToolsProductUpdatesManagementPatchErrors,
    ThrowOnError
  > =>
    (options.client ?? client).patch<
      UpdateProductUpdateEntryInternalToolsProductUpdatesManagementPatchResponses,
      UpdateProductUpdateEntryInternalToolsProductUpdatesManagementPatchErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal-tools/product-updates/management',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Upload Product Update Image
 *
 * Upload a global product-update image (Strawhat super-user only).
 */
export const uploadProductUpdateImageInternalToolsProductUpdatesManagementImagesPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UploadProductUpdateImageInternalToolsProductUpdatesManagementImagesPostData,
      ThrowOnError
    >
  ): RequestResult<
    UploadProductUpdateImageInternalToolsProductUpdatesManagementImagesPostResponses,
    UploadProductUpdateImageInternalToolsProductUpdatesManagementImagesPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      UploadProductUpdateImageInternalToolsProductUpdatesManagementImagesPostResponses,
      UploadProductUpdateImageInternalToolsProductUpdatesManagementImagesPostErrors,
      ThrowOnError
    >({
      ...formDataBodySerializer,
      responseType: 'json',
      url: '/internal-tools/product-updates/management/images',
      ...options,
      headers: {
        'Content-Type': null,
        ...options.headers,
      },
    });

/**
 * Delete Product Update Image
 *
 * Delete a global product-update image (Strawhat super-user only).
 * Does not check if anything is referencing the image, will leave it up to the UI to
 * prevent issues to improve speeds
 */
export const deleteProductUpdateImageInternalToolsProductUpdatesManagementImagesImageIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteProductUpdateImageInternalToolsProductUpdatesManagementImagesImageIdDeleteData,
      ThrowOnError
    >
  ): RequestResult<
    DeleteProductUpdateImageInternalToolsProductUpdatesManagementImagesImageIdDeleteResponses,
    DeleteProductUpdateImageInternalToolsProductUpdatesManagementImagesImageIdDeleteErrors,
    ThrowOnError
  > =>
    (options.client ?? client).delete<
      DeleteProductUpdateImageInternalToolsProductUpdatesManagementImagesImageIdDeleteResponses,
      DeleteProductUpdateImageInternalToolsProductUpdatesManagementImagesImageIdDeleteErrors,
      ThrowOnError
    >({
      url: '/internal-tools/product-updates/management/images/{image_id}',
      ...options,
    });

/**
 * Delete Product Update Entry
 *
 * Delete a product update (Roger internal / Strawhat super-user only).
 */
export const deleteProductUpdateEntryInternalToolsProductUpdatesManagementProductUpdateIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteProductUpdateEntryInternalToolsProductUpdatesManagementProductUpdateIdDeleteData,
      ThrowOnError
    >
  ): RequestResult<
    DeleteProductUpdateEntryInternalToolsProductUpdatesManagementProductUpdateIdDeleteResponses,
    DeleteProductUpdateEntryInternalToolsProductUpdatesManagementProductUpdateIdDeleteErrors,
    ThrowOnError
  > =>
    (options.client ?? client).delete<
      DeleteProductUpdateEntryInternalToolsProductUpdatesManagementProductUpdateIdDeleteResponses,
      DeleteProductUpdateEntryInternalToolsProductUpdatesManagementProductUpdateIdDeleteErrors,
      ThrowOnError
    >({
      url: '/internal-tools/product-updates/management/{product_update_id}',
      ...options,
    });

/**
 * List Simulated Order Faxes
 *
 * Every order fax this stage stored instead of sending, newest first.
 */
export const listSimulatedOrderFaxesInternalToolsSimulatedOrderFaxesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ListSimulatedOrderFaxesInternalToolsSimulatedOrderFaxesGetData,
    ThrowOnError
  >
): RequestResult<
  ListSimulatedOrderFaxesInternalToolsSimulatedOrderFaxesGetResponses,
  ListSimulatedOrderFaxesInternalToolsSimulatedOrderFaxesGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListSimulatedOrderFaxesInternalToolsSimulatedOrderFaxesGetResponses,
    ListSimulatedOrderFaxesInternalToolsSimulatedOrderFaxesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/simulated-order-faxes',
    ...options,
  });

/**
 * Get Simulated Order Fax Pdf
 *
 * The exact document that would have been faxed, mark and all.
 */
export const getSimulatedOrderFaxPdfInternalToolsSimulatedOrderFaxesStoredIdPdfGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetSimulatedOrderFaxPdfInternalToolsSimulatedOrderFaxesStoredIdPdfGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetSimulatedOrderFaxPdfInternalToolsSimulatedOrderFaxesStoredIdPdfGetResponses,
    GetSimulatedOrderFaxPdfInternalToolsSimulatedOrderFaxesStoredIdPdfGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetSimulatedOrderFaxPdfInternalToolsSimulatedOrderFaxesStoredIdPdfGetResponses,
      GetSimulatedOrderFaxPdfInternalToolsSimulatedOrderFaxesStoredIdPdfGetErrors,
      ThrowOnError
    >({
      responseType: 'blob',
      url: '/internal-tools/simulated-order-faxes/{stored_id}/pdf',
      ...options,
    });

/**
 * Sign And Return
 *
 * Sign the stored fax and push it back through the real inbound pipeline.
 */
export const signAndReturnInternalToolsSimulatedOrderFaxesStoredIdSignAndReturnPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      SignAndReturnInternalToolsSimulatedOrderFaxesStoredIdSignAndReturnPostData,
      ThrowOnError
    >
  ): RequestResult<
    SignAndReturnInternalToolsSimulatedOrderFaxesStoredIdSignAndReturnPostResponses,
    SignAndReturnInternalToolsSimulatedOrderFaxesStoredIdSignAndReturnPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      SignAndReturnInternalToolsSimulatedOrderFaxesStoredIdSignAndReturnPostResponses,
      SignAndReturnInternalToolsSimulatedOrderFaxesStoredIdSignAndReturnPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal-tools/simulated-order-faxes/{stored_id}/sign-and-return',
      ...options,
    });

/**
 * Preflight Stedi Replay
 *
 * Report what the system knows about each transaction ID. Mutates nothing.
 */
export const preflightStediReplayInternalToolsStediReplayPreflightPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PreflightStediReplayInternalToolsStediReplayPreflightPostData,
    ThrowOnError
  >
): RequestResult<
  PreflightStediReplayInternalToolsStediReplayPreflightPostResponses,
  PreflightStediReplayInternalToolsStediReplayPreflightPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PreflightStediReplayInternalToolsStediReplayPreflightPostResponses,
    PreflightStediReplayInternalToolsStediReplayPreflightPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/stedi-replay/preflight',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Replay Stedi Webhooks
 *
 * Start one Stedi835ProcessorWorkflow per 835 transaction ID.
 *
 * Returns as soon as start_workflow returns. The response says *started*,
 * not *succeeded*: the operator re-runs preflight to read the result.
 *
 * Replay is unconditional. It does not read the preflight verdict and never
 * skips on already_stored, because an 835 can hold many ERAs -- one child per
 * control number -- so a partial store is exactly the case this tool exists
 * for. Double-processing is prevented at the storage layer by the partial
 * unique index in app/crud/remittance_advice.py, which returns duplicate=True
 * before payments, claim application, or the era_received Slack.
 */
export const replayStediWebhooksInternalToolsStediReplayPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ReplayStediWebhooksInternalToolsStediReplayPostData,
    ThrowOnError
  >
): RequestResult<
  ReplayStediWebhooksInternalToolsStediReplayPostResponses,
  ReplayStediWebhooksInternalToolsStediReplayPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ReplayStediWebhooksInternalToolsStediReplayPostResponses,
    ReplayStediWebhooksInternalToolsStediReplayPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/stedi-replay',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Telnyx Fax Lines
 *
 * Every agency with a line or an active Telnyx number.
 */
export const listTelnyxFaxLinesInternalToolsTelnyxFaxLinesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ListTelnyxFaxLinesInternalToolsTelnyxFaxLinesGetData,
    ThrowOnError
  >
): RequestResult<
  ListTelnyxFaxLinesInternalToolsTelnyxFaxLinesGetResponses,
  ListTelnyxFaxLinesInternalToolsTelnyxFaxLinesGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListTelnyxFaxLinesInternalToolsTelnyxFaxLinesGetResponses,
    ListTelnyxFaxLinesInternalToolsTelnyxFaxLinesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/telnyx-fax-lines',
    ...options,
  });

/**
 * Get Telnyx Fax Line
 *
 * One agency's line, empty for an agency that has nothing yet.
 */
export const getTelnyxFaxLineInternalToolsTelnyxFaxLinesAgencyIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetTelnyxFaxLineInternalToolsTelnyxFaxLinesAgencyIdGetData,
    ThrowOnError
  >
): RequestResult<
  GetTelnyxFaxLineInternalToolsTelnyxFaxLinesAgencyIdGetResponses,
  GetTelnyxFaxLineInternalToolsTelnyxFaxLinesAgencyIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetTelnyxFaxLineInternalToolsTelnyxFaxLinesAgencyIdGetResponses,
    GetTelnyxFaxLineInternalToolsTelnyxFaxLinesAgencyIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/telnyx-fax-lines/{agency_id}',
    ...options,
  });

/**
 * Provision Telnyx Fax Line
 *
 * Create the agency's Telnyx fax application, or find the one it has.
 *
 * Safe to repeat: a second call returns the stored application, and a create
 * that timed out is found by its name on the next call. One Telnyx never
 * confirmed and the lookup cannot find answers 409 ``create_unconfirmed``
 * until the request says a person checked the Telnyx portal. Then the
 * agency's numbers and its unsubmitted port orders are put on it.
 */
export const provisionTelnyxFaxLineInternalToolsTelnyxFaxLinesAgencyIdProvisionPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ProvisionTelnyxFaxLineInternalToolsTelnyxFaxLinesAgencyIdProvisionPostData,
      ThrowOnError
    >
  ): RequestResult<
    ProvisionTelnyxFaxLineInternalToolsTelnyxFaxLinesAgencyIdProvisionPostResponses,
    ProvisionTelnyxFaxLineInternalToolsTelnyxFaxLinesAgencyIdProvisionPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      ProvisionTelnyxFaxLineInternalToolsTelnyxFaxLinesAgencyIdProvisionPostResponses,
      ProvisionTelnyxFaxLineInternalToolsTelnyxFaxLinesAgencyIdProvisionPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal-tools/telnyx-fax-lines/{agency_id}/provision',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Assign Telnyx Numbers
 *
 * Put each number not yet assigned on the agency's application at Telnyx.
 *
 * Safe to repeat. A number Telnyx does not hold as active yet, or that sits on
 * another connection, stays unassigned; the response shows which.
 */
export const assignTelnyxNumbersInternalToolsTelnyxFaxLinesAgencyIdNumbersAssignPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      AssignTelnyxNumbersInternalToolsTelnyxFaxLinesAgencyIdNumbersAssignPostData,
      ThrowOnError
    >
  ): RequestResult<
    AssignTelnyxNumbersInternalToolsTelnyxFaxLinesAgencyIdNumbersAssignPostResponses,
    AssignTelnyxNumbersInternalToolsTelnyxFaxLinesAgencyIdNumbersAssignPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      AssignTelnyxNumbersInternalToolsTelnyxFaxLinesAgencyIdNumbersAssignPostResponses,
      AssignTelnyxNumbersInternalToolsTelnyxFaxLinesAgencyIdNumbersAssignPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal-tools/telnyx-fax-lines/{agency_id}/numbers/assign',
      ...options,
    });

/**
 * Forget Telnyx Fax Application
 *
 * Forget the agency's stored application so it can be created or found again.
 *
 * Deletes nothing at Telnyx. Refused with 409 while the agency faxes through
 * Telnyx, because its sends would stop, and while a create marker stands with
 * no id stored (``create_in_flight`` or ``create_unconfirmed``).
 */
export const forgetTelnyxFaxApplicationInternalToolsTelnyxFaxLinesAgencyIdForgetApplicationPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ForgetTelnyxFaxApplicationInternalToolsTelnyxFaxLinesAgencyIdForgetApplicationPostData,
      ThrowOnError
    >
  ): RequestResult<
    ForgetTelnyxFaxApplicationInternalToolsTelnyxFaxLinesAgencyIdForgetApplicationPostResponses,
    ForgetTelnyxFaxApplicationInternalToolsTelnyxFaxLinesAgencyIdForgetApplicationPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      ForgetTelnyxFaxApplicationInternalToolsTelnyxFaxLinesAgencyIdForgetApplicationPostResponses,
      ForgetTelnyxFaxApplicationInternalToolsTelnyxFaxLinesAgencyIdForgetApplicationPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal-tools/telnyx-fax-lines/{agency_id}/forget-application',
      ...options,
    });

/**
 * Set Telnyx Outbound Number
 *
 * Choose the agency's outbound number, or clear it with null.
 */
export const setTelnyxOutboundNumberInternalToolsTelnyxFaxLinesAgencyIdOutboundNumberPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      SetTelnyxOutboundNumberInternalToolsTelnyxFaxLinesAgencyIdOutboundNumberPutData,
      ThrowOnError
    >
  ): RequestResult<
    SetTelnyxOutboundNumberInternalToolsTelnyxFaxLinesAgencyIdOutboundNumberPutResponses,
    SetTelnyxOutboundNumberInternalToolsTelnyxFaxLinesAgencyIdOutboundNumberPutErrors,
    ThrowOnError
  > =>
    (options.client ?? client).put<
      SetTelnyxOutboundNumberInternalToolsTelnyxFaxLinesAgencyIdOutboundNumberPutResponses,
      SetTelnyxOutboundNumberInternalToolsTelnyxFaxLinesAgencyIdOutboundNumberPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal-tools/telnyx-fax-lines/{agency_id}/outbound-number',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Add Telnyx Number
 *
 * Map a Telnyx number to the agency, the way the inbound parser looks it up.
 *
 * Once the mapping is committed, the number is put on the agency's stored
 * application at Telnyx where this stage may call Telnyx.
 */
export const addTelnyxNumberInternalToolsTelnyxFaxLinesAgencyIdNumbersPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AddTelnyxNumberInternalToolsTelnyxFaxLinesAgencyIdNumbersPostData,
    ThrowOnError
  >
): RequestResult<
  AddTelnyxNumberInternalToolsTelnyxFaxLinesAgencyIdNumbersPostResponses,
  AddTelnyxNumberInternalToolsTelnyxFaxLinesAgencyIdNumbersPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AddTelnyxNumberInternalToolsTelnyxFaxLinesAgencyIdNumbersPostResponses,
    AddTelnyxNumberInternalToolsTelnyxFaxLinesAgencyIdNumbersPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/telnyx-fax-lines/{agency_id}/numbers',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Unassigned Faxes
 *
 * The faxes waiting on a mapping, oldest first.
 */
export const listUnassignedFaxesInternalToolsUnassignedFaxesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ListUnassignedFaxesInternalToolsUnassignedFaxesGetData,
    ThrowOnError
  >
): RequestResult<
  ListUnassignedFaxesInternalToolsUnassignedFaxesGetResponses,
  ListUnassignedFaxesInternalToolsUnassignedFaxesGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListUnassignedFaxesInternalToolsUnassignedFaxesGetResponses,
    ListUnassignedFaxesInternalToolsUnassignedFaxesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/unassigned-faxes',
    ...options,
  });

/**
 * Get Unassigned Fax
 *
 * One parked fax, with the documents available to open.
 */
export const getUnassignedFaxInternalToolsUnassignedFaxesFaxIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetUnassignedFaxInternalToolsUnassignedFaxesFaxIdGetData,
    ThrowOnError
  >
): RequestResult<
  GetUnassignedFaxInternalToolsUnassignedFaxesFaxIdGetResponses,
  GetUnassignedFaxInternalToolsUnassignedFaxesFaxIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetUnassignedFaxInternalToolsUnassignedFaxesFaxIdGetResponses,
    GetUnassignedFaxInternalToolsUnassignedFaxesFaxIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/unassigned-faxes/{fax_id}',
    ...options,
  });

/**
 * Assign Unassigned Fax
 *
 * Hand a parked fax to the agency it turns out to belong to.
 *
 * One direction only. A fax already placed is not reachable here, so this can
 * give an agency a fax that was waiting for one but can never move a fax from
 * one agency to another, which would carry a patient's referral to a different
 * audience. The same reasoning is why deleting an agency restricts rather than
 * nulling these rows.
 *
 * This does not create the mapping that would have placed the fax in the first
 * place. That is the sibling route, and it is the fix: this one clears the
 * backlog, that one stops it refilling.
 */
export const assignUnassignedFaxInternalToolsUnassignedFaxesFaxIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AssignUnassignedFaxInternalToolsUnassignedFaxesFaxIdPatchData,
    ThrowOnError
  >
): RequestResult<
  AssignUnassignedFaxInternalToolsUnassignedFaxesFaxIdPatchResponses,
  AssignUnassignedFaxInternalToolsUnassignedFaxesFaxIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    AssignUnassignedFaxInternalToolsUnassignedFaxesFaxIdPatchResponses,
    AssignUnassignedFaxInternalToolsUnassignedFaxesFaxIdPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/unassigned-faxes/{fax_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Download Unassigned Fax Document
 *
 * A short-lived URL for one document of a parked fax.
 *
 * This is the one place staff read a patient's referral rather than routing
 * metadata, and it exists because the alternative is worse: a fax nobody can
 * open is a fax nobody can place, and it sits in the queue until it is
 * forgotten. Restricted to parked faxes, so it never becomes a way to read a
 * fax some agency already owns, and logged by fax and document id so the read
 * is answerable afterwards.
 */
export const downloadUnassignedFaxDocumentInternalToolsUnassignedFaxesFaxIdDocumentsDocumentIdDownloadGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DownloadUnassignedFaxDocumentInternalToolsUnassignedFaxesFaxIdDocumentsDocumentIdDownloadGetData,
      ThrowOnError
    >
  ): RequestResult<
    DownloadUnassignedFaxDocumentInternalToolsUnassignedFaxesFaxIdDocumentsDocumentIdDownloadGetResponses,
    DownloadUnassignedFaxDocumentInternalToolsUnassignedFaxesFaxIdDocumentsDocumentIdDownloadGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      DownloadUnassignedFaxDocumentInternalToolsUnassignedFaxesFaxIdDocumentsDocumentIdDownloadGetResponses,
      DownloadUnassignedFaxDocumentInternalToolsUnassignedFaxesFaxIdDocumentsDocumentIdDownloadGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal-tools/unassigned-faxes/{fax_id}/documents/{document_id}/download',
      ...options,
    });

/**
 * Get Temporal Scaling Overrides
 *
 * Return the current min/max override of each worker service.
 */
export const getTemporalScalingOverridesInternalToolsTemporalScalingOverridesGet =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      GetTemporalScalingOverridesInternalToolsTemporalScalingOverridesGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetTemporalScalingOverridesInternalToolsTemporalScalingOverridesGetResponses,
    GetTemporalScalingOverridesInternalToolsTemporalScalingOverridesGetErrors,
    ThrowOnError
  > =>
    (options?.client ?? client).get<
      GetTemporalScalingOverridesInternalToolsTemporalScalingOverridesGetResponses,
      GetTemporalScalingOverridesInternalToolsTemporalScalingOverridesGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal-tools/temporal-scaling/overrides',
      ...options,
    });

/**
 * Update Temporal Scaling Override
 *
 * Set or clear one override. A `null` value clears it.
 */
export const updateTemporalScalingOverrideInternalToolsTemporalScalingOverridesPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdateTemporalScalingOverrideInternalToolsTemporalScalingOverridesPutData,
      ThrowOnError
    >
  ): RequestResult<
    UpdateTemporalScalingOverrideInternalToolsTemporalScalingOverridesPutResponses,
    UpdateTemporalScalingOverrideInternalToolsTemporalScalingOverridesPutErrors,
    ThrowOnError
  > =>
    (options.client ?? client).put<
      UpdateTemporalScalingOverrideInternalToolsTemporalScalingOverridesPutResponses,
      UpdateTemporalScalingOverrideInternalToolsTemporalScalingOverridesPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal-tools/temporal-scaling/overrides',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Internal Health Check
 *
 * Health check endpoint for internal service communication.
 *
 * This endpoint is specifically for Roger Doc to verify RogerEMR API connectivity.
 */
export const internalHealthCheckInternalHealthGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<InternalHealthCheckInternalHealthGetData, ThrowOnError>
): RequestResult<
  InternalHealthCheckInternalHealthGetResponses,
  InternalHealthCheckInternalHealthGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    InternalHealthCheckInternalHealthGetResponses,
    InternalHealthCheckInternalHealthGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/health',
    ...options,
  });

/**
 * List Agencies Internal
 *
 * List every agency, for target selection in internal tooling.
 *
 * ``system_name`` is the join key to Roger Docs' agency ids — the values
 * match case-insensitively, not verbatim — which is how the import page
 * pairs a source agency with its own Roger org.
 */
export const listAgenciesInternalInternalAgenciesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListAgenciesInternalInternalAgenciesGetData, ThrowOnError>
): RequestResult<
  ListAgenciesInternalInternalAgenciesGetResponses,
  ListAgenciesInternalInternalAgenciesGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListAgenciesInternalInternalAgenciesGetResponses,
    ListAgenciesInternalInternalAgenciesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/agencies',
    ...options,
  });

/**
 * Create Agency Internal
 *
 * Create an agency for Roger Docs, with WorkOS, onboarding and products.
 *
 * Identifiers compare ignoring case. An agency that already has both the
 * system name and the abbreviation is returned with 200, so a retry is
 * safe; either one held by a different agency is a 409.
 */
export const createAgencyInternalInternalAgenciesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateAgencyInternalInternalAgenciesPostData, ThrowOnError>
): RequestResult<
  CreateAgencyInternalInternalAgenciesPostResponses,
  CreateAgencyInternalInternalAgenciesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateAgencyInternalInternalAgenciesPostResponses,
    CreateAgencyInternalInternalAgenciesPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/agencies',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Import Target Options Internal
 *
 * The rows an operator may pin on a Kinnser import's target.
 *
 * A cross-org import's portfolio carries the *source* agency's Kinnser
 * identity, so automatic resolution refuses in any multi-clinic target
 * org. This listing is what the page offers instead: the target's
 * clinics, its payer rows (with their clinic scope, so the page can keep
 * the importer's NULL-or-equal axis), and the live physicians the
 * attending can be substituted with. Physicians without an NPI are left
 * out — ``target.attending_physician_npi`` is the pin, and the importer
 * creates no physicians.
 *
 * Explicit ``agency_id`` predicates with ``skip_agency_filter``: the
 * internal route's ambient context is the bootstrap agency, not the one
 * being listed, and every id offered here is re-validated by the
 * importer's preconditions inside its own scoped context.
 */
export const getImportTargetOptionsInternalInternalAgenciesAgencyIdImportTargetOptionsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetImportTargetOptionsInternalInternalAgenciesAgencyIdImportTargetOptionsGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetImportTargetOptionsInternalInternalAgenciesAgencyIdImportTargetOptionsGetResponses,
    GetImportTargetOptionsInternalInternalAgenciesAgencyIdImportTargetOptionsGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetImportTargetOptionsInternalInternalAgenciesAgencyIdImportTargetOptionsGetResponses,
      GetImportTargetOptionsInternalInternalAgenciesAgencyIdImportTargetOptionsGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/agencies/{agency_id}/import-target-options',
      ...options,
    });

/**
 * Sync Agency Products Internal
 *
 * Copy which products an agency has from Roger Docs.
 *
 * Docs calls this after a product changes; a daily schedule runs the
 * every-agency form as a backstop. Nothing is written if Docs fails.
 */
export const syncAgencyProductsInternalInternalAgenciesSyncProductsPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    SyncAgencyProductsInternalInternalAgenciesSyncProductsPostData,
    ThrowOnError
  >
): RequestResult<
  SyncAgencyProductsInternalInternalAgenciesSyncProductsPostResponses,
  SyncAgencyProductsInternalInternalAgenciesSyncProductsPostErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    SyncAgencyProductsInternalInternalAgenciesSyncProductsPostResponses,
    SyncAgencyProductsInternalInternalAgenciesSyncProductsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/agencies/sync-products',
    ...options,
  });

/**
 * Sync Clinics From Clinic Info Internal
 *
 * Sync AgencyClinic and AgencyInsurance records by fetching clinic information from RogerDoc API.
 *
 * This is the internal version of the sync endpoint that uses internal API key authentication.
 * If agency_system_name is provided, syncs only that agency. Otherwise, starts
 * the all-agency sync in the background and returns at once.
 *
 * Args:
 * agency_system_name: Optional system name of the agency to sync. If None, syncs all agencies.
 * ctx: Current context from internal service authentication
 * db: Database session
 *
 * Returns:
 * SyncClinicInfoResponse for single agency, or BulkSyncResponse naming the
 * started workflow for all agencies
 *
 * Raises:
 * HTTPException: If agency not found, RogerDoc API is unavailable, or database operations fail
 */
export const syncClinicsFromClinicInfoInternalInternalAgencyClinicsSyncFromClinicInfoPost =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      SyncClinicsFromClinicInfoInternalInternalAgencyClinicsSyncFromClinicInfoPostData,
      ThrowOnError
    >
  ): RequestResult<
    SyncClinicsFromClinicInfoInternalInternalAgencyClinicsSyncFromClinicInfoPostResponses,
    SyncClinicsFromClinicInfoInternalInternalAgencyClinicsSyncFromClinicInfoPostErrors,
    ThrowOnError
  > =>
    (options?.client ?? client).post<
      SyncClinicsFromClinicInfoInternalInternalAgencyClinicsSyncFromClinicInfoPostResponses,
      SyncClinicsFromClinicInfoInternalInternalAgencyClinicsSyncFromClinicInfoPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/agency-clinics/sync-from-clinic-info',
      ...options,
    });

/**
 * Ensure Current Episode Internal
 *
 * Get or create the patient's episode that covers today (internal/testing).
 */
export const ensureCurrentEpisodeInternalInternalEpisodesEnsureCurrentPatientIdPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      EnsureCurrentEpisodeInternalInternalEpisodesEnsureCurrentPatientIdPostData,
      ThrowOnError
    >
  ): RequestResult<
    EnsureCurrentEpisodeInternalInternalEpisodesEnsureCurrentPatientIdPostResponses,
    EnsureCurrentEpisodeInternalInternalEpisodesEnsureCurrentPatientIdPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      EnsureCurrentEpisodeInternalInternalEpisodesEnsureCurrentPatientIdPostResponses,
      EnsureCurrentEpisodeInternalInternalEpisodesEnsureCurrentPatientIdPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/episodes/ensure-current/{patient_id}',
      ...options,
    });

/**
 * Get Patient Medications
 *
 * Get all medications for a patient.
 *
 * Optionally filter out discontinued medications with include_discontinued=false.
 */
export const getPatientMedicationsInternalPatientsPatientIdMedicationsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPatientMedicationsInternalPatientsPatientIdMedicationsGetData,
    ThrowOnError
  >
): RequestResult<
  GetPatientMedicationsInternalPatientsPatientIdMedicationsGetResponses,
  GetPatientMedicationsInternalPatientsPatientIdMedicationsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetPatientMedicationsInternalPatientsPatientIdMedicationsGetResponses,
    GetPatientMedicationsInternalPatientsPatientIdMedicationsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/patients/{patient_id}/medications/',
    ...options,
  });

/**
 * Create Patient Medication Internal
 *
 * Create a new medication for a patient.
 *
 * For on-market medications, provide exactly one of
 * medication_external_id or fdb_dispensable_drug_id (an FDB drug is
 * materialized into the local catalog on first use).
 * For off-market medications, set is_off_market=true and provide off_market_description.
 */
export const createPatientMedicationInternalInternalPatientsPatientIdMedicationsPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      CreatePatientMedicationInternalInternalPatientsPatientIdMedicationsPostData,
      ThrowOnError
    >
  ): RequestResult<
    CreatePatientMedicationInternalInternalPatientsPatientIdMedicationsPostResponses,
    CreatePatientMedicationInternalInternalPatientsPatientIdMedicationsPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      CreatePatientMedicationInternalInternalPatientsPatientIdMedicationsPostResponses,
      CreatePatientMedicationInternalInternalPatientsPatientIdMedicationsPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/patients/{patient_id}/medications/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Print Patient Medications
 *
 * Unsigned current medication list for office staff.
 *
 * Lists medications started on or before the clinic's business date and
 * not stopped by it. Nothing is saved or audited.
 */
export const printPatientMedicationsInternalPatientsPatientIdMedicationsPrintGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      PrintPatientMedicationsInternalPatientsPatientIdMedicationsPrintGetData,
      ThrowOnError
    >
  ): RequestResult<
    PrintPatientMedicationsInternalPatientsPatientIdMedicationsPrintGetResponses,
    PrintPatientMedicationsInternalPatientsPatientIdMedicationsPrintGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      PrintPatientMedicationsInternalPatientsPatientIdMedicationsPrintGetResponses,
      PrintPatientMedicationsInternalPatientsPatientIdMedicationsPrintGetErrors,
      ThrowOnError
    >({
      responseType: 'blob',
      url: '/internal/patients/{patient_id}/medications/print',
      ...options,
    });

/**
 * Get Medication Pdf
 *
 * Generate and return a Patient Medication Record PDF.
 *
 * Includes:
 * - Pharmacy on file (or "None on file")
 * - Medications grouped by: Future, Current, Discontinued
 * - Legend with status indicators (LS, N, C)
 * - Form sections for physician contact and medication interactions
 * - Signature section
 *
 * The PDF is dynamically generated from current medication data.
 *
 * Args:
 * patient_id: Patient UUID
 * db: Database session
 * ctx: Current context for agency-based access control
 *
 * Returns:
 * PDF file as application/pdf response
 *
 * Raises:
 * HTTPException: If patient not found or PDF generation fails
 */
export const getMedicationPdfInternalPatientsPatientIdMedicationsPdfPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetMedicationPdfInternalPatientsPatientIdMedicationsPdfPostData,
    ThrowOnError
  >
): RequestResult<
  GetMedicationPdfInternalPatientsPatientIdMedicationsPdfPostResponses,
  GetMedicationPdfInternalPatientsPatientIdMedicationsPdfPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GetMedicationPdfInternalPatientsPatientIdMedicationsPdfPostResponses,
    GetMedicationPdfInternalPatientsPatientIdMedicationsPdfPostErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/internal/patients/{patient_id}/medications/pdf',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Patient Medication
 *
 * Delete a medication.
 */
export const deletePatientMedicationInternalPatientsPatientIdMedicationsMedicationIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeletePatientMedicationInternalPatientsPatientIdMedicationsMedicationIdDeleteData,
      ThrowOnError
    >
  ): RequestResult<
    DeletePatientMedicationInternalPatientsPatientIdMedicationsMedicationIdDeleteResponses,
    DeletePatientMedicationInternalPatientsPatientIdMedicationsMedicationIdDeleteErrors,
    ThrowOnError
  > =>
    (options.client ?? client).delete<
      DeletePatientMedicationInternalPatientsPatientIdMedicationsMedicationIdDeleteResponses,
      DeletePatientMedicationInternalPatientsPatientIdMedicationsMedicationIdDeleteErrors,
      ThrowOnError
    >({
      url: '/internal/patients/{patient_id}/medications/{medication_id}',
      ...options,
    });

/**
 * Get Patient Medication
 *
 * Get a specific medication by ID.
 */
export const getPatientMedicationInternalPatientsPatientIdMedicationsMedicationIdGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetPatientMedicationInternalPatientsPatientIdMedicationsMedicationIdGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetPatientMedicationInternalPatientsPatientIdMedicationsMedicationIdGetResponses,
    GetPatientMedicationInternalPatientsPatientIdMedicationsMedicationIdGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetPatientMedicationInternalPatientsPatientIdMedicationsMedicationIdGetResponses,
      GetPatientMedicationInternalPatientsPatientIdMedicationsMedicationIdGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/patients/{patient_id}/medications/{medication_id}',
      ...options,
    });

/**
 * Update Patient Medication
 *
 * Update a medication.
 */
export const updatePatientMedicationInternalPatientsPatientIdMedicationsMedicationIdPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdatePatientMedicationInternalPatientsPatientIdMedicationsMedicationIdPutData,
      ThrowOnError
    >
  ): RequestResult<
    UpdatePatientMedicationInternalPatientsPatientIdMedicationsMedicationIdPutResponses,
    UpdatePatientMedicationInternalPatientsPatientIdMedicationsMedicationIdPutErrors,
    ThrowOnError
  > =>
    (options.client ?? client).put<
      UpdatePatientMedicationInternalPatientsPatientIdMedicationsMedicationIdPutResponses,
      UpdatePatientMedicationInternalPatientsPatientIdMedicationsMedicationIdPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/patients/{patient_id}/medications/{medication_id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Get Medication Catalog Version
 *
 * The published catalog's version, hash and a download URL.
 *
 * The URL points at the object the manifest names. A build's key is never
 * rewritten, so the URL serves exactly the bytes whose sha256 is returned
 * alongside it, even if a new build publishes while this request runs.
 */
export const getMedicationCatalogVersionInternalMedicationsCatalogVersionGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetMedicationCatalogVersionInternalMedicationsCatalogVersionGetData,
    ThrowOnError
  >
): RequestResult<
  GetMedicationCatalogVersionInternalMedicationsCatalogVersionGetResponses,
  GetMedicationCatalogVersionInternalMedicationsCatalogVersionGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetMedicationCatalogVersionInternalMedicationsCatalogVersionGetResponses,
    GetMedicationCatalogVersionInternalMedicationsCatalogVersionGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/medications/catalog/version',
    ...options,
  });

/**
 * Ensure Test Patient Internal
 *
 * Get or create a test patient, with an open admission, at the acting user's clinic.
 *
 * The patient is looked up by MRN across the acting user's clinics. A new one
 * goes in the first of those clinics and is flagged ``is_test_patient`` so it
 * never reaches CMS or billing. Follow with ``/episodes/ensure-current`` for
 * an episode that covers today.
 *
 * Not available in prod: answers exactly like a route that does not exist.
 */
export const ensureTestPatientInternalInternalPatientsEnsureTestPatientPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    EnsureTestPatientInternalInternalPatientsEnsureTestPatientPostData,
    ThrowOnError
  >
): RequestResult<
  EnsureTestPatientInternalInternalPatientsEnsureTestPatientPostResponses,
  EnsureTestPatientInternalInternalPatientsEnsureTestPatientPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    EnsureTestPatientInternalInternalPatientsEnsureTestPatientPostResponses,
    EnsureTestPatientInternalInternalPatientsEnsureTestPatientPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/patients/ensure-test-patient',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Take Over Dates Internal
 *
 * Every taken-over patient of the agency and, for each episode on their
 * current admission, its dates and the day Roger charts its visits from, for
 * RogerDocs to hide the External EMR's copy from that day on.
 *
 * The periods are the ones the visits feed judges ``other_side_of_take_over``
 * by (:func:`take_over_periods`). Patients without an MRN are left out,
 * since RogerDocs matches the External EMR's rows on it. Empty for an agency
 * without an External EMR. The caller must name the agency.
 */
export const takeOverDatesInternalInternalPatientsTakeOverDatesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    TakeOverDatesInternalInternalPatientsTakeOverDatesGetData,
    ThrowOnError
  >
): RequestResult<
  TakeOverDatesInternalInternalPatientsTakeOverDatesGetResponses,
  TakeOverDatesInternalInternalPatientsTakeOverDatesGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    TakeOverDatesInternalInternalPatientsTakeOverDatesGetResponses,
    TakeOverDatesInternalInternalPatientsTakeOverDatesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/patients/take-over-dates',
    ...options,
  });

/**
 * Get Visits List Internal
 *
 * Get list of visits for the authenticated user within date range (internal service authentication).
 *
 * This endpoint is specifically designed for Roger Doc to fetch scheduled visits
 * for a clinician within a specified date range.
 *
 * Args:
 * start_date: Start date in YYYY-MM-DD format
 * end_date: End date in YYYY-MM-DD format
 * custody: "roger" drops the visits marked ``external``
 * db_session: Database session
 * ctx: Current context from internal service authentication
 *
 * Returns:
 * Dictionary containing visits array for the date range
 *
 * Raises:
 * HTTPException: If dates are invalid or no access to visits
 */
export const getVisitsListInternalInternalVisitsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetVisitsListInternalInternalVisitsGetData, ThrowOnError>
): RequestResult<
  GetVisitsListInternalInternalVisitsGetResponses,
  GetVisitsListInternalInternalVisitsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetVisitsListInternalInternalVisitsGetResponses,
    GetVisitsListInternalInternalVisitsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/visits',
    ...options,
  });

/**
 * Create Visit Internal
 *
 * Create a new visit (internal service authentication).
 *
 * Args:
 * visit_create: Visit creation data
 * db_session: Database session
 * ctx: Current context from internal service authentication
 *
 * Returns:
 * Created visit details
 *
 * Raises:
 * HTTPException: If episode not found or not accessible by current agency
 */
export const createVisitInternalInternalVisitsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateVisitInternalInternalVisitsPostData, ThrowOnError>
): RequestResult<
  CreateVisitInternalInternalVisitsPostResponses,
  CreateVisitInternalInternalVisitsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateVisitInternalInternalVisitsPostResponses,
    CreateVisitInternalInternalVisitsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/visits',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Visit Internal
 *
 * Delete a visit (internal/testing). Locked visits cannot be deleted.
 */
export const deleteVisitInternalInternalVisitsVisitIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteVisitInternalInternalVisitsVisitIdDeleteData,
    ThrowOnError
  >
): RequestResult<
  DeleteVisitInternalInternalVisitsVisitIdDeleteResponses,
  DeleteVisitInternalInternalVisitsVisitIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteVisitInternalInternalVisitsVisitIdDeleteResponses,
    DeleteVisitInternalInternalVisitsVisitIdDeleteErrors,
    ThrowOnError
  >({ url: '/internal/visits/{visit_id}', ...options });

/**
 * Get Visit Internal
 *
 * Get a specific visit by ID (internal service authentication).
 *
 * Args:
 * visit_id: Visit UUID
 * db_session: Database session
 * ctx: Current context from internal service authentication
 *
 * Returns:
 * Visit details including visit_data and visit_data_last_updated
 *
 * Raises:
 * HTTPException: If visit not found or not accessible by current agency
 */
export const getVisitInternalInternalVisitsVisitIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetVisitInternalInternalVisitsVisitIdGetData, ThrowOnError>
): RequestResult<
  GetVisitInternalInternalVisitsVisitIdGetResponses,
  GetVisitInternalInternalVisitsVisitIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetVisitInternalInternalVisitsVisitIdGetResponses,
    GetVisitInternalInternalVisitsVisitIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/visits/{visit_id}',
    ...options,
  });

/**
 * Update Visit Internal
 *
 * Update visit basic information (internal service authentication).
 *
 * Args:
 * visit_id: Visit UUID
 * visit_update: Updated visit information
 * db_session: Database session
 * ctx: Current context from internal service authentication
 *
 * Returns:
 * Updated visit details
 *
 * Raises:
 * HTTPException: If visit not found or not accessible by current agency
 */
export const updateVisitInternalInternalVisitsVisitIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateVisitInternalInternalVisitsVisitIdPutData,
    ThrowOnError
  >
): RequestResult<
  UpdateVisitInternalInternalVisitsVisitIdPutResponses,
  UpdateVisitInternalInternalVisitsVisitIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateVisitInternalInternalVisitsVisitIdPutResponses,
    UpdateVisitInternalInternalVisitsVisitIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/visits/{visit_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Visit Data Internal
 *
 * Get only the visit_data for a specific visit (internal service authentication).
 *
 * This endpoint is specifically designed for Roger Doc to fetch existing form data
 * before processing new voice recordings.
 *
 * Args:
 * visit_id: Visit UUID
 * db_session: Database session
 * ctx: Current context from internal service authentication
 *
 * Returns:
 * Dictionary containing visit_data and visit_data_last_updated
 *
 * Raises:
 * HTTPException: If visit not found or not accessible by current agency
 */
export const getVisitDataInternalInternalVisitsVisitIdDataGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetVisitDataInternalInternalVisitsVisitIdDataGetData,
    ThrowOnError
  >
): RequestResult<
  GetVisitDataInternalInternalVisitsVisitIdDataGetResponses,
  GetVisitDataInternalInternalVisitsVisitIdDataGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetVisitDataInternalInternalVisitsVisitIdDataGetResponses,
    GetVisitDataInternalInternalVisitsVisitIdDataGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/visits/{visit_id}/data',
    ...options,
  });

/**
 * Update Visit Data Internal
 *
 * Update visit data with optimistic concurrency control (internal service authentication).
 *
 * This endpoint is specifically designed for Roger Doc to submit form responses
 * after AI processing of voice recordings.
 *
 * Uses visit_data_last_updated for optimistic locking to prevent concurrent edit conflicts.
 *
 * Args:
 * visit_id: Visit UUID
 * visit_update: Updated visit data and last updated timestamp
 * db_session: Database session
 * ctx: Current context from internal service authentication
 *
 * Returns:
 * Updated visit with new visit_data_last_updated timestamp
 *
 * Raises:
 * HTTPException: If visit not found, not accessible, or update is stale
 */
export const updateVisitDataInternalInternalVisitsVisitIdDataPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateVisitDataInternalInternalVisitsVisitIdDataPutData,
    ThrowOnError
  >
): RequestResult<
  UpdateVisitDataInternalInternalVisitsVisitIdDataPutResponses,
  UpdateVisitDataInternalInternalVisitsVisitIdDataPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateVisitDataInternalInternalVisitsVisitIdDataPutResponses,
    UpdateVisitDataInternalInternalVisitsVisitIdDataPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/visits/{visit_id}/data',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Active Diagnoses Data Internal
 *
 * Update active diagnoses comorbidity data (M1028) for a visit (internal).
 *
 * Guarded more tightly than the portal route sharing this write: that one accepts every
 * editable status, this one only the statuses RogerDoc may push to.
 */
export const updateActiveDiagnosesDataInternalInternalVisitsVisitIdActiveDiagnosesDataPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdateActiveDiagnosesDataInternalInternalVisitsVisitIdActiveDiagnosesDataPutData,
      ThrowOnError
    >
  ): RequestResult<
    UpdateActiveDiagnosesDataInternalInternalVisitsVisitIdActiveDiagnosesDataPutResponses,
    UpdateActiveDiagnosesDataInternalInternalVisitsVisitIdActiveDiagnosesDataPutErrors,
    ThrowOnError
  > =>
    (options.client ?? client).put<
      UpdateActiveDiagnosesDataInternalInternalVisitsVisitIdActiveDiagnosesDataPutResponses,
      UpdateActiveDiagnosesDataInternalInternalVisitsVisitIdActiveDiagnosesDataPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/visits/{visit_id}/active-diagnoses-data',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Get Missed Visit Options Internal
 *
 * The missed-visit form options for the nursing app's assigned clinician.
 */
export const getMissedVisitOptionsInternalInternalVisitsVisitIdMissedVisitOptionsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetMissedVisitOptionsInternalInternalVisitsVisitIdMissedVisitOptionsGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetMissedVisitOptionsInternalInternalVisitsVisitIdMissedVisitOptionsGetResponses,
    GetMissedVisitOptionsInternalInternalVisitsVisitIdMissedVisitOptionsGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetMissedVisitOptionsInternalInternalVisitsVisitIdMissedVisitOptionsGetResponses,
      GetMissedVisitOptionsInternalInternalVisitsVisitIdMissedVisitOptionsGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/visits/{visit_id}/missed-visit-options',
      ...options,
    });

/**
 * Mark Visit Missed Internal
 *
 * Mark a visit missed from the nursing app, as its assigned clinician.
 *
 * The same write as the portal's mark-missed. Already missed is answered
 * before editability and the closed period, so a retry reads as done. The
 * physician must be one the options route offered.
 */
export const markVisitMissedInternalInternalVisitsVisitIdMarkMissedPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MarkVisitMissedInternalInternalVisitsVisitIdMarkMissedPostData,
    ThrowOnError
  >
): RequestResult<
  MarkVisitMissedInternalInternalVisitsVisitIdMarkMissedPostResponses,
  MarkVisitMissedInternalInternalVisitsVisitIdMarkMissedPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    MarkVisitMissedInternalInternalVisitsVisitIdMarkMissedPostResponses,
    MarkVisitMissedInternalInternalVisitsVisitIdMarkMissedPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/visits/{visit_id}/mark-missed',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Push Visit Evv Internal
 *
 * Ingest a visit's EVV bundle pushed from Roger Doc.
 *
 * The clinician captures EVV (clock in/out, GPS, patient signature) in the
 * nursing app; Roger Doc pushes the whole bundle here when it fills the visit.
 * We store the clock readings and download each signature image into the EMR's
 * own bucket so the EMR owns its copy of a compliance artifact.
 *
 * Idempotent: clock readings are upserted and signatures are keyed by their
 * Roger Doc S3 key, so re-pushing the same bundle creates no duplicates and
 * re-downloads nothing. A clock event absent from the payload leaves any
 * previously stored value alone — Roger Doc only ever adds clock readings.
 *
 * Per-signature failures land in `errors` and do not fail the request: a
 * signature we could not fetch must not cost us the clock readings.
 *
 * Open on a chart the External EMR still charts (Daniel, 10/14): the app
 * has no sense of Take Over yet. The reading makes the visit count as
 * worked, so the Take Over plan lists it. See ``app.services.chart_lock``.
 */
export const pushVisitEvvInternalInternalVisitsVisitIdEvvPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PushVisitEvvInternalInternalVisitsVisitIdEvvPutData,
    ThrowOnError
  >
): RequestResult<
  PushVisitEvvInternalInternalVisitsVisitIdEvvPutResponses,
  PushVisitEvvInternalInternalVisitsVisitIdEvvPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PushVisitEvvInternalInternalVisitsVisitIdEvvPutResponses,
    PushVisitEvvInternalInternalVisitsVisitIdEvvPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/visits/{visit_id}/evv',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Mark Patient Goal Met Internal
 *
 * Mark a patient goal as met (internal service authentication).
 */
export const markPatientGoalMetInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdMarkMetPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      MarkPatientGoalMetInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdMarkMetPostData,
      ThrowOnError
    >
  ): RequestResult<
    MarkPatientGoalMetInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdMarkMetPostResponses,
    MarkPatientGoalMetInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdMarkMetPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      MarkPatientGoalMetInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdMarkMetPostResponses,
      MarkPatientGoalMetInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdMarkMetPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/goals/visit/progress/{visit_id}/progress/{patient_goal_id}/mark_met',
      ...options,
    });

/**
 * Mark Patient Goal Unattainable Internal
 *
 * Mark a patient goal as unattainable (internal service authentication).
 */
export const markPatientGoalUnattainableInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdMarkUnattainablePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      MarkPatientGoalUnattainableInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdMarkUnattainablePostData,
      ThrowOnError
    >
  ): RequestResult<
    MarkPatientGoalUnattainableInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdMarkUnattainablePostResponses,
    MarkPatientGoalUnattainableInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdMarkUnattainablePostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      MarkPatientGoalUnattainableInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdMarkUnattainablePostResponses,
      MarkPatientGoalUnattainableInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdMarkUnattainablePostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/goals/visit/progress/{visit_id}/progress/{patient_goal_id}/mark_unattainable',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Record Goal Progress Internal
 *
 * Record progress on a patient goal (internal service authentication).
 */
export const recordGoalProgressInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdRecordProgressPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      RecordGoalProgressInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdRecordProgressPostData,
      ThrowOnError
    >
  ): RequestResult<
    RecordGoalProgressInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdRecordProgressPostResponses,
    RecordGoalProgressInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdRecordProgressPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      RecordGoalProgressInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdRecordProgressPostResponses,
      RecordGoalProgressInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdRecordProgressPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/goals/visit/progress/{visit_id}/progress/{patient_goal_id}/record_progress',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Perform Intervention For Visit Internal
 *
 * Record performance of an intervention (internal service authentication).
 */
export const performInterventionForVisitInternalInternalGoalsVisitProgressVisitIdProgressPatientInterventionIdPerformPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      PerformInterventionForVisitInternalInternalGoalsVisitProgressVisitIdProgressPatientInterventionIdPerformPostData,
      ThrowOnError
    >
  ): RequestResult<
    PerformInterventionForVisitInternalInternalGoalsVisitProgressVisitIdProgressPatientInterventionIdPerformPostResponses,
    PerformInterventionForVisitInternalInternalGoalsVisitProgressVisitIdProgressPatientInterventionIdPerformPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      PerformInterventionForVisitInternalInternalGoalsVisitProgressVisitIdProgressPatientInterventionIdPerformPostResponses,
      PerformInterventionForVisitInternalInternalGoalsVisitProgressVisitIdProgressPatientInterventionIdPerformPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/goals/visit/progress/{visit_id}/progress/{patient_intervention_id}/perform',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Complete Intervention For Visit Internal
 *
 * Mark an intervention as complete (internal service authentication).
 */
export const completeInterventionForVisitInternalInternalGoalsVisitProgressVisitIdProgressPatientInterventionIdCompletePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      CompleteInterventionForVisitInternalInternalGoalsVisitProgressVisitIdProgressPatientInterventionIdCompletePostData,
      ThrowOnError
    >
  ): RequestResult<
    CompleteInterventionForVisitInternalInternalGoalsVisitProgressVisitIdProgressPatientInterventionIdCompletePostResponses,
    CompleteInterventionForVisitInternalInternalGoalsVisitProgressVisitIdProgressPatientInterventionIdCompletePostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      CompleteInterventionForVisitInternalInternalGoalsVisitProgressVisitIdProgressPatientInterventionIdCompletePostResponses,
      CompleteInterventionForVisitInternalInternalGoalsVisitProgressVisitIdProgressPatientInterventionIdCompletePostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/goals/visit/progress/{visit_id}/progress/{patient_intervention_id}/complete',
      ...options,
    });

/**
 * Get Patient Goals For Visit
 *
 * Patient goals for a task with progress history and interventions.
 *
 * For a visit, only goals of the visit's own discipline; for an order,
 * every goal in the episode.
 */
export const getPatientGoalsForVisitInternalGoalsVisitVisitIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPatientGoalsForVisitInternalGoalsVisitVisitIdGetData,
    ThrowOnError
  >
): RequestResult<
  GetPatientGoalsForVisitInternalGoalsVisitVisitIdGetResponses,
  GetPatientGoalsForVisitInternalGoalsVisitVisitIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetPatientGoalsForVisitInternalGoalsVisitVisitIdGetResponses,
    GetPatientGoalsForVisitInternalGoalsVisitVisitIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/goals/visit/{visit_id}',
    ...options,
  });

/**
 * Add Goal To Visit By External Id
 *
 * Add a goal to a visit using goal_external_id. Add interventions separately.
 */
export const addGoalToVisitByExternalIdInternalGoalsVisitVisitIdPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AddGoalToVisitByExternalIdInternalGoalsVisitVisitIdPostData,
    ThrowOnError
  >
): RequestResult<
  AddGoalToVisitByExternalIdInternalGoalsVisitVisitIdPostResponses,
  AddGoalToVisitByExternalIdInternalGoalsVisitVisitIdPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AddGoalToVisitByExternalIdInternalGoalsVisitVisitIdPostResponses,
    AddGoalToVisitByExternalIdInternalGoalsVisitVisitIdPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/goals/visit/{visit_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Goal Template By External Id
 *
 * Get a single goal template by external_id with its attached intervention templates.
 *
 * Resolution is scoped to the set the visit could be offered (active, in the
 * visit patient's clinic, matching the visit's discipline), so an
 * out-of-set external_id 404s exactly like a nonexistent one.
 */
export const getGoalTemplateByExternalIdInternalGoalsVisitVisitIdTemplateGoalExternalIdGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetGoalTemplateByExternalIdInternalGoalsVisitVisitIdTemplateGoalExternalIdGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetGoalTemplateByExternalIdInternalGoalsVisitVisitIdTemplateGoalExternalIdGetResponses,
    GetGoalTemplateByExternalIdInternalGoalsVisitVisitIdTemplateGoalExternalIdGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetGoalTemplateByExternalIdInternalGoalsVisitVisitIdTemplateGoalExternalIdGetResponses,
      GetGoalTemplateByExternalIdInternalGoalsVisitVisitIdTemplateGoalExternalIdGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/goals/visit/{visit_id}/template/{goal_external_id}',
      ...options,
    });

/**
 * Get Goal Templates By External Ids
 *
 * Get goal templates by external_ids with their attached intervention templates.
 *
 * Resolution is scoped to the set the visit could be offered (active, in the
 * visit patient's clinic, matching the visit's discipline), so an
 * out-of-set external_id 404s exactly like a nonexistent one
 * instead of being silently dropped.
 */
export const getGoalTemplatesByExternalIdsInternalGoalsVisitVisitIdTemplateBatchPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetGoalTemplatesByExternalIdsInternalGoalsVisitVisitIdTemplateBatchPostData,
      ThrowOnError
    >
  ): RequestResult<
    GetGoalTemplatesByExternalIdsInternalGoalsVisitVisitIdTemplateBatchPostResponses,
    GetGoalTemplatesByExternalIdsInternalGoalsVisitVisitIdTemplateBatchPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      GetGoalTemplatesByExternalIdsInternalGoalsVisitVisitIdTemplateBatchPostResponses,
      GetGoalTemplatesByExternalIdsInternalGoalsVisitVisitIdTemplateBatchPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/goals/visit/{visit_id}/template/batch',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Get Intervention Template By External Id
 *
 * Get a single intervention template by external_id.
 */
export const getInterventionTemplateByExternalIdInternalGoalsVisitInterventionInterventionExternalIdGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetInterventionTemplateByExternalIdInternalGoalsVisitInterventionInterventionExternalIdGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetInterventionTemplateByExternalIdInternalGoalsVisitInterventionInterventionExternalIdGetResponses,
    GetInterventionTemplateByExternalIdInternalGoalsVisitInterventionInterventionExternalIdGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetInterventionTemplateByExternalIdInternalGoalsVisitInterventionInterventionExternalIdGetResponses,
      GetInterventionTemplateByExternalIdInternalGoalsVisitInterventionInterventionExternalIdGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/goals/visit/intervention/{intervention_external_id}',
      ...options,
    });

/**
 * Add Intervention To Visit By External Id
 *
 * Add an intervention to a visit using intervention_external_id.
 */
export const addInterventionToVisitByExternalIdInternalGoalsVisitVisitIdInterventionPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      AddInterventionToVisitByExternalIdInternalGoalsVisitVisitIdInterventionPostData,
      ThrowOnError
    >
  ): RequestResult<
    AddInterventionToVisitByExternalIdInternalGoalsVisitVisitIdInterventionPostResponses,
    AddInterventionToVisitByExternalIdInternalGoalsVisitVisitIdInterventionPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      AddInterventionToVisitByExternalIdInternalGoalsVisitVisitIdInterventionPostResponses,
      AddInterventionToVisitByExternalIdInternalGoalsVisitVisitIdInterventionPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/goals/visit/{visit_id}/intervention',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Get Patient Documents Internal
 */
export const getPatientDocumentsInternalInternalPatientsPatientIdDocumentsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetPatientDocumentsInternalInternalPatientsPatientIdDocumentsGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetPatientDocumentsInternalInternalPatientsPatientIdDocumentsGetResponses,
    GetPatientDocumentsInternalInternalPatientsPatientIdDocumentsGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetPatientDocumentsInternalInternalPatientsPatientIdDocumentsGetResponses,
      GetPatientDocumentsInternalInternalPatientsPatientIdDocumentsGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/patients/{patient_id}/documents',
      ...options,
    });

/**
 * Get Patient Document Url Internal
 */
export const getPatientDocumentUrlInternalInternalPatientsPatientIdDocumentsDocumentIdUrlGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetPatientDocumentUrlInternalInternalPatientsPatientIdDocumentsDocumentIdUrlGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetPatientDocumentUrlInternalInternalPatientsPatientIdDocumentsDocumentIdUrlGetResponses,
    GetPatientDocumentUrlInternalInternalPatientsPatientIdDocumentsDocumentIdUrlGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetPatientDocumentUrlInternalInternalPatientsPatientIdDocumentsDocumentIdUrlGetResponses,
      GetPatientDocumentUrlInternalInternalPatientsPatientIdDocumentsDocumentIdUrlGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/patients/{patient_id}/documents/{document_id}/url',
      ...options,
    });

/**
 * List Visit Diagnoses Internal
 *
 * Bare list, unlike the public route's envelope.
 *
 * The public route wraps its rows in payer context so the diagnosis picker can
 * decide how loudly to warn about an unfit principal diagnosis. Internal
 * callers consume the rows themselves, so unwrap rather than change a contract
 * they did not ask to change. Each row still carries its own `primary_fitness`.
 */
export const listVisitDiagnosesInternalInternalVisitsVisitIdDiagnosesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListVisitDiagnosesInternalInternalVisitsVisitIdDiagnosesGetData,
    ThrowOnError
  >
): RequestResult<
  ListVisitDiagnosesInternalInternalVisitsVisitIdDiagnosesGetResponses,
  ListVisitDiagnosesInternalInternalVisitsVisitIdDiagnosesGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListVisitDiagnosesInternalInternalVisitsVisitIdDiagnosesGetResponses,
    ListVisitDiagnosesInternalInternalVisitsVisitIdDiagnosesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/visits/{visit_id}/diagnoses',
    ...options,
  });

/**
 * Create Visit Diagnosis Internal
 */
export const createVisitDiagnosisInternalInternalVisitsVisitIdDiagnosesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateVisitDiagnosisInternalInternalVisitsVisitIdDiagnosesPostData,
    ThrowOnError
  >
): RequestResult<
  CreateVisitDiagnosisInternalInternalVisitsVisitIdDiagnosesPostResponses,
  CreateVisitDiagnosisInternalInternalVisitsVisitIdDiagnosesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateVisitDiagnosisInternalInternalVisitsVisitIdDiagnosesPostResponses,
    CreateVisitDiagnosisInternalInternalVisitsVisitIdDiagnosesPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/visits/{visit_id}/diagnoses',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Visit Diagnosis Internal
 */
export const deleteVisitDiagnosisInternalInternalVisitsDiagnosesDiagnosisIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteVisitDiagnosisInternalInternalVisitsDiagnosesDiagnosisIdDeleteData,
      ThrowOnError
    >
  ): RequestResult<
    DeleteVisitDiagnosisInternalInternalVisitsDiagnosesDiagnosisIdDeleteResponses,
    DeleteVisitDiagnosisInternalInternalVisitsDiagnosesDiagnosisIdDeleteErrors,
    ThrowOnError
  > =>
    (options.client ?? client).delete<
      DeleteVisitDiagnosisInternalInternalVisitsDiagnosesDiagnosisIdDeleteResponses,
      DeleteVisitDiagnosisInternalInternalVisitsDiagnosesDiagnosisIdDeleteErrors,
      ThrowOnError
    >({ url: '/internal/visits/diagnoses/{diagnosis_id}', ...options });

/**
 * Update Visit Diagnosis Internal
 */
export const updateVisitDiagnosisInternalInternalVisitsDiagnosesDiagnosisIdPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdateVisitDiagnosisInternalInternalVisitsDiagnosesDiagnosisIdPutData,
      ThrowOnError
    >
  ): RequestResult<
    UpdateVisitDiagnosisInternalInternalVisitsDiagnosesDiagnosisIdPutResponses,
    UpdateVisitDiagnosisInternalInternalVisitsDiagnosesDiagnosisIdPutErrors,
    ThrowOnError
  > =>
    (options.client ?? client).put<
      UpdateVisitDiagnosisInternalInternalVisitsDiagnosesDiagnosisIdPutResponses,
      UpdateVisitDiagnosisInternalInternalVisitsDiagnosesDiagnosisIdPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/visits/diagnoses/{diagnosis_id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Update Diagnosis Positions Internal
 */
export const updateDiagnosisPositionsInternalInternalVisitsVisitIdDiagnosesPositionsPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdateDiagnosisPositionsInternalInternalVisitsVisitIdDiagnosesPositionsPutData,
      ThrowOnError
    >
  ): RequestResult<
    UpdateDiagnosisPositionsInternalInternalVisitsVisitIdDiagnosesPositionsPutResponses,
    UpdateDiagnosisPositionsInternalInternalVisitsVisitIdDiagnosesPositionsPutErrors,
    ThrowOnError
  > =>
    (options.client ?? client).put<
      UpdateDiagnosisPositionsInternalInternalVisitsVisitIdDiagnosesPositionsPutResponses,
      UpdateDiagnosisPositionsInternalInternalVisitsVisitIdDiagnosesPositionsPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/visits/{visit_id}/diagnoses/positions',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Import Kinnser Patient Portfolio Internal
 *
 * Rebuild one Kinnser admission as a RogerEMR chart, production rules.
 *
 * The chart is built whole — patient, admission, every episode with its
 * visits, OASIS answers, worksheet codes and authorizations, and the NOA
 * record when the payer requires one. Billing custody is pinned: no
 * historical billing-cycle replay, every imported episode marked externally
 * billed (Kinnser billed those periods), and the NOA record set to
 * ``accepted`` so it never sits in a submit queue. Findings are disclosed on
 * the result's ``notes``, never blocked on.
 *
 * ``target`` names the agency and optionally pins the clinic, agency
 * insurance and attending physician by id; ids left out are best-matched
 * from the portfolio's own Kinnser keys with the evidence reported (fully
 * automatic mode). Nothing is created either way — an axis that
 * cannot be matched refuses the import. ``target.agency_id`` governs where
 * the chart is written — the importer scopes its own writes to it — and the
 * request must name the agency it authenticated for: the identity the auth
 * layer resolved is the one that has to hold. Cross-org clones live on the
 * dev route, which refuses the same mismatch for the same reason.
 */
export const importKinnserPatientPortfolioInternalInternalKinnserImportPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ImportKinnserPatientPortfolioInternalInternalKinnserImportPostData,
    ThrowOnError
  >
): RequestResult<
  ImportKinnserPatientPortfolioInternalInternalKinnserImportPostResponses,
  ImportKinnserPatientPortfolioInternalInternalKinnserImportPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ImportKinnserPatientPortfolioInternalInternalKinnserImportPostResponses,
    ImportKinnserPatientPortfolioInternalInternalKinnserImportPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/kinnser-import',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Start Kinnser Import Workflow
 *
 * Start the durable form of the import: scrape via Roger Docs, then
 * import — as a Temporal workflow that survives deploys and retries
 * transient failures itself.
 *
 * The workflow id is deterministic per (target agency, patient), so a
 * duplicate submission reports ``already_running`` instead of starting a
 * second import. Poll the status route for the result; refusals surface
 * there with the same detail the synchronous route would return.
 *
 * What the patient is called stays here. The request is written to
 * ``kinnser_import_requests`` and committed first, and the workflow carries
 * that row's id — so the MRN or Kinnser key reaches the activity through the
 * tenant's own database, not through a Temporal input that Temporal Cloud
 * keeps in durable history.
 *
 * The target-agency rule is the synchronous route's, checked here because
 * this route is where the chart's destination is chosen — by the time the
 * activity writes, no request context is left to check it against.
 */
export const startKinnserImportWorkflowInternalKinnserImportWorkflowPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    StartKinnserImportWorkflowInternalKinnserImportWorkflowPostData,
    ThrowOnError
  >
): RequestResult<
  StartKinnserImportWorkflowInternalKinnserImportWorkflowPostResponses,
  StartKinnserImportWorkflowInternalKinnserImportWorkflowPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    StartKinnserImportWorkflowInternalKinnserImportWorkflowPostResponses,
    StartKinnserImportWorkflowInternalKinnserImportWorkflowPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/kinnser-import/workflow',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Kinnser Import Attempts
 *
 * Internal failure evidence remains readable after Temporal retention.
 */
export const getKinnserImportAttemptsInternalKinnserImportWorkflowWorkflowIdAttemptsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetKinnserImportAttemptsInternalKinnserImportWorkflowWorkflowIdAttemptsGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetKinnserImportAttemptsInternalKinnserImportWorkflowWorkflowIdAttemptsGetResponses,
    GetKinnserImportAttemptsInternalKinnserImportWorkflowWorkflowIdAttemptsGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetKinnserImportAttemptsInternalKinnserImportWorkflowWorkflowIdAttemptsGetResponses,
      GetKinnserImportAttemptsInternalKinnserImportWorkflowWorkflowIdAttemptsGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/kinnser-import/workflow/{workflow_id}/attempts',
      ...options,
    });

/**
 * Get Kinnser Import Workflow Status
 *
 * Report a durable import's progress; carries the ImportResult once done.
 *
 * A failed workflow reports the underlying refusal or error message —
 * the same detail the synchronous route would have returned as its 400.
 *
 * Readable only by the agency the import writes into: the report carries the
 * chart's own findings, so status is a PHI surface, not a progress bar.
 */
export const getKinnserImportWorkflowStatusInternalKinnserImportWorkflowWorkflowIdGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetKinnserImportWorkflowStatusInternalKinnserImportWorkflowWorkflowIdGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetKinnserImportWorkflowStatusInternalKinnserImportWorkflowWorkflowIdGetResponses,
    GetKinnserImportWorkflowStatusInternalKinnserImportWorkflowWorkflowIdGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetKinnserImportWorkflowStatusInternalKinnserImportWorkflowWorkflowIdGetResponses,
      GetKinnserImportWorkflowStatusInternalKinnserImportWorkflowWorkflowIdGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/kinnser-import/workflow/{workflow_id}',
      ...options,
    });

/**
 * List Kinnser Import Queue
 *
 * Every live row, then a page of the most recently finished ones.
 *
 * Reading the queue also re-kicks any login that still has work. A
 * sequencer can die without settling its rows — a failed run, or a batch
 * that committed while Temporal was unreachable so none was ever started —
 * and the rows are durable but inert until something starts one. Nothing
 * else was watching, so the page that shows the queue is what revives it.
 */
export const listKinnserImportQueueInternalKinnserImportQueueGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ListKinnserImportQueueInternalKinnserImportQueueGetData,
    ThrowOnError
  >
): RequestResult<
  ListKinnserImportQueueInternalKinnserImportQueueGetResponses,
  ListKinnserImportQueueInternalKinnserImportQueueGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListKinnserImportQueueInternalKinnserImportQueueGetResponses,
    ListKinnserImportQueueInternalKinnserImportQueueGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/kinnser-import/queue',
    ...options,
  });

/**
 * Enqueue Kinnser Import Queue
 *
 * Persist the batch, then return. The sequencer starts scrapes one at a time.
 */
export const enqueueKinnserImportQueueInternalKinnserImportQueuePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    EnqueueKinnserImportQueueInternalKinnserImportQueuePostData,
    ThrowOnError
  >
): RequestResult<
  EnqueueKinnserImportQueueInternalKinnserImportQueuePostResponses,
  EnqueueKinnserImportQueueInternalKinnserImportQueuePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    EnqueueKinnserImportQueueInternalKinnserImportQueuePostResponses,
    EnqueueKinnserImportQueueInternalKinnserImportQueuePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/kinnser-import/queue',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Backfill Kinnser Print Retries
 *
 * Queue the lost prints of every chart this agency already imported.
 *
 * Reads each patient's latest import report. The retries join the import
 * queue's pool, due after the retry delay, and run under the same per-login
 * limits as chart imports.
 */
export const backfillKinnserPrintRetriesInternalKinnserImportPrintRetriesBackfillPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      BackfillKinnserPrintRetriesInternalKinnserImportPrintRetriesBackfillPostData,
      ThrowOnError
    >
  ): RequestResult<
    BackfillKinnserPrintRetriesInternalKinnserImportPrintRetriesBackfillPostResponses,
    BackfillKinnserPrintRetriesInternalKinnserImportPrintRetriesBackfillPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      BackfillKinnserPrintRetriesInternalKinnserImportPrintRetriesBackfillPostResponses,
      BackfillKinnserPrintRetriesInternalKinnserImportPrintRetriesBackfillPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/kinnser-import/print-retries/backfill',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Backfill Kinnser Mapped Lines
 *
 * Code the certain matches on this agency's existing imported charts.
 *
 * The same conversion a first import and a refresh run:
 * untouched raw lines only, the same coded rows and audit rows, and the same
 * Revert in the Importer tool. For charts nobody refreshes. The page commits
 * as one transaction.
 */
export const backfillKinnserMappedLinesInternalKinnserImportMappedLinesBackfillPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      BackfillKinnserMappedLinesInternalKinnserImportMappedLinesBackfillPostData,
      ThrowOnError
    >
  ): RequestResult<
    BackfillKinnserMappedLinesInternalKinnserImportMappedLinesBackfillPostResponses,
    BackfillKinnserMappedLinesInternalKinnserImportMappedLinesBackfillPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      BackfillKinnserMappedLinesInternalKinnserImportMappedLinesBackfillPostResponses,
      BackfillKinnserMappedLinesInternalKinnserImportMappedLinesBackfillPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/kinnser-import/mapped-lines/backfill',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

/**
 * Cancel Kinnser Import Queue Item
 *
 * Cancel a queued row, or request cancel of the in-flight child import.
 */
export const cancelKinnserImportQueueItemInternalKinnserImportQueueItemIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      CancelKinnserImportQueueItemInternalKinnserImportQueueItemIdDeleteData,
      ThrowOnError
    >
  ): RequestResult<
    CancelKinnserImportQueueItemInternalKinnserImportQueueItemIdDeleteResponses,
    CancelKinnserImportQueueItemInternalKinnserImportQueueItemIdDeleteErrors,
    ThrowOnError
  > =>
    (options.client ?? client).delete<
      CancelKinnserImportQueueItemInternalKinnserImportQueueItemIdDeleteResponses,
      CancelKinnserImportQueueItemInternalKinnserImportQueueItemIdDeleteErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/kinnser-import/queue/{item_id}',
      ...options,
    });

/**
 * Start Capture
 */
export const startCaptureInternalKinnserHistoricalCapturesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    StartCaptureInternalKinnserHistoricalCapturesPostData,
    ThrowOnError
  >
): RequestResult<
  StartCaptureInternalKinnserHistoricalCapturesPostResponses,
  StartCaptureInternalKinnserHistoricalCapturesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    StartCaptureInternalKinnserHistoricalCapturesPostResponses,
    StartCaptureInternalKinnserHistoricalCapturesPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/kinnser-historical-captures',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Capture
 */
export const getCaptureInternalKinnserHistoricalCapturesCaptureIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetCaptureInternalKinnserHistoricalCapturesCaptureIdGetData,
    ThrowOnError
  >
): RequestResult<
  GetCaptureInternalKinnserHistoricalCapturesCaptureIdGetResponses,
  GetCaptureInternalKinnserHistoricalCapturesCaptureIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetCaptureInternalKinnserHistoricalCapturesCaptureIdGetResponses,
    GetCaptureInternalKinnserHistoricalCapturesCaptureIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/kinnser-historical-captures/{capture_id}',
    ...options,
  });

/**
 * Resume Capture
 */
export const resumeCaptureInternalKinnserHistoricalCapturesCaptureIdResumePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ResumeCaptureInternalKinnserHistoricalCapturesCaptureIdResumePostData,
      ThrowOnError
    >
  ): RequestResult<
    ResumeCaptureInternalKinnserHistoricalCapturesCaptureIdResumePostResponses,
    ResumeCaptureInternalKinnserHistoricalCapturesCaptureIdResumePostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      ResumeCaptureInternalKinnserHistoricalCapturesCaptureIdResumePostResponses,
      ResumeCaptureInternalKinnserHistoricalCapturesCaptureIdResumePostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/kinnser-historical-captures/{capture_id}/resume',
      ...options,
    });

/**
 * Get Captured Portfolio
 */
export const getCapturedPortfolioInternalKinnserHistoricalCapturesCaptureIdAdmissionsOrdinalPortfolioGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetCapturedPortfolioInternalKinnserHistoricalCapturesCaptureIdAdmissionsOrdinalPortfolioGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetCapturedPortfolioInternalKinnserHistoricalCapturesCaptureIdAdmissionsOrdinalPortfolioGetResponses,
    GetCapturedPortfolioInternalKinnserHistoricalCapturesCaptureIdAdmissionsOrdinalPortfolioGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetCapturedPortfolioInternalKinnserHistoricalCapturesCaptureIdAdmissionsOrdinalPortfolioGetResponses,
      GetCapturedPortfolioInternalKinnserHistoricalCapturesCaptureIdAdmissionsOrdinalPortfolioGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/kinnser-historical-captures/{capture_id}/admissions/{ordinal}/portfolio',
      ...options,
    });

/**
 * Resolve Code Schema Release
 *
 * The release of ``system`` whose effective period contains ``on``.
 *
 * Pick ``on`` by the question being asked (CMS Claims Processing Manual
 * Ch.10 §80.2):
 *
 * * codes for a visit or assessment: ``on`` = the visit date;
 * * codes on a claim: ``on`` = the claim Through date. A claim that spans
 * an update carries the codes valid after it;
 * * the HH grouper version is NOT this table. It follows CMS
 * ``Version_Range`` by claim From date, and January grouper releases have
 * no ICD-10-CM release.
 *
 * ``effective_to`` is exclusive and null for the newest release.
 */
export const resolveCodeSchemaReleaseInternalCodeSchemaReleasesResolveGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResolveCodeSchemaReleaseInternalCodeSchemaReleasesResolveGetData,
    ThrowOnError
  >
): RequestResult<
  ResolveCodeSchemaReleaseInternalCodeSchemaReleasesResolveGetResponses,
  ResolveCodeSchemaReleaseInternalCodeSchemaReleasesResolveGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ResolveCodeSchemaReleaseInternalCodeSchemaReleasesResolveGetResponses,
    ResolveCodeSchemaReleaseInternalCodeSchemaReleasesResolveGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/code-schema-releases/resolve',
    ...options,
  });

/**
 * Generate Test Data
 *
 * Generate test data for a specific agency.
 *
 * Creates patients, admissions, episodes, and visits.
 * Test patients are marked with a special email pattern for later deletion.
 *
 * SECURITY WARNING: This endpoint is only available in non-production environments!
 *
 * Note: Visits and episodes are assigned a deterministic seed clinician (one
 * per clinic, reused from the billing lifecycle seeder) when the agency has
 * clinics; clinic-less agencies skip assignment.
 */
export const generateTestDataDevTestDataGeneratePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GenerateTestDataDevTestDataGeneratePostData, ThrowOnError>
): RequestResult<
  GenerateTestDataDevTestDataGeneratePostResponses,
  GenerateTestDataDevTestDataGeneratePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GenerateTestDataDevTestDataGeneratePostResponses,
    GenerateTestDataDevTestDataGeneratePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/dev/test-data/generate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Clear Test Data
 *
 * Clear test data for a specific agency.
 *
 * Identifies test patients by their email pattern (test-*@test.roger-emr.internal)
 * and deletes them along with all associated data (admissions, episodes, visits).
 *
 * SECURITY WARNING: This endpoint is only available in non-production environments!
 */
export const clearTestDataDevTestDataClearDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ClearTestDataDevTestDataClearDeleteData, ThrowOnError>
): RequestResult<
  ClearTestDataDevTestDataClearDeleteResponses,
  ClearTestDataDevTestDataClearDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    ClearTestDataDevTestDataClearDeleteResponses,
    ClearTestDataDevTestDataClearDeleteErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/dev/test-data/clear',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Patient Hard
 *
 * Hard-delete a single patient and all associated data.
 *
 * Cascades through: visits, orders, patient communications, tasks,
 * episodes, notices of admission, admissions, documents, claims,
 * billing cycles, goals, medications, allergies, wounds, intakes,
 * and the patient record itself.
 *
 * Requires an authenticated session — the caller's agency scopes the
 * lookup, so a patient in a different agency returns 404. The ORM's
 * automatic agency filter (set up by ``get_current_ctx``) constrains
 * every query and bulk-delete in this handler to the caller's agency.
 *
 * SECURITY WARNING: Only available in non-production environments!
 * Intended for e2e test cleanup.
 */
export const deletePatientHardDevTestDataPatientPatientIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeletePatientHardDevTestDataPatientPatientIdDeleteData,
    ThrowOnError
  >
): RequestResult<
  DeletePatientHardDevTestDataPatientPatientIdDeleteResponses,
  DeletePatientHardDevTestDataPatientPatientIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeletePatientHardDevTestDataPatientPatientIdDeleteResponses,
    DeletePatientHardDevTestDataPatientPatientIdDeleteErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/dev/test-data/patient/{patient_id}',
    ...options,
  });

/**
 * Import Kinnser Patient Portfolio
 *
 * Rebuild one Kinnser admission as a RogerEMR chart.
 *
 * Creates patient, admission, patient insurance, **every** episode of the
 * admission in chronological order (each with its worksheet condition and
 * occurrence codes, its visits, and its billing cycles), and the one Notice
 * of Admission the admission gets when the target insurance requires one —
 * then reports the NOA's own validation result. A recertified admission
 * therefore arrives with both certification periods; ``episodes`` in the
 * result breaks the chart down per period, and every visit says which one it
 * landed on.
 *
 * ``options`` decides how much of the chart is built. With none of them set
 * the result is the Notice-of-Admission chart: one Start-of-Care visit shell.
 * ``import_visit_history`` adds every identifiable task as a visit with its
 * OASIS answers, diagnoses and authorizations;
 * ``fabricate_oasis_signed_exported`` writes the signed-and-exported OASIS
 * state a finished chart carries and a replicated chart cannot earn (an
 * imported payment OASIS is billable on its status alone without it); and
 * ``create_billing_cycles`` replays the billing cycles a historical episode
 * would have accumulated.
 *
 * Nothing is matched by name and no configuration is created: the clinic,
 * agency insurance, and attending physician must already exist and are named
 * by id in ``target``.
 *
 * SECURITY WARNING: Only available in non-production environments. Guarded by
 * the same strict check as patient hard-delete (never allowlisted for a prod
 * demo agency) because ``options.reset`` can hard-delete a real patient, and
 * because ``fabricate_oasis_signed_exported`` writes clinical-attestation
 * state that no clinician produced.
 */
export const importKinnserPatientPortfolioDevTestDataKinnserImportPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ImportKinnserPatientPortfolioDevTestDataKinnserImportPostData,
    ThrowOnError
  >
): RequestResult<
  ImportKinnserPatientPortfolioDevTestDataKinnserImportPostResponses,
  ImportKinnserPatientPortfolioDevTestDataKinnserImportPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ImportKinnserPatientPortfolioDevTestDataKinnserImportPostResponses,
    ImportKinnserPatientPortfolioDevTestDataKinnserImportPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/dev/test-data/kinnser-import',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Seed Verify Fixtures
 *
 * Prepare the caller's agency for post-merge verification.
 *
 * Verification signs in as a shared user and only reads, so it cannot show a
 * merged ticket working when the agency has no record of the right kind. This
 * fills in the ones that kept blocking it: billing lifecycle data, billing
 * and NOA access for the shared user, unclaimed imported clinicians made
 * assignable (demo sandboxes only), and a Clinical Manager on one test
 * patient's episode. When a member is named, the billing data goes only to
 * clinics that member can already access. Run it once per environment; a
 * second run adds nothing.
 *
 * SECURITY WARNING: Only available in non-production environments. It grants
 * roles and writes clinic postings, so it is never allowlisted for a
 * production demo agency.
 */
export const seedVerifyFixturesDevTestDataVerifyFixturesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SeedVerifyFixturesDevTestDataVerifyFixturesPostData,
    ThrowOnError
  >
): RequestResult<
  SeedVerifyFixturesDevTestDataVerifyFixturesPostResponses,
  SeedVerifyFixturesDevTestDataVerifyFixturesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SeedVerifyFixturesDevTestDataVerifyFixturesPostResponses,
    SeedVerifyFixturesDevTestDataVerifyFixturesPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/dev/test-data/verify-fixtures',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Shp Oasis Batch Stage
 *
 * How this stage routes SHP batches: whether it sends only test patients.
 */
export const getShpOasisBatchStageDevTestDataShpOasisBatchGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetShpOasisBatchStageDevTestDataShpOasisBatchGetData,
    ThrowOnError
  >
): RequestResult<
  GetShpOasisBatchStageDevTestDataShpOasisBatchGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetShpOasisBatchStageDevTestDataShpOasisBatchGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/dev/test-data/shp-oasis-batch',
    ...options,
  });

/**
 * Run Shp Oasis Batch Now
 *
 * Run the nightly SHP batch for the named charts of the caller's agency.
 */
export const runShpOasisBatchNowDevTestDataShpOasisBatchRunPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RunShpOasisBatchNowDevTestDataShpOasisBatchRunPostData,
    ThrowOnError
  >
): RequestResult<
  RunShpOasisBatchNowDevTestDataShpOasisBatchRunPostResponses,
  RunShpOasisBatchNowDevTestDataShpOasisBatchRunPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RunShpOasisBatchNowDevTestDataShpOasisBatchRunPostResponses,
    RunShpOasisBatchNowDevTestDataShpOasisBatchRunPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/dev/test-data/shp-oasis-batch/run',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Demo Environments
 *
 * Every Kinnser agency and how alive its demo is.
 *
 * Cross-tenant read, safe because the router already requires a Strawhat
 * super user: an operator asking "which demos exist and are any of them
 * healthy?" is asking about every agency, not their own.
 *
 * Agencies nobody has touched are included, reading never run: every Kinnser
 * agency is already a usable demo, so listing only configured ones would hide
 * most of them. The console filters to "My sandboxes" client-side.
 */
export const listDemoEnvironmentsDemoAgencySetupEnvironmentsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ListDemoEnvironmentsDemoAgencySetupEnvironmentsGetData,
    ThrowOnError
  >
): RequestResult<
  ListDemoEnvironmentsDemoAgencySetupEnvironmentsGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListDemoEnvironmentsDemoAgencySetupEnvironmentsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/demo-agency-setup/environments',
    ...options,
  });

/**
 * Update Demo Environment
 *
 * Save an agency's settings, or hide and unhide it.
 *
 * Creates the config if the agency has none — editing an untouched agency is
 * how it joins "My sandboxes". Hiding takes it out of that view and leaves its
 * seeded data and saved settings alone, so unhiding brings it back as it was.
 *
 * ``settings`` **replaces** the saved block rather than merging into it, so a
 * partial object resets the fields it omits to their defaults. The console
 * always sends the whole block; anything else calling this must too.
 *
 * Refuses a settings change with 409 while a run is in progress: the run's
 * seed steps read the saved settings part-way through, so a save then would
 * build one sandbox from two different settings. Hiding still works.
 */
export const updateDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdPutData,
    ThrowOnError
  >
): RequestResult<
  UpdateDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdPutResponses,
  UpdateDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdPutResponses,
    UpdateDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/demo-agency-setup/environments/{agency_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Demo Environment Runs
 *
 * An agency's recent runs, newest first, for its expanded row.
 */
export const listDemoEnvironmentRunsDemoAgencySetupEnvironmentsAgencyIdRunsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ListDemoEnvironmentRunsDemoAgencySetupEnvironmentsAgencyIdRunsGetData,
      ThrowOnError
    >
  ): RequestResult<
    ListDemoEnvironmentRunsDemoAgencySetupEnvironmentsAgencyIdRunsGetResponses,
    ListDemoEnvironmentRunsDemoAgencySetupEnvironmentsAgencyIdRunsGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      ListDemoEnvironmentRunsDemoAgencySetupEnvironmentsAgencyIdRunsGetResponses,
      ListDemoEnvironmentRunsDemoAgencySetupEnvironmentsAgencyIdRunsGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/demo-agency-setup/environments/{agency_id}/runs',
      ...options,
    });

/**
 * Run Demo Environment
 *
 * Start demo setup for an agency from its saved settings.
 *
 * Returns as soon as the run is started; the run itself happens in a Temporal
 * worker. Creates the config with default settings if the agency has none, so
 * running an untouched agency that has been pulled works in one click. Takes no
 * request body, so the run cannot drift from what the console shows.
 *
 * An agency nobody has pulled builds too: the Kinnser import is something a
 * sandbox may use, not something it depends on. It gets one invented clinic.
 *
 * Refuses with 409 while the agency already has a run in progress: two runs
 * would wipe and re-seed the same agency at the same time.
 */
export const runDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdRunPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RunDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdRunPostData,
    ThrowOnError
  >
): RequestResult<
  RunDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdRunPostResponses,
  RunDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdRunPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RunDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdRunPostResponses,
    RunDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdRunPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/demo-agency-setup/environments/{agency_id}/run',
    ...options,
  });

/**
 * Pull Kinnser For Demo Environment
 *
 * Pull an agency's clinic info from Kinnser and save it on its demo config.
 *
 * Writes only the demo config: the pull
 * fields nobody has set. The agency's clinics, insurances and physicians
 * are written by the next run, from this pull, so a run never calls Kinnser and
 * two runs of the same pull build the same sandbox. Replaces any earlier pull.
 *
 * Saving creates the config if the agency has none: a pull is data kept on the
 * config, so the agency moves into My sandboxes like an edit would.
 *
 * Refuses with 409 while a run is in progress, so a run never reads a pull that
 * changed part-way through it.
 */
export const pullKinnserForDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdPullKinnserPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      PullKinnserForDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdPullKinnserPostData,
      ThrowOnError
    >
  ): RequestResult<
    PullKinnserForDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdPullKinnserPostResponses,
    PullKinnserForDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdPullKinnserPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      PullKinnserForDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdPullKinnserPostResponses,
      PullKinnserForDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdPullKinnserPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/demo-agency-setup/environments/{agency_id}/pull-kinnser',
      ...options,
    });

/**
 * Get Kinnser Rescrape Status For Demo Environment
 *
 * Whether the scrape started after ``after`` is running, done or failed.
 */
export const getKinnserRescrapeStatusForDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdRescrapeKinnserGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetKinnserRescrapeStatusForDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdRescrapeKinnserGetData,
      ThrowOnError
    >
  ): RequestResult<
    GetKinnserRescrapeStatusForDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdRescrapeKinnserGetResponses,
    GetKinnserRescrapeStatusForDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdRescrapeKinnserGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetKinnserRescrapeStatusForDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdRescrapeKinnserGetResponses,
      GetKinnserRescrapeStatusForDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdRescrapeKinnserGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/demo-agency-setup/environments/{agency_id}/rescrape-kinnser',
      ...options,
    });

/**
 * Rescrape Kinnser For Demo Environment
 *
 * Ask RogerDoc to scrape the agency from Kinnser again, before a pull.
 *
 * A pull reads RogerDoc's stored copy, which only its scrape refreshes. Poll the
 * status route with the returned ``after``, then pull. Writes nothing in Roger.
 */
export const rescrapeKinnserForDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdRescrapeKinnserPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      RescrapeKinnserForDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdRescrapeKinnserPostData,
      ThrowOnError
    >
  ): RequestResult<
    RescrapeKinnserForDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdRescrapeKinnserPostResponses,
    RescrapeKinnserForDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdRescrapeKinnserPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      RescrapeKinnserForDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdRescrapeKinnserPostResponses,
      RescrapeKinnserForDemoEnvironmentDemoAgencySetupEnvironmentsAgencyIdRescrapeKinnserPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/demo-agency-setup/environments/{agency_id}/rescrape-kinnser',
      ...options,
    });

/**
 * List Pulled Payers
 *
 * The last pull's insurances, each matched to Roger's payor catalog.
 *
 * Matched with ``get_payor_by_electronic_id_or_alias``, the lookup the sync
 * runs when it writes an insurance, so this says before Run what Admin will
 * show after it. Matched on read rather than stored with the pull: the pull
 * summary is rebuilt by every sync fetch, and the catalog can change after a
 * pull. Empty when the agency has never been pulled.
 */
export const listPulledPayersDemoAgencySetupEnvironmentsAgencyIdPulledPayersGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ListPulledPayersDemoAgencySetupEnvironmentsAgencyIdPulledPayersGetData,
      ThrowOnError
    >
  ): RequestResult<
    ListPulledPayersDemoAgencySetupEnvironmentsAgencyIdPulledPayersGetResponses,
    ListPulledPayersDemoAgencySetupEnvironmentsAgencyIdPulledPayersGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      ListPulledPayersDemoAgencySetupEnvironmentsAgencyIdPulledPayersGetResponses,
      ListPulledPayersDemoAgencySetupEnvironmentsAgencyIdPulledPayersGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/demo-agency-setup/environments/{agency_id}/pulled-payers',
      ...options,
    });

/**
 * Get Demo Team Default
 *
 * The team a sandbox that never named one starts with.
 */
export const getDemoTeamDefaultDemoAgencySetupTeamDefaultGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetDemoTeamDefaultDemoAgencySetupTeamDefaultGetData,
    ThrowOnError
  >
): RequestResult<
  GetDemoTeamDefaultDemoAgencySetupTeamDefaultGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetDemoTeamDefaultDemoAgencySetupTeamDefaultGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/demo-agency-setup/team-default',
    ...options,
  });

/**
 * Set Demo Team Default
 *
 * Make this team the one a new sandbox starts with.
 *
 * Validated on the way in rather than on the way out: a default carrying a
 * malformed email would fail the invite step of every later run, minutes into
 * a build.
 */
export const setDemoTeamDefaultDemoAgencySetupTeamDefaultPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SetDemoTeamDefaultDemoAgencySetupTeamDefaultPutData,
    ThrowOnError
  >
): RequestResult<
  SetDemoTeamDefaultDemoAgencySetupTeamDefaultPutResponses,
  SetDemoTeamDefaultDemoAgencySetupTeamDefaultPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    SetDemoTeamDefaultDemoAgencySetupTeamDefaultPutResponses,
    SetDemoTeamDefaultDemoAgencySetupTeamDefaultPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/demo-agency-setup/team-default',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Root
 *
 * Root endpoint
 */
export const rootGet = <ThrowOnError extends boolean = false>(
  options?: Options<RootGetData, ThrowOnError>
): RequestResult<RootGetResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<RootGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/',
    ...options,
  });
